/* eslint-disable */
// kingbasura 0.3.1 c1c2990e472f8f1fedb9b9e785254c40a6b02a02
// --
// Code generated by Webrpc-gen@v0.31.3 with /usr/local/src/gen-typescript generator. DO NOT EDIT.
//
// webrpc-gen -schema=./kingbasura.ridl -target=/usr/local/src/gen-typescript -client -webrpcHeader=true -tq -infallibleTq -zod -out=../drat/src/rpc/webrpc-client.gen.ts

// Webrpc description and code-gen version
export const WebrpcVersion = "v1"

// Schema version of your RIDL schema
export const WebrpcSchemaVersion = "0.3.1"

// Schema hash generated from your RIDL schema
export const WebrpcSchemaHash = "c1c2990e472f8f1fedb9b9e785254c40a6b02a02"

//
// Client interface
//

export interface KingBasuraClient {
  ping(headers?: object, signal?: AbortSignal): Promise<PingResponse>

  login(req: LoginRequest, headers?: object, signal?: AbortSignal): Promise<LoginResponse>

  refreshAuthToken(headers?: object, signal?: AbortSignal): Promise<RefreshAuthTokenResponse>

  self(headers?: object, signal?: AbortSignal): Promise<SelfResponse>

  logout(headers?: object, signal?: AbortSignal): Promise<LogoutResponse>

  getSystemConfig(headers?: object, signal?: AbortSignal): Promise<GetSystemConfigResponse>

  getVersionInfo(headers?: object, signal?: AbortSignal): Promise<GetVersionInfoResponse>

  watchCompanyById(req: WatchCompanyByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompanyByIdResponse>

  lastValidCompanyById(req: LastValidCompanyByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidCompanyByIdResponse>

  companyByIdAsof(req: CompanyByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<CompanyByIdAsofResponse>

  companyRevisionCount(req: CompanyRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<CompanyRevisionCountResponse>

  allCompanyRevisions(req: AllCompanyRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllCompanyRevisionsResponse>

  watchCompanyByCode(req: WatchCompanyByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompanyByCodeResponse>

  lastValidCompanyByCode(req: LastValidCompanyByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidCompanyByCodeResponse>

  companyByCodeAsof(req: CompanyByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<CompanyByCodeAsofResponse>

  watchCompaniesByNameFragment(req: WatchCompaniesByNameFragmentRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompaniesByNameFragmentResponse>

  watchVenueById(req: WatchVenueByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByIdResponse>

  lastValidVenueById(req: LastValidVenueByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByIdResponse>

  venueByIdAsof(req: VenueByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByIdAsofResponse>

  venueRevisionCount(req: VenueRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<VenueRevisionCountResponse>

  allVenueRevisions(req: AllVenueRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllVenueRevisionsResponse>

  watchAdmittersOnDutyForVenue(req: WatchAdmittersOnDutyForVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchAdmittersOnDutyForVenueResponse>

  watchVenueByCode(req: WatchVenueByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByCodeResponse>

  lastValidVenueByCode(req: LastValidVenueByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByCodeResponse>

  venueByCodeAsof(req: VenueByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByCodeAsofResponse>

  watchVenueByName(req: WatchVenueByNameRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByNameResponse>

  lastValidVenueByName(req: LastValidVenueByNameRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByNameResponse>

  venueByNameAsof(req: VenueByNameAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByNameAsofResponse>

  downstreamVenues(headers?: object, signal?: AbortSignal): Promise<DownstreamVenuesResponse>

  watchTrucksDockedAt(req: WatchTrucksDockedAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchTrucksDockedAtResponse>

  watchAgentById(req: WatchAgentByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByIdResponse>

  lastValidAgentById(req: LastValidAgentByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByIdResponse>

  agentByIdAsof(req: AgentByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByIdAsofResponse>

  agentRevisionCount(req: AgentRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<AgentRevisionCountResponse>

  allAgentRevisions(req: AllAgentRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllAgentRevisionsResponse>

  watchAgentByCode(req: WatchAgentByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByCodeResponse>

  lastValidAgentByCode(req: LastValidAgentByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByCodeResponse>

  agentByCodeAsof(req: AgentByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByCodeAsofResponse>

  watchAgentByName(req: WatchAgentByNameRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByNameResponse>

  lastValidAgentByName(req: LastValidAgentByNameRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByNameResponse>

  agentByNameAsof(req: AgentByNameAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByNameAsofResponse>

  watchAgentByLogin(req: WatchAgentByLoginRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByLoginResponse>

  lastValidAgentByLogin(req: LastValidAgentByLoginRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByLoginResponse>

  agentByLoginAsof(req: AgentByLoginAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByLoginAsofResponse>

  agentStampById(req: AgentStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<AgentStampByIdResponse>

  lastFlavoredStampForAgent(req: LastFlavoredStampForAgentRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForAgentResponse>

  watchStampsForAgent(req: WatchStampsForAgentRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForAgentResponse>

  stampsForAgentDuring(req: StampsForAgentDuringRequest, headers?: object, signal?: AbortSignal): Promise<StampsForAgentDuringResponse>

  agentAvatar(req: AgentAvatarRequest, headers?: object, signal?: AbortSignal): Promise<AgentAvatarResponse>

  watchAgentPresenceById(req: WatchAgentPresenceByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentPresenceByIdResponse>

  watchAllPresentAgents(headers?: object, signal?: AbortSignal): Promise<WatchAllPresentAgentsResponse>

  watchTruckModels(headers?: object, signal?: AbortSignal): Promise<WatchTruckModelsResponse>

  watchTruckModelById(req: WatchTruckModelByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckModelByIdResponse>

  watchTruckById(req: WatchTruckByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByIdResponse>

  lastValidTruckById(req: LastValidTruckByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidTruckByIdResponse>

  truckByIdAsof(req: TruckByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<TruckByIdAsofResponse>

  truckRevisionCount(req: TruckRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<TruckRevisionCountResponse>

  allTruckRevisions(req: AllTruckRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllTruckRevisionsResponse>

  watchTruckByPlate(req: WatchTruckByPlateRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByPlateResponse>

  lastValidTruckByPlate(req: LastValidTruckByPlateRequest, headers?: object, signal?: AbortSignal): Promise<LastValidTruckByPlateResponse>

  truckByPlateAsof(req: TruckByPlateAsofRequest, headers?: object, signal?: AbortSignal): Promise<TruckByPlateAsofResponse>

  watchTruckByCrew(req: WatchTruckByCrewRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByCrewResponse>

  truckTenuresByCrewDuring(req: TruckTenuresByCrewDuringRequest, headers?: object, signal?: AbortSignal): Promise<TruckTenuresByCrewDuringResponse>

  watchCrewByTruck(req: WatchCrewByTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchCrewByTruckResponse>

  crewTenuresByTruckDuring(req: CrewTenuresByTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<CrewTenuresByTruckDuringResponse>

  truckStampById(req: TruckStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<TruckStampByIdResponse>

  lastFlavoredStampForTruck(req: LastFlavoredStampForTruckRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForTruckResponse>

  watchStampsForTruck(req: WatchStampsForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForTruckResponse>

  stampsForTruckDuring(req: StampsForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<StampsForTruckDuringResponse>

  truckAvatar(req: TruckAvatarRequest, headers?: object, signal?: AbortSignal): Promise<TruckAvatarResponse>

  watchJobById(req: WatchJobByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByIdResponse>

  lastValidJobById(req: LastValidJobByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByIdResponse>

  jobByIdAsof(req: JobByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByIdAsofResponse>

  jobRevisionCount(req: JobRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<JobRevisionCountResponse>

  allJobRevisions(req: AllJobRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllJobRevisionsResponse>

  watchExportableJobs(headers?: object, signal?: AbortSignal): Promise<WatchExportableJobsResponse>

  /**
   * initially returns all exported in the last 24 hours
   */
  watchExportedJobs(headers?: object, signal?: AbortSignal): Promise<WatchExportedJobsResponse>

  showExportedJob(req: ShowExportedJobRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedJobResponse>

  exportJob(req: ExportJobRequest, headers?: object, signal?: AbortSignal): Promise<ExportJobResponse>

  watchJobByJobCode(req: WatchJobByJobCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByJobCodeResponse>

  lastValidJobByJobCode(req: LastValidJobByJobCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByJobCodeResponse>

  jobByJobCodeAsof(req: JobByJobCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByJobCodeAsofResponse>

  watchJobByIntakeCode(req: WatchJobByIntakeCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByIntakeCodeResponse>

  lastValidJobByIntakeCode(req: LastValidJobByIntakeCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByIntakeCodeResponse>

  jobByIntakeCodeAsof(req: JobByIntakeCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByIntakeCodeAsofResponse>

  jobStampById(req: JobStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<JobStampByIdResponse>

  lastFlavoredStampForJob(req: LastFlavoredStampForJobRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForJobResponse>

  watchStampsForJob(req: WatchStampsForJobRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForJobResponse>

  watchUnbundledWastesForJobAtVenue(req: WatchUnbundledWastesForJobAtVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchUnbundledWastesForJobAtVenueResponse>

  surchargeFlavorById(req: SurchargeFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeFlavorByIdResponse>

  surchargeFlavorByCode(req: SurchargeFlavorByCodeRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeFlavorByCodeResponse>

  watchSurchargesForSubject(req: WatchSurchargesForSubjectRequest, headers?: object, signal?: AbortSignal): Promise<WatchSurchargesForSubjectResponse>

  watchSurchargeById(req: WatchSurchargeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchSurchargeByIdResponse>

  lastValidSurchargeById(req: LastValidSurchargeByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidSurchargeByIdResponse>

  surchargeByIdAsof(req: SurchargeByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeByIdAsofResponse>

  allSurchargeRevisions(req: AllSurchargeRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllSurchargeRevisionsResponse>

  watchBundleById(req: WatchBundleByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleByIdResponse>

  lastValidBundleById(req: LastValidBundleByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidBundleByIdResponse>

  bundleByIdAsof(req: BundleByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<BundleByIdAsofResponse>

  bundleRevisionCount(req: BundleRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<BundleRevisionCountResponse>

  allBundleRevisions(req: AllBundleRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllBundleRevisionsResponse>

  watchBundleLocation(req: WatchBundleLocationRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleLocationResponse>

  watchOrphanedBundles(headers?: object, signal?: AbortSignal): Promise<WatchOrphanedBundlesResponse>

  activeBundleCount(headers?: object, signal?: AbortSignal): Promise<ActiveBundleCountResponse>

  watchActiveBundles(headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesResponse>

  activeBundlePage(req: ActiveBundlePageRequest, headers?: object, signal?: AbortSignal): Promise<ActiveBundlePageResponse>

  watchActiveBundlesDestinedFor(req: WatchActiveBundlesDestinedForRequest, headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesDestinedForResponse>

  watchActiveBundlesOriginatingAt(req: WatchActiveBundlesOriginatingAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesOriginatingAtResponse>

  watchExportableBundles(headers?: object, signal?: AbortSignal): Promise<WatchExportableBundlesResponse>

  watchInspectableBundles(req: WatchInspectableBundlesRequest, headers?: object, signal?: AbortSignal): Promise<WatchInspectableBundlesResponse>

  watchBundlesNeedingSupervisor(req: WatchBundlesNeedingSupervisorRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundlesNeedingSupervisorResponse>

  showExportedBundle(req: ShowExportedBundleRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedBundleResponse>

  completeBundleHistoryById(req: CompleteBundleHistoryByIdRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleHistoryByIdResponse>

  bundleStampById(req: BundleStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<BundleStampByIdResponse>

  lastFlavoredStampForBundle(req: LastFlavoredStampForBundleRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForBundleResponse>

  watchStampsForBundle(req: WatchStampsForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForBundleResponse>

  watchFlavoredStampsForBundle(req: WatchFlavoredStampsForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchFlavoredStampsForBundleResponse>

  watchTransferById(req: WatchTransferByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransferByIdResponse>

  /**
   * when initially called, returns all transfers that overlap 'today'
   */
  watchAllTransfers(headers?: object, signal?: AbortSignal): Promise<WatchAllTransfersResponse>

  watchOpenTransfersForTruck(req: WatchOpenTransfersForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchOpenTransfersForTruckResponse>

  watchTransfersForTruck(req: WatchTransfersForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransfersForTruckResponse>

  watchLastTransferForBundle(req: WatchLastTransferForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchLastTransferForBundleResponse>

  lastTransferForBundleBefore(req: LastTransferForBundleBeforeRequest, headers?: object, signal?: AbortSignal): Promise<LastTransferForBundleBeforeResponse>

  allTransfersForBundle(req: AllTransfersForBundleRequest, headers?: object, signal?: AbortSignal): Promise<AllTransfersForBundleResponse>

  transfersForTruckDuring(req: TransfersForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<TransfersForTruckDuringResponse>

  watchTransfersAtVenue(req: WatchTransfersAtVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransfersAtVenueResponse>

  watchTriplegById(req: WatchTriplegByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegByIdResponse>

  /**
   * when initially called, returns all triplegs that overlap 'today'
   */
  watchAllTriplegs(headers?: object, signal?: AbortSignal): Promise<WatchAllTriplegsResponse>

  watchOpenTriplegForTruck(req: WatchOpenTriplegForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchOpenTriplegForTruckResponse>

  watchLastTriplegForTruck(req: WatchLastTriplegForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchLastTriplegForTruckResponse>

  watchTriplegsForTruck(req: WatchTriplegsForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegsForTruckResponse>

  triplegsForTruckDuring(req: TriplegsForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<TriplegsForTruckDuringResponse>

  watchUnadmittedTriplegsInto(req: WatchUnadmittedTriplegsIntoRequest, headers?: object, signal?: AbortSignal): Promise<WatchUnadmittedTriplegsIntoResponse>

  watchTriplegsInboundTo(req: WatchTriplegsInboundToRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegsInboundToResponse>

  watchScheduledTransferById(req: WatchScheduledTransferByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransferByIdResponse>

  watchScheduledTransferForBundle(req: WatchScheduledTransferForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransferForBundleResponse>

  /**
   * use an empty string to watch unassigned scheduled transfers
   */
  watchScheduledTransfersForDriver(req: WatchScheduledTransfersForDriverRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersForDriverResponse>

  watchScheduledTransfersAwaitingTruck(req: WatchScheduledTransfersAwaitingTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersAwaitingTruckResponse>

  scheduledTransfersDuring(req: ScheduledTransfersDuringRequest, headers?: object, signal?: AbortSignal): Promise<ScheduledTransfersDuringResponse>

  watchScheduledTransfersAt(req: WatchScheduledTransfersAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersAtResponse>

  watchScheduledTransfersForDispatch(headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersForDispatchResponse>

  wasteFlavorByCode(req: WasteFlavorByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WasteFlavorByCodeResponse>

  watchWasteFlavorById(req: WatchWasteFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteFlavorByIdResponse>

  lastValidWasteFlavorById(req: LastValidWasteFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidWasteFlavorByIdResponse>

  wasteFlavorRevisionCount(req: WasteFlavorRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<WasteFlavorRevisionCountResponse>

  allWasteFlavorRevisions(req: AllWasteFlavorRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteFlavorRevisionsResponse>

  activeWasteFlavors(req: ActiveWasteFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<ActiveWasteFlavorsResponse>

  getCleavableFlavors(req: GetCleavableFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<GetCleavableFlavorsResponse>

  getEmissibleFlavors(req: GetEmissibleFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<GetEmissibleFlavorsResponse>

  watchWasteById(req: WatchWasteByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteByIdResponse>

  lastValidWasteById(req: LastValidWasteByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidWasteByIdResponse>

  wasteByIdAsof(req: WasteByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<WasteByIdAsofResponse>

  wasteRevisionCount(req: WasteRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<WasteRevisionCountResponse>

  allWasteRevisionStubs(req: AllWasteRevisionStubsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteRevisionStubsResponse>

  allWasteRevisions(req: AllWasteRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteRevisionsResponse>

  watchWastesForBundle(req: WatchWastesForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchWastesForBundleResponse>

  allWastesForBundle(req: AllWastesForBundleRequest, headers?: object, signal?: AbortSignal): Promise<AllWastesForBundleResponse>

  wastesForBundleAsof(req: WastesForBundleAsofRequest, headers?: object, signal?: AbortSignal): Promise<WastesForBundleAsofResponse>

  allDaughtersOfWaste(req: AllDaughtersOfWasteRequest, headers?: object, signal?: AbortSignal): Promise<AllDaughtersOfWasteResponse>

  mothersOfWaste(req: MothersOfWasteRequest, headers?: object, signal?: AbortSignal): Promise<MothersOfWasteResponse>

  directWasteLineageRecords(req: DirectWasteLineageRecordsRequest, headers?: object, signal?: AbortSignal): Promise<DirectWasteLineageRecordsResponse>

  watchBundleForWaste(req: WatchBundleForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleForWasteResponse>

  lastValidBundleForWaste(req: LastValidBundleForWasteRequest, headers?: object, signal?: AbortSignal): Promise<LastValidBundleForWasteResponse>

  bundleForWasteAsof(req: BundleForWasteAsofRequest, headers?: object, signal?: AbortSignal): Promise<BundleForWasteAsofResponse>

  allBundlesForWaste(req: AllBundlesForWasteRequest, headers?: object, signal?: AbortSignal): Promise<AllBundlesForWasteResponse>

  watchAssociationsForWaste(req: WatchAssociationsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchAssociationsForWasteResponse>

  showExportedWaste(req: ShowExportedWasteRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedWasteResponse>

  completeWasteHistoryById(req: CompleteWasteHistoryByIdRequest, headers?: object, signal?: AbortSignal): Promise<CompleteWasteHistoryByIdResponse>

  watchWasteLocation(req: WatchWasteLocationRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteLocationResponse>

  watchWastesAt(req: WatchWastesAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchWastesAtResponse>

  wasteStampById(req: WasteStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<WasteStampByIdResponse>

  lastFlavoredStampForWaste(req: LastFlavoredStampForWasteRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForWasteResponse>

  watchStampsForWaste(req: WatchStampsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForWasteResponse>

  watchFlavoredStampsForWaste(req: WatchFlavoredStampsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchFlavoredStampsForWasteResponse>

  watchPackingModes(headers?: object, signal?: AbortSignal): Promise<WatchPackingModesResponse>

  watchPackingModeById(req: WatchPackingModeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchPackingModeByIdResponse>

  watchManifestTypes(headers?: object, signal?: AbortSignal): Promise<WatchManifestTypesResponse>

  watchManifestTypeById(req: WatchManifestTypeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchManifestTypeByIdResponse>

  watchUnits(headers?: object, signal?: AbortSignal): Promise<WatchUnitsResponse>

  watchTransformModes(headers?: object, signal?: AbortSignal): Promise<WatchTransformModesResponse>

  watchTransformModesForVenue(req: WatchTransformModesForVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransformModesForVenueResponse>

  allRewindCheckpoints(headers?: object, signal?: AbortSignal): Promise<AllRewindCheckpointsResponse>

  setlists(options: WebrpcStreamOptions<SetlistPacketResult>): WebrpcStreamController

  setlistSubscriptions(headers?: object, signal?: AbortSignal): Promise<SetlistSubscriptionsResponse>

  /**
   * this is loosely typed to allow extension. it needs to be guaranteed to extend
   * the shape of SystemConfig
   */
  setSystemConfig(req: SetSystemConfigRequest, headers?: object, signal?: AbortSignal): Promise<SetSystemConfigResponse>

  upsertCompany(req: UpsertCompanyRequest, headers?: object, signal?: AbortSignal): Promise<UpsertCompanyResponse>

  patchCompany(req: PatchCompanyRequest, headers?: object, signal?: AbortSignal): Promise<PatchCompanyResponse>

  retireCompany(req: RetireCompanyRequest, headers?: object, signal?: AbortSignal): Promise<RetireCompanyResponse>

  upsertVenue(req: UpsertVenueRequest, headers?: object, signal?: AbortSignal): Promise<UpsertVenueResponse>

  patchVenue(req: PatchVenueRequest, headers?: object, signal?: AbortSignal): Promise<PatchVenueResponse>

  retireVenue(req: RetireVenueRequest, headers?: object, signal?: AbortSignal): Promise<RetireVenueResponse>

  upsertDownstreamVenue(req: UpsertDownstreamVenueRequest, headers?: object, signal?: AbortSignal): Promise<UpsertDownstreamVenueResponse>

  upsertAgent(req: UpsertAgentRequest, headers?: object, signal?: AbortSignal): Promise<UpsertAgentResponse>

  patchAgent(req: PatchAgentRequest, headers?: object, signal?: AbortSignal): Promise<PatchAgentResponse>

  patchSelf(req: PatchSelfRequest, headers?: object, signal?: AbortSignal): Promise<PatchSelfResponse>

  /**
   * returns new authentication token
   */
  changePassword(req: ChangePasswordRequest, headers?: object, signal?: AbortSignal): Promise<ChangePasswordResponse>

  retireAgent(req: RetireAgentRequest, headers?: object, signal?: AbortSignal): Promise<RetireAgentResponse>

  stampAgent(req: StampAgentRequest, headers?: object, signal?: AbortSignal): Promise<StampAgentResponse>

  upsertTruckModel(req: UpsertTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTruckModelResponse>

  patchTruckModel(req: PatchTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<PatchTruckModelResponse>

  retireTruckModel(req: RetireTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<RetireTruckModelResponse>

  upsertTruck(req: UpsertTruckRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTruckResponse>

  patchTruck(req: PatchTruckRequest, headers?: object, signal?: AbortSignal): Promise<PatchTruckResponse>

  retireTruck(req: RetireTruckRequest, headers?: object, signal?: AbortSignal): Promise<RetireTruckResponse>

  mountTruck(req: MountTruckRequest, headers?: object, signal?: AbortSignal): Promise<MountTruckResponse>

  dismountTruck(headers?: object, signal?: AbortSignal): Promise<DismountTruckResponse>

  stampTruck(req: StampTruckRequest, headers?: object, signal?: AbortSignal): Promise<StampTruckResponse>

  upsertSurchargeFlavor(req: UpsertSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<UpsertSurchargeFlavorResponse>

  patchSurchargeFlavor(req: PatchSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<PatchSurchargeFlavorResponse>

  retireSurchargeFlavor(req: RetireSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<RetireSurchargeFlavorResponse>

  spawnSurcharge(req: SpawnSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<SpawnSurchargeResponse>

  patchSurcharge(req: PatchSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<PatchSurchargeResponse>

  retireSurcharge(req: RetireSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<RetireSurchargeResponse>

  upsertShinwaJob(req: UpsertShinwaJobRequest, headers?: object, signal?: AbortSignal): Promise<UpsertShinwaJobResponse>

  upsertSanyuJob(req: UpsertSanyuJobRequest, headers?: object, signal?: AbortSignal): Promise<UpsertSanyuJobResponse>

  patchJob(req: PatchJobRequest, headers?: object, signal?: AbortSignal): Promise<PatchJobResponse>

  stampJob(req: StampJobRequest, headers?: object, signal?: AbortSignal): Promise<StampJobResponse>

  cancelJobStamp(req: CancelJobStampRequest, headers?: object, signal?: AbortSignal): Promise<CancelJobStampResponse>

  spawnGroundedBundle(req: SpawnGroundedBundleRequest, headers?: object, signal?: AbortSignal): Promise<SpawnGroundedBundleResponse>

  spawnLoadedBundle(req: SpawnLoadedBundleRequest, headers?: object, signal?: AbortSignal): Promise<SpawnLoadedBundleResponse>

  patchBundle(req: PatchBundleRequest, headers?: object, signal?: AbortSignal): Promise<PatchBundleResponse>

  stampBundle(req: StampBundleRequest, headers?: object, signal?: AbortSignal): Promise<StampBundleResponse>

  fieldCancelBundle(req: FieldCancelBundleRequest, headers?: object, signal?: AbortSignal): Promise<FieldCancelBundleResponse>

  retireBundle(req: RetireBundleRequest, headers?: object, signal?: AbortSignal): Promise<RetireBundleResponse>

  scheduleBundlePickup(req: ScheduleBundlePickupRequest, headers?: object, signal?: AbortSignal): Promise<ScheduleBundlePickupResponse>

  scheduleBundleDropoff(req: ScheduleBundleDropoffRequest, headers?: object, signal?: AbortSignal): Promise<ScheduleBundleDropoffResponse>

  patchScheduledTransfer(req: PatchScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<PatchScheduledTransferResponse>

  cancelScheduledTransfer(req: CancelScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<CancelScheduledTransferResponse>

  disclaimScheduledTransfer(req: DisclaimScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<DisclaimScheduledTransferResponse>

  disclaimAllMyScheduledTransfers(headers?: object, signal?: AbortSignal): Promise<DisclaimAllMyScheduledTransfersResponse>

  startTripleg(req: StartTriplegRequest, headers?: object, signal?: AbortSignal): Promise<StartTriplegResponse>

  patchTripleg(req: PatchTriplegRequest, headers?: object, signal?: AbortSignal): Promise<PatchTriplegResponse>

  arrive(req: ArriveRequest, headers?: object, signal?: AbortSignal): Promise<ArriveResponse>

  admit(req: AdmitRequest, headers?: object, signal?: AbortSignal): Promise<AdmitResponse>

  startBundleOnloading(req: StartBundleOnloadingRequest, headers?: object, signal?: AbortSignal): Promise<StartBundleOnloadingResponse>

  completeBundleOnloading(req: CompleteBundleOnloadingRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleOnloadingResponse>

  startBundleOffloading(req: StartBundleOffloadingRequest, headers?: object, signal?: AbortSignal): Promise<StartBundleOffloadingResponse>

  completeBundleOffloading(req: CompleteBundleOffloadingRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleOffloadingResponse>

  upsertUnit(req: UpsertUnitRequest, headers?: object, signal?: AbortSignal): Promise<UpsertUnitResponse>

  upsertWasteFlavor(req: UpsertWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<UpsertWasteFlavorResponse>

  patchWasteFlavor(req: PatchWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<PatchWasteFlavorResponse>

  retireWasteFlavor(req: RetireWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<RetireWasteFlavorResponse>

  upsertWasteFlavorRecipe(req: UpsertWasteFlavorRecipeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertWasteFlavorRecipeResponse>

  deleteWasteFlavorRecipe(req: DeleteWasteFlavorRecipeRequest, headers?: object, signal?: AbortSignal): Promise<DeleteWasteFlavorRecipeResponse>

  upsertPackingMode(req: UpsertPackingModeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertPackingModeResponse>

  upsertManifestType(req: UpsertManifestTypeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertManifestTypeResponse>

  spawnWaste(req: SpawnWasteRequest, headers?: object, signal?: AbortSignal): Promise<SpawnWasteResponse>

  patchWaste(req: PatchWasteRequest, headers?: object, signal?: AbortSignal): Promise<PatchWasteResponse>

  stampWaste(req: StampWasteRequest, headers?: object, signal?: AbortSignal): Promise<StampWasteResponse>

  /**
   * you probably only want to call one or the other of these
   */
  attachWasteToBundle(req: AttachWasteToBundleRequest, headers?: object, signal?: AbortSignal): Promise<AttachWasteToBundleResponse>

  attachWasteToJob(req: AttachWasteToJobRequest, headers?: object, signal?: AbortSignal): Promise<AttachWasteToJobResponse>

  detachWasteFromBundle(req: DetachWasteFromBundleRequest, headers?: object, signal?: AbortSignal): Promise<DetachWasteFromBundleResponse>

  storeWasteTemporary(req: StoreWasteTemporaryRequest, headers?: object, signal?: AbortSignal): Promise<StoreWasteTemporaryResponse>

  storeWastePermanent(req: StoreWastePermanentRequest, headers?: object, signal?: AbortSignal): Promise<StoreWastePermanentResponse>

  divideFromWaste(req: DivideFromWasteRequest, headers?: object, signal?: AbortSignal): Promise<DivideFromWasteResponse>

  mergeIntoWaste(req: MergeIntoWasteRequest, headers?: object, signal?: AbortSignal): Promise<MergeIntoWasteResponse>

  retireWaste(req: RetireWasteRequest, headers?: object, signal?: AbortSignal): Promise<RetireWasteResponse>

  upsertTransformMode(req: UpsertTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTransformModeResponse>

  adoptTransformMode(req: AdoptTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<AdoptTransformModeResponse>

  abandonTransformMode(req: AbandonTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<AbandonTransformModeResponse>

  attachPhotoToStamp(req: AttachPhotoToStampRequest, headers?: object, signal?: AbortSignal): Promise<AttachPhotoToStampResponse>

  rewindToCheckpoint(req: RewindToCheckpointRequest, headers?: object, signal?: AbortSignal): Promise<RewindToCheckpointResponse>

  spawnCheckpoint(req: SpawnCheckpointRequest, headers?: object, signal?: AbortSignal): Promise<SpawnCheckpointResponse>
}


//
// Schema types
//

export interface EntityStub {
  id: string
  displayName: string
  code: string
}

export interface WiredSetlistPacket {
  pkid: string
  tbl: string
  asof: string
  path: Array<string>
  tqks: Array<string>
  dlta?: boolean
  prev?: any
  next?: any
}

export interface RewindCheckpoint {
  id: string
  author: AgentStub
  asof: string
  name: string
}

export interface Photo {
  id: string
  slug: string
  taker: AgentStub
  taken: string
}

export interface Stamp {
  id: string
  subjectClass: StampableClassname
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: string
  photo?: Photo
  caption?: string
}

export interface NewStampFood {
  subjectClass: StampableClassname
  subjectId: string
  flavor?: string
  photoId?: string
  caption?: string
}

export interface Company {
  id: string
  created: string
  asof?: string
  displayName: string
  sortName?: string
  code: string
  email?: string
  telno?: string
  author: AgentStub
  validSpan: string
}

export interface NewCompanyFood {
  displayName: string
  sortName?: string
  code: string
  address?: string
  email?: string
  telno?: string
}

export interface CompanyStub {
  id: string
  displayName: string
  code: string
}

export interface CompanyConflict {
  requested: NewCompanyFood
  existing: CompanyStub
}

export interface CompanyUpsertResult {
  existingId?: string
  newId?: string
  conflict?: CompanyConflict
}

export interface CompanyPatch {
  displayName?: string
  sortName?: string
  code?: string
  email?: string
  telno?: string
}

export interface Venue {
  id: string
  created: string
  asof?: string
  company: CompanyStub
  displayName: string
  sortName?: string
  code: string
  email?: string
  telno?: string
  address?: string
  geoloc?: string
  author: AgentStub
  validSpan: string
}

export interface NewVenueFood {
  companyId: string
  displayName: string
  code: string
  sortName?: string
  email?: string
  telno?: string
  address?: string
  geoloc?: string
}

export interface UpsertableVenue {
  companyId?: string
  companyCode?: string
  companyName?: string
  companySortName?: string
  code: string
  displayName: string
  sortName?: string
  email?: string
  telno?: string
  address?: string
  geoloc?: string
}

export interface VenueStub {
  id: string
  displayName: string
  code: string
}

export interface VenueConflict {
  requested: UpsertableVenue
  existing: VenueStub
}

export interface VenueUpsertResult {
  existingId?: string
  newId?: string
  companyConflict?: CompanyConflict
  conflict?: VenueConflict
}

export interface VenuePatch {
  companyId?: string
  displayName?: string
  sortName?: string
  code?: string
  email?: string
  telno?: string
  address?: string
  geoloc?: string
}

export interface Agent {
  id: string
  created: string
  asof?: string
  company: CompanyStub
  code: string
  displayName: string
  sortName?: string
  telno?: string
  email?: string
  loginName?: string
  canAdmin: boolean
  canDrive: boolean
  canDispatch: boolean
  admitterFor?: VenueStub
  inspectorFor?: VenueStub
  supervisorFor?: VenueStub
  author: AgentStub
  validSpan: string
}

export interface NewAgentFood {
  companyId: string
  code: string
  displayName: string
  sortName?: string
  telno?: string
  email?: string
  canAdmin?: boolean
  canDrive?: boolean
  canDispatch?: boolean
  admitterFor?: string
  inspectorFor?: string
  supervisorFor?: string
  loginName?: string
  password?: string
}

export interface UpsertableAgent {
  companyId?: string
  companyCode?: string
  companyName?: string
  code: string
  displayName: string
  sortName?: string
  telno?: string
  email?: string
  canAdmin?: boolean
  canDrive?: boolean
  canDispatch?: boolean
  admitterFor?: string
  admitterForCode?: string
  admitterForName?: string
  inspectorFor?: string
  inspectorForCode?: string
  inspectorForName?: string
  supervisorFor?: string
  supervisorForCode?: string
  supervisorForName?: string
  loginName?: string
  password?: string
}

export interface AgentUpsertResult {
  existingId?: string
  newId?: string
  companyConflict?: CompanyConflict
  venueConflict?: VenueConflict
  conflict?: AgentStub
}

export interface AgentPatch {
  displayName?: string
  sortName?: string
  loginName?: string
  password?: string
  code?: string
  telno?: string
  email?: string
  canAdmin?: boolean
  canDrive?: boolean
  canDispatch?: boolean
  admitterFor?: string
  inspectorFor?: string
  supervisorFor?: string
}

export interface SelfPatch {
  displayName?: string
  sortName?: string
  telno?: string
  email?: string
  loginName?: string
  prefs?: any
}

export interface PasswordChange {
  targetId: string
  oldPassword: string
  newPassword: string
}

export interface AgentStamp {
  id: string
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: AgentStampFlavor
  photo?: Photo
  caption?: string
}

export interface NewAgentStampFood {
  agentId: string
  flavor?: AgentStampFlavor
  photoId?: string
  caption?: string
}

export interface AgentStub {
  id: string
  displayName: string
  code: string
}

export interface AgentOutlet {
  outletId: string
  agentId: string
  connectionStatus: string
  opened: string
  lastUsed: string
  lastConnected?: string
  lastDisconnected?: string
}

export interface AgentPresence {
  id: string
  agent: AgentStub
  lastShiftEventFlavor?: AgentStampFlavor
  lastShiftEventPosted?: string
  outlets: Array<AgentOutlet>
}

export interface TruckModel {
  id: string
  created: string
  asof?: string
  displayName: string
  code: string
  weightCapGrams: number
  volCapDm3: number
  author: AgentStub
  validSpan: string
}

export interface NewTruckModelFood {
  code: string
  displayName: string
  weightCapGrams?: number
  volCapDm3?: number
}

export interface TruckModelUpsertResult {
  existingId?: string
  newId?: string
  conflict?: TruckModel
}

export interface TruckModelPatch {
  displayName?: string
  code?: string
  weightCapGrams?: number
  volCapDm3?: number
}

export interface TruckModelStub {
  id: string
  displayName: string
  code: string
}

export interface Truck {
  id: string
  created: string
  asof?: string
  company: CompanyStub
  code: string
  displayName: string
  sortName?: string
  model?: TruckModelStub
  author: AgentStub
  validSpan: string
}

export interface NewTruckFood {
  displayName: string
  companyId: string
  code: string
  modelId?: string
}

export interface UpsertableTruck {
  modelId?: string
  companyId?: string
  companyCode?: string
  companyName?: string
  displayName: string
  code?: string
}

export interface TruckStub {
  id: string
  displayName: string
  code: string
}

export interface TruckConflict {
  requested: UpsertableTruck
  existing: TruckStub
}

export interface TruckUpsertResult {
  existingId?: string
  newId?: string
  companyConflict?: CompanyConflict
  conflict?: TruckConflict
}

export interface TruckPatch {
  displayName?: string
  companyId?: string
  code?: string
  modelId?: string
}

export interface TruckStamp {
  id: string
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: TruckStampFlavor
  photo?: Photo
  caption?: string
}

export interface NewTruckStampFood {
  truckId: string
  flavor?: TruckStampFlavor
  photoId?: string
  caption?: string
}

export interface TruckCrewTenure {
  id: string
  truck: TruckStub
  crew: AgentStub
  validSpan: string
}

export interface CrewTenure {
  id: string
  crew: AgentStub
  validSpan: string
}

export interface TruckTenure {
  id: string
  truck: TruckStub
  validSpan: string
}

export interface ShinwaJobExtras {
  distanceFee?: boolean
  comboTripSlot?: boolean
  docking?: boolean
  salesContactName?: string
  orderContactName?: string
  specialNotes?: string
  orderNotes?: Array<string>
  driverNotes?: Array<string>
  photoRequired?: boolean
  manifestTypeCode?: string
}

export interface TransportSegment {
  pickupCompany?: CompanyStub
  pickupVenue?: VenueStub
  transportCompany?: CompanyStub
  dropoffCompany?: CompanyStub
  dropoffVenue?: VenueStub
}

export interface SanyuJobExtras {
  orderContact?: string
  manifestTypeCode?: string
  driverNotes?: string
  transportSegments: Array<TransportSegment>
}

export interface WideJobExtras {
  shinwa?: ShinwaJobExtras
  sanyu?: SanyuJobExtras
}

export interface Job {
  id: string
  created: string
  jobCode?: string
  intakeCode?: string
  code: string
  displayName: string
  sortName?: string
  asof?: string
  sendCompany: CompanyStub
  transportCompany?: CompanyStub
  receiveCompany?: CompanyStub
  origin?: VenueStub
  provisionalDestination?: VenueStub
  extras?: WideJobExtras
  author: AgentStub
  validSpan: string
}

export interface UpsertableShinwaJob {
  timestamp?: string
  orderId?: string
  intakeId?: string
  assignedDriverId?: string
  assignedDriverName?: string
  assignedDriverCode?: string
  assignedTruckModelId?: string
  assignedTruckModelName?: string
  assignedTruckModelCode?: string
  transportCompanyId?: string
  transportCompanyName?: string
  transportCompanyCode?: string
  assignedTruckId?: string
  assignedTruckPlate?: string
  assignedTruckCode?: string
  pickupDate?: string
  pickupStartTime?: string
  pickupEndTime?: string
  dropoffCompanyId?: string
  dropoffCompanyName?: string
  dropoffCompanyKana?: string
  dropoffCompanyCode?: string
  dropoffCompanyAddressPostCode?: string
  dropoffCompanyAddress0?: string
  dropoffCompanyAddress1?: string
  dropoffCompanyAddress2?: string
  dropoffCompanyTel?: string
  dropoffCompanyKind?: string
  dropoffCompanyKindCode?: string
  dropoffVenueId?: string
  dropoffVenueName?: string
  dropoffVenueKana?: string
  dropoffVenueCode?: string
  dropoffVenueAddressPostCode?: string
  dropoffVenueAddress0?: string
  dropoffVenueAddress3?: string
  dropoffVenueAddress4?: string
  dropoffVenueTel?: string
  dropoffJwnetId?: string
  dropoffEdiId?: string
  dropoffVenueKind?: string
  dropoffVenueKindCode?: string
  pickupCompanyId?: string
  pickupCompanyName?: string
  pickupCompanyKana?: string
  pickupCompanyCode?: string
  pickupCompanyAddressCode?: string
  pickupCompanyAddress0?: string
  pickupCompanyAddress3?: string
  pickupCompanyAddress4?: string
  pickupCompanyTel?: string
  pickupCompanyKind?: string
  pickupCompanyKindCode?: string
  transferName?: string
  transferCode?: string
  pickupVenueId?: string
  pickupVenueName?: string
  pickupVenueKana?: string
  pickupVenueCode?: string
  pickupVenueAddress1?: string
  pickupVenueAddress0?: string
  pickupVenueAddress3?: string
  pickupVenueAddress4?: string
  pickupVenueTel?: string
  pickupJwnetId?: string
  pickupEdiId?: string
  pickupVenueKind?: string
  pickupVenueKindCode?: string
  pickupInstructions?: string
  regulatoryInfo?: string
  contactName?: string
  orderNotes1?: string
  orderNotes2?: string
  officeAddress?: string
  officeTel?: string
  additionalContacts?: string
  contactTel?: string
  manifestType?: string
  transferKind?: string
  businessKind?: string
  additionalWork?: string
  extraDistance?: string
  keyPhoto?: string
  keyBoard?: string
  prepNumber?: string
  contractDropoffSite?: string
  pathInfo?: string
  specialNotes?: string
  driverNotes1?: string
  driverNotes2?: string
  driverNotes3?: string
  driverNotes4?: string
  driverNotes5?: string
  detailUrl?: string
  salesContactName?: string
  salesContactCode?: string
  comboTripSlot?: string
  specialTruck?: string
  docking?: string
}

export interface UpsertableSanyuJob {
  timestamp?: string
  orderId?: string
  internalTransferFlag?: string
  pickupCompanyId?: string
  pickupCompanyName?: string
  pickupCompanyKana?: string
  pickupCompanyCode?: string
  pickupCompanyAddressPostCode?: string
  pickupCompanyAddress0?: string
  pickupCompanyAddress1?: string
  pickupCompanyAddress2?: string
  pickupCompanyTel?: string
  pickupVenueId?: string
  pickupVenueName?: string
  pickupVenueKana?: string
  pickupVenueCode?: string
  pickupVenueAddressPostCode?: string
  pickupVenueAddress0?: string
  pickupVenueAddress1?: string
  pickupVenueAddress2?: string
  pickupVenueTel?: string
  pickupDepartmentName?: string
  pickupDepartmentCode?: string
  stage1TransportCompanyName?: string
  stage1TransportCompanyKana?: string
  stage1TransportCompanyCode?: string
  stage1TransportCompanyAddressPostCode?: string
  stage1TransportCompanyAddress0?: string
  stage1TransportCompanyAddress1?: string
  stage1TransportCompanyAddress2?: string
  stage1TransportCompanyTel?: string
  stage1DropoffCompanyName?: string
  stage1DropoffCompanyKana?: string
  stage1DropoffCompanyCode?: string
  stage1DropoffVenueName?: string
  stage1DropoffVenueKana?: string
  stage1DropoffVenueCode?: string
  stage1DropoffVenueAddressPostCode?: string
  stage1DropoffVenueAddress0?: string
  stage1DropoffVenueAddress1?: string
  stage1DropoffVenueAddress2?: string
  stage1DropoffVenueTel?: string
  stage2TransportCompanyName?: string
  stage2TransportCompanyKana?: string
  stage2TransportCompanyCode?: string
  stage2TransportCompanyAddressPostCode?: string
  stage2TransportCompanyAddress0?: string
  stage2TransportCompanyAddress1?: string
  stage2TransportCompanyAddress2?: string
  stage2TransportCompanyTel?: string
  stage2DropoffCompanyName?: string
  stage2DropoffCompanyKana?: string
  stage2DropoffCompanyCode?: string
  stage2DropoffVenueName?: string
  stage2DropoffVenueKana?: string
  stage2DropoffVenueCode?: string
  stage2DropoffVenueAddressPostCode?: string
  stage2DropoffVenueAddress0?: string
  stage2DropoffVenueAddress1?: string
  stage2DropoffVenueAddress2?: string
  stage2DropoffVenueTel?: string
  stage3TransportCompanyName?: string
  stage3TransportCompanyKana?: string
  stage3TransportCompanyCode?: string
  stage3TransportCompanyAddressPostCode?: string
  stage3TransportCompanyAddress0?: string
  stage3TransportCompanyAddress1?: string
  stage3TransportCompanyAddress2?: string
  stage3TransportCompanyTel?: string
  stage3DropoffCompanyName?: string
  stage3DropoffCompanyKana?: string
  stage3DropoffCompanyCode?: string
  stage3DropoffVenueName?: string
  stage3DropoffVenueKana?: string
  stage3DropoffVenueCode?: string
  stage3DropoffVenueAddressPostCode?: string
  stage3DropoffVenueAddress0?: string
  stage3DropoffVenueAddress1?: string
  stage3DropoffVenueAddress2?: string
  stage3DropoffVenueTel?: string
  stage4TransportCompanyName?: string
  stage4TransportCompanyKana?: string
  stage4TransportCompanyCode?: string
  stage4TransportCompanyAddressPostCode?: string
  stage4TransportCompanyAddress0?: string
  stage4TransportCompanyAddress1?: string
  stage4TransportCompanyAddress2?: string
  stage4TransportCompanyTel?: string
  stage4DropoffCompanyName?: string
  stage4DropoffCompanyKana?: string
  stage4DropoffCompanyCode?: string
  stage4DropoffVenueName?: string
  stage4DropoffVenueKana?: string
  stage4DropoffVenueCode?: string
  stage4DropoffVenueAddressPostCode?: string
  stage4DropoffVenueAddress0?: string
  stage4DropoffVenueAddress1?: string
  stage4DropoffVenueAddress2?: string
  stage4DropoffVenueTel?: string
  stage5TransportCompanyName?: string
  stage5TransportCompanyKana?: string
  stage5TransportCompanyCode?: string
  stage5TransportCompanyAddressPostCode?: string
  stage5TransportCompanyAddress0?: string
  stage5TransportCompanyAddress1?: string
  stage5TransportCompanyAddress2?: string
  stage5TransportCompanyTel?: string
  dropoffCompanyId?: string
  dropoffCompanyName?: string
  dropoffCompanyKana?: string
  dropoffCompanyCode?: string
  dropoffCompanyAddressPostCode?: string
  dropoffCompanyAddress0?: string
  dropoffCompanyAddress1?: string
  dropoffCompanyAddress2?: string
  dropoffCompanyTel?: string
  dropoffVenueId?: string
  dropoffVenueName?: string
  dropoffVenueKana?: string
  dropoffVenueCode?: string
  dropoffVenueAddressPostCode?: string
  dropoffVenueAddress0?: string
  dropoffVenueAddress1?: string
  dropoffVenueAddress2?: string
  dropoffVenueTel?: string
  billingEntityName?: string
  billingEntityCode?: string
  billingDepartmentName?: string
  billingDepartmentCode?: string
  orderContact?: string
  orderNotes2?: string
  orderNotes3?: string
  orderNotes4?: string
  orderNotes5?: string
  manifestType?: string
  driverNotes?: string
  siteContact?: string
}

export interface JobUpsertResult {
  existingId?: string
  newId?: string
  companyConflict?: CompanyConflict
  venueConflict?: VenueConflict
  driverConflict?: AgentStub
  truckConflict?: TruckConflict
  truckModelConflict?: TruckModelStub
  conflict?: JobStub
}

export interface JobPatch {
  jobCode?: string
  intakeCode?: string
  originId?: string
  provisionalDestinationId?: string
  extras?: WideJobExtras
}

export interface JobStub {
  id: string
  displayName: string
  code: string
}

export interface JobStamp {
  id: string
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: JobStampFlavor
  photo?: Photo
  caption?: string
}

export interface NewJobStampFood {
  jobId: string
  flavor?: JobStampFlavor
  photoId?: string
  caption?: string
}

export interface SurchargeFlavor {
  id: string
  created: string
  code: string
  displayName: string
  sortName?: string
  abbrev?: string
  unitId?: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  applyToJobs?: boolean
  applyToBundles?: boolean
  applyToWastes?: boolean
}

export interface NewSurchargeFlavorFood {
  code: string
  displayName: string
  sortName?: string
  abbrev?: string
  unitId: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  applyToJobs?: boolean
  applyToBundles?: boolean
  applyToWastes?: boolean
}

export interface SurchargeFlavorPatch {
  code?: string
  displayName?: string
  sortName?: string
  abbrev?: string
  unitId?: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  applyToJobs?: boolean
  applyToBundles?: boolean
  applyToWastes?: boolean
}

export interface SurchargeFlavorStub {
  id: string
  displayName: string
  code: string
  unitId: string
}

export interface Surcharge {
  id: string
  created: string
  asof?: string
  subjectClass: SurchargeableClassname
  subjectId: string
  flavor: SurchargeFlavorStub
  source: SurchargeSource
  quantity?: number
  cost?: number
  comment?: string
  author?: AgentStub
  validSpan: string
}

export interface NewSurchargeFood {
  subjectClass: SurchargeableClassname
  subjectId: string
  flavorId: string
  quantity?: number
  cost?: number
  comment?: string
}

export interface SurchargeFlavorUpsertResult {
  existingId?: string
  newId?: string
  conflict?: SurchargeFlavorStub
}

export interface SurchargePatch {
  flavorId?: string
  quantity?: number
  cost?: number
  comment?: string
}

export interface TruckOrVenueStub {
  id: string
  truck?: TruckStub
  venue?: VenueStub
}

export interface BundleExtras {
  fieldCancel?: boolean
  carrierBringCount?: number
  carrierTakeCount?: number
  bagBringCount?: number
  bagTakeCount?: number
  emptyBagTakeCount?: number
  assistBringCount?: number
  assistTakeCount?: number
  packingTime?: string
  containerBringCount?: number
  containerTakeCount?: number
  distanceFee?: boolean
  dollyFee?: boolean
  dockingFee?: boolean
  signageFee?: boolean
  halfDayFee?: boolean
  fullDayFee?: boolean
  eveningFee?: boolean
  lateNightFee?: boolean
  earlyMorningFee?: boolean
  manifestLegNumber?: number
}

export interface Bundle {
  id: string
  created: string
  asof?: string
  code: string
  displayName: string
  sortName?: string
  job: JobStub
  rankWithinJob: number
  origin: TruckOrVenueStub
  destination?: VenueStub
  extras?: BundleExtras
  author: AgentStub
  validSpan: string
}

export interface CompleteBundleHistory {
  bundle: Bundle
  job: Job
  revisions: Array<Bundle>
  stamps: Array<BundleStamp>
  transfers: Array<Transfer>
  surcharges: Array<Surcharge>
  wastes: Array<CompleteWasteHistory>
}

export interface NewGroundedBundleFood {
  jobId: string
  originVenueId: string
  destinationId?: string
  wastes: Array<NewWasteFood>
}

export interface NewLoadedBundleFood {
  jobId: string
  originTruckId: string
  destinationId?: string
  wastes: Array<NewWasteFood>
}

export interface BundlePatch {
  destinationId?: string
  extras?: BundleExtras
}

export interface BundleStub {
  id: string
  displayName: string
  code: string
}

export interface BundleStamp {
  id: string
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: BundleStampFlavor
  photo?: Photo
  caption?: string
}

export interface NewBundleStampFood {
  bundleId: string
  flavor?: BundleStampFlavor
  photoId?: string
  caption?: string
}

export interface Unit {
  id: string
  code: string
  displayName: string
  suffix?: string
  qx: number
  vx: number
  wx: number
}

export interface NewUnitFood {
  code: string
  displayName: string
  qx: number
  vx: number
  wx: number
}

export interface UnitUpsertResult {
  existingId?: string
  newId?: string
  conflict?: Unit
}

export interface WasteFlavorStub {
  id: string
  displayName: string
  code: string
  invoiceUnitId?: string
  manifestUnitId?: string
  stdPackingModeId?: string
}

export interface SanyuWasteFlavorExtra {
  sanyuCode?: string
  sanyuCodeUnreliable?: boolean
  recycleCategory?: string
}

export interface WasteFlavorExtra {
  sanyu?: SanyuWasteFlavorExtra
}

export interface WasteFlavor {
  id: string
  created: string
  asof?: string
  code: string
  displayName: string
  sortName?: string
  abbrev?: string
  invoiceUnitId?: string
  manifestName?: string
  manifestAbbrev?: string
  manifestCode?: string
  manifestUnitId?: string
  invoiceManiSlope: number
  invoiceManiIntercept: number
  stdPackingModeId?: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  includeInShortform?: boolean
  birthable?: boolean
  divisible?: boolean
  venueId?: string
  extra?: WasteFlavorExtra
  author: AgentStub
  validSpan: string
}

export interface NewWasteFlavorFood {
  code: string
  displayName: string
  sortName?: string
  abbrev?: string
  invoiceUnitId?: string
  manifestName?: string
  manifestAbbrev?: string
  manifestCode?: string
  manifestUnitId?: string
  invoiceManiSlope?: number
  invoiceManiIntercept?: number
  stdPackingModeId?: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  includeInShortform?: boolean
  birthable?: boolean
  divisible?: boolean
  extra?: WasteFlavorExtra
}

export interface WasteFlavorUpsertResult {
  existingId?: string
  newId?: string
  conflict?: WasteFlavorStub
}

export interface WasteFlavorPatch {
  code?: string
  displayName?: string
  sortName?: string
  abbrev?: string
  invoiceUnitId?: string
  manifestName?: string
  manifestAbbrev?: string
  manifestCode?: string
  manifestUnitId?: string
  invoiceManiSlope?: number
  invoiceManiIntercept?: number
  stdPackingModeId?: string
  showToDriver?: boolean
  showToIntaker?: boolean
  showToInspector?: boolean
  includeInShortform?: boolean
  venueId?: string
  birthable?: boolean
  divisible?: boolean
}

export interface UpsertablePackingMode {
  code: string
  displayName: string
  sortName?: string
  unitId: string
}

export interface PackingMode {
  id: string
  created: string
  code: string
  displayName: string
  sortName?: string
  unitId: string
}

export interface PackingModeUpsertResult {
  newId?: string
  existingId?: string
  conflict?: PackingMode
}

export interface UpsertableManifestType {
  code: string
  displayName: string
  sortName?: string
}

export interface ManifestType {
  id: string
  created: string
  code: string
  displayName: string
  sortName?: string
}

export interface ManifestTypeUpsertResult {
  existingId?: string
  newId?: string
  conflict?: ManifestType
}

export interface UpsertableTransformMode {
  code: string
  displayName: string
}

export interface TransformModeConflict {
  requested: UpsertableTransformMode
  existing: EntityStub
}

export interface TransformModeUpsertResult {
  existingId?: string
  newId?: string
  conflict?: TransformModeConflict
}

export interface WasteAtRestStatus {
  statusCode: WasteStatusCode
  venueId: string
}

export interface WasteInMotionStatus {
  statusCode: WasteStatusCode
  truckId: string
}

export interface WasteSplitStatus {
  children: Array<Waste>
}

export interface WasteMergeStatus {
  mergedInto: Waste
}

export interface WasteStatus {
  atRest?: WasteAtRestStatus
  inMotion?: WasteInMotionStatus
  split?: WasteSplitStatus
  merged?: WasteMergeStatus
}

export interface WasteExtras {
  label?: string
  notes?: string
  isShelf?: boolean
}

export interface Waste {
  id: string
  created: string
  asof?: string
  flavor: WasteFlavorStub
  isInvManiLinked: boolean
  invQ?: number
  maniQ?: number
  invW?: number
  maniW?: number
  invV?: number
  maniV?: number
  packingModeId?: string
  packQ?: number
  bara0?: number
  bags?: number
  manifestTypeId?: string
  manifestNumber?: string
  origin?: VenueStub
  destination?: VenueStub
  notational?: boolean
  transformMode?: EntityStub
  extras?: WasteExtras
  author: AgentStub
  validSpan: string
}

export interface NewWasteFood {
  flavorId: string
  isInvManiLinked?: boolean
  invQ?: number
  maniQ?: number
  invW?: number
  maniW?: number
  invV?: number
  maniV?: number
  packingModeId?: string
  packQ?: number
  bara0?: number
  bags?: number
  manifestTypeId?: string
  manifestNumber?: string
  originId?: string
  destinationId?: string
  notational?: boolean
  transformModeId?: string
  extras?: WasteExtras
}

export interface WastePatch {
  flavorId?: string
  isInvManiLinked?: boolean
  invQ?: number
  maniQ?: number
  invW?: number
  maniW?: number
  invV?: number
  maniV?: number
  packingModeId?: string
  packQ?: number
  bara0?: number
  bags?: number
  manifestTypeId?: string
  manifestNumber?: string
  originId?: string
  destinationId?: string
  notational?: boolean
  extras?: WasteExtras
  transformModeId?: string
}

export interface WasteStub {
  id: string
}

export interface WasteRevisionStub {
  author: AgentStub
  validSpan: string
}

export interface WasteStamp {
  id: string
  subjectId: string
  posted: string
  cancelled?: string
  author: AgentStub
  flavor?: WasteStampFlavor
  photo?: Photo
  caption?: string
}

export interface NewWasteStampFood {
  wasteId: string
  flavor?: WasteStampFlavor
  photoId?: string
  caption?: string
}

export interface WasteBundleAssociation {
  beginning: string
  bundleId: string
}

export interface WasteJobAssociation {
  jobId: string
  venueId: string
}

export interface WasteAssociation {
  id: string
  bundle?: WasteBundleAssociation
  job?: WasteJobAssociation
}

export interface CompleteWasteHistory {
  revisions: Array<Waste>
  stamps: Array<WasteStamp>
  surcharges: Array<Surcharge>
}

export interface WasteLineageRecord {
  before: string
  after: string
  posted: string
  author: AgentStub
}

export interface Transfer {
  id: string
  created: string
  bundle: BundleStub
  onloadVenue?: VenueStub
  onloadStarted?: string
  onloadEnded?: string
  truck: TruckStub
  offloadVenue?: VenueStub
  offloadStarted?: string
  offloadEnded?: string
  lastModifier: AgentStub
  lastModified: string
}

export interface TransferStub {
  id: string
}

export interface ScheduledTransfer {
  id: string
  bundle: BundleStub
  job: JobStub
  direction: PickupOrDropoff
  truck?: TruckStub
  truckModel?: TruckModelStub
  driver?: AgentStub
  venue: VenueStub
  arrivalWindow?: string
  posted: string
  lastModifier: AgentStub
  lastModified: string
}

export interface NewScheduledPickupFood {
  bundleId: string
  truckId?: string
  truckModelId?: string
  driverId?: string
  arrivalWindow?: string
}

export interface NewScheduledDropoffFood {
  bundleId: string
  truckId?: string
  truckModelId?: string
  driverId?: string
  arrivalWindow?: string
}

export interface ScheduledTransferPatch {
  truckId?: string
  truckModelId?: string
  driverId?: string
  arrivalWindow?: string
}

export interface ScheduledTransferStub {
  id: string
}

export interface Tripleg {
  id: string
  truck: TruckStub
  origin?: VenueStub
  departed: string
  destination: VenueStub
  estimatedArrival?: string
  arrived?: string
  admitted?: string
  lastModified: string
  lastModifier: AgentStub
}

export interface NewTriplegFood {
  destinationId: string
  estimatedArrival?: string
}

export interface TriplegPatch {
  destinationId?: string
  estimatedArrival?: string
}

export interface TriplegStub {
  id: string
}

export interface SelfResult {
  self: Agent
  lastShift?: string
  lastBreak?: string
  prefs?: any
}

export interface SetlistPacketResult {
  packet: WiredSetlistPacket
}

export interface SetlistSubscription {
  subscriber: string
  exchange: string
}

export interface VersionInfo {
  branch: string
  commitSlug: string
  isSnapshot: boolean
  webrpcHeader: string
}

export interface StandardUnitCodes {
  q: string
  v: string
  w: string
}

export interface SystemConfig {
  vendor: VendorName
  dratBanner: string
  standardUnitCodes: StandardUnitCodes
  driversCanAddWastes?: boolean
  fieldConfirmSurcharges?: boolean
  autoExportIntervalMinutes?: number
  elideManifest?: boolean
  inputWasteFlavorCodes?: boolean
  showInspectorFacets?: boolean
  quickInspectorActions?: boolean
  quickSupervisorActions?: boolean
  quickManifestNumber?: boolean
  quickPackQ?: boolean
}


export interface PingRequest {
}

export interface PingResponse {
}

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  jwt: string
}

export interface RefreshAuthTokenRequest {
}

export interface RefreshAuthTokenResponse {
  jwt: string
}

export interface SelfRequest {
}

export interface SelfResponse {
  srv: SelfResult
}

export interface LogoutRequest {
}

export interface LogoutResponse {
}

export interface GetSystemConfigRequest {
}

export interface GetSystemConfigResponse {
  config: SystemConfig
}

export interface GetVersionInfoRequest {
}

export interface GetVersionInfoResponse {
  vinfo: VersionInfo
}

export interface WatchCompanyByIdRequest {
  companyId: string
}

export interface WatchCompanyByIdResponse {
  company?: Company
}

export interface LastValidCompanyByIdRequest {
  companyId: string
}

export interface LastValidCompanyByIdResponse {
  company: Company
}

export interface CompanyByIdAsofRequest {
  companyId: string
  asof: string
}

export interface CompanyByIdAsofResponse {
  company?: Company
}

export interface CompanyRevisionCountRequest {
  companyId: string
}

export interface CompanyRevisionCountResponse {
  revisionCount: number
}

export interface AllCompanyRevisionsRequest {
  companyId: string
}

export interface AllCompanyRevisionsResponse {
  revisions: Array<Company>
}

export interface WatchCompanyByCodeRequest {
  companyCode: string
}

export interface WatchCompanyByCodeResponse {
  company?: Company
}

export interface LastValidCompanyByCodeRequest {
  companyCode: string
}

export interface LastValidCompanyByCodeResponse {
  company?: Company
}

export interface CompanyByCodeAsofRequest {
  companyCode: string
  asof: string
}

export interface CompanyByCodeAsofResponse {
  company?: Company
}

export interface WatchCompaniesByNameFragmentRequest {
  companyNameFrag: string
  startOffset?: number
}

export interface WatchCompaniesByNameFragmentResponse {
  companies: Array<CompanyStub>
}

export interface WatchVenueByIdRequest {
  venueId: string
}

export interface WatchVenueByIdResponse {
  venue?: Venue
}

export interface LastValidVenueByIdRequest {
  venueId: string
}

export interface LastValidVenueByIdResponse {
  venue: Venue
}

export interface VenueByIdAsofRequest {
  venueId: string
  asof: string
}

export interface VenueByIdAsofResponse {
  venue?: Venue
}

export interface VenueRevisionCountRequest {
  venueId: string
}

export interface VenueRevisionCountResponse {
  revisionCount: number
}

export interface AllVenueRevisionsRequest {
  venueId: string
}

export interface AllVenueRevisionsResponse {
  revisions: Array<Venue>
}

export interface WatchAdmittersOnDutyForVenueRequest {
  venueId: string
}

export interface WatchAdmittersOnDutyForVenueResponse {
  admitters: Array<AgentStub>
}

export interface WatchVenueByCodeRequest {
  companyId: string
  venueCode: string
}

export interface WatchVenueByCodeResponse {
  venue?: Venue
}

export interface LastValidVenueByCodeRequest {
  companyId: string
  venueCode: string
}

export interface LastValidVenueByCodeResponse {
  venue?: Venue
}

export interface VenueByCodeAsofRequest {
  companyId: string
  venueCode: string
  asof: string
}

export interface VenueByCodeAsofResponse {
  venue?: Venue
}

export interface WatchVenueByNameRequest {
  companyId: string
  venueName: string
}

export interface WatchVenueByNameResponse {
  venue?: Venue
}

export interface LastValidVenueByNameRequest {
  companyId: string
  venueName: string
}

export interface LastValidVenueByNameResponse {
  venue?: Venue
}

export interface VenueByNameAsofRequest {
  companyId: string
  venueName: string
  asof: string
}

export interface VenueByNameAsofResponse {
  venue?: Venue
}

export interface DownstreamVenuesRequest {
}

export interface DownstreamVenuesResponse {
  venues: Array<VenueStub>
}

export interface WatchTrucksDockedAtRequest {
  venueId: string
}

export interface WatchTrucksDockedAtResponse {
  trucks: Array<TruckStub>
}

export interface WatchAgentByIdRequest {
  agentId: string
}

export interface WatchAgentByIdResponse {
  agent?: Agent
}

export interface LastValidAgentByIdRequest {
  agentId: string
}

export interface LastValidAgentByIdResponse {
  agent: Agent
}

export interface AgentByIdAsofRequest {
  agentId: string
  asof: string
}

export interface AgentByIdAsofResponse {
  agent?: Agent
}

export interface AgentRevisionCountRequest {
  agentId: string
}

export interface AgentRevisionCountResponse {
  revisionCount: number
}

export interface AllAgentRevisionsRequest {
  agentId: string
}

export interface AllAgentRevisionsResponse {
  revisions: Array<Agent>
}

export interface WatchAgentByCodeRequest {
  companyId: string
  agentCode: string
}

export interface WatchAgentByCodeResponse {
  agent?: Agent
}

export interface LastValidAgentByCodeRequest {
  companyId: string
  agentCode: string
}

export interface LastValidAgentByCodeResponse {
  agent?: Agent
}

export interface AgentByCodeAsofRequest {
  companyId: string
  agentCode: string
  asof: string
}

export interface AgentByCodeAsofResponse {
  agent?: Agent
}

export interface WatchAgentByNameRequest {
  companyId: string
  agentName: string
}

export interface WatchAgentByNameResponse {
  agent?: Agent
}

export interface LastValidAgentByNameRequest {
  companyId: string
  agentName: string
}

export interface LastValidAgentByNameResponse {
  agent?: Agent
}

export interface AgentByNameAsofRequest {
  companyId: string
  agentName: string
  asof: string
}

export interface AgentByNameAsofResponse {
  agent?: Agent
}

export interface WatchAgentByLoginRequest {
  login: string
}

export interface WatchAgentByLoginResponse {
  agent?: Agent
}

export interface LastValidAgentByLoginRequest {
  login: string
}

export interface LastValidAgentByLoginResponse {
  agent: Agent
}

export interface AgentByLoginAsofRequest {
  login: string
  asof: string
}

export interface AgentByLoginAsofResponse {
  agent?: Agent
}

export interface AgentStampByIdRequest {
  stampId: string
}

export interface AgentStampByIdResponse {
  stamp: AgentStamp
}

export interface LastFlavoredStampForAgentRequest {
  agentId: string
}

export interface LastFlavoredStampForAgentResponse {
  stamp?: AgentStamp
}

export interface WatchStampsForAgentRequest {
  agentId: string
}

export interface WatchStampsForAgentResponse {
  stamps: Array<AgentStamp>
}

export interface StampsForAgentDuringRequest {
  agentId: string
  during: string
}

export interface StampsForAgentDuringResponse {
  stamps: Array<AgentStamp>
}

export interface AgentAvatarRequest {
  agentId: string
}

export interface AgentAvatarResponse {
  photoSlug?: string
}

export interface WatchAgentPresenceByIdRequest {
  agentId: string
}

export interface WatchAgentPresenceByIdResponse {
  presence: AgentPresence
}

export interface WatchAllPresentAgentsRequest {
}

export interface WatchAllPresentAgentsResponse {
  agents: Array<AgentStub>
}

export interface WatchTruckModelsRequest {
}

export interface WatchTruckModelsResponse {
  models: Array<TruckModel>
}

export interface WatchTruckModelByIdRequest {
  modelId: string
}

export interface WatchTruckModelByIdResponse {
  model?: TruckModel
}

export interface WatchTruckByIdRequest {
  truckId: string
}

export interface WatchTruckByIdResponse {
  truck?: Truck
}

export interface LastValidTruckByIdRequest {
  truckId: string
}

export interface LastValidTruckByIdResponse {
  truck: Truck
}

export interface TruckByIdAsofRequest {
  truckId: string
  asof: string
}

export interface TruckByIdAsofResponse {
  truck?: Truck
}

export interface TruckRevisionCountRequest {
  truckId: string
}

export interface TruckRevisionCountResponse {
  revisionCount: number
}

export interface AllTruckRevisionsRequest {
  truckId: string
}

export interface AllTruckRevisionsResponse {
  revisions: Array<Truck>
}

export interface WatchTruckByPlateRequest {
  plate: string
}

export interface WatchTruckByPlateResponse {
  truck?: Truck
}

export interface LastValidTruckByPlateRequest {
  plate: string
}

export interface LastValidTruckByPlateResponse {
  truck: Truck
}

export interface TruckByPlateAsofRequest {
  plate: string
  asof: string
}

export interface TruckByPlateAsofResponse {
  truck?: Truck
}

export interface WatchTruckByCrewRequest {
  crewId: string
}

export interface WatchTruckByCrewResponse {
  truck?: TruckStub
}

export interface TruckTenuresByCrewDuringRequest {
  crewId: string
  during: string
}

export interface TruckTenuresByCrewDuringResponse {
  tenures: Array<TruckTenure>
}

export interface WatchCrewByTruckRequest {
  truckId: string
}

export interface WatchCrewByTruckResponse {
  tenures: Array<CrewTenure>
}

export interface CrewTenuresByTruckDuringRequest {
  truckId: string
  during: string
}

export interface CrewTenuresByTruckDuringResponse {
  tenures: Array<CrewTenure>
}

export interface TruckStampByIdRequest {
  stampId: string
}

export interface TruckStampByIdResponse {
  stamp: TruckStamp
}

export interface LastFlavoredStampForTruckRequest {
  truckId: string
}

export interface LastFlavoredStampForTruckResponse {
  stamp?: TruckStamp
}

export interface WatchStampsForTruckRequest {
  truckId: string
}

export interface WatchStampsForTruckResponse {
  stamps: Array<TruckStamp>
}

export interface StampsForTruckDuringRequest {
  truckId: string
  during: string
}

export interface StampsForTruckDuringResponse {
  stamps: Array<TruckStamp>
}

export interface TruckAvatarRequest {
  truckId: string
}

export interface TruckAvatarResponse {
  photoSlug?: string
}

export interface WatchJobByIdRequest {
  jobId: string
}

export interface WatchJobByIdResponse {
  job?: Job
}

export interface LastValidJobByIdRequest {
  jobId: string
}

export interface LastValidJobByIdResponse {
  job: Job
}

export interface JobByIdAsofRequest {
  jobId: string
  asof: string
}

export interface JobByIdAsofResponse {
  job: Job
}

export interface JobRevisionCountRequest {
  jobId: string
}

export interface JobRevisionCountResponse {
  revisionCount: number
}

export interface AllJobRevisionsRequest {
  jobId: string
}

export interface AllJobRevisionsResponse {
  revisions: Array<Job>
}

export interface WatchExportableJobsRequest {
}

export interface WatchExportableJobsResponse {
  jobs: Array<JobStub>
}

export interface WatchExportedJobsRequest {
}

export interface WatchExportedJobsResponse {
  jobs: Array<JobStub>
}

export interface ShowExportedJobRequest {
  jobId: string
}

export interface ShowExportedJobResponse {
  exported: string
}

export interface ExportJobRequest {
  jobId: string
}

export interface ExportJobResponse {
}

export interface WatchJobByJobCodeRequest {
  jobCode: string
}

export interface WatchJobByJobCodeResponse {
  job?: Job
}

export interface LastValidJobByJobCodeRequest {
  jobCode: string
}

export interface LastValidJobByJobCodeResponse {
  job: Job
}

export interface JobByJobCodeAsofRequest {
  jobCode: string
  asof: string
}

export interface JobByJobCodeAsofResponse {
  job?: Job
}

export interface WatchJobByIntakeCodeRequest {
  intakeCode: string
}

export interface WatchJobByIntakeCodeResponse {
  job?: Job
}

export interface LastValidJobByIntakeCodeRequest {
  intakeCode: string
}

export interface LastValidJobByIntakeCodeResponse {
  job: Job
}

export interface JobByIntakeCodeAsofRequest {
  intakeCode: string
  asof: string
}

export interface JobByIntakeCodeAsofResponse {
  job?: Job
}

export interface JobStampByIdRequest {
  stampId: string
}

export interface JobStampByIdResponse {
  stamp: JobStamp
}

export interface LastFlavoredStampForJobRequest {
  jobId: string
}

export interface LastFlavoredStampForJobResponse {
  stamp?: JobStamp
}

export interface WatchStampsForJobRequest {
  jobId: string
}

export interface WatchStampsForJobResponse {
  stamps: Array<JobStamp>
}

export interface WatchUnbundledWastesForJobAtVenueRequest {
  jobId: string
  venueId: string
}

export interface WatchUnbundledWastesForJobAtVenueResponse {
  wastes: Array<WasteStub>
}

export interface SurchargeFlavorByIdRequest {
  surchargeFlavorId: string
}

export interface SurchargeFlavorByIdResponse {
  flavor: SurchargeFlavor
}

export interface SurchargeFlavorByCodeRequest {
  code: string
}

export interface SurchargeFlavorByCodeResponse {
  flavor?: SurchargeFlavor
}

export interface WatchSurchargesForSubjectRequest {
  subjectClass: SurchargeableClassname
  subjectId: string
}

export interface WatchSurchargesForSubjectResponse {
  surcharges: Array<Surcharge>
}

export interface WatchSurchargeByIdRequest {
  subjectClass: SurchargeableClassname
  surchargeId: string
}

export interface WatchSurchargeByIdResponse {
  surcharge?: Surcharge
}

export interface LastValidSurchargeByIdRequest {
  subjectClass: SurchargeableClassname
  surchargeId: string
}

export interface LastValidSurchargeByIdResponse {
  surcharge: Surcharge
}

export interface SurchargeByIdAsofRequest {
  subjectClass: SurchargeableClassname
  surchargeId: string
  asof: string
}

export interface SurchargeByIdAsofResponse {
  surcharge?: Surcharge
}

export interface AllSurchargeRevisionsRequest {
  subjectClass: SurchargeableClassname
  surchargeId: string
}

export interface AllSurchargeRevisionsResponse {
  revisions: Array<Surcharge>
}

export interface WatchBundleByIdRequest {
  bundleId: string
}

export interface WatchBundleByIdResponse {
  bundle?: Bundle
}

export interface LastValidBundleByIdRequest {
  bundleId: string
}

export interface LastValidBundleByIdResponse {
  bundle: Bundle
}

export interface BundleByIdAsofRequest {
  bundleId: string
  asof: string
}

export interface BundleByIdAsofResponse {
  bundle?: Bundle
}

export interface BundleRevisionCountRequest {
  bundleId: string
}

export interface BundleRevisionCountResponse {
  revisionCount: number
}

export interface AllBundleRevisionsRequest {
  bundleId: string
}

export interface AllBundleRevisionsResponse {
  revisions: Array<Bundle>
}

export interface WatchBundleLocationRequest {
  bundleId: string
}

export interface WatchBundleLocationResponse {
  curloc: TruckOrVenueStub
}

export interface WatchOrphanedBundlesRequest {
}

export interface WatchOrphanedBundlesResponse {
  orphans: Array<BundleStub>
}

export interface ActiveBundleCountRequest {
}

export interface ActiveBundleCountResponse {
  bundleCount: number
}

export interface WatchActiveBundlesRequest {
}

export interface WatchActiveBundlesResponse {
  bundles: Array<BundleStub>
}

export interface ActiveBundlePageRequest {
  offset: number
}

export interface ActiveBundlePageResponse {
  bundles: Array<BundleStub>
}

export interface WatchActiveBundlesDestinedForRequest {
  venueId: string
}

export interface WatchActiveBundlesDestinedForResponse {
  bundles: Array<BundleStub>
}

export interface WatchActiveBundlesOriginatingAtRequest {
  venueId: string
}

export interface WatchActiveBundlesOriginatingAtResponse {
  bundles: Array<BundleStub>
}

export interface WatchExportableBundlesRequest {
}

export interface WatchExportableBundlesResponse {
  bundles: Array<BundleStub>
}

export interface WatchInspectableBundlesRequest {
  venueId: string
}

export interface WatchInspectableBundlesResponse {
  bundles: Array<BundleStub>
}

export interface WatchBundlesNeedingSupervisorRequest {
  venueId: string
}

export interface WatchBundlesNeedingSupervisorResponse {
  bundles: Array<BundleStub>
}

export interface ShowExportedBundleRequest {
  bundleId: string
}

export interface ShowExportedBundleResponse {
  exported: string
}

export interface CompleteBundleHistoryByIdRequest {
  bundleId: string
}

export interface CompleteBundleHistoryByIdResponse {
  history: CompleteBundleHistory
}

export interface BundleStampByIdRequest {
  stampId: string
}

export interface BundleStampByIdResponse {
  stamp?: BundleStamp
}

export interface LastFlavoredStampForBundleRequest {
  bundleId: string
}

export interface LastFlavoredStampForBundleResponse {
  stamp?: BundleStamp
}

export interface WatchStampsForBundleRequest {
  bundleId: string
}

export interface WatchStampsForBundleResponse {
  stamps: Array<BundleStamp>
}

export interface WatchFlavoredStampsForBundleRequest {
  bundleId: string
}

export interface WatchFlavoredStampsForBundleResponse {
  stamps: Array<BundleStamp>
}

export interface WatchTransferByIdRequest {
  transferId: string
}

export interface WatchTransferByIdResponse {
  transfer: Transfer
}

export interface WatchAllTransfersRequest {
}

export interface WatchAllTransfersResponse {
  transfers: Array<TransferStub>
}

export interface WatchOpenTransfersForTruckRequest {
  truckId: string
}

export interface WatchOpenTransfersForTruckResponse {
  transfers: Array<TransferStub>
}

export interface WatchTransfersForTruckRequest {
  truckId: string
}

export interface WatchTransfersForTruckResponse {
  transfers: Array<TransferStub>
}

export interface WatchLastTransferForBundleRequest {
  bundleId: string
}

export interface WatchLastTransferForBundleResponse {
  transfer?: Transfer
}

export interface LastTransferForBundleBeforeRequest {
  bundleId: string
  before: string
}

export interface LastTransferForBundleBeforeResponse {
  transfer?: Transfer
}

export interface AllTransfersForBundleRequest {
  bundleId: string
}

export interface AllTransfersForBundleResponse {
  transfers: Array<TransferStub>
}

export interface TransfersForTruckDuringRequest {
  truckId: string
  during: string
}

export interface TransfersForTruckDuringResponse {
  transfers: Array<TransferStub>
}

export interface WatchTransfersAtVenueRequest {
  venueId: string
}

export interface WatchTransfersAtVenueResponse {
  transfers: Array<TransferStub>
}

export interface WatchTriplegByIdRequest {
  triplegId: string
}

export interface WatchTriplegByIdResponse {
  tripleg: Tripleg
}

export interface WatchAllTriplegsRequest {
}

export interface WatchAllTriplegsResponse {
  triplegs: Array<TriplegStub>
}

export interface WatchOpenTriplegForTruckRequest {
  truckId: string
}

export interface WatchOpenTriplegForTruckResponse {
  tripleg?: Tripleg
}

export interface WatchLastTriplegForTruckRequest {
  truckId: string
}

export interface WatchLastTriplegForTruckResponse {
  tripleg?: Tripleg
}

export interface WatchTriplegsForTruckRequest {
  truckId: string
}

export interface WatchTriplegsForTruckResponse {
  triplegs: Array<TriplegStub>
}

export interface TriplegsForTruckDuringRequest {
  truckId: string
  during: string
}

export interface TriplegsForTruckDuringResponse {
  triplegs: Array<TriplegStub>
}

export interface WatchUnadmittedTriplegsIntoRequest {
  venueId: string
}

export interface WatchUnadmittedTriplegsIntoResponse {
  triplegs: Array<TriplegStub>
}

export interface WatchTriplegsInboundToRequest {
  venueId: string
}

export interface WatchTriplegsInboundToResponse {
  triplegs: Array<TriplegStub>
}

export interface WatchScheduledTransferByIdRequest {
  scheduledTransferId: string
}

export interface WatchScheduledTransferByIdResponse {
  scheduledTransfer?: ScheduledTransfer
}

export interface WatchScheduledTransferForBundleRequest {
  bundleId: string
}

export interface WatchScheduledTransferForBundleResponse {
  scheduledTransfer?: ScheduledTransfer
}

export interface WatchScheduledTransfersForDriverRequest {
  driverId: string
}

export interface WatchScheduledTransfersForDriverResponse {
  scheduledTransfers: Array<ScheduledTransferStub>
}

export interface WatchScheduledTransfersAwaitingTruckRequest {
  truckId: string
  venueId: string
}

export interface WatchScheduledTransfersAwaitingTruckResponse {
  scheduledTransfers: Array<ScheduledTransferStub>
}

export interface ScheduledTransfersDuringRequest {
  during: string
}

export interface ScheduledTransfersDuringResponse {
  scheduledTransfers: Array<ScheduledTransferStub>
}

export interface WatchScheduledTransfersAtRequest {
  venueId: string
}

export interface WatchScheduledTransfersAtResponse {
  scheduledTransfers: Array<ScheduledTransferStub>
}

export interface WatchScheduledTransfersForDispatchRequest {
}

export interface WatchScheduledTransfersForDispatchResponse {
  scheduledTransfers: Array<ScheduledTransferStub>
}

export interface WasteFlavorByCodeRequest {
  code: string
}

export interface WasteFlavorByCodeResponse {
  flavor?: WasteFlavor
}

export interface WatchWasteFlavorByIdRequest {
  wasteFlavorId: string
}

export interface WatchWasteFlavorByIdResponse {
  flavor: WasteFlavor
}

export interface LastValidWasteFlavorByIdRequest {
  wasteFlavorId: string
}

export interface LastValidWasteFlavorByIdResponse {
  flavor: WasteFlavor
}

export interface WasteFlavorRevisionCountRequest {
  wasteFlavorId: string
}

export interface WasteFlavorRevisionCountResponse {
  revisionCount: number
}

export interface AllWasteFlavorRevisionsRequest {
  wasteFlavorId: string
}

export interface AllWasteFlavorRevisionsResponse {
  revisions: Array<WasteFlavor>
}

export interface ActiveWasteFlavorsRequest {
  purpose: WasteFlavorPurpose
  offset?: number
}

export interface ActiveWasteFlavorsResponse {
  flavorStubs: Array<WasteFlavorStub>
}

export interface GetCleavableFlavorsRequest {
  sourceFlavorId: string
}

export interface GetCleavableFlavorsResponse {
  flavors: Array<WasteFlavorStub>
}

export interface GetEmissibleFlavorsRequest {
  sinkFlavorId: string
}

export interface GetEmissibleFlavorsResponse {
  flavors: Array<WasteFlavorStub>
}

export interface WatchWasteByIdRequest {
  wasteId: string
}

export interface WatchWasteByIdResponse {
  waste?: Waste
}

export interface LastValidWasteByIdRequest {
  wasteId: string
}

export interface LastValidWasteByIdResponse {
  waste: Waste
}

export interface WasteByIdAsofRequest {
  wasteId: string
  asof: string
}

export interface WasteByIdAsofResponse {
  waste?: Waste
}

export interface WasteRevisionCountRequest {
  wasteId: string
}

export interface WasteRevisionCountResponse {
  revisionCount: number
}

export interface AllWasteRevisionStubsRequest {
  wasteId: string
}

export interface AllWasteRevisionStubsResponse {
  revisions: Array<WasteRevisionStub>
}

export interface AllWasteRevisionsRequest {
  wasteId: string
}

export interface AllWasteRevisionsResponse {
  revisions: Array<Waste>
}

export interface WatchWastesForBundleRequest {
  bundleId: string
}

export interface WatchWastesForBundleResponse {
  wastes: Array<WasteStub>
}

export interface AllWastesForBundleRequest {
  bundleId: string
}

export interface AllWastesForBundleResponse {
  wastes: Array<WasteStub>
}

export interface WastesForBundleAsofRequest {
  bundleId: string
  asof: string
}

export interface WastesForBundleAsofResponse {
  wastes: Array<WasteStub>
}

export interface AllDaughtersOfWasteRequest {
  wasteId: string
}

export interface AllDaughtersOfWasteResponse {
  daughters: Array<WasteStub>
}

export interface MothersOfWasteRequest {
  wasteId: string
}

export interface MothersOfWasteResponse {
  mothers: Array<Waste>
}

export interface DirectWasteLineageRecordsRequest {
  wasteId: string
}

export interface DirectWasteLineageRecordsResponse {
  lineageRecords: Array<WasteLineageRecord>
}

export interface WatchBundleForWasteRequest {
  wasteId: string
}

export interface WatchBundleForWasteResponse {
  bundle?: Bundle
}

export interface LastValidBundleForWasteRequest {
  wasteId: string
}

export interface LastValidBundleForWasteResponse {
  bundle?: Bundle
}

export interface BundleForWasteAsofRequest {
  wasteId: string
  asof: string
}

export interface BundleForWasteAsofResponse {
  bundle?: Bundle
}

export interface AllBundlesForWasteRequest {
  wasteId: string
}

export interface AllBundlesForWasteResponse {
  bundles: Array<BundleStub>
}

export interface WatchAssociationsForWasteRequest {
  wasteId: string
}

export interface WatchAssociationsForWasteResponse {
  assoc: WasteAssociation
}

export interface ShowExportedWasteRequest {
  wasteId: string
}

export interface ShowExportedWasteResponse {
  exported: string
}

export interface CompleteWasteHistoryByIdRequest {
  wasteId: string
}

export interface CompleteWasteHistoryByIdResponse {
  history: CompleteWasteHistory
}

export interface WatchWasteLocationRequest {
  wasteId: string
}

export interface WatchWasteLocationResponse {
  curloc: TruckOrVenueStub
}

export interface WatchWastesAtRequest {
  venueId: string
}

export interface WatchWastesAtResponse {
  stubs: Array<WasteStub>
}

export interface WasteStampByIdRequest {
  stampId: string
}

export interface WasteStampByIdResponse {
  stamp: WasteStamp
}

export interface LastFlavoredStampForWasteRequest {
  wasteId: string
}

export interface LastFlavoredStampForWasteResponse {
  stamp?: WasteStamp
}

export interface WatchStampsForWasteRequest {
  wasteId: string
}

export interface WatchStampsForWasteResponse {
  stamps: Array<WasteStamp>
}

export interface WatchFlavoredStampsForWasteRequest {
  wasteId: string
}

export interface WatchFlavoredStampsForWasteResponse {
  stamps: Array<WasteStamp>
}

export interface WatchPackingModesRequest {
}

export interface WatchPackingModesResponse {
  modes: Array<PackingMode>
}

export interface WatchPackingModeByIdRequest {
  packingModeId: string
}

export interface WatchPackingModeByIdResponse {
  mode: PackingMode
}

export interface WatchManifestTypesRequest {
}

export interface WatchManifestTypesResponse {
  maniTypes: Array<ManifestType>
}

export interface WatchManifestTypeByIdRequest {
  maniTypeId: string
}

export interface WatchManifestTypeByIdResponse {
  maniType?: ManifestType
}

export interface WatchUnitsRequest {
}

export interface WatchUnitsResponse {
  units: Array<Unit>
}

export interface WatchTransformModesRequest {
}

export interface WatchTransformModesResponse {
  modes: Array<EntityStub>
}

export interface WatchTransformModesForVenueRequest {
  venueId: string
}

export interface WatchTransformModesForVenueResponse {
  modes: Array<EntityStub>
}

export interface AllRewindCheckpointsRequest {
}

export interface AllRewindCheckpointsResponse {
  checkpoints: Array<RewindCheckpoint>
}


export interface SetlistSubscriptionsRequest {
}

export interface SetlistSubscriptionsResponse {
  subscriptions: Array<SetlistSubscription>
}

export interface SetSystemConfigRequest {
  sysconf: {[key: string]: any}
}

export interface SetSystemConfigResponse {
}

export interface UpsertCompanyRequest {
  food: NewCompanyFood
}

export interface UpsertCompanyResponse {
  result: CompanyUpsertResult
}

export interface PatchCompanyRequest {
  companyId: string
  patch: CompanyPatch
}

export interface PatchCompanyResponse {
  company: Company
}

export interface RetireCompanyRequest {
  companyId: string
}

export interface RetireCompanyResponse {
}

export interface UpsertVenueRequest {
  food: UpsertableVenue
}

export interface UpsertVenueResponse {
  result: VenueUpsertResult
}

export interface PatchVenueRequest {
  venueId: string
  patch: VenuePatch
}

export interface PatchVenueResponse {
  venue: Venue
}

export interface RetireVenueRequest {
  venueId: string
}

export interface RetireVenueResponse {
}

export interface UpsertDownstreamVenueRequest {
  food: UpsertableVenue
}

export interface UpsertDownstreamVenueResponse {
  result: VenueUpsertResult
}

export interface UpsertAgentRequest {
  food: UpsertableAgent
}

export interface UpsertAgentResponse {
  result: AgentUpsertResult
}

export interface PatchAgentRequest {
  agentId: string
  patch: AgentPatch
}

export interface PatchAgentResponse {
  agent: Agent
}

export interface PatchSelfRequest {
  patch: SelfPatch
}

export interface PatchSelfResponse {
  self: Agent
}

export interface ChangePasswordRequest {
  food: PasswordChange
}

export interface ChangePasswordResponse {
  authtoken: string
}

export interface RetireAgentRequest {
  agentId: string
}

export interface RetireAgentResponse {
}

export interface StampAgentRequest {
  food: NewAgentStampFood
}

export interface StampAgentResponse {
  stamp: AgentStamp
}

export interface UpsertTruckModelRequest {
  food: NewTruckModelFood
}

export interface UpsertTruckModelResponse {
  model: TruckModelUpsertResult
}

export interface PatchTruckModelRequest {
  modelId: string
  patch: TruckModelPatch
}

export interface PatchTruckModelResponse {
  model: TruckModel
}

export interface RetireTruckModelRequest {
  modelId: string
}

export interface RetireTruckModelResponse {
}

export interface UpsertTruckRequest {
  food: UpsertableTruck
}

export interface UpsertTruckResponse {
  result: TruckUpsertResult
}

export interface PatchTruckRequest {
  truckId: string
  patch: TruckPatch
}

export interface PatchTruckResponse {
  truck: Truck
}

export interface RetireTruckRequest {
  truckId: string
}

export interface RetireTruckResponse {
}

export interface MountTruckRequest {
  truckId: string
}

export interface MountTruckResponse {
}

export interface DismountTruckRequest {
}

export interface DismountTruckResponse {
  oldTruckId?: string
}

export interface StampTruckRequest {
  food: NewTruckStampFood
}

export interface StampTruckResponse {
  stamp: TruckStamp
}

export interface UpsertSurchargeFlavorRequest {
  food: NewSurchargeFlavorFood
}

export interface UpsertSurchargeFlavorResponse {
  result: SurchargeFlavorUpsertResult
}

export interface PatchSurchargeFlavorRequest {
  flavorId: string
  patch: SurchargeFlavorPatch
}

export interface PatchSurchargeFlavorResponse {
  flavor: SurchargeFlavor
}

export interface RetireSurchargeFlavorRequest {
  flavorId: string
}

export interface RetireSurchargeFlavorResponse {
}

export interface SpawnSurchargeRequest {
  food: NewSurchargeFood
}

export interface SpawnSurchargeResponse {
  surcharge: Surcharge
}

export interface PatchSurchargeRequest {
  subjectClassname: SurchargeableClassname
  surchargeId: string
  patch: SurchargePatch
}

export interface PatchSurchargeResponse {
  surcharge: Surcharge
}

export interface RetireSurchargeRequest {
  subjectClassname: SurchargeableClassname
  surchargeId: string
}

export interface RetireSurchargeResponse {
}

export interface UpsertShinwaJobRequest {
  food: UpsertableShinwaJob
}

export interface UpsertShinwaJobResponse {
  result: JobUpsertResult
}

export interface UpsertSanyuJobRequest {
  food: UpsertableSanyuJob
}

export interface UpsertSanyuJobResponse {
  result: JobUpsertResult
}

export interface PatchJobRequest {
  jobId: string
  patch: JobPatch
}

export interface PatchJobResponse {
  job: Job
}

export interface StampJobRequest {
  food: NewJobStampFood
}

export interface StampJobResponse {
  stamp: JobStamp
}

export interface CancelJobStampRequest {
  stampId: string
}

export interface CancelJobStampResponse {
}

export interface SpawnGroundedBundleRequest {
  food: NewGroundedBundleFood
}

export interface SpawnGroundedBundleResponse {
  bundle: Bundle
}

export interface SpawnLoadedBundleRequest {
  food: NewLoadedBundleFood
}

export interface SpawnLoadedBundleResponse {
  bundle: Bundle
}

export interface PatchBundleRequest {
  bundleId: string
  patch: BundlePatch
}

export interface PatchBundleResponse {
  bundle: Bundle
}

export interface StampBundleRequest {
  food: NewBundleStampFood
}

export interface StampBundleResponse {
  stamp: BundleStamp
}

export interface FieldCancelBundleRequest {
  bundleId: string
}

export interface FieldCancelBundleResponse {
}

export interface RetireBundleRequest {
  bundleId: string
  deep: boolean
}

export interface RetireBundleResponse {
}

export interface ScheduleBundlePickupRequest {
  food: NewScheduledPickupFood
}

export interface ScheduleBundlePickupResponse {
  scheduledTransfer: ScheduledTransfer
}

export interface ScheduleBundleDropoffRequest {
  food: NewScheduledDropoffFood
}

export interface ScheduleBundleDropoffResponse {
  scheduledTransfer: ScheduledTransfer
}

export interface PatchScheduledTransferRequest {
  transferId: string
  patch: ScheduledTransferPatch
}

export interface PatchScheduledTransferResponse {
  scheduledTransfer: ScheduledTransfer
}

export interface CancelScheduledTransferRequest {
  transferId: string
}

export interface CancelScheduledTransferResponse {
}

export interface DisclaimScheduledTransferRequest {
  transferId: string
  removeTruck?: boolean
}

export interface DisclaimScheduledTransferResponse {
}

export interface DisclaimAllMyScheduledTransfersRequest {
}

export interface DisclaimAllMyScheduledTransfersResponse {
}

export interface StartTriplegRequest {
  food: NewTriplegFood
}

export interface StartTriplegResponse {
  tripleg: Tripleg
}

export interface PatchTriplegRequest {
  triplegId: string
  patch: TriplegPatch
}

export interface PatchTriplegResponse {
  tripleg: Tripleg
}

export interface ArriveRequest {
  triplegId: string
}

export interface ArriveResponse {
}

export interface AdmitRequest {
  triplegId: string
}

export interface AdmitResponse {
}

export interface StartBundleOnloadingRequest {
  bundleId: string
  truckId: string
}

export interface StartBundleOnloadingResponse {
  transfer: Transfer
}

export interface CompleteBundleOnloadingRequest {
  bundleId: string
}

export interface CompleteBundleOnloadingResponse {
  transfer: Transfer
}

export interface StartBundleOffloadingRequest {
  bundleId: string
  venueId: string
}

export interface StartBundleOffloadingResponse {
  transfer: Transfer
}

export interface CompleteBundleOffloadingRequest {
  bundleId: string
}

export interface CompleteBundleOffloadingResponse {
  transfer: Transfer
}

export interface UpsertUnitRequest {
  food: NewUnitFood
}

export interface UpsertUnitResponse {
  result: UnitUpsertResult
}

export interface UpsertWasteFlavorRequest {
  food: NewWasteFlavorFood
}

export interface UpsertWasteFlavorResponse {
  result: WasteFlavorUpsertResult
}

export interface PatchWasteFlavorRequest {
  flavorId: string
  patch: WasteFlavorPatch
}

export interface PatchWasteFlavorResponse {
  flavor: WasteFlavor
}

export interface RetireWasteFlavorRequest {
  flavorId: string
}

export interface RetireWasteFlavorResponse {
}

export interface UpsertWasteFlavorRecipeRequest {
  sourceId: string
  sinkId: string
}

export interface UpsertWasteFlavorRecipeResponse {
}

export interface DeleteWasteFlavorRecipeRequest {
  sourceId: string
  sinkId: string
}

export interface DeleteWasteFlavorRecipeResponse {
}

export interface UpsertPackingModeRequest {
  food: UpsertablePackingMode
}

export interface UpsertPackingModeResponse {
  result: PackingModeUpsertResult
}

export interface UpsertManifestTypeRequest {
  food: UpsertableManifestType
}

export interface UpsertManifestTypeResponse {
  result: ManifestTypeUpsertResult
}

export interface SpawnWasteRequest {
  food: NewWasteFood
}

export interface SpawnWasteResponse {
  waste: Waste
}

export interface PatchWasteRequest {
  wasteId: string
  patch: WastePatch
}

export interface PatchWasteResponse {
  waste: Waste
}

export interface StampWasteRequest {
  food: NewWasteStampFood
}

export interface StampWasteResponse {
  stamp: WasteStamp
}

export interface AttachWasteToBundleRequest {
  bundleId: string
  wasteId: string
}

export interface AttachWasteToBundleResponse {
}

export interface AttachWasteToJobRequest {
  jobId: string
  originId: string
  wasteId: string
}

export interface AttachWasteToJobResponse {
}

export interface DetachWasteFromBundleRequest {
  wasteId: string
}

export interface DetachWasteFromBundleResponse {
}

export interface StoreWasteTemporaryRequest {
  wasteId: string
  venueId: string
}

export interface StoreWasteTemporaryResponse {
}

export interface StoreWastePermanentRequest {
  wasteId: string
  venueId: string
}

export interface StoreWastePermanentResponse {
}

export interface DivideFromWasteRequest {
  oyaId: string
  food: NewWasteFood
}

export interface DivideFromWasteResponse {
  daughter: Waste
}

export interface MergeIntoWasteRequest {
  dyingId: string
  receivingId: string
}

export interface MergeIntoWasteResponse {
}

export interface RetireWasteRequest {
  wasteId: string
}

export interface RetireWasteResponse {
}

export interface UpsertTransformModeRequest {
  food: UpsertableTransformMode
}

export interface UpsertTransformModeResponse {
  result: TransformModeUpsertResult
}

export interface AdoptTransformModeRequest {
  modeId: string
}

export interface AdoptTransformModeResponse {
}

export interface AbandonTransformModeRequest {
  modeId: string
}

export interface AbandonTransformModeResponse {
}

export interface AttachPhotoToStampRequest {
  subjectClass: StampableClassname
  stampId: string
  photoSlug: string
}

export interface AttachPhotoToStampResponse {
}

export interface RewindToCheckpointRequest {
  checkpointId: string
}

export interface RewindToCheckpointResponse {
}

export interface SpawnCheckpointRequest {
  name: string
}

export interface SpawnCheckpointResponse {
  checkpoint: RewindCheckpoint
}



//
// Client
//

export class KingBasura implements KingBasuraClient {
  protected hostname: string
  protected fetch: Fetch
  protected path = '/rpc/KingBasura/'

  constructor(hostname: string, fetch: Fetch) {
    this.hostname = hostname.replace(/\/*$/, '')
    this.fetch = (input: RequestInfo, init?: RequestInit) => fetch(input, init)
  }

  private url(name: string): string {
    return this.hostname + this.path + name
  }

  queryKey = {
    ping: () => ['KingBasura', 'ping'] as const,
    login: (req: LoginRequest) => ['KingBasura', 'login', req] as const,
    refreshAuthToken: () => ['KingBasura', 'refreshAuthToken'] as const,
    self: () => ['KingBasura', 'self'] as const,
    logout: () => ['KingBasura', 'logout'] as const,
    getSystemConfig: () => ['KingBasura', 'getSystemConfig'] as const,
    getVersionInfo: () => ['KingBasura', 'getVersionInfo'] as const,
    watchCompanyById: (req: WatchCompanyByIdRequest) => ['KingBasura', 'watchCompanyById', req] as const,
    lastValidCompanyById: (req: LastValidCompanyByIdRequest) => ['KingBasura', 'lastValidCompanyById', req] as const,
    companyByIdAsof: (req: CompanyByIdAsofRequest) => ['KingBasura', 'companyByIdAsof', req] as const,
    companyRevisionCount: (req: CompanyRevisionCountRequest) => ['KingBasura', 'companyRevisionCount', req] as const,
    allCompanyRevisions: (req: AllCompanyRevisionsRequest) => ['KingBasura', 'allCompanyRevisions', req] as const,
    watchCompanyByCode: (req: WatchCompanyByCodeRequest) => ['KingBasura', 'watchCompanyByCode', req] as const,
    lastValidCompanyByCode: (req: LastValidCompanyByCodeRequest) => ['KingBasura', 'lastValidCompanyByCode', req] as const,
    companyByCodeAsof: (req: CompanyByCodeAsofRequest) => ['KingBasura', 'companyByCodeAsof', req] as const,
    watchCompaniesByNameFragment: (req: WatchCompaniesByNameFragmentRequest) => ['KingBasura', 'watchCompaniesByNameFragment', req] as const,
    watchVenueById: (req: WatchVenueByIdRequest) => ['KingBasura', 'watchVenueById', req] as const,
    lastValidVenueById: (req: LastValidVenueByIdRequest) => ['KingBasura', 'lastValidVenueById', req] as const,
    venueByIdAsof: (req: VenueByIdAsofRequest) => ['KingBasura', 'venueByIdAsof', req] as const,
    venueRevisionCount: (req: VenueRevisionCountRequest) => ['KingBasura', 'venueRevisionCount', req] as const,
    allVenueRevisions: (req: AllVenueRevisionsRequest) => ['KingBasura', 'allVenueRevisions', req] as const,
    watchAdmittersOnDutyForVenue: (req: WatchAdmittersOnDutyForVenueRequest) => ['KingBasura', 'watchAdmittersOnDutyForVenue', req] as const,
    watchVenueByCode: (req: WatchVenueByCodeRequest) => ['KingBasura', 'watchVenueByCode', req] as const,
    lastValidVenueByCode: (req: LastValidVenueByCodeRequest) => ['KingBasura', 'lastValidVenueByCode', req] as const,
    venueByCodeAsof: (req: VenueByCodeAsofRequest) => ['KingBasura', 'venueByCodeAsof', req] as const,
    watchVenueByName: (req: WatchVenueByNameRequest) => ['KingBasura', 'watchVenueByName', req] as const,
    lastValidVenueByName: (req: LastValidVenueByNameRequest) => ['KingBasura', 'lastValidVenueByName', req] as const,
    venueByNameAsof: (req: VenueByNameAsofRequest) => ['KingBasura', 'venueByNameAsof', req] as const,
    downstreamVenues: () => ['KingBasura', 'downstreamVenues'] as const,
    watchTrucksDockedAt: (req: WatchTrucksDockedAtRequest) => ['KingBasura', 'watchTrucksDockedAt', req] as const,
    watchAgentById: (req: WatchAgentByIdRequest) => ['KingBasura', 'watchAgentById', req] as const,
    lastValidAgentById: (req: LastValidAgentByIdRequest) => ['KingBasura', 'lastValidAgentById', req] as const,
    agentByIdAsof: (req: AgentByIdAsofRequest) => ['KingBasura', 'agentByIdAsof', req] as const,
    agentRevisionCount: (req: AgentRevisionCountRequest) => ['KingBasura', 'agentRevisionCount', req] as const,
    allAgentRevisions: (req: AllAgentRevisionsRequest) => ['KingBasura', 'allAgentRevisions', req] as const,
    watchAgentByCode: (req: WatchAgentByCodeRequest) => ['KingBasura', 'watchAgentByCode', req] as const,
    lastValidAgentByCode: (req: LastValidAgentByCodeRequest) => ['KingBasura', 'lastValidAgentByCode', req] as const,
    agentByCodeAsof: (req: AgentByCodeAsofRequest) => ['KingBasura', 'agentByCodeAsof', req] as const,
    watchAgentByName: (req: WatchAgentByNameRequest) => ['KingBasura', 'watchAgentByName', req] as const,
    lastValidAgentByName: (req: LastValidAgentByNameRequest) => ['KingBasura', 'lastValidAgentByName', req] as const,
    agentByNameAsof: (req: AgentByNameAsofRequest) => ['KingBasura', 'agentByNameAsof', req] as const,
    watchAgentByLogin: (req: WatchAgentByLoginRequest) => ['KingBasura', 'watchAgentByLogin', req] as const,
    lastValidAgentByLogin: (req: LastValidAgentByLoginRequest) => ['KingBasura', 'lastValidAgentByLogin', req] as const,
    agentByLoginAsof: (req: AgentByLoginAsofRequest) => ['KingBasura', 'agentByLoginAsof', req] as const,
    agentStampById: (req: AgentStampByIdRequest) => ['KingBasura', 'agentStampById', req] as const,
    lastFlavoredStampForAgent: (req: LastFlavoredStampForAgentRequest) => ['KingBasura', 'lastFlavoredStampForAgent', req] as const,
    watchStampsForAgent: (req: WatchStampsForAgentRequest) => ['KingBasura', 'watchStampsForAgent', req] as const,
    stampsForAgentDuring: (req: StampsForAgentDuringRequest) => ['KingBasura', 'stampsForAgentDuring', req] as const,
    agentAvatar: (req: AgentAvatarRequest) => ['KingBasura', 'agentAvatar', req] as const,
    watchAgentPresenceById: (req: WatchAgentPresenceByIdRequest) => ['KingBasura', 'watchAgentPresenceById', req] as const,
    watchAllPresentAgents: () => ['KingBasura', 'watchAllPresentAgents'] as const,
    watchTruckModels: () => ['KingBasura', 'watchTruckModels'] as const,
    watchTruckModelById: (req: WatchTruckModelByIdRequest) => ['KingBasura', 'watchTruckModelById', req] as const,
    watchTruckById: (req: WatchTruckByIdRequest) => ['KingBasura', 'watchTruckById', req] as const,
    lastValidTruckById: (req: LastValidTruckByIdRequest) => ['KingBasura', 'lastValidTruckById', req] as const,
    truckByIdAsof: (req: TruckByIdAsofRequest) => ['KingBasura', 'truckByIdAsof', req] as const,
    truckRevisionCount: (req: TruckRevisionCountRequest) => ['KingBasura', 'truckRevisionCount', req] as const,
    allTruckRevisions: (req: AllTruckRevisionsRequest) => ['KingBasura', 'allTruckRevisions', req] as const,
    watchTruckByPlate: (req: WatchTruckByPlateRequest) => ['KingBasura', 'watchTruckByPlate', req] as const,
    lastValidTruckByPlate: (req: LastValidTruckByPlateRequest) => ['KingBasura', 'lastValidTruckByPlate', req] as const,
    truckByPlateAsof: (req: TruckByPlateAsofRequest) => ['KingBasura', 'truckByPlateAsof', req] as const,
    watchTruckByCrew: (req: WatchTruckByCrewRequest) => ['KingBasura', 'watchTruckByCrew', req] as const,
    truckTenuresByCrewDuring: (req: TruckTenuresByCrewDuringRequest) => ['KingBasura', 'truckTenuresByCrewDuring', req] as const,
    watchCrewByTruck: (req: WatchCrewByTruckRequest) => ['KingBasura', 'watchCrewByTruck', req] as const,
    crewTenuresByTruckDuring: (req: CrewTenuresByTruckDuringRequest) => ['KingBasura', 'crewTenuresByTruckDuring', req] as const,
    truckStampById: (req: TruckStampByIdRequest) => ['KingBasura', 'truckStampById', req] as const,
    lastFlavoredStampForTruck: (req: LastFlavoredStampForTruckRequest) => ['KingBasura', 'lastFlavoredStampForTruck', req] as const,
    watchStampsForTruck: (req: WatchStampsForTruckRequest) => ['KingBasura', 'watchStampsForTruck', req] as const,
    stampsForTruckDuring: (req: StampsForTruckDuringRequest) => ['KingBasura', 'stampsForTruckDuring', req] as const,
    truckAvatar: (req: TruckAvatarRequest) => ['KingBasura', 'truckAvatar', req] as const,
    watchJobById: (req: WatchJobByIdRequest) => ['KingBasura', 'watchJobById', req] as const,
    lastValidJobById: (req: LastValidJobByIdRequest) => ['KingBasura', 'lastValidJobById', req] as const,
    jobByIdAsof: (req: JobByIdAsofRequest) => ['KingBasura', 'jobByIdAsof', req] as const,
    jobRevisionCount: (req: JobRevisionCountRequest) => ['KingBasura', 'jobRevisionCount', req] as const,
    allJobRevisions: (req: AllJobRevisionsRequest) => ['KingBasura', 'allJobRevisions', req] as const,
    watchExportableJobs: () => ['KingBasura', 'watchExportableJobs'] as const,
    watchExportedJobs: () => ['KingBasura', 'watchExportedJobs'] as const,
    showExportedJob: (req: ShowExportedJobRequest) => ['KingBasura', 'showExportedJob', req] as const,
    exportJob: (req: ExportJobRequest) => ['KingBasura', 'exportJob', req] as const,
    watchJobByJobCode: (req: WatchJobByJobCodeRequest) => ['KingBasura', 'watchJobByJobCode', req] as const,
    lastValidJobByJobCode: (req: LastValidJobByJobCodeRequest) => ['KingBasura', 'lastValidJobByJobCode', req] as const,
    jobByJobCodeAsof: (req: JobByJobCodeAsofRequest) => ['KingBasura', 'jobByJobCodeAsof', req] as const,
    watchJobByIntakeCode: (req: WatchJobByIntakeCodeRequest) => ['KingBasura', 'watchJobByIntakeCode', req] as const,
    lastValidJobByIntakeCode: (req: LastValidJobByIntakeCodeRequest) => ['KingBasura', 'lastValidJobByIntakeCode', req] as const,
    jobByIntakeCodeAsof: (req: JobByIntakeCodeAsofRequest) => ['KingBasura', 'jobByIntakeCodeAsof', req] as const,
    jobStampById: (req: JobStampByIdRequest) => ['KingBasura', 'jobStampById', req] as const,
    lastFlavoredStampForJob: (req: LastFlavoredStampForJobRequest) => ['KingBasura', 'lastFlavoredStampForJob', req] as const,
    watchStampsForJob: (req: WatchStampsForJobRequest) => ['KingBasura', 'watchStampsForJob', req] as const,
    watchUnbundledWastesForJobAtVenue: (req: WatchUnbundledWastesForJobAtVenueRequest) => ['KingBasura', 'watchUnbundledWastesForJobAtVenue', req] as const,
    surchargeFlavorById: (req: SurchargeFlavorByIdRequest) => ['KingBasura', 'surchargeFlavorById', req] as const,
    surchargeFlavorByCode: (req: SurchargeFlavorByCodeRequest) => ['KingBasura', 'surchargeFlavorByCode', req] as const,
    watchSurchargesForSubject: (req: WatchSurchargesForSubjectRequest) => ['KingBasura', 'watchSurchargesForSubject', req] as const,
    watchSurchargeById: (req: WatchSurchargeByIdRequest) => ['KingBasura', 'watchSurchargeById', req] as const,
    lastValidSurchargeById: (req: LastValidSurchargeByIdRequest) => ['KingBasura', 'lastValidSurchargeById', req] as const,
    surchargeByIdAsof: (req: SurchargeByIdAsofRequest) => ['KingBasura', 'surchargeByIdAsof', req] as const,
    allSurchargeRevisions: (req: AllSurchargeRevisionsRequest) => ['KingBasura', 'allSurchargeRevisions', req] as const,
    watchBundleById: (req: WatchBundleByIdRequest) => ['KingBasura', 'watchBundleById', req] as const,
    lastValidBundleById: (req: LastValidBundleByIdRequest) => ['KingBasura', 'lastValidBundleById', req] as const,
    bundleByIdAsof: (req: BundleByIdAsofRequest) => ['KingBasura', 'bundleByIdAsof', req] as const,
    bundleRevisionCount: (req: BundleRevisionCountRequest) => ['KingBasura', 'bundleRevisionCount', req] as const,
    allBundleRevisions: (req: AllBundleRevisionsRequest) => ['KingBasura', 'allBundleRevisions', req] as const,
    watchBundleLocation: (req: WatchBundleLocationRequest) => ['KingBasura', 'watchBundleLocation', req] as const,
    watchOrphanedBundles: () => ['KingBasura', 'watchOrphanedBundles'] as const,
    activeBundleCount: () => ['KingBasura', 'activeBundleCount'] as const,
    watchActiveBundles: () => ['KingBasura', 'watchActiveBundles'] as const,
    activeBundlePage: (req: ActiveBundlePageRequest) => ['KingBasura', 'activeBundlePage', req] as const,
    watchActiveBundlesDestinedFor: (req: WatchActiveBundlesDestinedForRequest) => ['KingBasura', 'watchActiveBundlesDestinedFor', req] as const,
    watchActiveBundlesOriginatingAt: (req: WatchActiveBundlesOriginatingAtRequest) => ['KingBasura', 'watchActiveBundlesOriginatingAt', req] as const,
    watchExportableBundles: () => ['KingBasura', 'watchExportableBundles'] as const,
    watchInspectableBundles: (req: WatchInspectableBundlesRequest) => ['KingBasura', 'watchInspectableBundles', req] as const,
    watchBundlesNeedingSupervisor: (req: WatchBundlesNeedingSupervisorRequest) => ['KingBasura', 'watchBundlesNeedingSupervisor', req] as const,
    showExportedBundle: (req: ShowExportedBundleRequest) => ['KingBasura', 'showExportedBundle', req] as const,
    completeBundleHistoryById: (req: CompleteBundleHistoryByIdRequest) => ['KingBasura', 'completeBundleHistoryById', req] as const,
    bundleStampById: (req: BundleStampByIdRequest) => ['KingBasura', 'bundleStampById', req] as const,
    lastFlavoredStampForBundle: (req: LastFlavoredStampForBundleRequest) => ['KingBasura', 'lastFlavoredStampForBundle', req] as const,
    watchStampsForBundle: (req: WatchStampsForBundleRequest) => ['KingBasura', 'watchStampsForBundle', req] as const,
    watchFlavoredStampsForBundle: (req: WatchFlavoredStampsForBundleRequest) => ['KingBasura', 'watchFlavoredStampsForBundle', req] as const,
    watchTransferById: (req: WatchTransferByIdRequest) => ['KingBasura', 'watchTransferById', req] as const,
    watchAllTransfers: () => ['KingBasura', 'watchAllTransfers'] as const,
    watchOpenTransfersForTruck: (req: WatchOpenTransfersForTruckRequest) => ['KingBasura', 'watchOpenTransfersForTruck', req] as const,
    watchTransfersForTruck: (req: WatchTransfersForTruckRequest) => ['KingBasura', 'watchTransfersForTruck', req] as const,
    watchLastTransferForBundle: (req: WatchLastTransferForBundleRequest) => ['KingBasura', 'watchLastTransferForBundle', req] as const,
    lastTransferForBundleBefore: (req: LastTransferForBundleBeforeRequest) => ['KingBasura', 'lastTransferForBundleBefore', req] as const,
    allTransfersForBundle: (req: AllTransfersForBundleRequest) => ['KingBasura', 'allTransfersForBundle', req] as const,
    transfersForTruckDuring: (req: TransfersForTruckDuringRequest) => ['KingBasura', 'transfersForTruckDuring', req] as const,
    watchTransfersAtVenue: (req: WatchTransfersAtVenueRequest) => ['KingBasura', 'watchTransfersAtVenue', req] as const,
    watchTriplegById: (req: WatchTriplegByIdRequest) => ['KingBasura', 'watchTriplegById', req] as const,
    watchAllTriplegs: () => ['KingBasura', 'watchAllTriplegs'] as const,
    watchOpenTriplegForTruck: (req: WatchOpenTriplegForTruckRequest) => ['KingBasura', 'watchOpenTriplegForTruck', req] as const,
    watchLastTriplegForTruck: (req: WatchLastTriplegForTruckRequest) => ['KingBasura', 'watchLastTriplegForTruck', req] as const,
    watchTriplegsForTruck: (req: WatchTriplegsForTruckRequest) => ['KingBasura', 'watchTriplegsForTruck', req] as const,
    triplegsForTruckDuring: (req: TriplegsForTruckDuringRequest) => ['KingBasura', 'triplegsForTruckDuring', req] as const,
    watchUnadmittedTriplegsInto: (req: WatchUnadmittedTriplegsIntoRequest) => ['KingBasura', 'watchUnadmittedTriplegsInto', req] as const,
    watchTriplegsInboundTo: (req: WatchTriplegsInboundToRequest) => ['KingBasura', 'watchTriplegsInboundTo', req] as const,
    watchScheduledTransferById: (req: WatchScheduledTransferByIdRequest) => ['KingBasura', 'watchScheduledTransferById', req] as const,
    watchScheduledTransferForBundle: (req: WatchScheduledTransferForBundleRequest) => ['KingBasura', 'watchScheduledTransferForBundle', req] as const,
    watchScheduledTransfersForDriver: (req: WatchScheduledTransfersForDriverRequest) => ['KingBasura', 'watchScheduledTransfersForDriver', req] as const,
    watchScheduledTransfersAwaitingTruck: (req: WatchScheduledTransfersAwaitingTruckRequest) => ['KingBasura', 'watchScheduledTransfersAwaitingTruck', req] as const,
    scheduledTransfersDuring: (req: ScheduledTransfersDuringRequest) => ['KingBasura', 'scheduledTransfersDuring', req] as const,
    watchScheduledTransfersAt: (req: WatchScheduledTransfersAtRequest) => ['KingBasura', 'watchScheduledTransfersAt', req] as const,
    watchScheduledTransfersForDispatch: () => ['KingBasura', 'watchScheduledTransfersForDispatch'] as const,
    wasteFlavorByCode: (req: WasteFlavorByCodeRequest) => ['KingBasura', 'wasteFlavorByCode', req] as const,
    watchWasteFlavorById: (req: WatchWasteFlavorByIdRequest) => ['KingBasura', 'watchWasteFlavorById', req] as const,
    lastValidWasteFlavorById: (req: LastValidWasteFlavorByIdRequest) => ['KingBasura', 'lastValidWasteFlavorById', req] as const,
    wasteFlavorRevisionCount: (req: WasteFlavorRevisionCountRequest) => ['KingBasura', 'wasteFlavorRevisionCount', req] as const,
    allWasteFlavorRevisions: (req: AllWasteFlavorRevisionsRequest) => ['KingBasura', 'allWasteFlavorRevisions', req] as const,
    activeWasteFlavors: (req: ActiveWasteFlavorsRequest) => ['KingBasura', 'activeWasteFlavors', req] as const,
    getCleavableFlavors: (req: GetCleavableFlavorsRequest) => ['KingBasura', 'getCleavableFlavors', req] as const,
    getEmissibleFlavors: (req: GetEmissibleFlavorsRequest) => ['KingBasura', 'getEmissibleFlavors', req] as const,
    watchWasteById: (req: WatchWasteByIdRequest) => ['KingBasura', 'watchWasteById', req] as const,
    lastValidWasteById: (req: LastValidWasteByIdRequest) => ['KingBasura', 'lastValidWasteById', req] as const,
    wasteByIdAsof: (req: WasteByIdAsofRequest) => ['KingBasura', 'wasteByIdAsof', req] as const,
    wasteRevisionCount: (req: WasteRevisionCountRequest) => ['KingBasura', 'wasteRevisionCount', req] as const,
    allWasteRevisionStubs: (req: AllWasteRevisionStubsRequest) => ['KingBasura', 'allWasteRevisionStubs', req] as const,
    allWasteRevisions: (req: AllWasteRevisionsRequest) => ['KingBasura', 'allWasteRevisions', req] as const,
    watchWastesForBundle: (req: WatchWastesForBundleRequest) => ['KingBasura', 'watchWastesForBundle', req] as const,
    allWastesForBundle: (req: AllWastesForBundleRequest) => ['KingBasura', 'allWastesForBundle', req] as const,
    wastesForBundleAsof: (req: WastesForBundleAsofRequest) => ['KingBasura', 'wastesForBundleAsof', req] as const,
    allDaughtersOfWaste: (req: AllDaughtersOfWasteRequest) => ['KingBasura', 'allDaughtersOfWaste', req] as const,
    mothersOfWaste: (req: MothersOfWasteRequest) => ['KingBasura', 'mothersOfWaste', req] as const,
    directWasteLineageRecords: (req: DirectWasteLineageRecordsRequest) => ['KingBasura', 'directWasteLineageRecords', req] as const,
    watchBundleForWaste: (req: WatchBundleForWasteRequest) => ['KingBasura', 'watchBundleForWaste', req] as const,
    lastValidBundleForWaste: (req: LastValidBundleForWasteRequest) => ['KingBasura', 'lastValidBundleForWaste', req] as const,
    bundleForWasteAsof: (req: BundleForWasteAsofRequest) => ['KingBasura', 'bundleForWasteAsof', req] as const,
    allBundlesForWaste: (req: AllBundlesForWasteRequest) => ['KingBasura', 'allBundlesForWaste', req] as const,
    watchAssociationsForWaste: (req: WatchAssociationsForWasteRequest) => ['KingBasura', 'watchAssociationsForWaste', req] as const,
    showExportedWaste: (req: ShowExportedWasteRequest) => ['KingBasura', 'showExportedWaste', req] as const,
    completeWasteHistoryById: (req: CompleteWasteHistoryByIdRequest) => ['KingBasura', 'completeWasteHistoryById', req] as const,
    watchWasteLocation: (req: WatchWasteLocationRequest) => ['KingBasura', 'watchWasteLocation', req] as const,
    watchWastesAt: (req: WatchWastesAtRequest) => ['KingBasura', 'watchWastesAt', req] as const,
    wasteStampById: (req: WasteStampByIdRequest) => ['KingBasura', 'wasteStampById', req] as const,
    lastFlavoredStampForWaste: (req: LastFlavoredStampForWasteRequest) => ['KingBasura', 'lastFlavoredStampForWaste', req] as const,
    watchStampsForWaste: (req: WatchStampsForWasteRequest) => ['KingBasura', 'watchStampsForWaste', req] as const,
    watchFlavoredStampsForWaste: (req: WatchFlavoredStampsForWasteRequest) => ['KingBasura', 'watchFlavoredStampsForWaste', req] as const,
    watchPackingModes: () => ['KingBasura', 'watchPackingModes'] as const,
    watchPackingModeById: (req: WatchPackingModeByIdRequest) => ['KingBasura', 'watchPackingModeById', req] as const,
    watchManifestTypes: () => ['KingBasura', 'watchManifestTypes'] as const,
    watchManifestTypeById: (req: WatchManifestTypeByIdRequest) => ['KingBasura', 'watchManifestTypeById', req] as const,
    watchUnits: () => ['KingBasura', 'watchUnits'] as const,
    watchTransformModes: () => ['KingBasura', 'watchTransformModes'] as const,
    watchTransformModesForVenue: (req: WatchTransformModesForVenueRequest) => ['KingBasura', 'watchTransformModesForVenue', req] as const,
    allRewindCheckpoints: () => ['KingBasura', 'allRewindCheckpoints'] as const,
    setlists: () => ['KingBasura', 'setlists'] as const,
    setlistSubscriptions: () => ['KingBasura', 'setlistSubscriptions'] as const,
    setSystemConfig: (req: SetSystemConfigRequest) => ['KingBasura', 'setSystemConfig', req] as const,
    upsertCompany: (req: UpsertCompanyRequest) => ['KingBasura', 'upsertCompany', req] as const,
    patchCompany: (req: PatchCompanyRequest) => ['KingBasura', 'patchCompany', req] as const,
    retireCompany: (req: RetireCompanyRequest) => ['KingBasura', 'retireCompany', req] as const,
    upsertVenue: (req: UpsertVenueRequest) => ['KingBasura', 'upsertVenue', req] as const,
    patchVenue: (req: PatchVenueRequest) => ['KingBasura', 'patchVenue', req] as const,
    retireVenue: (req: RetireVenueRequest) => ['KingBasura', 'retireVenue', req] as const,
    upsertDownstreamVenue: (req: UpsertDownstreamVenueRequest) => ['KingBasura', 'upsertDownstreamVenue', req] as const,
    upsertAgent: (req: UpsertAgentRequest) => ['KingBasura', 'upsertAgent', req] as const,
    patchAgent: (req: PatchAgentRequest) => ['KingBasura', 'patchAgent', req] as const,
    patchSelf: (req: PatchSelfRequest) => ['KingBasura', 'patchSelf', req] as const,
    changePassword: (req: ChangePasswordRequest) => ['KingBasura', 'changePassword', req] as const,
    retireAgent: (req: RetireAgentRequest) => ['KingBasura', 'retireAgent', req] as const,
    stampAgent: (req: StampAgentRequest) => ['KingBasura', 'stampAgent', req] as const,
    upsertTruckModel: (req: UpsertTruckModelRequest) => ['KingBasura', 'upsertTruckModel', req] as const,
    patchTruckModel: (req: PatchTruckModelRequest) => ['KingBasura', 'patchTruckModel', req] as const,
    retireTruckModel: (req: RetireTruckModelRequest) => ['KingBasura', 'retireTruckModel', req] as const,
    upsertTruck: (req: UpsertTruckRequest) => ['KingBasura', 'upsertTruck', req] as const,
    patchTruck: (req: PatchTruckRequest) => ['KingBasura', 'patchTruck', req] as const,
    retireTruck: (req: RetireTruckRequest) => ['KingBasura', 'retireTruck', req] as const,
    mountTruck: (req: MountTruckRequest) => ['KingBasura', 'mountTruck', req] as const,
    dismountTruck: () => ['KingBasura', 'dismountTruck'] as const,
    stampTruck: (req: StampTruckRequest) => ['KingBasura', 'stampTruck', req] as const,
    upsertSurchargeFlavor: (req: UpsertSurchargeFlavorRequest) => ['KingBasura', 'upsertSurchargeFlavor', req] as const,
    patchSurchargeFlavor: (req: PatchSurchargeFlavorRequest) => ['KingBasura', 'patchSurchargeFlavor', req] as const,
    retireSurchargeFlavor: (req: RetireSurchargeFlavorRequest) => ['KingBasura', 'retireSurchargeFlavor', req] as const,
    spawnSurcharge: (req: SpawnSurchargeRequest) => ['KingBasura', 'spawnSurcharge', req] as const,
    patchSurcharge: (req: PatchSurchargeRequest) => ['KingBasura', 'patchSurcharge', req] as const,
    retireSurcharge: (req: RetireSurchargeRequest) => ['KingBasura', 'retireSurcharge', req] as const,
    upsertShinwaJob: (req: UpsertShinwaJobRequest) => ['KingBasura', 'upsertShinwaJob', req] as const,
    upsertSanyuJob: (req: UpsertSanyuJobRequest) => ['KingBasura', 'upsertSanyuJob', req] as const,
    patchJob: (req: PatchJobRequest) => ['KingBasura', 'patchJob', req] as const,
    stampJob: (req: StampJobRequest) => ['KingBasura', 'stampJob', req] as const,
    cancelJobStamp: (req: CancelJobStampRequest) => ['KingBasura', 'cancelJobStamp', req] as const,
    spawnGroundedBundle: (req: SpawnGroundedBundleRequest) => ['KingBasura', 'spawnGroundedBundle', req] as const,
    spawnLoadedBundle: (req: SpawnLoadedBundleRequest) => ['KingBasura', 'spawnLoadedBundle', req] as const,
    patchBundle: (req: PatchBundleRequest) => ['KingBasura', 'patchBundle', req] as const,
    stampBundle: (req: StampBundleRequest) => ['KingBasura', 'stampBundle', req] as const,
    fieldCancelBundle: (req: FieldCancelBundleRequest) => ['KingBasura', 'fieldCancelBundle', req] as const,
    retireBundle: (req: RetireBundleRequest) => ['KingBasura', 'retireBundle', req] as const,
    scheduleBundlePickup: (req: ScheduleBundlePickupRequest) => ['KingBasura', 'scheduleBundlePickup', req] as const,
    scheduleBundleDropoff: (req: ScheduleBundleDropoffRequest) => ['KingBasura', 'scheduleBundleDropoff', req] as const,
    patchScheduledTransfer: (req: PatchScheduledTransferRequest) => ['KingBasura', 'patchScheduledTransfer', req] as const,
    cancelScheduledTransfer: (req: CancelScheduledTransferRequest) => ['KingBasura', 'cancelScheduledTransfer', req] as const,
    disclaimScheduledTransfer: (req: DisclaimScheduledTransferRequest) => ['KingBasura', 'disclaimScheduledTransfer', req] as const,
    disclaimAllMyScheduledTransfers: () => ['KingBasura', 'disclaimAllMyScheduledTransfers'] as const,
    startTripleg: (req: StartTriplegRequest) => ['KingBasura', 'startTripleg', req] as const,
    patchTripleg: (req: PatchTriplegRequest) => ['KingBasura', 'patchTripleg', req] as const,
    arrive: (req: ArriveRequest) => ['KingBasura', 'arrive', req] as const,
    admit: (req: AdmitRequest) => ['KingBasura', 'admit', req] as const,
    startBundleOnloading: (req: StartBundleOnloadingRequest) => ['KingBasura', 'startBundleOnloading', req] as const,
    completeBundleOnloading: (req: CompleteBundleOnloadingRequest) => ['KingBasura', 'completeBundleOnloading', req] as const,
    startBundleOffloading: (req: StartBundleOffloadingRequest) => ['KingBasura', 'startBundleOffloading', req] as const,
    completeBundleOffloading: (req: CompleteBundleOffloadingRequest) => ['KingBasura', 'completeBundleOffloading', req] as const,
    upsertUnit: (req: UpsertUnitRequest) => ['KingBasura', 'upsertUnit', req] as const,
    upsertWasteFlavor: (req: UpsertWasteFlavorRequest) => ['KingBasura', 'upsertWasteFlavor', req] as const,
    patchWasteFlavor: (req: PatchWasteFlavorRequest) => ['KingBasura', 'patchWasteFlavor', req] as const,
    retireWasteFlavor: (req: RetireWasteFlavorRequest) => ['KingBasura', 'retireWasteFlavor', req] as const,
    upsertWasteFlavorRecipe: (req: UpsertWasteFlavorRecipeRequest) => ['KingBasura', 'upsertWasteFlavorRecipe', req] as const,
    deleteWasteFlavorRecipe: (req: DeleteWasteFlavorRecipeRequest) => ['KingBasura', 'deleteWasteFlavorRecipe', req] as const,
    upsertPackingMode: (req: UpsertPackingModeRequest) => ['KingBasura', 'upsertPackingMode', req] as const,
    upsertManifestType: (req: UpsertManifestTypeRequest) => ['KingBasura', 'upsertManifestType', req] as const,
    spawnWaste: (req: SpawnWasteRequest) => ['KingBasura', 'spawnWaste', req] as const,
    patchWaste: (req: PatchWasteRequest) => ['KingBasura', 'patchWaste', req] as const,
    stampWaste: (req: StampWasteRequest) => ['KingBasura', 'stampWaste', req] as const,
    attachWasteToBundle: (req: AttachWasteToBundleRequest) => ['KingBasura', 'attachWasteToBundle', req] as const,
    attachWasteToJob: (req: AttachWasteToJobRequest) => ['KingBasura', 'attachWasteToJob', req] as const,
    detachWasteFromBundle: (req: DetachWasteFromBundleRequest) => ['KingBasura', 'detachWasteFromBundle', req] as const,
    storeWasteTemporary: (req: StoreWasteTemporaryRequest) => ['KingBasura', 'storeWasteTemporary', req] as const,
    storeWastePermanent: (req: StoreWastePermanentRequest) => ['KingBasura', 'storeWastePermanent', req] as const,
    divideFromWaste: (req: DivideFromWasteRequest) => ['KingBasura', 'divideFromWaste', req] as const,
    mergeIntoWaste: (req: MergeIntoWasteRequest) => ['KingBasura', 'mergeIntoWaste', req] as const,
    retireWaste: (req: RetireWasteRequest) => ['KingBasura', 'retireWaste', req] as const,
    upsertTransformMode: (req: UpsertTransformModeRequest) => ['KingBasura', 'upsertTransformMode', req] as const,
    adoptTransformMode: (req: AdoptTransformModeRequest) => ['KingBasura', 'adoptTransformMode', req] as const,
    abandonTransformMode: (req: AbandonTransformModeRequest) => ['KingBasura', 'abandonTransformMode', req] as const,
    attachPhotoToStamp: (req: AttachPhotoToStampRequest) => ['KingBasura', 'attachPhotoToStamp', req] as const,
    rewindToCheckpoint: (req: RewindToCheckpointRequest) => ['KingBasura', 'rewindToCheckpoint', req] as const,
    spawnCheckpoint: (req: SpawnCheckpointRequest) => ['KingBasura', 'spawnCheckpoint', req] as const,
  }

  ping = (headers?: object, signal?: AbortSignal): Promise<PingResponse> => {
    return this.fetch(
      this.url('Ping'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PingResponse>(_data, 'PingResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  login = (req: LoginRequest, headers?: object, signal?: AbortSignal): Promise<LoginResponse> => {
    return this.fetch(
      this.url('Login'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LoginResponse>(_data, 'LoginResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  refreshAuthToken = (headers?: object, signal?: AbortSignal): Promise<RefreshAuthTokenResponse> => {
    return this.fetch(
      this.url('RefreshAuthToken'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RefreshAuthTokenResponse>(_data, 'RefreshAuthTokenResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  self = (headers?: object, signal?: AbortSignal): Promise<SelfResponse> => {
    return this.fetch(
      this.url('Self'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SelfResponse>(_data, 'SelfResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  logout = (headers?: object, signal?: AbortSignal): Promise<LogoutResponse> => {
    return this.fetch(
      this.url('Logout'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LogoutResponse>(_data, 'LogoutResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  getSystemConfig = (headers?: object, signal?: AbortSignal): Promise<GetSystemConfigResponse> => {
    return this.fetch(
      this.url('GetSystemConfig'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<GetSystemConfigResponse>(_data, 'GetSystemConfigResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  getVersionInfo = (headers?: object, signal?: AbortSignal): Promise<GetVersionInfoResponse> => {
    return this.fetch(
      this.url('GetVersionInfo'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<GetVersionInfoResponse>(_data, 'GetVersionInfoResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchCompanyById = (req: WatchCompanyByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompanyByIdResponse> => {
    return this.fetch(
      this.url('WatchCompanyById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchCompanyByIdResponse>(_data, 'WatchCompanyByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidCompanyById = (req: LastValidCompanyByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidCompanyByIdResponse> => {
    return this.fetch(
      this.url('LastValidCompanyById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidCompanyByIdResponse>(_data, 'LastValidCompanyByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  companyByIdAsof = (req: CompanyByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<CompanyByIdAsofResponse> => {
    return this.fetch(
      this.url('CompanyByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompanyByIdAsofResponse>(_data, 'CompanyByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  companyRevisionCount = (req: CompanyRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<CompanyRevisionCountResponse> => {
    return this.fetch(
      this.url('CompanyRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompanyRevisionCountResponse>(_data, 'CompanyRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allCompanyRevisions = (req: AllCompanyRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllCompanyRevisionsResponse> => {
    return this.fetch(
      this.url('AllCompanyRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllCompanyRevisionsResponse>(_data, 'AllCompanyRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchCompanyByCode = (req: WatchCompanyByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompanyByCodeResponse> => {
    return this.fetch(
      this.url('WatchCompanyByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchCompanyByCodeResponse>(_data, 'WatchCompanyByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidCompanyByCode = (req: LastValidCompanyByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidCompanyByCodeResponse> => {
    return this.fetch(
      this.url('LastValidCompanyByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidCompanyByCodeResponse>(_data, 'LastValidCompanyByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  companyByCodeAsof = (req: CompanyByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<CompanyByCodeAsofResponse> => {
    return this.fetch(
      this.url('CompanyByCodeAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompanyByCodeAsofResponse>(_data, 'CompanyByCodeAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchCompaniesByNameFragment = (req: WatchCompaniesByNameFragmentRequest, headers?: object, signal?: AbortSignal): Promise<WatchCompaniesByNameFragmentResponse> => {
    return this.fetch(
      this.url('WatchCompaniesByNameFragment'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchCompaniesByNameFragmentResponse>(_data, 'WatchCompaniesByNameFragmentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchVenueById = (req: WatchVenueByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByIdResponse> => {
    return this.fetch(
      this.url('WatchVenueById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchVenueByIdResponse>(_data, 'WatchVenueByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidVenueById = (req: LastValidVenueByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByIdResponse> => {
    return this.fetch(
      this.url('LastValidVenueById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidVenueByIdResponse>(_data, 'LastValidVenueByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  venueByIdAsof = (req: VenueByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByIdAsofResponse> => {
    return this.fetch(
      this.url('VenueByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<VenueByIdAsofResponse>(_data, 'VenueByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  venueRevisionCount = (req: VenueRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<VenueRevisionCountResponse> => {
    return this.fetch(
      this.url('VenueRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<VenueRevisionCountResponse>(_data, 'VenueRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allVenueRevisions = (req: AllVenueRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllVenueRevisionsResponse> => {
    return this.fetch(
      this.url('AllVenueRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllVenueRevisionsResponse>(_data, 'AllVenueRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAdmittersOnDutyForVenue = (req: WatchAdmittersOnDutyForVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchAdmittersOnDutyForVenueResponse> => {
    return this.fetch(
      this.url('WatchAdmittersOnDutyForVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAdmittersOnDutyForVenueResponse>(_data, 'WatchAdmittersOnDutyForVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchVenueByCode = (req: WatchVenueByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByCodeResponse> => {
    return this.fetch(
      this.url('WatchVenueByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchVenueByCodeResponse>(_data, 'WatchVenueByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidVenueByCode = (req: LastValidVenueByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByCodeResponse> => {
    return this.fetch(
      this.url('LastValidVenueByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidVenueByCodeResponse>(_data, 'LastValidVenueByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  venueByCodeAsof = (req: VenueByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByCodeAsofResponse> => {
    return this.fetch(
      this.url('VenueByCodeAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<VenueByCodeAsofResponse>(_data, 'VenueByCodeAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchVenueByName = (req: WatchVenueByNameRequest, headers?: object, signal?: AbortSignal): Promise<WatchVenueByNameResponse> => {
    return this.fetch(
      this.url('WatchVenueByName'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchVenueByNameResponse>(_data, 'WatchVenueByNameResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidVenueByName = (req: LastValidVenueByNameRequest, headers?: object, signal?: AbortSignal): Promise<LastValidVenueByNameResponse> => {
    return this.fetch(
      this.url('LastValidVenueByName'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidVenueByNameResponse>(_data, 'LastValidVenueByNameResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  venueByNameAsof = (req: VenueByNameAsofRequest, headers?: object, signal?: AbortSignal): Promise<VenueByNameAsofResponse> => {
    return this.fetch(
      this.url('VenueByNameAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<VenueByNameAsofResponse>(_data, 'VenueByNameAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  downstreamVenues = (headers?: object, signal?: AbortSignal): Promise<DownstreamVenuesResponse> => {
    return this.fetch(
      this.url('DownstreamVenues'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DownstreamVenuesResponse>(_data, 'DownstreamVenuesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTrucksDockedAt = (req: WatchTrucksDockedAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchTrucksDockedAtResponse> => {
    return this.fetch(
      this.url('WatchTrucksDockedAt'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTrucksDockedAtResponse>(_data, 'WatchTrucksDockedAtResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAgentById = (req: WatchAgentByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByIdResponse> => {
    return this.fetch(
      this.url('WatchAgentById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAgentByIdResponse>(_data, 'WatchAgentByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidAgentById = (req: LastValidAgentByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByIdResponse> => {
    return this.fetch(
      this.url('LastValidAgentById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidAgentByIdResponse>(_data, 'LastValidAgentByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentByIdAsof = (req: AgentByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByIdAsofResponse> => {
    return this.fetch(
      this.url('AgentByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentByIdAsofResponse>(_data, 'AgentByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentRevisionCount = (req: AgentRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<AgentRevisionCountResponse> => {
    return this.fetch(
      this.url('AgentRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentRevisionCountResponse>(_data, 'AgentRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allAgentRevisions = (req: AllAgentRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllAgentRevisionsResponse> => {
    return this.fetch(
      this.url('AllAgentRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllAgentRevisionsResponse>(_data, 'AllAgentRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAgentByCode = (req: WatchAgentByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByCodeResponse> => {
    return this.fetch(
      this.url('WatchAgentByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAgentByCodeResponse>(_data, 'WatchAgentByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidAgentByCode = (req: LastValidAgentByCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByCodeResponse> => {
    return this.fetch(
      this.url('LastValidAgentByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidAgentByCodeResponse>(_data, 'LastValidAgentByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentByCodeAsof = (req: AgentByCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByCodeAsofResponse> => {
    return this.fetch(
      this.url('AgentByCodeAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentByCodeAsofResponse>(_data, 'AgentByCodeAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAgentByName = (req: WatchAgentByNameRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByNameResponse> => {
    return this.fetch(
      this.url('WatchAgentByName'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAgentByNameResponse>(_data, 'WatchAgentByNameResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidAgentByName = (req: LastValidAgentByNameRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByNameResponse> => {
    return this.fetch(
      this.url('LastValidAgentByName'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidAgentByNameResponse>(_data, 'LastValidAgentByNameResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentByNameAsof = (req: AgentByNameAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByNameAsofResponse> => {
    return this.fetch(
      this.url('AgentByNameAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentByNameAsofResponse>(_data, 'AgentByNameAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAgentByLogin = (req: WatchAgentByLoginRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentByLoginResponse> => {
    return this.fetch(
      this.url('WatchAgentByLogin'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAgentByLoginResponse>(_data, 'WatchAgentByLoginResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidAgentByLogin = (req: LastValidAgentByLoginRequest, headers?: object, signal?: AbortSignal): Promise<LastValidAgentByLoginResponse> => {
    return this.fetch(
      this.url('LastValidAgentByLogin'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidAgentByLoginResponse>(_data, 'LastValidAgentByLoginResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentByLoginAsof = (req: AgentByLoginAsofRequest, headers?: object, signal?: AbortSignal): Promise<AgentByLoginAsofResponse> => {
    return this.fetch(
      this.url('AgentByLoginAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentByLoginAsofResponse>(_data, 'AgentByLoginAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentStampById = (req: AgentStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<AgentStampByIdResponse> => {
    return this.fetch(
      this.url('AgentStampById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentStampByIdResponse>(_data, 'AgentStampByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastFlavoredStampForAgent = (req: LastFlavoredStampForAgentRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForAgentResponse> => {
    return this.fetch(
      this.url('LastFlavoredStampForAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastFlavoredStampForAgentResponse>(_data, 'LastFlavoredStampForAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchStampsForAgent = (req: WatchStampsForAgentRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForAgentResponse> => {
    return this.fetch(
      this.url('WatchStampsForAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchStampsForAgentResponse>(_data, 'WatchStampsForAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampsForAgentDuring = (req: StampsForAgentDuringRequest, headers?: object, signal?: AbortSignal): Promise<StampsForAgentDuringResponse> => {
    return this.fetch(
      this.url('StampsForAgentDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampsForAgentDuringResponse>(_data, 'StampsForAgentDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  agentAvatar = (req: AgentAvatarRequest, headers?: object, signal?: AbortSignal): Promise<AgentAvatarResponse> => {
    return this.fetch(
      this.url('AgentAvatar'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AgentAvatarResponse>(_data, 'AgentAvatarResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAgentPresenceById = (req: WatchAgentPresenceByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchAgentPresenceByIdResponse> => {
    return this.fetch(
      this.url('WatchAgentPresenceById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAgentPresenceByIdResponse>(_data, 'WatchAgentPresenceByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAllPresentAgents = (headers?: object, signal?: AbortSignal): Promise<WatchAllPresentAgentsResponse> => {
    return this.fetch(
      this.url('WatchAllPresentAgents'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAllPresentAgentsResponse>(_data, 'WatchAllPresentAgentsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTruckModels = (headers?: object, signal?: AbortSignal): Promise<WatchTruckModelsResponse> => {
    return this.fetch(
      this.url('WatchTruckModels'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTruckModelsResponse>(_data, 'WatchTruckModelsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTruckModelById = (req: WatchTruckModelByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckModelByIdResponse> => {
    return this.fetch(
      this.url('WatchTruckModelById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTruckModelByIdResponse>(_data, 'WatchTruckModelByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTruckById = (req: WatchTruckByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByIdResponse> => {
    return this.fetch(
      this.url('WatchTruckById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTruckByIdResponse>(_data, 'WatchTruckByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidTruckById = (req: LastValidTruckByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidTruckByIdResponse> => {
    return this.fetch(
      this.url('LastValidTruckById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidTruckByIdResponse>(_data, 'LastValidTruckByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckByIdAsof = (req: TruckByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<TruckByIdAsofResponse> => {
    return this.fetch(
      this.url('TruckByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckByIdAsofResponse>(_data, 'TruckByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckRevisionCount = (req: TruckRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<TruckRevisionCountResponse> => {
    return this.fetch(
      this.url('TruckRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckRevisionCountResponse>(_data, 'TruckRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allTruckRevisions = (req: AllTruckRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllTruckRevisionsResponse> => {
    return this.fetch(
      this.url('AllTruckRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllTruckRevisionsResponse>(_data, 'AllTruckRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTruckByPlate = (req: WatchTruckByPlateRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByPlateResponse> => {
    return this.fetch(
      this.url('WatchTruckByPlate'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTruckByPlateResponse>(_data, 'WatchTruckByPlateResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidTruckByPlate = (req: LastValidTruckByPlateRequest, headers?: object, signal?: AbortSignal): Promise<LastValidTruckByPlateResponse> => {
    return this.fetch(
      this.url('LastValidTruckByPlate'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidTruckByPlateResponse>(_data, 'LastValidTruckByPlateResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckByPlateAsof = (req: TruckByPlateAsofRequest, headers?: object, signal?: AbortSignal): Promise<TruckByPlateAsofResponse> => {
    return this.fetch(
      this.url('TruckByPlateAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckByPlateAsofResponse>(_data, 'TruckByPlateAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTruckByCrew = (req: WatchTruckByCrewRequest, headers?: object, signal?: AbortSignal): Promise<WatchTruckByCrewResponse> => {
    return this.fetch(
      this.url('WatchTruckByCrew'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTruckByCrewResponse>(_data, 'WatchTruckByCrewResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckTenuresByCrewDuring = (req: TruckTenuresByCrewDuringRequest, headers?: object, signal?: AbortSignal): Promise<TruckTenuresByCrewDuringResponse> => {
    return this.fetch(
      this.url('TruckTenuresByCrewDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckTenuresByCrewDuringResponse>(_data, 'TruckTenuresByCrewDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchCrewByTruck = (req: WatchCrewByTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchCrewByTruckResponse> => {
    return this.fetch(
      this.url('WatchCrewByTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchCrewByTruckResponse>(_data, 'WatchCrewByTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  crewTenuresByTruckDuring = (req: CrewTenuresByTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<CrewTenuresByTruckDuringResponse> => {
    return this.fetch(
      this.url('CrewTenuresByTruckDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CrewTenuresByTruckDuringResponse>(_data, 'CrewTenuresByTruckDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckStampById = (req: TruckStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<TruckStampByIdResponse> => {
    return this.fetch(
      this.url('TruckStampById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckStampByIdResponse>(_data, 'TruckStampByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastFlavoredStampForTruck = (req: LastFlavoredStampForTruckRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForTruckResponse> => {
    return this.fetch(
      this.url('LastFlavoredStampForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastFlavoredStampForTruckResponse>(_data, 'LastFlavoredStampForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchStampsForTruck = (req: WatchStampsForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForTruckResponse> => {
    return this.fetch(
      this.url('WatchStampsForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchStampsForTruckResponse>(_data, 'WatchStampsForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampsForTruckDuring = (req: StampsForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<StampsForTruckDuringResponse> => {
    return this.fetch(
      this.url('StampsForTruckDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampsForTruckDuringResponse>(_data, 'StampsForTruckDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  truckAvatar = (req: TruckAvatarRequest, headers?: object, signal?: AbortSignal): Promise<TruckAvatarResponse> => {
    return this.fetch(
      this.url('TruckAvatar'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TruckAvatarResponse>(_data, 'TruckAvatarResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchJobById = (req: WatchJobByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByIdResponse> => {
    return this.fetch(
      this.url('WatchJobById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchJobByIdResponse>(_data, 'WatchJobByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidJobById = (req: LastValidJobByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByIdResponse> => {
    return this.fetch(
      this.url('LastValidJobById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidJobByIdResponse>(_data, 'LastValidJobByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  jobByIdAsof = (req: JobByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByIdAsofResponse> => {
    return this.fetch(
      this.url('JobByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<JobByIdAsofResponse>(_data, 'JobByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  jobRevisionCount = (req: JobRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<JobRevisionCountResponse> => {
    return this.fetch(
      this.url('JobRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<JobRevisionCountResponse>(_data, 'JobRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allJobRevisions = (req: AllJobRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllJobRevisionsResponse> => {
    return this.fetch(
      this.url('AllJobRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllJobRevisionsResponse>(_data, 'AllJobRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchExportableJobs = (headers?: object, signal?: AbortSignal): Promise<WatchExportableJobsResponse> => {
    return this.fetch(
      this.url('WatchExportableJobs'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchExportableJobsResponse>(_data, 'WatchExportableJobsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchExportedJobs = (headers?: object, signal?: AbortSignal): Promise<WatchExportedJobsResponse> => {
    return this.fetch(
      this.url('WatchExportedJobs'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchExportedJobsResponse>(_data, 'WatchExportedJobsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  showExportedJob = (req: ShowExportedJobRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedJobResponse> => {
    return this.fetch(
      this.url('ShowExportedJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ShowExportedJobResponse>(_data, 'ShowExportedJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  exportJob = (req: ExportJobRequest, headers?: object, signal?: AbortSignal): Promise<ExportJobResponse> => {
    return this.fetch(
      this.url('ExportJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ExportJobResponse>(_data, 'ExportJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchJobByJobCode = (req: WatchJobByJobCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByJobCodeResponse> => {
    return this.fetch(
      this.url('WatchJobByJobCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchJobByJobCodeResponse>(_data, 'WatchJobByJobCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidJobByJobCode = (req: LastValidJobByJobCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByJobCodeResponse> => {
    return this.fetch(
      this.url('LastValidJobByJobCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidJobByJobCodeResponse>(_data, 'LastValidJobByJobCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  jobByJobCodeAsof = (req: JobByJobCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByJobCodeAsofResponse> => {
    return this.fetch(
      this.url('JobByJobCodeAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<JobByJobCodeAsofResponse>(_data, 'JobByJobCodeAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchJobByIntakeCode = (req: WatchJobByIntakeCodeRequest, headers?: object, signal?: AbortSignal): Promise<WatchJobByIntakeCodeResponse> => {
    return this.fetch(
      this.url('WatchJobByIntakeCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchJobByIntakeCodeResponse>(_data, 'WatchJobByIntakeCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidJobByIntakeCode = (req: LastValidJobByIntakeCodeRequest, headers?: object, signal?: AbortSignal): Promise<LastValidJobByIntakeCodeResponse> => {
    return this.fetch(
      this.url('LastValidJobByIntakeCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidJobByIntakeCodeResponse>(_data, 'LastValidJobByIntakeCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  jobByIntakeCodeAsof = (req: JobByIntakeCodeAsofRequest, headers?: object, signal?: AbortSignal): Promise<JobByIntakeCodeAsofResponse> => {
    return this.fetch(
      this.url('JobByIntakeCodeAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<JobByIntakeCodeAsofResponse>(_data, 'JobByIntakeCodeAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  jobStampById = (req: JobStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<JobStampByIdResponse> => {
    return this.fetch(
      this.url('JobStampById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<JobStampByIdResponse>(_data, 'JobStampByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastFlavoredStampForJob = (req: LastFlavoredStampForJobRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForJobResponse> => {
    return this.fetch(
      this.url('LastFlavoredStampForJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastFlavoredStampForJobResponse>(_data, 'LastFlavoredStampForJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchStampsForJob = (req: WatchStampsForJobRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForJobResponse> => {
    return this.fetch(
      this.url('WatchStampsForJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchStampsForJobResponse>(_data, 'WatchStampsForJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchUnbundledWastesForJobAtVenue = (req: WatchUnbundledWastesForJobAtVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchUnbundledWastesForJobAtVenueResponse> => {
    return this.fetch(
      this.url('WatchUnbundledWastesForJobAtVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchUnbundledWastesForJobAtVenueResponse>(_data, 'WatchUnbundledWastesForJobAtVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  surchargeFlavorById = (req: SurchargeFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeFlavorByIdResponse> => {
    return this.fetch(
      this.url('SurchargeFlavorById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SurchargeFlavorByIdResponse>(_data, 'SurchargeFlavorByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  surchargeFlavorByCode = (req: SurchargeFlavorByCodeRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeFlavorByCodeResponse> => {
    return this.fetch(
      this.url('SurchargeFlavorByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SurchargeFlavorByCodeResponse>(_data, 'SurchargeFlavorByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchSurchargesForSubject = (req: WatchSurchargesForSubjectRequest, headers?: object, signal?: AbortSignal): Promise<WatchSurchargesForSubjectResponse> => {
    return this.fetch(
      this.url('WatchSurchargesForSubject'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchSurchargesForSubjectResponse>(_data, 'WatchSurchargesForSubjectResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchSurchargeById = (req: WatchSurchargeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchSurchargeByIdResponse> => {
    return this.fetch(
      this.url('WatchSurchargeById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchSurchargeByIdResponse>(_data, 'WatchSurchargeByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidSurchargeById = (req: LastValidSurchargeByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidSurchargeByIdResponse> => {
    return this.fetch(
      this.url('LastValidSurchargeById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidSurchargeByIdResponse>(_data, 'LastValidSurchargeByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  surchargeByIdAsof = (req: SurchargeByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<SurchargeByIdAsofResponse> => {
    return this.fetch(
      this.url('SurchargeByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SurchargeByIdAsofResponse>(_data, 'SurchargeByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allSurchargeRevisions = (req: AllSurchargeRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllSurchargeRevisionsResponse> => {
    return this.fetch(
      this.url('AllSurchargeRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllSurchargeRevisionsResponse>(_data, 'AllSurchargeRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchBundleById = (req: WatchBundleByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleByIdResponse> => {
    return this.fetch(
      this.url('WatchBundleById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchBundleByIdResponse>(_data, 'WatchBundleByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidBundleById = (req: LastValidBundleByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidBundleByIdResponse> => {
    return this.fetch(
      this.url('LastValidBundleById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidBundleByIdResponse>(_data, 'LastValidBundleByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  bundleByIdAsof = (req: BundleByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<BundleByIdAsofResponse> => {
    return this.fetch(
      this.url('BundleByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<BundleByIdAsofResponse>(_data, 'BundleByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  bundleRevisionCount = (req: BundleRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<BundleRevisionCountResponse> => {
    return this.fetch(
      this.url('BundleRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<BundleRevisionCountResponse>(_data, 'BundleRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allBundleRevisions = (req: AllBundleRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllBundleRevisionsResponse> => {
    return this.fetch(
      this.url('AllBundleRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllBundleRevisionsResponse>(_data, 'AllBundleRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchBundleLocation = (req: WatchBundleLocationRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleLocationResponse> => {
    return this.fetch(
      this.url('WatchBundleLocation'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchBundleLocationResponse>(_data, 'WatchBundleLocationResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchOrphanedBundles = (headers?: object, signal?: AbortSignal): Promise<WatchOrphanedBundlesResponse> => {
    return this.fetch(
      this.url('WatchOrphanedBundles'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchOrphanedBundlesResponse>(_data, 'WatchOrphanedBundlesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  activeBundleCount = (headers?: object, signal?: AbortSignal): Promise<ActiveBundleCountResponse> => {
    return this.fetch(
      this.url('ActiveBundleCount'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ActiveBundleCountResponse>(_data, 'ActiveBundleCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchActiveBundles = (headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesResponse> => {
    return this.fetch(
      this.url('WatchActiveBundles'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchActiveBundlesResponse>(_data, 'WatchActiveBundlesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  activeBundlePage = (req: ActiveBundlePageRequest, headers?: object, signal?: AbortSignal): Promise<ActiveBundlePageResponse> => {
    return this.fetch(
      this.url('ActiveBundlePage'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ActiveBundlePageResponse>(_data, 'ActiveBundlePageResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchActiveBundlesDestinedFor = (req: WatchActiveBundlesDestinedForRequest, headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesDestinedForResponse> => {
    return this.fetch(
      this.url('WatchActiveBundlesDestinedFor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchActiveBundlesDestinedForResponse>(_data, 'WatchActiveBundlesDestinedForResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchActiveBundlesOriginatingAt = (req: WatchActiveBundlesOriginatingAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchActiveBundlesOriginatingAtResponse> => {
    return this.fetch(
      this.url('WatchActiveBundlesOriginatingAt'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchActiveBundlesOriginatingAtResponse>(_data, 'WatchActiveBundlesOriginatingAtResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchExportableBundles = (headers?: object, signal?: AbortSignal): Promise<WatchExportableBundlesResponse> => {
    return this.fetch(
      this.url('WatchExportableBundles'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchExportableBundlesResponse>(_data, 'WatchExportableBundlesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchInspectableBundles = (req: WatchInspectableBundlesRequest, headers?: object, signal?: AbortSignal): Promise<WatchInspectableBundlesResponse> => {
    return this.fetch(
      this.url('WatchInspectableBundles'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchInspectableBundlesResponse>(_data, 'WatchInspectableBundlesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchBundlesNeedingSupervisor = (req: WatchBundlesNeedingSupervisorRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundlesNeedingSupervisorResponse> => {
    return this.fetch(
      this.url('WatchBundlesNeedingSupervisor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchBundlesNeedingSupervisorResponse>(_data, 'WatchBundlesNeedingSupervisorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  showExportedBundle = (req: ShowExportedBundleRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedBundleResponse> => {
    return this.fetch(
      this.url('ShowExportedBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ShowExportedBundleResponse>(_data, 'ShowExportedBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  completeBundleHistoryById = (req: CompleteBundleHistoryByIdRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleHistoryByIdResponse> => {
    return this.fetch(
      this.url('CompleteBundleHistoryById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompleteBundleHistoryByIdResponse>(_data, 'CompleteBundleHistoryByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  bundleStampById = (req: BundleStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<BundleStampByIdResponse> => {
    return this.fetch(
      this.url('BundleStampById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<BundleStampByIdResponse>(_data, 'BundleStampByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastFlavoredStampForBundle = (req: LastFlavoredStampForBundleRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForBundleResponse> => {
    return this.fetch(
      this.url('LastFlavoredStampForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastFlavoredStampForBundleResponse>(_data, 'LastFlavoredStampForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchStampsForBundle = (req: WatchStampsForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForBundleResponse> => {
    return this.fetch(
      this.url('WatchStampsForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchStampsForBundleResponse>(_data, 'WatchStampsForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchFlavoredStampsForBundle = (req: WatchFlavoredStampsForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchFlavoredStampsForBundleResponse> => {
    return this.fetch(
      this.url('WatchFlavoredStampsForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchFlavoredStampsForBundleResponse>(_data, 'WatchFlavoredStampsForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTransferById = (req: WatchTransferByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransferByIdResponse> => {
    return this.fetch(
      this.url('WatchTransferById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTransferByIdResponse>(_data, 'WatchTransferByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAllTransfers = (headers?: object, signal?: AbortSignal): Promise<WatchAllTransfersResponse> => {
    return this.fetch(
      this.url('WatchAllTransfers'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAllTransfersResponse>(_data, 'WatchAllTransfersResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchOpenTransfersForTruck = (req: WatchOpenTransfersForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchOpenTransfersForTruckResponse> => {
    return this.fetch(
      this.url('WatchOpenTransfersForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchOpenTransfersForTruckResponse>(_data, 'WatchOpenTransfersForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTransfersForTruck = (req: WatchTransfersForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransfersForTruckResponse> => {
    return this.fetch(
      this.url('WatchTransfersForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTransfersForTruckResponse>(_data, 'WatchTransfersForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchLastTransferForBundle = (req: WatchLastTransferForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchLastTransferForBundleResponse> => {
    return this.fetch(
      this.url('WatchLastTransferForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchLastTransferForBundleResponse>(_data, 'WatchLastTransferForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastTransferForBundleBefore = (req: LastTransferForBundleBeforeRequest, headers?: object, signal?: AbortSignal): Promise<LastTransferForBundleBeforeResponse> => {
    return this.fetch(
      this.url('LastTransferForBundleBefore'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastTransferForBundleBeforeResponse>(_data, 'LastTransferForBundleBeforeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allTransfersForBundle = (req: AllTransfersForBundleRequest, headers?: object, signal?: AbortSignal): Promise<AllTransfersForBundleResponse> => {
    return this.fetch(
      this.url('AllTransfersForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllTransfersForBundleResponse>(_data, 'AllTransfersForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  transfersForTruckDuring = (req: TransfersForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<TransfersForTruckDuringResponse> => {
    return this.fetch(
      this.url('TransfersForTruckDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TransfersForTruckDuringResponse>(_data, 'TransfersForTruckDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTransfersAtVenue = (req: WatchTransfersAtVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransfersAtVenueResponse> => {
    return this.fetch(
      this.url('WatchTransfersAtVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTransfersAtVenueResponse>(_data, 'WatchTransfersAtVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTriplegById = (req: WatchTriplegByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegByIdResponse> => {
    return this.fetch(
      this.url('WatchTriplegById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTriplegByIdResponse>(_data, 'WatchTriplegByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAllTriplegs = (headers?: object, signal?: AbortSignal): Promise<WatchAllTriplegsResponse> => {
    return this.fetch(
      this.url('WatchAllTriplegs'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAllTriplegsResponse>(_data, 'WatchAllTriplegsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchOpenTriplegForTruck = (req: WatchOpenTriplegForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchOpenTriplegForTruckResponse> => {
    return this.fetch(
      this.url('WatchOpenTriplegForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchOpenTriplegForTruckResponse>(_data, 'WatchOpenTriplegForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchLastTriplegForTruck = (req: WatchLastTriplegForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchLastTriplegForTruckResponse> => {
    return this.fetch(
      this.url('WatchLastTriplegForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchLastTriplegForTruckResponse>(_data, 'WatchLastTriplegForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTriplegsForTruck = (req: WatchTriplegsForTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegsForTruckResponse> => {
    return this.fetch(
      this.url('WatchTriplegsForTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTriplegsForTruckResponse>(_data, 'WatchTriplegsForTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  triplegsForTruckDuring = (req: TriplegsForTruckDuringRequest, headers?: object, signal?: AbortSignal): Promise<TriplegsForTruckDuringResponse> => {
    return this.fetch(
      this.url('TriplegsForTruckDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<TriplegsForTruckDuringResponse>(_data, 'TriplegsForTruckDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchUnadmittedTriplegsInto = (req: WatchUnadmittedTriplegsIntoRequest, headers?: object, signal?: AbortSignal): Promise<WatchUnadmittedTriplegsIntoResponse> => {
    return this.fetch(
      this.url('WatchUnadmittedTriplegsInto'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchUnadmittedTriplegsIntoResponse>(_data, 'WatchUnadmittedTriplegsIntoResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTriplegsInboundTo = (req: WatchTriplegsInboundToRequest, headers?: object, signal?: AbortSignal): Promise<WatchTriplegsInboundToResponse> => {
    return this.fetch(
      this.url('WatchTriplegsInboundTo'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTriplegsInboundToResponse>(_data, 'WatchTriplegsInboundToResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransferById = (req: WatchScheduledTransferByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransferByIdResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransferById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransferByIdResponse>(_data, 'WatchScheduledTransferByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransferForBundle = (req: WatchScheduledTransferForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransferForBundleResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransferForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransferForBundleResponse>(_data, 'WatchScheduledTransferForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransfersForDriver = (req: WatchScheduledTransfersForDriverRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersForDriverResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransfersForDriver'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransfersForDriverResponse>(_data, 'WatchScheduledTransfersForDriverResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransfersAwaitingTruck = (req: WatchScheduledTransfersAwaitingTruckRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersAwaitingTruckResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransfersAwaitingTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransfersAwaitingTruckResponse>(_data, 'WatchScheduledTransfersAwaitingTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  scheduledTransfersDuring = (req: ScheduledTransfersDuringRequest, headers?: object, signal?: AbortSignal): Promise<ScheduledTransfersDuringResponse> => {
    return this.fetch(
      this.url('ScheduledTransfersDuring'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ScheduledTransfersDuringResponse>(_data, 'ScheduledTransfersDuringResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransfersAt = (req: WatchScheduledTransfersAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersAtResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransfersAt'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransfersAtResponse>(_data, 'WatchScheduledTransfersAtResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchScheduledTransfersForDispatch = (headers?: object, signal?: AbortSignal): Promise<WatchScheduledTransfersForDispatchResponse> => {
    return this.fetch(
      this.url('WatchScheduledTransfersForDispatch'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchScheduledTransfersForDispatchResponse>(_data, 'WatchScheduledTransfersForDispatchResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wasteFlavorByCode = (req: WasteFlavorByCodeRequest, headers?: object, signal?: AbortSignal): Promise<WasteFlavorByCodeResponse> => {
    return this.fetch(
      this.url('WasteFlavorByCode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WasteFlavorByCodeResponse>(_data, 'WasteFlavorByCodeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchWasteFlavorById = (req: WatchWasteFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteFlavorByIdResponse> => {
    return this.fetch(
      this.url('WatchWasteFlavorById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchWasteFlavorByIdResponse>(_data, 'WatchWasteFlavorByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidWasteFlavorById = (req: LastValidWasteFlavorByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidWasteFlavorByIdResponse> => {
    return this.fetch(
      this.url('LastValidWasteFlavorById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidWasteFlavorByIdResponse>(_data, 'LastValidWasteFlavorByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wasteFlavorRevisionCount = (req: WasteFlavorRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<WasteFlavorRevisionCountResponse> => {
    return this.fetch(
      this.url('WasteFlavorRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WasteFlavorRevisionCountResponse>(_data, 'WasteFlavorRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allWasteFlavorRevisions = (req: AllWasteFlavorRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteFlavorRevisionsResponse> => {
    return this.fetch(
      this.url('AllWasteFlavorRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllWasteFlavorRevisionsResponse>(_data, 'AllWasteFlavorRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  activeWasteFlavors = (req: ActiveWasteFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<ActiveWasteFlavorsResponse> => {
    return this.fetch(
      this.url('ActiveWasteFlavors'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ActiveWasteFlavorsResponse>(_data, 'ActiveWasteFlavorsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  getCleavableFlavors = (req: GetCleavableFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<GetCleavableFlavorsResponse> => {
    return this.fetch(
      this.url('GetCleavableFlavors'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<GetCleavableFlavorsResponse>(_data, 'GetCleavableFlavorsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  getEmissibleFlavors = (req: GetEmissibleFlavorsRequest, headers?: object, signal?: AbortSignal): Promise<GetEmissibleFlavorsResponse> => {
    return this.fetch(
      this.url('GetEmissibleFlavors'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<GetEmissibleFlavorsResponse>(_data, 'GetEmissibleFlavorsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchWasteById = (req: WatchWasteByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteByIdResponse> => {
    return this.fetch(
      this.url('WatchWasteById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchWasteByIdResponse>(_data, 'WatchWasteByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidWasteById = (req: LastValidWasteByIdRequest, headers?: object, signal?: AbortSignal): Promise<LastValidWasteByIdResponse> => {
    return this.fetch(
      this.url('LastValidWasteById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidWasteByIdResponse>(_data, 'LastValidWasteByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wasteByIdAsof = (req: WasteByIdAsofRequest, headers?: object, signal?: AbortSignal): Promise<WasteByIdAsofResponse> => {
    return this.fetch(
      this.url('WasteByIdAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WasteByIdAsofResponse>(_data, 'WasteByIdAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wasteRevisionCount = (req: WasteRevisionCountRequest, headers?: object, signal?: AbortSignal): Promise<WasteRevisionCountResponse> => {
    return this.fetch(
      this.url('WasteRevisionCount'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WasteRevisionCountResponse>(_data, 'WasteRevisionCountResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allWasteRevisionStubs = (req: AllWasteRevisionStubsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteRevisionStubsResponse> => {
    return this.fetch(
      this.url('AllWasteRevisionStubs'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllWasteRevisionStubsResponse>(_data, 'AllWasteRevisionStubsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allWasteRevisions = (req: AllWasteRevisionsRequest, headers?: object, signal?: AbortSignal): Promise<AllWasteRevisionsResponse> => {
    return this.fetch(
      this.url('AllWasteRevisions'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllWasteRevisionsResponse>(_data, 'AllWasteRevisionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchWastesForBundle = (req: WatchWastesForBundleRequest, headers?: object, signal?: AbortSignal): Promise<WatchWastesForBundleResponse> => {
    return this.fetch(
      this.url('WatchWastesForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchWastesForBundleResponse>(_data, 'WatchWastesForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allWastesForBundle = (req: AllWastesForBundleRequest, headers?: object, signal?: AbortSignal): Promise<AllWastesForBundleResponse> => {
    return this.fetch(
      this.url('AllWastesForBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllWastesForBundleResponse>(_data, 'AllWastesForBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wastesForBundleAsof = (req: WastesForBundleAsofRequest, headers?: object, signal?: AbortSignal): Promise<WastesForBundleAsofResponse> => {
    return this.fetch(
      this.url('WastesForBundleAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WastesForBundleAsofResponse>(_data, 'WastesForBundleAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allDaughtersOfWaste = (req: AllDaughtersOfWasteRequest, headers?: object, signal?: AbortSignal): Promise<AllDaughtersOfWasteResponse> => {
    return this.fetch(
      this.url('AllDaughtersOfWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllDaughtersOfWasteResponse>(_data, 'AllDaughtersOfWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  mothersOfWaste = (req: MothersOfWasteRequest, headers?: object, signal?: AbortSignal): Promise<MothersOfWasteResponse> => {
    return this.fetch(
      this.url('MothersOfWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<MothersOfWasteResponse>(_data, 'MothersOfWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  directWasteLineageRecords = (req: DirectWasteLineageRecordsRequest, headers?: object, signal?: AbortSignal): Promise<DirectWasteLineageRecordsResponse> => {
    return this.fetch(
      this.url('DirectWasteLineageRecords'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DirectWasteLineageRecordsResponse>(_data, 'DirectWasteLineageRecordsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchBundleForWaste = (req: WatchBundleForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchBundleForWasteResponse> => {
    return this.fetch(
      this.url('WatchBundleForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchBundleForWasteResponse>(_data, 'WatchBundleForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastValidBundleForWaste = (req: LastValidBundleForWasteRequest, headers?: object, signal?: AbortSignal): Promise<LastValidBundleForWasteResponse> => {
    return this.fetch(
      this.url('LastValidBundleForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastValidBundleForWasteResponse>(_data, 'LastValidBundleForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  bundleForWasteAsof = (req: BundleForWasteAsofRequest, headers?: object, signal?: AbortSignal): Promise<BundleForWasteAsofResponse> => {
    return this.fetch(
      this.url('BundleForWasteAsof'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<BundleForWasteAsofResponse>(_data, 'BundleForWasteAsofResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allBundlesForWaste = (req: AllBundlesForWasteRequest, headers?: object, signal?: AbortSignal): Promise<AllBundlesForWasteResponse> => {
    return this.fetch(
      this.url('AllBundlesForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllBundlesForWasteResponse>(_data, 'AllBundlesForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchAssociationsForWaste = (req: WatchAssociationsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchAssociationsForWasteResponse> => {
    return this.fetch(
      this.url('WatchAssociationsForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchAssociationsForWasteResponse>(_data, 'WatchAssociationsForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  showExportedWaste = (req: ShowExportedWasteRequest, headers?: object, signal?: AbortSignal): Promise<ShowExportedWasteResponse> => {
    return this.fetch(
      this.url('ShowExportedWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ShowExportedWasteResponse>(_data, 'ShowExportedWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  completeWasteHistoryById = (req: CompleteWasteHistoryByIdRequest, headers?: object, signal?: AbortSignal): Promise<CompleteWasteHistoryByIdResponse> => {
    return this.fetch(
      this.url('CompleteWasteHistoryById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompleteWasteHistoryByIdResponse>(_data, 'CompleteWasteHistoryByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchWasteLocation = (req: WatchWasteLocationRequest, headers?: object, signal?: AbortSignal): Promise<WatchWasteLocationResponse> => {
    return this.fetch(
      this.url('WatchWasteLocation'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchWasteLocationResponse>(_data, 'WatchWasteLocationResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchWastesAt = (req: WatchWastesAtRequest, headers?: object, signal?: AbortSignal): Promise<WatchWastesAtResponse> => {
    return this.fetch(
      this.url('WatchWastesAt'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchWastesAtResponse>(_data, 'WatchWastesAtResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  wasteStampById = (req: WasteStampByIdRequest, headers?: object, signal?: AbortSignal): Promise<WasteStampByIdResponse> => {
    return this.fetch(
      this.url('WasteStampById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WasteStampByIdResponse>(_data, 'WasteStampByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  lastFlavoredStampForWaste = (req: LastFlavoredStampForWasteRequest, headers?: object, signal?: AbortSignal): Promise<LastFlavoredStampForWasteResponse> => {
    return this.fetch(
      this.url('LastFlavoredStampForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<LastFlavoredStampForWasteResponse>(_data, 'LastFlavoredStampForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchStampsForWaste = (req: WatchStampsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchStampsForWasteResponse> => {
    return this.fetch(
      this.url('WatchStampsForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchStampsForWasteResponse>(_data, 'WatchStampsForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchFlavoredStampsForWaste = (req: WatchFlavoredStampsForWasteRequest, headers?: object, signal?: AbortSignal): Promise<WatchFlavoredStampsForWasteResponse> => {
    return this.fetch(
      this.url('WatchFlavoredStampsForWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchFlavoredStampsForWasteResponse>(_data, 'WatchFlavoredStampsForWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchPackingModes = (headers?: object, signal?: AbortSignal): Promise<WatchPackingModesResponse> => {
    return this.fetch(
      this.url('WatchPackingModes'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchPackingModesResponse>(_data, 'WatchPackingModesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchPackingModeById = (req: WatchPackingModeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchPackingModeByIdResponse> => {
    return this.fetch(
      this.url('WatchPackingModeById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchPackingModeByIdResponse>(_data, 'WatchPackingModeByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchManifestTypes = (headers?: object, signal?: AbortSignal): Promise<WatchManifestTypesResponse> => {
    return this.fetch(
      this.url('WatchManifestTypes'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchManifestTypesResponse>(_data, 'WatchManifestTypesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchManifestTypeById = (req: WatchManifestTypeByIdRequest, headers?: object, signal?: AbortSignal): Promise<WatchManifestTypeByIdResponse> => {
    return this.fetch(
      this.url('WatchManifestTypeById'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchManifestTypeByIdResponse>(_data, 'WatchManifestTypeByIdResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchUnits = (headers?: object, signal?: AbortSignal): Promise<WatchUnitsResponse> => {
    return this.fetch(
      this.url('WatchUnits'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchUnitsResponse>(_data, 'WatchUnitsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTransformModes = (headers?: object, signal?: AbortSignal): Promise<WatchTransformModesResponse> => {
    return this.fetch(
      this.url('WatchTransformModes'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTransformModesResponse>(_data, 'WatchTransformModesResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  watchTransformModesForVenue = (req: WatchTransformModesForVenueRequest, headers?: object, signal?: AbortSignal): Promise<WatchTransformModesForVenueResponse> => {
    return this.fetch(
      this.url('WatchTransformModesForVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<WatchTransformModesForVenueResponse>(_data, 'WatchTransformModesForVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  allRewindCheckpoints = (headers?: object, signal?: AbortSignal): Promise<AllRewindCheckpointsResponse> => {
    return this.fetch(
      this.url('AllRewindCheckpoints'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AllRewindCheckpointsResponse>(_data, 'AllRewindCheckpointsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  setlists = (options: WebrpcStreamOptions<SetlistPacketResult>): WebrpcStreamController => {
    const abortController = new AbortController()
    const abortSignal = abortController.signal

    if (options.signal) {
      abortSignal.addEventListener("abort", () => abortController.abort(options.signal?.reason), {
        signal: options.signal,
      })
    }

    const _fetch = () => this.fetch(this.url('Setlists'),
      createHttpRequest('{}', options.headers, options.signal)
    ).then(async (res) => {
      await sseResponse(res, options, _fetch)
    }, (error) => {
      options.onError(error, _fetch)
    })

    const resp = _fetch()
    return {
      abort: abortController.abort.bind(abortController),
      closed: resp
    }
  }
  setlistSubscriptions = (headers?: object, signal?: AbortSignal): Promise<SetlistSubscriptionsResponse> => {
    return this.fetch(
      this.url('SetlistSubscriptions'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SetlistSubscriptionsResponse>(_data, 'SetlistSubscriptionsResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  setSystemConfig = (req: SetSystemConfigRequest, headers?: object, signal?: AbortSignal): Promise<SetSystemConfigResponse> => {
    return this.fetch(
      this.url('SetSystemConfig'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SetSystemConfigResponse>(_data, 'SetSystemConfigResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertCompany = (req: UpsertCompanyRequest, headers?: object, signal?: AbortSignal): Promise<UpsertCompanyResponse> => {
    return this.fetch(
      this.url('UpsertCompany'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertCompanyResponse>(_data, 'UpsertCompanyResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchCompany = (req: PatchCompanyRequest, headers?: object, signal?: AbortSignal): Promise<PatchCompanyResponse> => {
    return this.fetch(
      this.url('PatchCompany'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchCompanyResponse>(_data, 'PatchCompanyResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireCompany = (req: RetireCompanyRequest, headers?: object, signal?: AbortSignal): Promise<RetireCompanyResponse> => {
    return this.fetch(
      this.url('RetireCompany'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireCompanyResponse>(_data, 'RetireCompanyResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertVenue = (req: UpsertVenueRequest, headers?: object, signal?: AbortSignal): Promise<UpsertVenueResponse> => {
    return this.fetch(
      this.url('UpsertVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertVenueResponse>(_data, 'UpsertVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchVenue = (req: PatchVenueRequest, headers?: object, signal?: AbortSignal): Promise<PatchVenueResponse> => {
    return this.fetch(
      this.url('PatchVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchVenueResponse>(_data, 'PatchVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireVenue = (req: RetireVenueRequest, headers?: object, signal?: AbortSignal): Promise<RetireVenueResponse> => {
    return this.fetch(
      this.url('RetireVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireVenueResponse>(_data, 'RetireVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertDownstreamVenue = (req: UpsertDownstreamVenueRequest, headers?: object, signal?: AbortSignal): Promise<UpsertDownstreamVenueResponse> => {
    return this.fetch(
      this.url('UpsertDownstreamVenue'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertDownstreamVenueResponse>(_data, 'UpsertDownstreamVenueResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertAgent = (req: UpsertAgentRequest, headers?: object, signal?: AbortSignal): Promise<UpsertAgentResponse> => {
    return this.fetch(
      this.url('UpsertAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertAgentResponse>(_data, 'UpsertAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchAgent = (req: PatchAgentRequest, headers?: object, signal?: AbortSignal): Promise<PatchAgentResponse> => {
    return this.fetch(
      this.url('PatchAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchAgentResponse>(_data, 'PatchAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchSelf = (req: PatchSelfRequest, headers?: object, signal?: AbortSignal): Promise<PatchSelfResponse> => {
    return this.fetch(
      this.url('PatchSelf'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchSelfResponse>(_data, 'PatchSelfResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  changePassword = (req: ChangePasswordRequest, headers?: object, signal?: AbortSignal): Promise<ChangePasswordResponse> => {
    return this.fetch(
      this.url('ChangePassword'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ChangePasswordResponse>(_data, 'ChangePasswordResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireAgent = (req: RetireAgentRequest, headers?: object, signal?: AbortSignal): Promise<RetireAgentResponse> => {
    return this.fetch(
      this.url('RetireAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireAgentResponse>(_data, 'RetireAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampAgent = (req: StampAgentRequest, headers?: object, signal?: AbortSignal): Promise<StampAgentResponse> => {
    return this.fetch(
      this.url('StampAgent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampAgentResponse>(_data, 'StampAgentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertTruckModel = (req: UpsertTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTruckModelResponse> => {
    return this.fetch(
      this.url('UpsertTruckModel'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertTruckModelResponse>(_data, 'UpsertTruckModelResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchTruckModel = (req: PatchTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<PatchTruckModelResponse> => {
    return this.fetch(
      this.url('PatchTruckModel'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchTruckModelResponse>(_data, 'PatchTruckModelResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireTruckModel = (req: RetireTruckModelRequest, headers?: object, signal?: AbortSignal): Promise<RetireTruckModelResponse> => {
    return this.fetch(
      this.url('RetireTruckModel'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireTruckModelResponse>(_data, 'RetireTruckModelResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertTruck = (req: UpsertTruckRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTruckResponse> => {
    return this.fetch(
      this.url('UpsertTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertTruckResponse>(_data, 'UpsertTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchTruck = (req: PatchTruckRequest, headers?: object, signal?: AbortSignal): Promise<PatchTruckResponse> => {
    return this.fetch(
      this.url('PatchTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchTruckResponse>(_data, 'PatchTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireTruck = (req: RetireTruckRequest, headers?: object, signal?: AbortSignal): Promise<RetireTruckResponse> => {
    return this.fetch(
      this.url('RetireTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireTruckResponse>(_data, 'RetireTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  mountTruck = (req: MountTruckRequest, headers?: object, signal?: AbortSignal): Promise<MountTruckResponse> => {
    return this.fetch(
      this.url('MountTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<MountTruckResponse>(_data, 'MountTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  dismountTruck = (headers?: object, signal?: AbortSignal): Promise<DismountTruckResponse> => {
    return this.fetch(
      this.url('DismountTruck'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DismountTruckResponse>(_data, 'DismountTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampTruck = (req: StampTruckRequest, headers?: object, signal?: AbortSignal): Promise<StampTruckResponse> => {
    return this.fetch(
      this.url('StampTruck'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampTruckResponse>(_data, 'StampTruckResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertSurchargeFlavor = (req: UpsertSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<UpsertSurchargeFlavorResponse> => {
    return this.fetch(
      this.url('UpsertSurchargeFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertSurchargeFlavorResponse>(_data, 'UpsertSurchargeFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchSurchargeFlavor = (req: PatchSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<PatchSurchargeFlavorResponse> => {
    return this.fetch(
      this.url('PatchSurchargeFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchSurchargeFlavorResponse>(_data, 'PatchSurchargeFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireSurchargeFlavor = (req: RetireSurchargeFlavorRequest, headers?: object, signal?: AbortSignal): Promise<RetireSurchargeFlavorResponse> => {
    return this.fetch(
      this.url('RetireSurchargeFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireSurchargeFlavorResponse>(_data, 'RetireSurchargeFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  spawnSurcharge = (req: SpawnSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<SpawnSurchargeResponse> => {
    return this.fetch(
      this.url('SpawnSurcharge'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SpawnSurchargeResponse>(_data, 'SpawnSurchargeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchSurcharge = (req: PatchSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<PatchSurchargeResponse> => {
    return this.fetch(
      this.url('PatchSurcharge'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchSurchargeResponse>(_data, 'PatchSurchargeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireSurcharge = (req: RetireSurchargeRequest, headers?: object, signal?: AbortSignal): Promise<RetireSurchargeResponse> => {
    return this.fetch(
      this.url('RetireSurcharge'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireSurchargeResponse>(_data, 'RetireSurchargeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertShinwaJob = (req: UpsertShinwaJobRequest, headers?: object, signal?: AbortSignal): Promise<UpsertShinwaJobResponse> => {
    return this.fetch(
      this.url('UpsertShinwaJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertShinwaJobResponse>(_data, 'UpsertShinwaJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertSanyuJob = (req: UpsertSanyuJobRequest, headers?: object, signal?: AbortSignal): Promise<UpsertSanyuJobResponse> => {
    return this.fetch(
      this.url('UpsertSanyuJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertSanyuJobResponse>(_data, 'UpsertSanyuJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchJob = (req: PatchJobRequest, headers?: object, signal?: AbortSignal): Promise<PatchJobResponse> => {
    return this.fetch(
      this.url('PatchJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchJobResponse>(_data, 'PatchJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampJob = (req: StampJobRequest, headers?: object, signal?: AbortSignal): Promise<StampJobResponse> => {
    return this.fetch(
      this.url('StampJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampJobResponse>(_data, 'StampJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  cancelJobStamp = (req: CancelJobStampRequest, headers?: object, signal?: AbortSignal): Promise<CancelJobStampResponse> => {
    return this.fetch(
      this.url('CancelJobStamp'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CancelJobStampResponse>(_data, 'CancelJobStampResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  spawnGroundedBundle = (req: SpawnGroundedBundleRequest, headers?: object, signal?: AbortSignal): Promise<SpawnGroundedBundleResponse> => {
    return this.fetch(
      this.url('SpawnGroundedBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SpawnGroundedBundleResponse>(_data, 'SpawnGroundedBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  spawnLoadedBundle = (req: SpawnLoadedBundleRequest, headers?: object, signal?: AbortSignal): Promise<SpawnLoadedBundleResponse> => {
    return this.fetch(
      this.url('SpawnLoadedBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SpawnLoadedBundleResponse>(_data, 'SpawnLoadedBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchBundle = (req: PatchBundleRequest, headers?: object, signal?: AbortSignal): Promise<PatchBundleResponse> => {
    return this.fetch(
      this.url('PatchBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchBundleResponse>(_data, 'PatchBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampBundle = (req: StampBundleRequest, headers?: object, signal?: AbortSignal): Promise<StampBundleResponse> => {
    return this.fetch(
      this.url('StampBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampBundleResponse>(_data, 'StampBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  fieldCancelBundle = (req: FieldCancelBundleRequest, headers?: object, signal?: AbortSignal): Promise<FieldCancelBundleResponse> => {
    return this.fetch(
      this.url('FieldCancelBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<FieldCancelBundleResponse>(_data, 'FieldCancelBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireBundle = (req: RetireBundleRequest, headers?: object, signal?: AbortSignal): Promise<RetireBundleResponse> => {
    return this.fetch(
      this.url('RetireBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireBundleResponse>(_data, 'RetireBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  scheduleBundlePickup = (req: ScheduleBundlePickupRequest, headers?: object, signal?: AbortSignal): Promise<ScheduleBundlePickupResponse> => {
    return this.fetch(
      this.url('ScheduleBundlePickup'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ScheduleBundlePickupResponse>(_data, 'ScheduleBundlePickupResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  scheduleBundleDropoff = (req: ScheduleBundleDropoffRequest, headers?: object, signal?: AbortSignal): Promise<ScheduleBundleDropoffResponse> => {
    return this.fetch(
      this.url('ScheduleBundleDropoff'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ScheduleBundleDropoffResponse>(_data, 'ScheduleBundleDropoffResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchScheduledTransfer = (req: PatchScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<PatchScheduledTransferResponse> => {
    return this.fetch(
      this.url('PatchScheduledTransfer'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchScheduledTransferResponse>(_data, 'PatchScheduledTransferResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  cancelScheduledTransfer = (req: CancelScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<CancelScheduledTransferResponse> => {
    return this.fetch(
      this.url('CancelScheduledTransfer'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CancelScheduledTransferResponse>(_data, 'CancelScheduledTransferResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  disclaimScheduledTransfer = (req: DisclaimScheduledTransferRequest, headers?: object, signal?: AbortSignal): Promise<DisclaimScheduledTransferResponse> => {
    return this.fetch(
      this.url('DisclaimScheduledTransfer'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DisclaimScheduledTransferResponse>(_data, 'DisclaimScheduledTransferResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  disclaimAllMyScheduledTransfers = (headers?: object, signal?: AbortSignal): Promise<DisclaimAllMyScheduledTransfersResponse> => {
    return this.fetch(
      this.url('DisclaimAllMyScheduledTransfers'),
      createHttpRequest('{}', headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DisclaimAllMyScheduledTransfersResponse>(_data, 'DisclaimAllMyScheduledTransfersResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  startTripleg = (req: StartTriplegRequest, headers?: object, signal?: AbortSignal): Promise<StartTriplegResponse> => {
    return this.fetch(
      this.url('StartTripleg'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StartTriplegResponse>(_data, 'StartTriplegResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchTripleg = (req: PatchTriplegRequest, headers?: object, signal?: AbortSignal): Promise<PatchTriplegResponse> => {
    return this.fetch(
      this.url('PatchTripleg'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchTriplegResponse>(_data, 'PatchTriplegResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  arrive = (req: ArriveRequest, headers?: object, signal?: AbortSignal): Promise<ArriveResponse> => {
    return this.fetch(
      this.url('Arrive'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<ArriveResponse>(_data, 'ArriveResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  admit = (req: AdmitRequest, headers?: object, signal?: AbortSignal): Promise<AdmitResponse> => {
    return this.fetch(
      this.url('Admit'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AdmitResponse>(_data, 'AdmitResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  startBundleOnloading = (req: StartBundleOnloadingRequest, headers?: object, signal?: AbortSignal): Promise<StartBundleOnloadingResponse> => {
    return this.fetch(
      this.url('StartBundleOnloading'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StartBundleOnloadingResponse>(_data, 'StartBundleOnloadingResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  completeBundleOnloading = (req: CompleteBundleOnloadingRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleOnloadingResponse> => {
    return this.fetch(
      this.url('CompleteBundleOnloading'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompleteBundleOnloadingResponse>(_data, 'CompleteBundleOnloadingResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  startBundleOffloading = (req: StartBundleOffloadingRequest, headers?: object, signal?: AbortSignal): Promise<StartBundleOffloadingResponse> => {
    return this.fetch(
      this.url('StartBundleOffloading'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StartBundleOffloadingResponse>(_data, 'StartBundleOffloadingResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  completeBundleOffloading = (req: CompleteBundleOffloadingRequest, headers?: object, signal?: AbortSignal): Promise<CompleteBundleOffloadingResponse> => {
    return this.fetch(
      this.url('CompleteBundleOffloading'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<CompleteBundleOffloadingResponse>(_data, 'CompleteBundleOffloadingResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertUnit = (req: UpsertUnitRequest, headers?: object, signal?: AbortSignal): Promise<UpsertUnitResponse> => {
    return this.fetch(
      this.url('UpsertUnit'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertUnitResponse>(_data, 'UpsertUnitResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertWasteFlavor = (req: UpsertWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<UpsertWasteFlavorResponse> => {
    return this.fetch(
      this.url('UpsertWasteFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertWasteFlavorResponse>(_data, 'UpsertWasteFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchWasteFlavor = (req: PatchWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<PatchWasteFlavorResponse> => {
    return this.fetch(
      this.url('PatchWasteFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchWasteFlavorResponse>(_data, 'PatchWasteFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireWasteFlavor = (req: RetireWasteFlavorRequest, headers?: object, signal?: AbortSignal): Promise<RetireWasteFlavorResponse> => {
    return this.fetch(
      this.url('RetireWasteFlavor'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireWasteFlavorResponse>(_data, 'RetireWasteFlavorResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertWasteFlavorRecipe = (req: UpsertWasteFlavorRecipeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertWasteFlavorRecipeResponse> => {
    return this.fetch(
      this.url('UpsertWasteFlavorRecipe'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertWasteFlavorRecipeResponse>(_data, 'UpsertWasteFlavorRecipeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  deleteWasteFlavorRecipe = (req: DeleteWasteFlavorRecipeRequest, headers?: object, signal?: AbortSignal): Promise<DeleteWasteFlavorRecipeResponse> => {
    return this.fetch(
      this.url('DeleteWasteFlavorRecipe'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DeleteWasteFlavorRecipeResponse>(_data, 'DeleteWasteFlavorRecipeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertPackingMode = (req: UpsertPackingModeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertPackingModeResponse> => {
    return this.fetch(
      this.url('UpsertPackingMode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertPackingModeResponse>(_data, 'UpsertPackingModeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertManifestType = (req: UpsertManifestTypeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertManifestTypeResponse> => {
    return this.fetch(
      this.url('UpsertManifestType'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertManifestTypeResponse>(_data, 'UpsertManifestTypeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  spawnWaste = (req: SpawnWasteRequest, headers?: object, signal?: AbortSignal): Promise<SpawnWasteResponse> => {
    return this.fetch(
      this.url('SpawnWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SpawnWasteResponse>(_data, 'SpawnWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  patchWaste = (req: PatchWasteRequest, headers?: object, signal?: AbortSignal): Promise<PatchWasteResponse> => {
    return this.fetch(
      this.url('PatchWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<PatchWasteResponse>(_data, 'PatchWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  stampWaste = (req: StampWasteRequest, headers?: object, signal?: AbortSignal): Promise<StampWasteResponse> => {
    return this.fetch(
      this.url('StampWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StampWasteResponse>(_data, 'StampWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  attachWasteToBundle = (req: AttachWasteToBundleRequest, headers?: object, signal?: AbortSignal): Promise<AttachWasteToBundleResponse> => {
    return this.fetch(
      this.url('AttachWasteToBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AttachWasteToBundleResponse>(_data, 'AttachWasteToBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  attachWasteToJob = (req: AttachWasteToJobRequest, headers?: object, signal?: AbortSignal): Promise<AttachWasteToJobResponse> => {
    return this.fetch(
      this.url('AttachWasteToJob'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AttachWasteToJobResponse>(_data, 'AttachWasteToJobResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  detachWasteFromBundle = (req: DetachWasteFromBundleRequest, headers?: object, signal?: AbortSignal): Promise<DetachWasteFromBundleResponse> => {
    return this.fetch(
      this.url('DetachWasteFromBundle'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DetachWasteFromBundleResponse>(_data, 'DetachWasteFromBundleResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  storeWasteTemporary = (req: StoreWasteTemporaryRequest, headers?: object, signal?: AbortSignal): Promise<StoreWasteTemporaryResponse> => {
    return this.fetch(
      this.url('StoreWasteTemporary'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StoreWasteTemporaryResponse>(_data, 'StoreWasteTemporaryResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  storeWastePermanent = (req: StoreWastePermanentRequest, headers?: object, signal?: AbortSignal): Promise<StoreWastePermanentResponse> => {
    return this.fetch(
      this.url('StoreWastePermanent'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<StoreWastePermanentResponse>(_data, 'StoreWastePermanentResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  divideFromWaste = (req: DivideFromWasteRequest, headers?: object, signal?: AbortSignal): Promise<DivideFromWasteResponse> => {
    return this.fetch(
      this.url('DivideFromWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<DivideFromWasteResponse>(_data, 'DivideFromWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  mergeIntoWaste = (req: MergeIntoWasteRequest, headers?: object, signal?: AbortSignal): Promise<MergeIntoWasteResponse> => {
    return this.fetch(
      this.url('MergeIntoWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<MergeIntoWasteResponse>(_data, 'MergeIntoWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  retireWaste = (req: RetireWasteRequest, headers?: object, signal?: AbortSignal): Promise<RetireWasteResponse> => {
    return this.fetch(
      this.url('RetireWaste'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RetireWasteResponse>(_data, 'RetireWasteResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  upsertTransformMode = (req: UpsertTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<UpsertTransformModeResponse> => {
    return this.fetch(
      this.url('UpsertTransformMode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<UpsertTransformModeResponse>(_data, 'UpsertTransformModeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  adoptTransformMode = (req: AdoptTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<AdoptTransformModeResponse> => {
    return this.fetch(
      this.url('AdoptTransformMode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AdoptTransformModeResponse>(_data, 'AdoptTransformModeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  abandonTransformMode = (req: AbandonTransformModeRequest, headers?: object, signal?: AbortSignal): Promise<AbandonTransformModeResponse> => {
    return this.fetch(
      this.url('AbandonTransformMode'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AbandonTransformModeResponse>(_data, 'AbandonTransformModeResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  attachPhotoToStamp = (req: AttachPhotoToStampRequest, headers?: object, signal?: AbortSignal): Promise<AttachPhotoToStampResponse> => {
    return this.fetch(
      this.url('AttachPhotoToStamp'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<AttachPhotoToStampResponse>(_data, 'AttachPhotoToStampResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  rewindToCheckpoint = (req: RewindToCheckpointRequest, headers?: object, signal?: AbortSignal): Promise<RewindToCheckpointResponse> => {
    return this.fetch(
      this.url('RewindToCheckpoint'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<RewindToCheckpointResponse>(_data, 'RewindToCheckpointResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

  spawnCheckpoint = (req: SpawnCheckpointRequest, headers?: object, signal?: AbortSignal): Promise<SpawnCheckpointResponse> => {
    return this.fetch(
      this.url('SpawnCheckpoint'),
      createHttpRequest(JsonEncode(req), headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return JsonDecode<SpawnCheckpointResponse>(_data, 'SpawnCheckpointResponse')
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error instanceof Error ? error.message : String(error)}` })
    })
  }

}
  
const sseResponse = async (
    res: Response,
    options: WebrpcStreamOptions<any>,
    retryFetch: () => Promise<void>
) => {
    const {onMessage, onOpen, onClose, onError} = options;

    if (!res.ok) {
        try {
            await buildResponse(res)
        } catch (error) {
            // @ts-ignore
            onError(error, retryFetch)
        }
        return;
    }

    if (!res.body) {
        onError(
            WebrpcBadResponseError.new({
                status: res.status,
                cause: "Invalid response, missing body",
            }),
            retryFetch
        )
        return;
    }

    onOpen && onOpen()

    const reader = res.body.getReader()
    const decoder = new TextDecoder()
    let buffer = "";
    let lastReadTime = Date.now()
    const timeout = (10 + 1) * 1000;
    let timeoutError = false
    const intervalId = setInterval(() => {
        if (Date.now() - lastReadTime > timeout) {
          timeoutError = true
          clearInterval(intervalId)
          reader.releaseLock()
        }
    }, timeout)

    while (true) {
        let value;
        let done;
        try {
            ({value, done} = await reader.read())
            if (timeoutError) throw new Error("Timeout, no data or heartbeat received")
            lastReadTime = Date.now()
            buffer += decoder.decode(value, {stream: true})
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") {
                onError(
                    WebrpcClientAbortedError.new({
                        message: "AbortError",
                        cause: `AbortError: ${error instanceof Error ? error.message : String(error)}`,
                    }),
                    () => {
                        throw new Error("Abort signal cannot be used to reconnect")
                    }
                )
            } else {
                onError(
                    WebrpcStreamLostError.new({
                        cause: `reader.read(): ${error instanceof Error ? error.message : String(error)}`,
                    }),
                    retryFetch
                )
            }
            return;
        }

        let lines = buffer.split("\n")
        for (let i = 0; i < lines.length - 1; i++) {
            const line = lines[i];
            if (!line || line.length === 0) {
                continue;
            }
            let data: any;
            try {
                data = JSON.parse(line)
                if (data.hasOwnProperty("webrpcError")) {
                    const error = data.webrpcError;
                    const code: number =
                        typeof error.code === "number" ? error.code : 0;
                    onError(
                        (webrpcErrorByCode[code] || WebrpcError).new(error),
                        retryFetch
                    )
                    return;
                }
            } catch (error) {
                if (
                    error instanceof Error &&
                    error.message === "Abort signal cannot be used to reconnect"
                ) {
                    throw error;
                }
                onError(
                    WebrpcBadResponseError.new({
                        status: res.status,
                        cause: `JSON.parse(): ${error instanceof Error ? error.message : String(error)}`,
                    }),
                    retryFetch
                )
            }
            onMessage(data)
        }

        if (!done) {
            const lastLine = lines[lines.length - 1];
            buffer = lastLine || "";
            continue;
        }

        onClose && onClose()
        return;
    }
};





/** TQK **/
import {queryOptions, Query, DefaultError, QueryClient, QueryKey,
	useQueries, skipToken} from "@tanstack/react-query";
import {mergeUseQueriesWithInfill} from "../tq/mergeUseQueriesWithInfill.tsx";
import {NADA} from "../util/arutil.tsx";
import {pendingUseResult} from "../util/hookutil.tsx";
import {useRefreshableInfallibleQuery, useRefreshSet} from "../util/tqrefresh.tsx";
import {isDeepEqual} from "remeda";
import {useEffect, useState, createContext, useContext} from "react";
import {isAfter} from "date-fns";


export type VerbedQueryKey = [string, ...unknown[]];

export interface TqCacheUpdate<T> {
	query: Query<T, DefaultError, T, VerbedQueryKey>;
	data: T | undefined;
	dataUpdatedAt?: number;
	manual?: boolean;
}

export type TqCacheListener<T> = (event: TqCacheUpdate<T>) => void;

export type TqCacheSpyEntry<T> = [string, TqCacheListener<T>];

const TQDEADBEEF = "TQDEADBEEF";

const TQDEADBEEF_KEY = [TQDEADBEEF];

export const DEADBEEF_QUERY_OPTS = queryOptions({
    queryKey: TQDEADBEEF_KEY,
    queryFn: skipToken,
    initialData: TQDEADBEEF,
});

export const KingBasuraMamaContext = createContext<KingBasura>({} as KingBasura);

export function useKingBasuraMothership() {
    const rv = useContext(KingBasuraMamaContext);
    return rv;
}
// TQMLOOPTOP
// TQK IN

export const pingVerb = "Ping";

export const pingTqk = [pingVerb] as const;
// TQK OUT
// TQP IN

export function ensurePing({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: pingTqk,
        queryFn: () => 
mama.ping(),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// Ping takes no args
export function pingTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: pingTqk,
        queryFn: () => 
mama.ping(),
        throwOnError: true,
        
    });
}

export function usePing() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(pingTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const loginVerb = "Login";

export function loginTqk(args?: LoginRequest) {
    return args ? [loginVerb, args] as const : [loginVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLogin({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LoginRequest}) {
    return tqc.ensureQueryData({
        queryKey: loginTqk(args),
        queryFn: () => 
mama.login(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// Login can take args
export function loginTqo(mama: KingBasura, args ?: LoginRequest) {
    return queryOptions({
        queryKey: loginTqk(args),
        queryFn: args
            ? () => 
mama.login(args)
            : skipToken,
        throwOnError: true,
        select: (data: LoginResponse) => data.jwt,
    });
}

export function useLogin(args ?: LoginRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(loginTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const refreshAuthTokenVerb = "RefreshAuthToken";

export const refreshAuthTokenTqk = [refreshAuthTokenVerb] as const;
// TQK OUT
// TQP IN

export function ensureRefreshAuthToken({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: refreshAuthTokenTqk,
        queryFn: () => 
mama.refreshAuthToken(),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// RefreshAuthToken takes no args
export function refreshAuthTokenTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: refreshAuthTokenTqk,
        queryFn: () => 
mama.refreshAuthToken(),
        throwOnError: true,
        select: (data: RefreshAuthTokenResponse) => data.jwt,
    });
}

export function useRefreshAuthToken() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(refreshAuthTokenTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const selfVerb = "Self";

export const selfTqk = [selfVerb] as const;
// TQK OUT
// TQP IN

export function ensureSelf({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: selfTqk,
        queryFn: () => 
mama.self(),
    });
}
// TQP OUT
// TQOTOP
// SelfResult is not a stub
// Self takes no args
export function selfTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: selfTqk,
        queryFn: () => 
mama.self(),
        throwOnError: true,
        select: (data: SelfResponse) => data.srv,
    });
}

export function useSelf() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(selfTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const logoutVerb = "Logout";

export const logoutTqk = [logoutVerb] as const;
// TQK OUT
// TQP IN

export function ensureLogout({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: logoutTqk,
        queryFn: () => 
mama.logout(),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// Logout takes no args
export function logoutTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: logoutTqk,
        queryFn: () => 
mama.logout(),
        throwOnError: true,
        
    });
}

export function useLogout() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(logoutTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const getSystemConfigVerb = "GetSystemConfig";

export const getSystemConfigTqk = [getSystemConfigVerb] as const;
// TQK OUT
// TQP IN

export function ensureGetSystemConfig({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: getSystemConfigTqk,
        queryFn: () => 
mama.getSystemConfig(),
    });
}
// TQP OUT
// TQOTOP
// SystemConfig is not a stub
// GetSystemConfig takes no args
export function getSystemConfigTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: getSystemConfigTqk,
        queryFn: () => 
mama.getSystemConfig(),
        throwOnError: true,
        select: (data: GetSystemConfigResponse) => data.config,
    });
}

export function useGetSystemConfig() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(getSystemConfigTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const getVersionInfoVerb = "GetVersionInfo";

export const getVersionInfoTqk = [getVersionInfoVerb] as const;
// TQK OUT
// TQP IN

export function ensureGetVersionInfo({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: getVersionInfoTqk,
        queryFn: () => 
mama.getVersionInfo(),
    });
}
// TQP OUT
// TQOTOP
// VersionInfo is not a stub
// GetVersionInfo takes no args
export function getVersionInfoTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: getVersionInfoTqk,
        queryFn: () => 
mama.getVersionInfo(),
        throwOnError: true,
        select: (data: GetVersionInfoResponse) => data.vinfo,
    });
}

export function useGetVersionInfo() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(getVersionInfoTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companyByIdVerb = "CompanyById";
export type CompanyByIdRequest = WatchCompanyByIdRequest;

export function companyByIdTqk(args?: CompanyByIdRequest) {
    return args ? [companyByIdVerb, args] as const : [companyByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompanyById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompanyByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: companyByIdTqk(args),
        queryFn: () => 
mama.watchCompanyById(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// CompanyById can take args
export function watchCompanyByIdTqo(mama: KingBasura, args ?: CompanyByIdRequest) {
    return queryOptions({
        queryKey: companyByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchCompanyById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchCompanyByIdResponse) => data.company,
    });
}

export function useCompanyById(args ?: CompanyByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchCompanyByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidCompanyByIdVerb = "LastValidCompanyById";

export function lastValidCompanyByIdTqk(args?: LastValidCompanyByIdRequest) {
    return args ? [lastValidCompanyByIdVerb, args] as const : [lastValidCompanyByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidCompanyById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidCompanyByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidCompanyByIdTqk(args),
        queryFn: () => 
mama.lastValidCompanyById(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// LastValidCompanyById can take args
export function lastValidCompanyByIdTqo(mama: KingBasura, args ?: LastValidCompanyByIdRequest) {
    return queryOptions({
        queryKey: lastValidCompanyByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidCompanyById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidCompanyByIdResponse) => data.company,
    });
}

export function useLastValidCompanyById(args ?: LastValidCompanyByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidCompanyByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companyByIdAsofVerb = "CompanyByIdAsof";

export function companyByIdAsofTqk(args?: CompanyByIdAsofRequest) {
    return args ? [companyByIdAsofVerb, args] as const : [companyByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompanyByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompanyByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: companyByIdAsofTqk(args),
        queryFn: () => 
mama.companyByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// CompanyByIdAsof can take args
export function companyByIdAsofTqo(mama: KingBasura, args ?: CompanyByIdAsofRequest) {
    return queryOptions({
        queryKey: companyByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.companyByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompanyByIdAsofResponse) => data.company,
    });
}

export function useCompanyByIdAsof(args ?: CompanyByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(companyByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companyRevisionCountVerb = "CompanyRevisionCount";

export function companyRevisionCountTqk(args?: CompanyRevisionCountRequest) {
    return args ? [companyRevisionCountVerb, args] as const : [companyRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompanyRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompanyRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: companyRevisionCountTqk(args),
        queryFn: () => 
mama.companyRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// CompanyRevisionCount can take args
export function companyRevisionCountTqo(mama: KingBasura, args ?: CompanyRevisionCountRequest) {
    return queryOptions({
        queryKey: companyRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.companyRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompanyRevisionCountResponse) => data.revisionCount,
    });
}

export function useCompanyRevisionCount(args ?: CompanyRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(companyRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allCompanyRevisionsVerb = "AllCompanyRevisions";

export function allCompanyRevisionsTqk(args?: AllCompanyRevisionsRequest) {
    return args ? [allCompanyRevisionsVerb, args] as const : [allCompanyRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllCompanyRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllCompanyRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allCompanyRevisionsTqk(args),
        queryFn: () => 
mama.allCompanyRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// AllCompanyRevisions can take args
export function allCompanyRevisionsTqo(mama: KingBasura, args ?: AllCompanyRevisionsRequest) {
    return queryOptions({
        queryKey: allCompanyRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allCompanyRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllCompanyRevisionsResponse) => data.revisions,
    });
}

export function useAllCompanyRevisions(args ?: AllCompanyRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allCompanyRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companyByCodeVerb = "CompanyByCode";
export type CompanyByCodeRequest = WatchCompanyByCodeRequest;

export function companyByCodeTqk(args?: CompanyByCodeRequest) {
    return args ? [companyByCodeVerb, args] as const : [companyByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompanyByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompanyByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: companyByCodeTqk(args),
        queryFn: () => 
mama.watchCompanyByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// CompanyByCode can take args
export function watchCompanyByCodeTqo(mama: KingBasura, args ?: CompanyByCodeRequest) {
    return queryOptions({
        queryKey: companyByCodeTqk(args),
        queryFn: args
            ? () => 
mama.watchCompanyByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchCompanyByCodeResponse) => data.company,
    });
}

export function useCompanyByCode(args ?: CompanyByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchCompanyByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidCompanyByCodeVerb = "LastValidCompanyByCode";

export function lastValidCompanyByCodeTqk(args?: LastValidCompanyByCodeRequest) {
    return args ? [lastValidCompanyByCodeVerb, args] as const : [lastValidCompanyByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidCompanyByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidCompanyByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidCompanyByCodeTqk(args),
        queryFn: () => 
mama.lastValidCompanyByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// LastValidCompanyByCode can take args
export function lastValidCompanyByCodeTqo(mama: KingBasura, args ?: LastValidCompanyByCodeRequest) {
    return queryOptions({
        queryKey: lastValidCompanyByCodeTqk(args),
        queryFn: args
            ? () => 
mama.lastValidCompanyByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidCompanyByCodeResponse) => data.company,
    });
}

export function useLastValidCompanyByCode(args ?: LastValidCompanyByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidCompanyByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companyByCodeAsofVerb = "CompanyByCodeAsof";

export function companyByCodeAsofTqk(args?: CompanyByCodeAsofRequest) {
    return args ? [companyByCodeAsofVerb, args] as const : [companyByCodeAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompanyByCodeAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompanyByCodeAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: companyByCodeAsofTqk(args),
        queryFn: () => 
mama.companyByCodeAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// CompanyByCodeAsof can take args
export function companyByCodeAsofTqo(mama: KingBasura, args ?: CompanyByCodeAsofRequest) {
    return queryOptions({
        queryKey: companyByCodeAsofTqk(args),
        queryFn: args
            ? () => 
mama.companyByCodeAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompanyByCodeAsofResponse) => data.company,
    });
}

export function useCompanyByCodeAsof(args ?: CompanyByCodeAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(companyByCodeAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const companiesByNameFragmentVerb = "CompaniesByNameFragment";
export type CompaniesByNameFragmentRequest = WatchCompaniesByNameFragmentRequest;

export function companiesByNameFragmentTqk(args?: CompaniesByNameFragmentRequest) {
    return args ? [companiesByNameFragmentVerb, args] as const : [companiesByNameFragmentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompaniesByNameFragment({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompaniesByNameFragmentRequest}) {
    return tqc.ensureQueryData({
        queryKey: companiesByNameFragmentTqk(args),
        queryFn: () => 
mama.watchCompaniesByNameFragment(args),
    });
}

export function ensureFullCompaniesByNameFragment({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompaniesByNameFragmentRequest}) {
    return ensureCompaniesByNameFragment({tqc, mama, args}).then(tqrv => Promise.all(tqrv.companies.map(stub => ensureCompanyById({tqc, mama, args: {companyId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []CompanyStub is a stub
// []CompanyStub is a slice
// CompaniesByNameFragment can take arguments
export function watchCompaniesByNameFragmentTqo(mama: KingBasura, args?: CompaniesByNameFragmentRequest) {
    return queryOptions({
        queryKey: companiesByNameFragmentTqk(args),
        queryFn: args
            ? () => 
mama.watchCompaniesByNameFragment(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchCompaniesByNameFragmentResponse) => data.companies,
    });
}

export function useCompaniesByNameFragment(args?: CompaniesByNameFragmentRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchCompaniesByNameFragmentTqo(mama, args));
}
export function useFullCompaniesByNameFragment(args?: CompaniesByNameFragmentRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useCompaniesByNameFragment(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {companyId: stub.id} as const;
        return {
            queryKey: companyByIdTqk(ribRequest),
            queryFn: () => mama.watchCompanyById(ribRequest),
            select: (data: WatchCompanyByIdResponse) => data.company,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByIdVerb = "VenueById";
export type VenueByIdRequest = WatchVenueByIdRequest;

export function venueByIdTqk(args?: VenueByIdRequest) {
    return args ? [venueByIdVerb, args] as const : [venueByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByIdTqk(args),
        queryFn: () => 
mama.watchVenueById(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueById can take args
export function watchVenueByIdTqo(mama: KingBasura, args ?: VenueByIdRequest) {
    return queryOptions({
        queryKey: venueByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchVenueById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchVenueByIdResponse) => data.venue,
    });
}

export function useVenueById(args ?: VenueByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchVenueByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidVenueByIdVerb = "LastValidVenueById";

export function lastValidVenueByIdTqk(args?: LastValidVenueByIdRequest) {
    return args ? [lastValidVenueByIdVerb, args] as const : [lastValidVenueByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidVenueById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidVenueByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidVenueByIdTqk(args),
        queryFn: () => 
mama.lastValidVenueById(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// LastValidVenueById can take args
export function lastValidVenueByIdTqo(mama: KingBasura, args ?: LastValidVenueByIdRequest) {
    return queryOptions({
        queryKey: lastValidVenueByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidVenueById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidVenueByIdResponse) => data.venue,
    });
}

export function useLastValidVenueById(args ?: LastValidVenueByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidVenueByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByIdAsofVerb = "VenueByIdAsof";

export function venueByIdAsofTqk(args?: VenueByIdAsofRequest) {
    return args ? [venueByIdAsofVerb, args] as const : [venueByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByIdAsofTqk(args),
        queryFn: () => 
mama.venueByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueByIdAsof can take args
export function venueByIdAsofTqo(mama: KingBasura, args ?: VenueByIdAsofRequest) {
    return queryOptions({
        queryKey: venueByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.venueByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: VenueByIdAsofResponse) => data.venue,
    });
}

export function useVenueByIdAsof(args ?: VenueByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(venueByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueRevisionCountVerb = "VenueRevisionCount";

export function venueRevisionCountTqk(args?: VenueRevisionCountRequest) {
    return args ? [venueRevisionCountVerb, args] as const : [venueRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueRevisionCountTqk(args),
        queryFn: () => 
mama.venueRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// VenueRevisionCount can take args
export function venueRevisionCountTqo(mama: KingBasura, args ?: VenueRevisionCountRequest) {
    return queryOptions({
        queryKey: venueRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.venueRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: VenueRevisionCountResponse) => data.revisionCount,
    });
}

export function useVenueRevisionCount(args ?: VenueRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(venueRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allVenueRevisionsVerb = "AllVenueRevisions";

export function allVenueRevisionsTqk(args?: AllVenueRevisionsRequest) {
    return args ? [allVenueRevisionsVerb, args] as const : [allVenueRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllVenueRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllVenueRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allVenueRevisionsTqk(args),
        queryFn: () => 
mama.allVenueRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// AllVenueRevisions can take args
export function allVenueRevisionsTqo(mama: KingBasura, args ?: AllVenueRevisionsRequest) {
    return queryOptions({
        queryKey: allVenueRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allVenueRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllVenueRevisionsResponse) => data.revisions,
    });
}

export function useAllVenueRevisions(args ?: AllVenueRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allVenueRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const admittersOnDutyForVenueVerb = "AdmittersOnDutyForVenue";
export type AdmittersOnDutyForVenueRequest = WatchAdmittersOnDutyForVenueRequest;

export function admittersOnDutyForVenueTqk(args?: AdmittersOnDutyForVenueRequest) {
    return args ? [admittersOnDutyForVenueVerb, args] as const : [admittersOnDutyForVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAdmittersOnDutyForVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AdmittersOnDutyForVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: admittersOnDutyForVenueTqk(args),
        queryFn: () => 
mama.watchAdmittersOnDutyForVenue(args),
    });
}

export function ensureFullAdmittersOnDutyForVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AdmittersOnDutyForVenueRequest}) {
    return ensureAdmittersOnDutyForVenue({tqc, mama, args}).then(tqrv => Promise.all(tqrv.admitters.map(stub => ensureAgentById({tqc, mama, args: {agentId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []AgentStub is a stub
// []AgentStub is a slice
// AdmittersOnDutyForVenue can take arguments
export function watchAdmittersOnDutyForVenueTqo(mama: KingBasura, args?: AdmittersOnDutyForVenueRequest) {
    return queryOptions({
        queryKey: admittersOnDutyForVenueTqk(args),
        queryFn: args
            ? () => 
mama.watchAdmittersOnDutyForVenue(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchAdmittersOnDutyForVenueResponse) => data.admitters,
    });
}

export function useAdmittersOnDutyForVenue(args?: AdmittersOnDutyForVenueRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAdmittersOnDutyForVenueTqo(mama, args));
}
export function useFullAdmittersOnDutyForVenue(args?: AdmittersOnDutyForVenueRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useAdmittersOnDutyForVenue(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {agentId: stub.id} as const;
        return {
            queryKey: agentByIdTqk(ribRequest),
            queryFn: () => mama.watchAgentById(ribRequest),
            select: (data: WatchAgentByIdResponse) => data.agent,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByCodeVerb = "VenueByCode";
export type VenueByCodeRequest = WatchVenueByCodeRequest;

export function venueByCodeTqk(args?: VenueByCodeRequest) {
    return args ? [venueByCodeVerb, args] as const : [venueByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByCodeTqk(args),
        queryFn: () => 
mama.watchVenueByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueByCode can take args
export function watchVenueByCodeTqo(mama: KingBasura, args ?: VenueByCodeRequest) {
    return queryOptions({
        queryKey: venueByCodeTqk(args),
        queryFn: args
            ? () => 
mama.watchVenueByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchVenueByCodeResponse) => data.venue,
    });
}

export function useVenueByCode(args ?: VenueByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchVenueByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidVenueByCodeVerb = "LastValidVenueByCode";

export function lastValidVenueByCodeTqk(args?: LastValidVenueByCodeRequest) {
    return args ? [lastValidVenueByCodeVerb, args] as const : [lastValidVenueByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidVenueByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidVenueByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidVenueByCodeTqk(args),
        queryFn: () => 
mama.lastValidVenueByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// LastValidVenueByCode can take args
export function lastValidVenueByCodeTqo(mama: KingBasura, args ?: LastValidVenueByCodeRequest) {
    return queryOptions({
        queryKey: lastValidVenueByCodeTqk(args),
        queryFn: args
            ? () => 
mama.lastValidVenueByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidVenueByCodeResponse) => data.venue,
    });
}

export function useLastValidVenueByCode(args ?: LastValidVenueByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidVenueByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByCodeAsofVerb = "VenueByCodeAsof";

export function venueByCodeAsofTqk(args?: VenueByCodeAsofRequest) {
    return args ? [venueByCodeAsofVerb, args] as const : [venueByCodeAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueByCodeAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByCodeAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByCodeAsofTqk(args),
        queryFn: () => 
mama.venueByCodeAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueByCodeAsof can take args
export function venueByCodeAsofTqo(mama: KingBasura, args ?: VenueByCodeAsofRequest) {
    return queryOptions({
        queryKey: venueByCodeAsofTqk(args),
        queryFn: args
            ? () => 
mama.venueByCodeAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: VenueByCodeAsofResponse) => data.venue,
    });
}

export function useVenueByCodeAsof(args ?: VenueByCodeAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(venueByCodeAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByNameVerb = "VenueByName";
export type VenueByNameRequest = WatchVenueByNameRequest;

export function venueByNameTqk(args?: VenueByNameRequest) {
    return args ? [venueByNameVerb, args] as const : [venueByNameVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueByName({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByNameRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByNameTqk(args),
        queryFn: () => 
mama.watchVenueByName(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueByName can take args
export function watchVenueByNameTqo(mama: KingBasura, args ?: VenueByNameRequest) {
    return queryOptions({
        queryKey: venueByNameTqk(args),
        queryFn: args
            ? () => 
mama.watchVenueByName(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchVenueByNameResponse) => data.venue,
    });
}

export function useVenueByName(args ?: VenueByNameRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchVenueByNameTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidVenueByNameVerb = "LastValidVenueByName";

export function lastValidVenueByNameTqk(args?: LastValidVenueByNameRequest) {
    return args ? [lastValidVenueByNameVerb, args] as const : [lastValidVenueByNameVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidVenueByName({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidVenueByNameRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidVenueByNameTqk(args),
        queryFn: () => 
mama.lastValidVenueByName(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// LastValidVenueByName can take args
export function lastValidVenueByNameTqo(mama: KingBasura, args ?: LastValidVenueByNameRequest) {
    return queryOptions({
        queryKey: lastValidVenueByNameTqk(args),
        queryFn: args
            ? () => 
mama.lastValidVenueByName(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidVenueByNameResponse) => data.venue,
    });
}

export function useLastValidVenueByName(args ?: LastValidVenueByNameRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidVenueByNameTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const venueByNameAsofVerb = "VenueByNameAsof";

export function venueByNameAsofTqk(args?: VenueByNameAsofRequest) {
    return args ? [venueByNameAsofVerb, args] as const : [venueByNameAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureVenueByNameAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: VenueByNameAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: venueByNameAsofTqk(args),
        queryFn: () => 
mama.venueByNameAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// VenueByNameAsof can take args
export function venueByNameAsofTqo(mama: KingBasura, args ?: VenueByNameAsofRequest) {
    return queryOptions({
        queryKey: venueByNameAsofTqk(args),
        queryFn: args
            ? () => 
mama.venueByNameAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: VenueByNameAsofResponse) => data.venue,
    });
}

export function useVenueByNameAsof(args ?: VenueByNameAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(venueByNameAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const downstreamVenuesVerb = "DownstreamVenues";

export const downstreamVenuesTqk = [downstreamVenuesVerb] as const;
// TQK OUT
// TQP IN

export function ensureDownstreamVenues({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: downstreamVenuesTqk,
        queryFn: () => 
mama.downstreamVenues(),
    });
}

export function ensureFullDownstreamVenues({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureDownstreamVenues({tqc, mama}).then(tqrv => Promise.all(tqrv.venues.map(stub => ensureVenueById({tqc, mama, args: {venueId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []VenueStub is a stub
// []VenueStub is a slice
// DownstreamVenues takes no args
export function downstreamVenuesTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: downstreamVenuesTqk,
        queryFn: () => 
mama.downstreamVenues(),
        throwOnError: true,
        select: (data: DownstreamVenuesResponse) => data.venues,
});
}

export function useDownstreamVenues() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(downstreamVenuesTqo(mama));
}

export function useFullDownstreamVenues() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useDownstreamVenues();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {venueId: stub.id} as const;
        return {
            queryKey: venueByIdTqk(ribRequest),
            queryFn: () => mama.watchVenueById(ribRequest),
            select: (data: WatchVenueByIdResponse) => data.venue,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const trucksDockedAtVerb = "TrucksDockedAt";
export type TrucksDockedAtRequest = WatchTrucksDockedAtRequest;

export function trucksDockedAtTqk(args?: TrucksDockedAtRequest) {
    return args ? [trucksDockedAtVerb, args] as const : [trucksDockedAtVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTrucksDockedAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TrucksDockedAtRequest}) {
    return tqc.ensureQueryData({
        queryKey: trucksDockedAtTqk(args),
        queryFn: () => 
mama.watchTrucksDockedAt(args),
    });
}

export function ensureFullTrucksDockedAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TrucksDockedAtRequest}) {
    return ensureTrucksDockedAt({tqc, mama, args}).then(tqrv => Promise.all(tqrv.trucks.map(stub => ensureTruckById({tqc, mama, args: {truckId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TruckStub is a stub
// []TruckStub is a slice
// TrucksDockedAt can take arguments
export function watchTrucksDockedAtTqo(mama: KingBasura, args?: TrucksDockedAtRequest) {
    return queryOptions({
        queryKey: trucksDockedAtTqk(args),
        queryFn: args
            ? () => 
mama.watchTrucksDockedAt(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchTrucksDockedAtResponse) => data.trucks,
    });
}

export function useTrucksDockedAt(args?: TrucksDockedAtRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTrucksDockedAtTqo(mama, args));
}
export function useFullTrucksDockedAt(args?: TrucksDockedAtRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTrucksDockedAt(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {truckId: stub.id} as const;
        return {
            queryKey: truckByIdTqk(ribRequest),
            queryFn: () => mama.watchTruckById(ribRequest),
            select: (data: WatchTruckByIdResponse) => data.truck,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByIdVerb = "AgentById";
export type AgentByIdRequest = WatchAgentByIdRequest;

export function agentByIdTqk(args?: AgentByIdRequest) {
    return args ? [agentByIdVerb, args] as const : [agentByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByIdTqk(args),
        queryFn: () => 
mama.watchAgentById(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentById can take args
export function watchAgentByIdTqo(mama: KingBasura, args ?: AgentByIdRequest) {
    return queryOptions({
        queryKey: agentByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchAgentById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAgentByIdResponse) => data.agent,
    });
}

export function useAgentById(args ?: AgentByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAgentByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidAgentByIdVerb = "LastValidAgentById";

export function lastValidAgentByIdTqk(args?: LastValidAgentByIdRequest) {
    return args ? [lastValidAgentByIdVerb, args] as const : [lastValidAgentByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidAgentById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidAgentByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidAgentByIdTqk(args),
        queryFn: () => 
mama.lastValidAgentById(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// LastValidAgentById can take args
export function lastValidAgentByIdTqo(mama: KingBasura, args ?: LastValidAgentByIdRequest) {
    return queryOptions({
        queryKey: lastValidAgentByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidAgentById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidAgentByIdResponse) => data.agent,
    });
}

export function useLastValidAgentById(args ?: LastValidAgentByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidAgentByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByIdAsofVerb = "AgentByIdAsof";

export function agentByIdAsofTqk(args?: AgentByIdAsofRequest) {
    return args ? [agentByIdAsofVerb, args] as const : [agentByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByIdAsofTqk(args),
        queryFn: () => 
mama.agentByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByIdAsof can take args
export function agentByIdAsofTqo(mama: KingBasura, args ?: AgentByIdAsofRequest) {
    return queryOptions({
        queryKey: agentByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.agentByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentByIdAsofResponse) => data.agent,
    });
}

export function useAgentByIdAsof(args ?: AgentByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentRevisionCountVerb = "AgentRevisionCount";

export function agentRevisionCountTqk(args?: AgentRevisionCountRequest) {
    return args ? [agentRevisionCountVerb, args] as const : [agentRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentRevisionCountTqk(args),
        queryFn: () => 
mama.agentRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// AgentRevisionCount can take args
export function agentRevisionCountTqo(mama: KingBasura, args ?: AgentRevisionCountRequest) {
    return queryOptions({
        queryKey: agentRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.agentRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentRevisionCountResponse) => data.revisionCount,
    });
}

export function useAgentRevisionCount(args ?: AgentRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allAgentRevisionsVerb = "AllAgentRevisions";

export function allAgentRevisionsTqk(args?: AllAgentRevisionsRequest) {
    return args ? [allAgentRevisionsVerb, args] as const : [allAgentRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllAgentRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllAgentRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allAgentRevisionsTqk(args),
        queryFn: () => 
mama.allAgentRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AllAgentRevisions can take args
export function allAgentRevisionsTqo(mama: KingBasura, args ?: AllAgentRevisionsRequest) {
    return queryOptions({
        queryKey: allAgentRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allAgentRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllAgentRevisionsResponse) => data.revisions,
    });
}

export function useAllAgentRevisions(args ?: AllAgentRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allAgentRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByCodeVerb = "AgentByCode";
export type AgentByCodeRequest = WatchAgentByCodeRequest;

export function agentByCodeTqk(args?: AgentByCodeRequest) {
    return args ? [agentByCodeVerb, args] as const : [agentByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByCodeTqk(args),
        queryFn: () => 
mama.watchAgentByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByCode can take args
export function watchAgentByCodeTqo(mama: KingBasura, args ?: AgentByCodeRequest) {
    return queryOptions({
        queryKey: agentByCodeTqk(args),
        queryFn: args
            ? () => 
mama.watchAgentByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAgentByCodeResponse) => data.agent,
    });
}

export function useAgentByCode(args ?: AgentByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAgentByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidAgentByCodeVerb = "LastValidAgentByCode";

export function lastValidAgentByCodeTqk(args?: LastValidAgentByCodeRequest) {
    return args ? [lastValidAgentByCodeVerb, args] as const : [lastValidAgentByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidAgentByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidAgentByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidAgentByCodeTqk(args),
        queryFn: () => 
mama.lastValidAgentByCode(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// LastValidAgentByCode can take args
export function lastValidAgentByCodeTqo(mama: KingBasura, args ?: LastValidAgentByCodeRequest) {
    return queryOptions({
        queryKey: lastValidAgentByCodeTqk(args),
        queryFn: args
            ? () => 
mama.lastValidAgentByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidAgentByCodeResponse) => data.agent,
    });
}

export function useLastValidAgentByCode(args ?: LastValidAgentByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidAgentByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByCodeAsofVerb = "AgentByCodeAsof";

export function agentByCodeAsofTqk(args?: AgentByCodeAsofRequest) {
    return args ? [agentByCodeAsofVerb, args] as const : [agentByCodeAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByCodeAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByCodeAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByCodeAsofTqk(args),
        queryFn: () => 
mama.agentByCodeAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByCodeAsof can take args
export function agentByCodeAsofTqo(mama: KingBasura, args ?: AgentByCodeAsofRequest) {
    return queryOptions({
        queryKey: agentByCodeAsofTqk(args),
        queryFn: args
            ? () => 
mama.agentByCodeAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentByCodeAsofResponse) => data.agent,
    });
}

export function useAgentByCodeAsof(args ?: AgentByCodeAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentByCodeAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByNameVerb = "AgentByName";
export type AgentByNameRequest = WatchAgentByNameRequest;

export function agentByNameTqk(args?: AgentByNameRequest) {
    return args ? [agentByNameVerb, args] as const : [agentByNameVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByName({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByNameRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByNameTqk(args),
        queryFn: () => 
mama.watchAgentByName(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByName can take args
export function watchAgentByNameTqo(mama: KingBasura, args ?: AgentByNameRequest) {
    return queryOptions({
        queryKey: agentByNameTqk(args),
        queryFn: args
            ? () => 
mama.watchAgentByName(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAgentByNameResponse) => data.agent,
    });
}

export function useAgentByName(args ?: AgentByNameRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAgentByNameTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidAgentByNameVerb = "LastValidAgentByName";

export function lastValidAgentByNameTqk(args?: LastValidAgentByNameRequest) {
    return args ? [lastValidAgentByNameVerb, args] as const : [lastValidAgentByNameVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidAgentByName({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidAgentByNameRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidAgentByNameTqk(args),
        queryFn: () => 
mama.lastValidAgentByName(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// LastValidAgentByName can take args
export function lastValidAgentByNameTqo(mama: KingBasura, args ?: LastValidAgentByNameRequest) {
    return queryOptions({
        queryKey: lastValidAgentByNameTqk(args),
        queryFn: args
            ? () => 
mama.lastValidAgentByName(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidAgentByNameResponse) => data.agent,
    });
}

export function useLastValidAgentByName(args ?: LastValidAgentByNameRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidAgentByNameTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByNameAsofVerb = "AgentByNameAsof";

export function agentByNameAsofTqk(args?: AgentByNameAsofRequest) {
    return args ? [agentByNameAsofVerb, args] as const : [agentByNameAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByNameAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByNameAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByNameAsofTqk(args),
        queryFn: () => 
mama.agentByNameAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByNameAsof can take args
export function agentByNameAsofTqo(mama: KingBasura, args ?: AgentByNameAsofRequest) {
    return queryOptions({
        queryKey: agentByNameAsofTqk(args),
        queryFn: args
            ? () => 
mama.agentByNameAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentByNameAsofResponse) => data.agent,
    });
}

export function useAgentByNameAsof(args ?: AgentByNameAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentByNameAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByLoginVerb = "AgentByLogin";
export type AgentByLoginRequest = WatchAgentByLoginRequest;

export function agentByLoginTqk(args?: AgentByLoginRequest) {
    return args ? [agentByLoginVerb, args] as const : [agentByLoginVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByLogin({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByLoginRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByLoginTqk(args),
        queryFn: () => 
mama.watchAgentByLogin(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByLogin can take args
export function watchAgentByLoginTqo(mama: KingBasura, args ?: AgentByLoginRequest) {
    return queryOptions({
        queryKey: agentByLoginTqk(args),
        queryFn: args
            ? () => 
mama.watchAgentByLogin(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAgentByLoginResponse) => data.agent,
    });
}

export function useAgentByLogin(args ?: AgentByLoginRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAgentByLoginTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidAgentByLoginVerb = "LastValidAgentByLogin";

export function lastValidAgentByLoginTqk(args?: LastValidAgentByLoginRequest) {
    return args ? [lastValidAgentByLoginVerb, args] as const : [lastValidAgentByLoginVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidAgentByLogin({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidAgentByLoginRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidAgentByLoginTqk(args),
        queryFn: () => 
mama.lastValidAgentByLogin(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// LastValidAgentByLogin can take args
export function lastValidAgentByLoginTqo(mama: KingBasura, args ?: LastValidAgentByLoginRequest) {
    return queryOptions({
        queryKey: lastValidAgentByLoginTqk(args),
        queryFn: args
            ? () => 
mama.lastValidAgentByLogin(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidAgentByLoginResponse) => data.agent,
    });
}

export function useLastValidAgentByLogin(args ?: LastValidAgentByLoginRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidAgentByLoginTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentByLoginAsofVerb = "AgentByLoginAsof";

export function agentByLoginAsofTqk(args?: AgentByLoginAsofRequest) {
    return args ? [agentByLoginAsofVerb, args] as const : [agentByLoginAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentByLoginAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentByLoginAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentByLoginAsofTqk(args),
        queryFn: () => 
mama.agentByLoginAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// AgentByLoginAsof can take args
export function agentByLoginAsofTqo(mama: KingBasura, args ?: AgentByLoginAsofRequest) {
    return queryOptions({
        queryKey: agentByLoginAsofTqk(args),
        queryFn: args
            ? () => 
mama.agentByLoginAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentByLoginAsofResponse) => data.agent,
    });
}

export function useAgentByLoginAsof(args ?: AgentByLoginAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentByLoginAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentStampByIdVerb = "AgentStampById";

export function agentStampByIdTqk(args?: AgentStampByIdRequest) {
    return args ? [agentStampByIdVerb, args] as const : [agentStampByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentStampById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentStampByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentStampByIdTqk(args),
        queryFn: () => 
mama.agentStampById(args),
    });
}
// TQP OUT
// TQOTOP
// AgentStamp is not a stub
// AgentStampById can take args
export function agentStampByIdTqo(mama: KingBasura, args ?: AgentStampByIdRequest) {
    return queryOptions({
        queryKey: agentStampByIdTqk(args),
        queryFn: args
            ? () => 
mama.agentStampById(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentStampByIdResponse) => data.stamp,
    });
}

export function useAgentStampById(args ?: AgentStampByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentStampByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastFlavoredStampForAgentVerb = "LastFlavoredStampForAgent";

export function lastFlavoredStampForAgentTqk(args?: LastFlavoredStampForAgentRequest) {
    return args ? [lastFlavoredStampForAgentVerb, args] as const : [lastFlavoredStampForAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastFlavoredStampForAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastFlavoredStampForAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastFlavoredStampForAgentTqk(args),
        queryFn: () => 
mama.lastFlavoredStampForAgent(args),
    });
}
// TQP OUT
// TQOTOP
// AgentStamp is not a stub
// LastFlavoredStampForAgent can take args
export function lastFlavoredStampForAgentTqo(mama: KingBasura, args ?: LastFlavoredStampForAgentRequest) {
    return queryOptions({
        queryKey: lastFlavoredStampForAgentTqk(args),
        queryFn: args
            ? () => 
mama.lastFlavoredStampForAgent(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastFlavoredStampForAgentResponse) => data.stamp,
    });
}

export function useLastFlavoredStampForAgent(args ?: LastFlavoredStampForAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastFlavoredStampForAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForAgentVerb = "StampsForAgent";
export type StampsForAgentRequest = WatchStampsForAgentRequest;

export function stampsForAgentTqk(args?: StampsForAgentRequest) {
    return args ? [stampsForAgentVerb, args] as const : [stampsForAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForAgentTqk(args),
        queryFn: () => 
mama.watchStampsForAgent(args),
    });
}
// TQP OUT
// TQOTOP
// AgentStamp is not a stub
// StampsForAgent can take args
export function watchStampsForAgentTqo(mama: KingBasura, args ?: StampsForAgentRequest) {
    return queryOptions({
        queryKey: stampsForAgentTqk(args),
        queryFn: args
            ? () => 
mama.watchStampsForAgent(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchStampsForAgentResponse) => data.stamps,
    });
}

export function useStampsForAgent(args ?: StampsForAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchStampsForAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForAgentDuringVerb = "StampsForAgentDuring";

export function stampsForAgentDuringTqk(args?: StampsForAgentDuringRequest) {
    return args ? [stampsForAgentDuringVerb, args] as const : [stampsForAgentDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForAgentDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForAgentDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForAgentDuringTqk(args),
        queryFn: () => 
mama.stampsForAgentDuring(args),
    });
}
// TQP OUT
// TQOTOP
// AgentStamp is not a stub
// StampsForAgentDuring can take args
export function stampsForAgentDuringTqo(mama: KingBasura, args ?: StampsForAgentDuringRequest) {
    return queryOptions({
        queryKey: stampsForAgentDuringTqk(args),
        queryFn: args
            ? () => 
mama.stampsForAgentDuring(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampsForAgentDuringResponse) => data.stamps,
    });
}

export function useStampsForAgentDuring(args ?: StampsForAgentDuringRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampsForAgentDuringTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentAvatarVerb = "AgentAvatar";

export function agentAvatarTqk(args?: AgentAvatarRequest) {
    return args ? [agentAvatarVerb, args] as const : [agentAvatarVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentAvatar({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentAvatarRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentAvatarTqk(args),
        queryFn: () => 
mama.agentAvatar(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// AgentAvatar can take args
export function agentAvatarTqo(mama: KingBasura, args ?: AgentAvatarRequest) {
    return queryOptions({
        queryKey: agentAvatarTqk(args),
        queryFn: args
            ? () => 
mama.agentAvatar(args)
            : skipToken,
        throwOnError: true,
        select: (data: AgentAvatarResponse) => data.photoSlug,
    });
}

export function useAgentAvatar(args ?: AgentAvatarRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(agentAvatarTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const agentPresenceByIdVerb = "AgentPresenceById";
export type AgentPresenceByIdRequest = WatchAgentPresenceByIdRequest;

export function agentPresenceByIdTqk(args?: AgentPresenceByIdRequest) {
    return args ? [agentPresenceByIdVerb, args] as const : [agentPresenceByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAgentPresenceById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AgentPresenceByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: agentPresenceByIdTqk(args),
        queryFn: () => 
mama.watchAgentPresenceById(args),
    });
}
// TQP OUT
// TQOTOP
// AgentPresence is not a stub
// AgentPresenceById can take args
export function watchAgentPresenceByIdTqo(mama: KingBasura, args ?: AgentPresenceByIdRequest) {
    return queryOptions({
        queryKey: agentPresenceByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchAgentPresenceById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAgentPresenceByIdResponse) => data.presence,
    });
}

export function useAgentPresenceById(args ?: AgentPresenceByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAgentPresenceByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allPresentAgentsVerb = "AllPresentAgents";

export const allPresentAgentsTqk = [allPresentAgentsVerb] as const;
// TQK OUT
// TQP IN

export function ensureAllPresentAgents({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: allPresentAgentsTqk,
        queryFn: () => 
mama.watchAllPresentAgents(),
    });
}

export function ensureFullAllPresentAgents({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureAllPresentAgents({tqc, mama}).then(tqrv => Promise.all(tqrv.agents.map(stub => ensureAgentById({tqc, mama, args: {agentId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []AgentStub is a stub
// []AgentStub is a slice
// AllPresentAgents takes no args
export function watchAllPresentAgentsTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: allPresentAgentsTqk,
        queryFn: () => 
mama.watchAllPresentAgents(),
        throwOnError: true,
        select: (data: WatchAllPresentAgentsResponse) => data.agents,
});
}

export function useAllPresentAgents() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAllPresentAgentsTqo(mama));
}

export function useFullAllPresentAgents() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useAllPresentAgents();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {agentId: stub.id} as const;
        return {
            queryKey: agentByIdTqk(ribRequest),
            queryFn: () => mama.watchAgentById(ribRequest),
            select: (data: WatchAgentByIdResponse) => data.agent,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckModelsVerb = "TruckModels";

export const truckModelsTqk = [truckModelsVerb] as const;
// TQK OUT
// TQP IN

export function ensureTruckModels({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: truckModelsTqk,
        queryFn: () => 
mama.watchTruckModels(),
    });
}
// TQP OUT
// TQOTOP
// TruckModel is not a stub
// TruckModels takes no args
export function watchTruckModelsTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: truckModelsTqk,
        queryFn: () => 
mama.watchTruckModels(),
        throwOnError: true,
        select: (data: WatchTruckModelsResponse) => data.models,
    });
}

export function useTruckModels() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(watchTruckModelsTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckModelByIdVerb = "TruckModelById";
export type TruckModelByIdRequest = WatchTruckModelByIdRequest;

export function truckModelByIdTqk(args?: TruckModelByIdRequest) {
    return args ? [truckModelByIdVerb, args] as const : [truckModelByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckModelById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckModelByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckModelByIdTqk(args),
        queryFn: () => 
mama.watchTruckModelById(args),
    });
}
// TQP OUT
// TQOTOP
// TruckModel is not a stub
// TruckModelById can take args
export function watchTruckModelByIdTqo(mama: KingBasura, args ?: TruckModelByIdRequest) {
    return queryOptions({
        queryKey: truckModelByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchTruckModelById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchTruckModelByIdResponse) => data.model,
    });
}

export function useTruckModelById(args ?: TruckModelByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTruckModelByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckByIdVerb = "TruckById";
export type TruckByIdRequest = WatchTruckByIdRequest;

export function truckByIdTqk(args?: TruckByIdRequest) {
    return args ? [truckByIdVerb, args] as const : [truckByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckByIdTqk(args),
        queryFn: () => 
mama.watchTruckById(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// TruckById can take args
export function watchTruckByIdTqo(mama: KingBasura, args ?: TruckByIdRequest) {
    return queryOptions({
        queryKey: truckByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchTruckById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchTruckByIdResponse) => data.truck,
    });
}

export function useTruckById(args ?: TruckByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTruckByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidTruckByIdVerb = "LastValidTruckById";

export function lastValidTruckByIdTqk(args?: LastValidTruckByIdRequest) {
    return args ? [lastValidTruckByIdVerb, args] as const : [lastValidTruckByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidTruckById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidTruckByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidTruckByIdTqk(args),
        queryFn: () => 
mama.lastValidTruckById(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// LastValidTruckById can take args
export function lastValidTruckByIdTqo(mama: KingBasura, args ?: LastValidTruckByIdRequest) {
    return queryOptions({
        queryKey: lastValidTruckByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidTruckById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidTruckByIdResponse) => data.truck,
    });
}

export function useLastValidTruckById(args ?: LastValidTruckByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidTruckByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckByIdAsofVerb = "TruckByIdAsof";

export function truckByIdAsofTqk(args?: TruckByIdAsofRequest) {
    return args ? [truckByIdAsofVerb, args] as const : [truckByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckByIdAsofTqk(args),
        queryFn: () => 
mama.truckByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// TruckByIdAsof can take args
export function truckByIdAsofTqo(mama: KingBasura, args ?: TruckByIdAsofRequest) {
    return queryOptions({
        queryKey: truckByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.truckByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckByIdAsofResponse) => data.truck,
    });
}

export function useTruckByIdAsof(args ?: TruckByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckRevisionCountVerb = "TruckRevisionCount";

export function truckRevisionCountTqk(args?: TruckRevisionCountRequest) {
    return args ? [truckRevisionCountVerb, args] as const : [truckRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckRevisionCountTqk(args),
        queryFn: () => 
mama.truckRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// TruckRevisionCount can take args
export function truckRevisionCountTqo(mama: KingBasura, args ?: TruckRevisionCountRequest) {
    return queryOptions({
        queryKey: truckRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.truckRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckRevisionCountResponse) => data.revisionCount,
    });
}

export function useTruckRevisionCount(args ?: TruckRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allTruckRevisionsVerb = "AllTruckRevisions";

export function allTruckRevisionsTqk(args?: AllTruckRevisionsRequest) {
    return args ? [allTruckRevisionsVerb, args] as const : [allTruckRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllTruckRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllTruckRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allTruckRevisionsTqk(args),
        queryFn: () => 
mama.allTruckRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// AllTruckRevisions can take args
export function allTruckRevisionsTqo(mama: KingBasura, args ?: AllTruckRevisionsRequest) {
    return queryOptions({
        queryKey: allTruckRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allTruckRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllTruckRevisionsResponse) => data.revisions,
    });
}

export function useAllTruckRevisions(args ?: AllTruckRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allTruckRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckByPlateVerb = "TruckByPlate";
export type TruckByPlateRequest = WatchTruckByPlateRequest;

export function truckByPlateTqk(args?: TruckByPlateRequest) {
    return args ? [truckByPlateVerb, args] as const : [truckByPlateVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckByPlate({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByPlateRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckByPlateTqk(args),
        queryFn: () => 
mama.watchTruckByPlate(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// TruckByPlate can take args
export function watchTruckByPlateTqo(mama: KingBasura, args ?: TruckByPlateRequest) {
    return queryOptions({
        queryKey: truckByPlateTqk(args),
        queryFn: args
            ? () => 
mama.watchTruckByPlate(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchTruckByPlateResponse) => data.truck,
    });
}

export function useTruckByPlate(args ?: TruckByPlateRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTruckByPlateTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidTruckByPlateVerb = "LastValidTruckByPlate";

export function lastValidTruckByPlateTqk(args?: LastValidTruckByPlateRequest) {
    return args ? [lastValidTruckByPlateVerb, args] as const : [lastValidTruckByPlateVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidTruckByPlate({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidTruckByPlateRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidTruckByPlateTqk(args),
        queryFn: () => 
mama.lastValidTruckByPlate(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// LastValidTruckByPlate can take args
export function lastValidTruckByPlateTqo(mama: KingBasura, args ?: LastValidTruckByPlateRequest) {
    return queryOptions({
        queryKey: lastValidTruckByPlateTqk(args),
        queryFn: args
            ? () => 
mama.lastValidTruckByPlate(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidTruckByPlateResponse) => data.truck,
    });
}

export function useLastValidTruckByPlate(args ?: LastValidTruckByPlateRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidTruckByPlateTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckByPlateAsofVerb = "TruckByPlateAsof";

export function truckByPlateAsofTqk(args?: TruckByPlateAsofRequest) {
    return args ? [truckByPlateAsofVerb, args] as const : [truckByPlateAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckByPlateAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByPlateAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckByPlateAsofTqk(args),
        queryFn: () => 
mama.truckByPlateAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// TruckByPlateAsof can take args
export function truckByPlateAsofTqo(mama: KingBasura, args ?: TruckByPlateAsofRequest) {
    return queryOptions({
        queryKey: truckByPlateAsofTqk(args),
        queryFn: args
            ? () => 
mama.truckByPlateAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckByPlateAsofResponse) => data.truck,
    });
}

export function useTruckByPlateAsof(args ?: TruckByPlateAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckByPlateAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckByCrewVerb = "TruckByCrew";
export type TruckByCrewRequest = WatchTruckByCrewRequest;

export function truckByCrewTqk(args?: TruckByCrewRequest) {
    return args ? [truckByCrewVerb, args] as const : [truckByCrewVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckByCrew({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByCrewRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckByCrewTqk(args),
        queryFn: () => 
mama.watchTruckByCrew(args),
    });
}

export function ensureFullTruckByCrew({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckByCrewRequest}) {
    return ensureTruckByCrew({tqc, mama, args}).then(tqrv => tqrv?.truck ? ensureTruckById({tqc, mama, args: {truckId: tqrv.truck.id}}) : undefined);
}
// TQP OUT
// TQOTOP
// TruckStub is a stub
// TruckStub not a slice
// TruckByCrew can take args
export function watchTruckByCrewTqo(mama: KingBasura, args ?: TruckByCrewRequest) {
    return queryOptions({
        queryKey: truckByCrewTqk(args),
        queryFn: args
            ? () => 
mama.watchTruckByCrew(args)
        : skipToken,
        throwOnError: true,
        select: (data: WatchTruckByCrewResponse) => data.truck,
    });
}

export function useTruckByCrew(args ?: TruckByCrewRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTruckByCrewTqo(mama, args));
}

export function useFullTruckByCrew(args ?: TruckByCrewRequest) {
    const mama = useKingBasuraMothership();
    const stubTqrv = useTruckByCrew(args);
    let dataUpdatedAt = stubTqrv.dataUpdatedAt;
	const ribRequest = stubTqrv.data ? { truckId: stubTqrv.data.id } as const : undefined;

	const ribTqrv = useRefreshableInfallibleQuery({
		queryKey: truckByIdTqk(ribRequest),
		queryFn: ribRequest
            ? () => mama.watchTruckById(ribRequest)
            : skipToken,
    });
	if (isAfter(ribTqrv.dataUpdatedAt, dataUpdatedAt)) {
		dataUpdatedAt = ribTqrv.dataUpdatedAt;
    }

	return {...ribTqrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckTenuresByCrewDuringVerb = "TruckTenuresByCrewDuring";

export function truckTenuresByCrewDuringTqk(args?: TruckTenuresByCrewDuringRequest) {
    return args ? [truckTenuresByCrewDuringVerb, args] as const : [truckTenuresByCrewDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckTenuresByCrewDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckTenuresByCrewDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckTenuresByCrewDuringTqk(args),
        queryFn: () => 
mama.truckTenuresByCrewDuring(args),
    });
}
// TQP OUT
// TQOTOP
// TruckTenure is not a stub
// TruckTenuresByCrewDuring can take args
export function truckTenuresByCrewDuringTqo(mama: KingBasura, args ?: TruckTenuresByCrewDuringRequest) {
    return queryOptions({
        queryKey: truckTenuresByCrewDuringTqk(args),
        queryFn: args
            ? () => 
mama.truckTenuresByCrewDuring(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckTenuresByCrewDuringResponse) => data.tenures,
    });
}

export function useTruckTenuresByCrewDuring(args ?: TruckTenuresByCrewDuringRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckTenuresByCrewDuringTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const crewByTruckVerb = "CrewByTruck";
export type CrewByTruckRequest = WatchCrewByTruckRequest;

export function crewByTruckTqk(args?: CrewByTruckRequest) {
    return args ? [crewByTruckVerb, args] as const : [crewByTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCrewByTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CrewByTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: crewByTruckTqk(args),
        queryFn: () => 
mama.watchCrewByTruck(args),
    });
}
// TQP OUT
// TQOTOP
// CrewTenure is not a stub
// CrewByTruck can take args
export function watchCrewByTruckTqo(mama: KingBasura, args ?: CrewByTruckRequest) {
    return queryOptions({
        queryKey: crewByTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchCrewByTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchCrewByTruckResponse) => data.tenures,
    });
}

export function useCrewByTruck(args ?: CrewByTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchCrewByTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const crewTenuresByTruckDuringVerb = "CrewTenuresByTruckDuring";

export function crewTenuresByTruckDuringTqk(args?: CrewTenuresByTruckDuringRequest) {
    return args ? [crewTenuresByTruckDuringVerb, args] as const : [crewTenuresByTruckDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCrewTenuresByTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CrewTenuresByTruckDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: crewTenuresByTruckDuringTqk(args),
        queryFn: () => 
mama.crewTenuresByTruckDuring(args),
    });
}
// TQP OUT
// TQOTOP
// CrewTenure is not a stub
// CrewTenuresByTruckDuring can take args
export function crewTenuresByTruckDuringTqo(mama: KingBasura, args ?: CrewTenuresByTruckDuringRequest) {
    return queryOptions({
        queryKey: crewTenuresByTruckDuringTqk(args),
        queryFn: args
            ? () => 
mama.crewTenuresByTruckDuring(args)
            : skipToken,
        throwOnError: true,
        select: (data: CrewTenuresByTruckDuringResponse) => data.tenures,
    });
}

export function useCrewTenuresByTruckDuring(args ?: CrewTenuresByTruckDuringRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(crewTenuresByTruckDuringTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckStampByIdVerb = "TruckStampById";

export function truckStampByIdTqk(args?: TruckStampByIdRequest) {
    return args ? [truckStampByIdVerb, args] as const : [truckStampByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckStampById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckStampByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckStampByIdTqk(args),
        queryFn: () => 
mama.truckStampById(args),
    });
}
// TQP OUT
// TQOTOP
// TruckStamp is not a stub
// TruckStampById can take args
export function truckStampByIdTqo(mama: KingBasura, args ?: TruckStampByIdRequest) {
    return queryOptions({
        queryKey: truckStampByIdTqk(args),
        queryFn: args
            ? () => 
mama.truckStampById(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckStampByIdResponse) => data.stamp,
    });
}

export function useTruckStampById(args ?: TruckStampByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckStampByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastFlavoredStampForTruckVerb = "LastFlavoredStampForTruck";

export function lastFlavoredStampForTruckTqk(args?: LastFlavoredStampForTruckRequest) {
    return args ? [lastFlavoredStampForTruckVerb, args] as const : [lastFlavoredStampForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastFlavoredStampForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastFlavoredStampForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastFlavoredStampForTruckTqk(args),
        queryFn: () => 
mama.lastFlavoredStampForTruck(args),
    });
}
// TQP OUT
// TQOTOP
// TruckStamp is not a stub
// LastFlavoredStampForTruck can take args
export function lastFlavoredStampForTruckTqo(mama: KingBasura, args ?: LastFlavoredStampForTruckRequest) {
    return queryOptions({
        queryKey: lastFlavoredStampForTruckTqk(args),
        queryFn: args
            ? () => 
mama.lastFlavoredStampForTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastFlavoredStampForTruckResponse) => data.stamp,
    });
}

export function useLastFlavoredStampForTruck(args ?: LastFlavoredStampForTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastFlavoredStampForTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForTruckVerb = "StampsForTruck";
export type StampsForTruckRequest = WatchStampsForTruckRequest;

export function stampsForTruckTqk(args?: StampsForTruckRequest) {
    return args ? [stampsForTruckVerb, args] as const : [stampsForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForTruckTqk(args),
        queryFn: () => 
mama.watchStampsForTruck(args),
    });
}
// TQP OUT
// TQOTOP
// TruckStamp is not a stub
// StampsForTruck can take args
export function watchStampsForTruckTqo(mama: KingBasura, args ?: StampsForTruckRequest) {
    return queryOptions({
        queryKey: stampsForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchStampsForTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchStampsForTruckResponse) => data.stamps,
    });
}

export function useStampsForTruck(args ?: StampsForTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchStampsForTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForTruckDuringVerb = "StampsForTruckDuring";

export function stampsForTruckDuringTqk(args?: StampsForTruckDuringRequest) {
    return args ? [stampsForTruckDuringVerb, args] as const : [stampsForTruckDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForTruckDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForTruckDuringTqk(args),
        queryFn: () => 
mama.stampsForTruckDuring(args),
    });
}
// TQP OUT
// TQOTOP
// TruckStamp is not a stub
// StampsForTruckDuring can take args
export function stampsForTruckDuringTqo(mama: KingBasura, args ?: StampsForTruckDuringRequest) {
    return queryOptions({
        queryKey: stampsForTruckDuringTqk(args),
        queryFn: args
            ? () => 
mama.stampsForTruckDuring(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampsForTruckDuringResponse) => data.stamps,
    });
}

export function useStampsForTruckDuring(args ?: StampsForTruckDuringRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampsForTruckDuringTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const truckAvatarVerb = "TruckAvatar";

export function truckAvatarTqk(args?: TruckAvatarRequest) {
    return args ? [truckAvatarVerb, args] as const : [truckAvatarVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTruckAvatar({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TruckAvatarRequest}) {
    return tqc.ensureQueryData({
        queryKey: truckAvatarTqk(args),
        queryFn: () => 
mama.truckAvatar(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// TruckAvatar can take args
export function truckAvatarTqo(mama: KingBasura, args ?: TruckAvatarRequest) {
    return queryOptions({
        queryKey: truckAvatarTqk(args),
        queryFn: args
            ? () => 
mama.truckAvatar(args)
            : skipToken,
        throwOnError: true,
        select: (data: TruckAvatarResponse) => data.photoSlug,
    });
}

export function useTruckAvatar(args ?: TruckAvatarRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(truckAvatarTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByIdVerb = "JobById";
export type JobByIdRequest = WatchJobByIdRequest;

export function jobByIdTqk(args?: JobByIdRequest) {
    return args ? [jobByIdVerb, args] as const : [jobByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByIdTqk(args),
        queryFn: () => 
mama.watchJobById(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobById can take args
export function watchJobByIdTqo(mama: KingBasura, args ?: JobByIdRequest) {
    return queryOptions({
        queryKey: jobByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchJobById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchJobByIdResponse) => data.job,
    });
}

export function useJobById(args ?: JobByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchJobByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidJobByIdVerb = "LastValidJobById";

export function lastValidJobByIdTqk(args?: LastValidJobByIdRequest) {
    return args ? [lastValidJobByIdVerb, args] as const : [lastValidJobByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidJobById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidJobByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidJobByIdTqk(args),
        queryFn: () => 
mama.lastValidJobById(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// LastValidJobById can take args
export function lastValidJobByIdTqo(mama: KingBasura, args ?: LastValidJobByIdRequest) {
    return queryOptions({
        queryKey: lastValidJobByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidJobById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidJobByIdResponse) => data.job,
    });
}

export function useLastValidJobById(args ?: LastValidJobByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidJobByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByIdAsofVerb = "JobByIdAsof";

export function jobByIdAsofTqk(args?: JobByIdAsofRequest) {
    return args ? [jobByIdAsofVerb, args] as const : [jobByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByIdAsofTqk(args),
        queryFn: () => 
mama.jobByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobByIdAsof can take args
export function jobByIdAsofTqo(mama: KingBasura, args ?: JobByIdAsofRequest) {
    return queryOptions({
        queryKey: jobByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.jobByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: JobByIdAsofResponse) => data.job,
    });
}

export function useJobByIdAsof(args ?: JobByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(jobByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobRevisionCountVerb = "JobRevisionCount";

export function jobRevisionCountTqk(args?: JobRevisionCountRequest) {
    return args ? [jobRevisionCountVerb, args] as const : [jobRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobRevisionCountTqk(args),
        queryFn: () => 
mama.jobRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// JobRevisionCount can take args
export function jobRevisionCountTqo(mama: KingBasura, args ?: JobRevisionCountRequest) {
    return queryOptions({
        queryKey: jobRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.jobRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: JobRevisionCountResponse) => data.revisionCount,
    });
}

export function useJobRevisionCount(args ?: JobRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(jobRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allJobRevisionsVerb = "AllJobRevisions";

export function allJobRevisionsTqk(args?: AllJobRevisionsRequest) {
    return args ? [allJobRevisionsVerb, args] as const : [allJobRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllJobRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllJobRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allJobRevisionsTqk(args),
        queryFn: () => 
mama.allJobRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// AllJobRevisions can take args
export function allJobRevisionsTqo(mama: KingBasura, args ?: AllJobRevisionsRequest) {
    return queryOptions({
        queryKey: allJobRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allJobRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllJobRevisionsResponse) => data.revisions,
    });
}

export function useAllJobRevisions(args ?: AllJobRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allJobRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const exportableJobsVerb = "ExportableJobs";

export const exportableJobsTqk = [exportableJobsVerb] as const;
// TQK OUT
// TQP IN

export function ensureExportableJobs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: exportableJobsTqk,
        queryFn: () => 
mama.watchExportableJobs(),
    });
}

export function ensureFullExportableJobs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureExportableJobs({tqc, mama}).then(tqrv => Promise.all(tqrv.jobs.map(stub => ensureJobById({tqc, mama, args: {jobId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []JobStub is a stub
// []JobStub is a slice
// ExportableJobs takes no args
export function watchExportableJobsTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: exportableJobsTqk,
        queryFn: () => 
mama.watchExportableJobs(),
        throwOnError: true,
        select: (data: WatchExportableJobsResponse) => data.jobs,
});
}

export function useExportableJobs() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchExportableJobsTqo(mama));
}

export function useFullExportableJobs() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useExportableJobs();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {jobId: stub.id} as const;
        return {
            queryKey: jobByIdTqk(ribRequest),
            queryFn: () => mama.watchJobById(ribRequest),
            select: (data: WatchJobByIdResponse) => data.job,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const exportedJobsVerb = "ExportedJobs";

export const exportedJobsTqk = [exportedJobsVerb] as const;
// TQK OUT
// TQP IN

export function ensureExportedJobs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: exportedJobsTqk,
        queryFn: () => 
mama.watchExportedJobs(),
    });
}

export function ensureFullExportedJobs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureExportedJobs({tqc, mama}).then(tqrv => Promise.all(tqrv.jobs.map(stub => ensureJobById({tqc, mama, args: {jobId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []JobStub is a stub
// []JobStub is a slice
// ExportedJobs takes no args
export function watchExportedJobsTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: exportedJobsTqk,
        queryFn: () => 
mama.watchExportedJobs(),
        throwOnError: true,
        select: (data: WatchExportedJobsResponse) => data.jobs,
});
}

export function useExportedJobs() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchExportedJobsTqo(mama));
}

export function useFullExportedJobs() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useExportedJobs();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {jobId: stub.id} as const;
        return {
            queryKey: jobByIdTqk(ribRequest),
            queryFn: () => mama.watchJobById(ribRequest),
            select: (data: WatchJobByIdResponse) => data.job,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const showExportedJobVerb = "ShowExportedJob";

export function showExportedJobTqk(args?: ShowExportedJobRequest) {
    return args ? [showExportedJobVerb, args] as const : [showExportedJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureShowExportedJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ShowExportedJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: showExportedJobTqk(args),
        queryFn: () => 
mama.showExportedJob(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// ShowExportedJob can take args
export function showExportedJobTqo(mama: KingBasura, args ?: ShowExportedJobRequest) {
    return queryOptions({
        queryKey: showExportedJobTqk(args),
        queryFn: args
            ? () => 
mama.showExportedJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: ShowExportedJobResponse) => data.exported,
    });
}

export function useShowExportedJob(args ?: ShowExportedJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(showExportedJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const exportJobVerb = "ExportJob";

export function exportJobTqk(args?: ExportJobRequest) {
    return args ? [exportJobVerb, args] as const : [exportJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureExportJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ExportJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: exportJobTqk(args),
        queryFn: () => 
mama.exportJob(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// ExportJob can take args
export function exportJobTqo(mama: KingBasura, args ?: ExportJobRequest) {
    return queryOptions({
        queryKey: exportJobTqk(args),
        queryFn: args
            ? () => 
mama.exportJob(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useExportJob(args ?: ExportJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(exportJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByJobCodeVerb = "JobByJobCode";
export type JobByJobCodeRequest = WatchJobByJobCodeRequest;

export function jobByJobCodeTqk(args?: JobByJobCodeRequest) {
    return args ? [jobByJobCodeVerb, args] as const : [jobByJobCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobByJobCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByJobCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByJobCodeTqk(args),
        queryFn: () => 
mama.watchJobByJobCode(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobByJobCode can take args
export function watchJobByJobCodeTqo(mama: KingBasura, args ?: JobByJobCodeRequest) {
    return queryOptions({
        queryKey: jobByJobCodeTqk(args),
        queryFn: args
            ? () => 
mama.watchJobByJobCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchJobByJobCodeResponse) => data.job,
    });
}

export function useJobByJobCode(args ?: JobByJobCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchJobByJobCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidJobByJobCodeVerb = "LastValidJobByJobCode";

export function lastValidJobByJobCodeTqk(args?: LastValidJobByJobCodeRequest) {
    return args ? [lastValidJobByJobCodeVerb, args] as const : [lastValidJobByJobCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidJobByJobCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidJobByJobCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidJobByJobCodeTqk(args),
        queryFn: () => 
mama.lastValidJobByJobCode(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// LastValidJobByJobCode can take args
export function lastValidJobByJobCodeTqo(mama: KingBasura, args ?: LastValidJobByJobCodeRequest) {
    return queryOptions({
        queryKey: lastValidJobByJobCodeTqk(args),
        queryFn: args
            ? () => 
mama.lastValidJobByJobCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidJobByJobCodeResponse) => data.job,
    });
}

export function useLastValidJobByJobCode(args ?: LastValidJobByJobCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidJobByJobCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByJobCodeAsofVerb = "JobByJobCodeAsof";

export function jobByJobCodeAsofTqk(args?: JobByJobCodeAsofRequest) {
    return args ? [jobByJobCodeAsofVerb, args] as const : [jobByJobCodeAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobByJobCodeAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByJobCodeAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByJobCodeAsofTqk(args),
        queryFn: () => 
mama.jobByJobCodeAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobByJobCodeAsof can take args
export function jobByJobCodeAsofTqo(mama: KingBasura, args ?: JobByJobCodeAsofRequest) {
    return queryOptions({
        queryKey: jobByJobCodeAsofTqk(args),
        queryFn: args
            ? () => 
mama.jobByJobCodeAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: JobByJobCodeAsofResponse) => data.job,
    });
}

export function useJobByJobCodeAsof(args ?: JobByJobCodeAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(jobByJobCodeAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByIntakeCodeVerb = "JobByIntakeCode";
export type JobByIntakeCodeRequest = WatchJobByIntakeCodeRequest;

export function jobByIntakeCodeTqk(args?: JobByIntakeCodeRequest) {
    return args ? [jobByIntakeCodeVerb, args] as const : [jobByIntakeCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobByIntakeCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByIntakeCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByIntakeCodeTqk(args),
        queryFn: () => 
mama.watchJobByIntakeCode(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobByIntakeCode can take args
export function watchJobByIntakeCodeTqo(mama: KingBasura, args ?: JobByIntakeCodeRequest) {
    return queryOptions({
        queryKey: jobByIntakeCodeTqk(args),
        queryFn: args
            ? () => 
mama.watchJobByIntakeCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchJobByIntakeCodeResponse) => data.job,
    });
}

export function useJobByIntakeCode(args ?: JobByIntakeCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchJobByIntakeCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidJobByIntakeCodeVerb = "LastValidJobByIntakeCode";

export function lastValidJobByIntakeCodeTqk(args?: LastValidJobByIntakeCodeRequest) {
    return args ? [lastValidJobByIntakeCodeVerb, args] as const : [lastValidJobByIntakeCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidJobByIntakeCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidJobByIntakeCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidJobByIntakeCodeTqk(args),
        queryFn: () => 
mama.lastValidJobByIntakeCode(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// LastValidJobByIntakeCode can take args
export function lastValidJobByIntakeCodeTqo(mama: KingBasura, args ?: LastValidJobByIntakeCodeRequest) {
    return queryOptions({
        queryKey: lastValidJobByIntakeCodeTqk(args),
        queryFn: args
            ? () => 
mama.lastValidJobByIntakeCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidJobByIntakeCodeResponse) => data.job,
    });
}

export function useLastValidJobByIntakeCode(args ?: LastValidJobByIntakeCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidJobByIntakeCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobByIntakeCodeAsofVerb = "JobByIntakeCodeAsof";

export function jobByIntakeCodeAsofTqk(args?: JobByIntakeCodeAsofRequest) {
    return args ? [jobByIntakeCodeAsofVerb, args] as const : [jobByIntakeCodeAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobByIntakeCodeAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobByIntakeCodeAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobByIntakeCodeAsofTqk(args),
        queryFn: () => 
mama.jobByIntakeCodeAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// JobByIntakeCodeAsof can take args
export function jobByIntakeCodeAsofTqo(mama: KingBasura, args ?: JobByIntakeCodeAsofRequest) {
    return queryOptions({
        queryKey: jobByIntakeCodeAsofTqk(args),
        queryFn: args
            ? () => 
mama.jobByIntakeCodeAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: JobByIntakeCodeAsofResponse) => data.job,
    });
}

export function useJobByIntakeCodeAsof(args ?: JobByIntakeCodeAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(jobByIntakeCodeAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const jobStampByIdVerb = "JobStampById";

export function jobStampByIdTqk(args?: JobStampByIdRequest) {
    return args ? [jobStampByIdVerb, args] as const : [jobStampByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureJobStampById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: JobStampByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: jobStampByIdTqk(args),
        queryFn: () => 
mama.jobStampById(args),
    });
}
// TQP OUT
// TQOTOP
// JobStamp is not a stub
// JobStampById can take args
export function jobStampByIdTqo(mama: KingBasura, args ?: JobStampByIdRequest) {
    return queryOptions({
        queryKey: jobStampByIdTqk(args),
        queryFn: args
            ? () => 
mama.jobStampById(args)
            : skipToken,
        throwOnError: true,
        select: (data: JobStampByIdResponse) => data.stamp,
    });
}

export function useJobStampById(args ?: JobStampByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(jobStampByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastFlavoredStampForJobVerb = "LastFlavoredStampForJob";

export function lastFlavoredStampForJobTqk(args?: LastFlavoredStampForJobRequest) {
    return args ? [lastFlavoredStampForJobVerb, args] as const : [lastFlavoredStampForJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastFlavoredStampForJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastFlavoredStampForJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastFlavoredStampForJobTqk(args),
        queryFn: () => 
mama.lastFlavoredStampForJob(args),
    });
}
// TQP OUT
// TQOTOP
// JobStamp is not a stub
// LastFlavoredStampForJob can take args
export function lastFlavoredStampForJobTqo(mama: KingBasura, args ?: LastFlavoredStampForJobRequest) {
    return queryOptions({
        queryKey: lastFlavoredStampForJobTqk(args),
        queryFn: args
            ? () => 
mama.lastFlavoredStampForJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastFlavoredStampForJobResponse) => data.stamp,
    });
}

export function useLastFlavoredStampForJob(args ?: LastFlavoredStampForJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastFlavoredStampForJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForJobVerb = "StampsForJob";
export type StampsForJobRequest = WatchStampsForJobRequest;

export function stampsForJobTqk(args?: StampsForJobRequest) {
    return args ? [stampsForJobVerb, args] as const : [stampsForJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForJobTqk(args),
        queryFn: () => 
mama.watchStampsForJob(args),
    });
}
// TQP OUT
// TQOTOP
// JobStamp is not a stub
// StampsForJob can take args
export function watchStampsForJobTqo(mama: KingBasura, args ?: StampsForJobRequest) {
    return queryOptions({
        queryKey: stampsForJobTqk(args),
        queryFn: args
            ? () => 
mama.watchStampsForJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchStampsForJobResponse) => data.stamps,
    });
}

export function useStampsForJob(args ?: StampsForJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchStampsForJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const unbundledWastesForJobAtVenueVerb = "UnbundledWastesForJobAtVenue";
export type UnbundledWastesForJobAtVenueRequest = WatchUnbundledWastesForJobAtVenueRequest;

export function unbundledWastesForJobAtVenueTqk(args?: UnbundledWastesForJobAtVenueRequest) {
    return args ? [unbundledWastesForJobAtVenueVerb, args] as const : [unbundledWastesForJobAtVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUnbundledWastesForJobAtVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UnbundledWastesForJobAtVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: unbundledWastesForJobAtVenueTqk(args),
        queryFn: () => 
mama.watchUnbundledWastesForJobAtVenue(args),
    });
}

export function ensureFullUnbundledWastesForJobAtVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UnbundledWastesForJobAtVenueRequest}) {
    return ensureUnbundledWastesForJobAtVenue({tqc, mama, args}).then(tqrv => Promise.all(tqrv.wastes.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// UnbundledWastesForJobAtVenue can take arguments
export function watchUnbundledWastesForJobAtVenueTqo(mama: KingBasura, args?: UnbundledWastesForJobAtVenueRequest) {
    return queryOptions({
        queryKey: unbundledWastesForJobAtVenueTqk(args),
        queryFn: args
            ? () => 
mama.watchUnbundledWastesForJobAtVenue(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchUnbundledWastesForJobAtVenueResponse) => data.wastes,
    });
}

export function useUnbundledWastesForJobAtVenue(args?: UnbundledWastesForJobAtVenueRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchUnbundledWastesForJobAtVenueTqo(mama, args));
}
export function useFullUnbundledWastesForJobAtVenue(args?: UnbundledWastesForJobAtVenueRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useUnbundledWastesForJobAtVenue(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const surchargeFlavorByIdVerb = "SurchargeFlavorById";

export function surchargeFlavorByIdTqk(args?: SurchargeFlavorByIdRequest) {
    return args ? [surchargeFlavorByIdVerb, args] as const : [surchargeFlavorByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSurchargeFlavorById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SurchargeFlavorByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: surchargeFlavorByIdTqk(args),
        queryFn: () => 
mama.surchargeFlavorById(args),
    });
}
// TQP OUT
// TQOTOP
// SurchargeFlavor is not a stub
// SurchargeFlavorById can take args
export function surchargeFlavorByIdTqo(mama: KingBasura, args ?: SurchargeFlavorByIdRequest) {
    return queryOptions({
        queryKey: surchargeFlavorByIdTqk(args),
        queryFn: args
            ? () => 
mama.surchargeFlavorById(args)
            : skipToken,
        throwOnError: true,
        select: (data: SurchargeFlavorByIdResponse) => data.flavor,
    });
}

export function useSurchargeFlavorById(args ?: SurchargeFlavorByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(surchargeFlavorByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const surchargeFlavorByCodeVerb = "SurchargeFlavorByCode";

export function surchargeFlavorByCodeTqk(args?: SurchargeFlavorByCodeRequest) {
    return args ? [surchargeFlavorByCodeVerb, args] as const : [surchargeFlavorByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSurchargeFlavorByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SurchargeFlavorByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: surchargeFlavorByCodeTqk(args),
        queryFn: () => 
mama.surchargeFlavorByCode(args),
    });
}
// TQP OUT
// TQOTOP
// SurchargeFlavor is not a stub
// SurchargeFlavorByCode can take args
export function surchargeFlavorByCodeTqo(mama: KingBasura, args ?: SurchargeFlavorByCodeRequest) {
    return queryOptions({
        queryKey: surchargeFlavorByCodeTqk(args),
        queryFn: args
            ? () => 
mama.surchargeFlavorByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: SurchargeFlavorByCodeResponse) => data.flavor,
    });
}

export function useSurchargeFlavorByCode(args ?: SurchargeFlavorByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(surchargeFlavorByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const surchargesForSubjectVerb = "SurchargesForSubject";
export type SurchargesForSubjectRequest = WatchSurchargesForSubjectRequest;

export function surchargesForSubjectTqk(args?: SurchargesForSubjectRequest) {
    return args ? [surchargesForSubjectVerb, args] as const : [surchargesForSubjectVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSurchargesForSubject({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SurchargesForSubjectRequest}) {
    return tqc.ensureQueryData({
        queryKey: surchargesForSubjectTqk(args),
        queryFn: () => 
mama.watchSurchargesForSubject(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// SurchargesForSubject can take args
export function watchSurchargesForSubjectTqo(mama: KingBasura, args ?: SurchargesForSubjectRequest) {
    return queryOptions({
        queryKey: surchargesForSubjectTqk(args),
        queryFn: args
            ? () => 
mama.watchSurchargesForSubject(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchSurchargesForSubjectResponse) => data.surcharges,
    });
}

export function useSurchargesForSubject(args ?: SurchargesForSubjectRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchSurchargesForSubjectTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const surchargeByIdVerb = "SurchargeById";
export type SurchargeByIdRequest = WatchSurchargeByIdRequest;

export function surchargeByIdTqk(args?: SurchargeByIdRequest) {
    return args ? [surchargeByIdVerb, args] as const : [surchargeByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSurchargeById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SurchargeByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: surchargeByIdTqk(args),
        queryFn: () => 
mama.watchSurchargeById(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// SurchargeById can take args
export function watchSurchargeByIdTqo(mama: KingBasura, args ?: SurchargeByIdRequest) {
    return queryOptions({
        queryKey: surchargeByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchSurchargeById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchSurchargeByIdResponse) => data.surcharge,
    });
}

export function useSurchargeById(args ?: SurchargeByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchSurchargeByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidSurchargeByIdVerb = "LastValidSurchargeById";

export function lastValidSurchargeByIdTqk(args?: LastValidSurchargeByIdRequest) {
    return args ? [lastValidSurchargeByIdVerb, args] as const : [lastValidSurchargeByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidSurchargeById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidSurchargeByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidSurchargeByIdTqk(args),
        queryFn: () => 
mama.lastValidSurchargeById(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// LastValidSurchargeById can take args
export function lastValidSurchargeByIdTqo(mama: KingBasura, args ?: LastValidSurchargeByIdRequest) {
    return queryOptions({
        queryKey: lastValidSurchargeByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidSurchargeById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidSurchargeByIdResponse) => data.surcharge,
    });
}

export function useLastValidSurchargeById(args ?: LastValidSurchargeByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidSurchargeByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const surchargeByIdAsofVerb = "SurchargeByIdAsof";

export function surchargeByIdAsofTqk(args?: SurchargeByIdAsofRequest) {
    return args ? [surchargeByIdAsofVerb, args] as const : [surchargeByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSurchargeByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SurchargeByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: surchargeByIdAsofTqk(args),
        queryFn: () => 
mama.surchargeByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// SurchargeByIdAsof can take args
export function surchargeByIdAsofTqo(mama: KingBasura, args ?: SurchargeByIdAsofRequest) {
    return queryOptions({
        queryKey: surchargeByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.surchargeByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: SurchargeByIdAsofResponse) => data.surcharge,
    });
}

export function useSurchargeByIdAsof(args ?: SurchargeByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(surchargeByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allSurchargeRevisionsVerb = "AllSurchargeRevisions";

export function allSurchargeRevisionsTqk(args?: AllSurchargeRevisionsRequest) {
    return args ? [allSurchargeRevisionsVerb, args] as const : [allSurchargeRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllSurchargeRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllSurchargeRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allSurchargeRevisionsTqk(args),
        queryFn: () => 
mama.allSurchargeRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// AllSurchargeRevisions can take args
export function allSurchargeRevisionsTqo(mama: KingBasura, args ?: AllSurchargeRevisionsRequest) {
    return queryOptions({
        queryKey: allSurchargeRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allSurchargeRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllSurchargeRevisionsResponse) => data.revisions,
    });
}

export function useAllSurchargeRevisions(args ?: AllSurchargeRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allSurchargeRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleByIdVerb = "BundleById";
export type BundleByIdRequest = WatchBundleByIdRequest;

export function bundleByIdTqk(args?: BundleByIdRequest) {
    return args ? [bundleByIdVerb, args] as const : [bundleByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleByIdTqk(args),
        queryFn: () => 
mama.watchBundleById(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// BundleById can take args
export function watchBundleByIdTqo(mama: KingBasura, args ?: BundleByIdRequest) {
    return queryOptions({
        queryKey: bundleByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchBundleById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchBundleByIdResponse) => data.bundle,
    });
}

export function useBundleById(args ?: BundleByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchBundleByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidBundleByIdVerb = "LastValidBundleById";

export function lastValidBundleByIdTqk(args?: LastValidBundleByIdRequest) {
    return args ? [lastValidBundleByIdVerb, args] as const : [lastValidBundleByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidBundleById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidBundleByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidBundleByIdTqk(args),
        queryFn: () => 
mama.lastValidBundleById(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// LastValidBundleById can take args
export function lastValidBundleByIdTqo(mama: KingBasura, args ?: LastValidBundleByIdRequest) {
    return queryOptions({
        queryKey: lastValidBundleByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidBundleById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidBundleByIdResponse) => data.bundle,
    });
}

export function useLastValidBundleById(args ?: LastValidBundleByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidBundleByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleByIdAsofVerb = "BundleByIdAsof";

export function bundleByIdAsofTqk(args?: BundleByIdAsofRequest) {
    return args ? [bundleByIdAsofVerb, args] as const : [bundleByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleByIdAsofTqk(args),
        queryFn: () => 
mama.bundleByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// BundleByIdAsof can take args
export function bundleByIdAsofTqo(mama: KingBasura, args ?: BundleByIdAsofRequest) {
    return queryOptions({
        queryKey: bundleByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.bundleByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: BundleByIdAsofResponse) => data.bundle,
    });
}

export function useBundleByIdAsof(args ?: BundleByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(bundleByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleRevisionCountVerb = "BundleRevisionCount";

export function bundleRevisionCountTqk(args?: BundleRevisionCountRequest) {
    return args ? [bundleRevisionCountVerb, args] as const : [bundleRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleRevisionCountTqk(args),
        queryFn: () => 
mama.bundleRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// BundleRevisionCount can take args
export function bundleRevisionCountTqo(mama: KingBasura, args ?: BundleRevisionCountRequest) {
    return queryOptions({
        queryKey: bundleRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.bundleRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: BundleRevisionCountResponse) => data.revisionCount,
    });
}

export function useBundleRevisionCount(args ?: BundleRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(bundleRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allBundleRevisionsVerb = "AllBundleRevisions";

export function allBundleRevisionsTqk(args?: AllBundleRevisionsRequest) {
    return args ? [allBundleRevisionsVerb, args] as const : [allBundleRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllBundleRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllBundleRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allBundleRevisionsTqk(args),
        queryFn: () => 
mama.allBundleRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// AllBundleRevisions can take args
export function allBundleRevisionsTqo(mama: KingBasura, args ?: AllBundleRevisionsRequest) {
    return queryOptions({
        queryKey: allBundleRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allBundleRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllBundleRevisionsResponse) => data.revisions,
    });
}

export function useAllBundleRevisions(args ?: AllBundleRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allBundleRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleLocationVerb = "BundleLocation";
export type BundleLocationRequest = WatchBundleLocationRequest;

export function bundleLocationTqk(args?: BundleLocationRequest) {
    return args ? [bundleLocationVerb, args] as const : [bundleLocationVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleLocation({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleLocationRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleLocationTqk(args),
        queryFn: () => 
mama.watchBundleLocation(args),
    });
}
// no rib query ensureTruckOrVenueById available
// TQP OUT
// TQOTOP
// TruckOrVenueStub is a stub
// WARNING: byIdWatcher WatchTruckOrVenueById for BundleLocation does not exist
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const orphanedBundlesVerb = "OrphanedBundles";

export const orphanedBundlesTqk = [orphanedBundlesVerb] as const;
// TQK OUT
// TQP IN

export function ensureOrphanedBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: orphanedBundlesTqk,
        queryFn: () => 
mama.watchOrphanedBundles(),
    });
}

export function ensureFullOrphanedBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureOrphanedBundles({tqc, mama}).then(tqrv => Promise.all(tqrv.orphans.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// OrphanedBundles takes no args
export function watchOrphanedBundlesTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: orphanedBundlesTqk,
        queryFn: () => 
mama.watchOrphanedBundles(),
        throwOnError: true,
        select: (data: WatchOrphanedBundlesResponse) => data.orphans,
});
}

export function useOrphanedBundles() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchOrphanedBundlesTqo(mama));
}

export function useFullOrphanedBundles() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useOrphanedBundles();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeBundleCountVerb = "ActiveBundleCount";

export const activeBundleCountTqk = [activeBundleCountVerb] as const;
// TQK OUT
// TQP IN

export function ensureActiveBundleCount({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: activeBundleCountTqk,
        queryFn: () => 
mama.activeBundleCount(),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// ActiveBundleCount takes no args
export function activeBundleCountTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: activeBundleCountTqk,
        queryFn: () => 
mama.activeBundleCount(),
        throwOnError: true,
        select: (data: ActiveBundleCountResponse) => data.bundleCount,
    });
}

export function useActiveBundleCount() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(activeBundleCountTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeBundlesVerb = "ActiveBundles";

export const activeBundlesTqk = [activeBundlesVerb] as const;
// TQK OUT
// TQP IN

export function ensureActiveBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: activeBundlesTqk,
        queryFn: () => 
mama.watchActiveBundles(),
    });
}

export function ensureFullActiveBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureActiveBundles({tqc, mama}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// ActiveBundles takes no args
export function watchActiveBundlesTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: activeBundlesTqk,
        queryFn: () => 
mama.watchActiveBundles(),
        throwOnError: true,
        select: (data: WatchActiveBundlesResponse) => data.bundles,
});
}

export function useActiveBundles() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchActiveBundlesTqo(mama));
}

export function useFullActiveBundles() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useActiveBundles();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeBundlePageVerb = "ActiveBundlePage";

export function activeBundlePageTqk(args?: ActiveBundlePageRequest) {
    return args ? [activeBundlePageVerb, args] as const : [activeBundlePageVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureActiveBundlePage({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlePageRequest}) {
    return tqc.ensureQueryData({
        queryKey: activeBundlePageTqk(args),
        queryFn: () => 
mama.activeBundlePage(args),
    });
}

export function ensureFullActiveBundlePage({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlePageRequest}) {
    return ensureActiveBundlePage({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// ActiveBundlePage can take arguments
export function activeBundlePageTqo(mama: KingBasura, args?: ActiveBundlePageRequest) {
    return queryOptions({
        queryKey: activeBundlePageTqk(args),
        queryFn: args
            ? () => 
mama.activeBundlePage(args)
            : skipToken,
        throwOnError: true,
		select: (data: ActiveBundlePageResponse) => data.bundles,
    });
}

export function useActiveBundlePage(args?: ActiveBundlePageRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(activeBundlePageTqo(mama, args));
}
export function useFullActiveBundlePage(args?: ActiveBundlePageRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useActiveBundlePage(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeBundlesDestinedForVerb = "ActiveBundlesDestinedFor";
export type ActiveBundlesDestinedForRequest = WatchActiveBundlesDestinedForRequest;

export function activeBundlesDestinedForTqk(args?: ActiveBundlesDestinedForRequest) {
    return args ? [activeBundlesDestinedForVerb, args] as const : [activeBundlesDestinedForVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureActiveBundlesDestinedFor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlesDestinedForRequest}) {
    return tqc.ensureQueryData({
        queryKey: activeBundlesDestinedForTqk(args),
        queryFn: () => 
mama.watchActiveBundlesDestinedFor(args),
    });
}

export function ensureFullActiveBundlesDestinedFor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlesDestinedForRequest}) {
    return ensureActiveBundlesDestinedFor({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// ActiveBundlesDestinedFor can take arguments
export function watchActiveBundlesDestinedForTqo(mama: KingBasura, args?: ActiveBundlesDestinedForRequest) {
    return queryOptions({
        queryKey: activeBundlesDestinedForTqk(args),
        queryFn: args
            ? () => 
mama.watchActiveBundlesDestinedFor(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchActiveBundlesDestinedForResponse) => data.bundles,
    });
}

export function useActiveBundlesDestinedFor(args?: ActiveBundlesDestinedForRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchActiveBundlesDestinedForTqo(mama, args));
}
export function useFullActiveBundlesDestinedFor(args?: ActiveBundlesDestinedForRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useActiveBundlesDestinedFor(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeBundlesOriginatingAtVerb = "ActiveBundlesOriginatingAt";
export type ActiveBundlesOriginatingAtRequest = WatchActiveBundlesOriginatingAtRequest;

export function activeBundlesOriginatingAtTqk(args?: ActiveBundlesOriginatingAtRequest) {
    return args ? [activeBundlesOriginatingAtVerb, args] as const : [activeBundlesOriginatingAtVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureActiveBundlesOriginatingAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlesOriginatingAtRequest}) {
    return tqc.ensureQueryData({
        queryKey: activeBundlesOriginatingAtTqk(args),
        queryFn: () => 
mama.watchActiveBundlesOriginatingAt(args),
    });
}

export function ensureFullActiveBundlesOriginatingAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveBundlesOriginatingAtRequest}) {
    return ensureActiveBundlesOriginatingAt({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// ActiveBundlesOriginatingAt can take arguments
export function watchActiveBundlesOriginatingAtTqo(mama: KingBasura, args?: ActiveBundlesOriginatingAtRequest) {
    return queryOptions({
        queryKey: activeBundlesOriginatingAtTqk(args),
        queryFn: args
            ? () => 
mama.watchActiveBundlesOriginatingAt(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchActiveBundlesOriginatingAtResponse) => data.bundles,
    });
}

export function useActiveBundlesOriginatingAt(args?: ActiveBundlesOriginatingAtRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchActiveBundlesOriginatingAtTqo(mama, args));
}
export function useFullActiveBundlesOriginatingAt(args?: ActiveBundlesOriginatingAtRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useActiveBundlesOriginatingAt(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const exportableBundlesVerb = "ExportableBundles";

export const exportableBundlesTqk = [exportableBundlesVerb] as const;
// TQK OUT
// TQP IN

export function ensureExportableBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: exportableBundlesTqk,
        queryFn: () => 
mama.watchExportableBundles(),
    });
}

export function ensureFullExportableBundles({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureExportableBundles({tqc, mama}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// ExportableBundles takes no args
export function watchExportableBundlesTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: exportableBundlesTqk,
        queryFn: () => 
mama.watchExportableBundles(),
        throwOnError: true,
        select: (data: WatchExportableBundlesResponse) => data.bundles,
});
}

export function useExportableBundles() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchExportableBundlesTqo(mama));
}

export function useFullExportableBundles() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useExportableBundles();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const inspectableBundlesVerb = "InspectableBundles";
export type InspectableBundlesRequest = WatchInspectableBundlesRequest;

export function inspectableBundlesTqk(args?: InspectableBundlesRequest) {
    return args ? [inspectableBundlesVerb, args] as const : [inspectableBundlesVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureInspectableBundles({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: InspectableBundlesRequest}) {
    return tqc.ensureQueryData({
        queryKey: inspectableBundlesTqk(args),
        queryFn: () => 
mama.watchInspectableBundles(args),
    });
}

export function ensureFullInspectableBundles({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: InspectableBundlesRequest}) {
    return ensureInspectableBundles({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// InspectableBundles can take arguments
export function watchInspectableBundlesTqo(mama: KingBasura, args?: InspectableBundlesRequest) {
    return queryOptions({
        queryKey: inspectableBundlesTqk(args),
        queryFn: args
            ? () => 
mama.watchInspectableBundles(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchInspectableBundlesResponse) => data.bundles,
    });
}

export function useInspectableBundles(args?: InspectableBundlesRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchInspectableBundlesTqo(mama, args));
}
export function useFullInspectableBundles(args?: InspectableBundlesRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useInspectableBundles(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundlesNeedingSupervisorVerb = "BundlesNeedingSupervisor";
export type BundlesNeedingSupervisorRequest = WatchBundlesNeedingSupervisorRequest;

export function bundlesNeedingSupervisorTqk(args?: BundlesNeedingSupervisorRequest) {
    return args ? [bundlesNeedingSupervisorVerb, args] as const : [bundlesNeedingSupervisorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundlesNeedingSupervisor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundlesNeedingSupervisorRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundlesNeedingSupervisorTqk(args),
        queryFn: () => 
mama.watchBundlesNeedingSupervisor(args),
    });
}

export function ensureFullBundlesNeedingSupervisor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundlesNeedingSupervisorRequest}) {
    return ensureBundlesNeedingSupervisor({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// BundlesNeedingSupervisor can take arguments
export function watchBundlesNeedingSupervisorTqo(mama: KingBasura, args?: BundlesNeedingSupervisorRequest) {
    return queryOptions({
        queryKey: bundlesNeedingSupervisorTqk(args),
        queryFn: args
            ? () => 
mama.watchBundlesNeedingSupervisor(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchBundlesNeedingSupervisorResponse) => data.bundles,
    });
}

export function useBundlesNeedingSupervisor(args?: BundlesNeedingSupervisorRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchBundlesNeedingSupervisorTqo(mama, args));
}
export function useFullBundlesNeedingSupervisor(args?: BundlesNeedingSupervisorRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useBundlesNeedingSupervisor(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const showExportedBundleVerb = "ShowExportedBundle";

export function showExportedBundleTqk(args?: ShowExportedBundleRequest) {
    return args ? [showExportedBundleVerb, args] as const : [showExportedBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureShowExportedBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ShowExportedBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: showExportedBundleTqk(args),
        queryFn: () => 
mama.showExportedBundle(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// ShowExportedBundle can take args
export function showExportedBundleTqo(mama: KingBasura, args ?: ShowExportedBundleRequest) {
    return queryOptions({
        queryKey: showExportedBundleTqk(args),
        queryFn: args
            ? () => 
mama.showExportedBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: ShowExportedBundleResponse) => data.exported,
    });
}

export function useShowExportedBundle(args ?: ShowExportedBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(showExportedBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const completeBundleHistoryByIdVerb = "CompleteBundleHistoryById";

export function completeBundleHistoryByIdTqk(args?: CompleteBundleHistoryByIdRequest) {
    return args ? [completeBundleHistoryByIdVerb, args] as const : [completeBundleHistoryByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompleteBundleHistoryById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompleteBundleHistoryByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: completeBundleHistoryByIdTqk(args),
        queryFn: () => 
mama.completeBundleHistoryById(args),
    });
}
// TQP OUT
// TQOTOP
// CompleteBundleHistory is not a stub
// CompleteBundleHistoryById can take args
export function completeBundleHistoryByIdTqo(mama: KingBasura, args ?: CompleteBundleHistoryByIdRequest) {
    return queryOptions({
        queryKey: completeBundleHistoryByIdTqk(args),
        queryFn: args
            ? () => 
mama.completeBundleHistoryById(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompleteBundleHistoryByIdResponse) => data.history,
    });
}

export function useCompleteBundleHistoryById(args ?: CompleteBundleHistoryByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(completeBundleHistoryByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleStampByIdVerb = "BundleStampById";

export function bundleStampByIdTqk(args?: BundleStampByIdRequest) {
    return args ? [bundleStampByIdVerb, args] as const : [bundleStampByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleStampById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleStampByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleStampByIdTqk(args),
        queryFn: () => 
mama.bundleStampById(args),
    });
}
// TQP OUT
// TQOTOP
// BundleStamp is not a stub
// BundleStampById can take args
export function bundleStampByIdTqo(mama: KingBasura, args ?: BundleStampByIdRequest) {
    return queryOptions({
        queryKey: bundleStampByIdTqk(args),
        queryFn: args
            ? () => 
mama.bundleStampById(args)
            : skipToken,
        throwOnError: true,
        select: (data: BundleStampByIdResponse) => data.stamp,
    });
}

export function useBundleStampById(args ?: BundleStampByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(bundleStampByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastFlavoredStampForBundleVerb = "LastFlavoredStampForBundle";

export function lastFlavoredStampForBundleTqk(args?: LastFlavoredStampForBundleRequest) {
    return args ? [lastFlavoredStampForBundleVerb, args] as const : [lastFlavoredStampForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastFlavoredStampForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastFlavoredStampForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastFlavoredStampForBundleTqk(args),
        queryFn: () => 
mama.lastFlavoredStampForBundle(args),
    });
}
// TQP OUT
// TQOTOP
// BundleStamp is not a stub
// LastFlavoredStampForBundle can take args
export function lastFlavoredStampForBundleTqo(mama: KingBasura, args ?: LastFlavoredStampForBundleRequest) {
    return queryOptions({
        queryKey: lastFlavoredStampForBundleTqk(args),
        queryFn: args
            ? () => 
mama.lastFlavoredStampForBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastFlavoredStampForBundleResponse) => data.stamp,
    });
}

export function useLastFlavoredStampForBundle(args ?: LastFlavoredStampForBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastFlavoredStampForBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForBundleVerb = "StampsForBundle";
export type StampsForBundleRequest = WatchStampsForBundleRequest;

export function stampsForBundleTqk(args?: StampsForBundleRequest) {
    return args ? [stampsForBundleVerb, args] as const : [stampsForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForBundleTqk(args),
        queryFn: () => 
mama.watchStampsForBundle(args),
    });
}
// TQP OUT
// TQOTOP
// BundleStamp is not a stub
// StampsForBundle can take args
export function watchStampsForBundleTqo(mama: KingBasura, args ?: StampsForBundleRequest) {
    return queryOptions({
        queryKey: stampsForBundleTqk(args),
        queryFn: args
            ? () => 
mama.watchStampsForBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchStampsForBundleResponse) => data.stamps,
    });
}

export function useStampsForBundle(args ?: StampsForBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchStampsForBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const flavoredStampsForBundleVerb = "FlavoredStampsForBundle";
export type FlavoredStampsForBundleRequest = WatchFlavoredStampsForBundleRequest;

export function flavoredStampsForBundleTqk(args?: FlavoredStampsForBundleRequest) {
    return args ? [flavoredStampsForBundleVerb, args] as const : [flavoredStampsForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureFlavoredStampsForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: FlavoredStampsForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: flavoredStampsForBundleTqk(args),
        queryFn: () => 
mama.watchFlavoredStampsForBundle(args),
    });
}
// TQP OUT
// TQOTOP
// BundleStamp is not a stub
// FlavoredStampsForBundle can take args
export function watchFlavoredStampsForBundleTqo(mama: KingBasura, args ?: FlavoredStampsForBundleRequest) {
    return queryOptions({
        queryKey: flavoredStampsForBundleTqk(args),
        queryFn: args
            ? () => 
mama.watchFlavoredStampsForBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchFlavoredStampsForBundleResponse) => data.stamps,
    });
}

export function useFlavoredStampsForBundle(args ?: FlavoredStampsForBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchFlavoredStampsForBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transferByIdVerb = "TransferById";
export type TransferByIdRequest = WatchTransferByIdRequest;

export function transferByIdTqk(args?: TransferByIdRequest) {
    return args ? [transferByIdVerb, args] as const : [transferByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTransferById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransferByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: transferByIdTqk(args),
        queryFn: () => 
mama.watchTransferById(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// TransferById can take args
export function watchTransferByIdTqo(mama: KingBasura, args ?: TransferByIdRequest) {
    return queryOptions({
        queryKey: transferByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchTransferById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchTransferByIdResponse) => data.transfer,
    });
}

export function useTransferById(args ?: TransferByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTransferByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allTransfersVerb = "AllTransfers";

export const allTransfersTqk = [allTransfersVerb] as const;
// TQK OUT
// TQP IN

export function ensureAllTransfers({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: allTransfersTqk,
        queryFn: () => 
mama.watchAllTransfers(),
    });
}

export function ensureFullAllTransfers({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureAllTransfers({tqc, mama}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// AllTransfers takes no args
export function watchAllTransfersTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: allTransfersTqk,
        queryFn: () => 
mama.watchAllTransfers(),
        throwOnError: true,
        select: (data: WatchAllTransfersResponse) => data.transfers,
});
}

export function useAllTransfers() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAllTransfersTqo(mama));
}

export function useFullAllTransfers() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useAllTransfers();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const openTransfersForTruckVerb = "OpenTransfersForTruck";
export type OpenTransfersForTruckRequest = WatchOpenTransfersForTruckRequest;

export function openTransfersForTruckTqk(args?: OpenTransfersForTruckRequest) {
    return args ? [openTransfersForTruckVerb, args] as const : [openTransfersForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureOpenTransfersForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: OpenTransfersForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: openTransfersForTruckTqk(args),
        queryFn: () => 
mama.watchOpenTransfersForTruck(args),
    });
}

export function ensureFullOpenTransfersForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: OpenTransfersForTruckRequest}) {
    return ensureOpenTransfersForTruck({tqc, mama, args}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// OpenTransfersForTruck can take arguments
export function watchOpenTransfersForTruckTqo(mama: KingBasura, args?: OpenTransfersForTruckRequest) {
    return queryOptions({
        queryKey: openTransfersForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchOpenTransfersForTruck(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchOpenTransfersForTruckResponse) => data.transfers,
    });
}

export function useOpenTransfersForTruck(args?: OpenTransfersForTruckRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchOpenTransfersForTruckTqo(mama, args));
}
export function useFullOpenTransfersForTruck(args?: OpenTransfersForTruckRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useOpenTransfersForTruck(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transfersForTruckVerb = "TransfersForTruck";
export type TransfersForTruckRequest = WatchTransfersForTruckRequest;

export function transfersForTruckTqk(args?: TransfersForTruckRequest) {
    return args ? [transfersForTruckVerb, args] as const : [transfersForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTransfersForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: transfersForTruckTqk(args),
        queryFn: () => 
mama.watchTransfersForTruck(args),
    });
}

export function ensureFullTransfersForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersForTruckRequest}) {
    return ensureTransfersForTruck({tqc, mama, args}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// TransfersForTruck can take arguments
export function watchTransfersForTruckTqo(mama: KingBasura, args?: TransfersForTruckRequest) {
    return queryOptions({
        queryKey: transfersForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchTransfersForTruck(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchTransfersForTruckResponse) => data.transfers,
    });
}

export function useTransfersForTruck(args?: TransfersForTruckRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTransfersForTruckTqo(mama, args));
}
export function useFullTransfersForTruck(args?: TransfersForTruckRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTransfersForTruck(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastTransferForBundleVerb = "LastTransferForBundle";
export type LastTransferForBundleRequest = WatchLastTransferForBundleRequest;

export function lastTransferForBundleTqk(args?: LastTransferForBundleRequest) {
    return args ? [lastTransferForBundleVerb, args] as const : [lastTransferForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastTransferForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastTransferForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastTransferForBundleTqk(args),
        queryFn: () => 
mama.watchLastTransferForBundle(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// LastTransferForBundle can take args
export function watchLastTransferForBundleTqo(mama: KingBasura, args ?: LastTransferForBundleRequest) {
    return queryOptions({
        queryKey: lastTransferForBundleTqk(args),
        queryFn: args
            ? () => 
mama.watchLastTransferForBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchLastTransferForBundleResponse) => data.transfer,
    });
}

export function useLastTransferForBundle(args ?: LastTransferForBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchLastTransferForBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastTransferForBundleBeforeVerb = "LastTransferForBundleBefore";

export function lastTransferForBundleBeforeTqk(args?: LastTransferForBundleBeforeRequest) {
    return args ? [lastTransferForBundleBeforeVerb, args] as const : [lastTransferForBundleBeforeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastTransferForBundleBefore({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastTransferForBundleBeforeRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastTransferForBundleBeforeTqk(args),
        queryFn: () => 
mama.lastTransferForBundleBefore(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// LastTransferForBundleBefore can take args
export function lastTransferForBundleBeforeTqo(mama: KingBasura, args ?: LastTransferForBundleBeforeRequest) {
    return queryOptions({
        queryKey: lastTransferForBundleBeforeTqk(args),
        queryFn: args
            ? () => 
mama.lastTransferForBundleBefore(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastTransferForBundleBeforeResponse) => data.transfer,
    });
}

export function useLastTransferForBundleBefore(args ?: LastTransferForBundleBeforeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastTransferForBundleBeforeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allTransfersForBundleVerb = "AllTransfersForBundle";

export function allTransfersForBundleTqk(args?: AllTransfersForBundleRequest) {
    return args ? [allTransfersForBundleVerb, args] as const : [allTransfersForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllTransfersForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllTransfersForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: allTransfersForBundleTqk(args),
        queryFn: () => 
mama.allTransfersForBundle(args),
    });
}

export function ensureFullAllTransfersForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllTransfersForBundleRequest}) {
    return ensureAllTransfersForBundle({tqc, mama, args}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// AllTransfersForBundle can take arguments
export function allTransfersForBundleTqo(mama: KingBasura, args?: AllTransfersForBundleRequest) {
    return queryOptions({
        queryKey: allTransfersForBundleTqk(args),
        queryFn: args
            ? () => 
mama.allTransfersForBundle(args)
            : skipToken,
        throwOnError: true,
		select: (data: AllTransfersForBundleResponse) => data.transfers,
    });
}

export function useAllTransfersForBundle(args?: AllTransfersForBundleRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allTransfersForBundleTqo(mama, args));
}
export function useFullAllTransfersForBundle(args?: AllTransfersForBundleRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useAllTransfersForBundle(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transfersForTruckDuringVerb = "TransfersForTruckDuring";

export function transfersForTruckDuringTqk(args?: TransfersForTruckDuringRequest) {
    return args ? [transfersForTruckDuringVerb, args] as const : [transfersForTruckDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTransfersForTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersForTruckDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: transfersForTruckDuringTqk(args),
        queryFn: () => 
mama.transfersForTruckDuring(args),
    });
}

export function ensureFullTransfersForTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersForTruckDuringRequest}) {
    return ensureTransfersForTruckDuring({tqc, mama, args}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// TransfersForTruckDuring can take arguments
export function transfersForTruckDuringTqo(mama: KingBasura, args?: TransfersForTruckDuringRequest) {
    return queryOptions({
        queryKey: transfersForTruckDuringTqk(args),
        queryFn: args
            ? () => 
mama.transfersForTruckDuring(args)
            : skipToken,
        throwOnError: true,
		select: (data: TransfersForTruckDuringResponse) => data.transfers,
    });
}

export function useTransfersForTruckDuring(args?: TransfersForTruckDuringRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(transfersForTruckDuringTqo(mama, args));
}
export function useFullTransfersForTruckDuring(args?: TransfersForTruckDuringRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTransfersForTruckDuring(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transfersAtVenueVerb = "TransfersAtVenue";
export type TransfersAtVenueRequest = WatchTransfersAtVenueRequest;

export function transfersAtVenueTqk(args?: TransfersAtVenueRequest) {
    return args ? [transfersAtVenueVerb, args] as const : [transfersAtVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTransfersAtVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersAtVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: transfersAtVenueTqk(args),
        queryFn: () => 
mama.watchTransfersAtVenue(args),
    });
}

export function ensureFullTransfersAtVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransfersAtVenueRequest}) {
    return ensureTransfersAtVenue({tqc, mama, args}).then(tqrv => Promise.all(tqrv.transfers.map(stub => ensureTransferById({tqc, mama, args: {transferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TransferStub is a stub
// []TransferStub is a slice
// TransfersAtVenue can take arguments
export function watchTransfersAtVenueTqo(mama: KingBasura, args?: TransfersAtVenueRequest) {
    return queryOptions({
        queryKey: transfersAtVenueTqk(args),
        queryFn: args
            ? () => 
mama.watchTransfersAtVenue(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchTransfersAtVenueResponse) => data.transfers,
    });
}

export function useTransfersAtVenue(args?: TransfersAtVenueRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTransfersAtVenueTqo(mama, args));
}
export function useFullTransfersAtVenue(args?: TransfersAtVenueRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTransfersAtVenue(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {transferId: stub.id} as const;
        return {
            queryKey: transferByIdTqk(ribRequest),
            queryFn: () => mama.watchTransferById(ribRequest),
            select: (data: WatchTransferByIdResponse) => data.transfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const triplegByIdVerb = "TriplegById";
export type TriplegByIdRequest = WatchTriplegByIdRequest;

export function triplegByIdTqk(args?: TriplegByIdRequest) {
    return args ? [triplegByIdVerb, args] as const : [triplegByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTriplegById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: triplegByIdTqk(args),
        queryFn: () => 
mama.watchTriplegById(args),
    });
}
// TQP OUT
// TQOTOP
// Tripleg is not a stub
// TriplegById can take args
export function watchTriplegByIdTqo(mama: KingBasura, args ?: TriplegByIdRequest) {
    return queryOptions({
        queryKey: triplegByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchTriplegById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchTriplegByIdResponse) => data.tripleg,
    });
}

export function useTriplegById(args ?: TriplegByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTriplegByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allTriplegsVerb = "AllTriplegs";

export const allTriplegsTqk = [allTriplegsVerb] as const;
// TQK OUT
// TQP IN

export function ensureAllTriplegs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: allTriplegsTqk,
        queryFn: () => 
mama.watchAllTriplegs(),
    });
}

export function ensureFullAllTriplegs({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureAllTriplegs({tqc, mama}).then(tqrv => Promise.all(tqrv.triplegs.map(stub => ensureTriplegById({tqc, mama, args: {triplegId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TriplegStub is a stub
// []TriplegStub is a slice
// AllTriplegs takes no args
export function watchAllTriplegsTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: allTriplegsTqk,
        queryFn: () => 
mama.watchAllTriplegs(),
        throwOnError: true,
        select: (data: WatchAllTriplegsResponse) => data.triplegs,
});
}

export function useAllTriplegs() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAllTriplegsTqo(mama));
}

export function useFullAllTriplegs() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useAllTriplegs();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {triplegId: stub.id} as const;
        return {
            queryKey: triplegByIdTqk(ribRequest),
            queryFn: () => mama.watchTriplegById(ribRequest),
            select: (data: WatchTriplegByIdResponse) => data.tripleg,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const openTriplegForTruckVerb = "OpenTriplegForTruck";
export type OpenTriplegForTruckRequest = WatchOpenTriplegForTruckRequest;

export function openTriplegForTruckTqk(args?: OpenTriplegForTruckRequest) {
    return args ? [openTriplegForTruckVerb, args] as const : [openTriplegForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureOpenTriplegForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: OpenTriplegForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: openTriplegForTruckTqk(args),
        queryFn: () => 
mama.watchOpenTriplegForTruck(args),
    });
}
// TQP OUT
// TQOTOP
// Tripleg is not a stub
// OpenTriplegForTruck can take args
export function watchOpenTriplegForTruckTqo(mama: KingBasura, args ?: OpenTriplegForTruckRequest) {
    return queryOptions({
        queryKey: openTriplegForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchOpenTriplegForTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchOpenTriplegForTruckResponse) => data.tripleg,
    });
}

export function useOpenTriplegForTruck(args ?: OpenTriplegForTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchOpenTriplegForTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastTriplegForTruckVerb = "LastTriplegForTruck";
export type LastTriplegForTruckRequest = WatchLastTriplegForTruckRequest;

export function lastTriplegForTruckTqk(args?: LastTriplegForTruckRequest) {
    return args ? [lastTriplegForTruckVerb, args] as const : [lastTriplegForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastTriplegForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastTriplegForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastTriplegForTruckTqk(args),
        queryFn: () => 
mama.watchLastTriplegForTruck(args),
    });
}
// TQP OUT
// TQOTOP
// Tripleg is not a stub
// LastTriplegForTruck can take args
export function watchLastTriplegForTruckTqo(mama: KingBasura, args ?: LastTriplegForTruckRequest) {
    return queryOptions({
        queryKey: lastTriplegForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchLastTriplegForTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchLastTriplegForTruckResponse) => data.tripleg,
    });
}

export function useLastTriplegForTruck(args ?: LastTriplegForTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchLastTriplegForTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const triplegsForTruckVerb = "TriplegsForTruck";
export type TriplegsForTruckRequest = WatchTriplegsForTruckRequest;

export function triplegsForTruckTqk(args?: TriplegsForTruckRequest) {
    return args ? [triplegsForTruckVerb, args] as const : [triplegsForTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTriplegsForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsForTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: triplegsForTruckTqk(args),
        queryFn: () => 
mama.watchTriplegsForTruck(args),
    });
}

export function ensureFullTriplegsForTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsForTruckRequest}) {
    return ensureTriplegsForTruck({tqc, mama, args}).then(tqrv => Promise.all(tqrv.triplegs.map(stub => ensureTriplegById({tqc, mama, args: {triplegId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TriplegStub is a stub
// []TriplegStub is a slice
// TriplegsForTruck can take arguments
export function watchTriplegsForTruckTqo(mama: KingBasura, args?: TriplegsForTruckRequest) {
    return queryOptions({
        queryKey: triplegsForTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchTriplegsForTruck(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchTriplegsForTruckResponse) => data.triplegs,
    });
}

export function useTriplegsForTruck(args?: TriplegsForTruckRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTriplegsForTruckTqo(mama, args));
}
export function useFullTriplegsForTruck(args?: TriplegsForTruckRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTriplegsForTruck(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {triplegId: stub.id} as const;
        return {
            queryKey: triplegByIdTqk(ribRequest),
            queryFn: () => mama.watchTriplegById(ribRequest),
            select: (data: WatchTriplegByIdResponse) => data.tripleg,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const triplegsForTruckDuringVerb = "TriplegsForTruckDuring";

export function triplegsForTruckDuringTqk(args?: TriplegsForTruckDuringRequest) {
    return args ? [triplegsForTruckDuringVerb, args] as const : [triplegsForTruckDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTriplegsForTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsForTruckDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: triplegsForTruckDuringTqk(args),
        queryFn: () => 
mama.triplegsForTruckDuring(args),
    });
}

export function ensureFullTriplegsForTruckDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsForTruckDuringRequest}) {
    return ensureTriplegsForTruckDuring({tqc, mama, args}).then(tqrv => Promise.all(tqrv.triplegs.map(stub => ensureTriplegById({tqc, mama, args: {triplegId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TriplegStub is a stub
// []TriplegStub is a slice
// TriplegsForTruckDuring can take arguments
export function triplegsForTruckDuringTqo(mama: KingBasura, args?: TriplegsForTruckDuringRequest) {
    return queryOptions({
        queryKey: triplegsForTruckDuringTqk(args),
        queryFn: args
            ? () => 
mama.triplegsForTruckDuring(args)
            : skipToken,
        throwOnError: true,
		select: (data: TriplegsForTruckDuringResponse) => data.triplegs,
    });
}

export function useTriplegsForTruckDuring(args?: TriplegsForTruckDuringRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(triplegsForTruckDuringTqo(mama, args));
}
export function useFullTriplegsForTruckDuring(args?: TriplegsForTruckDuringRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTriplegsForTruckDuring(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {triplegId: stub.id} as const;
        return {
            queryKey: triplegByIdTqk(ribRequest),
            queryFn: () => mama.watchTriplegById(ribRequest),
            select: (data: WatchTriplegByIdResponse) => data.tripleg,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const unadmittedTriplegsIntoVerb = "UnadmittedTriplegsInto";
export type UnadmittedTriplegsIntoRequest = WatchUnadmittedTriplegsIntoRequest;

export function unadmittedTriplegsIntoTqk(args?: UnadmittedTriplegsIntoRequest) {
    return args ? [unadmittedTriplegsIntoVerb, args] as const : [unadmittedTriplegsIntoVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUnadmittedTriplegsInto({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UnadmittedTriplegsIntoRequest}) {
    return tqc.ensureQueryData({
        queryKey: unadmittedTriplegsIntoTqk(args),
        queryFn: () => 
mama.watchUnadmittedTriplegsInto(args),
    });
}

export function ensureFullUnadmittedTriplegsInto({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UnadmittedTriplegsIntoRequest}) {
    return ensureUnadmittedTriplegsInto({tqc, mama, args}).then(tqrv => Promise.all(tqrv.triplegs.map(stub => ensureTriplegById({tqc, mama, args: {triplegId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TriplegStub is a stub
// []TriplegStub is a slice
// UnadmittedTriplegsInto can take arguments
export function watchUnadmittedTriplegsIntoTqo(mama: KingBasura, args?: UnadmittedTriplegsIntoRequest) {
    return queryOptions({
        queryKey: unadmittedTriplegsIntoTqk(args),
        queryFn: args
            ? () => 
mama.watchUnadmittedTriplegsInto(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchUnadmittedTriplegsIntoResponse) => data.triplegs,
    });
}

export function useUnadmittedTriplegsInto(args?: UnadmittedTriplegsIntoRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchUnadmittedTriplegsIntoTqo(mama, args));
}
export function useFullUnadmittedTriplegsInto(args?: UnadmittedTriplegsIntoRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useUnadmittedTriplegsInto(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {triplegId: stub.id} as const;
        return {
            queryKey: triplegByIdTqk(ribRequest),
            queryFn: () => mama.watchTriplegById(ribRequest),
            select: (data: WatchTriplegByIdResponse) => data.tripleg,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const triplegsInboundToVerb = "TriplegsInboundTo";
export type TriplegsInboundToRequest = WatchTriplegsInboundToRequest;

export function triplegsInboundToTqk(args?: TriplegsInboundToRequest) {
    return args ? [triplegsInboundToVerb, args] as const : [triplegsInboundToVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTriplegsInboundTo({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsInboundToRequest}) {
    return tqc.ensureQueryData({
        queryKey: triplegsInboundToTqk(args),
        queryFn: () => 
mama.watchTriplegsInboundTo(args),
    });
}

export function ensureFullTriplegsInboundTo({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TriplegsInboundToRequest}) {
    return ensureTriplegsInboundTo({tqc, mama, args}).then(tqrv => Promise.all(tqrv.triplegs.map(stub => ensureTriplegById({tqc, mama, args: {triplegId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []TriplegStub is a stub
// []TriplegStub is a slice
// TriplegsInboundTo can take arguments
export function watchTriplegsInboundToTqo(mama: KingBasura, args?: TriplegsInboundToRequest) {
    return queryOptions({
        queryKey: triplegsInboundToTqk(args),
        queryFn: args
            ? () => 
mama.watchTriplegsInboundTo(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchTriplegsInboundToResponse) => data.triplegs,
    });
}

export function useTriplegsInboundTo(args?: TriplegsInboundToRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchTriplegsInboundToTqo(mama, args));
}
export function useFullTriplegsInboundTo(args?: TriplegsInboundToRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useTriplegsInboundTo(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {triplegId: stub.id} as const;
        return {
            queryKey: triplegByIdTqk(ribRequest),
            queryFn: () => mama.watchTriplegById(ribRequest),
            select: (data: WatchTriplegByIdResponse) => data.tripleg,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransferByIdVerb = "ScheduledTransferById";
export type ScheduledTransferByIdRequest = WatchScheduledTransferByIdRequest;

export function scheduledTransferByIdTqk(args?: ScheduledTransferByIdRequest) {
    return args ? [scheduledTransferByIdVerb, args] as const : [scheduledTransferByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransferById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransferByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransferByIdTqk(args),
        queryFn: () => 
mama.watchScheduledTransferById(args),
    });
}
// TQP OUT
// TQOTOP
// ScheduledTransfer is not a stub
// ScheduledTransferById can take args
export function watchScheduledTransferByIdTqo(mama: KingBasura, args ?: ScheduledTransferByIdRequest) {
    return queryOptions({
        queryKey: scheduledTransferByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchScheduledTransferById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
    });
}

export function useScheduledTransferById(args ?: ScheduledTransferByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransferByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransferForBundleVerb = "ScheduledTransferForBundle";
export type ScheduledTransferForBundleRequest = WatchScheduledTransferForBundleRequest;

export function scheduledTransferForBundleTqk(args?: ScheduledTransferForBundleRequest) {
    return args ? [scheduledTransferForBundleVerb, args] as const : [scheduledTransferForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransferForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransferForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransferForBundleTqk(args),
        queryFn: () => 
mama.watchScheduledTransferForBundle(args),
    });
}
// TQP OUT
// TQOTOP
// ScheduledTransfer is not a stub
// ScheduledTransferForBundle can take args
export function watchScheduledTransferForBundleTqo(mama: KingBasura, args ?: ScheduledTransferForBundleRequest) {
    return queryOptions({
        queryKey: scheduledTransferForBundleTqk(args),
        queryFn: args
            ? () => 
mama.watchScheduledTransferForBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchScheduledTransferForBundleResponse) => data.scheduledTransfer,
    });
}

export function useScheduledTransferForBundle(args ?: ScheduledTransferForBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransferForBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransfersForDriverVerb = "ScheduledTransfersForDriver";
export type ScheduledTransfersForDriverRequest = WatchScheduledTransfersForDriverRequest;

export function scheduledTransfersForDriverTqk(args?: ScheduledTransfersForDriverRequest) {
    return args ? [scheduledTransfersForDriverVerb, args] as const : [scheduledTransfersForDriverVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransfersForDriver({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersForDriverRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransfersForDriverTqk(args),
        queryFn: () => 
mama.watchScheduledTransfersForDriver(args),
    });
}

export function ensureFullScheduledTransfersForDriver({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersForDriverRequest}) {
    return ensureScheduledTransfersForDriver({tqc, mama, args}).then(tqrv => Promise.all(tqrv.scheduledTransfers.map(stub => ensureScheduledTransferById({tqc, mama, args: {scheduledTransferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []ScheduledTransferStub is a stub
// []ScheduledTransferStub is a slice
// ScheduledTransfersForDriver can take arguments
export function watchScheduledTransfersForDriverTqo(mama: KingBasura, args?: ScheduledTransfersForDriverRequest) {
    return queryOptions({
        queryKey: scheduledTransfersForDriverTqk(args),
        queryFn: args
            ? () => 
mama.watchScheduledTransfersForDriver(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchScheduledTransfersForDriverResponse) => data.scheduledTransfers,
    });
}

export function useScheduledTransfersForDriver(args?: ScheduledTransfersForDriverRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransfersForDriverTqo(mama, args));
}
export function useFullScheduledTransfersForDriver(args?: ScheduledTransfersForDriverRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useScheduledTransfersForDriver(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {scheduledTransferId: stub.id} as const;
        return {
            queryKey: scheduledTransferByIdTqk(ribRequest),
            queryFn: () => mama.watchScheduledTransferById(ribRequest),
            select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransfersAwaitingTruckVerb = "ScheduledTransfersAwaitingTruck";
export type ScheduledTransfersAwaitingTruckRequest = WatchScheduledTransfersAwaitingTruckRequest;

export function scheduledTransfersAwaitingTruckTqk(args?: ScheduledTransfersAwaitingTruckRequest) {
    return args ? [scheduledTransfersAwaitingTruckVerb, args] as const : [scheduledTransfersAwaitingTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransfersAwaitingTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersAwaitingTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransfersAwaitingTruckTqk(args),
        queryFn: () => 
mama.watchScheduledTransfersAwaitingTruck(args),
    });
}

export function ensureFullScheduledTransfersAwaitingTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersAwaitingTruckRequest}) {
    return ensureScheduledTransfersAwaitingTruck({tqc, mama, args}).then(tqrv => Promise.all(tqrv.scheduledTransfers.map(stub => ensureScheduledTransferById({tqc, mama, args: {scheduledTransferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []ScheduledTransferStub is a stub
// []ScheduledTransferStub is a slice
// ScheduledTransfersAwaitingTruck can take arguments
export function watchScheduledTransfersAwaitingTruckTqo(mama: KingBasura, args?: ScheduledTransfersAwaitingTruckRequest) {
    return queryOptions({
        queryKey: scheduledTransfersAwaitingTruckTqk(args),
        queryFn: args
            ? () => 
mama.watchScheduledTransfersAwaitingTruck(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchScheduledTransfersAwaitingTruckResponse) => data.scheduledTransfers,
    });
}

export function useScheduledTransfersAwaitingTruck(args?: ScheduledTransfersAwaitingTruckRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransfersAwaitingTruckTqo(mama, args));
}
export function useFullScheduledTransfersAwaitingTruck(args?: ScheduledTransfersAwaitingTruckRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useScheduledTransfersAwaitingTruck(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {scheduledTransferId: stub.id} as const;
        return {
            queryKey: scheduledTransferByIdTqk(ribRequest),
            queryFn: () => mama.watchScheduledTransferById(ribRequest),
            select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransfersDuringVerb = "ScheduledTransfersDuring";

export function scheduledTransfersDuringTqk(args?: ScheduledTransfersDuringRequest) {
    return args ? [scheduledTransfersDuringVerb, args] as const : [scheduledTransfersDuringVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransfersDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersDuringRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransfersDuringTqk(args),
        queryFn: () => 
mama.scheduledTransfersDuring(args),
    });
}

export function ensureFullScheduledTransfersDuring({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersDuringRequest}) {
    return ensureScheduledTransfersDuring({tqc, mama, args}).then(tqrv => Promise.all(tqrv.scheduledTransfers.map(stub => ensureScheduledTransferById({tqc, mama, args: {scheduledTransferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []ScheduledTransferStub is a stub
// []ScheduledTransferStub is a slice
// ScheduledTransfersDuring can take arguments
export function scheduledTransfersDuringTqo(mama: KingBasura, args?: ScheduledTransfersDuringRequest) {
    return queryOptions({
        queryKey: scheduledTransfersDuringTqk(args),
        queryFn: args
            ? () => 
mama.scheduledTransfersDuring(args)
            : skipToken,
        throwOnError: true,
		select: (data: ScheduledTransfersDuringResponse) => data.scheduledTransfers,
    });
}

export function useScheduledTransfersDuring(args?: ScheduledTransfersDuringRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(scheduledTransfersDuringTqo(mama, args));
}
export function useFullScheduledTransfersDuring(args?: ScheduledTransfersDuringRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useScheduledTransfersDuring(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {scheduledTransferId: stub.id} as const;
        return {
            queryKey: scheduledTransferByIdTqk(ribRequest),
            queryFn: () => mama.watchScheduledTransferById(ribRequest),
            select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransfersAtVerb = "ScheduledTransfersAt";
export type ScheduledTransfersAtRequest = WatchScheduledTransfersAtRequest;

export function scheduledTransfersAtTqk(args?: ScheduledTransfersAtRequest) {
    return args ? [scheduledTransfersAtVerb, args] as const : [scheduledTransfersAtVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduledTransfersAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersAtRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransfersAtTqk(args),
        queryFn: () => 
mama.watchScheduledTransfersAt(args),
    });
}

export function ensureFullScheduledTransfersAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduledTransfersAtRequest}) {
    return ensureScheduledTransfersAt({tqc, mama, args}).then(tqrv => Promise.all(tqrv.scheduledTransfers.map(stub => ensureScheduledTransferById({tqc, mama, args: {scheduledTransferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []ScheduledTransferStub is a stub
// []ScheduledTransferStub is a slice
// ScheduledTransfersAt can take arguments
export function watchScheduledTransfersAtTqo(mama: KingBasura, args?: ScheduledTransfersAtRequest) {
    return queryOptions({
        queryKey: scheduledTransfersAtTqk(args),
        queryFn: args
            ? () => 
mama.watchScheduledTransfersAt(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchScheduledTransfersAtResponse) => data.scheduledTransfers,
    });
}

export function useScheduledTransfersAt(args?: ScheduledTransfersAtRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransfersAtTqo(mama, args));
}
export function useFullScheduledTransfersAt(args?: ScheduledTransfersAtRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useScheduledTransfersAt(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {scheduledTransferId: stub.id} as const;
        return {
            queryKey: scheduledTransferByIdTqk(ribRequest),
            queryFn: () => mama.watchScheduledTransferById(ribRequest),
            select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduledTransfersForDispatchVerb = "ScheduledTransfersForDispatch";

export const scheduledTransfersForDispatchTqk = [scheduledTransfersForDispatchVerb] as const;
// TQK OUT
// TQP IN

export function ensureScheduledTransfersForDispatch({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: scheduledTransfersForDispatchTqk,
        queryFn: () => 
mama.watchScheduledTransfersForDispatch(),
    });
}

export function ensureFullScheduledTransfersForDispatch({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return ensureScheduledTransfersForDispatch({tqc, mama}).then(tqrv => Promise.all(tqrv.scheduledTransfers.map(stub => ensureScheduledTransferById({tqc, mama, args: {scheduledTransferId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []ScheduledTransferStub is a stub
// []ScheduledTransferStub is a slice
// ScheduledTransfersForDispatch takes no args
export function watchScheduledTransfersForDispatchTqo(mama: KingBasura) {
    return queryOptions({
        queryKey: scheduledTransfersForDispatchTqk,
        queryFn: () => 
mama.watchScheduledTransfersForDispatch(),
        throwOnError: true,
        select: (data: WatchScheduledTransfersForDispatchResponse) => data.scheduledTransfers,
});
}

export function useScheduledTransfersForDispatch() {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchScheduledTransfersForDispatchTqo(mama));
}

export function useFullScheduledTransfersForDispatch() {
    const mama = useKingBasuraMothership();
	const stubsTqrv = useScheduledTransfersForDispatch();
	// let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {scheduledTransferId: stub.id} as const;
        return {
            queryKey: scheduledTransferByIdTqk(ribRequest),
            queryFn: () => mama.watchScheduledTransferById(ribRequest),
            select: (data: WatchScheduledTransferByIdResponse) => data.scheduledTransfer,
        } as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

    /* having combine be constant even if the spine query has not settled yet
     * seemed to be causing problems whereby success with empty arrays was
     * getting through
     */
     const uqsrv = useQueries(stubsTqrv.isSuccess
	 ? {
		 queries: qos,
		 combine: mergeUseQueriesWithInfill,
	 } : {queries: NADA});


    if (stubsTqrv.isPending) {
        return pendingUseResult;
    }

    // return {...uqsrv, dataUpdatedAt};
	 return uqsrv;
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteFlavorByCodeVerb = "WasteFlavorByCode";

export function wasteFlavorByCodeTqk(args?: WasteFlavorByCodeRequest) {
    return args ? [wasteFlavorByCodeVerb, args] as const : [wasteFlavorByCodeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteFlavorByCode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteFlavorByCodeRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteFlavorByCodeTqk(args),
        queryFn: () => 
mama.wasteFlavorByCode(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavor is not a stub
// WasteFlavorByCode can take args
export function wasteFlavorByCodeTqo(mama: KingBasura, args ?: WasteFlavorByCodeRequest) {
    return queryOptions({
        queryKey: wasteFlavorByCodeTqk(args),
        queryFn: args
            ? () => 
mama.wasteFlavorByCode(args)
            : skipToken,
        throwOnError: true,
        select: (data: WasteFlavorByCodeResponse) => data.flavor,
    });
}

export function useWasteFlavorByCode(args ?: WasteFlavorByCodeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wasteFlavorByCodeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteFlavorByIdVerb = "WasteFlavorById";
export type WasteFlavorByIdRequest = WatchWasteFlavorByIdRequest;

export function wasteFlavorByIdTqk(args?: WasteFlavorByIdRequest) {
    return args ? [wasteFlavorByIdVerb, args] as const : [wasteFlavorByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteFlavorById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteFlavorByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteFlavorByIdTqk(args),
        queryFn: () => 
mama.watchWasteFlavorById(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavor is not a stub
// WasteFlavorById can take args
export function watchWasteFlavorByIdTqo(mama: KingBasura, args ?: WasteFlavorByIdRequest) {
    return queryOptions({
        queryKey: wasteFlavorByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchWasteFlavorById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchWasteFlavorByIdResponse) => data.flavor,
    });
}

export function useWasteFlavorById(args ?: WasteFlavorByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchWasteFlavorByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidWasteFlavorByIdVerb = "LastValidWasteFlavorById";

export function lastValidWasteFlavorByIdTqk(args?: LastValidWasteFlavorByIdRequest) {
    return args ? [lastValidWasteFlavorByIdVerb, args] as const : [lastValidWasteFlavorByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidWasteFlavorById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidWasteFlavorByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidWasteFlavorByIdTqk(args),
        queryFn: () => 
mama.lastValidWasteFlavorById(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavor is not a stub
// LastValidWasteFlavorById can take args
export function lastValidWasteFlavorByIdTqo(mama: KingBasura, args ?: LastValidWasteFlavorByIdRequest) {
    return queryOptions({
        queryKey: lastValidWasteFlavorByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidWasteFlavorById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidWasteFlavorByIdResponse) => data.flavor,
    });
}

export function useLastValidWasteFlavorById(args ?: LastValidWasteFlavorByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidWasteFlavorByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteFlavorRevisionCountVerb = "WasteFlavorRevisionCount";

export function wasteFlavorRevisionCountTqk(args?: WasteFlavorRevisionCountRequest) {
    return args ? [wasteFlavorRevisionCountVerb, args] as const : [wasteFlavorRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteFlavorRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteFlavorRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteFlavorRevisionCountTqk(args),
        queryFn: () => 
mama.wasteFlavorRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// WasteFlavorRevisionCount can take args
export function wasteFlavorRevisionCountTqo(mama: KingBasura, args ?: WasteFlavorRevisionCountRequest) {
    return queryOptions({
        queryKey: wasteFlavorRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.wasteFlavorRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: WasteFlavorRevisionCountResponse) => data.revisionCount,
    });
}

export function useWasteFlavorRevisionCount(args ?: WasteFlavorRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wasteFlavorRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allWasteFlavorRevisionsVerb = "AllWasteFlavorRevisions";

export function allWasteFlavorRevisionsTqk(args?: AllWasteFlavorRevisionsRequest) {
    return args ? [allWasteFlavorRevisionsVerb, args] as const : [allWasteFlavorRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllWasteFlavorRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllWasteFlavorRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allWasteFlavorRevisionsTqk(args),
        queryFn: () => 
mama.allWasteFlavorRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavor is not a stub
// AllWasteFlavorRevisions can take args
export function allWasteFlavorRevisionsTqo(mama: KingBasura, args ?: AllWasteFlavorRevisionsRequest) {
    return queryOptions({
        queryKey: allWasteFlavorRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allWasteFlavorRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllWasteFlavorRevisionsResponse) => data.revisions,
    });
}

export function useAllWasteFlavorRevisions(args ?: AllWasteFlavorRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allWasteFlavorRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const activeWasteFlavorsVerb = "ActiveWasteFlavors";

export function activeWasteFlavorsTqk(args?: ActiveWasteFlavorsRequest) {
    return args ? [activeWasteFlavorsVerb, args] as const : [activeWasteFlavorsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureActiveWasteFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveWasteFlavorsRequest}) {
    return tqc.ensureQueryData({
        queryKey: activeWasteFlavorsTqk(args),
        queryFn: () => 
mama.activeWasteFlavors(args),
    });
}

export function ensureFullActiveWasteFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ActiveWasteFlavorsRequest}) {
    return ensureActiveWasteFlavors({tqc, mama, args}).then(tqrv => Promise.all(tqrv.flavorStubs.map(stub => ensureWasteFlavorById({tqc, mama, args: {wasteFlavorId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteFlavorStub is a stub
// []WasteFlavorStub is a slice
// ActiveWasteFlavors can take arguments
export function activeWasteFlavorsTqo(mama: KingBasura, args?: ActiveWasteFlavorsRequest) {
    return queryOptions({
        queryKey: activeWasteFlavorsTqk(args),
        queryFn: args
            ? () => 
mama.activeWasteFlavors(args)
            : skipToken,
        throwOnError: true,
		select: (data: ActiveWasteFlavorsResponse) => data.flavorStubs,
    });
}

export function useActiveWasteFlavors(args?: ActiveWasteFlavorsRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(activeWasteFlavorsTqo(mama, args));
}
export function useFullActiveWasteFlavors(args?: ActiveWasteFlavorsRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useActiveWasteFlavors(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteFlavorId: stub.id} as const;
        return {
            queryKey: wasteFlavorByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteFlavorById(ribRequest),
            select: (data: WatchWasteFlavorByIdResponse) => data.flavor,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const getCleavableFlavorsVerb = "GetCleavableFlavors";

export function getCleavableFlavorsTqk(args?: GetCleavableFlavorsRequest) {
    return args ? [getCleavableFlavorsVerb, args] as const : [getCleavableFlavorsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureGetCleavableFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: GetCleavableFlavorsRequest}) {
    return tqc.ensureQueryData({
        queryKey: getCleavableFlavorsTqk(args),
        queryFn: () => 
mama.getCleavableFlavors(args),
    });
}

export function ensureFullGetCleavableFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: GetCleavableFlavorsRequest}) {
    return ensureGetCleavableFlavors({tqc, mama, args}).then(tqrv => Promise.all(tqrv.flavors.map(stub => ensureWasteFlavorById({tqc, mama, args: {wasteFlavorId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteFlavorStub is a stub
// []WasteFlavorStub is a slice
// GetCleavableFlavors can take arguments
export function getCleavableFlavorsTqo(mama: KingBasura, args?: GetCleavableFlavorsRequest) {
    return queryOptions({
        queryKey: getCleavableFlavorsTqk(args),
        queryFn: args
            ? () => 
mama.getCleavableFlavors(args)
            : skipToken,
        throwOnError: true,
		select: (data: GetCleavableFlavorsResponse) => data.flavors,
    });
}

export function useGetCleavableFlavors(args?: GetCleavableFlavorsRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(getCleavableFlavorsTqo(mama, args));
}
export function useFullGetCleavableFlavors(args?: GetCleavableFlavorsRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useGetCleavableFlavors(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteFlavorId: stub.id} as const;
        return {
            queryKey: wasteFlavorByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteFlavorById(ribRequest),
            select: (data: WatchWasteFlavorByIdResponse) => data.flavor,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const getEmissibleFlavorsVerb = "GetEmissibleFlavors";

export function getEmissibleFlavorsTqk(args?: GetEmissibleFlavorsRequest) {
    return args ? [getEmissibleFlavorsVerb, args] as const : [getEmissibleFlavorsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureGetEmissibleFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: GetEmissibleFlavorsRequest}) {
    return tqc.ensureQueryData({
        queryKey: getEmissibleFlavorsTqk(args),
        queryFn: () => 
mama.getEmissibleFlavors(args),
    });
}

export function ensureFullGetEmissibleFlavors({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: GetEmissibleFlavorsRequest}) {
    return ensureGetEmissibleFlavors({tqc, mama, args}).then(tqrv => Promise.all(tqrv.flavors.map(stub => ensureWasteFlavorById({tqc, mama, args: {wasteFlavorId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteFlavorStub is a stub
// []WasteFlavorStub is a slice
// GetEmissibleFlavors can take arguments
export function getEmissibleFlavorsTqo(mama: KingBasura, args?: GetEmissibleFlavorsRequest) {
    return queryOptions({
        queryKey: getEmissibleFlavorsTqk(args),
        queryFn: args
            ? () => 
mama.getEmissibleFlavors(args)
            : skipToken,
        throwOnError: true,
		select: (data: GetEmissibleFlavorsResponse) => data.flavors,
    });
}

export function useGetEmissibleFlavors(args?: GetEmissibleFlavorsRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(getEmissibleFlavorsTqo(mama, args));
}
export function useFullGetEmissibleFlavors(args?: GetEmissibleFlavorsRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useGetEmissibleFlavors(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteFlavorId: stub.id} as const;
        return {
            queryKey: wasteFlavorByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteFlavorById(ribRequest),
            select: (data: WatchWasteFlavorByIdResponse) => data.flavor,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteByIdVerb = "WasteById";
export type WasteByIdRequest = WatchWasteByIdRequest;

export function wasteByIdTqk(args?: WasteByIdRequest) {
    return args ? [wasteByIdVerb, args] as const : [wasteByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteByIdTqk(args),
        queryFn: () => 
mama.watchWasteById(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// WasteById can take args
export function watchWasteByIdTqo(mama: KingBasura, args ?: WasteByIdRequest) {
    return queryOptions({
        queryKey: wasteByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchWasteById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchWasteByIdResponse) => data.waste,
    });
}

export function useWasteById(args ?: WasteByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchWasteByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidWasteByIdVerb = "LastValidWasteById";

export function lastValidWasteByIdTqk(args?: LastValidWasteByIdRequest) {
    return args ? [lastValidWasteByIdVerb, args] as const : [lastValidWasteByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidWasteById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidWasteByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidWasteByIdTqk(args),
        queryFn: () => 
mama.lastValidWasteById(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// LastValidWasteById can take args
export function lastValidWasteByIdTqo(mama: KingBasura, args ?: LastValidWasteByIdRequest) {
    return queryOptions({
        queryKey: lastValidWasteByIdTqk(args),
        queryFn: args
            ? () => 
mama.lastValidWasteById(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidWasteByIdResponse) => data.waste,
    });
}

export function useLastValidWasteById(args ?: LastValidWasteByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidWasteByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteByIdAsofVerb = "WasteByIdAsof";

export function wasteByIdAsofTqk(args?: WasteByIdAsofRequest) {
    return args ? [wasteByIdAsofVerb, args] as const : [wasteByIdAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteByIdAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteByIdAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteByIdAsofTqk(args),
        queryFn: () => 
mama.wasteByIdAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// WasteByIdAsof can take args
export function wasteByIdAsofTqo(mama: KingBasura, args ?: WasteByIdAsofRequest) {
    return queryOptions({
        queryKey: wasteByIdAsofTqk(args),
        queryFn: args
            ? () => 
mama.wasteByIdAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: WasteByIdAsofResponse) => data.waste,
    });
}

export function useWasteByIdAsof(args ?: WasteByIdAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wasteByIdAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteRevisionCountVerb = "WasteRevisionCount";

export function wasteRevisionCountTqk(args?: WasteRevisionCountRequest) {
    return args ? [wasteRevisionCountVerb, args] as const : [wasteRevisionCountVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteRevisionCount({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteRevisionCountRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteRevisionCountTqk(args),
        queryFn: () => 
mama.wasteRevisionCount(args),
    });
}
// TQP OUT
// TQOTOP
// int32 is not a stub
// WasteRevisionCount can take args
export function wasteRevisionCountTqo(mama: KingBasura, args ?: WasteRevisionCountRequest) {
    return queryOptions({
        queryKey: wasteRevisionCountTqk(args),
        queryFn: args
            ? () => 
mama.wasteRevisionCount(args)
            : skipToken,
        throwOnError: true,
        select: (data: WasteRevisionCountResponse) => data.revisionCount,
    });
}

export function useWasteRevisionCount(args ?: WasteRevisionCountRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wasteRevisionCountTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allWasteRevisionStubsVerb = "AllWasteRevisionStubs";

export function allWasteRevisionStubsTqk(args?: AllWasteRevisionStubsRequest) {
    return args ? [allWasteRevisionStubsVerb, args] as const : [allWasteRevisionStubsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllWasteRevisionStubs({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllWasteRevisionStubsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allWasteRevisionStubsTqk(args),
        queryFn: () => 
mama.allWasteRevisionStubs(args),
    });
}
// no rib query ensureWasteRevisionById available
// TQP OUT
// TQOTOP
// []WasteRevisionStub is a stub
// WARNING: byIdWatcher WatchWasteRevisionById for AllWasteRevisionStubs does not exist
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allWasteRevisionsVerb = "AllWasteRevisions";

export function allWasteRevisionsTqk(args?: AllWasteRevisionsRequest) {
    return args ? [allWasteRevisionsVerb, args] as const : [allWasteRevisionsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllWasteRevisions({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllWasteRevisionsRequest}) {
    return tqc.ensureQueryData({
        queryKey: allWasteRevisionsTqk(args),
        queryFn: () => 
mama.allWasteRevisions(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// AllWasteRevisions can take args
export function allWasteRevisionsTqo(mama: KingBasura, args ?: AllWasteRevisionsRequest) {
    return queryOptions({
        queryKey: allWasteRevisionsTqk(args),
        queryFn: args
            ? () => 
mama.allWasteRevisions(args)
            : skipToken,
        throwOnError: true,
        select: (data: AllWasteRevisionsResponse) => data.revisions,
    });
}

export function useAllWasteRevisions(args ?: AllWasteRevisionsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allWasteRevisionsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wastesForBundleVerb = "WastesForBundle";
export type WastesForBundleRequest = WatchWastesForBundleRequest;

export function wastesForBundleTqk(args?: WastesForBundleRequest) {
    return args ? [wastesForBundleVerb, args] as const : [wastesForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWastesForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: wastesForBundleTqk(args),
        queryFn: () => 
mama.watchWastesForBundle(args),
    });
}

export function ensureFullWastesForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesForBundleRequest}) {
    return ensureWastesForBundle({tqc, mama, args}).then(tqrv => Promise.all(tqrv.wastes.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// WastesForBundle can take arguments
export function watchWastesForBundleTqo(mama: KingBasura, args?: WastesForBundleRequest) {
    return queryOptions({
        queryKey: wastesForBundleTqk(args),
        queryFn: args
            ? () => 
mama.watchWastesForBundle(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchWastesForBundleResponse) => data.wastes,
    });
}

export function useWastesForBundle(args?: WastesForBundleRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchWastesForBundleTqo(mama, args));
}
export function useFullWastesForBundle(args?: WastesForBundleRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useWastesForBundle(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allWastesForBundleVerb = "AllWastesForBundle";

export function allWastesForBundleTqk(args?: AllWastesForBundleRequest) {
    return args ? [allWastesForBundleVerb, args] as const : [allWastesForBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllWastesForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllWastesForBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: allWastesForBundleTqk(args),
        queryFn: () => 
mama.allWastesForBundle(args),
    });
}

export function ensureFullAllWastesForBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllWastesForBundleRequest}) {
    return ensureAllWastesForBundle({tqc, mama, args}).then(tqrv => Promise.all(tqrv.wastes.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// AllWastesForBundle can take arguments
export function allWastesForBundleTqo(mama: KingBasura, args?: AllWastesForBundleRequest) {
    return queryOptions({
        queryKey: allWastesForBundleTqk(args),
        queryFn: args
            ? () => 
mama.allWastesForBundle(args)
            : skipToken,
        throwOnError: true,
		select: (data: AllWastesForBundleResponse) => data.wastes,
    });
}

export function useAllWastesForBundle(args?: AllWastesForBundleRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allWastesForBundleTqo(mama, args));
}
export function useFullAllWastesForBundle(args?: AllWastesForBundleRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useAllWastesForBundle(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wastesForBundleAsofVerb = "WastesForBundleAsof";

export function wastesForBundleAsofTqk(args?: WastesForBundleAsofRequest) {
    return args ? [wastesForBundleAsofVerb, args] as const : [wastesForBundleAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWastesForBundleAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesForBundleAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: wastesForBundleAsofTqk(args),
        queryFn: () => 
mama.wastesForBundleAsof(args),
    });
}

export function ensureFullWastesForBundleAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesForBundleAsofRequest}) {
    return ensureWastesForBundleAsof({tqc, mama, args}).then(tqrv => Promise.all(tqrv.wastes.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// WastesForBundleAsof can take arguments
export function wastesForBundleAsofTqo(mama: KingBasura, args?: WastesForBundleAsofRequest) {
    return queryOptions({
        queryKey: wastesForBundleAsofTqk(args),
        queryFn: args
            ? () => 
mama.wastesForBundleAsof(args)
            : skipToken,
        throwOnError: true,
		select: (data: WastesForBundleAsofResponse) => data.wastes,
    });
}

export function useWastesForBundleAsof(args?: WastesForBundleAsofRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wastesForBundleAsofTqo(mama, args));
}
export function useFullWastesForBundleAsof(args?: WastesForBundleAsofRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useWastesForBundleAsof(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allDaughtersOfWasteVerb = "AllDaughtersOfWaste";

export function allDaughtersOfWasteTqk(args?: AllDaughtersOfWasteRequest) {
    return args ? [allDaughtersOfWasteVerb, args] as const : [allDaughtersOfWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllDaughtersOfWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllDaughtersOfWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: allDaughtersOfWasteTqk(args),
        queryFn: () => 
mama.allDaughtersOfWaste(args),
    });
}

export function ensureFullAllDaughtersOfWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllDaughtersOfWasteRequest}) {
    return ensureAllDaughtersOfWaste({tqc, mama, args}).then(tqrv => Promise.all(tqrv.daughters.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// AllDaughtersOfWaste can take arguments
export function allDaughtersOfWasteTqo(mama: KingBasura, args?: AllDaughtersOfWasteRequest) {
    return queryOptions({
        queryKey: allDaughtersOfWasteTqk(args),
        queryFn: args
            ? () => 
mama.allDaughtersOfWaste(args)
            : skipToken,
        throwOnError: true,
		select: (data: AllDaughtersOfWasteResponse) => data.daughters,
    });
}

export function useAllDaughtersOfWaste(args?: AllDaughtersOfWasteRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allDaughtersOfWasteTqo(mama, args));
}
export function useFullAllDaughtersOfWaste(args?: AllDaughtersOfWasteRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useAllDaughtersOfWaste(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const mothersOfWasteVerb = "MothersOfWaste";

export function mothersOfWasteTqk(args?: MothersOfWasteRequest) {
    return args ? [mothersOfWasteVerb, args] as const : [mothersOfWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureMothersOfWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: MothersOfWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: mothersOfWasteTqk(args),
        queryFn: () => 
mama.mothersOfWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// MothersOfWaste can take args
export function mothersOfWasteTqo(mama: KingBasura, args ?: MothersOfWasteRequest) {
    return queryOptions({
        queryKey: mothersOfWasteTqk(args),
        queryFn: args
            ? () => 
mama.mothersOfWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: MothersOfWasteResponse) => data.mothers,
    });
}

export function useMothersOfWaste(args ?: MothersOfWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(mothersOfWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const directWasteLineageRecordsVerb = "DirectWasteLineageRecords";

export function directWasteLineageRecordsTqk(args?: DirectWasteLineageRecordsRequest) {
    return args ? [directWasteLineageRecordsVerb, args] as const : [directWasteLineageRecordsVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureDirectWasteLineageRecords({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: DirectWasteLineageRecordsRequest}) {
    return tqc.ensureQueryData({
        queryKey: directWasteLineageRecordsTqk(args),
        queryFn: () => 
mama.directWasteLineageRecords(args),
    });
}
// TQP OUT
// TQOTOP
// WasteLineageRecord is not a stub
// DirectWasteLineageRecords can take args
export function directWasteLineageRecordsTqo(mama: KingBasura, args ?: DirectWasteLineageRecordsRequest) {
    return queryOptions({
        queryKey: directWasteLineageRecordsTqk(args),
        queryFn: args
            ? () => 
mama.directWasteLineageRecords(args)
            : skipToken,
        throwOnError: true,
        select: (data: DirectWasteLineageRecordsResponse) => data.lineageRecords,
    });
}

export function useDirectWasteLineageRecords(args ?: DirectWasteLineageRecordsRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(directWasteLineageRecordsTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleForWasteVerb = "BundleForWaste";
export type BundleForWasteRequest = WatchBundleForWasteRequest;

export function bundleForWasteTqk(args?: BundleForWasteRequest) {
    return args ? [bundleForWasteVerb, args] as const : [bundleForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleForWasteTqk(args),
        queryFn: () => 
mama.watchBundleForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// BundleForWaste can take args
export function watchBundleForWasteTqo(mama: KingBasura, args ?: BundleForWasteRequest) {
    return queryOptions({
        queryKey: bundleForWasteTqk(args),
        queryFn: args
            ? () => 
mama.watchBundleForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchBundleForWasteResponse) => data.bundle,
    });
}

export function useBundleForWaste(args ?: BundleForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchBundleForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastValidBundleForWasteVerb = "LastValidBundleForWaste";

export function lastValidBundleForWasteTqk(args?: LastValidBundleForWasteRequest) {
    return args ? [lastValidBundleForWasteVerb, args] as const : [lastValidBundleForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastValidBundleForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastValidBundleForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastValidBundleForWasteTqk(args),
        queryFn: () => 
mama.lastValidBundleForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// LastValidBundleForWaste can take args
export function lastValidBundleForWasteTqo(mama: KingBasura, args ?: LastValidBundleForWasteRequest) {
    return queryOptions({
        queryKey: lastValidBundleForWasteTqk(args),
        queryFn: args
            ? () => 
mama.lastValidBundleForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastValidBundleForWasteResponse) => data.bundle,
    });
}

export function useLastValidBundleForWaste(args ?: LastValidBundleForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastValidBundleForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const bundleForWasteAsofVerb = "BundleForWasteAsof";

export function bundleForWasteAsofTqk(args?: BundleForWasteAsofRequest) {
    return args ? [bundleForWasteAsofVerb, args] as const : [bundleForWasteAsofVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureBundleForWasteAsof({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: BundleForWasteAsofRequest}) {
    return tqc.ensureQueryData({
        queryKey: bundleForWasteAsofTqk(args),
        queryFn: () => 
mama.bundleForWasteAsof(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// BundleForWasteAsof can take args
export function bundleForWasteAsofTqo(mama: KingBasura, args ?: BundleForWasteAsofRequest) {
    return queryOptions({
        queryKey: bundleForWasteAsofTqk(args),
        queryFn: args
            ? () => 
mama.bundleForWasteAsof(args)
            : skipToken,
        throwOnError: true,
        select: (data: BundleForWasteAsofResponse) => data.bundle,
    });
}

export function useBundleForWasteAsof(args ?: BundleForWasteAsofRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(bundleForWasteAsofTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allBundlesForWasteVerb = "AllBundlesForWaste";

export function allBundlesForWasteTqk(args?: AllBundlesForWasteRequest) {
    return args ? [allBundlesForWasteVerb, args] as const : [allBundlesForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAllBundlesForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllBundlesForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: allBundlesForWasteTqk(args),
        queryFn: () => 
mama.allBundlesForWaste(args),
    });
}

export function ensureFullAllBundlesForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AllBundlesForWasteRequest}) {
    return ensureAllBundlesForWaste({tqc, mama, args}).then(tqrv => Promise.all(tqrv.bundles.map(stub => ensureBundleById({tqc, mama, args: {bundleId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []BundleStub is a stub
// []BundleStub is a slice
// AllBundlesForWaste can take arguments
export function allBundlesForWasteTqo(mama: KingBasura, args?: AllBundlesForWasteRequest) {
    return queryOptions({
        queryKey: allBundlesForWasteTqk(args),
        queryFn: args
            ? () => 
mama.allBundlesForWaste(args)
            : skipToken,
        throwOnError: true,
		select: (data: AllBundlesForWasteResponse) => data.bundles,
    });
}

export function useAllBundlesForWaste(args?: AllBundlesForWasteRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(allBundlesForWasteTqo(mama, args));
}
export function useFullAllBundlesForWaste(args?: AllBundlesForWasteRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useAllBundlesForWaste(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {bundleId: stub.id} as const;
        return {
            queryKey: bundleByIdTqk(ribRequest),
            queryFn: () => mama.watchBundleById(ribRequest),
            select: (data: WatchBundleByIdResponse) => data.bundle,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const associationsForWasteVerb = "AssociationsForWaste";
export type AssociationsForWasteRequest = WatchAssociationsForWasteRequest;

export function associationsForWasteTqk(args?: AssociationsForWasteRequest) {
    return args ? [associationsForWasteVerb, args] as const : [associationsForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAssociationsForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AssociationsForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: associationsForWasteTqk(args),
        queryFn: () => 
mama.watchAssociationsForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// WasteAssociation is not a stub
// AssociationsForWaste can take args
export function watchAssociationsForWasteTqo(mama: KingBasura, args ?: AssociationsForWasteRequest) {
    return queryOptions({
        queryKey: associationsForWasteTqk(args),
        queryFn: args
            ? () => 
mama.watchAssociationsForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchAssociationsForWasteResponse) => data.assoc,
    });
}

export function useAssociationsForWaste(args ?: AssociationsForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchAssociationsForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const showExportedWasteVerb = "ShowExportedWaste";

export function showExportedWasteTqk(args?: ShowExportedWasteRequest) {
    return args ? [showExportedWasteVerb, args] as const : [showExportedWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureShowExportedWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ShowExportedWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: showExportedWasteTqk(args),
        queryFn: () => 
mama.showExportedWaste(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// ShowExportedWaste can take args
export function showExportedWasteTqo(mama: KingBasura, args ?: ShowExportedWasteRequest) {
    return queryOptions({
        queryKey: showExportedWasteTqk(args),
        queryFn: args
            ? () => 
mama.showExportedWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: ShowExportedWasteResponse) => data.exported,
    });
}

export function useShowExportedWaste(args ?: ShowExportedWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(showExportedWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const completeWasteHistoryByIdVerb = "CompleteWasteHistoryById";

export function completeWasteHistoryByIdTqk(args?: CompleteWasteHistoryByIdRequest) {
    return args ? [completeWasteHistoryByIdVerb, args] as const : [completeWasteHistoryByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompleteWasteHistoryById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompleteWasteHistoryByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: completeWasteHistoryByIdTqk(args),
        queryFn: () => 
mama.completeWasteHistoryById(args),
    });
}
// TQP OUT
// TQOTOP
// CompleteWasteHistory is not a stub
// CompleteWasteHistoryById can take args
export function completeWasteHistoryByIdTqo(mama: KingBasura, args ?: CompleteWasteHistoryByIdRequest) {
    return queryOptions({
        queryKey: completeWasteHistoryByIdTqk(args),
        queryFn: args
            ? () => 
mama.completeWasteHistoryById(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompleteWasteHistoryByIdResponse) => data.history,
    });
}

export function useCompleteWasteHistoryById(args ?: CompleteWasteHistoryByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(completeWasteHistoryByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteLocationVerb = "WasteLocation";
export type WasteLocationRequest = WatchWasteLocationRequest;

export function wasteLocationTqk(args?: WasteLocationRequest) {
    return args ? [wasteLocationVerb, args] as const : [wasteLocationVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteLocation({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteLocationRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteLocationTqk(args),
        queryFn: () => 
mama.watchWasteLocation(args),
    });
}
// no rib query ensureTruckOrVenueById available
// TQP OUT
// TQOTOP
// TruckOrVenueStub is a stub
// WARNING: byIdWatcher WatchTruckOrVenueById for WasteLocation does not exist
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wastesAtVerb = "WastesAt";
export type WastesAtRequest = WatchWastesAtRequest;

export function wastesAtTqk(args?: WastesAtRequest) {
    return args ? [wastesAtVerb, args] as const : [wastesAtVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWastesAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesAtRequest}) {
    return tqc.ensureQueryData({
        queryKey: wastesAtTqk(args),
        queryFn: () => 
mama.watchWastesAt(args),
    });
}

export function ensureFullWastesAt({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WastesAtRequest}) {
    return ensureWastesAt({tqc, mama, args}).then(tqrv => Promise.all(tqrv.stubs.map(stub => ensureWasteById({tqc, mama, args: {wasteId: stub.id}}))));
}
// TQP OUT
// TQOTOP
// []WasteStub is a stub
// []WasteStub is a slice
// WastesAt can take arguments
export function watchWastesAtTqo(mama: KingBasura, args?: WastesAtRequest) {
    return queryOptions({
        queryKey: wastesAtTqk(args),
        queryFn: args
            ? () => 
mama.watchWastesAt(args)
            : skipToken,
        throwOnError: true,
		select: (data: WatchWastesAtResponse) => data.stubs,
    });
}

export function useWastesAt(args?: WastesAtRequest) {
    const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchWastesAtTqo(mama, args));
}
export function useFullWastesAt(args?: WastesAtRequest) {
    const mama = useKingBasuraMothership();
    const stubsTqrv = useWastesAt(args);
//    let dataUpdatedAt = stubsTqrv.dataUpdatedAt;

	const qos = (stubsTqrv.data ?? []).map(stub => {
        const ribRequest = {wasteId: stub.id} as const;
        return {
            queryKey: wasteByIdTqk(ribRequest),
            queryFn: () => mama.watchWasteById(ribRequest),
            select: (data: WatchWasteByIdResponse) => data.waste,
} as const;
    });

    const refreshManager = useRefreshSet();
    const qks = qos.map(qo => qo.queryKey);
    const [watchingQks, setWatchingQks] = useState<QueryKey[]>([]);
    useEffect(() => {
        if (!isDeepEqual(qks, watchingQks)) {
            watchingQks.forEach(qk => {
                refreshManager.unregister(qk)
            });
            qks.forEach(qk => {
                refreshManager.register(qk);
            });
            setWatchingQks(qks);
        }
    }, [qks, refreshManager, watchingQks]);

	/* having combine be constant even if the spine query has not settled yet
	 * seemed to be causing problems whereby success with empty arrays was
	 * getting through
	 */
    const uqsrv = useQueries(args && stubsTqrv.isSuccess
	? {
		queries: qos,
		combine: mergeUseQueriesWithInfill,
	} : {queries: NADA});

	if (!args || stubsTqrv.isPending) {
	    return pendingUseResult;
    }

	return uqsrv;

    // if (!!combine && isAfter(uqsrv.dataUpdatedAt, dataUpdatedAt)) {
    //    dataUpdatedAt = uqsrv.dataUpdatedAt;
    // }

    // return {...uqsrv, dataUpdatedAt};
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const wasteStampByIdVerb = "WasteStampById";

export function wasteStampByIdTqk(args?: WasteStampByIdRequest) {
    return args ? [wasteStampByIdVerb, args] as const : [wasteStampByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureWasteStampById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: WasteStampByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: wasteStampByIdTqk(args),
        queryFn: () => 
mama.wasteStampById(args),
    });
}
// TQP OUT
// TQOTOP
// WasteStamp is not a stub
// WasteStampById can take args
export function wasteStampByIdTqo(mama: KingBasura, args ?: WasteStampByIdRequest) {
    return queryOptions({
        queryKey: wasteStampByIdTqk(args),
        queryFn: args
            ? () => 
mama.wasteStampById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WasteStampByIdResponse) => data.stamp,
    });
}

export function useWasteStampById(args ?: WasteStampByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(wasteStampByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const lastFlavoredStampForWasteVerb = "LastFlavoredStampForWaste";

export function lastFlavoredStampForWasteTqk(args?: LastFlavoredStampForWasteRequest) {
    return args ? [lastFlavoredStampForWasteVerb, args] as const : [lastFlavoredStampForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureLastFlavoredStampForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: LastFlavoredStampForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: lastFlavoredStampForWasteTqk(args),
        queryFn: () => 
mama.lastFlavoredStampForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// WasteStamp is not a stub
// LastFlavoredStampForWaste can take args
export function lastFlavoredStampForWasteTqo(mama: KingBasura, args ?: LastFlavoredStampForWasteRequest) {
    return queryOptions({
        queryKey: lastFlavoredStampForWasteTqk(args),
        queryFn: args
            ? () => 
mama.lastFlavoredStampForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: LastFlavoredStampForWasteResponse) => data.stamp,
    });
}

export function useLastFlavoredStampForWaste(args ?: LastFlavoredStampForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(lastFlavoredStampForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampsForWasteVerb = "StampsForWaste";
export type StampsForWasteRequest = WatchStampsForWasteRequest;

export function stampsForWasteTqk(args?: StampsForWasteRequest) {
    return args ? [stampsForWasteVerb, args] as const : [stampsForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampsForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampsForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampsForWasteTqk(args),
        queryFn: () => 
mama.watchStampsForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// WasteStamp is not a stub
// StampsForWaste can take args
export function watchStampsForWasteTqo(mama: KingBasura, args ?: StampsForWasteRequest) {
    return queryOptions({
        queryKey: stampsForWasteTqk(args),
        queryFn: args
            ? () => 
mama.watchStampsForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchStampsForWasteResponse) => data.stamps,
    });
}

export function useStampsForWaste(args ?: StampsForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchStampsForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const flavoredStampsForWasteVerb = "FlavoredStampsForWaste";
export type FlavoredStampsForWasteRequest = WatchFlavoredStampsForWasteRequest;

export function flavoredStampsForWasteTqk(args?: FlavoredStampsForWasteRequest) {
    return args ? [flavoredStampsForWasteVerb, args] as const : [flavoredStampsForWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureFlavoredStampsForWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: FlavoredStampsForWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: flavoredStampsForWasteTqk(args),
        queryFn: () => 
mama.watchFlavoredStampsForWaste(args),
    });
}
// TQP OUT
// TQOTOP
// WasteStamp is not a stub
// FlavoredStampsForWaste can take args
export function watchFlavoredStampsForWasteTqo(mama: KingBasura, args ?: FlavoredStampsForWasteRequest) {
    return queryOptions({
        queryKey: flavoredStampsForWasteTqk(args),
        queryFn: args
            ? () => 
mama.watchFlavoredStampsForWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchFlavoredStampsForWasteResponse) => data.stamps,
    });
}

export function useFlavoredStampsForWaste(args ?: FlavoredStampsForWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchFlavoredStampsForWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const packingModesVerb = "PackingModes";

export const packingModesTqk = [packingModesVerb] as const;
// TQK OUT
// TQP IN

export function ensurePackingModes({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: packingModesTqk,
        queryFn: () => 
mama.watchPackingModes(),
    });
}
// TQP OUT
// TQOTOP
// PackingMode is not a stub
// PackingModes takes no args
export function watchPackingModesTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: packingModesTqk,
        queryFn: () => 
mama.watchPackingModes(),
        throwOnError: true,
        select: (data: WatchPackingModesResponse) => data.modes,
    });
}

export function usePackingModes() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(watchPackingModesTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const packingModeByIdVerb = "PackingModeById";
export type PackingModeByIdRequest = WatchPackingModeByIdRequest;

export function packingModeByIdTqk(args?: PackingModeByIdRequest) {
    return args ? [packingModeByIdVerb, args] as const : [packingModeByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePackingModeById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PackingModeByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: packingModeByIdTqk(args),
        queryFn: () => 
mama.watchPackingModeById(args),
    });
}
// TQP OUT
// TQOTOP
// PackingMode is not a stub
// PackingModeById can take args
export function watchPackingModeByIdTqo(mama: KingBasura, args ?: PackingModeByIdRequest) {
    return queryOptions({
        queryKey: packingModeByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchPackingModeById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchPackingModeByIdResponse) => data.mode,
    });
}

export function usePackingModeById(args ?: PackingModeByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchPackingModeByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const manifestTypesVerb = "ManifestTypes";

export const manifestTypesTqk = [manifestTypesVerb] as const;
// TQK OUT
// TQP IN

export function ensureManifestTypes({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: manifestTypesTqk,
        queryFn: () => 
mama.watchManifestTypes(),
    });
}
// TQP OUT
// TQOTOP
// ManifestType is not a stub
// ManifestTypes takes no args
export function watchManifestTypesTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: manifestTypesTqk,
        queryFn: () => 
mama.watchManifestTypes(),
        throwOnError: true,
        select: (data: WatchManifestTypesResponse) => data.maniTypes,
    });
}

export function useManifestTypes() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(watchManifestTypesTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const manifestTypeByIdVerb = "ManifestTypeById";
export type ManifestTypeByIdRequest = WatchManifestTypeByIdRequest;

export function manifestTypeByIdTqk(args?: ManifestTypeByIdRequest) {
    return args ? [manifestTypeByIdVerb, args] as const : [manifestTypeByIdVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureManifestTypeById({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ManifestTypeByIdRequest}) {
    return tqc.ensureQueryData({
        queryKey: manifestTypeByIdTqk(args),
        queryFn: () => 
mama.watchManifestTypeById(args),
    });
}
// TQP OUT
// TQOTOP
// ManifestType is not a stub
// ManifestTypeById can take args
export function watchManifestTypeByIdTqo(mama: KingBasura, args ?: ManifestTypeByIdRequest) {
    return queryOptions({
        queryKey: manifestTypeByIdTqk(args),
        queryFn: args
            ? () => 
mama.watchManifestTypeById(args)
            : skipToken,
        throwOnError: true,
        select: (data: WatchManifestTypeByIdResponse) => data.maniType,
    });
}

export function useManifestTypeById(args ?: ManifestTypeByIdRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(watchManifestTypeByIdTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const unitsVerb = "Units";

export const unitsTqk = [unitsVerb] as const;
// TQK OUT
// TQP IN

export function ensureUnits({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: unitsTqk,
        queryFn: () => 
mama.watchUnits(),
    });
}
// TQP OUT
// TQOTOP
// Unit is not a stub
// Units takes no args
export function watchUnitsTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: unitsTqk,
        queryFn: () => 
mama.watchUnits(),
        throwOnError: true,
        select: (data: WatchUnitsResponse) => data.units,
    });
}

export function useUnits() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(watchUnitsTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transformModesVerb = "TransformModes";

export const transformModesTqk = [transformModesVerb] as const;
// TQK OUT
// TQP IN

export function ensureTransformModes({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: transformModesTqk,
        queryFn: () => 
mama.watchTransformModes(),
    });
}
// no rib query ensureEntityById available
// TQP OUT
// TQOTOP
// []EntityStub is a stub
// WARNING: byIdWatcher WatchEntityById for TransformModes does not exist
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const transformModesForVenueVerb = "TransformModesForVenue";
export type TransformModesForVenueRequest = WatchTransformModesForVenueRequest;

export function transformModesForVenueTqk(args?: TransformModesForVenueRequest) {
    return args ? [transformModesForVenueVerb, args] as const : [transformModesForVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureTransformModesForVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: TransformModesForVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: transformModesForVenueTqk(args),
        queryFn: () => 
mama.watchTransformModesForVenue(args),
    });
}
// no rib query ensureEntityById available
// TQP OUT
// TQOTOP
// []EntityStub is a stub
// WARNING: byIdWatcher WatchEntityById for TransformModesForVenue does not exist
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const allRewindCheckpointsVerb = "AllRewindCheckpoints";

export const allRewindCheckpointsTqk = [allRewindCheckpointsVerb] as const;
// TQK OUT
// TQP IN

export function ensureAllRewindCheckpoints({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: allRewindCheckpointsTqk,
        queryFn: () => 
mama.allRewindCheckpoints(),
    });
}
// TQP OUT
// TQOTOP
// RewindCheckpoint is not a stub
// AllRewindCheckpoints takes no args
export function allRewindCheckpointsTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: allRewindCheckpointsTqk,
        queryFn: () => 
mama.allRewindCheckpoints(),
        throwOnError: true,
        select: (data: AllRewindCheckpointsResponse) => data.checkpoints,
    });
}

export function useAllRewindCheckpoints() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(allRewindCheckpointsTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const setlistSubscriptionsVerb = "SetlistSubscriptions";

export const setlistSubscriptionsTqk = [setlistSubscriptionsVerb] as const;
// TQK OUT
// TQP IN

export function ensureSetlistSubscriptions({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: setlistSubscriptionsTqk,
        queryFn: () => 
mama.setlistSubscriptions(),
    });
}
// TQP OUT
// TQOTOP
// SetlistSubscription is not a stub
// SetlistSubscriptions takes no args
export function setlistSubscriptionsTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: setlistSubscriptionsTqk,
        queryFn: () => 
mama.setlistSubscriptions(),
        throwOnError: true,
        select: (data: SetlistSubscriptionsResponse) => data.subscriptions,
    });
}

export function useSetlistSubscriptions() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(setlistSubscriptionsTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const setSystemConfigVerb = "SetSystemConfig";

export function setSystemConfigTqk(args?: SetSystemConfigRequest) {
    return args ? [setSystemConfigVerb, args] as const : [setSystemConfigVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSetSystemConfig({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SetSystemConfigRequest}) {
    return tqc.ensureQueryData({
        queryKey: setSystemConfigTqk(args),
        queryFn: () => 
mama.setSystemConfig(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// SetSystemConfig can take args
export function setSystemConfigTqo(mama: KingBasura, args ?: SetSystemConfigRequest) {
    return queryOptions({
        queryKey: setSystemConfigTqk(args),
        queryFn: args
            ? () => 
mama.setSystemConfig(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useSetSystemConfig(args ?: SetSystemConfigRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(setSystemConfigTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertCompanyVerb = "UpsertCompany";

export function upsertCompanyTqk(args?: UpsertCompanyRequest) {
    return args ? [upsertCompanyVerb, args] as const : [upsertCompanyVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertCompany({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertCompanyRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertCompanyTqk(args),
        queryFn: () => 
mama.upsertCompany(args),
    });
}
// TQP OUT
// TQOTOP
// CompanyUpsertResult is not a stub
// UpsertCompany can take args
export function upsertCompanyTqo(mama: KingBasura, args ?: UpsertCompanyRequest) {
    return queryOptions({
        queryKey: upsertCompanyTqk(args),
        queryFn: args
            ? () => 
mama.upsertCompany(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertCompanyResponse) => data.result,
    });
}

export function useUpsertCompany(args ?: UpsertCompanyRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertCompanyTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchCompanyVerb = "PatchCompany";

export function patchCompanyTqk(args?: PatchCompanyRequest) {
    return args ? [patchCompanyVerb, args] as const : [patchCompanyVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchCompany({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchCompanyRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchCompanyTqk(args),
        queryFn: () => 
mama.patchCompany(args),
    });
}
// TQP OUT
// TQOTOP
// Company is not a stub
// PatchCompany can take args
export function patchCompanyTqo(mama: KingBasura, args ?: PatchCompanyRequest) {
    return queryOptions({
        queryKey: patchCompanyTqk(args),
        queryFn: args
            ? () => 
mama.patchCompany(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchCompanyResponse) => data.company,
    });
}

export function usePatchCompany(args ?: PatchCompanyRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchCompanyTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireCompanyVerb = "RetireCompany";

export function retireCompanyTqk(args?: RetireCompanyRequest) {
    return args ? [retireCompanyVerb, args] as const : [retireCompanyVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireCompany({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireCompanyRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireCompanyTqk(args),
        queryFn: () => 
mama.retireCompany(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireCompany can take args
export function retireCompanyTqo(mama: KingBasura, args ?: RetireCompanyRequest) {
    return queryOptions({
        queryKey: retireCompanyTqk(args),
        queryFn: args
            ? () => 
mama.retireCompany(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireCompany(args ?: RetireCompanyRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireCompanyTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertVenueVerb = "UpsertVenue";

export function upsertVenueTqk(args?: UpsertVenueRequest) {
    return args ? [upsertVenueVerb, args] as const : [upsertVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertVenueTqk(args),
        queryFn: () => 
mama.upsertVenue(args),
    });
}
// TQP OUT
// TQOTOP
// VenueUpsertResult is not a stub
// UpsertVenue can take args
export function upsertVenueTqo(mama: KingBasura, args ?: UpsertVenueRequest) {
    return queryOptions({
        queryKey: upsertVenueTqk(args),
        queryFn: args
            ? () => 
mama.upsertVenue(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertVenueResponse) => data.result,
    });
}

export function useUpsertVenue(args ?: UpsertVenueRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertVenueTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchVenueVerb = "PatchVenue";

export function patchVenueTqk(args?: PatchVenueRequest) {
    return args ? [patchVenueVerb, args] as const : [patchVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchVenueTqk(args),
        queryFn: () => 
mama.patchVenue(args),
    });
}
// TQP OUT
// TQOTOP
// Venue is not a stub
// PatchVenue can take args
export function patchVenueTqo(mama: KingBasura, args ?: PatchVenueRequest) {
    return queryOptions({
        queryKey: patchVenueTqk(args),
        queryFn: args
            ? () => 
mama.patchVenue(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchVenueResponse) => data.venue,
    });
}

export function usePatchVenue(args ?: PatchVenueRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchVenueTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireVenueVerb = "RetireVenue";

export function retireVenueTqk(args?: RetireVenueRequest) {
    return args ? [retireVenueVerb, args] as const : [retireVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireVenueTqk(args),
        queryFn: () => 
mama.retireVenue(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireVenue can take args
export function retireVenueTqo(mama: KingBasura, args ?: RetireVenueRequest) {
    return queryOptions({
        queryKey: retireVenueTqk(args),
        queryFn: args
            ? () => 
mama.retireVenue(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireVenue(args ?: RetireVenueRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireVenueTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertDownstreamVenueVerb = "UpsertDownstreamVenue";

export function upsertDownstreamVenueTqk(args?: UpsertDownstreamVenueRequest) {
    return args ? [upsertDownstreamVenueVerb, args] as const : [upsertDownstreamVenueVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertDownstreamVenue({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertDownstreamVenueRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertDownstreamVenueTqk(args),
        queryFn: () => 
mama.upsertDownstreamVenue(args),
    });
}
// TQP OUT
// TQOTOP
// VenueUpsertResult is not a stub
// UpsertDownstreamVenue can take args
export function upsertDownstreamVenueTqo(mama: KingBasura, args ?: UpsertDownstreamVenueRequest) {
    return queryOptions({
        queryKey: upsertDownstreamVenueTqk(args),
        queryFn: args
            ? () => 
mama.upsertDownstreamVenue(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertDownstreamVenueResponse) => data.result,
    });
}

export function useUpsertDownstreamVenue(args ?: UpsertDownstreamVenueRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertDownstreamVenueTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertAgentVerb = "UpsertAgent";

export function upsertAgentTqk(args?: UpsertAgentRequest) {
    return args ? [upsertAgentVerb, args] as const : [upsertAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertAgentTqk(args),
        queryFn: () => 
mama.upsertAgent(args),
    });
}
// TQP OUT
// TQOTOP
// AgentUpsertResult is not a stub
// UpsertAgent can take args
export function upsertAgentTqo(mama: KingBasura, args ?: UpsertAgentRequest) {
    return queryOptions({
        queryKey: upsertAgentTqk(args),
        queryFn: args
            ? () => 
mama.upsertAgent(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertAgentResponse) => data.result,
    });
}

export function useUpsertAgent(args ?: UpsertAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchAgentVerb = "PatchAgent";

export function patchAgentTqk(args?: PatchAgentRequest) {
    return args ? [patchAgentVerb, args] as const : [patchAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchAgentTqk(args),
        queryFn: () => 
mama.patchAgent(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// PatchAgent can take args
export function patchAgentTqo(mama: KingBasura, args ?: PatchAgentRequest) {
    return queryOptions({
        queryKey: patchAgentTqk(args),
        queryFn: args
            ? () => 
mama.patchAgent(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchAgentResponse) => data.agent,
    });
}

export function usePatchAgent(args ?: PatchAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchSelfVerb = "PatchSelf";

export function patchSelfTqk(args?: PatchSelfRequest) {
    return args ? [patchSelfVerb, args] as const : [patchSelfVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchSelf({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchSelfRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchSelfTqk(args),
        queryFn: () => 
mama.patchSelf(args),
    });
}
// TQP OUT
// TQOTOP
// Agent is not a stub
// PatchSelf can take args
export function patchSelfTqo(mama: KingBasura, args ?: PatchSelfRequest) {
    return queryOptions({
        queryKey: patchSelfTqk(args),
        queryFn: args
            ? () => 
mama.patchSelf(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchSelfResponse) => data.self,
    });
}

export function usePatchSelf(args ?: PatchSelfRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchSelfTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const changePasswordVerb = "ChangePassword";

export function changePasswordTqk(args?: ChangePasswordRequest) {
    return args ? [changePasswordVerb, args] as const : [changePasswordVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureChangePassword({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ChangePasswordRequest}) {
    return tqc.ensureQueryData({
        queryKey: changePasswordTqk(args),
        queryFn: () => 
mama.changePassword(args),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// ChangePassword can take args
export function changePasswordTqo(mama: KingBasura, args ?: ChangePasswordRequest) {
    return queryOptions({
        queryKey: changePasswordTqk(args),
        queryFn: args
            ? () => 
mama.changePassword(args)
            : skipToken,
        throwOnError: true,
        select: (data: ChangePasswordResponse) => data.authtoken,
    });
}

export function useChangePassword(args ?: ChangePasswordRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(changePasswordTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireAgentVerb = "RetireAgent";

export function retireAgentTqk(args?: RetireAgentRequest) {
    return args ? [retireAgentVerb, args] as const : [retireAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireAgentTqk(args),
        queryFn: () => 
mama.retireAgent(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireAgent can take args
export function retireAgentTqo(mama: KingBasura, args ?: RetireAgentRequest) {
    return queryOptions({
        queryKey: retireAgentTqk(args),
        queryFn: args
            ? () => 
mama.retireAgent(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireAgent(args ?: RetireAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampAgentVerb = "StampAgent";

export function stampAgentTqk(args?: StampAgentRequest) {
    return args ? [stampAgentVerb, args] as const : [stampAgentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampAgent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampAgentRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampAgentTqk(args),
        queryFn: () => 
mama.stampAgent(args),
    });
}
// TQP OUT
// TQOTOP
// AgentStamp is not a stub
// StampAgent can take args
export function stampAgentTqo(mama: KingBasura, args ?: StampAgentRequest) {
    return queryOptions({
        queryKey: stampAgentTqk(args),
        queryFn: args
            ? () => 
mama.stampAgent(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampAgentResponse) => data.stamp,
    });
}

export function useStampAgent(args ?: StampAgentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampAgentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertTruckModelVerb = "UpsertTruckModel";

export function upsertTruckModelTqk(args?: UpsertTruckModelRequest) {
    return args ? [upsertTruckModelVerb, args] as const : [upsertTruckModelVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertTruckModel({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertTruckModelRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertTruckModelTqk(args),
        queryFn: () => 
mama.upsertTruckModel(args),
    });
}
// TQP OUT
// TQOTOP
// TruckModelUpsertResult is not a stub
// UpsertTruckModel can take args
export function upsertTruckModelTqo(mama: KingBasura, args ?: UpsertTruckModelRequest) {
    return queryOptions({
        queryKey: upsertTruckModelTqk(args),
        queryFn: args
            ? () => 
mama.upsertTruckModel(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertTruckModelResponse) => data.model,
    });
}

export function useUpsertTruckModel(args ?: UpsertTruckModelRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertTruckModelTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchTruckModelVerb = "PatchTruckModel";

export function patchTruckModelTqk(args?: PatchTruckModelRequest) {
    return args ? [patchTruckModelVerb, args] as const : [patchTruckModelVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchTruckModel({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchTruckModelRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchTruckModelTqk(args),
        queryFn: () => 
mama.patchTruckModel(args),
    });
}
// TQP OUT
// TQOTOP
// TruckModel is not a stub
// PatchTruckModel can take args
export function patchTruckModelTqo(mama: KingBasura, args ?: PatchTruckModelRequest) {
    return queryOptions({
        queryKey: patchTruckModelTqk(args),
        queryFn: args
            ? () => 
mama.patchTruckModel(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchTruckModelResponse) => data.model,
    });
}

export function usePatchTruckModel(args ?: PatchTruckModelRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchTruckModelTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireTruckModelVerb = "RetireTruckModel";

export function retireTruckModelTqk(args?: RetireTruckModelRequest) {
    return args ? [retireTruckModelVerb, args] as const : [retireTruckModelVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireTruckModel({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireTruckModelRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireTruckModelTqk(args),
        queryFn: () => 
mama.retireTruckModel(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireTruckModel can take args
export function retireTruckModelTqo(mama: KingBasura, args ?: RetireTruckModelRequest) {
    return queryOptions({
        queryKey: retireTruckModelTqk(args),
        queryFn: args
            ? () => 
mama.retireTruckModel(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireTruckModel(args ?: RetireTruckModelRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireTruckModelTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertTruckVerb = "UpsertTruck";

export function upsertTruckTqk(args?: UpsertTruckRequest) {
    return args ? [upsertTruckVerb, args] as const : [upsertTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertTruckTqk(args),
        queryFn: () => 
mama.upsertTruck(args),
    });
}
// TQP OUT
// TQOTOP
// TruckUpsertResult is not a stub
// UpsertTruck can take args
export function upsertTruckTqo(mama: KingBasura, args ?: UpsertTruckRequest) {
    return queryOptions({
        queryKey: upsertTruckTqk(args),
        queryFn: args
            ? () => 
mama.upsertTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertTruckResponse) => data.result,
    });
}

export function useUpsertTruck(args ?: UpsertTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchTruckVerb = "PatchTruck";

export function patchTruckTqk(args?: PatchTruckRequest) {
    return args ? [patchTruckVerb, args] as const : [patchTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchTruckTqk(args),
        queryFn: () => 
mama.patchTruck(args),
    });
}
// TQP OUT
// TQOTOP
// Truck is not a stub
// PatchTruck can take args
export function patchTruckTqo(mama: KingBasura, args ?: PatchTruckRequest) {
    return queryOptions({
        queryKey: patchTruckTqk(args),
        queryFn: args
            ? () => 
mama.patchTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchTruckResponse) => data.truck,
    });
}

export function usePatchTruck(args ?: PatchTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireTruckVerb = "RetireTruck";

export function retireTruckTqk(args?: RetireTruckRequest) {
    return args ? [retireTruckVerb, args] as const : [retireTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireTruckTqk(args),
        queryFn: () => 
mama.retireTruck(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireTruck can take args
export function retireTruckTqo(mama: KingBasura, args ?: RetireTruckRequest) {
    return queryOptions({
        queryKey: retireTruckTqk(args),
        queryFn: args
            ? () => 
mama.retireTruck(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireTruck(args ?: RetireTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const mountTruckVerb = "MountTruck";

export function mountTruckTqk(args?: MountTruckRequest) {
    return args ? [mountTruckVerb, args] as const : [mountTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureMountTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: MountTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: mountTruckTqk(args),
        queryFn: () => 
mama.mountTruck(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// MountTruck can take args
export function mountTruckTqo(mama: KingBasura, args ?: MountTruckRequest) {
    return queryOptions({
        queryKey: mountTruckTqk(args),
        queryFn: args
            ? () => 
mama.mountTruck(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useMountTruck(args ?: MountTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(mountTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const dismountTruckVerb = "DismountTruck";

export const dismountTruckTqk = [dismountTruckVerb] as const;
// TQK OUT
// TQP IN

export function ensureDismountTruck({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: dismountTruckTqk,
        queryFn: () => 
mama.dismountTruck(),
    });
}
// TQP OUT
// TQOTOP
// string is not a stub
// DismountTruck takes no args
export function dismountTruckTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: dismountTruckTqk,
        queryFn: () => 
mama.dismountTruck(),
        throwOnError: true,
        select: (data: DismountTruckResponse) => data.oldTruckId,
    });
}

export function useDismountTruck() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(dismountTruckTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampTruckVerb = "StampTruck";

export function stampTruckTqk(args?: StampTruckRequest) {
    return args ? [stampTruckVerb, args] as const : [stampTruckVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampTruck({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampTruckRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampTruckTqk(args),
        queryFn: () => 
mama.stampTruck(args),
    });
}
// TQP OUT
// TQOTOP
// TruckStamp is not a stub
// StampTruck can take args
export function stampTruckTqo(mama: KingBasura, args ?: StampTruckRequest) {
    return queryOptions({
        queryKey: stampTruckTqk(args),
        queryFn: args
            ? () => 
mama.stampTruck(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampTruckResponse) => data.stamp,
    });
}

export function useStampTruck(args ?: StampTruckRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampTruckTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertSurchargeFlavorVerb = "UpsertSurchargeFlavor";

export function upsertSurchargeFlavorTqk(args?: UpsertSurchargeFlavorRequest) {
    return args ? [upsertSurchargeFlavorVerb, args] as const : [upsertSurchargeFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertSurchargeFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertSurchargeFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertSurchargeFlavorTqk(args),
        queryFn: () => 
mama.upsertSurchargeFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// SurchargeFlavorUpsertResult is not a stub
// UpsertSurchargeFlavor can take args
export function upsertSurchargeFlavorTqo(mama: KingBasura, args ?: UpsertSurchargeFlavorRequest) {
    return queryOptions({
        queryKey: upsertSurchargeFlavorTqk(args),
        queryFn: args
            ? () => 
mama.upsertSurchargeFlavor(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertSurchargeFlavorResponse) => data.result,
    });
}

export function useUpsertSurchargeFlavor(args ?: UpsertSurchargeFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertSurchargeFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchSurchargeFlavorVerb = "PatchSurchargeFlavor";

export function patchSurchargeFlavorTqk(args?: PatchSurchargeFlavorRequest) {
    return args ? [patchSurchargeFlavorVerb, args] as const : [patchSurchargeFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchSurchargeFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchSurchargeFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchSurchargeFlavorTqk(args),
        queryFn: () => 
mama.patchSurchargeFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// SurchargeFlavor is not a stub
// PatchSurchargeFlavor can take args
export function patchSurchargeFlavorTqo(mama: KingBasura, args ?: PatchSurchargeFlavorRequest) {
    return queryOptions({
        queryKey: patchSurchargeFlavorTqk(args),
        queryFn: args
            ? () => 
mama.patchSurchargeFlavor(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchSurchargeFlavorResponse) => data.flavor,
    });
}

export function usePatchSurchargeFlavor(args ?: PatchSurchargeFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchSurchargeFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireSurchargeFlavorVerb = "RetireSurchargeFlavor";

export function retireSurchargeFlavorTqk(args?: RetireSurchargeFlavorRequest) {
    return args ? [retireSurchargeFlavorVerb, args] as const : [retireSurchargeFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireSurchargeFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireSurchargeFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireSurchargeFlavorTqk(args),
        queryFn: () => 
mama.retireSurchargeFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireSurchargeFlavor can take args
export function retireSurchargeFlavorTqo(mama: KingBasura, args ?: RetireSurchargeFlavorRequest) {
    return queryOptions({
        queryKey: retireSurchargeFlavorTqk(args),
        queryFn: args
            ? () => 
mama.retireSurchargeFlavor(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireSurchargeFlavor(args ?: RetireSurchargeFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireSurchargeFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const spawnSurchargeVerb = "SpawnSurcharge";

export function spawnSurchargeTqk(args?: SpawnSurchargeRequest) {
    return args ? [spawnSurchargeVerb, args] as const : [spawnSurchargeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSpawnSurcharge({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SpawnSurchargeRequest}) {
    return tqc.ensureQueryData({
        queryKey: spawnSurchargeTqk(args),
        queryFn: () => 
mama.spawnSurcharge(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// SpawnSurcharge can take args
export function spawnSurchargeTqo(mama: KingBasura, args ?: SpawnSurchargeRequest) {
    return queryOptions({
        queryKey: spawnSurchargeTqk(args),
        queryFn: args
            ? () => 
mama.spawnSurcharge(args)
            : skipToken,
        throwOnError: true,
        select: (data: SpawnSurchargeResponse) => data.surcharge,
    });
}

export function useSpawnSurcharge(args ?: SpawnSurchargeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(spawnSurchargeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchSurchargeVerb = "PatchSurcharge";

export function patchSurchargeTqk(args?: PatchSurchargeRequest) {
    return args ? [patchSurchargeVerb, args] as const : [patchSurchargeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchSurcharge({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchSurchargeRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchSurchargeTqk(args),
        queryFn: () => 
mama.patchSurcharge(args),
    });
}
// TQP OUT
// TQOTOP
// Surcharge is not a stub
// PatchSurcharge can take args
export function patchSurchargeTqo(mama: KingBasura, args ?: PatchSurchargeRequest) {
    return queryOptions({
        queryKey: patchSurchargeTqk(args),
        queryFn: args
            ? () => 
mama.patchSurcharge(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchSurchargeResponse) => data.surcharge,
    });
}

export function usePatchSurcharge(args ?: PatchSurchargeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchSurchargeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireSurchargeVerb = "RetireSurcharge";

export function retireSurchargeTqk(args?: RetireSurchargeRequest) {
    return args ? [retireSurchargeVerb, args] as const : [retireSurchargeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireSurcharge({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireSurchargeRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireSurchargeTqk(args),
        queryFn: () => 
mama.retireSurcharge(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireSurcharge can take args
export function retireSurchargeTqo(mama: KingBasura, args ?: RetireSurchargeRequest) {
    return queryOptions({
        queryKey: retireSurchargeTqk(args),
        queryFn: args
            ? () => 
mama.retireSurcharge(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireSurcharge(args ?: RetireSurchargeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireSurchargeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertShinwaJobVerb = "UpsertShinwaJob";

export function upsertShinwaJobTqk(args?: UpsertShinwaJobRequest) {
    return args ? [upsertShinwaJobVerb, args] as const : [upsertShinwaJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertShinwaJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertShinwaJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertShinwaJobTqk(args),
        queryFn: () => 
mama.upsertShinwaJob(args),
    });
}
// TQP OUT
// TQOTOP
// JobUpsertResult is not a stub
// UpsertShinwaJob can take args
export function upsertShinwaJobTqo(mama: KingBasura, args ?: UpsertShinwaJobRequest) {
    return queryOptions({
        queryKey: upsertShinwaJobTqk(args),
        queryFn: args
            ? () => 
mama.upsertShinwaJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertShinwaJobResponse) => data.result,
    });
}

export function useUpsertShinwaJob(args ?: UpsertShinwaJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertShinwaJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertSanyuJobVerb = "UpsertSanyuJob";

export function upsertSanyuJobTqk(args?: UpsertSanyuJobRequest) {
    return args ? [upsertSanyuJobVerb, args] as const : [upsertSanyuJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertSanyuJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertSanyuJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertSanyuJobTqk(args),
        queryFn: () => 
mama.upsertSanyuJob(args),
    });
}
// TQP OUT
// TQOTOP
// JobUpsertResult is not a stub
// UpsertSanyuJob can take args
export function upsertSanyuJobTqo(mama: KingBasura, args ?: UpsertSanyuJobRequest) {
    return queryOptions({
        queryKey: upsertSanyuJobTqk(args),
        queryFn: args
            ? () => 
mama.upsertSanyuJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertSanyuJobResponse) => data.result,
    });
}

export function useUpsertSanyuJob(args ?: UpsertSanyuJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertSanyuJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchJobVerb = "PatchJob";

export function patchJobTqk(args?: PatchJobRequest) {
    return args ? [patchJobVerb, args] as const : [patchJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchJobTqk(args),
        queryFn: () => 
mama.patchJob(args),
    });
}
// TQP OUT
// TQOTOP
// Job is not a stub
// PatchJob can take args
export function patchJobTqo(mama: KingBasura, args ?: PatchJobRequest) {
    return queryOptions({
        queryKey: patchJobTqk(args),
        queryFn: args
            ? () => 
mama.patchJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchJobResponse) => data.job,
    });
}

export function usePatchJob(args ?: PatchJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampJobVerb = "StampJob";

export function stampJobTqk(args?: StampJobRequest) {
    return args ? [stampJobVerb, args] as const : [stampJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampJobTqk(args),
        queryFn: () => 
mama.stampJob(args),
    });
}
// TQP OUT
// TQOTOP
// JobStamp is not a stub
// StampJob can take args
export function stampJobTqo(mama: KingBasura, args ?: StampJobRequest) {
    return queryOptions({
        queryKey: stampJobTqk(args),
        queryFn: args
            ? () => 
mama.stampJob(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampJobResponse) => data.stamp,
    });
}

export function useStampJob(args ?: StampJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const cancelJobStampVerb = "CancelJobStamp";

export function cancelJobStampTqk(args?: CancelJobStampRequest) {
    return args ? [cancelJobStampVerb, args] as const : [cancelJobStampVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCancelJobStamp({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CancelJobStampRequest}) {
    return tqc.ensureQueryData({
        queryKey: cancelJobStampTqk(args),
        queryFn: () => 
mama.cancelJobStamp(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// CancelJobStamp can take args
export function cancelJobStampTqo(mama: KingBasura, args ?: CancelJobStampRequest) {
    return queryOptions({
        queryKey: cancelJobStampTqk(args),
        queryFn: args
            ? () => 
mama.cancelJobStamp(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useCancelJobStamp(args ?: CancelJobStampRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(cancelJobStampTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const spawnGroundedBundleVerb = "SpawnGroundedBundle";

export function spawnGroundedBundleTqk(args?: SpawnGroundedBundleRequest) {
    return args ? [spawnGroundedBundleVerb, args] as const : [spawnGroundedBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSpawnGroundedBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SpawnGroundedBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: spawnGroundedBundleTqk(args),
        queryFn: () => 
mama.spawnGroundedBundle(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// SpawnGroundedBundle can take args
export function spawnGroundedBundleTqo(mama: KingBasura, args ?: SpawnGroundedBundleRequest) {
    return queryOptions({
        queryKey: spawnGroundedBundleTqk(args),
        queryFn: args
            ? () => 
mama.spawnGroundedBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: SpawnGroundedBundleResponse) => data.bundle,
    });
}

export function useSpawnGroundedBundle(args ?: SpawnGroundedBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(spawnGroundedBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const spawnLoadedBundleVerb = "SpawnLoadedBundle";

export function spawnLoadedBundleTqk(args?: SpawnLoadedBundleRequest) {
    return args ? [spawnLoadedBundleVerb, args] as const : [spawnLoadedBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSpawnLoadedBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SpawnLoadedBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: spawnLoadedBundleTqk(args),
        queryFn: () => 
mama.spawnLoadedBundle(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// SpawnLoadedBundle can take args
export function spawnLoadedBundleTqo(mama: KingBasura, args ?: SpawnLoadedBundleRequest) {
    return queryOptions({
        queryKey: spawnLoadedBundleTqk(args),
        queryFn: args
            ? () => 
mama.spawnLoadedBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: SpawnLoadedBundleResponse) => data.bundle,
    });
}

export function useSpawnLoadedBundle(args ?: SpawnLoadedBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(spawnLoadedBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchBundleVerb = "PatchBundle";

export function patchBundleTqk(args?: PatchBundleRequest) {
    return args ? [patchBundleVerb, args] as const : [patchBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchBundleTqk(args),
        queryFn: () => 
mama.patchBundle(args),
    });
}
// TQP OUT
// TQOTOP
// Bundle is not a stub
// PatchBundle can take args
export function patchBundleTqo(mama: KingBasura, args ?: PatchBundleRequest) {
    return queryOptions({
        queryKey: patchBundleTqk(args),
        queryFn: args
            ? () => 
mama.patchBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchBundleResponse) => data.bundle,
    });
}

export function usePatchBundle(args ?: PatchBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampBundleVerb = "StampBundle";

export function stampBundleTqk(args?: StampBundleRequest) {
    return args ? [stampBundleVerb, args] as const : [stampBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampBundleTqk(args),
        queryFn: () => 
mama.stampBundle(args),
    });
}
// TQP OUT
// TQOTOP
// BundleStamp is not a stub
// StampBundle can take args
export function stampBundleTqo(mama: KingBasura, args ?: StampBundleRequest) {
    return queryOptions({
        queryKey: stampBundleTqk(args),
        queryFn: args
            ? () => 
mama.stampBundle(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampBundleResponse) => data.stamp,
    });
}

export function useStampBundle(args ?: StampBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const fieldCancelBundleVerb = "FieldCancelBundle";

export function fieldCancelBundleTqk(args?: FieldCancelBundleRequest) {
    return args ? [fieldCancelBundleVerb, args] as const : [fieldCancelBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureFieldCancelBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: FieldCancelBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: fieldCancelBundleTqk(args),
        queryFn: () => 
mama.fieldCancelBundle(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// FieldCancelBundle can take args
export function fieldCancelBundleTqo(mama: KingBasura, args ?: FieldCancelBundleRequest) {
    return queryOptions({
        queryKey: fieldCancelBundleTqk(args),
        queryFn: args
            ? () => 
mama.fieldCancelBundle(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useFieldCancelBundle(args ?: FieldCancelBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(fieldCancelBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireBundleVerb = "RetireBundle";

export function retireBundleTqk(args?: RetireBundleRequest) {
    return args ? [retireBundleVerb, args] as const : [retireBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireBundleTqk(args),
        queryFn: () => 
mama.retireBundle(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireBundle can take args
export function retireBundleTqo(mama: KingBasura, args ?: RetireBundleRequest) {
    return queryOptions({
        queryKey: retireBundleTqk(args),
        queryFn: args
            ? () => 
mama.retireBundle(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireBundle(args ?: RetireBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduleBundlePickupVerb = "ScheduleBundlePickup";

export function scheduleBundlePickupTqk(args?: ScheduleBundlePickupRequest) {
    return args ? [scheduleBundlePickupVerb, args] as const : [scheduleBundlePickupVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduleBundlePickup({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduleBundlePickupRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduleBundlePickupTqk(args),
        queryFn: () => 
mama.scheduleBundlePickup(args),
    });
}
// TQP OUT
// TQOTOP
// ScheduledTransfer is not a stub
// ScheduleBundlePickup can take args
export function scheduleBundlePickupTqo(mama: KingBasura, args ?: ScheduleBundlePickupRequest) {
    return queryOptions({
        queryKey: scheduleBundlePickupTqk(args),
        queryFn: args
            ? () => 
mama.scheduleBundlePickup(args)
            : skipToken,
        throwOnError: true,
        select: (data: ScheduleBundlePickupResponse) => data.scheduledTransfer,
    });
}

export function useScheduleBundlePickup(args ?: ScheduleBundlePickupRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(scheduleBundlePickupTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const scheduleBundleDropoffVerb = "ScheduleBundleDropoff";

export function scheduleBundleDropoffTqk(args?: ScheduleBundleDropoffRequest) {
    return args ? [scheduleBundleDropoffVerb, args] as const : [scheduleBundleDropoffVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureScheduleBundleDropoff({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ScheduleBundleDropoffRequest}) {
    return tqc.ensureQueryData({
        queryKey: scheduleBundleDropoffTqk(args),
        queryFn: () => 
mama.scheduleBundleDropoff(args),
    });
}
// TQP OUT
// TQOTOP
// ScheduledTransfer is not a stub
// ScheduleBundleDropoff can take args
export function scheduleBundleDropoffTqo(mama: KingBasura, args ?: ScheduleBundleDropoffRequest) {
    return queryOptions({
        queryKey: scheduleBundleDropoffTqk(args),
        queryFn: args
            ? () => 
mama.scheduleBundleDropoff(args)
            : skipToken,
        throwOnError: true,
        select: (data: ScheduleBundleDropoffResponse) => data.scheduledTransfer,
    });
}

export function useScheduleBundleDropoff(args ?: ScheduleBundleDropoffRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(scheduleBundleDropoffTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchScheduledTransferVerb = "PatchScheduledTransfer";

export function patchScheduledTransferTqk(args?: PatchScheduledTransferRequest) {
    return args ? [patchScheduledTransferVerb, args] as const : [patchScheduledTransferVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchScheduledTransfer({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchScheduledTransferRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchScheduledTransferTqk(args),
        queryFn: () => 
mama.patchScheduledTransfer(args),
    });
}
// TQP OUT
// TQOTOP
// ScheduledTransfer is not a stub
// PatchScheduledTransfer can take args
export function patchScheduledTransferTqo(mama: KingBasura, args ?: PatchScheduledTransferRequest) {
    return queryOptions({
        queryKey: patchScheduledTransferTqk(args),
        queryFn: args
            ? () => 
mama.patchScheduledTransfer(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchScheduledTransferResponse) => data.scheduledTransfer,
    });
}

export function usePatchScheduledTransfer(args ?: PatchScheduledTransferRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchScheduledTransferTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const cancelScheduledTransferVerb = "CancelScheduledTransfer";

export function cancelScheduledTransferTqk(args?: CancelScheduledTransferRequest) {
    return args ? [cancelScheduledTransferVerb, args] as const : [cancelScheduledTransferVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCancelScheduledTransfer({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CancelScheduledTransferRequest}) {
    return tqc.ensureQueryData({
        queryKey: cancelScheduledTransferTqk(args),
        queryFn: () => 
mama.cancelScheduledTransfer(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// CancelScheduledTransfer can take args
export function cancelScheduledTransferTqo(mama: KingBasura, args ?: CancelScheduledTransferRequest) {
    return queryOptions({
        queryKey: cancelScheduledTransferTqk(args),
        queryFn: args
            ? () => 
mama.cancelScheduledTransfer(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useCancelScheduledTransfer(args ?: CancelScheduledTransferRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(cancelScheduledTransferTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const disclaimScheduledTransferVerb = "DisclaimScheduledTransfer";

export function disclaimScheduledTransferTqk(args?: DisclaimScheduledTransferRequest) {
    return args ? [disclaimScheduledTransferVerb, args] as const : [disclaimScheduledTransferVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureDisclaimScheduledTransfer({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: DisclaimScheduledTransferRequest}) {
    return tqc.ensureQueryData({
        queryKey: disclaimScheduledTransferTqk(args),
        queryFn: () => 
mama.disclaimScheduledTransfer(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// DisclaimScheduledTransfer can take args
export function disclaimScheduledTransferTqo(mama: KingBasura, args ?: DisclaimScheduledTransferRequest) {
    return queryOptions({
        queryKey: disclaimScheduledTransferTqk(args),
        queryFn: args
            ? () => 
mama.disclaimScheduledTransfer(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useDisclaimScheduledTransfer(args ?: DisclaimScheduledTransferRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(disclaimScheduledTransferTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const disclaimAllMyScheduledTransfersVerb = "DisclaimAllMyScheduledTransfers";

export const disclaimAllMyScheduledTransfersTqk = [disclaimAllMyScheduledTransfersVerb] as const;
// TQK OUT
// TQP IN

export function ensureDisclaimAllMyScheduledTransfers({tqc, mama}: {tqc: QueryClient, mama: KingBasura}) {
    return tqc.ensureQueryData({
        queryKey: disclaimAllMyScheduledTransfersTqk,
        queryFn: () => 
mama.disclaimAllMyScheduledTransfers(),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// DisclaimAllMyScheduledTransfers takes no args
export function disclaimAllMyScheduledTransfersTqo(mama: KingBasura) {
	return queryOptions({
        queryKey: disclaimAllMyScheduledTransfersTqk,
        queryFn: () => 
mama.disclaimAllMyScheduledTransfers(),
        throwOnError: true,
        
    });
}

export function useDisclaimAllMyScheduledTransfers() {
    const mama = useKingBasuraMothership();
    return useRefreshableInfallibleQuery(disclaimAllMyScheduledTransfersTqo(mama));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const startTriplegVerb = "StartTripleg";

export function startTriplegTqk(args?: StartTriplegRequest) {
    return args ? [startTriplegVerb, args] as const : [startTriplegVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStartTripleg({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StartTriplegRequest}) {
    return tqc.ensureQueryData({
        queryKey: startTriplegTqk(args),
        queryFn: () => 
mama.startTripleg(args),
    });
}
// TQP OUT
// TQOTOP
// Tripleg is not a stub
// StartTripleg can take args
export function startTriplegTqo(mama: KingBasura, args ?: StartTriplegRequest) {
    return queryOptions({
        queryKey: startTriplegTqk(args),
        queryFn: args
            ? () => 
mama.startTripleg(args)
            : skipToken,
        throwOnError: true,
        select: (data: StartTriplegResponse) => data.tripleg,
    });
}

export function useStartTripleg(args ?: StartTriplegRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(startTriplegTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchTriplegVerb = "PatchTripleg";

export function patchTriplegTqk(args?: PatchTriplegRequest) {
    return args ? [patchTriplegVerb, args] as const : [patchTriplegVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchTripleg({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchTriplegRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchTriplegTqk(args),
        queryFn: () => 
mama.patchTripleg(args),
    });
}
// TQP OUT
// TQOTOP
// Tripleg is not a stub
// PatchTripleg can take args
export function patchTriplegTqo(mama: KingBasura, args ?: PatchTriplegRequest) {
    return queryOptions({
        queryKey: patchTriplegTqk(args),
        queryFn: args
            ? () => 
mama.patchTripleg(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchTriplegResponse) => data.tripleg,
    });
}

export function usePatchTripleg(args ?: PatchTriplegRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchTriplegTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const arriveVerb = "Arrive";

export function arriveTqk(args?: ArriveRequest) {
    return args ? [arriveVerb, args] as const : [arriveVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureArrive({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: ArriveRequest}) {
    return tqc.ensureQueryData({
        queryKey: arriveTqk(args),
        queryFn: () => 
mama.arrive(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// Arrive can take args
export function arriveTqo(mama: KingBasura, args ?: ArriveRequest) {
    return queryOptions({
        queryKey: arriveTqk(args),
        queryFn: args
            ? () => 
mama.arrive(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useArrive(args ?: ArriveRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(arriveTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const admitVerb = "Admit";

export function admitTqk(args?: AdmitRequest) {
    return args ? [admitVerb, args] as const : [admitVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAdmit({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AdmitRequest}) {
    return tqc.ensureQueryData({
        queryKey: admitTqk(args),
        queryFn: () => 
mama.admit(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// Admit can take args
export function admitTqo(mama: KingBasura, args ?: AdmitRequest) {
    return queryOptions({
        queryKey: admitTqk(args),
        queryFn: args
            ? () => 
mama.admit(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAdmit(args ?: AdmitRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(admitTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const startBundleOnloadingVerb = "StartBundleOnloading";

export function startBundleOnloadingTqk(args?: StartBundleOnloadingRequest) {
    return args ? [startBundleOnloadingVerb, args] as const : [startBundleOnloadingVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStartBundleOnloading({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StartBundleOnloadingRequest}) {
    return tqc.ensureQueryData({
        queryKey: startBundleOnloadingTqk(args),
        queryFn: () => 
mama.startBundleOnloading(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// StartBundleOnloading can take args
export function startBundleOnloadingTqo(mama: KingBasura, args ?: StartBundleOnloadingRequest) {
    return queryOptions({
        queryKey: startBundleOnloadingTqk(args),
        queryFn: args
            ? () => 
mama.startBundleOnloading(args)
            : skipToken,
        throwOnError: true,
        select: (data: StartBundleOnloadingResponse) => data.transfer,
    });
}

export function useStartBundleOnloading(args ?: StartBundleOnloadingRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(startBundleOnloadingTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const completeBundleOnloadingVerb = "CompleteBundleOnloading";

export function completeBundleOnloadingTqk(args?: CompleteBundleOnloadingRequest) {
    return args ? [completeBundleOnloadingVerb, args] as const : [completeBundleOnloadingVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompleteBundleOnloading({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompleteBundleOnloadingRequest}) {
    return tqc.ensureQueryData({
        queryKey: completeBundleOnloadingTqk(args),
        queryFn: () => 
mama.completeBundleOnloading(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// CompleteBundleOnloading can take args
export function completeBundleOnloadingTqo(mama: KingBasura, args ?: CompleteBundleOnloadingRequest) {
    return queryOptions({
        queryKey: completeBundleOnloadingTqk(args),
        queryFn: args
            ? () => 
mama.completeBundleOnloading(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompleteBundleOnloadingResponse) => data.transfer,
    });
}

export function useCompleteBundleOnloading(args ?: CompleteBundleOnloadingRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(completeBundleOnloadingTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const startBundleOffloadingVerb = "StartBundleOffloading";

export function startBundleOffloadingTqk(args?: StartBundleOffloadingRequest) {
    return args ? [startBundleOffloadingVerb, args] as const : [startBundleOffloadingVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStartBundleOffloading({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StartBundleOffloadingRequest}) {
    return tqc.ensureQueryData({
        queryKey: startBundleOffloadingTqk(args),
        queryFn: () => 
mama.startBundleOffloading(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// StartBundleOffloading can take args
export function startBundleOffloadingTqo(mama: KingBasura, args ?: StartBundleOffloadingRequest) {
    return queryOptions({
        queryKey: startBundleOffloadingTqk(args),
        queryFn: args
            ? () => 
mama.startBundleOffloading(args)
            : skipToken,
        throwOnError: true,
        select: (data: StartBundleOffloadingResponse) => data.transfer,
    });
}

export function useStartBundleOffloading(args ?: StartBundleOffloadingRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(startBundleOffloadingTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const completeBundleOffloadingVerb = "CompleteBundleOffloading";

export function completeBundleOffloadingTqk(args?: CompleteBundleOffloadingRequest) {
    return args ? [completeBundleOffloadingVerb, args] as const : [completeBundleOffloadingVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureCompleteBundleOffloading({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: CompleteBundleOffloadingRequest}) {
    return tqc.ensureQueryData({
        queryKey: completeBundleOffloadingTqk(args),
        queryFn: () => 
mama.completeBundleOffloading(args),
    });
}
// TQP OUT
// TQOTOP
// Transfer is not a stub
// CompleteBundleOffloading can take args
export function completeBundleOffloadingTqo(mama: KingBasura, args ?: CompleteBundleOffloadingRequest) {
    return queryOptions({
        queryKey: completeBundleOffloadingTqk(args),
        queryFn: args
            ? () => 
mama.completeBundleOffloading(args)
            : skipToken,
        throwOnError: true,
        select: (data: CompleteBundleOffloadingResponse) => data.transfer,
    });
}

export function useCompleteBundleOffloading(args ?: CompleteBundleOffloadingRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(completeBundleOffloadingTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertUnitVerb = "UpsertUnit";

export function upsertUnitTqk(args?: UpsertUnitRequest) {
    return args ? [upsertUnitVerb, args] as const : [upsertUnitVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertUnit({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertUnitRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertUnitTqk(args),
        queryFn: () => 
mama.upsertUnit(args),
    });
}
// TQP OUT
// TQOTOP
// UnitUpsertResult is not a stub
// UpsertUnit can take args
export function upsertUnitTqo(mama: KingBasura, args ?: UpsertUnitRequest) {
    return queryOptions({
        queryKey: upsertUnitTqk(args),
        queryFn: args
            ? () => 
mama.upsertUnit(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertUnitResponse) => data.result,
    });
}

export function useUpsertUnit(args ?: UpsertUnitRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertUnitTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertWasteFlavorVerb = "UpsertWasteFlavor";

export function upsertWasteFlavorTqk(args?: UpsertWasteFlavorRequest) {
    return args ? [upsertWasteFlavorVerb, args] as const : [upsertWasteFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertWasteFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertWasteFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertWasteFlavorTqk(args),
        queryFn: () => 
mama.upsertWasteFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavorUpsertResult is not a stub
// UpsertWasteFlavor can take args
export function upsertWasteFlavorTqo(mama: KingBasura, args ?: UpsertWasteFlavorRequest) {
    return queryOptions({
        queryKey: upsertWasteFlavorTqk(args),
        queryFn: args
            ? () => 
mama.upsertWasteFlavor(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertWasteFlavorResponse) => data.result,
    });
}

export function useUpsertWasteFlavor(args ?: UpsertWasteFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertWasteFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchWasteFlavorVerb = "PatchWasteFlavor";

export function patchWasteFlavorTqk(args?: PatchWasteFlavorRequest) {
    return args ? [patchWasteFlavorVerb, args] as const : [patchWasteFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchWasteFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchWasteFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchWasteFlavorTqk(args),
        queryFn: () => 
mama.patchWasteFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// WasteFlavor is not a stub
// PatchWasteFlavor can take args
export function patchWasteFlavorTqo(mama: KingBasura, args ?: PatchWasteFlavorRequest) {
    return queryOptions({
        queryKey: patchWasteFlavorTqk(args),
        queryFn: args
            ? () => 
mama.patchWasteFlavor(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchWasteFlavorResponse) => data.flavor,
    });
}

export function usePatchWasteFlavor(args ?: PatchWasteFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchWasteFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireWasteFlavorVerb = "RetireWasteFlavor";

export function retireWasteFlavorTqk(args?: RetireWasteFlavorRequest) {
    return args ? [retireWasteFlavorVerb, args] as const : [retireWasteFlavorVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireWasteFlavor({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireWasteFlavorRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireWasteFlavorTqk(args),
        queryFn: () => 
mama.retireWasteFlavor(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireWasteFlavor can take args
export function retireWasteFlavorTqo(mama: KingBasura, args ?: RetireWasteFlavorRequest) {
    return queryOptions({
        queryKey: retireWasteFlavorTqk(args),
        queryFn: args
            ? () => 
mama.retireWasteFlavor(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireWasteFlavor(args ?: RetireWasteFlavorRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireWasteFlavorTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertWasteFlavorRecipeVerb = "UpsertWasteFlavorRecipe";

export function upsertWasteFlavorRecipeTqk(args?: UpsertWasteFlavorRecipeRequest) {
    return args ? [upsertWasteFlavorRecipeVerb, args] as const : [upsertWasteFlavorRecipeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertWasteFlavorRecipe({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertWasteFlavorRecipeRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertWasteFlavorRecipeTqk(args),
        queryFn: () => 
mama.upsertWasteFlavorRecipe(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// UpsertWasteFlavorRecipe can take args
export function upsertWasteFlavorRecipeTqo(mama: KingBasura, args ?: UpsertWasteFlavorRecipeRequest) {
    return queryOptions({
        queryKey: upsertWasteFlavorRecipeTqk(args),
        queryFn: args
            ? () => 
mama.upsertWasteFlavorRecipe(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useUpsertWasteFlavorRecipe(args ?: UpsertWasteFlavorRecipeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertWasteFlavorRecipeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const deleteWasteFlavorRecipeVerb = "DeleteWasteFlavorRecipe";

export function deleteWasteFlavorRecipeTqk(args?: DeleteWasteFlavorRecipeRequest) {
    return args ? [deleteWasteFlavorRecipeVerb, args] as const : [deleteWasteFlavorRecipeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureDeleteWasteFlavorRecipe({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: DeleteWasteFlavorRecipeRequest}) {
    return tqc.ensureQueryData({
        queryKey: deleteWasteFlavorRecipeTqk(args),
        queryFn: () => 
mama.deleteWasteFlavorRecipe(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// DeleteWasteFlavorRecipe can take args
export function deleteWasteFlavorRecipeTqo(mama: KingBasura, args ?: DeleteWasteFlavorRecipeRequest) {
    return queryOptions({
        queryKey: deleteWasteFlavorRecipeTqk(args),
        queryFn: args
            ? () => 
mama.deleteWasteFlavorRecipe(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useDeleteWasteFlavorRecipe(args ?: DeleteWasteFlavorRecipeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(deleteWasteFlavorRecipeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertPackingModeVerb = "UpsertPackingMode";

export function upsertPackingModeTqk(args?: UpsertPackingModeRequest) {
    return args ? [upsertPackingModeVerb, args] as const : [upsertPackingModeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertPackingMode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertPackingModeRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertPackingModeTqk(args),
        queryFn: () => 
mama.upsertPackingMode(args),
    });
}
// TQP OUT
// TQOTOP
// PackingModeUpsertResult is not a stub
// UpsertPackingMode can take args
export function upsertPackingModeTqo(mama: KingBasura, args ?: UpsertPackingModeRequest) {
    return queryOptions({
        queryKey: upsertPackingModeTqk(args),
        queryFn: args
            ? () => 
mama.upsertPackingMode(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertPackingModeResponse) => data.result,
    });
}

export function useUpsertPackingMode(args ?: UpsertPackingModeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertPackingModeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertManifestTypeVerb = "UpsertManifestType";

export function upsertManifestTypeTqk(args?: UpsertManifestTypeRequest) {
    return args ? [upsertManifestTypeVerb, args] as const : [upsertManifestTypeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertManifestType({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertManifestTypeRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertManifestTypeTqk(args),
        queryFn: () => 
mama.upsertManifestType(args),
    });
}
// TQP OUT
// TQOTOP
// ManifestTypeUpsertResult is not a stub
// UpsertManifestType can take args
export function upsertManifestTypeTqo(mama: KingBasura, args ?: UpsertManifestTypeRequest) {
    return queryOptions({
        queryKey: upsertManifestTypeTqk(args),
        queryFn: args
            ? () => 
mama.upsertManifestType(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertManifestTypeResponse) => data.result,
    });
}

export function useUpsertManifestType(args ?: UpsertManifestTypeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertManifestTypeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const spawnWasteVerb = "SpawnWaste";

export function spawnWasteTqk(args?: SpawnWasteRequest) {
    return args ? [spawnWasteVerb, args] as const : [spawnWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSpawnWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SpawnWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: spawnWasteTqk(args),
        queryFn: () => 
mama.spawnWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// SpawnWaste can take args
export function spawnWasteTqo(mama: KingBasura, args ?: SpawnWasteRequest) {
    return queryOptions({
        queryKey: spawnWasteTqk(args),
        queryFn: args
            ? () => 
mama.spawnWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: SpawnWasteResponse) => data.waste,
    });
}

export function useSpawnWaste(args ?: SpawnWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(spawnWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const patchWasteVerb = "PatchWaste";

export function patchWasteTqk(args?: PatchWasteRequest) {
    return args ? [patchWasteVerb, args] as const : [patchWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensurePatchWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: PatchWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: patchWasteTqk(args),
        queryFn: () => 
mama.patchWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// PatchWaste can take args
export function patchWasteTqo(mama: KingBasura, args ?: PatchWasteRequest) {
    return queryOptions({
        queryKey: patchWasteTqk(args),
        queryFn: args
            ? () => 
mama.patchWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: PatchWasteResponse) => data.waste,
    });
}

export function usePatchWaste(args ?: PatchWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(patchWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const stampWasteVerb = "StampWaste";

export function stampWasteTqk(args?: StampWasteRequest) {
    return args ? [stampWasteVerb, args] as const : [stampWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStampWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StampWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: stampWasteTqk(args),
        queryFn: () => 
mama.stampWaste(args),
    });
}
// TQP OUT
// TQOTOP
// WasteStamp is not a stub
// StampWaste can take args
export function stampWasteTqo(mama: KingBasura, args ?: StampWasteRequest) {
    return queryOptions({
        queryKey: stampWasteTqk(args),
        queryFn: args
            ? () => 
mama.stampWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: StampWasteResponse) => data.stamp,
    });
}

export function useStampWaste(args ?: StampWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(stampWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const attachWasteToBundleVerb = "AttachWasteToBundle";

export function attachWasteToBundleTqk(args?: AttachWasteToBundleRequest) {
    return args ? [attachWasteToBundleVerb, args] as const : [attachWasteToBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAttachWasteToBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AttachWasteToBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: attachWasteToBundleTqk(args),
        queryFn: () => 
mama.attachWasteToBundle(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// AttachWasteToBundle can take args
export function attachWasteToBundleTqo(mama: KingBasura, args ?: AttachWasteToBundleRequest) {
    return queryOptions({
        queryKey: attachWasteToBundleTqk(args),
        queryFn: args
            ? () => 
mama.attachWasteToBundle(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAttachWasteToBundle(args ?: AttachWasteToBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(attachWasteToBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const attachWasteToJobVerb = "AttachWasteToJob";

export function attachWasteToJobTqk(args?: AttachWasteToJobRequest) {
    return args ? [attachWasteToJobVerb, args] as const : [attachWasteToJobVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAttachWasteToJob({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AttachWasteToJobRequest}) {
    return tqc.ensureQueryData({
        queryKey: attachWasteToJobTqk(args),
        queryFn: () => 
mama.attachWasteToJob(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// AttachWasteToJob can take args
export function attachWasteToJobTqo(mama: KingBasura, args ?: AttachWasteToJobRequest) {
    return queryOptions({
        queryKey: attachWasteToJobTqk(args),
        queryFn: args
            ? () => 
mama.attachWasteToJob(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAttachWasteToJob(args ?: AttachWasteToJobRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(attachWasteToJobTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const detachWasteFromBundleVerb = "DetachWasteFromBundle";

export function detachWasteFromBundleTqk(args?: DetachWasteFromBundleRequest) {
    return args ? [detachWasteFromBundleVerb, args] as const : [detachWasteFromBundleVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureDetachWasteFromBundle({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: DetachWasteFromBundleRequest}) {
    return tqc.ensureQueryData({
        queryKey: detachWasteFromBundleTqk(args),
        queryFn: () => 
mama.detachWasteFromBundle(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// DetachWasteFromBundle can take args
export function detachWasteFromBundleTqo(mama: KingBasura, args ?: DetachWasteFromBundleRequest) {
    return queryOptions({
        queryKey: detachWasteFromBundleTqk(args),
        queryFn: args
            ? () => 
mama.detachWasteFromBundle(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useDetachWasteFromBundle(args ?: DetachWasteFromBundleRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(detachWasteFromBundleTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const storeWasteTemporaryVerb = "StoreWasteTemporary";

export function storeWasteTemporaryTqk(args?: StoreWasteTemporaryRequest) {
    return args ? [storeWasteTemporaryVerb, args] as const : [storeWasteTemporaryVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStoreWasteTemporary({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StoreWasteTemporaryRequest}) {
    return tqc.ensureQueryData({
        queryKey: storeWasteTemporaryTqk(args),
        queryFn: () => 
mama.storeWasteTemporary(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// StoreWasteTemporary can take args
export function storeWasteTemporaryTqo(mama: KingBasura, args ?: StoreWasteTemporaryRequest) {
    return queryOptions({
        queryKey: storeWasteTemporaryTqk(args),
        queryFn: args
            ? () => 
mama.storeWasteTemporary(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useStoreWasteTemporary(args ?: StoreWasteTemporaryRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(storeWasteTemporaryTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const storeWastePermanentVerb = "StoreWastePermanent";

export function storeWastePermanentTqk(args?: StoreWastePermanentRequest) {
    return args ? [storeWastePermanentVerb, args] as const : [storeWastePermanentVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureStoreWastePermanent({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: StoreWastePermanentRequest}) {
    return tqc.ensureQueryData({
        queryKey: storeWastePermanentTqk(args),
        queryFn: () => 
mama.storeWastePermanent(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// StoreWastePermanent can take args
export function storeWastePermanentTqo(mama: KingBasura, args ?: StoreWastePermanentRequest) {
    return queryOptions({
        queryKey: storeWastePermanentTqk(args),
        queryFn: args
            ? () => 
mama.storeWastePermanent(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useStoreWastePermanent(args ?: StoreWastePermanentRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(storeWastePermanentTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const divideFromWasteVerb = "DivideFromWaste";

export function divideFromWasteTqk(args?: DivideFromWasteRequest) {
    return args ? [divideFromWasteVerb, args] as const : [divideFromWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureDivideFromWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: DivideFromWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: divideFromWasteTqk(args),
        queryFn: () => 
mama.divideFromWaste(args),
    });
}
// TQP OUT
// TQOTOP
// Waste is not a stub
// DivideFromWaste can take args
export function divideFromWasteTqo(mama: KingBasura, args ?: DivideFromWasteRequest) {
    return queryOptions({
        queryKey: divideFromWasteTqk(args),
        queryFn: args
            ? () => 
mama.divideFromWaste(args)
            : skipToken,
        throwOnError: true,
        select: (data: DivideFromWasteResponse) => data.daughter,
    });
}

export function useDivideFromWaste(args ?: DivideFromWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(divideFromWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const mergeIntoWasteVerb = "MergeIntoWaste";

export function mergeIntoWasteTqk(args?: MergeIntoWasteRequest) {
    return args ? [mergeIntoWasteVerb, args] as const : [mergeIntoWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureMergeIntoWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: MergeIntoWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: mergeIntoWasteTqk(args),
        queryFn: () => 
mama.mergeIntoWaste(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// MergeIntoWaste can take args
export function mergeIntoWasteTqo(mama: KingBasura, args ?: MergeIntoWasteRequest) {
    return queryOptions({
        queryKey: mergeIntoWasteTqk(args),
        queryFn: args
            ? () => 
mama.mergeIntoWaste(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useMergeIntoWaste(args ?: MergeIntoWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(mergeIntoWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const retireWasteVerb = "RetireWaste";

export function retireWasteTqk(args?: RetireWasteRequest) {
    return args ? [retireWasteVerb, args] as const : [retireWasteVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRetireWaste({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RetireWasteRequest}) {
    return tqc.ensureQueryData({
        queryKey: retireWasteTqk(args),
        queryFn: () => 
mama.retireWaste(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RetireWaste can take args
export function retireWasteTqo(mama: KingBasura, args ?: RetireWasteRequest) {
    return queryOptions({
        queryKey: retireWasteTqk(args),
        queryFn: args
            ? () => 
mama.retireWaste(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRetireWaste(args ?: RetireWasteRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(retireWasteTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const upsertTransformModeVerb = "UpsertTransformMode";

export function upsertTransformModeTqk(args?: UpsertTransformModeRequest) {
    return args ? [upsertTransformModeVerb, args] as const : [upsertTransformModeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureUpsertTransformMode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: UpsertTransformModeRequest}) {
    return tqc.ensureQueryData({
        queryKey: upsertTransformModeTqk(args),
        queryFn: () => 
mama.upsertTransformMode(args),
    });
}
// TQP OUT
// TQOTOP
// TransformModeUpsertResult is not a stub
// UpsertTransformMode can take args
export function upsertTransformModeTqo(mama: KingBasura, args ?: UpsertTransformModeRequest) {
    return queryOptions({
        queryKey: upsertTransformModeTqk(args),
        queryFn: args
            ? () => 
mama.upsertTransformMode(args)
            : skipToken,
        throwOnError: true,
        select: (data: UpsertTransformModeResponse) => data.result,
    });
}

export function useUpsertTransformMode(args ?: UpsertTransformModeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(upsertTransformModeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const adoptTransformModeVerb = "AdoptTransformMode";

export function adoptTransformModeTqk(args?: AdoptTransformModeRequest) {
    return args ? [adoptTransformModeVerb, args] as const : [adoptTransformModeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAdoptTransformMode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AdoptTransformModeRequest}) {
    return tqc.ensureQueryData({
        queryKey: adoptTransformModeTqk(args),
        queryFn: () => 
mama.adoptTransformMode(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// AdoptTransformMode can take args
export function adoptTransformModeTqo(mama: KingBasura, args ?: AdoptTransformModeRequest) {
    return queryOptions({
        queryKey: adoptTransformModeTqk(args),
        queryFn: args
            ? () => 
mama.adoptTransformMode(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAdoptTransformMode(args ?: AdoptTransformModeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(adoptTransformModeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const abandonTransformModeVerb = "AbandonTransformMode";

export function abandonTransformModeTqk(args?: AbandonTransformModeRequest) {
    return args ? [abandonTransformModeVerb, args] as const : [abandonTransformModeVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAbandonTransformMode({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AbandonTransformModeRequest}) {
    return tqc.ensureQueryData({
        queryKey: abandonTransformModeTqk(args),
        queryFn: () => 
mama.abandonTransformMode(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// AbandonTransformMode can take args
export function abandonTransformModeTqo(mama: KingBasura, args ?: AbandonTransformModeRequest) {
    return queryOptions({
        queryKey: abandonTransformModeTqk(args),
        queryFn: args
            ? () => 
mama.abandonTransformMode(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAbandonTransformMode(args ?: AbandonTransformModeRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(abandonTransformModeTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const attachPhotoToStampVerb = "AttachPhotoToStamp";

export function attachPhotoToStampTqk(args?: AttachPhotoToStampRequest) {
    return args ? [attachPhotoToStampVerb, args] as const : [attachPhotoToStampVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureAttachPhotoToStamp({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: AttachPhotoToStampRequest}) {
    return tqc.ensureQueryData({
        queryKey: attachPhotoToStampTqk(args),
        queryFn: () => 
mama.attachPhotoToStamp(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// AttachPhotoToStamp can take args
export function attachPhotoToStampTqo(mama: KingBasura, args ?: AttachPhotoToStampRequest) {
    return queryOptions({
        queryKey: attachPhotoToStampTqk(args),
        queryFn: args
            ? () => 
mama.attachPhotoToStamp(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useAttachPhotoToStamp(args ?: AttachPhotoToStampRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(attachPhotoToStampTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const rewindToCheckpointVerb = "RewindToCheckpoint";

export function rewindToCheckpointTqk(args?: RewindToCheckpointRequest) {
    return args ? [rewindToCheckpointVerb, args] as const : [rewindToCheckpointVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureRewindToCheckpoint({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: RewindToCheckpointRequest}) {
    return tqc.ensureQueryData({
        queryKey: rewindToCheckpointTqk(args),
        queryFn: () => 
mama.rewindToCheckpoint(args),
    });
}
// TQP OUT
// TQOTOP
// false is not a stub
// RewindToCheckpoint can take args
export function rewindToCheckpointTqo(mama: KingBasura, args ?: RewindToCheckpointRequest) {
    return queryOptions({
        queryKey: rewindToCheckpointTqk(args),
        queryFn: args
            ? () => 
mama.rewindToCheckpoint(args)
            : skipToken,
        throwOnError: true,
        
    });
}

export function useRewindToCheckpoint(args ?: RewindToCheckpointRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(rewindToCheckpointTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// TQMLOOPTOP
// TQK IN

export const spawnCheckpointVerb = "SpawnCheckpoint";

export function spawnCheckpointTqk(args?: SpawnCheckpointRequest) {
    return args ? [spawnCheckpointVerb, args] as const : [spawnCheckpointVerb] as const;
}
// TQK OUT
// TQP IN

export function ensureSpawnCheckpoint({tqc, mama, args}: {tqc: QueryClient, mama: KingBasura, args: SpawnCheckpointRequest}) {
    return tqc.ensureQueryData({
        queryKey: spawnCheckpointTqk(args),
        queryFn: () => 
mama.spawnCheckpoint(args),
    });
}
// TQP OUT
// TQOTOP
// RewindCheckpoint is not a stub
// SpawnCheckpoint can take args
export function spawnCheckpointTqo(mama: KingBasura, args ?: SpawnCheckpointRequest) {
    return queryOptions({
        queryKey: spawnCheckpointTqk(args),
        queryFn: args
            ? () => 
mama.spawnCheckpoint(args)
            : skipToken,
        throwOnError: true,
        select: (data: SpawnCheckpointResponse) => data.checkpoint,
    });
}

export function useSpawnCheckpoint(args ?: SpawnCheckpointRequest) {
	const mama = useKingBasuraMothership();
	return useRefreshableInfallibleQuery(spawnCheckpointTqo(mama, args));
}
// TQOOUT
// TQMLOOPEND
// it's necessary to know whether a setlist is single or multiple,
// because you cannot rely on whether the existing cache entry is an
// array or not. in the case where we subscribe to a list that is
// empty at the time of subscription, we have to know whether
// to fill it with an empty array or with null.

type Multiplicity = "single" | "multi";

const setlistVerbMultiplicities = new Map<string, Multiplicity>([
    ["ActiveBundles", "multi"],
    ["ActiveBundlesDestinedFor", "multi"],
    ["ActiveBundlesOriginatingAt", "multi"],
    ["AdmittersOnDutyForVenue", "multi"],
    ["AgentByCode", "single"],
    ["AgentById", "single"],
    ["AgentByLogin", "single"],
    ["AgentByName", "single"],
    ["AgentPresenceById", "single"],
    ["AllPresentAgents", "multi"],
    ["AllTransfers", "multi"],
    ["AllTriplegs", "multi"],
    ["AssociationsForWaste", "single"],
    ["BundleById", "single"],
    ["BundleForWaste", "single"],
    ["BundleLocation", "single"],
    ["BundlesNeedingSupervisor", "multi"],
    ["CompaniesByNameFragment", "multi"],
    ["CompanyByCode", "single"],
    ["CompanyById", "single"],
    ["CrewByTruck", "multi"],
    ["ExportableBundles", "multi"],
    ["ExportableJobs", "multi"],
    ["ExportedJobs", "multi"],
    ["FlavoredStampsForBundle", "multi"],
    ["FlavoredStampsForWaste", "multi"],
    ["InspectableBundles", "multi"],
    ["JobById", "single"],
    ["JobByIntakeCode", "single"],
    ["JobByJobCode", "single"],
    ["LastTransferForBundle", "single"],
    ["LastTriplegForTruck", "single"],
    ["ManifestTypeById", "single"],
    ["ManifestTypes", "multi"],
    ["OpenTransfersForTruck", "multi"],
    ["OpenTriplegForTruck", "single"],
    ["OrphanedBundles", "multi"],
    ["PackingModeById", "single"],
    ["PackingModes", "multi"],
    ["ScheduledTransferById", "single"],
    ["ScheduledTransferForBundle", "single"],
    ["ScheduledTransfersAt", "multi"],
    ["ScheduledTransfersAwaitingTruck", "multi"],
    ["ScheduledTransfersForDispatch", "multi"],
    ["ScheduledTransfersForDriver", "multi"],
    ["StampsForAgent", "multi"],
    ["StampsForBundle", "multi"],
    ["StampsForJob", "multi"],
    ["StampsForTruck", "multi"],
    ["StampsForWaste", "multi"],
    ["SurchargeById", "single"],
    ["SurchargesForSubject", "multi"],
    ["TransferById", "single"],
    ["TransfersAtVenue", "multi"],
    ["TransfersForTruck", "multi"],
    ["TransformModes", "multi"],
    ["TransformModesForVenue", "multi"],
    ["TriplegById", "single"],
    ["TriplegsForTruck", "multi"],
    ["TriplegsInboundTo", "multi"],
    ["TruckByCrew", "single"],
    ["TruckById", "single"],
    ["TruckByPlate", "single"],
    ["TruckModelById", "single"],
    ["TruckModels", "multi"],
    ["TrucksDockedAt", "multi"],
    ["UnadmittedTriplegsInto", "multi"],
    ["UnbundledWastesForJobAtVenue", "multi"],
    ["Units", "multi"],
    ["VenueByCode", "single"],
    ["VenueById", "single"],
    ["VenueByName", "single"],
    ["WasteById", "single"],
    ["WasteFlavorById", "single"],
    ["WasteLocation", "single"],
    ["WastesAt", "multi"],
    ["WastesForBundle", "multi"],
]);

export function isSetlistTqkSingle(tqk: QueryKey) {
	return setlistVerbMultiplicities.get(tqk[0] as string) === "single";
}

export interface TqCacheSpySet {
    ActiveBundles?: TqCacheListener<Awaited<ReturnType<typeof ensureActiveBundles>>>;
    ActiveBundlesDestinedFor?: TqCacheListener<Awaited<ReturnType<typeof ensureActiveBundlesDestinedFor>>>;
    ActiveBundlesOriginatingAt?: TqCacheListener<Awaited<ReturnType<typeof ensureActiveBundlesOriginatingAt>>>;
    AdmittersOnDutyForVenue?: TqCacheListener<Awaited<ReturnType<typeof ensureAdmittersOnDutyForVenue>>>;
    AgentByCode?: TqCacheListener<Awaited<ReturnType<typeof ensureAgentByCode>>>;
    AgentById?: TqCacheListener<Awaited<ReturnType<typeof ensureAgentById>>>;
    AgentByLogin?: TqCacheListener<Awaited<ReturnType<typeof ensureAgentByLogin>>>;
    AgentByName?: TqCacheListener<Awaited<ReturnType<typeof ensureAgentByName>>>;
    AgentPresenceById?: TqCacheListener<Awaited<ReturnType<typeof ensureAgentPresenceById>>>;
    AllPresentAgents?: TqCacheListener<Awaited<ReturnType<typeof ensureAllPresentAgents>>>;
    AllTransfers?: TqCacheListener<Awaited<ReturnType<typeof ensureAllTransfers>>>;
    AllTriplegs?: TqCacheListener<Awaited<ReturnType<typeof ensureAllTriplegs>>>;
    AssociationsForWaste?: TqCacheListener<Awaited<ReturnType<typeof ensureAssociationsForWaste>>>;
    BundleById?: TqCacheListener<Awaited<ReturnType<typeof ensureBundleById>>>;
    BundleForWaste?: TqCacheListener<Awaited<ReturnType<typeof ensureBundleForWaste>>>;
    BundleLocation?: TqCacheListener<Awaited<ReturnType<typeof ensureBundleLocation>>>;
    BundlesNeedingSupervisor?: TqCacheListener<Awaited<ReturnType<typeof ensureBundlesNeedingSupervisor>>>;
    CompaniesByNameFragment?: TqCacheListener<Awaited<ReturnType<typeof ensureCompaniesByNameFragment>>>;
    CompanyByCode?: TqCacheListener<Awaited<ReturnType<typeof ensureCompanyByCode>>>;
    CompanyById?: TqCacheListener<Awaited<ReturnType<typeof ensureCompanyById>>>;
    CrewByTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureCrewByTruck>>>;
    ExportableBundles?: TqCacheListener<Awaited<ReturnType<typeof ensureExportableBundles>>>;
    ExportableJobs?: TqCacheListener<Awaited<ReturnType<typeof ensureExportableJobs>>>;
    ExportedJobs?: TqCacheListener<Awaited<ReturnType<typeof ensureExportedJobs>>>;
    FlavoredStampsForBundle?: TqCacheListener<Awaited<ReturnType<typeof ensureFlavoredStampsForBundle>>>;
    FlavoredStampsForWaste?: TqCacheListener<Awaited<ReturnType<typeof ensureFlavoredStampsForWaste>>>;
    InspectableBundles?: TqCacheListener<Awaited<ReturnType<typeof ensureInspectableBundles>>>;
    JobById?: TqCacheListener<Awaited<ReturnType<typeof ensureJobById>>>;
    JobByIntakeCode?: TqCacheListener<Awaited<ReturnType<typeof ensureJobByIntakeCode>>>;
    JobByJobCode?: TqCacheListener<Awaited<ReturnType<typeof ensureJobByJobCode>>>;
    LastTransferForBundle?: TqCacheListener<Awaited<ReturnType<typeof ensureLastTransferForBundle>>>;
    LastTriplegForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureLastTriplegForTruck>>>;
    ManifestTypeById?: TqCacheListener<Awaited<ReturnType<typeof ensureManifestTypeById>>>;
    ManifestTypes?: TqCacheListener<Awaited<ReturnType<typeof ensureManifestTypes>>>;
    OpenTransfersForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureOpenTransfersForTruck>>>;
    OpenTriplegForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureOpenTriplegForTruck>>>;
    OrphanedBundles?: TqCacheListener<Awaited<ReturnType<typeof ensureOrphanedBundles>>>;
    PackingModeById?: TqCacheListener<Awaited<ReturnType<typeof ensurePackingModeById>>>;
    PackingModes?: TqCacheListener<Awaited<ReturnType<typeof ensurePackingModes>>>;
    ScheduledTransferById?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransferById>>>;
    ScheduledTransferForBundle?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransferForBundle>>>;
    ScheduledTransfersAt?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransfersAt>>>;
    ScheduledTransfersAwaitingTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransfersAwaitingTruck>>>;
    ScheduledTransfersForDispatch?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransfersForDispatch>>>;
    ScheduledTransfersForDriver?: TqCacheListener<Awaited<ReturnType<typeof ensureScheduledTransfersForDriver>>>;
    StampsForAgent?: TqCacheListener<Awaited<ReturnType<typeof ensureStampsForAgent>>>;
    StampsForBundle?: TqCacheListener<Awaited<ReturnType<typeof ensureStampsForBundle>>>;
    StampsForJob?: TqCacheListener<Awaited<ReturnType<typeof ensureStampsForJob>>>;
    StampsForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureStampsForTruck>>>;
    StampsForWaste?: TqCacheListener<Awaited<ReturnType<typeof ensureStampsForWaste>>>;
    SurchargeById?: TqCacheListener<Awaited<ReturnType<typeof ensureSurchargeById>>>;
    SurchargesForSubject?: TqCacheListener<Awaited<ReturnType<typeof ensureSurchargesForSubject>>>;
    TransferById?: TqCacheListener<Awaited<ReturnType<typeof ensureTransferById>>>;
    TransfersAtVenue?: TqCacheListener<Awaited<ReturnType<typeof ensureTransfersAtVenue>>>;
    TransfersForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureTransfersForTruck>>>;
    TransformModes?: TqCacheListener<Awaited<ReturnType<typeof ensureTransformModes>>>;
    TransformModesForVenue?: TqCacheListener<Awaited<ReturnType<typeof ensureTransformModesForVenue>>>;
    TriplegById?: TqCacheListener<Awaited<ReturnType<typeof ensureTriplegById>>>;
    TriplegsForTruck?: TqCacheListener<Awaited<ReturnType<typeof ensureTriplegsForTruck>>>;
    TriplegsInboundTo?: TqCacheListener<Awaited<ReturnType<typeof ensureTriplegsInboundTo>>>;
    TruckByCrew?: TqCacheListener<Awaited<ReturnType<typeof ensureTruckByCrew>>>;
    TruckById?: TqCacheListener<Awaited<ReturnType<typeof ensureTruckById>>>;
    TruckByPlate?: TqCacheListener<Awaited<ReturnType<typeof ensureTruckByPlate>>>;
    TruckModelById?: TqCacheListener<Awaited<ReturnType<typeof ensureTruckModelById>>>;
    TruckModels?: TqCacheListener<Awaited<ReturnType<typeof ensureTruckModels>>>;
    TrucksDockedAt?: TqCacheListener<Awaited<ReturnType<typeof ensureTrucksDockedAt>>>;
    UnadmittedTriplegsInto?: TqCacheListener<Awaited<ReturnType<typeof ensureUnadmittedTriplegsInto>>>;
    UnbundledWastesForJobAtVenue?: TqCacheListener<Awaited<ReturnType<typeof ensureUnbundledWastesForJobAtVenue>>>;
    Units?: TqCacheListener<Awaited<ReturnType<typeof ensureUnits>>>;
    VenueByCode?: TqCacheListener<Awaited<ReturnType<typeof ensureVenueByCode>>>;
    VenueById?: TqCacheListener<Awaited<ReturnType<typeof ensureVenueById>>>;
    VenueByName?: TqCacheListener<Awaited<ReturnType<typeof ensureVenueByName>>>;
    WasteById?: TqCacheListener<Awaited<ReturnType<typeof ensureWasteById>>>;
    WasteFlavorById?: TqCacheListener<Awaited<ReturnType<typeof ensureWasteFlavorById>>>;
    WasteLocation?: TqCacheListener<Awaited<ReturnType<typeof ensureWasteLocation>>>;
    WastesAt?: TqCacheListener<Awaited<ReturnType<typeof ensureWastesAt>>>;
    WastesForBundle?: TqCacheListener<Awaited<ReturnType<typeof ensureWastesForBundle>>>;
}


const createHttpRequest = (body: string = '{}', headers: object = {}, signal: AbortSignal | null = null): object => {
  const reqHeaders: { [key: string]: string } = { ...headers, 'Content-Type': 'application/json', [WebrpcHeader]: WebrpcHeaderValue }
  return { method: 'POST', headers: reqHeaders, body, signal }
}

const buildResponse = (res: Response): Promise<any> => {
  return res.text().then(text => {
    let data
    try {
      data = JSON.parse(text)
    } catch(error) {
      throw WebrpcBadResponseError.new({
        status: res.status,
        cause: `JSON.parse(): ${error instanceof Error ? error.message : String(error)}: response text: ${text}`},
      )
    }
    if (!res.ok) {
      const code: number = (typeof data.code === 'number') ? data.code : 0
      throw (webrpcErrorByCode[code] || WebrpcError).new(data)
    }
    return data
  })
}

export type Fetch = (input: RequestInfo, init?: RequestInit) => Promise<Response>


export interface WebrpcStreamOptions<T> extends WebrpcOptions {
  onMessage: (message: T) => void;
  onError: (error: WebrpcError, reconnect: () => void) => void;
  onOpen?: () => void;
  onClose?: () => void;
}

export interface WebrpcOptions {
  headers?: HeadersInit;
  signal?: AbortSignal;
}

export interface WebrpcStreamController {
  abort: (reason?: any) => void;
  closed: Promise<void>;
}





export const JsonEncode = <T = any>(obj: T): string => {
  return JSON.stringify(obj)
}

export const JsonDecode = <T = any>(data: string | any, _typ: string = ''): T => {
  let parsed: any = data
  if (typeof data === 'string') {
    try { parsed = JSON.parse(data) } catch (err) {
      throw WebrpcBadResponseError.new({ cause: `JsonDecode: JSON.parse failed: ${(err as Error).message}` })
    }
  }
  return parsed as T
}


//
// Errors
//

type WebrpcErrorParams = { name?: string, code?: number, message?: string, status?: number, cause?: string }

export class WebrpcError extends Error {
  code: number
  status: number

  constructor(error: WebrpcErrorParams = {}) {
    super(error.message)
    this.name = error.name || 'WebrpcEndpointError'
    this.code = typeof error.code === 'number' ? error.code : 0
    this.message = error.message || `endpoint error`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcError.prototype)
  }

  static new(payload: any): WebrpcError {
    return new this({ message: payload.message, code: payload.code, status: payload.status, cause: payload.cause })
  }
}


export class WebrpcEndpointError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcEndpoint'
    this.code = typeof error.code === 'number' ? error.code : 0
    this.message = error.message || `endpoint error`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcEndpointError.prototype)
  }
}

export class WebrpcRequestFailedError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcRequestFailed'
    this.code = typeof error.code === 'number' ? error.code : -1
    this.message = error.message || `request failed`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcRequestFailedError.prototype)
  }
}

export class WebrpcBadRouteError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcBadRoute'
    this.code = typeof error.code === 'number' ? error.code : -2
    this.message = error.message || `bad route`
    this.status = typeof error.status === 'number' ? error.status : 404
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcBadRouteError.prototype)
  }
}

export class WebrpcBadMethodError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcBadMethod'
    this.code = typeof error.code === 'number' ? error.code : -3
    this.message = error.message || `bad method`
    this.status = typeof error.status === 'number' ? error.status : 405
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcBadMethodError.prototype)
  }
}

export class WebrpcBadRequestError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcBadRequest'
    this.code = typeof error.code === 'number' ? error.code : -4
    this.message = error.message || `bad request`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcBadRequestError.prototype)
  }
}

export class WebrpcBadResponseError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcBadResponse'
    this.code = typeof error.code === 'number' ? error.code : -5
    this.message = error.message || `bad response`
    this.status = typeof error.status === 'number' ? error.status : 500
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcBadResponseError.prototype)
  }
}

export class WebrpcServerPanicError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcServerPanic'
    this.code = typeof error.code === 'number' ? error.code : -6
    this.message = error.message || `server panic`
    this.status = typeof error.status === 'number' ? error.status : 500
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcServerPanicError.prototype)
  }
}

export class WebrpcInternalErrorError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcInternalError'
    this.code = typeof error.code === 'number' ? error.code : -7
    this.message = error.message || `internal error`
    this.status = typeof error.status === 'number' ? error.status : 500
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcInternalErrorError.prototype)
  }
}

export class WebrpcClientAbortedError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcClientAborted'
    this.code = typeof error.code === 'number' ? error.code : -8
    this.message = error.message || `request aborted by client`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcClientAbortedError.prototype)
  }
}

export class WebrpcStreamLostError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcStreamLost'
    this.code = typeof error.code === 'number' ? error.code : -9
    this.message = error.message || `stream lost`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcStreamLostError.prototype)
  }
}

export class WebrpcStreamFinishedError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'WebrpcStreamFinished'
    this.code = typeof error.code === 'number' ? error.code : -10
    this.message = error.message || `stream finished`
    this.status = typeof error.status === 'number' ? error.status : 200
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, WebrpcStreamFinishedError.prototype)
  }
}


//
// Schema errors
//

export class NoMountedTruckError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'NoMountedTruck'
    this.code = typeof error.code === 'number' ? error.code : 1025
    this.message = error.message || `no mounted truck`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, NoMountedTruckError.prototype)
  }
}

export class BadPasswordError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'BadPassword'
    this.code = typeof error.code === 'number' ? error.code : 1026
    this.message = error.message || `bad password`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, BadPasswordError.prototype)
  }
}

export class ClosedPoolError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'ClosedPool'
    this.code = typeof error.code === 'number' ? error.code : 1027
    this.message = error.message || `closed pool`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, ClosedPoolError.prototype)
  }
}

export class ActivePoolError extends WebrpcError {
  constructor(error: WebrpcErrorParams = {}) {
    super(error)
    this.name = error.name || 'ActivePool'
    this.code = typeof error.code === 'number' ? error.code : 1028
    this.message = error.message || `active pool`
    this.status = typeof error.status === 'number' ? error.status : 400
    if (error.cause !== undefined) this.cause = error.cause
    Object.setPrototypeOf(this, ActivePoolError.prototype)
  }
}


export enum errors {
  WebrpcEndpoint = 'WebrpcEndpoint',
  WebrpcRequestFailed = 'WebrpcRequestFailed',
  WebrpcBadRoute = 'WebrpcBadRoute',
  WebrpcBadMethod = 'WebrpcBadMethod',
  WebrpcBadRequest = 'WebrpcBadRequest',
  WebrpcBadResponse = 'WebrpcBadResponse',
  WebrpcServerPanic = 'WebrpcServerPanic',
  WebrpcInternalError = 'WebrpcInternalError',
  WebrpcClientAborted = 'WebrpcClientAborted',
  WebrpcStreamLost = 'WebrpcStreamLost',
  WebrpcStreamFinished = 'WebrpcStreamFinished',
  NoMountedTruck = 'NoMountedTruck',
  BadPassword = 'BadPassword',
  ClosedPool = 'ClosedPool',
  ActivePool = 'ActivePool',
}

export enum WebrpcErrorCodes {
  WebrpcEndpoint = 0,
  WebrpcRequestFailed = -1,
  WebrpcBadRoute = -2,
  WebrpcBadMethod = -3,
  WebrpcBadRequest = -4,
  WebrpcBadResponse = -5,
  WebrpcServerPanic = -6,
  WebrpcInternalError = -7,
  WebrpcClientAborted = -8,
  WebrpcStreamLost = -9,
  WebrpcStreamFinished = -10,
  NoMountedTruck = 1025,
  BadPassword = 1026,
  ClosedPool = 1027,
  ActivePool = 1028,
}

export const webrpcErrorByCode: { [code: number]: any } = {
  [0]: WebrpcEndpointError,
  [-1]: WebrpcRequestFailedError,
  [-2]: WebrpcBadRouteError,
  [-3]: WebrpcBadMethodError,
  [-4]: WebrpcBadRequestError,
  [-5]: WebrpcBadResponseError,
  [-6]: WebrpcServerPanicError,
  [-7]: WebrpcInternalErrorError,
  [-8]: WebrpcClientAbortedError,
  [-9]: WebrpcStreamLostError,
  [-10]: WebrpcStreamFinishedError,
  [1025]: NoMountedTruckError,
  [1026]: BadPasswordError,
  [1027]: ClosedPoolError,
  [1028]: ActivePoolError,
}






    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
		    
			
		    
			
		    
				
			
		    
			
		    
				
			
		    
			
		    
			
		    
				
			
		    
			
		    
			
		    
			
		    
			
		    
				
			
		    
			
		    
				
			
		    
				
			
		    
			
		    
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
			
		    
				
			
		    
				
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
				
			
		    
			
		    
				
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
			
		    
				
			
		    
			
		    
			
		    
			
		    
				
			
		    
				
			
		    
				
			
		    
				
			
		    
			
		    
				
			
		    
			
		    
				
			
		    
				
			
		    
				
			

import {z} from "zod/v4";

type Transition<T> = {
	prev: T;
	next: T;
}

interface Ided {
	id: string;
}

function applyPatch<T extends Ided>(prev: T, trans: Transition<Partial<T>>): Partial<T> {
	const next = structuredClone(prev) as Record<string, any>;
	for (const k in trans.prev) {
		if (k !== "id") {
			// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
			delete (next[k]);
		}
	}
	for (const k in trans.next) {
		if (k !== "id") {
			next[k] = trans.next[k];
		}
	}
	const rv = next as T;
	return rv;
}

function isNukePacket(wpkt: WiredSetlistPacket) {
	return (!("prev" in wpkt) || !wpkt.prev) && (!("next" in wpkt) || !wpkt.next);
}

const Ided = z.object({id: z.string()});





export const StampableClassname = z.enum([
    "Agent",
    "Truck",
    "Job",
    "Bundle",
    "Waste",
]);
export type StampableClassname = z.infer<typeof StampableClassname>;







export const SortOrder = z.enum([
    "ASC",
    "DESC",
]);
export type SortOrder = z.infer<typeof SortOrder>;







export const AgentStampFlavor = z.enum([
    "SHIFT_START",
    "SHIFT_END",
    "BREAK_START",
    "BREAK_END",
    "AVATAR",
]);
export type AgentStampFlavor = z.infer<typeof AgentStampFlavor>;







export const TruckStampFlavor = z.enum([
    "AVATAR",
    "MILEAGE",
    "EMPTY",
    "SHIFT_START",
    "SHIFT_END",
    "FUEL",
    "OUT_OF_SERVICE",
    "IN_SERVICE",
    "ACCIDENT",
]);
export type TruckStampFlavor = z.infer<typeof TruckStampFlavor>;







export const JobStampFlavor = z.enum([
    "PROPOSE",
    "ACCEPT",
    "IMPORT",
    "FIELD_COMPLETE_PROPOSE",
    "FIELD_COMPLETE_ACCEPT",
    "INVOICE_COMPLETE_PROPOSE",
    "INVOICE_COMPLETE_ACCEPT",
    "EXPORT",
]);
export type JobStampFlavor = z.infer<typeof JobStampFlavor>;







export const SurchargeableClassname = z.enum([
    "job",
    "bundle",
    "waste",
]);
export type SurchargeableClassname = z.infer<typeof SurchargeableClassname>;







export const SurchargeSource = z.enum([
    "IMPORTED",
    "MANUAL",
    "INHERITED",
    "AUTOMATIC",
]);
export type SurchargeSource = z.infer<typeof SurchargeSource>;







export const BundleStampFlavor = z.enum([
    "PICKUP_PROPOSE",
    "PICKUP_ACCEPT",
    "FIELD_COMPLETE_PROPOSE",
    "FIELD_COMPLETE_ACCEPT",
    "DELIVERED",
]);
export type BundleStampFlavor = z.infer<typeof BundleStampFlavor>;







export const WasteFlavorPurpose = z.enum([
    "SHOW_TO_DRIVER",
    "SHOW_TO_INTAKER",
    "SHOW_TO_INSPECTOR",
    "SHOW_TO_SUPERVISOR",
    "SHORT_FORM",
    "BIRTH",
    "DIVISION",
]);
export type WasteFlavorPurpose = z.infer<typeof WasteFlavorPurpose>;







export const WasteStatusCode = z.enum([
    "UNKNOWN",
    "AWAITING_PICKUP",
    "ONLOADING",
    "LOADED",
    "OFFLOADING",
    "INSPECTING",
    "PURGATORY",
    "STORAGE",
    "SPLIT",
    "MERGED",
]);
export type WasteStatusCode = z.infer<typeof WasteStatusCode>;







export const WasteStampFlavor = z.enum([
    "ONLOADED",
    "PRELIM_INSPECT",
    "FINAL_INSPECT",
    "SPLIT",
    "MERGE",
    "CLOSED",
    "LISTED",
    "PICKUP_READY",
]);
export type WasteStampFlavor = z.infer<typeof WasteStampFlavor>;







export const PickupOrDropoff = z.enum([
    "PICKUP",
    "DROPOFF",
]);
export type PickupOrDropoff = z.infer<typeof PickupOrDropoff>;







export const VendorName = z.enum([
    "shinwa",
    "sanyu",
]);
export type VendorName = z.infer<typeof VendorName>;








    
    
    

export const EntityStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const EntityStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type EntityStubRequired = z.infer<typeof EntityStubRequired>;
        
        
        
export const EntityStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: EntityStub,
});

export const EntityStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const EntityStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(EntityStub),
	next: z.optional(EntityStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const EntityStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const EntityStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: EntityStubDelta,
	next: EntityStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const EntityStubSingleTransition = z.union([
    EntityStubSingleAliveTransition, EntityStubDelTransition, EntityStubDeltaTransition,
]);

export const EntityStubListTransition = z.union([
    EntityStubListFullTransition, EntityStubDeltaTransition,
]);








    
    
    
    
    
    
    
    

export const WiredSetlistPacket = z.object({
        pkid: z.string(),
        tbl: z.string(),
        asof: z.string(),
        path: z.string().array(),
        tqks: z.string().array(),
        dlta: z.optional(z.boolean()),
        prev: z.optional(z.any()),
        next: z.optional(z.any()),
});

export const WiredSetlistPacketRequired = z.object({
    pkid: z.string(),
    tbl: z.string(),
    asof: z.string(),
    path: z.string().array(),
    tqks: z.string().array(),
    dlta: z.boolean(),
    prev: z.any(),
    next: z.any(),
});
export type WiredSetlistPacketRequired = z.infer<typeof WiredSetlistPacketRequired>;








    
    
    // prioritizing AgentStub needed for RewindCheckpoint
	    






    
    
    

export const AgentStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const AgentStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type AgentStubRequired = z.infer<typeof AgentStubRequired>;
        
        
        
export const AgentStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: AgentStub,
});

export const AgentStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const AgentStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(AgentStub),
	next: z.optional(AgentStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const AgentStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: AgentStubDelta,
	next: AgentStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentStubSingleTransition = z.union([
    AgentStubSingleAliveTransition, AgentStubDelTransition, AgentStubDeltaTransition,
]);

export const AgentStubListTransition = z.union([
    AgentStubListFullTransition, AgentStubDeltaTransition,
]);


		
    
    

export const RewindCheckpoint = z.object({
        id: z.string(),
        author: AgentStub,
        asof: z.string(),
        name: z.string(),
});

export const RewindCheckpointRequired = z.object({
    id: z.string(),
    author: AgentStub,
    asof: z.string(),
    name: z.string(),
});
export type RewindCheckpointRequired = z.infer<typeof RewindCheckpointRequired>;








    
    
    
    

export const Photo = z.object({
        id: z.string(),
        slug: z.string(),
        taker: AgentStub,
        taken: z.string(),
});

export const PhotoRequired = z.object({
    id: z.string(),
    slug: z.string(),
    taker: AgentStub,
    taken: z.string(),
});
export type PhotoRequired = z.infer<typeof PhotoRequired>;








    
    
    
    
    
    
    
    
    

export const Stamp = z.object({
        id: z.string(),
        subjectClass: StampableClassname,
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(z.string()),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const StampRequired = z.object({
    id: z.string(),
    subjectClass: StampableClassname,
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: z.string(),
    photo: Photo,
    caption: z.string(),
});
export type StampRequired = z.infer<typeof StampRequired>;








    
    
    
    
    

export const NewStampFood = z.object({
        subjectClass: StampableClassname,
        subjectId: z.string(),
        flavor: z.optional(z.string()),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewStampFoodRequired = z.object({
    subjectClass: StampableClassname,
    subjectId: z.string(),
    flavor: z.string(),
    photoId: z.string(),
    caption: z.string(),
});
export type NewStampFoodRequired = z.infer<typeof NewStampFoodRequired>;








    
    
    
    
    
    
    
    
    
    

export const Company = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        code: z.string(),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
        author: AgentStub,
        validSpan: z.string(),
});

export const CompanyRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    code: z.string(),
    email: z.string(),
    telno: z.string(),
    author: AgentStub,
    validSpan: z.string(),
});
export type CompanyRequired = z.infer<typeof CompanyRequired>;
        
        
        
        
        
        
        
        
        
        
export const CompanySingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Company,
});

export const CompanyDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const CompanyListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Company),
	next: z.optional(Company),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CompanyDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                code: z.optional(z.string()),
                email: z.optional(z.string()),
                telno: z.optional(z.string()),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const CompanyDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: CompanyDelta,
	next: CompanyDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CompanySingleTransition = z.union([
    CompanySingleAliveTransition, CompanyDelTransition, CompanyDeltaTransition,
]);

export const CompanyListTransition = z.union([
    CompanyListFullTransition, CompanyDeltaTransition,
]);








    
    
    
    
    
    

export const NewCompanyFood = z.object({
        displayName: z.string(),
        sortName: z.optional(z.string()),
        code: z.string(),
        address: z.optional(z.string()),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
});

export const NewCompanyFoodRequired = z.object({
    displayName: z.string(),
    sortName: z.string(),
    code: z.string(),
    address: z.string(),
    email: z.string(),
    telno: z.string(),
});
export type NewCompanyFoodRequired = z.infer<typeof NewCompanyFoodRequired>;








    
    
    

export const CompanyStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const CompanyStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type CompanyStubRequired = z.infer<typeof CompanyStubRequired>;
        
        
        
export const CompanyStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: CompanyStub,
});

export const CompanyStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const CompanyStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(CompanyStub),
	next: z.optional(CompanyStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CompanyStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const CompanyStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: CompanyStubDelta,
	next: CompanyStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CompanyStubSingleTransition = z.union([
    CompanyStubSingleAliveTransition, CompanyStubDelTransition, CompanyStubDeltaTransition,
]);

export const CompanyStubListTransition = z.union([
    CompanyStubListFullTransition, CompanyStubDeltaTransition,
]);








    
    

export const CompanyConflict = z.object({
        requested: NewCompanyFood,
        existing: CompanyStub,
});

export const CompanyConflictRequired = z.object({
    requested: NewCompanyFood,
    existing: CompanyStub,
});
export type CompanyConflictRequired = z.infer<typeof CompanyConflictRequired>;








    
    
    

export const CompanyUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(CompanyConflict),
});

export const CompanyUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: CompanyConflict,
});
export type CompanyUpsertResultRequired = z.infer<typeof CompanyUpsertResultRequired>;








    
    
    
    
    

export const CompanyPatch = z.object({
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        code: z.optional(z.string()),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
});

export const CompanyPatchRequired = z.object({
    displayName: z.string(),
    sortName: z.string(),
    code: z.string(),
    email: z.string(),
    telno: z.string(),
});
export type CompanyPatchRequired = z.infer<typeof CompanyPatchRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    

export const Venue = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        company: CompanyStub,
        displayName: z.string(),
        sortName: z.optional(z.string()),
        code: z.string(),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
        address: z.optional(z.string()),
        geoloc: z.optional(z.string()),
        author: AgentStub,
        validSpan: z.string(),
});

export const VenueRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    company: CompanyStub,
    displayName: z.string(),
    sortName: z.string(),
    code: z.string(),
    email: z.string(),
    telno: z.string(),
    address: z.string(),
    geoloc: z.string(),
    author: AgentStub,
    validSpan: z.string(),
});
export type VenueRequired = z.infer<typeof VenueRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
export const VenueSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Venue,
});

export const VenueDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const VenueListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Venue),
	next: z.optional(Venue),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const VenueDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                company: z.optional(CompanyStub),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                code: z.optional(z.string()),
                email: z.optional(z.string()),
                telno: z.optional(z.string()),
                address: z.optional(z.string()),
                geoloc: z.optional(z.string()),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const VenueDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: VenueDelta,
	next: VenueDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const VenueSingleTransition = z.union([
    VenueSingleAliveTransition, VenueDelTransition, VenueDeltaTransition,
]);

export const VenueListTransition = z.union([
    VenueListFullTransition, VenueDeltaTransition,
]);








    
    
    
    
    
    
    
    

export const NewVenueFood = z.object({
        companyId: z.string(),
        displayName: z.string(),
        code: z.string(),
        sortName: z.optional(z.string()),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
        address: z.optional(z.string()),
        geoloc: z.optional(z.string()),
});

export const NewVenueFoodRequired = z.object({
    companyId: z.string(),
    displayName: z.string(),
    code: z.string(),
    sortName: z.string(),
    email: z.string(),
    telno: z.string(),
    address: z.string(),
    geoloc: z.string(),
});
export type NewVenueFoodRequired = z.infer<typeof NewVenueFoodRequired>;








    
    
    
    
    
    
    
    
    
    
    

export const UpsertableVenue = z.object({
        companyId: z.optional(z.string()),
        companyCode: z.optional(z.string()),
        companyName: z.optional(z.string()),
        companySortName: z.optional(z.string()),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
        address: z.optional(z.string()),
        geoloc: z.optional(z.string()),
});

export const UpsertableVenueRequired = z.object({
    companyId: z.string(),
    companyCode: z.string(),
    companyName: z.string(),
    companySortName: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    email: z.string(),
    telno: z.string(),
    address: z.string(),
    geoloc: z.string(),
});
export type UpsertableVenueRequired = z.infer<typeof UpsertableVenueRequired>;








    
    
    

export const VenueStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const VenueStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type VenueStubRequired = z.infer<typeof VenueStubRequired>;








    
    

export const VenueConflict = z.object({
        requested: UpsertableVenue,
        existing: VenueStub,
});

export const VenueConflictRequired = z.object({
    requested: UpsertableVenue,
    existing: VenueStub,
});
export type VenueConflictRequired = z.infer<typeof VenueConflictRequired>;








    
    
    
    

export const VenueUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        companyConflict: z.optional(CompanyConflict),
        conflict: z.optional(VenueConflict),
});

export const VenueUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    companyConflict: CompanyConflict,
    conflict: VenueConflict,
});
export type VenueUpsertResultRequired = z.infer<typeof VenueUpsertResultRequired>;








    
    
    
    
    
    
    
    

export const VenuePatch = z.object({
        companyId: z.optional(z.string()),
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        code: z.optional(z.string()),
        email: z.optional(z.string()),
        telno: z.optional(z.string()),
        address: z.optional(z.string()),
        geoloc: z.optional(z.string()),
});

export const VenuePatchRequired = z.object({
    companyId: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    code: z.string(),
    email: z.string(),
    telno: z.string(),
    address: z.string(),
    geoloc: z.string(),
});
export type VenuePatchRequired = z.infer<typeof VenuePatchRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const Agent = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        company: CompanyStub,
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        telno: z.optional(z.string()),
        email: z.optional(z.string()),
        loginName: z.optional(z.string()),
        canAdmin: z.boolean(),
        canDrive: z.boolean(),
        canDispatch: z.boolean(),
        admitterFor: z.optional(VenueStub),
        inspectorFor: z.optional(VenueStub),
        supervisorFor: z.optional(VenueStub),
        author: AgentStub,
        validSpan: z.string(),
});

export const AgentRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    company: CompanyStub,
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    telno: z.string(),
    email: z.string(),
    loginName: z.string(),
    canAdmin: z.boolean(),
    canDrive: z.boolean(),
    canDispatch: z.boolean(),
    admitterFor: VenueStub,
    inspectorFor: VenueStub,
    supervisorFor: VenueStub,
    author: AgentStub,
    validSpan: z.string(),
});
export type AgentRequired = z.infer<typeof AgentRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
export const AgentSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Agent,
});

export const AgentDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const AgentListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Agent),
	next: z.optional(Agent),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                company: z.optional(CompanyStub),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                telno: z.optional(z.string()),
                email: z.optional(z.string()),
                loginName: z.optional(z.string()),
                canAdmin: z.optional(z.boolean()),
                canDrive: z.optional(z.boolean()),
                canDispatch: z.optional(z.boolean()),
                admitterFor: z.optional(VenueStub),
                inspectorFor: z.optional(VenueStub),
                supervisorFor: z.optional(VenueStub),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const AgentDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: AgentDelta,
	next: AgentDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentSingleTransition = z.union([
    AgentSingleAliveTransition, AgentDelTransition, AgentDeltaTransition,
]);

export const AgentListTransition = z.union([
    AgentListFullTransition, AgentDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const NewAgentFood = z.object({
        companyId: z.string(),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        telno: z.optional(z.string()),
        email: z.optional(z.string()),
        canAdmin: z.optional(z.boolean()),
        canDrive: z.optional(z.boolean()),
        canDispatch: z.optional(z.boolean()),
        admitterFor: z.optional(z.string()),
        inspectorFor: z.optional(z.string()),
        supervisorFor: z.optional(z.string()),
        loginName: z.optional(z.string()),
        password: z.optional(z.string()),
});

export const NewAgentFoodRequired = z.object({
    companyId: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    telno: z.string(),
    email: z.string(),
    canAdmin: z.boolean(),
    canDrive: z.boolean(),
    canDispatch: z.boolean(),
    admitterFor: z.string(),
    inspectorFor: z.string(),
    supervisorFor: z.string(),
    loginName: z.string(),
    password: z.string(),
});
export type NewAgentFoodRequired = z.infer<typeof NewAgentFoodRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const UpsertableAgent = z.object({
        companyId: z.optional(z.string()),
        companyCode: z.optional(z.string()),
        companyName: z.optional(z.string()),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        telno: z.optional(z.string()),
        email: z.optional(z.string()),
        canAdmin: z.optional(z.boolean()),
        canDrive: z.optional(z.boolean()),
        canDispatch: z.optional(z.boolean()),
        admitterFor: z.optional(z.string()),
        admitterForCode: z.optional(z.string()),
        admitterForName: z.optional(z.string()),
        inspectorFor: z.optional(z.string()),
        inspectorForCode: z.optional(z.string()),
        inspectorForName: z.optional(z.string()),
        supervisorFor: z.optional(z.string()),
        supervisorForCode: z.optional(z.string()),
        supervisorForName: z.optional(z.string()),
        loginName: z.optional(z.string()),
        password: z.optional(z.string()),
});

export const UpsertableAgentRequired = z.object({
    companyId: z.string(),
    companyCode: z.string(),
    companyName: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    telno: z.string(),
    email: z.string(),
    canAdmin: z.boolean(),
    canDrive: z.boolean(),
    canDispatch: z.boolean(),
    admitterFor: z.string(),
    admitterForCode: z.string(),
    admitterForName: z.string(),
    inspectorFor: z.string(),
    inspectorForCode: z.string(),
    inspectorForName: z.string(),
    supervisorFor: z.string(),
    supervisorForCode: z.string(),
    supervisorForName: z.string(),
    loginName: z.string(),
    password: z.string(),
});
export type UpsertableAgentRequired = z.infer<typeof UpsertableAgentRequired>;








    
    
    
    
    

export const AgentUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        companyConflict: z.optional(CompanyConflict),
        venueConflict: z.optional(VenueConflict),
        conflict: z.optional(AgentStub),
});

export const AgentUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    companyConflict: CompanyConflict,
    venueConflict: VenueConflict,
    conflict: AgentStub,
});
export type AgentUpsertResultRequired = z.infer<typeof AgentUpsertResultRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    

export const AgentPatch = z.object({
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        loginName: z.optional(z.string()),
        password: z.optional(z.string()),
        code: z.optional(z.string()),
        telno: z.optional(z.string()),
        email: z.optional(z.string()),
        canAdmin: z.optional(z.boolean()),
        canDrive: z.optional(z.boolean()),
        canDispatch: z.optional(z.boolean()),
        admitterFor: z.optional(z.string()),
        inspectorFor: z.optional(z.string()),
        supervisorFor: z.optional(z.string()),
});

export const AgentPatchRequired = z.object({
    displayName: z.string(),
    sortName: z.string(),
    loginName: z.string(),
    password: z.string(),
    code: z.string(),
    telno: z.string(),
    email: z.string(),
    canAdmin: z.boolean(),
    canDrive: z.boolean(),
    canDispatch: z.boolean(),
    admitterFor: z.string(),
    inspectorFor: z.string(),
    supervisorFor: z.string(),
});
export type AgentPatchRequired = z.infer<typeof AgentPatchRequired>;








    
    
    
    
    
    

export const SelfPatch = z.object({
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        telno: z.optional(z.string()),
        email: z.optional(z.string()),
        loginName: z.optional(z.string()),
        prefs: z.optional(z.any()),
});

export const SelfPatchRequired = z.object({
    displayName: z.string(),
    sortName: z.string(),
    telno: z.string(),
    email: z.string(),
    loginName: z.string(),
    prefs: z.any(),
});
export type SelfPatchRequired = z.infer<typeof SelfPatchRequired>;








    
    
    

export const PasswordChange = z.object({
        targetId: z.string(),
        oldPassword: z.string(),
        newPassword: z.string(),
});

export const PasswordChangeRequired = z.object({
    targetId: z.string(),
    oldPassword: z.string(),
    newPassword: z.string(),
});
export type PasswordChangeRequired = z.infer<typeof PasswordChangeRequired>;








    
    
    
    
    
    
    
    

export const AgentStamp = z.object({
        id: z.string(),
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(AgentStampFlavor),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const AgentStampRequired = z.object({
    id: z.string(),
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: AgentStampFlavor,
    photo: Photo,
    caption: z.string(),
});
export type AgentStampRequired = z.infer<typeof AgentStampRequired>;
        
        
        
        
        
        
        
        
export const AgentStampSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: AgentStamp,
});

export const AgentStampDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const AgentStampListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(AgentStamp),
	next: z.optional(AgentStamp),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentStampDelta = z.object({
                id: z.string(),
                subjectId: z.optional(z.string()),
                posted: z.optional(z.string()),
                cancelled: z.optional(z.string()),
                author: z.optional(AgentStub),
                flavor: z.optional(AgentStampFlavor),
                photo: z.optional(Photo),
                caption: z.optional(z.string()),
});

export const AgentStampDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: AgentStampDelta,
	next: AgentStampDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentStampSingleTransition = z.union([
    AgentStampSingleAliveTransition, AgentStampDelTransition, AgentStampDeltaTransition,
]);

export const AgentStampListTransition = z.union([
    AgentStampListFullTransition, AgentStampDeltaTransition,
]);








    
    
    
    

export const NewAgentStampFood = z.object({
        agentId: z.string(),
        flavor: z.optional(AgentStampFlavor),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewAgentStampFoodRequired = z.object({
    agentId: z.string(),
    flavor: AgentStampFlavor,
    photoId: z.string(),
    caption: z.string(),
});
export type NewAgentStampFoodRequired = z.infer<typeof NewAgentStampFoodRequired>;








    
    
    
    
    
    
    

export const AgentOutlet = z.object({
        outletId: z.string(),
        agentId: z.string(),
        connectionStatus: z.string(),
        opened: z.string(),
        lastUsed: z.string(),
        lastConnected: z.optional(z.string()),
        lastDisconnected: z.optional(z.string()),
});

export const AgentOutletRequired = z.object({
    outletId: z.string(),
    agentId: z.string(),
    connectionStatus: z.string(),
    opened: z.string(),
    lastUsed: z.string(),
    lastConnected: z.string(),
    lastDisconnected: z.string(),
});
export type AgentOutletRequired = z.infer<typeof AgentOutletRequired>;








    
    
    
    
    

export const AgentPresence = z.object({
        id: z.string(),
        agent: AgentStub,
        lastShiftEventFlavor: z.optional(AgentStampFlavor),
        lastShiftEventPosted: z.optional(z.string()),
        outlets: AgentOutlet.array(),
});

export const AgentPresenceRequired = z.object({
    id: z.string(),
    agent: AgentStub,
    lastShiftEventFlavor: AgentStampFlavor,
    lastShiftEventPosted: z.string(),
    outlets: AgentOutlet.array(),
});
export type AgentPresenceRequired = z.infer<typeof AgentPresenceRequired>;
        
        
        
        
        
export const AgentPresenceSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: AgentPresence,
});

export const AgentPresenceDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const AgentPresenceListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(AgentPresence),
	next: z.optional(AgentPresence),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentPresenceDelta = z.object({
                id: z.string(),
                agent: z.optional(AgentStub),
                lastShiftEventFlavor: z.optional(AgentStampFlavor),
                lastShiftEventPosted: z.optional(z.string()),
                outlets: z.optional(AgentOutlet.array()),
});

export const AgentPresenceDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: AgentPresenceDelta,
	next: AgentPresenceDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const AgentPresenceSingleTransition = z.union([
    AgentPresenceSingleAliveTransition, AgentPresenceDelTransition, AgentPresenceDeltaTransition,
]);

export const AgentPresenceListTransition = z.union([
    AgentPresenceListFullTransition, AgentPresenceDeltaTransition,
]);








    
    
    
    
    
    
    
    
    

export const TruckModel = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        displayName: z.string(),
        code: z.string(),
        weightCapGrams: z.number(),
        volCapDm3: z.number(),
        author: AgentStub,
        validSpan: z.string(),
});

export const TruckModelRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    displayName: z.string(),
    code: z.string(),
    weightCapGrams: z.number(),
    volCapDm3: z.number(),
    author: AgentStub,
    validSpan: z.string(),
});
export type TruckModelRequired = z.infer<typeof TruckModelRequired>;
        
        
        
        
        
        
        
        
        
export const TruckModelSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TruckModel,
});

export const TruckModelDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TruckModelListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TruckModel),
	next: z.optional(TruckModel),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckModelDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
                weightCapGrams: z.optional(z.number()),
                volCapDm3: z.optional(z.number()),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const TruckModelDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TruckModelDelta,
	next: TruckModelDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckModelSingleTransition = z.union([
    TruckModelSingleAliveTransition, TruckModelDelTransition, TruckModelDeltaTransition,
]);

export const TruckModelListTransition = z.union([
    TruckModelListFullTransition, TruckModelDeltaTransition,
]);








    
    
    
    

export const NewTruckModelFood = z.object({
        code: z.string(),
        displayName: z.string(),
        weightCapGrams: z.optional(z.number()),
        volCapDm3: z.optional(z.number()),
});

export const NewTruckModelFoodRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    weightCapGrams: z.number(),
    volCapDm3: z.number(),
});
export type NewTruckModelFoodRequired = z.infer<typeof NewTruckModelFoodRequired>;








    
    
    

export const TruckModelUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(TruckModel),
});

export const TruckModelUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: TruckModel,
});
export type TruckModelUpsertResultRequired = z.infer<typeof TruckModelUpsertResultRequired>;








    
    
    
    

export const TruckModelPatch = z.object({
        displayName: z.optional(z.string()),
        code: z.optional(z.string()),
        weightCapGrams: z.optional(z.number()),
        volCapDm3: z.optional(z.number()),
});

export const TruckModelPatchRequired = z.object({
    displayName: z.string(),
    code: z.string(),
    weightCapGrams: z.number(),
    volCapDm3: z.number(),
});
export type TruckModelPatchRequired = z.infer<typeof TruckModelPatchRequired>;








    
    
    

export const TruckModelStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const TruckModelStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type TruckModelStubRequired = z.infer<typeof TruckModelStubRequired>;








    
    
    
    
    
    
    
    
    
    

export const Truck = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        company: CompanyStub,
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        model: z.optional(TruckModelStub),
        author: AgentStub,
        validSpan: z.string(),
});

export const TruckRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    company: CompanyStub,
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    model: TruckModelStub,
    author: AgentStub,
    validSpan: z.string(),
});
export type TruckRequired = z.infer<typeof TruckRequired>;
        
        
        
        
        
        
        
        
        
        
export const TruckSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Truck,
});

export const TruckDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TruckListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Truck),
	next: z.optional(Truck),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                company: z.optional(CompanyStub),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                model: z.optional(TruckModelStub),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const TruckDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TruckDelta,
	next: TruckDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckSingleTransition = z.union([
    TruckSingleAliveTransition, TruckDelTransition, TruckDeltaTransition,
]);

export const TruckListTransition = z.union([
    TruckListFullTransition, TruckDeltaTransition,
]);








    
    
    
    

export const NewTruckFood = z.object({
        displayName: z.string(),
        companyId: z.string(),
        code: z.string(),
        modelId: z.optional(z.string()),
});

export const NewTruckFoodRequired = z.object({
    displayName: z.string(),
    companyId: z.string(),
    code: z.string(),
    modelId: z.string(),
});
export type NewTruckFoodRequired = z.infer<typeof NewTruckFoodRequired>;








    
    
    
    
    
    

export const UpsertableTruck = z.object({
        modelId: z.optional(z.string()),
        companyId: z.optional(z.string()),
        companyCode: z.optional(z.string()),
        companyName: z.optional(z.string()),
        displayName: z.string(),
        code: z.optional(z.string()),
});

export const UpsertableTruckRequired = z.object({
    modelId: z.string(),
    companyId: z.string(),
    companyCode: z.string(),
    companyName: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type UpsertableTruckRequired = z.infer<typeof UpsertableTruckRequired>;








    
    
    

export const TruckStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const TruckStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type TruckStubRequired = z.infer<typeof TruckStubRequired>;
        
        
        
export const TruckStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TruckStub,
});

export const TruckStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TruckStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TruckStub),
	next: z.optional(TruckStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const TruckStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TruckStubDelta,
	next: TruckStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckStubSingleTransition = z.union([
    TruckStubSingleAliveTransition, TruckStubDelTransition, TruckStubDeltaTransition,
]);

export const TruckStubListTransition = z.union([
    TruckStubListFullTransition, TruckStubDeltaTransition,
]);








    
    

export const TruckConflict = z.object({
        requested: UpsertableTruck,
        existing: TruckStub,
});

export const TruckConflictRequired = z.object({
    requested: UpsertableTruck,
    existing: TruckStub,
});
export type TruckConflictRequired = z.infer<typeof TruckConflictRequired>;








    
    
    
    

export const TruckUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        companyConflict: z.optional(CompanyConflict),
        conflict: z.optional(TruckConflict),
});

export const TruckUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    companyConflict: CompanyConflict,
    conflict: TruckConflict,
});
export type TruckUpsertResultRequired = z.infer<typeof TruckUpsertResultRequired>;








    
    
    
    

export const TruckPatch = z.object({
        displayName: z.optional(z.string()),
        companyId: z.optional(z.string()),
        code: z.optional(z.string()),
        modelId: z.optional(z.string()),
});

export const TruckPatchRequired = z.object({
    displayName: z.string(),
    companyId: z.string(),
    code: z.string(),
    modelId: z.string(),
});
export type TruckPatchRequired = z.infer<typeof TruckPatchRequired>;








    
    
    
    
    
    
    
    

export const TruckStamp = z.object({
        id: z.string(),
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(TruckStampFlavor),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const TruckStampRequired = z.object({
    id: z.string(),
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: TruckStampFlavor,
    photo: Photo,
    caption: z.string(),
});
export type TruckStampRequired = z.infer<typeof TruckStampRequired>;
        
        
        
        
        
        
        
        
export const TruckStampSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TruckStamp,
});

export const TruckStampDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TruckStampListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TruckStamp),
	next: z.optional(TruckStamp),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckStampDelta = z.object({
                id: z.string(),
                subjectId: z.optional(z.string()),
                posted: z.optional(z.string()),
                cancelled: z.optional(z.string()),
                author: z.optional(AgentStub),
                flavor: z.optional(TruckStampFlavor),
                photo: z.optional(Photo),
                caption: z.optional(z.string()),
});

export const TruckStampDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TruckStampDelta,
	next: TruckStampDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckStampSingleTransition = z.union([
    TruckStampSingleAliveTransition, TruckStampDelTransition, TruckStampDeltaTransition,
]);

export const TruckStampListTransition = z.union([
    TruckStampListFullTransition, TruckStampDeltaTransition,
]);








    
    
    
    

export const NewTruckStampFood = z.object({
        truckId: z.string(),
        flavor: z.optional(TruckStampFlavor),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewTruckStampFoodRequired = z.object({
    truckId: z.string(),
    flavor: TruckStampFlavor,
    photoId: z.string(),
    caption: z.string(),
});
export type NewTruckStampFoodRequired = z.infer<typeof NewTruckStampFoodRequired>;








    
    
    
    

export const TruckCrewTenure = z.object({
        id: z.string(),
        truck: TruckStub,
        crew: AgentStub,
        validSpan: z.string(),
});

export const TruckCrewTenureRequired = z.object({
    id: z.string(),
    truck: TruckStub,
    crew: AgentStub,
    validSpan: z.string(),
});
export type TruckCrewTenureRequired = z.infer<typeof TruckCrewTenureRequired>;








    
    
    

export const CrewTenure = z.object({
        id: z.string(),
        crew: AgentStub,
        validSpan: z.string(),
});

export const CrewTenureRequired = z.object({
    id: z.string(),
    crew: AgentStub,
    validSpan: z.string(),
});
export type CrewTenureRequired = z.infer<typeof CrewTenureRequired>;
        
        
        
export const CrewTenureSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: CrewTenure,
});

export const CrewTenureDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const CrewTenureListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(CrewTenure),
	next: z.optional(CrewTenure),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CrewTenureDelta = z.object({
                id: z.string(),
                crew: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const CrewTenureDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: CrewTenureDelta,
	next: CrewTenureDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const CrewTenureSingleTransition = z.union([
    CrewTenureSingleAliveTransition, CrewTenureDelTransition, CrewTenureDeltaTransition,
]);

export const CrewTenureListTransition = z.union([
    CrewTenureListFullTransition, CrewTenureDeltaTransition,
]);








    
    
    

export const TruckTenure = z.object({
        id: z.string(),
        truck: TruckStub,
        validSpan: z.string(),
});

export const TruckTenureRequired = z.object({
    id: z.string(),
    truck: TruckStub,
    validSpan: z.string(),
});
export type TruckTenureRequired = z.infer<typeof TruckTenureRequired>;








    
    
    
    
    
    
    
    
    
    

export const ShinwaJobExtras = z.object({
        distanceFee: z.optional(z.boolean()),
        comboTripSlot: z.optional(z.boolean()),
        docking: z.optional(z.boolean()),
        salesContactName: z.optional(z.string()),
        orderContactName: z.optional(z.string()),
        specialNotes: z.optional(z.string()),
        orderNotes: z.optional(z.string().array()),
        driverNotes: z.optional(z.string().array()),
        photoRequired: z.optional(z.boolean()),
        manifestTypeCode: z.optional(z.string()),
});

export const ShinwaJobExtrasRequired = z.object({
    distanceFee: z.boolean(),
    comboTripSlot: z.boolean(),
    docking: z.boolean(),
    salesContactName: z.string(),
    orderContactName: z.string(),
    specialNotes: z.string(),
    orderNotes: z.string().array(),
    driverNotes: z.string().array(),
    photoRequired: z.boolean(),
    manifestTypeCode: z.string(),
});
export type ShinwaJobExtrasRequired = z.infer<typeof ShinwaJobExtrasRequired>;








    
    
    
    
    

export const TransportSegment = z.object({
        pickupCompany: z.optional(CompanyStub),
        pickupVenue: z.optional(VenueStub),
        transportCompany: z.optional(CompanyStub),
        dropoffCompany: z.optional(CompanyStub),
        dropoffVenue: z.optional(VenueStub),
});

export const TransportSegmentRequired = z.object({
    pickupCompany: CompanyStub,
    pickupVenue: VenueStub,
    transportCompany: CompanyStub,
    dropoffCompany: CompanyStub,
    dropoffVenue: VenueStub,
});
export type TransportSegmentRequired = z.infer<typeof TransportSegmentRequired>;








    
    
    
    

export const SanyuJobExtras = z.object({
        orderContact: z.optional(z.string()),
        manifestTypeCode: z.optional(z.string()),
        driverNotes: z.optional(z.string()),
        transportSegments: TransportSegment.array(),
});

export const SanyuJobExtrasRequired = z.object({
    orderContact: z.string(),
    manifestTypeCode: z.string(),
    driverNotes: z.string(),
    transportSegments: TransportSegment.array(),
});
export type SanyuJobExtrasRequired = z.infer<typeof SanyuJobExtrasRequired>;








    
    

export const WideJobExtras = z.object({
        shinwa: z.optional(ShinwaJobExtras),
        sanyu: z.optional(SanyuJobExtras),
});

export const WideJobExtrasRequired = z.object({
    shinwa: ShinwaJobExtras,
    sanyu: SanyuJobExtras,
});
export type WideJobExtrasRequired = z.infer<typeof WideJobExtrasRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const Job = z.object({
        id: z.string(),
        created: z.string(),
        jobCode: z.optional(z.string()),
        intakeCode: z.optional(z.string()),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        asof: z.optional(z.string()),
        sendCompany: CompanyStub,
        transportCompany: z.optional(CompanyStub),
        receiveCompany: z.optional(CompanyStub),
        origin: z.optional(VenueStub),
        provisionalDestination: z.optional(VenueStub),
        extras: z.optional(WideJobExtras),
        author: AgentStub,
        validSpan: z.string(),
});

export const JobRequired = z.object({
    id: z.string(),
    created: z.string(),
    jobCode: z.string(),
    intakeCode: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    asof: z.string(),
    sendCompany: CompanyStub,
    transportCompany: CompanyStub,
    receiveCompany: CompanyStub,
    origin: VenueStub,
    provisionalDestination: VenueStub,
    extras: WideJobExtras,
    author: AgentStub,
    validSpan: z.string(),
});
export type JobRequired = z.infer<typeof JobRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
export const JobSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Job,
});

export const JobDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const JobListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Job),
	next: z.optional(Job),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                jobCode: z.optional(z.string()),
                intakeCode: z.optional(z.string()),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                asof: z.optional(z.string()),
                sendCompany: z.optional(CompanyStub),
                transportCompany: z.optional(CompanyStub),
                receiveCompany: z.optional(CompanyStub),
                origin: z.optional(VenueStub),
                provisionalDestination: z.optional(VenueStub),
                extras: z.optional(WideJobExtras),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const JobDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: JobDelta,
	next: JobDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobSingleTransition = z.union([
    JobSingleAliveTransition, JobDelTransition, JobDeltaTransition,
]);

export const JobListTransition = z.union([
    JobListFullTransition, JobDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const UpsertableShinwaJob = z.object({
        timestamp: z.optional(z.string()),
        orderId: z.optional(z.string()),
        intakeId: z.optional(z.string()),
        assignedDriverId: z.optional(z.string()),
        assignedDriverName: z.optional(z.string()),
        assignedDriverCode: z.optional(z.string()),
        assignedTruckModelId: z.optional(z.string()),
        assignedTruckModelName: z.optional(z.string()),
        assignedTruckModelCode: z.optional(z.string()),
        transportCompanyId: z.optional(z.string()),
        transportCompanyName: z.optional(z.string()),
        transportCompanyCode: z.optional(z.string()),
        assignedTruckId: z.optional(z.string()),
        assignedTruckPlate: z.optional(z.string()),
        assignedTruckCode: z.optional(z.string()),
        pickupDate: z.optional(z.string()),
        pickupStartTime: z.optional(z.string()),
        pickupEndTime: z.optional(z.string()),
        dropoffCompanyId: z.optional(z.string()),
        dropoffCompanyName: z.optional(z.string()),
        dropoffCompanyKana: z.optional(z.string()),
        dropoffCompanyCode: z.optional(z.string()),
        dropoffCompanyAddressPostCode: z.optional(z.string()),
        dropoffCompanyAddress0: z.optional(z.string()),
        dropoffCompanyAddress1: z.optional(z.string()),
        dropoffCompanyAddress2: z.optional(z.string()),
        dropoffCompanyTel: z.optional(z.string()),
        dropoffCompanyKind: z.optional(z.string()),
        dropoffCompanyKindCode: z.optional(z.string()),
        dropoffVenueId: z.optional(z.string()),
        dropoffVenueName: z.optional(z.string()),
        dropoffVenueKana: z.optional(z.string()),
        dropoffVenueCode: z.optional(z.string()),
        dropoffVenueAddressPostCode: z.optional(z.string()),
        dropoffVenueAddress0: z.optional(z.string()),
        dropoffVenueAddress3: z.optional(z.string()),
        dropoffVenueAddress4: z.optional(z.string()),
        dropoffVenueTel: z.optional(z.string()),
        dropoffJwnetId: z.optional(z.string()),
        dropoffEdiId: z.optional(z.string()),
        dropoffVenueKind: z.optional(z.string()),
        dropoffVenueKindCode: z.optional(z.string()),
        pickupCompanyId: z.optional(z.string()),
        pickupCompanyName: z.optional(z.string()),
        pickupCompanyKana: z.optional(z.string()),
        pickupCompanyCode: z.optional(z.string()),
        pickupCompanyAddressCode: z.optional(z.string()),
        pickupCompanyAddress0: z.optional(z.string()),
        pickupCompanyAddress3: z.optional(z.string()),
        pickupCompanyAddress4: z.optional(z.string()),
        pickupCompanyTel: z.optional(z.string()),
        pickupCompanyKind: z.optional(z.string()),
        pickupCompanyKindCode: z.optional(z.string()),
        transferName: z.optional(z.string()),
        transferCode: z.optional(z.string()),
        pickupVenueId: z.optional(z.string()),
        pickupVenueName: z.optional(z.string()),
        pickupVenueKana: z.optional(z.string()),
        pickupVenueCode: z.optional(z.string()),
        pickupVenueAddress1: z.optional(z.string()),
        pickupVenueAddress0: z.optional(z.string()),
        pickupVenueAddress3: z.optional(z.string()),
        pickupVenueAddress4: z.optional(z.string()),
        pickupVenueTel: z.optional(z.string()),
        pickupJwnetId: z.optional(z.string()),
        pickupEdiId: z.optional(z.string()),
        pickupVenueKind: z.optional(z.string()),
        pickupVenueKindCode: z.optional(z.string()),
        pickupInstructions: z.optional(z.string()),
        regulatoryInfo: z.optional(z.string()),
        contactName: z.optional(z.string()),
        orderNotes1: z.optional(z.string()),
        orderNotes2: z.optional(z.string()),
        officeAddress: z.optional(z.string()),
        officeTel: z.optional(z.string()),
        additionalContacts: z.optional(z.string()),
        contactTel: z.optional(z.string()),
        manifestType: z.optional(z.string()),
        transferKind: z.optional(z.string()),
        businessKind: z.optional(z.string()),
        additionalWork: z.optional(z.string()),
        extraDistance: z.optional(z.string()),
        keyPhoto: z.optional(z.string()),
        keyBoard: z.optional(z.string()),
        prepNumber: z.optional(z.string()),
        contractDropoffSite: z.optional(z.string()),
        pathInfo: z.optional(z.string()),
        specialNotes: z.optional(z.string()),
        driverNotes1: z.optional(z.string()),
        driverNotes2: z.optional(z.string()),
        driverNotes3: z.optional(z.string()),
        driverNotes4: z.optional(z.string()),
        driverNotes5: z.optional(z.string()),
        detailUrl: z.optional(z.string()),
        salesContactName: z.optional(z.string()),
        salesContactCode: z.optional(z.string()),
        comboTripSlot: z.optional(z.string()),
        specialTruck: z.optional(z.string()),
        docking: z.optional(z.string()),
});

export const UpsertableShinwaJobRequired = z.object({
    timestamp: z.string(),
    orderId: z.string(),
    intakeId: z.string(),
    assignedDriverId: z.string(),
    assignedDriverName: z.string(),
    assignedDriverCode: z.string(),
    assignedTruckModelId: z.string(),
    assignedTruckModelName: z.string(),
    assignedTruckModelCode: z.string(),
    transportCompanyId: z.string(),
    transportCompanyName: z.string(),
    transportCompanyCode: z.string(),
    assignedTruckId: z.string(),
    assignedTruckPlate: z.string(),
    assignedTruckCode: z.string(),
    pickupDate: z.string(),
    pickupStartTime: z.string(),
    pickupEndTime: z.string(),
    dropoffCompanyId: z.string(),
    dropoffCompanyName: z.string(),
    dropoffCompanyKana: z.string(),
    dropoffCompanyCode: z.string(),
    dropoffCompanyAddressPostCode: z.string(),
    dropoffCompanyAddress0: z.string(),
    dropoffCompanyAddress1: z.string(),
    dropoffCompanyAddress2: z.string(),
    dropoffCompanyTel: z.string(),
    dropoffCompanyKind: z.string(),
    dropoffCompanyKindCode: z.string(),
    dropoffVenueId: z.string(),
    dropoffVenueName: z.string(),
    dropoffVenueKana: z.string(),
    dropoffVenueCode: z.string(),
    dropoffVenueAddressPostCode: z.string(),
    dropoffVenueAddress0: z.string(),
    dropoffVenueAddress3: z.string(),
    dropoffVenueAddress4: z.string(),
    dropoffVenueTel: z.string(),
    dropoffJwnetId: z.string(),
    dropoffEdiId: z.string(),
    dropoffVenueKind: z.string(),
    dropoffVenueKindCode: z.string(),
    pickupCompanyId: z.string(),
    pickupCompanyName: z.string(),
    pickupCompanyKana: z.string(),
    pickupCompanyCode: z.string(),
    pickupCompanyAddressCode: z.string(),
    pickupCompanyAddress0: z.string(),
    pickupCompanyAddress3: z.string(),
    pickupCompanyAddress4: z.string(),
    pickupCompanyTel: z.string(),
    pickupCompanyKind: z.string(),
    pickupCompanyKindCode: z.string(),
    transferName: z.string(),
    transferCode: z.string(),
    pickupVenueId: z.string(),
    pickupVenueName: z.string(),
    pickupVenueKana: z.string(),
    pickupVenueCode: z.string(),
    pickupVenueAddress1: z.string(),
    pickupVenueAddress0: z.string(),
    pickupVenueAddress3: z.string(),
    pickupVenueAddress4: z.string(),
    pickupVenueTel: z.string(),
    pickupJwnetId: z.string(),
    pickupEdiId: z.string(),
    pickupVenueKind: z.string(),
    pickupVenueKindCode: z.string(),
    pickupInstructions: z.string(),
    regulatoryInfo: z.string(),
    contactName: z.string(),
    orderNotes1: z.string(),
    orderNotes2: z.string(),
    officeAddress: z.string(),
    officeTel: z.string(),
    additionalContacts: z.string(),
    contactTel: z.string(),
    manifestType: z.string(),
    transferKind: z.string(),
    businessKind: z.string(),
    additionalWork: z.string(),
    extraDistance: z.string(),
    keyPhoto: z.string(),
    keyBoard: z.string(),
    prepNumber: z.string(),
    contractDropoffSite: z.string(),
    pathInfo: z.string(),
    specialNotes: z.string(),
    driverNotes1: z.string(),
    driverNotes2: z.string(),
    driverNotes3: z.string(),
    driverNotes4: z.string(),
    driverNotes5: z.string(),
    detailUrl: z.string(),
    salesContactName: z.string(),
    salesContactCode: z.string(),
    comboTripSlot: z.string(),
    specialTruck: z.string(),
    docking: z.string(),
});
export type UpsertableShinwaJobRequired = z.infer<typeof UpsertableShinwaJobRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const UpsertableSanyuJob = z.object({
        timestamp: z.optional(z.string()),
        orderId: z.optional(z.string()),
        internalTransferFlag: z.optional(z.string()),
        pickupCompanyId: z.optional(z.string()),
        pickupCompanyName: z.optional(z.string()),
        pickupCompanyKana: z.optional(z.string()),
        pickupCompanyCode: z.optional(z.string()),
        pickupCompanyAddressPostCode: z.optional(z.string()),
        pickupCompanyAddress0: z.optional(z.string()),
        pickupCompanyAddress1: z.optional(z.string()),
        pickupCompanyAddress2: z.optional(z.string()),
        pickupCompanyTel: z.optional(z.string()),
        pickupVenueId: z.optional(z.string()),
        pickupVenueName: z.optional(z.string()),
        pickupVenueKana: z.optional(z.string()),
        pickupVenueCode: z.optional(z.string()),
        pickupVenueAddressPostCode: z.optional(z.string()),
        pickupVenueAddress0: z.optional(z.string()),
        pickupVenueAddress1: z.optional(z.string()),
        pickupVenueAddress2: z.optional(z.string()),
        pickupVenueTel: z.optional(z.string()),
        pickupDepartmentName: z.optional(z.string()),
        pickupDepartmentCode: z.optional(z.string()),
        stage1TransportCompanyName: z.optional(z.string()),
        stage1TransportCompanyKana: z.optional(z.string()),
        stage1TransportCompanyCode: z.optional(z.string()),
        stage1TransportCompanyAddressPostCode: z.optional(z.string()),
        stage1TransportCompanyAddress0: z.optional(z.string()),
        stage1TransportCompanyAddress1: z.optional(z.string()),
        stage1TransportCompanyAddress2: z.optional(z.string()),
        stage1TransportCompanyTel: z.optional(z.string()),
        stage1DropoffCompanyName: z.optional(z.string()),
        stage1DropoffCompanyKana: z.optional(z.string()),
        stage1DropoffCompanyCode: z.optional(z.string()),
        stage1DropoffVenueName: z.optional(z.string()),
        stage1DropoffVenueKana: z.optional(z.string()),
        stage1DropoffVenueCode: z.optional(z.string()),
        stage1DropoffVenueAddressPostCode: z.optional(z.string()),
        stage1DropoffVenueAddress0: z.optional(z.string()),
        stage1DropoffVenueAddress1: z.optional(z.string()),
        stage1DropoffVenueAddress2: z.optional(z.string()),
        stage1DropoffVenueTel: z.optional(z.string()),
        stage2TransportCompanyName: z.optional(z.string()),
        stage2TransportCompanyKana: z.optional(z.string()),
        stage2TransportCompanyCode: z.optional(z.string()),
        stage2TransportCompanyAddressPostCode: z.optional(z.string()),
        stage2TransportCompanyAddress0: z.optional(z.string()),
        stage2TransportCompanyAddress1: z.optional(z.string()),
        stage2TransportCompanyAddress2: z.optional(z.string()),
        stage2TransportCompanyTel: z.optional(z.string()),
        stage2DropoffCompanyName: z.optional(z.string()),
        stage2DropoffCompanyKana: z.optional(z.string()),
        stage2DropoffCompanyCode: z.optional(z.string()),
        stage2DropoffVenueName: z.optional(z.string()),
        stage2DropoffVenueKana: z.optional(z.string()),
        stage2DropoffVenueCode: z.optional(z.string()),
        stage2DropoffVenueAddressPostCode: z.optional(z.string()),
        stage2DropoffVenueAddress0: z.optional(z.string()),
        stage2DropoffVenueAddress1: z.optional(z.string()),
        stage2DropoffVenueAddress2: z.optional(z.string()),
        stage2DropoffVenueTel: z.optional(z.string()),
        stage3TransportCompanyName: z.optional(z.string()),
        stage3TransportCompanyKana: z.optional(z.string()),
        stage3TransportCompanyCode: z.optional(z.string()),
        stage3TransportCompanyAddressPostCode: z.optional(z.string()),
        stage3TransportCompanyAddress0: z.optional(z.string()),
        stage3TransportCompanyAddress1: z.optional(z.string()),
        stage3TransportCompanyAddress2: z.optional(z.string()),
        stage3TransportCompanyTel: z.optional(z.string()),
        stage3DropoffCompanyName: z.optional(z.string()),
        stage3DropoffCompanyKana: z.optional(z.string()),
        stage3DropoffCompanyCode: z.optional(z.string()),
        stage3DropoffVenueName: z.optional(z.string()),
        stage3DropoffVenueKana: z.optional(z.string()),
        stage3DropoffVenueCode: z.optional(z.string()),
        stage3DropoffVenueAddressPostCode: z.optional(z.string()),
        stage3DropoffVenueAddress0: z.optional(z.string()),
        stage3DropoffVenueAddress1: z.optional(z.string()),
        stage3DropoffVenueAddress2: z.optional(z.string()),
        stage3DropoffVenueTel: z.optional(z.string()),
        stage4TransportCompanyName: z.optional(z.string()),
        stage4TransportCompanyKana: z.optional(z.string()),
        stage4TransportCompanyCode: z.optional(z.string()),
        stage4TransportCompanyAddressPostCode: z.optional(z.string()),
        stage4TransportCompanyAddress0: z.optional(z.string()),
        stage4TransportCompanyAddress1: z.optional(z.string()),
        stage4TransportCompanyAddress2: z.optional(z.string()),
        stage4TransportCompanyTel: z.optional(z.string()),
        stage4DropoffCompanyName: z.optional(z.string()),
        stage4DropoffCompanyKana: z.optional(z.string()),
        stage4DropoffCompanyCode: z.optional(z.string()),
        stage4DropoffVenueName: z.optional(z.string()),
        stage4DropoffVenueKana: z.optional(z.string()),
        stage4DropoffVenueCode: z.optional(z.string()),
        stage4DropoffVenueAddressPostCode: z.optional(z.string()),
        stage4DropoffVenueAddress0: z.optional(z.string()),
        stage4DropoffVenueAddress1: z.optional(z.string()),
        stage4DropoffVenueAddress2: z.optional(z.string()),
        stage4DropoffVenueTel: z.optional(z.string()),
        stage5TransportCompanyName: z.optional(z.string()),
        stage5TransportCompanyKana: z.optional(z.string()),
        stage5TransportCompanyCode: z.optional(z.string()),
        stage5TransportCompanyAddressPostCode: z.optional(z.string()),
        stage5TransportCompanyAddress0: z.optional(z.string()),
        stage5TransportCompanyAddress1: z.optional(z.string()),
        stage5TransportCompanyAddress2: z.optional(z.string()),
        stage5TransportCompanyTel: z.optional(z.string()),
        dropoffCompanyId: z.optional(z.string()),
        dropoffCompanyName: z.optional(z.string()),
        dropoffCompanyKana: z.optional(z.string()),
        dropoffCompanyCode: z.optional(z.string()),
        dropoffCompanyAddressPostCode: z.optional(z.string()),
        dropoffCompanyAddress0: z.optional(z.string()),
        dropoffCompanyAddress1: z.optional(z.string()),
        dropoffCompanyAddress2: z.optional(z.string()),
        dropoffCompanyTel: z.optional(z.string()),
        dropoffVenueId: z.optional(z.string()),
        dropoffVenueName: z.optional(z.string()),
        dropoffVenueKana: z.optional(z.string()),
        dropoffVenueCode: z.optional(z.string()),
        dropoffVenueAddressPostCode: z.optional(z.string()),
        dropoffVenueAddress0: z.optional(z.string()),
        dropoffVenueAddress1: z.optional(z.string()),
        dropoffVenueAddress2: z.optional(z.string()),
        dropoffVenueTel: z.optional(z.string()),
        billingEntityName: z.optional(z.string()),
        billingEntityCode: z.optional(z.string()),
        billingDepartmentName: z.optional(z.string()),
        billingDepartmentCode: z.optional(z.string()),
        orderContact: z.optional(z.string()),
        orderNotes2: z.optional(z.string()),
        orderNotes3: z.optional(z.string()),
        orderNotes4: z.optional(z.string()),
        orderNotes5: z.optional(z.string()),
        manifestType: z.optional(z.string()),
        driverNotes: z.optional(z.string()),
        siteContact: z.optional(z.string()),
});

export const UpsertableSanyuJobRequired = z.object({
    timestamp: z.string(),
    orderId: z.string(),
    internalTransferFlag: z.string(),
    pickupCompanyId: z.string(),
    pickupCompanyName: z.string(),
    pickupCompanyKana: z.string(),
    pickupCompanyCode: z.string(),
    pickupCompanyAddressPostCode: z.string(),
    pickupCompanyAddress0: z.string(),
    pickupCompanyAddress1: z.string(),
    pickupCompanyAddress2: z.string(),
    pickupCompanyTel: z.string(),
    pickupVenueId: z.string(),
    pickupVenueName: z.string(),
    pickupVenueKana: z.string(),
    pickupVenueCode: z.string(),
    pickupVenueAddressPostCode: z.string(),
    pickupVenueAddress0: z.string(),
    pickupVenueAddress1: z.string(),
    pickupVenueAddress2: z.string(),
    pickupVenueTel: z.string(),
    pickupDepartmentName: z.string(),
    pickupDepartmentCode: z.string(),
    stage1TransportCompanyName: z.string(),
    stage1TransportCompanyKana: z.string(),
    stage1TransportCompanyCode: z.string(),
    stage1TransportCompanyAddressPostCode: z.string(),
    stage1TransportCompanyAddress0: z.string(),
    stage1TransportCompanyAddress1: z.string(),
    stage1TransportCompanyAddress2: z.string(),
    stage1TransportCompanyTel: z.string(),
    stage1DropoffCompanyName: z.string(),
    stage1DropoffCompanyKana: z.string(),
    stage1DropoffCompanyCode: z.string(),
    stage1DropoffVenueName: z.string(),
    stage1DropoffVenueKana: z.string(),
    stage1DropoffVenueCode: z.string(),
    stage1DropoffVenueAddressPostCode: z.string(),
    stage1DropoffVenueAddress0: z.string(),
    stage1DropoffVenueAddress1: z.string(),
    stage1DropoffVenueAddress2: z.string(),
    stage1DropoffVenueTel: z.string(),
    stage2TransportCompanyName: z.string(),
    stage2TransportCompanyKana: z.string(),
    stage2TransportCompanyCode: z.string(),
    stage2TransportCompanyAddressPostCode: z.string(),
    stage2TransportCompanyAddress0: z.string(),
    stage2TransportCompanyAddress1: z.string(),
    stage2TransportCompanyAddress2: z.string(),
    stage2TransportCompanyTel: z.string(),
    stage2DropoffCompanyName: z.string(),
    stage2DropoffCompanyKana: z.string(),
    stage2DropoffCompanyCode: z.string(),
    stage2DropoffVenueName: z.string(),
    stage2DropoffVenueKana: z.string(),
    stage2DropoffVenueCode: z.string(),
    stage2DropoffVenueAddressPostCode: z.string(),
    stage2DropoffVenueAddress0: z.string(),
    stage2DropoffVenueAddress1: z.string(),
    stage2DropoffVenueAddress2: z.string(),
    stage2DropoffVenueTel: z.string(),
    stage3TransportCompanyName: z.string(),
    stage3TransportCompanyKana: z.string(),
    stage3TransportCompanyCode: z.string(),
    stage3TransportCompanyAddressPostCode: z.string(),
    stage3TransportCompanyAddress0: z.string(),
    stage3TransportCompanyAddress1: z.string(),
    stage3TransportCompanyAddress2: z.string(),
    stage3TransportCompanyTel: z.string(),
    stage3DropoffCompanyName: z.string(),
    stage3DropoffCompanyKana: z.string(),
    stage3DropoffCompanyCode: z.string(),
    stage3DropoffVenueName: z.string(),
    stage3DropoffVenueKana: z.string(),
    stage3DropoffVenueCode: z.string(),
    stage3DropoffVenueAddressPostCode: z.string(),
    stage3DropoffVenueAddress0: z.string(),
    stage3DropoffVenueAddress1: z.string(),
    stage3DropoffVenueAddress2: z.string(),
    stage3DropoffVenueTel: z.string(),
    stage4TransportCompanyName: z.string(),
    stage4TransportCompanyKana: z.string(),
    stage4TransportCompanyCode: z.string(),
    stage4TransportCompanyAddressPostCode: z.string(),
    stage4TransportCompanyAddress0: z.string(),
    stage4TransportCompanyAddress1: z.string(),
    stage4TransportCompanyAddress2: z.string(),
    stage4TransportCompanyTel: z.string(),
    stage4DropoffCompanyName: z.string(),
    stage4DropoffCompanyKana: z.string(),
    stage4DropoffCompanyCode: z.string(),
    stage4DropoffVenueName: z.string(),
    stage4DropoffVenueKana: z.string(),
    stage4DropoffVenueCode: z.string(),
    stage4DropoffVenueAddressPostCode: z.string(),
    stage4DropoffVenueAddress0: z.string(),
    stage4DropoffVenueAddress1: z.string(),
    stage4DropoffVenueAddress2: z.string(),
    stage4DropoffVenueTel: z.string(),
    stage5TransportCompanyName: z.string(),
    stage5TransportCompanyKana: z.string(),
    stage5TransportCompanyCode: z.string(),
    stage5TransportCompanyAddressPostCode: z.string(),
    stage5TransportCompanyAddress0: z.string(),
    stage5TransportCompanyAddress1: z.string(),
    stage5TransportCompanyAddress2: z.string(),
    stage5TransportCompanyTel: z.string(),
    dropoffCompanyId: z.string(),
    dropoffCompanyName: z.string(),
    dropoffCompanyKana: z.string(),
    dropoffCompanyCode: z.string(),
    dropoffCompanyAddressPostCode: z.string(),
    dropoffCompanyAddress0: z.string(),
    dropoffCompanyAddress1: z.string(),
    dropoffCompanyAddress2: z.string(),
    dropoffCompanyTel: z.string(),
    dropoffVenueId: z.string(),
    dropoffVenueName: z.string(),
    dropoffVenueKana: z.string(),
    dropoffVenueCode: z.string(),
    dropoffVenueAddressPostCode: z.string(),
    dropoffVenueAddress0: z.string(),
    dropoffVenueAddress1: z.string(),
    dropoffVenueAddress2: z.string(),
    dropoffVenueTel: z.string(),
    billingEntityName: z.string(),
    billingEntityCode: z.string(),
    billingDepartmentName: z.string(),
    billingDepartmentCode: z.string(),
    orderContact: z.string(),
    orderNotes2: z.string(),
    orderNotes3: z.string(),
    orderNotes4: z.string(),
    orderNotes5: z.string(),
    manifestType: z.string(),
    driverNotes: z.string(),
    siteContact: z.string(),
});
export type UpsertableSanyuJobRequired = z.infer<typeof UpsertableSanyuJobRequired>;








    
    
    
    
    
    
    
    
    // prioritizing JobStub needed for JobUpsertResult
	    






    
    
    

export const JobStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const JobStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type JobStubRequired = z.infer<typeof JobStubRequired>;
        
        
        
export const JobStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: JobStub,
});

export const JobStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const JobStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(JobStub),
	next: z.optional(JobStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const JobStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: JobStubDelta,
	next: JobStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobStubSingleTransition = z.union([
    JobStubSingleAliveTransition, JobStubDelTransition, JobStubDeltaTransition,
]);

export const JobStubListTransition = z.union([
    JobStubListFullTransition, JobStubDeltaTransition,
]);


		

export const JobUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        companyConflict: z.optional(CompanyConflict),
        venueConflict: z.optional(VenueConflict),
        driverConflict: z.optional(AgentStub),
        truckConflict: z.optional(TruckConflict),
        truckModelConflict: z.optional(TruckModelStub),
        conflict: z.optional(JobStub),
});

export const JobUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    companyConflict: CompanyConflict,
    venueConflict: VenueConflict,
    driverConflict: AgentStub,
    truckConflict: TruckConflict,
    truckModelConflict: TruckModelStub,
    conflict: JobStub,
});
export type JobUpsertResultRequired = z.infer<typeof JobUpsertResultRequired>;








    
    
    
    
    

export const JobPatch = z.object({
        jobCode: z.optional(z.string()),
        intakeCode: z.optional(z.string()),
        originId: z.optional(z.string()),
        provisionalDestinationId: z.optional(z.string()),
        extras: z.optional(WideJobExtras),
});

export const JobPatchRequired = z.object({
    jobCode: z.string(),
    intakeCode: z.string(),
    originId: z.string(),
    provisionalDestinationId: z.string(),
    extras: WideJobExtras,
});
export type JobPatchRequired = z.infer<typeof JobPatchRequired>;








    
    
    
    
    
    
    
    

export const JobStamp = z.object({
        id: z.string(),
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(JobStampFlavor),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const JobStampRequired = z.object({
    id: z.string(),
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: JobStampFlavor,
    photo: Photo,
    caption: z.string(),
});
export type JobStampRequired = z.infer<typeof JobStampRequired>;
        
        
        
        
        
        
        
        
export const JobStampSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: JobStamp,
});

export const JobStampDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const JobStampListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(JobStamp),
	next: z.optional(JobStamp),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobStampDelta = z.object({
                id: z.string(),
                subjectId: z.optional(z.string()),
                posted: z.optional(z.string()),
                cancelled: z.optional(z.string()),
                author: z.optional(AgentStub),
                flavor: z.optional(JobStampFlavor),
                photo: z.optional(Photo),
                caption: z.optional(z.string()),
});

export const JobStampDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: JobStampDelta,
	next: JobStampDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const JobStampSingleTransition = z.union([
    JobStampSingleAliveTransition, JobStampDelTransition, JobStampDeltaTransition,
]);

export const JobStampListTransition = z.union([
    JobStampListFullTransition, JobStampDeltaTransition,
]);








    
    
    
    

export const NewJobStampFood = z.object({
        jobId: z.string(),
        flavor: z.optional(JobStampFlavor),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewJobStampFoodRequired = z.object({
    jobId: z.string(),
    flavor: JobStampFlavor,
    photoId: z.string(),
    caption: z.string(),
});
export type NewJobStampFoodRequired = z.infer<typeof NewJobStampFoodRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    

export const SurchargeFlavor = z.object({
        id: z.string(),
        created: z.string(),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        unitId: z.optional(z.string()),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        applyToJobs: z.optional(z.boolean()),
        applyToBundles: z.optional(z.boolean()),
        applyToWastes: z.optional(z.boolean()),
});

export const SurchargeFlavorRequired = z.object({
    id: z.string(),
    created: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    unitId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    applyToJobs: z.boolean(),
    applyToBundles: z.boolean(),
    applyToWastes: z.boolean(),
});
export type SurchargeFlavorRequired = z.infer<typeof SurchargeFlavorRequired>;








    
    
    
    
    
    
    
    
    
    
    

export const NewSurchargeFlavorFood = z.object({
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        unitId: z.string(),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        applyToJobs: z.optional(z.boolean()),
        applyToBundles: z.optional(z.boolean()),
        applyToWastes: z.optional(z.boolean()),
});

export const NewSurchargeFlavorFoodRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    unitId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    applyToJobs: z.boolean(),
    applyToBundles: z.boolean(),
    applyToWastes: z.boolean(),
});
export type NewSurchargeFlavorFoodRequired = z.infer<typeof NewSurchargeFlavorFoodRequired>;








    
    
    
    
    
    
    
    
    
    
    

export const SurchargeFlavorPatch = z.object({
        code: z.optional(z.string()),
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        unitId: z.optional(z.string()),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        applyToJobs: z.optional(z.boolean()),
        applyToBundles: z.optional(z.boolean()),
        applyToWastes: z.optional(z.boolean()),
});

export const SurchargeFlavorPatchRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    unitId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    applyToJobs: z.boolean(),
    applyToBundles: z.boolean(),
    applyToWastes: z.boolean(),
});
export type SurchargeFlavorPatchRequired = z.infer<typeof SurchargeFlavorPatchRequired>;








    
    
    
    

export const SurchargeFlavorStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
        unitId: z.string(),
});

export const SurchargeFlavorStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
    unitId: z.string(),
});
export type SurchargeFlavorStubRequired = z.infer<typeof SurchargeFlavorStubRequired>;








    
    
    
    
    
    
    
    
    
    
    
    

export const Surcharge = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        subjectClass: SurchargeableClassname,
        subjectId: z.string(),
        flavor: SurchargeFlavorStub,
        source: SurchargeSource,
        quantity: z.optional(z.number()),
        cost: z.optional(z.number()),
        comment: z.optional(z.string()),
        author: z.optional(AgentStub),
        validSpan: z.string(),
});

export const SurchargeRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    subjectClass: SurchargeableClassname,
    subjectId: z.string(),
    flavor: SurchargeFlavorStub,
    source: SurchargeSource,
    quantity: z.number(),
    cost: z.number(),
    comment: z.string(),
    author: AgentStub,
    validSpan: z.string(),
});
export type SurchargeRequired = z.infer<typeof SurchargeRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
export const SurchargeSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Surcharge,
});

export const SurchargeDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const SurchargeListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Surcharge),
	next: z.optional(Surcharge),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const SurchargeDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                subjectClass: z.optional(SurchargeableClassname),
                subjectId: z.optional(z.string()),
                flavor: z.optional(SurchargeFlavorStub),
                source: z.optional(SurchargeSource),
                quantity: z.optional(z.number()),
                cost: z.optional(z.number()),
                comment: z.optional(z.string()),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const SurchargeDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: SurchargeDelta,
	next: SurchargeDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const SurchargeSingleTransition = z.union([
    SurchargeSingleAliveTransition, SurchargeDelTransition, SurchargeDeltaTransition,
]);

export const SurchargeListTransition = z.union([
    SurchargeListFullTransition, SurchargeDeltaTransition,
]);








    
    
    
    
    
    

export const NewSurchargeFood = z.object({
        subjectClass: SurchargeableClassname,
        subjectId: z.string(),
        flavorId: z.string(),
        quantity: z.optional(z.number()),
        cost: z.optional(z.number()),
        comment: z.optional(z.string()),
});

export const NewSurchargeFoodRequired = z.object({
    subjectClass: SurchargeableClassname,
    subjectId: z.string(),
    flavorId: z.string(),
    quantity: z.number(),
    cost: z.number(),
    comment: z.string(),
});
export type NewSurchargeFoodRequired = z.infer<typeof NewSurchargeFoodRequired>;








    
    
    

export const SurchargeFlavorUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(SurchargeFlavorStub),
});

export const SurchargeFlavorUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: SurchargeFlavorStub,
});
export type SurchargeFlavorUpsertResultRequired = z.infer<typeof SurchargeFlavorUpsertResultRequired>;








    
    
    
    

export const SurchargePatch = z.object({
        flavorId: z.optional(z.string()),
        quantity: z.optional(z.number()),
        cost: z.optional(z.number()),
        comment: z.optional(z.string()),
});

export const SurchargePatchRequired = z.object({
    flavorId: z.string(),
    quantity: z.number(),
    cost: z.number(),
    comment: z.string(),
});
export type SurchargePatchRequired = z.infer<typeof SurchargePatchRequired>;








    
    
    

export const TruckOrVenueStub = z.object({
        id: z.string(),
        truck: z.optional(TruckStub),
        venue: z.optional(VenueStub),
});

export const TruckOrVenueStubRequired = z.object({
    id: z.string(),
    truck: TruckStub,
    venue: VenueStub,
});
export type TruckOrVenueStubRequired = z.infer<typeof TruckOrVenueStubRequired>;
        
        
        
export const TruckOrVenueStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TruckOrVenueStub,
});

export const TruckOrVenueStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TruckOrVenueStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TruckOrVenueStub),
	next: z.optional(TruckOrVenueStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckOrVenueStubDelta = z.object({
                id: z.string(),
                truck: z.optional(TruckStub),
                venue: z.optional(VenueStub),
});

export const TruckOrVenueStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TruckOrVenueStubDelta,
	next: TruckOrVenueStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TruckOrVenueStubSingleTransition = z.union([
    TruckOrVenueStubSingleAliveTransition, TruckOrVenueStubDelTransition, TruckOrVenueStubDeltaTransition,
]);

export const TruckOrVenueStubListTransition = z.union([
    TruckOrVenueStubListFullTransition, TruckOrVenueStubDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const BundleExtras = z.object({
        fieldCancel: z.optional(z.boolean()),
        carrierBringCount: z.optional(z.number()),
        carrierTakeCount: z.optional(z.number()),
        bagBringCount: z.optional(z.number()),
        bagTakeCount: z.optional(z.number()),
        emptyBagTakeCount: z.optional(z.number()),
        assistBringCount: z.optional(z.number()),
        assistTakeCount: z.optional(z.number()),
        packingTime: z.optional(z.string()),
        containerBringCount: z.optional(z.number()),
        containerTakeCount: z.optional(z.number()),
        distanceFee: z.optional(z.boolean()),
        dollyFee: z.optional(z.boolean()),
        dockingFee: z.optional(z.boolean()),
        signageFee: z.optional(z.boolean()),
        halfDayFee: z.optional(z.boolean()),
        fullDayFee: z.optional(z.boolean()),
        eveningFee: z.optional(z.boolean()),
        lateNightFee: z.optional(z.boolean()),
        earlyMorningFee: z.optional(z.boolean()),
        manifestLegNumber: z.optional(z.number()),
});

export const BundleExtrasRequired = z.object({
    fieldCancel: z.boolean(),
    carrierBringCount: z.number(),
    carrierTakeCount: z.number(),
    bagBringCount: z.number(),
    bagTakeCount: z.number(),
    emptyBagTakeCount: z.number(),
    assistBringCount: z.number(),
    assistTakeCount: z.number(),
    packingTime: z.string(),
    containerBringCount: z.number(),
    containerTakeCount: z.number(),
    distanceFee: z.boolean(),
    dollyFee: z.boolean(),
    dockingFee: z.boolean(),
    signageFee: z.boolean(),
    halfDayFee: z.boolean(),
    fullDayFee: z.boolean(),
    eveningFee: z.boolean(),
    lateNightFee: z.boolean(),
    earlyMorningFee: z.boolean(),
    manifestLegNumber: z.number(),
});
export type BundleExtrasRequired = z.infer<typeof BundleExtrasRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    

export const Bundle = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        job: JobStub,
        rankWithinJob: z.number(),
        origin: TruckOrVenueStub,
        destination: z.optional(VenueStub),
        extras: z.optional(BundleExtras),
        author: AgentStub,
        validSpan: z.string(),
});

export const BundleRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    job: JobStub,
    rankWithinJob: z.number(),
    origin: TruckOrVenueStub,
    destination: VenueStub,
    extras: BundleExtras,
    author: AgentStub,
    validSpan: z.string(),
});
export type BundleRequired = z.infer<typeof BundleRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
export const BundleSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Bundle,
});

export const BundleDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const BundleListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Bundle),
	next: z.optional(Bundle),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                job: z.optional(JobStub),
                rankWithinJob: z.optional(z.number()),
                origin: z.optional(TruckOrVenueStub),
                destination: z.optional(VenueStub),
                extras: z.optional(BundleExtras),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const BundleDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: BundleDelta,
	next: BundleDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleSingleTransition = z.union([
    BundleSingleAliveTransition, BundleDelTransition, BundleDeltaTransition,
]);

export const BundleListTransition = z.union([
    BundleListFullTransition, BundleDeltaTransition,
]);








    
    
    
    
    // prioritizing BundleStamp needed for CompleteBundleHistory
	    






    
    
    
    
    
    
    
    

export const BundleStamp = z.object({
        id: z.string(),
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(BundleStampFlavor),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const BundleStampRequired = z.object({
    id: z.string(),
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: BundleStampFlavor,
    photo: Photo,
    caption: z.string(),
});
export type BundleStampRequired = z.infer<typeof BundleStampRequired>;
        
        
        
        
        
        
        
        
export const BundleStampSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: BundleStamp,
});

export const BundleStampDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const BundleStampListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(BundleStamp),
	next: z.optional(BundleStamp),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleStampDelta = z.object({
                id: z.string(),
                subjectId: z.optional(z.string()),
                posted: z.optional(z.string()),
                cancelled: z.optional(z.string()),
                author: z.optional(AgentStub),
                flavor: z.optional(BundleStampFlavor),
                photo: z.optional(Photo),
                caption: z.optional(z.string()),
});

export const BundleStampDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: BundleStampDelta,
	next: BundleStampDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleStampSingleTransition = z.union([
    BundleStampSingleAliveTransition, BundleStampDelTransition, BundleStampDeltaTransition,
]);

export const BundleStampListTransition = z.union([
    BundleStampListFullTransition, BundleStampDeltaTransition,
]);


		
    
    // prioritizing Transfer needed for CompleteBundleHistory
	    






    
    
    
    // prioritizing BundleStub needed for Transfer
	    






    
    
    

export const BundleStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
});

export const BundleStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
});
export type BundleStubRequired = z.infer<typeof BundleStubRequired>;
        
        
        
export const BundleStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: BundleStub,
});

export const BundleStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const BundleStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(BundleStub),
	next: z.optional(BundleStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleStubDelta = z.object({
                id: z.string(),
                displayName: z.optional(z.string()),
                code: z.optional(z.string()),
});

export const BundleStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: BundleStubDelta,
	next: BundleStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const BundleStubSingleTransition = z.union([
    BundleStubSingleAliveTransition, BundleStubDelTransition, BundleStubDeltaTransition,
]);

export const BundleStubListTransition = z.union([
    BundleStubListFullTransition, BundleStubDeltaTransition,
]);


		
    
    
    
    
    
    
    
    
    

export const Transfer = z.object({
        id: z.string(),
        created: z.string(),
        bundle: BundleStub,
        onloadVenue: z.optional(VenueStub),
        onloadStarted: z.optional(z.string()),
        onloadEnded: z.optional(z.string()),
        truck: TruckStub,
        offloadVenue: z.optional(VenueStub),
        offloadStarted: z.optional(z.string()),
        offloadEnded: z.optional(z.string()),
        lastModifier: AgentStub,
        lastModified: z.string(),
});

export const TransferRequired = z.object({
    id: z.string(),
    created: z.string(),
    bundle: BundleStub,
    onloadVenue: VenueStub,
    onloadStarted: z.string(),
    onloadEnded: z.string(),
    truck: TruckStub,
    offloadVenue: VenueStub,
    offloadStarted: z.string(),
    offloadEnded: z.string(),
    lastModifier: AgentStub,
    lastModified: z.string(),
});
export type TransferRequired = z.infer<typeof TransferRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
export const TransferSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Transfer,
});

export const TransferDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TransferListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Transfer),
	next: z.optional(Transfer),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TransferDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                bundle: z.optional(BundleStub),
                onloadVenue: z.optional(VenueStub),
                onloadStarted: z.optional(z.string()),
                onloadEnded: z.optional(z.string()),
                truck: z.optional(TruckStub),
                offloadVenue: z.optional(VenueStub),
                offloadStarted: z.optional(z.string()),
                offloadEnded: z.optional(z.string()),
                lastModifier: z.optional(AgentStub),
                lastModified: z.optional(z.string()),
});

export const TransferDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TransferDelta,
	next: TransferDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TransferSingleTransition = z.union([
    TransferSingleAliveTransition, TransferDelTransition, TransferDeltaTransition,
]);

export const TransferListTransition = z.union([
    TransferListFullTransition, TransferDeltaTransition,
]);


		
    
    
    // prioritizing CompleteWasteHistory needed for CompleteBundleHistory
	    






    
    // prioritizing Waste needed for CompleteWasteHistory
	    






    
    
    
    
    // prioritizing WasteFlavorStub needed for Waste
	    






    
    
    
    
    
    

export const WasteFlavorStub = z.object({
        id: z.string(),
        displayName: z.string(),
        code: z.string(),
        invoiceUnitId: z.optional(z.string()),
        manifestUnitId: z.optional(z.string()),
        stdPackingModeId: z.optional(z.string()),
});

export const WasteFlavorStubRequired = z.object({
    id: z.string(),
    displayName: z.string(),
    code: z.string(),
    invoiceUnitId: z.string(),
    manifestUnitId: z.string(),
    stdPackingModeId: z.string(),
});
export type WasteFlavorStubRequired = z.infer<typeof WasteFlavorStubRequired>;


		
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    // prioritizing WasteExtras needed for Waste
	    






    
    
    

export const WasteExtras = z.object({
        label: z.optional(z.string()),
        notes: z.optional(z.string()),
        isShelf: z.optional(z.boolean()),
});

export const WasteExtrasRequired = z.object({
    label: z.string(),
    notes: z.string(),
    isShelf: z.boolean(),
});
export type WasteExtrasRequired = z.infer<typeof WasteExtrasRequired>;


		
    
    

export const Waste = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        flavor: WasteFlavorStub,
        isInvManiLinked: z.boolean(),
        invQ: z.optional(z.number()),
        maniQ: z.optional(z.number()),
        invW: z.optional(z.number()),
        maniW: z.optional(z.number()),
        invV: z.optional(z.number()),
        maniV: z.optional(z.number()),
        packingModeId: z.optional(z.string()),
        packQ: z.optional(z.number()),
        bara0: z.optional(z.number()),
        bags: z.optional(z.number()),
        manifestTypeId: z.optional(z.string()),
        manifestNumber: z.optional(z.string()),
        origin: z.optional(VenueStub),
        destination: z.optional(VenueStub),
        notational: z.optional(z.boolean()),
        transformMode: z.optional(EntityStub),
        extras: z.optional(WasteExtras),
        author: AgentStub,
        validSpan: z.string(),
});

export const WasteRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    flavor: WasteFlavorStub,
    isInvManiLinked: z.boolean(),
    invQ: z.number(),
    maniQ: z.number(),
    invW: z.number(),
    maniW: z.number(),
    invV: z.number(),
    maniV: z.number(),
    packingModeId: z.string(),
    packQ: z.number(),
    bara0: z.number(),
    bags: z.number(),
    manifestTypeId: z.string(),
    manifestNumber: z.string(),
    origin: VenueStub,
    destination: VenueStub,
    notational: z.boolean(),
    transformMode: EntityStub,
    extras: WasteExtras,
    author: AgentStub,
    validSpan: z.string(),
});
export type WasteRequired = z.infer<typeof WasteRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
export const WasteSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Waste,
});

export const WasteDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const WasteListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Waste),
	next: z.optional(Waste),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                flavor: z.optional(WasteFlavorStub),
                isInvManiLinked: z.optional(z.boolean()),
                invQ: z.optional(z.number()),
                maniQ: z.optional(z.number()),
                invW: z.optional(z.number()),
                maniW: z.optional(z.number()),
                invV: z.optional(z.number()),
                maniV: z.optional(z.number()),
                packingModeId: z.optional(z.string()),
                packQ: z.optional(z.number()),
                bara0: z.optional(z.number()),
                bags: z.optional(z.number()),
                manifestTypeId: z.optional(z.string()),
                manifestNumber: z.optional(z.string()),
                origin: z.optional(VenueStub),
                destination: z.optional(VenueStub),
                notational: z.optional(z.boolean()),
                transformMode: z.optional(EntityStub),
                extras: z.optional(WasteExtras),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const WasteDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: WasteDelta,
	next: WasteDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteSingleTransition = z.union([
    WasteSingleAliveTransition, WasteDelTransition, WasteDeltaTransition,
]);

export const WasteListTransition = z.union([
    WasteListFullTransition, WasteDeltaTransition,
]);


		
    
    // prioritizing WasteStamp needed for CompleteWasteHistory
	    






    
    
    
    
    
    
    
    

export const WasteStamp = z.object({
        id: z.string(),
        subjectId: z.string(),
        posted: z.string(),
        cancelled: z.optional(z.string()),
        author: AgentStub,
        flavor: z.optional(WasteStampFlavor),
        photo: z.optional(Photo),
        caption: z.optional(z.string()),
});

export const WasteStampRequired = z.object({
    id: z.string(),
    subjectId: z.string(),
    posted: z.string(),
    cancelled: z.string(),
    author: AgentStub,
    flavor: WasteStampFlavor,
    photo: Photo,
    caption: z.string(),
});
export type WasteStampRequired = z.infer<typeof WasteStampRequired>;
        
        
        
        
        
        
        
        
export const WasteStampSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: WasteStamp,
});

export const WasteStampDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const WasteStampListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(WasteStamp),
	next: z.optional(WasteStamp),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteStampDelta = z.object({
                id: z.string(),
                subjectId: z.optional(z.string()),
                posted: z.optional(z.string()),
                cancelled: z.optional(z.string()),
                author: z.optional(AgentStub),
                flavor: z.optional(WasteStampFlavor),
                photo: z.optional(Photo),
                caption: z.optional(z.string()),
});

export const WasteStampDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: WasteStampDelta,
	next: WasteStampDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteStampSingleTransition = z.union([
    WasteStampSingleAliveTransition, WasteStampDelTransition, WasteStampDeltaTransition,
]);

export const WasteStampListTransition = z.union([
    WasteStampListFullTransition, WasteStampDeltaTransition,
]);


		
    

export const CompleteWasteHistory = z.object({
        revisions: Waste.array(),
        stamps: WasteStamp.array(),
        surcharges: Surcharge.array(),
});

export const CompleteWasteHistoryRequired = z.object({
    revisions: Waste.array(),
    stamps: WasteStamp.array(),
    surcharges: Surcharge.array(),
});
export type CompleteWasteHistoryRequired = z.infer<typeof CompleteWasteHistoryRequired>;


		

export const CompleteBundleHistory = z.object({
        bundle: Bundle,
        job: Job,
        revisions: Bundle.array(),
        stamps: BundleStamp.array(),
        transfers: Transfer.array(),
        surcharges: Surcharge.array(),
        wastes: CompleteWasteHistory.array(),
});

export const CompleteBundleHistoryRequired = z.object({
    bundle: Bundle,
    job: Job,
    revisions: Bundle.array(),
    stamps: BundleStamp.array(),
    transfers: Transfer.array(),
    surcharges: Surcharge.array(),
    wastes: CompleteWasteHistory.array(),
});
export type CompleteBundleHistoryRequired = z.infer<typeof CompleteBundleHistoryRequired>;








    
    
    
    
    // prioritizing NewWasteFood needed for NewGroundedBundleFood
	    






    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const NewWasteFood = z.object({
        flavorId: z.string(),
        isInvManiLinked: z.optional(z.boolean()),
        invQ: z.optional(z.number()),
        maniQ: z.optional(z.number()),
        invW: z.optional(z.number()),
        maniW: z.optional(z.number()),
        invV: z.optional(z.number()),
        maniV: z.optional(z.number()),
        packingModeId: z.optional(z.string()),
        packQ: z.optional(z.number()),
        bara0: z.optional(z.number()),
        bags: z.optional(z.number()),
        manifestTypeId: z.optional(z.string()),
        manifestNumber: z.optional(z.string()),
        originId: z.optional(z.string()),
        destinationId: z.optional(z.string()),
        notational: z.optional(z.boolean()),
        transformModeId: z.optional(z.string()),
        extras: z.optional(WasteExtras),
});

export const NewWasteFoodRequired = z.object({
    flavorId: z.string(),
    isInvManiLinked: z.boolean(),
    invQ: z.number(),
    maniQ: z.number(),
    invW: z.number(),
    maniW: z.number(),
    invV: z.number(),
    maniV: z.number(),
    packingModeId: z.string(),
    packQ: z.number(),
    bara0: z.number(),
    bags: z.number(),
    manifestTypeId: z.string(),
    manifestNumber: z.string(),
    originId: z.string(),
    destinationId: z.string(),
    notational: z.boolean(),
    transformModeId: z.string(),
    extras: WasteExtras,
});
export type NewWasteFoodRequired = z.infer<typeof NewWasteFoodRequired>;


		

export const NewGroundedBundleFood = z.object({
        jobId: z.string(),
        originVenueId: z.string(),
        destinationId: z.optional(z.string()),
        wastes: NewWasteFood.array(),
});

export const NewGroundedBundleFoodRequired = z.object({
    jobId: z.string(),
    originVenueId: z.string(),
    destinationId: z.string(),
    wastes: NewWasteFood.array(),
});
export type NewGroundedBundleFoodRequired = z.infer<typeof NewGroundedBundleFoodRequired>;








    
    
    
    

export const NewLoadedBundleFood = z.object({
        jobId: z.string(),
        originTruckId: z.string(),
        destinationId: z.optional(z.string()),
        wastes: NewWasteFood.array(),
});

export const NewLoadedBundleFoodRequired = z.object({
    jobId: z.string(),
    originTruckId: z.string(),
    destinationId: z.string(),
    wastes: NewWasteFood.array(),
});
export type NewLoadedBundleFoodRequired = z.infer<typeof NewLoadedBundleFoodRequired>;








    
    

export const BundlePatch = z.object({
        destinationId: z.optional(z.string()),
        extras: z.optional(BundleExtras),
});

export const BundlePatchRequired = z.object({
    destinationId: z.string(),
    extras: BundleExtras,
});
export type BundlePatchRequired = z.infer<typeof BundlePatchRequired>;








    
    
    
    

export const NewBundleStampFood = z.object({
        bundleId: z.string(),
        flavor: z.optional(BundleStampFlavor),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewBundleStampFoodRequired = z.object({
    bundleId: z.string(),
    flavor: BundleStampFlavor,
    photoId: z.string(),
    caption: z.string(),
});
export type NewBundleStampFoodRequired = z.infer<typeof NewBundleStampFoodRequired>;








    
    
    
    
    
    
    

export const Unit = z.object({
        id: z.string(),
        code: z.string(),
        displayName: z.string(),
        suffix: z.optional(z.string()),
        qx: z.number(),
        vx: z.number(),
        wx: z.number(),
});

export const UnitRequired = z.object({
    id: z.string(),
    code: z.string(),
    displayName: z.string(),
    suffix: z.string(),
    qx: z.number(),
    vx: z.number(),
    wx: z.number(),
});
export type UnitRequired = z.infer<typeof UnitRequired>;
        
        
        
        
        
        
        
export const UnitSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Unit,
});

export const UnitDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const UnitListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Unit),
	next: z.optional(Unit),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const UnitDelta = z.object({
                id: z.string(),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                suffix: z.optional(z.string()),
                qx: z.optional(z.number()),
                vx: z.optional(z.number()),
                wx: z.optional(z.number()),
});

export const UnitDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: UnitDelta,
	next: UnitDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const UnitSingleTransition = z.union([
    UnitSingleAliveTransition, UnitDelTransition, UnitDeltaTransition,
]);

export const UnitListTransition = z.union([
    UnitListFullTransition, UnitDeltaTransition,
]);








    
    
    
    
    

export const NewUnitFood = z.object({
        code: z.string(),
        displayName: z.string(),
        qx: z.number(),
        vx: z.number(),
        wx: z.number(),
});

export const NewUnitFoodRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    qx: z.number(),
    vx: z.number(),
    wx: z.number(),
});
export type NewUnitFoodRequired = z.infer<typeof NewUnitFoodRequired>;








    
    
    

export const UnitUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(Unit),
});

export const UnitUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: Unit,
});
export type UnitUpsertResultRequired = z.infer<typeof UnitUpsertResultRequired>;








    
    
    

export const SanyuWasteFlavorExtra = z.object({
        sanyuCode: z.optional(z.string()),
        sanyuCodeUnreliable: z.optional(z.boolean()),
        recycleCategory: z.optional(z.string()),
});

export const SanyuWasteFlavorExtraRequired = z.object({
    sanyuCode: z.string(),
    sanyuCodeUnreliable: z.boolean(),
    recycleCategory: z.string(),
});
export type SanyuWasteFlavorExtraRequired = z.infer<typeof SanyuWasteFlavorExtraRequired>;








    

export const WasteFlavorExtra = z.object({
        sanyu: z.optional(SanyuWasteFlavorExtra),
});

export const WasteFlavorExtraRequired = z.object({
    sanyu: SanyuWasteFlavorExtra,
});
export type WasteFlavorExtraRequired = z.infer<typeof WasteFlavorExtraRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const WasteFlavor = z.object({
        id: z.string(),
        created: z.string(),
        asof: z.optional(z.string()),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        invoiceUnitId: z.optional(z.string()),
        manifestName: z.optional(z.string()),
        manifestAbbrev: z.optional(z.string()),
        manifestCode: z.optional(z.string()),
        manifestUnitId: z.optional(z.string()),
        invoiceManiSlope: z.number(),
        invoiceManiIntercept: z.number(),
        stdPackingModeId: z.optional(z.string()),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        includeInShortform: z.optional(z.boolean()),
        birthable: z.optional(z.boolean()),
        divisible: z.optional(z.boolean()),
        venueId: z.optional(z.string()),
        extra: z.optional(WasteFlavorExtra),
        author: AgentStub,
        validSpan: z.string(),
});

export const WasteFlavorRequired = z.object({
    id: z.string(),
    created: z.string(),
    asof: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    invoiceUnitId: z.string(),
    manifestName: z.string(),
    manifestAbbrev: z.string(),
    manifestCode: z.string(),
    manifestUnitId: z.string(),
    invoiceManiSlope: z.number(),
    invoiceManiIntercept: z.number(),
    stdPackingModeId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    includeInShortform: z.boolean(),
    birthable: z.boolean(),
    divisible: z.boolean(),
    venueId: z.string(),
    extra: WasteFlavorExtra,
    author: AgentStub,
    validSpan: z.string(),
});
export type WasteFlavorRequired = z.infer<typeof WasteFlavorRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
export const WasteFlavorSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: WasteFlavor,
});

export const WasteFlavorDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const WasteFlavorListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(WasteFlavor),
	next: z.optional(WasteFlavor),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteFlavorDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                asof: z.optional(z.string()),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                abbrev: z.optional(z.string()),
                invoiceUnitId: z.optional(z.string()),
                manifestName: z.optional(z.string()),
                manifestAbbrev: z.optional(z.string()),
                manifestCode: z.optional(z.string()),
                manifestUnitId: z.optional(z.string()),
                invoiceManiSlope: z.optional(z.number()),
                invoiceManiIntercept: z.optional(z.number()),
                stdPackingModeId: z.optional(z.string()),
                showToDriver: z.optional(z.boolean()),
                showToIntaker: z.optional(z.boolean()),
                showToInspector: z.optional(z.boolean()),
                includeInShortform: z.optional(z.boolean()),
                birthable: z.optional(z.boolean()),
                divisible: z.optional(z.boolean()),
                venueId: z.optional(z.string()),
                extra: z.optional(WasteFlavorExtra),
                author: z.optional(AgentStub),
                validSpan: z.optional(z.string()),
});

export const WasteFlavorDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: WasteFlavorDelta,
	next: WasteFlavorDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteFlavorSingleTransition = z.union([
    WasteFlavorSingleAliveTransition, WasteFlavorDelTransition, WasteFlavorDeltaTransition,
]);

export const WasteFlavorListTransition = z.union([
    WasteFlavorListFullTransition, WasteFlavorDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const NewWasteFlavorFood = z.object({
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        invoiceUnitId: z.optional(z.string()),
        manifestName: z.optional(z.string()),
        manifestAbbrev: z.optional(z.string()),
        manifestCode: z.optional(z.string()),
        manifestUnitId: z.optional(z.string()),
        invoiceManiSlope: z.optional(z.number()),
        invoiceManiIntercept: z.optional(z.number()),
        stdPackingModeId: z.optional(z.string()),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        includeInShortform: z.optional(z.boolean()),
        birthable: z.optional(z.boolean()),
        divisible: z.optional(z.boolean()),
        extra: z.optional(WasteFlavorExtra),
});

export const NewWasteFlavorFoodRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    invoiceUnitId: z.string(),
    manifestName: z.string(),
    manifestAbbrev: z.string(),
    manifestCode: z.string(),
    manifestUnitId: z.string(),
    invoiceManiSlope: z.number(),
    invoiceManiIntercept: z.number(),
    stdPackingModeId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    includeInShortform: z.boolean(),
    birthable: z.boolean(),
    divisible: z.boolean(),
    extra: WasteFlavorExtra,
});
export type NewWasteFlavorFoodRequired = z.infer<typeof NewWasteFlavorFoodRequired>;








    
    
    

export const WasteFlavorUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(WasteFlavorStub),
});

export const WasteFlavorUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: WasteFlavorStub,
});
export type WasteFlavorUpsertResultRequired = z.infer<typeof WasteFlavorUpsertResultRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const WasteFlavorPatch = z.object({
        code: z.optional(z.string()),
        displayName: z.optional(z.string()),
        sortName: z.optional(z.string()),
        abbrev: z.optional(z.string()),
        invoiceUnitId: z.optional(z.string()),
        manifestName: z.optional(z.string()),
        manifestAbbrev: z.optional(z.string()),
        manifestCode: z.optional(z.string()),
        manifestUnitId: z.optional(z.string()),
        invoiceManiSlope: z.optional(z.number()),
        invoiceManiIntercept: z.optional(z.number()),
        stdPackingModeId: z.optional(z.string()),
        showToDriver: z.optional(z.boolean()),
        showToIntaker: z.optional(z.boolean()),
        showToInspector: z.optional(z.boolean()),
        includeInShortform: z.optional(z.boolean()),
        venueId: z.optional(z.string()),
        birthable: z.optional(z.boolean()),
        divisible: z.optional(z.boolean()),
});

export const WasteFlavorPatchRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    abbrev: z.string(),
    invoiceUnitId: z.string(),
    manifestName: z.string(),
    manifestAbbrev: z.string(),
    manifestCode: z.string(),
    manifestUnitId: z.string(),
    invoiceManiSlope: z.number(),
    invoiceManiIntercept: z.number(),
    stdPackingModeId: z.string(),
    showToDriver: z.boolean(),
    showToIntaker: z.boolean(),
    showToInspector: z.boolean(),
    includeInShortform: z.boolean(),
    venueId: z.string(),
    birthable: z.boolean(),
    divisible: z.boolean(),
});
export type WasteFlavorPatchRequired = z.infer<typeof WasteFlavorPatchRequired>;








    
    
    
    

export const UpsertablePackingMode = z.object({
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        unitId: z.string(),
});

export const UpsertablePackingModeRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    unitId: z.string(),
});
export type UpsertablePackingModeRequired = z.infer<typeof UpsertablePackingModeRequired>;








    
    
    
    
    
    

export const PackingMode = z.object({
        id: z.string(),
        created: z.string(),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
        unitId: z.string(),
});

export const PackingModeRequired = z.object({
    id: z.string(),
    created: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
    unitId: z.string(),
});
export type PackingModeRequired = z.infer<typeof PackingModeRequired>;
        
        
        
        
        
        
export const PackingModeSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: PackingMode,
});

export const PackingModeDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const PackingModeListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(PackingMode),
	next: z.optional(PackingMode),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const PackingModeDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
                unitId: z.optional(z.string()),
});

export const PackingModeDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: PackingModeDelta,
	next: PackingModeDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const PackingModeSingleTransition = z.union([
    PackingModeSingleAliveTransition, PackingModeDelTransition, PackingModeDeltaTransition,
]);

export const PackingModeListTransition = z.union([
    PackingModeListFullTransition, PackingModeDeltaTransition,
]);








    
    
    

export const PackingModeUpsertResult = z.object({
        newId: z.optional(z.string()),
        existingId: z.optional(z.string()),
        conflict: z.optional(PackingMode),
});

export const PackingModeUpsertResultRequired = z.object({
    newId: z.string(),
    existingId: z.string(),
    conflict: PackingMode,
});
export type PackingModeUpsertResultRequired = z.infer<typeof PackingModeUpsertResultRequired>;








    
    
    

export const UpsertableManifestType = z.object({
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
});

export const UpsertableManifestTypeRequired = z.object({
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
});
export type UpsertableManifestTypeRequired = z.infer<typeof UpsertableManifestTypeRequired>;








    
    
    
    
    

export const ManifestType = z.object({
        id: z.string(),
        created: z.string(),
        code: z.string(),
        displayName: z.string(),
        sortName: z.optional(z.string()),
});

export const ManifestTypeRequired = z.object({
    id: z.string(),
    created: z.string(),
    code: z.string(),
    displayName: z.string(),
    sortName: z.string(),
});
export type ManifestTypeRequired = z.infer<typeof ManifestTypeRequired>;
        
        
        
        
        
export const ManifestTypeSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: ManifestType,
});

export const ManifestTypeDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const ManifestTypeListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(ManifestType),
	next: z.optional(ManifestType),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ManifestTypeDelta = z.object({
                id: z.string(),
                created: z.optional(z.string()),
                code: z.optional(z.string()),
                displayName: z.optional(z.string()),
                sortName: z.optional(z.string()),
});

export const ManifestTypeDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: ManifestTypeDelta,
	next: ManifestTypeDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ManifestTypeSingleTransition = z.union([
    ManifestTypeSingleAliveTransition, ManifestTypeDelTransition, ManifestTypeDeltaTransition,
]);

export const ManifestTypeListTransition = z.union([
    ManifestTypeListFullTransition, ManifestTypeDeltaTransition,
]);








    
    
    

export const ManifestTypeUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(ManifestType),
});

export const ManifestTypeUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: ManifestType,
});
export type ManifestTypeUpsertResultRequired = z.infer<typeof ManifestTypeUpsertResultRequired>;








    
    

export const UpsertableTransformMode = z.object({
        code: z.string(),
        displayName: z.string(),
});

export const UpsertableTransformModeRequired = z.object({
    code: z.string(),
    displayName: z.string(),
});
export type UpsertableTransformModeRequired = z.infer<typeof UpsertableTransformModeRequired>;








    
    

export const TransformModeConflict = z.object({
        requested: UpsertableTransformMode,
        existing: EntityStub,
});

export const TransformModeConflictRequired = z.object({
    requested: UpsertableTransformMode,
    existing: EntityStub,
});
export type TransformModeConflictRequired = z.infer<typeof TransformModeConflictRequired>;








    
    
    

export const TransformModeUpsertResult = z.object({
        existingId: z.optional(z.string()),
        newId: z.optional(z.string()),
        conflict: z.optional(TransformModeConflict),
});

export const TransformModeUpsertResultRequired = z.object({
    existingId: z.string(),
    newId: z.string(),
    conflict: TransformModeConflict,
});
export type TransformModeUpsertResultRequired = z.infer<typeof TransformModeUpsertResultRequired>;








    
    

export const WasteAtRestStatus = z.object({
        statusCode: WasteStatusCode,
        venueId: z.string(),
});

export const WasteAtRestStatusRequired = z.object({
    statusCode: WasteStatusCode,
    venueId: z.string(),
});
export type WasteAtRestStatusRequired = z.infer<typeof WasteAtRestStatusRequired>;








    
    

export const WasteInMotionStatus = z.object({
        statusCode: WasteStatusCode,
        truckId: z.string(),
});

export const WasteInMotionStatusRequired = z.object({
    statusCode: WasteStatusCode,
    truckId: z.string(),
});
export type WasteInMotionStatusRequired = z.infer<typeof WasteInMotionStatusRequired>;








    

export const WasteSplitStatus = z.object({
        children: Waste.array(),
});

export const WasteSplitStatusRequired = z.object({
    children: Waste.array(),
});
export type WasteSplitStatusRequired = z.infer<typeof WasteSplitStatusRequired>;








    

export const WasteMergeStatus = z.object({
        mergedInto: Waste,
});

export const WasteMergeStatusRequired = z.object({
    mergedInto: Waste,
});
export type WasteMergeStatusRequired = z.infer<typeof WasteMergeStatusRequired>;








    
    
    
    

export const WasteStatus = z.object({
        atRest: z.optional(WasteAtRestStatus),
        inMotion: z.optional(WasteInMotionStatus),
        split: z.optional(WasteSplitStatus),
        merged: z.optional(WasteMergeStatus),
});

export const WasteStatusRequired = z.object({
    atRest: WasteAtRestStatus,
    inMotion: WasteInMotionStatus,
    split: WasteSplitStatus,
    merged: WasteMergeStatus,
});
export type WasteStatusRequired = z.infer<typeof WasteStatusRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

export const WastePatch = z.object({
        flavorId: z.optional(z.string()),
        isInvManiLinked: z.optional(z.boolean()),
        invQ: z.optional(z.number()),
        maniQ: z.optional(z.number()),
        invW: z.optional(z.number()),
        maniW: z.optional(z.number()),
        invV: z.optional(z.number()),
        maniV: z.optional(z.number()),
        packingModeId: z.optional(z.string()),
        packQ: z.optional(z.number()),
        bara0: z.optional(z.number()),
        bags: z.optional(z.number()),
        manifestTypeId: z.optional(z.string()),
        manifestNumber: z.optional(z.string()),
        originId: z.optional(z.string()),
        destinationId: z.optional(z.string()),
        notational: z.optional(z.boolean()),
        extras: z.optional(WasteExtras),
        transformModeId: z.optional(z.string()),
});

export const WastePatchRequired = z.object({
    flavorId: z.string(),
    isInvManiLinked: z.boolean(),
    invQ: z.number(),
    maniQ: z.number(),
    invW: z.number(),
    maniW: z.number(),
    invV: z.number(),
    maniV: z.number(),
    packingModeId: z.string(),
    packQ: z.number(),
    bara0: z.number(),
    bags: z.number(),
    manifestTypeId: z.string(),
    manifestNumber: z.string(),
    originId: z.string(),
    destinationId: z.string(),
    notational: z.boolean(),
    extras: WasteExtras,
    transformModeId: z.string(),
});
export type WastePatchRequired = z.infer<typeof WastePatchRequired>;








    

export const WasteStub = z.object({
        id: z.string(),
});

export const WasteStubRequired = z.object({
    id: z.string(),
});
export type WasteStubRequired = z.infer<typeof WasteStubRequired>;
        
export const WasteStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: WasteStub,
});

export const WasteStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const WasteStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(WasteStub),
	next: z.optional(WasteStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteStubDelta = z.object({
                id: z.string(),
});

export const WasteStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: WasteStubDelta,
	next: WasteStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteStubSingleTransition = z.union([
    WasteStubSingleAliveTransition, WasteStubDelTransition, WasteStubDeltaTransition,
]);

export const WasteStubListTransition = z.union([
    WasteStubListFullTransition, WasteStubDeltaTransition,
]);








    
    

export const WasteRevisionStub = z.object({
        author: AgentStub,
        validSpan: z.string(),
});

export const WasteRevisionStubRequired = z.object({
    author: AgentStub,
    validSpan: z.string(),
});
export type WasteRevisionStubRequired = z.infer<typeof WasteRevisionStubRequired>;








    
    
    
    

export const NewWasteStampFood = z.object({
        wasteId: z.string(),
        flavor: z.optional(WasteStampFlavor),
        photoId: z.optional(z.string()),
        caption: z.optional(z.string()),
});

export const NewWasteStampFoodRequired = z.object({
    wasteId: z.string(),
    flavor: WasteStampFlavor,
    photoId: z.string(),
    caption: z.string(),
});
export type NewWasteStampFoodRequired = z.infer<typeof NewWasteStampFoodRequired>;








    
    

export const WasteBundleAssociation = z.object({
        beginning: z.string(),
        bundleId: z.string(),
});

export const WasteBundleAssociationRequired = z.object({
    beginning: z.string(),
    bundleId: z.string(),
});
export type WasteBundleAssociationRequired = z.infer<typeof WasteBundleAssociationRequired>;








    
    

export const WasteJobAssociation = z.object({
        jobId: z.string(),
        venueId: z.string(),
});

export const WasteJobAssociationRequired = z.object({
    jobId: z.string(),
    venueId: z.string(),
});
export type WasteJobAssociationRequired = z.infer<typeof WasteJobAssociationRequired>;








    
    
    

export const WasteAssociation = z.object({
        id: z.string(),
        bundle: z.optional(WasteBundleAssociation),
        job: z.optional(WasteJobAssociation),
});

export const WasteAssociationRequired = z.object({
    id: z.string(),
    bundle: WasteBundleAssociation,
    job: WasteJobAssociation,
});
export type WasteAssociationRequired = z.infer<typeof WasteAssociationRequired>;
        
        
        
export const WasteAssociationSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: WasteAssociation,
});

export const WasteAssociationDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const WasteAssociationListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(WasteAssociation),
	next: z.optional(WasteAssociation),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteAssociationDelta = z.object({
                id: z.string(),
                bundle: z.optional(WasteBundleAssociation),
                job: z.optional(WasteJobAssociation),
});

export const WasteAssociationDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: WasteAssociationDelta,
	next: WasteAssociationDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const WasteAssociationSingleTransition = z.union([
    WasteAssociationSingleAliveTransition, WasteAssociationDelTransition, WasteAssociationDeltaTransition,
]);

export const WasteAssociationListTransition = z.union([
    WasteAssociationListFullTransition, WasteAssociationDeltaTransition,
]);








    
    
    
    

export const WasteLineageRecord = z.object({
        before: z.string(),
        after: z.string(),
        posted: z.string(),
        author: AgentStub,
});

export const WasteLineageRecordRequired = z.object({
    before: z.string(),
    after: z.string(),
    posted: z.string(),
    author: AgentStub,
});
export type WasteLineageRecordRequired = z.infer<typeof WasteLineageRecordRequired>;








    

export const TransferStub = z.object({
        id: z.string(),
});

export const TransferStubRequired = z.object({
    id: z.string(),
});
export type TransferStubRequired = z.infer<typeof TransferStubRequired>;
        
export const TransferStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TransferStub,
});

export const TransferStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TransferStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TransferStub),
	next: z.optional(TransferStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TransferStubDelta = z.object({
                id: z.string(),
});

export const TransferStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TransferStubDelta,
	next: TransferStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TransferStubSingleTransition = z.union([
    TransferStubSingleAliveTransition, TransferStubDelTransition, TransferStubDeltaTransition,
]);

export const TransferStubListTransition = z.union([
    TransferStubListFullTransition, TransferStubDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    
    
    

export const ScheduledTransfer = z.object({
        id: z.string(),
        bundle: BundleStub,
        job: JobStub,
        direction: PickupOrDropoff,
        truck: z.optional(TruckStub),
        truckModel: z.optional(TruckModelStub),
        driver: z.optional(AgentStub),
        venue: VenueStub,
        arrivalWindow: z.optional(z.string()),
        posted: z.string(),
        lastModifier: AgentStub,
        lastModified: z.string(),
});

export const ScheduledTransferRequired = z.object({
    id: z.string(),
    bundle: BundleStub,
    job: JobStub,
    direction: PickupOrDropoff,
    truck: TruckStub,
    truckModel: TruckModelStub,
    driver: AgentStub,
    venue: VenueStub,
    arrivalWindow: z.string(),
    posted: z.string(),
    lastModifier: AgentStub,
    lastModified: z.string(),
});
export type ScheduledTransferRequired = z.infer<typeof ScheduledTransferRequired>;
        
        
        
        
        
        
        
        
        
        
        
        
export const ScheduledTransferSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: ScheduledTransfer,
});

export const ScheduledTransferDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const ScheduledTransferListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(ScheduledTransfer),
	next: z.optional(ScheduledTransfer),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ScheduledTransferDelta = z.object({
                id: z.string(),
                bundle: z.optional(BundleStub),
                job: z.optional(JobStub),
                direction: z.optional(PickupOrDropoff),
                truck: z.optional(TruckStub),
                truckModel: z.optional(TruckModelStub),
                driver: z.optional(AgentStub),
                venue: z.optional(VenueStub),
                arrivalWindow: z.optional(z.string()),
                posted: z.optional(z.string()),
                lastModifier: z.optional(AgentStub),
                lastModified: z.optional(z.string()),
});

export const ScheduledTransferDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: ScheduledTransferDelta,
	next: ScheduledTransferDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ScheduledTransferSingleTransition = z.union([
    ScheduledTransferSingleAliveTransition, ScheduledTransferDelTransition, ScheduledTransferDeltaTransition,
]);

export const ScheduledTransferListTransition = z.union([
    ScheduledTransferListFullTransition, ScheduledTransferDeltaTransition,
]);








    
    
    
    
    

export const NewScheduledPickupFood = z.object({
        bundleId: z.string(),
        truckId: z.optional(z.string()),
        truckModelId: z.optional(z.string()),
        driverId: z.optional(z.string()),
        arrivalWindow: z.optional(z.string()),
});

export const NewScheduledPickupFoodRequired = z.object({
    bundleId: z.string(),
    truckId: z.string(),
    truckModelId: z.string(),
    driverId: z.string(),
    arrivalWindow: z.string(),
});
export type NewScheduledPickupFoodRequired = z.infer<typeof NewScheduledPickupFoodRequired>;








    
    
    
    
    

export const NewScheduledDropoffFood = z.object({
        bundleId: z.string(),
        truckId: z.optional(z.string()),
        truckModelId: z.optional(z.string()),
        driverId: z.optional(z.string()),
        arrivalWindow: z.optional(z.string()),
});

export const NewScheduledDropoffFoodRequired = z.object({
    bundleId: z.string(),
    truckId: z.string(),
    truckModelId: z.string(),
    driverId: z.string(),
    arrivalWindow: z.string(),
});
export type NewScheduledDropoffFoodRequired = z.infer<typeof NewScheduledDropoffFoodRequired>;








    
    
    
    

export const ScheduledTransferPatch = z.object({
        truckId: z.optional(z.string()),
        truckModelId: z.optional(z.string()),
        driverId: z.optional(z.string()),
        arrivalWindow: z.optional(z.string()),
});

export const ScheduledTransferPatchRequired = z.object({
    truckId: z.string(),
    truckModelId: z.string(),
    driverId: z.string(),
    arrivalWindow: z.string(),
});
export type ScheduledTransferPatchRequired = z.infer<typeof ScheduledTransferPatchRequired>;








    

export const ScheduledTransferStub = z.object({
        id: z.string(),
});

export const ScheduledTransferStubRequired = z.object({
    id: z.string(),
});
export type ScheduledTransferStubRequired = z.infer<typeof ScheduledTransferStubRequired>;
        
export const ScheduledTransferStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: ScheduledTransferStub,
});

export const ScheduledTransferStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const ScheduledTransferStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(ScheduledTransferStub),
	next: z.optional(ScheduledTransferStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ScheduledTransferStubDelta = z.object({
                id: z.string(),
});

export const ScheduledTransferStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: ScheduledTransferStubDelta,
	next: ScheduledTransferStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const ScheduledTransferStubSingleTransition = z.union([
    ScheduledTransferStubSingleAliveTransition, ScheduledTransferStubDelTransition, ScheduledTransferStubDeltaTransition,
]);

export const ScheduledTransferStubListTransition = z.union([
    ScheduledTransferStubListFullTransition, ScheduledTransferStubDeltaTransition,
]);








    
    
    
    
    
    
    
    
    
    

export const Tripleg = z.object({
        id: z.string(),
        truck: TruckStub,
        origin: z.optional(VenueStub),
        departed: z.string(),
        destination: VenueStub,
        estimatedArrival: z.optional(z.string()),
        arrived: z.optional(z.string()),
        admitted: z.optional(z.string()),
        lastModified: z.string(),
        lastModifier: AgentStub,
});

export const TriplegRequired = z.object({
    id: z.string(),
    truck: TruckStub,
    origin: VenueStub,
    departed: z.string(),
    destination: VenueStub,
    estimatedArrival: z.string(),
    arrived: z.string(),
    admitted: z.string(),
    lastModified: z.string(),
    lastModifier: AgentStub,
});
export type TriplegRequired = z.infer<typeof TriplegRequired>;
        
        
        
        
        
        
        
        
        
        
export const TriplegSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: Tripleg,
});

export const TriplegDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TriplegListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(Tripleg),
	next: z.optional(Tripleg),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TriplegDelta = z.object({
                id: z.string(),
                truck: z.optional(TruckStub),
                origin: z.optional(VenueStub),
                departed: z.optional(z.string()),
                destination: z.optional(VenueStub),
                estimatedArrival: z.optional(z.string()),
                arrived: z.optional(z.string()),
                admitted: z.optional(z.string()),
                lastModified: z.optional(z.string()),
                lastModifier: z.optional(AgentStub),
});

export const TriplegDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TriplegDelta,
	next: TriplegDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TriplegSingleTransition = z.union([
    TriplegSingleAliveTransition, TriplegDelTransition, TriplegDeltaTransition,
]);

export const TriplegListTransition = z.union([
    TriplegListFullTransition, TriplegDeltaTransition,
]);








    
    

export const NewTriplegFood = z.object({
        destinationId: z.string(),
        estimatedArrival: z.optional(z.string()),
});

export const NewTriplegFoodRequired = z.object({
    destinationId: z.string(),
    estimatedArrival: z.string(),
});
export type NewTriplegFoodRequired = z.infer<typeof NewTriplegFoodRequired>;








    
    

export const TriplegPatch = z.object({
        destinationId: z.optional(z.string()),
        estimatedArrival: z.optional(z.string()),
});

export const TriplegPatchRequired = z.object({
    destinationId: z.string(),
    estimatedArrival: z.string(),
});
export type TriplegPatchRequired = z.infer<typeof TriplegPatchRequired>;








    

export const TriplegStub = z.object({
        id: z.string(),
});

export const TriplegStubRequired = z.object({
    id: z.string(),
});
export type TriplegStubRequired = z.infer<typeof TriplegStubRequired>;
        
export const TriplegStubSingleAliveTransition = z.object({
    dlta: z.optional(z.never()),
    next: TriplegStub,
});

export const TriplegStubDelTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.object({id: z.string()}),
	next: z.optional(z.never()),
});

export const TriplegStubListFullTransition = z.object({
    dlta: z.optional(z.never()),
	prev: z.optional(TriplegStub),
	next: z.optional(TriplegStub),
}).check(ctx => {
	if (("prev" in ctx.value) && ("next" in ctx.value)) {
		const prevId = ctx.value.prev?.id;
		const nextId = ctx.value.next?.id;
		if (!prevId || !nextId || prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TriplegStubDelta = z.object({
                id: z.string(),
});

export const TriplegStubDeltaTransition = z.object({
	dlta: z.literal(true),
	prev: TriplegStubDelta,
	next: TriplegStubDelta,
}).check(ctx => {
    if (("prev" in ctx.value) && ("next" in ctx.value)) {
        const prevId = ctx.value.prev.id;
        const nextId = ctx.value.next.id;
        if (prevId !== nextId) {
            ctx.issues.push({
                code: "custom",
                message: "prev and next ids must match",
                values: [prevId, nextId],
                input: ctx.value,
            });
        }
    }
});

export const TriplegStubSingleTransition = z.union([
    TriplegStubSingleAliveTransition, TriplegStubDelTransition, TriplegStubDeltaTransition,
]);

export const TriplegStubListTransition = z.union([
    TriplegStubListFullTransition, TriplegStubDeltaTransition,
]);








    
    
    
    

export const SelfResult = z.object({
        self: Agent,
        lastShift: z.optional(z.string()),
        lastBreak: z.optional(z.string()),
        prefs: z.optional(z.any()),
});

export const SelfResultRequired = z.object({
    self: Agent,
    lastShift: z.string(),
    lastBreak: z.string(),
    prefs: z.any(),
});
export type SelfResultRequired = z.infer<typeof SelfResultRequired>;








    

export const SetlistPacketResult = z.object({
        packet: WiredSetlistPacket,
});

export const SetlistPacketResultRequired = z.object({
    packet: WiredSetlistPacket,
});
export type SetlistPacketResultRequired = z.infer<typeof SetlistPacketResultRequired>;








    
    

export const SetlistSubscription = z.object({
        subscriber: z.string(),
        exchange: z.string(),
});

export const SetlistSubscriptionRequired = z.object({
    subscriber: z.string(),
    exchange: z.string(),
});
export type SetlistSubscriptionRequired = z.infer<typeof SetlistSubscriptionRequired>;








    
    
    
    

export const VersionInfo = z.object({
        branch: z.string(),
        commitSlug: z.string(),
        isSnapshot: z.boolean(),
        webrpcHeader: z.string(),
});

export const VersionInfoRequired = z.object({
    branch: z.string(),
    commitSlug: z.string(),
    isSnapshot: z.boolean(),
    webrpcHeader: z.string(),
});
export type VersionInfoRequired = z.infer<typeof VersionInfoRequired>;








    
    
    

export const StandardUnitCodes = z.object({
        q: z.string(),
        v: z.string(),
        w: z.string(),
});

export const StandardUnitCodesRequired = z.object({
    q: z.string(),
    v: z.string(),
    w: z.string(),
});
export type StandardUnitCodesRequired = z.infer<typeof StandardUnitCodesRequired>;








    
    
    
    
    
    
    
    
    
    
    
    
    

export const SystemConfig = z.object({
        vendor: VendorName,
        dratBanner: z.string(),
        standardUnitCodes: StandardUnitCodes,
        driversCanAddWastes: z.optional(z.boolean()),
        fieldConfirmSurcharges: z.optional(z.boolean()),
        autoExportIntervalMinutes: z.optional(z.number()),
        elideManifest: z.optional(z.boolean()),
        inputWasteFlavorCodes: z.optional(z.boolean()),
        showInspectorFacets: z.optional(z.boolean()),
        quickInspectorActions: z.optional(z.boolean()),
        quickSupervisorActions: z.optional(z.boolean()),
        quickManifestNumber: z.optional(z.boolean()),
        quickPackQ: z.optional(z.boolean()),
});

export const SystemConfigRequired = z.object({
    vendor: VendorName,
    dratBanner: z.string(),
    standardUnitCodes: StandardUnitCodes,
    driversCanAddWastes: z.boolean(),
    fieldConfirmSurcharges: z.boolean(),
    autoExportIntervalMinutes: z.number(),
    elideManifest: z.boolean(),
    inputWasteFlavorCodes: z.boolean(),
    showInspectorFacets: z.boolean(),
    quickInspectorActions: z.boolean(),
    quickSupervisorActions: z.boolean(),
    quickManifestNumber: z.boolean(),
    quickPackQ: z.boolean(),
});
export type SystemConfigRequired = z.infer<typeof SystemConfigRequired>;



export const RpcTypeMap = {
        StampableClassname: {
			name: "StampableClassname",
			schema: StampableClassname,
			deltaTransitionSchema: undefined,
        },
        SortOrder: {
			name: "SortOrder",
			schema: SortOrder,
			deltaTransitionSchema: undefined,
        },
        AgentStampFlavor: {
			name: "AgentStampFlavor",
			schema: AgentStampFlavor,
			deltaTransitionSchema: undefined,
        },
        TruckStampFlavor: {
			name: "TruckStampFlavor",
			schema: TruckStampFlavor,
			deltaTransitionSchema: undefined,
        },
        JobStampFlavor: {
			name: "JobStampFlavor",
			schema: JobStampFlavor,
			deltaTransitionSchema: undefined,
        },
        SurchargeableClassname: {
			name: "SurchargeableClassname",
			schema: SurchargeableClassname,
			deltaTransitionSchema: undefined,
        },
        SurchargeSource: {
			name: "SurchargeSource",
			schema: SurchargeSource,
			deltaTransitionSchema: undefined,
        },
        BundleStampFlavor: {
			name: "BundleStampFlavor",
			schema: BundleStampFlavor,
			deltaTransitionSchema: undefined,
        },
        WasteFlavorPurpose: {
			name: "WasteFlavorPurpose",
			schema: WasteFlavorPurpose,
			deltaTransitionSchema: undefined,
        },
        WasteStatusCode: {
			name: "WasteStatusCode",
			schema: WasteStatusCode,
			deltaTransitionSchema: undefined,
        },
        WasteStampFlavor: {
			name: "WasteStampFlavor",
			schema: WasteStampFlavor,
			deltaTransitionSchema: undefined,
        },
        PickupOrDropoff: {
			name: "PickupOrDropoff",
			schema: PickupOrDropoff,
			deltaTransitionSchema: undefined,
        },
        VendorName: {
			name: "VendorName",
			schema: VendorName,
			deltaTransitionSchema: undefined,
        },
        EntityStub: {
			name: "EntityStub",
			schema: EntityStub,
			deltaTransitionSchema: EntityStubDeltaTransition,
        },
        WiredSetlistPacket: {
			name: "WiredSetlistPacket",
			schema: WiredSetlistPacket,
			deltaTransitionSchema: undefined,
        },
        RewindCheckpoint: {
			name: "RewindCheckpoint",
			schema: RewindCheckpoint,
			deltaTransitionSchema: undefined,
        },
        Photo: {
			name: "Photo",
			schema: Photo,
			deltaTransitionSchema: undefined,
        },
        Stamp: {
			name: "Stamp",
			schema: Stamp,
			deltaTransitionSchema: undefined,
        },
        NewStampFood: {
			name: "NewStampFood",
			schema: NewStampFood,
			deltaTransitionSchema: undefined,
        },
        Company: {
			name: "Company",
			schema: Company,
			deltaTransitionSchema: CompanyDeltaTransition,
        },
        NewCompanyFood: {
			name: "NewCompanyFood",
			schema: NewCompanyFood,
			deltaTransitionSchema: undefined,
        },
        CompanyStub: {
			name: "CompanyStub",
			schema: CompanyStub,
			deltaTransitionSchema: CompanyStubDeltaTransition,
        },
        CompanyConflict: {
			name: "CompanyConflict",
			schema: CompanyConflict,
			deltaTransitionSchema: undefined,
        },
        CompanyUpsertResult: {
			name: "CompanyUpsertResult",
			schema: CompanyUpsertResult,
			deltaTransitionSchema: undefined,
        },
        CompanyPatch: {
			name: "CompanyPatch",
			schema: CompanyPatch,
			deltaTransitionSchema: undefined,
        },
        Venue: {
			name: "Venue",
			schema: Venue,
			deltaTransitionSchema: VenueDeltaTransition,
        },
        NewVenueFood: {
			name: "NewVenueFood",
			schema: NewVenueFood,
			deltaTransitionSchema: undefined,
        },
        UpsertableVenue: {
			name: "UpsertableVenue",
			schema: UpsertableVenue,
			deltaTransitionSchema: undefined,
        },
        VenueStub: {
			name: "VenueStub",
			schema: VenueStub,
			deltaTransitionSchema: undefined,
        },
        VenueConflict: {
			name: "VenueConflict",
			schema: VenueConflict,
			deltaTransitionSchema: undefined,
        },
        VenueUpsertResult: {
			name: "VenueUpsertResult",
			schema: VenueUpsertResult,
			deltaTransitionSchema: undefined,
        },
        VenuePatch: {
			name: "VenuePatch",
			schema: VenuePatch,
			deltaTransitionSchema: undefined,
        },
        Agent: {
			name: "Agent",
			schema: Agent,
			deltaTransitionSchema: AgentDeltaTransition,
        },
        NewAgentFood: {
			name: "NewAgentFood",
			schema: NewAgentFood,
			deltaTransitionSchema: undefined,
        },
        UpsertableAgent: {
			name: "UpsertableAgent",
			schema: UpsertableAgent,
			deltaTransitionSchema: undefined,
        },
        AgentUpsertResult: {
			name: "AgentUpsertResult",
			schema: AgentUpsertResult,
			deltaTransitionSchema: undefined,
        },
        AgentPatch: {
			name: "AgentPatch",
			schema: AgentPatch,
			deltaTransitionSchema: undefined,
        },
        SelfPatch: {
			name: "SelfPatch",
			schema: SelfPatch,
			deltaTransitionSchema: undefined,
        },
        PasswordChange: {
			name: "PasswordChange",
			schema: PasswordChange,
			deltaTransitionSchema: undefined,
        },
        AgentStamp: {
			name: "AgentStamp",
			schema: AgentStamp,
			deltaTransitionSchema: AgentStampDeltaTransition,
        },
        NewAgentStampFood: {
			name: "NewAgentStampFood",
			schema: NewAgentStampFood,
			deltaTransitionSchema: undefined,
        },
        AgentStub: {
			name: "AgentStub",
			schema: AgentStub,
			deltaTransitionSchema: AgentStubDeltaTransition,
        },
        AgentOutlet: {
			name: "AgentOutlet",
			schema: AgentOutlet,
			deltaTransitionSchema: undefined,
        },
        AgentPresence: {
			name: "AgentPresence",
			schema: AgentPresence,
			deltaTransitionSchema: AgentPresenceDeltaTransition,
        },
        TruckModel: {
			name: "TruckModel",
			schema: TruckModel,
			deltaTransitionSchema: TruckModelDeltaTransition,
        },
        NewTruckModelFood: {
			name: "NewTruckModelFood",
			schema: NewTruckModelFood,
			deltaTransitionSchema: undefined,
        },
        TruckModelUpsertResult: {
			name: "TruckModelUpsertResult",
			schema: TruckModelUpsertResult,
			deltaTransitionSchema: undefined,
        },
        TruckModelPatch: {
			name: "TruckModelPatch",
			schema: TruckModelPatch,
			deltaTransitionSchema: undefined,
        },
        TruckModelStub: {
			name: "TruckModelStub",
			schema: TruckModelStub,
			deltaTransitionSchema: undefined,
        },
        Truck: {
			name: "Truck",
			schema: Truck,
			deltaTransitionSchema: TruckDeltaTransition,
        },
        NewTruckFood: {
			name: "NewTruckFood",
			schema: NewTruckFood,
			deltaTransitionSchema: undefined,
        },
        UpsertableTruck: {
			name: "UpsertableTruck",
			schema: UpsertableTruck,
			deltaTransitionSchema: undefined,
        },
        TruckStub: {
			name: "TruckStub",
			schema: TruckStub,
			deltaTransitionSchema: TruckStubDeltaTransition,
        },
        TruckConflict: {
			name: "TruckConflict",
			schema: TruckConflict,
			deltaTransitionSchema: undefined,
        },
        TruckUpsertResult: {
			name: "TruckUpsertResult",
			schema: TruckUpsertResult,
			deltaTransitionSchema: undefined,
        },
        TruckPatch: {
			name: "TruckPatch",
			schema: TruckPatch,
			deltaTransitionSchema: undefined,
        },
        TruckStamp: {
			name: "TruckStamp",
			schema: TruckStamp,
			deltaTransitionSchema: TruckStampDeltaTransition,
        },
        NewTruckStampFood: {
			name: "NewTruckStampFood",
			schema: NewTruckStampFood,
			deltaTransitionSchema: undefined,
        },
        TruckCrewTenure: {
			name: "TruckCrewTenure",
			schema: TruckCrewTenure,
			deltaTransitionSchema: undefined,
        },
        CrewTenure: {
			name: "CrewTenure",
			schema: CrewTenure,
			deltaTransitionSchema: CrewTenureDeltaTransition,
        },
        TruckTenure: {
			name: "TruckTenure",
			schema: TruckTenure,
			deltaTransitionSchema: undefined,
        },
        ShinwaJobExtras: {
			name: "ShinwaJobExtras",
			schema: ShinwaJobExtras,
			deltaTransitionSchema: undefined,
        },
        TransportSegment: {
			name: "TransportSegment",
			schema: TransportSegment,
			deltaTransitionSchema: undefined,
        },
        SanyuJobExtras: {
			name: "SanyuJobExtras",
			schema: SanyuJobExtras,
			deltaTransitionSchema: undefined,
        },
        WideJobExtras: {
			name: "WideJobExtras",
			schema: WideJobExtras,
			deltaTransitionSchema: undefined,
        },
        Job: {
			name: "Job",
			schema: Job,
			deltaTransitionSchema: JobDeltaTransition,
        },
        UpsertableShinwaJob: {
			name: "UpsertableShinwaJob",
			schema: UpsertableShinwaJob,
			deltaTransitionSchema: undefined,
        },
        UpsertableSanyuJob: {
			name: "UpsertableSanyuJob",
			schema: UpsertableSanyuJob,
			deltaTransitionSchema: undefined,
        },
        JobUpsertResult: {
			name: "JobUpsertResult",
			schema: JobUpsertResult,
			deltaTransitionSchema: undefined,
        },
        JobPatch: {
			name: "JobPatch",
			schema: JobPatch,
			deltaTransitionSchema: undefined,
        },
        JobStub: {
			name: "JobStub",
			schema: JobStub,
			deltaTransitionSchema: JobStubDeltaTransition,
        },
        JobStamp: {
			name: "JobStamp",
			schema: JobStamp,
			deltaTransitionSchema: JobStampDeltaTransition,
        },
        NewJobStampFood: {
			name: "NewJobStampFood",
			schema: NewJobStampFood,
			deltaTransitionSchema: undefined,
        },
        SurchargeFlavor: {
			name: "SurchargeFlavor",
			schema: SurchargeFlavor,
			deltaTransitionSchema: undefined,
        },
        NewSurchargeFlavorFood: {
			name: "NewSurchargeFlavorFood",
			schema: NewSurchargeFlavorFood,
			deltaTransitionSchema: undefined,
        },
        SurchargeFlavorPatch: {
			name: "SurchargeFlavorPatch",
			schema: SurchargeFlavorPatch,
			deltaTransitionSchema: undefined,
        },
        SurchargeFlavorStub: {
			name: "SurchargeFlavorStub",
			schema: SurchargeFlavorStub,
			deltaTransitionSchema: undefined,
        },
        Surcharge: {
			name: "Surcharge",
			schema: Surcharge,
			deltaTransitionSchema: SurchargeDeltaTransition,
        },
        NewSurchargeFood: {
			name: "NewSurchargeFood",
			schema: NewSurchargeFood,
			deltaTransitionSchema: undefined,
        },
        SurchargeFlavorUpsertResult: {
			name: "SurchargeFlavorUpsertResult",
			schema: SurchargeFlavorUpsertResult,
			deltaTransitionSchema: undefined,
        },
        SurchargePatch: {
			name: "SurchargePatch",
			schema: SurchargePatch,
			deltaTransitionSchema: undefined,
        },
        TruckOrVenueStub: {
			name: "TruckOrVenueStub",
			schema: TruckOrVenueStub,
			deltaTransitionSchema: TruckOrVenueStubDeltaTransition,
        },
        BundleExtras: {
			name: "BundleExtras",
			schema: BundleExtras,
			deltaTransitionSchema: undefined,
        },
        Bundle: {
			name: "Bundle",
			schema: Bundle,
			deltaTransitionSchema: BundleDeltaTransition,
        },
        CompleteBundleHistory: {
			name: "CompleteBundleHistory",
			schema: CompleteBundleHistory,
			deltaTransitionSchema: undefined,
        },
        NewGroundedBundleFood: {
			name: "NewGroundedBundleFood",
			schema: NewGroundedBundleFood,
			deltaTransitionSchema: undefined,
        },
        NewLoadedBundleFood: {
			name: "NewLoadedBundleFood",
			schema: NewLoadedBundleFood,
			deltaTransitionSchema: undefined,
        },
        BundlePatch: {
			name: "BundlePatch",
			schema: BundlePatch,
			deltaTransitionSchema: undefined,
        },
        BundleStub: {
			name: "BundleStub",
			schema: BundleStub,
			deltaTransitionSchema: BundleStubDeltaTransition,
        },
        BundleStamp: {
			name: "BundleStamp",
			schema: BundleStamp,
			deltaTransitionSchema: BundleStampDeltaTransition,
        },
        NewBundleStampFood: {
			name: "NewBundleStampFood",
			schema: NewBundleStampFood,
			deltaTransitionSchema: undefined,
        },
        Unit: {
			name: "Unit",
			schema: Unit,
			deltaTransitionSchema: UnitDeltaTransition,
        },
        NewUnitFood: {
			name: "NewUnitFood",
			schema: NewUnitFood,
			deltaTransitionSchema: undefined,
        },
        UnitUpsertResult: {
			name: "UnitUpsertResult",
			schema: UnitUpsertResult,
			deltaTransitionSchema: undefined,
        },
        WasteFlavorStub: {
			name: "WasteFlavorStub",
			schema: WasteFlavorStub,
			deltaTransitionSchema: undefined,
        },
        SanyuWasteFlavorExtra: {
			name: "SanyuWasteFlavorExtra",
			schema: SanyuWasteFlavorExtra,
			deltaTransitionSchema: undefined,
        },
        WasteFlavorExtra: {
			name: "WasteFlavorExtra",
			schema: WasteFlavorExtra,
			deltaTransitionSchema: undefined,
        },
        WasteFlavor: {
			name: "WasteFlavor",
			schema: WasteFlavor,
			deltaTransitionSchema: WasteFlavorDeltaTransition,
        },
        NewWasteFlavorFood: {
			name: "NewWasteFlavorFood",
			schema: NewWasteFlavorFood,
			deltaTransitionSchema: undefined,
        },
        WasteFlavorUpsertResult: {
			name: "WasteFlavorUpsertResult",
			schema: WasteFlavorUpsertResult,
			deltaTransitionSchema: undefined,
        },
        WasteFlavorPatch: {
			name: "WasteFlavorPatch",
			schema: WasteFlavorPatch,
			deltaTransitionSchema: undefined,
        },
        UpsertablePackingMode: {
			name: "UpsertablePackingMode",
			schema: UpsertablePackingMode,
			deltaTransitionSchema: undefined,
        },
        PackingMode: {
			name: "PackingMode",
			schema: PackingMode,
			deltaTransitionSchema: PackingModeDeltaTransition,
        },
        PackingModeUpsertResult: {
			name: "PackingModeUpsertResult",
			schema: PackingModeUpsertResult,
			deltaTransitionSchema: undefined,
        },
        UpsertableManifestType: {
			name: "UpsertableManifestType",
			schema: UpsertableManifestType,
			deltaTransitionSchema: undefined,
        },
        ManifestType: {
			name: "ManifestType",
			schema: ManifestType,
			deltaTransitionSchema: ManifestTypeDeltaTransition,
        },
        ManifestTypeUpsertResult: {
			name: "ManifestTypeUpsertResult",
			schema: ManifestTypeUpsertResult,
			deltaTransitionSchema: undefined,
        },
        UpsertableTransformMode: {
			name: "UpsertableTransformMode",
			schema: UpsertableTransformMode,
			deltaTransitionSchema: undefined,
        },
        TransformModeConflict: {
			name: "TransformModeConflict",
			schema: TransformModeConflict,
			deltaTransitionSchema: undefined,
        },
        TransformModeUpsertResult: {
			name: "TransformModeUpsertResult",
			schema: TransformModeUpsertResult,
			deltaTransitionSchema: undefined,
        },
        WasteAtRestStatus: {
			name: "WasteAtRestStatus",
			schema: WasteAtRestStatus,
			deltaTransitionSchema: undefined,
        },
        WasteInMotionStatus: {
			name: "WasteInMotionStatus",
			schema: WasteInMotionStatus,
			deltaTransitionSchema: undefined,
        },
        WasteSplitStatus: {
			name: "WasteSplitStatus",
			schema: WasteSplitStatus,
			deltaTransitionSchema: undefined,
        },
        WasteMergeStatus: {
			name: "WasteMergeStatus",
			schema: WasteMergeStatus,
			deltaTransitionSchema: undefined,
        },
        WasteStatus: {
			name: "WasteStatus",
			schema: WasteStatus,
			deltaTransitionSchema: undefined,
        },
        WasteExtras: {
			name: "WasteExtras",
			schema: WasteExtras,
			deltaTransitionSchema: undefined,
        },
        Waste: {
			name: "Waste",
			schema: Waste,
			deltaTransitionSchema: WasteDeltaTransition,
        },
        NewWasteFood: {
			name: "NewWasteFood",
			schema: NewWasteFood,
			deltaTransitionSchema: undefined,
        },
        WastePatch: {
			name: "WastePatch",
			schema: WastePatch,
			deltaTransitionSchema: undefined,
        },
        WasteStub: {
			name: "WasteStub",
			schema: WasteStub,
			deltaTransitionSchema: WasteStubDeltaTransition,
        },
        WasteRevisionStub: {
			name: "WasteRevisionStub",
			schema: WasteRevisionStub,
			deltaTransitionSchema: undefined,
        },
        WasteStamp: {
			name: "WasteStamp",
			schema: WasteStamp,
			deltaTransitionSchema: WasteStampDeltaTransition,
        },
        NewWasteStampFood: {
			name: "NewWasteStampFood",
			schema: NewWasteStampFood,
			deltaTransitionSchema: undefined,
        },
        WasteBundleAssociation: {
			name: "WasteBundleAssociation",
			schema: WasteBundleAssociation,
			deltaTransitionSchema: undefined,
        },
        WasteJobAssociation: {
			name: "WasteJobAssociation",
			schema: WasteJobAssociation,
			deltaTransitionSchema: undefined,
        },
        WasteAssociation: {
			name: "WasteAssociation",
			schema: WasteAssociation,
			deltaTransitionSchema: WasteAssociationDeltaTransition,
        },
        CompleteWasteHistory: {
			name: "CompleteWasteHistory",
			schema: CompleteWasteHistory,
			deltaTransitionSchema: undefined,
        },
        WasteLineageRecord: {
			name: "WasteLineageRecord",
			schema: WasteLineageRecord,
			deltaTransitionSchema: undefined,
        },
        Transfer: {
			name: "Transfer",
			schema: Transfer,
			deltaTransitionSchema: TransferDeltaTransition,
        },
        TransferStub: {
			name: "TransferStub",
			schema: TransferStub,
			deltaTransitionSchema: TransferStubDeltaTransition,
        },
        ScheduledTransfer: {
			name: "ScheduledTransfer",
			schema: ScheduledTransfer,
			deltaTransitionSchema: ScheduledTransferDeltaTransition,
        },
        NewScheduledPickupFood: {
			name: "NewScheduledPickupFood",
			schema: NewScheduledPickupFood,
			deltaTransitionSchema: undefined,
        },
        NewScheduledDropoffFood: {
			name: "NewScheduledDropoffFood",
			schema: NewScheduledDropoffFood,
			deltaTransitionSchema: undefined,
        },
        ScheduledTransferPatch: {
			name: "ScheduledTransferPatch",
			schema: ScheduledTransferPatch,
			deltaTransitionSchema: undefined,
        },
        ScheduledTransferStub: {
			name: "ScheduledTransferStub",
			schema: ScheduledTransferStub,
			deltaTransitionSchema: ScheduledTransferStubDeltaTransition,
        },
        Tripleg: {
			name: "Tripleg",
			schema: Tripleg,
			deltaTransitionSchema: TriplegDeltaTransition,
        },
        NewTriplegFood: {
			name: "NewTriplegFood",
			schema: NewTriplegFood,
			deltaTransitionSchema: undefined,
        },
        TriplegPatch: {
			name: "TriplegPatch",
			schema: TriplegPatch,
			deltaTransitionSchema: undefined,
        },
        TriplegStub: {
			name: "TriplegStub",
			schema: TriplegStub,
			deltaTransitionSchema: TriplegStubDeltaTransition,
        },
        SelfResult: {
			name: "SelfResult",
			schema: SelfResult,
			deltaTransitionSchema: undefined,
        },
        SetlistPacketResult: {
			name: "SetlistPacketResult",
			schema: SetlistPacketResult,
			deltaTransitionSchema: undefined,
        },
        SetlistSubscription: {
			name: "SetlistSubscription",
			schema: SetlistSubscription,
			deltaTransitionSchema: undefined,
        },
        VersionInfo: {
			name: "VersionInfo",
			schema: VersionInfo,
			deltaTransitionSchema: undefined,
        },
        StandardUnitCodes: {
			name: "StandardUnitCodes",
			schema: StandardUnitCodes,
			deltaTransitionSchema: undefined,
        },
        SystemConfig: {
			name: "SystemConfig",
			schema: SystemConfig,
			deltaTransitionSchema: undefined,
        },
} as const;
export type RpcType = keyof typeof RpcTypeMap;
			// method {Ping map[] [] false false false false [] [] [] 0xc0005b06e0}
			// method {Login map[] [] false false false false [0xc00066fd60 0xc00066fe00] [0xc00066fea0] [] 0xc0005b06e0}






    
    

export const LoginRequest = z.object({
        username: z.string(),
        password: z.string(),
});

export const LoginRequestRequired = z.object({
    username: z.string(),
    password: z.string(),
});
export type LoginRequestRequired = z.infer<typeof LoginRequestRequired>;








    

export const LoginResponse = z.object({
        jwt: z.string(),
});

export const LoginResponseRequired = z.object({
    jwt: z.string(),
});
export type LoginResponseRequired = z.infer<typeof LoginResponseRequired>;


			// method {RefreshAuthToken map[] [] false false false false [] [0xc000688000] [] 0xc0005b06e0}






    

export const RefreshAuthTokenResponse = z.object({
        jwt: z.string(),
});

export const RefreshAuthTokenResponseRequired = z.object({
    jwt: z.string(),
});
export type RefreshAuthTokenResponseRequired = z.infer<typeof RefreshAuthTokenResponseRequired>;


			// method {Self map[] [] false false false false [] [0xc0006880a0] [] 0xc0005b06e0}






    

export const SelfResponse = z.object({
        srv: SelfResult,
});

export const SelfResponseRequired = z.object({
    srv: SelfResult,
});
export type SelfResponseRequired = z.infer<typeof SelfResponseRequired>;


			// method {Logout map[] [] false false false false [] [] [] 0xc0005b06e0}
			// method {GetSystemConfig map[] [] false false false false [] [0xc000688140] [] 0xc0005b06e0}






    

export const GetSystemConfigResponse = z.object({
        config: SystemConfig,
});

export const GetSystemConfigResponseRequired = z.object({
    config: SystemConfig,
});
export type GetSystemConfigResponseRequired = z.infer<typeof GetSystemConfigResponseRequired>;


			// method {GetVersionInfo map[] [] false false false false [] [0xc0006881e0] [] 0xc0005b06e0}






    

export const GetVersionInfoResponse = z.object({
        vinfo: VersionInfo,
});

export const GetVersionInfoResponseRequired = z.object({
    vinfo: VersionInfo,
});
export type GetVersionInfoResponseRequired = z.infer<typeof GetVersionInfoResponseRequired>;


			// method {WatchCompanyById map[] [] false false false false [0xc000688280] [0xc000688320] [] 0xc0005b06e0}






    

export const WatchCompanyByIdRequest = z.object({
        companyId: z.string(),
});

export const WatchCompanyByIdRequestRequired = z.object({
    companyId: z.string(),
});
export type WatchCompanyByIdRequestRequired = z.infer<typeof WatchCompanyByIdRequestRequired>;








    

export const WatchCompanyByIdResponse = z.object({
        company: z.optional(Company),
});

export const WatchCompanyByIdResponseRequired = z.object({
    company: Company,
});
export type WatchCompanyByIdResponseRequired = z.infer<typeof WatchCompanyByIdResponseRequired>;


			// method {LastValidCompanyById map[] [] false false false false [0xc0006883c0] [0xc000688460] [] 0xc0005b06e0}






    

export const LastValidCompanyByIdRequest = z.object({
        companyId: z.string(),
});

export const LastValidCompanyByIdRequestRequired = z.object({
    companyId: z.string(),
});
export type LastValidCompanyByIdRequestRequired = z.infer<typeof LastValidCompanyByIdRequestRequired>;








    

export const LastValidCompanyByIdResponse = z.object({
        company: Company,
});

export const LastValidCompanyByIdResponseRequired = z.object({
    company: Company,
});
export type LastValidCompanyByIdResponseRequired = z.infer<typeof LastValidCompanyByIdResponseRequired>;


			// method {CompanyByIdAsof map[] [] false false false false [0xc000688500 0xc0006885a0] [0xc000688640] [] 0xc0005b06e0}






    
    

export const CompanyByIdAsofRequest = z.object({
        companyId: z.string(),
        asof: z.string(),
});

export const CompanyByIdAsofRequestRequired = z.object({
    companyId: z.string(),
    asof: z.string(),
});
export type CompanyByIdAsofRequestRequired = z.infer<typeof CompanyByIdAsofRequestRequired>;








    

export const CompanyByIdAsofResponse = z.object({
        company: z.optional(Company),
});

export const CompanyByIdAsofResponseRequired = z.object({
    company: Company,
});
export type CompanyByIdAsofResponseRequired = z.infer<typeof CompanyByIdAsofResponseRequired>;


			// method {CompanyRevisionCount map[] [] false false false false [0xc0006886e0] [0xc000688780] [] 0xc0005b06e0}






    

export const CompanyRevisionCountRequest = z.object({
        companyId: z.string(),
});

export const CompanyRevisionCountRequestRequired = z.object({
    companyId: z.string(),
});
export type CompanyRevisionCountRequestRequired = z.infer<typeof CompanyRevisionCountRequestRequired>;








    

export const CompanyRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const CompanyRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type CompanyRevisionCountResponseRequired = z.infer<typeof CompanyRevisionCountResponseRequired>;


			// method {AllCompanyRevisions map[] [] false false false false [0xc000688820] [0xc000688910] [] 0xc0005b06e0}






    

export const AllCompanyRevisionsRequest = z.object({
        companyId: z.string(),
});

export const AllCompanyRevisionsRequestRequired = z.object({
    companyId: z.string(),
});
export type AllCompanyRevisionsRequestRequired = z.infer<typeof AllCompanyRevisionsRequestRequired>;








    

export const AllCompanyRevisionsResponse = z.object({
        revisions: Company.array(),
});

export const AllCompanyRevisionsResponseRequired = z.object({
    revisions: Company.array(),
});
export type AllCompanyRevisionsResponseRequired = z.infer<typeof AllCompanyRevisionsResponseRequired>;


			// method {WatchCompanyByCode map[] [] false false false false [0xc0006889b0] [0xc000688a50] [] 0xc0005b06e0}






    

export const WatchCompanyByCodeRequest = z.object({
        companyCode: z.string(),
});

export const WatchCompanyByCodeRequestRequired = z.object({
    companyCode: z.string(),
});
export type WatchCompanyByCodeRequestRequired = z.infer<typeof WatchCompanyByCodeRequestRequired>;








    

export const WatchCompanyByCodeResponse = z.object({
        company: z.optional(Company),
});

export const WatchCompanyByCodeResponseRequired = z.object({
    company: Company,
});
export type WatchCompanyByCodeResponseRequired = z.infer<typeof WatchCompanyByCodeResponseRequired>;


			// method {LastValidCompanyByCode map[] [] false false false false [0xc000688af0] [0xc000688b90] [] 0xc0005b06e0}






    

export const LastValidCompanyByCodeRequest = z.object({
        companyCode: z.string(),
});

export const LastValidCompanyByCodeRequestRequired = z.object({
    companyCode: z.string(),
});
export type LastValidCompanyByCodeRequestRequired = z.infer<typeof LastValidCompanyByCodeRequestRequired>;








    

export const LastValidCompanyByCodeResponse = z.object({
        company: z.optional(Company),
});

export const LastValidCompanyByCodeResponseRequired = z.object({
    company: Company,
});
export type LastValidCompanyByCodeResponseRequired = z.infer<typeof LastValidCompanyByCodeResponseRequired>;


			// method {CompanyByCodeAsof map[] [] false false false false [0xc000688c30 0xc000688cd0] [0xc000688d70] [] 0xc0005b06e0}






    
    

export const CompanyByCodeAsofRequest = z.object({
        companyCode: z.string(),
        asof: z.string(),
});

export const CompanyByCodeAsofRequestRequired = z.object({
    companyCode: z.string(),
    asof: z.string(),
});
export type CompanyByCodeAsofRequestRequired = z.infer<typeof CompanyByCodeAsofRequestRequired>;








    

export const CompanyByCodeAsofResponse = z.object({
        company: z.optional(Company),
});

export const CompanyByCodeAsofResponseRequired = z.object({
    company: Company,
});
export type CompanyByCodeAsofResponseRequired = z.infer<typeof CompanyByCodeAsofResponseRequired>;


			// method {WatchCompaniesByNameFragment map[] [] false false false false [0xc000688e10 0xc000688eb0] [0xc000688fa0] [] 0xc0005b06e0}






    
    

export const WatchCompaniesByNameFragmentRequest = z.object({
        companyNameFrag: z.string(),
        startOffset: z.optional(z.number()),
});

export const WatchCompaniesByNameFragmentRequestRequired = z.object({
    companyNameFrag: z.string(),
    startOffset: z.number(),
});
export type WatchCompaniesByNameFragmentRequestRequired = z.infer<typeof WatchCompaniesByNameFragmentRequestRequired>;








    

export const WatchCompaniesByNameFragmentResponse = z.object({
        companies: CompanyStub.array(),
});

export const WatchCompaniesByNameFragmentResponseRequired = z.object({
    companies: CompanyStub.array(),
});
export type WatchCompaniesByNameFragmentResponseRequired = z.infer<typeof WatchCompaniesByNameFragmentResponseRequired>;


			// method {WatchVenueById map[] [] false false false false [0xc000689040] [0xc0006890e0] [] 0xc0005b06e0}






    

export const WatchVenueByIdRequest = z.object({
        venueId: z.string(),
});

export const WatchVenueByIdRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchVenueByIdRequestRequired = z.infer<typeof WatchVenueByIdRequestRequired>;








    

export const WatchVenueByIdResponse = z.object({
        venue: z.optional(Venue),
});

export const WatchVenueByIdResponseRequired = z.object({
    venue: Venue,
});
export type WatchVenueByIdResponseRequired = z.infer<typeof WatchVenueByIdResponseRequired>;


			// method {LastValidVenueById map[] [] false false false false [0xc000689180] [0xc000689220] [] 0xc0005b06e0}






    

export const LastValidVenueByIdRequest = z.object({
        venueId: z.string(),
});

export const LastValidVenueByIdRequestRequired = z.object({
    venueId: z.string(),
});
export type LastValidVenueByIdRequestRequired = z.infer<typeof LastValidVenueByIdRequestRequired>;








    

export const LastValidVenueByIdResponse = z.object({
        venue: Venue,
});

export const LastValidVenueByIdResponseRequired = z.object({
    venue: Venue,
});
export type LastValidVenueByIdResponseRequired = z.infer<typeof LastValidVenueByIdResponseRequired>;


			// method {VenueByIdAsof map[] [] false false false false [0xc0006892c0 0xc000689360] [0xc000689400] [] 0xc0005b06e0}






    
    

export const VenueByIdAsofRequest = z.object({
        venueId: z.string(),
        asof: z.string(),
});

export const VenueByIdAsofRequestRequired = z.object({
    venueId: z.string(),
    asof: z.string(),
});
export type VenueByIdAsofRequestRequired = z.infer<typeof VenueByIdAsofRequestRequired>;








    

export const VenueByIdAsofResponse = z.object({
        venue: z.optional(Venue),
});

export const VenueByIdAsofResponseRequired = z.object({
    venue: Venue,
});
export type VenueByIdAsofResponseRequired = z.infer<typeof VenueByIdAsofResponseRequired>;


			// method {VenueRevisionCount map[] [] false false false false [0xc0006894a0] [0xc000689540] [] 0xc0005b06e0}






    

export const VenueRevisionCountRequest = z.object({
        venueId: z.string(),
});

export const VenueRevisionCountRequestRequired = z.object({
    venueId: z.string(),
});
export type VenueRevisionCountRequestRequired = z.infer<typeof VenueRevisionCountRequestRequired>;








    

export const VenueRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const VenueRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type VenueRevisionCountResponseRequired = z.infer<typeof VenueRevisionCountResponseRequired>;


			// method {AllVenueRevisions map[] [] false false false false [0xc0006895e0] [0xc0006896d0] [] 0xc0005b06e0}






    

export const AllVenueRevisionsRequest = z.object({
        venueId: z.string(),
});

export const AllVenueRevisionsRequestRequired = z.object({
    venueId: z.string(),
});
export type AllVenueRevisionsRequestRequired = z.infer<typeof AllVenueRevisionsRequestRequired>;








    

export const AllVenueRevisionsResponse = z.object({
        revisions: Venue.array(),
});

export const AllVenueRevisionsResponseRequired = z.object({
    revisions: Venue.array(),
});
export type AllVenueRevisionsResponseRequired = z.infer<typeof AllVenueRevisionsResponseRequired>;


			// method {WatchAdmittersOnDutyForVenue map[] [] false false false false [0xc000689770] [0xc000689860] [] 0xc0005b06e0}






    

export const WatchAdmittersOnDutyForVenueRequest = z.object({
        venueId: z.string(),
});

export const WatchAdmittersOnDutyForVenueRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchAdmittersOnDutyForVenueRequestRequired = z.infer<typeof WatchAdmittersOnDutyForVenueRequestRequired>;








    

export const WatchAdmittersOnDutyForVenueResponse = z.object({
        admitters: AgentStub.array(),
});

export const WatchAdmittersOnDutyForVenueResponseRequired = z.object({
    admitters: AgentStub.array(),
});
export type WatchAdmittersOnDutyForVenueResponseRequired = z.infer<typeof WatchAdmittersOnDutyForVenueResponseRequired>;


			// method {WatchVenueByCode map[] [] false false false false [0xc000689900 0xc0006899a0] [0xc000689a40] [] 0xc0005b06e0}






    
    

export const WatchVenueByCodeRequest = z.object({
        companyId: z.string(),
        venueCode: z.string(),
});

export const WatchVenueByCodeRequestRequired = z.object({
    companyId: z.string(),
    venueCode: z.string(),
});
export type WatchVenueByCodeRequestRequired = z.infer<typeof WatchVenueByCodeRequestRequired>;








    

export const WatchVenueByCodeResponse = z.object({
        venue: z.optional(Venue),
});

export const WatchVenueByCodeResponseRequired = z.object({
    venue: Venue,
});
export type WatchVenueByCodeResponseRequired = z.infer<typeof WatchVenueByCodeResponseRequired>;


			// method {LastValidVenueByCode map[] [] false false false false [0xc000689ae0 0xc000689b80] [0xc000689c20] [] 0xc0005b06e0}






    
    

export const LastValidVenueByCodeRequest = z.object({
        companyId: z.string(),
        venueCode: z.string(),
});

export const LastValidVenueByCodeRequestRequired = z.object({
    companyId: z.string(),
    venueCode: z.string(),
});
export type LastValidVenueByCodeRequestRequired = z.infer<typeof LastValidVenueByCodeRequestRequired>;








    

export const LastValidVenueByCodeResponse = z.object({
        venue: z.optional(Venue),
});

export const LastValidVenueByCodeResponseRequired = z.object({
    venue: Venue,
});
export type LastValidVenueByCodeResponseRequired = z.infer<typeof LastValidVenueByCodeResponseRequired>;


			// method {VenueByCodeAsof map[] [] false false false false [0xc000689cc0 0xc000689d60 0xc000689e00] [0xc000689ea0] [] 0xc0005b06e0}






    
    
    

export const VenueByCodeAsofRequest = z.object({
        companyId: z.string(),
        venueCode: z.string(),
        asof: z.string(),
});

export const VenueByCodeAsofRequestRequired = z.object({
    companyId: z.string(),
    venueCode: z.string(),
    asof: z.string(),
});
export type VenueByCodeAsofRequestRequired = z.infer<typeof VenueByCodeAsofRequestRequired>;








    

export const VenueByCodeAsofResponse = z.object({
        venue: z.optional(Venue),
});

export const VenueByCodeAsofResponseRequired = z.object({
    venue: Venue,
});
export type VenueByCodeAsofResponseRequired = z.infer<typeof VenueByCodeAsofResponseRequired>;


			// method {WatchVenueByName map[] [] false false false false [0xc00068a000 0xc00068a0a0] [0xc00068a140] [] 0xc0005b06e0}






    
    

export const WatchVenueByNameRequest = z.object({
        companyId: z.string(),
        venueName: z.string(),
});

export const WatchVenueByNameRequestRequired = z.object({
    companyId: z.string(),
    venueName: z.string(),
});
export type WatchVenueByNameRequestRequired = z.infer<typeof WatchVenueByNameRequestRequired>;








    

export const WatchVenueByNameResponse = z.object({
        venue: z.optional(Venue),
});

export const WatchVenueByNameResponseRequired = z.object({
    venue: Venue,
});
export type WatchVenueByNameResponseRequired = z.infer<typeof WatchVenueByNameResponseRequired>;


			// method {LastValidVenueByName map[] [] false false false false [0xc00068a1e0 0xc00068a280] [0xc00068a320] [] 0xc0005b06e0}






    
    

export const LastValidVenueByNameRequest = z.object({
        companyId: z.string(),
        venueName: z.string(),
});

export const LastValidVenueByNameRequestRequired = z.object({
    companyId: z.string(),
    venueName: z.string(),
});
export type LastValidVenueByNameRequestRequired = z.infer<typeof LastValidVenueByNameRequestRequired>;








    

export const LastValidVenueByNameResponse = z.object({
        venue: z.optional(Venue),
});

export const LastValidVenueByNameResponseRequired = z.object({
    venue: Venue,
});
export type LastValidVenueByNameResponseRequired = z.infer<typeof LastValidVenueByNameResponseRequired>;


			// method {VenueByNameAsof map[] [] false false false false [0xc00068a3c0 0xc00068a460 0xc00068a500] [0xc00068a5a0] [] 0xc0005b06e0}






    
    
    

export const VenueByNameAsofRequest = z.object({
        companyId: z.string(),
        venueName: z.string(),
        asof: z.string(),
});

export const VenueByNameAsofRequestRequired = z.object({
    companyId: z.string(),
    venueName: z.string(),
    asof: z.string(),
});
export type VenueByNameAsofRequestRequired = z.infer<typeof VenueByNameAsofRequestRequired>;








    

export const VenueByNameAsofResponse = z.object({
        venue: z.optional(Venue),
});

export const VenueByNameAsofResponseRequired = z.object({
    venue: Venue,
});
export type VenueByNameAsofResponseRequired = z.infer<typeof VenueByNameAsofResponseRequired>;


			// method {DownstreamVenues map[] [] false false false false [] [0xc00068a690] [] 0xc0005b06e0}






    

export const DownstreamVenuesResponse = z.object({
        venues: VenueStub.array(),
});

export const DownstreamVenuesResponseRequired = z.object({
    venues: VenueStub.array(),
});
export type DownstreamVenuesResponseRequired = z.infer<typeof DownstreamVenuesResponseRequired>;


			// method {WatchTrucksDockedAt map[] [] false false false false [0xc00068a730] [0xc00068a820] [] 0xc0005b06e0}






    

export const WatchTrucksDockedAtRequest = z.object({
        venueId: z.string(),
});

export const WatchTrucksDockedAtRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchTrucksDockedAtRequestRequired = z.infer<typeof WatchTrucksDockedAtRequestRequired>;








    

export const WatchTrucksDockedAtResponse = z.object({
        trucks: TruckStub.array(),
});

export const WatchTrucksDockedAtResponseRequired = z.object({
    trucks: TruckStub.array(),
});
export type WatchTrucksDockedAtResponseRequired = z.infer<typeof WatchTrucksDockedAtResponseRequired>;


			// method {WatchAgentById map[] [] false false false false [0xc00068a8c0] [0xc00068a960] [] 0xc0005b06e0}






    

export const WatchAgentByIdRequest = z.object({
        agentId: z.string(),
});

export const WatchAgentByIdRequestRequired = z.object({
    agentId: z.string(),
});
export type WatchAgentByIdRequestRequired = z.infer<typeof WatchAgentByIdRequestRequired>;








    

export const WatchAgentByIdResponse = z.object({
        agent: z.optional(Agent),
});

export const WatchAgentByIdResponseRequired = z.object({
    agent: Agent,
});
export type WatchAgentByIdResponseRequired = z.infer<typeof WatchAgentByIdResponseRequired>;


			// method {LastValidAgentById map[] [] false false false false [0xc00068aa00] [0xc00068aaa0] [] 0xc0005b06e0}






    

export const LastValidAgentByIdRequest = z.object({
        agentId: z.string(),
});

export const LastValidAgentByIdRequestRequired = z.object({
    agentId: z.string(),
});
export type LastValidAgentByIdRequestRequired = z.infer<typeof LastValidAgentByIdRequestRequired>;








    

export const LastValidAgentByIdResponse = z.object({
        agent: Agent,
});

export const LastValidAgentByIdResponseRequired = z.object({
    agent: Agent,
});
export type LastValidAgentByIdResponseRequired = z.infer<typeof LastValidAgentByIdResponseRequired>;


			// method {AgentByIdAsof map[] [] false false false false [0xc00068ab40 0xc00068abe0] [0xc00068ac80] [] 0xc0005b06e0}






    
    

export const AgentByIdAsofRequest = z.object({
        agentId: z.string(),
        asof: z.string(),
});

export const AgentByIdAsofRequestRequired = z.object({
    agentId: z.string(),
    asof: z.string(),
});
export type AgentByIdAsofRequestRequired = z.infer<typeof AgentByIdAsofRequestRequired>;








    

export const AgentByIdAsofResponse = z.object({
        agent: z.optional(Agent),
});

export const AgentByIdAsofResponseRequired = z.object({
    agent: Agent,
});
export type AgentByIdAsofResponseRequired = z.infer<typeof AgentByIdAsofResponseRequired>;


			// method {AgentRevisionCount map[] [] false false false false [0xc00068ad20] [0xc00068adc0] [] 0xc0005b06e0}






    

export const AgentRevisionCountRequest = z.object({
        agentId: z.string(),
});

export const AgentRevisionCountRequestRequired = z.object({
    agentId: z.string(),
});
export type AgentRevisionCountRequestRequired = z.infer<typeof AgentRevisionCountRequestRequired>;








    

export const AgentRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const AgentRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type AgentRevisionCountResponseRequired = z.infer<typeof AgentRevisionCountResponseRequired>;


			// method {AllAgentRevisions map[] [] false false false false [0xc00068ae60] [0xc00068af50] [] 0xc0005b06e0}






    

export const AllAgentRevisionsRequest = z.object({
        agentId: z.string(),
});

export const AllAgentRevisionsRequestRequired = z.object({
    agentId: z.string(),
});
export type AllAgentRevisionsRequestRequired = z.infer<typeof AllAgentRevisionsRequestRequired>;








    

export const AllAgentRevisionsResponse = z.object({
        revisions: Agent.array(),
});

export const AllAgentRevisionsResponseRequired = z.object({
    revisions: Agent.array(),
});
export type AllAgentRevisionsResponseRequired = z.infer<typeof AllAgentRevisionsResponseRequired>;


			// method {WatchAgentByCode map[] [] false false false false [0xc00068aff0 0xc00068b090] [0xc00068b130] [] 0xc0005b06e0}






    
    

export const WatchAgentByCodeRequest = z.object({
        companyId: z.string(),
        agentCode: z.string(),
});

export const WatchAgentByCodeRequestRequired = z.object({
    companyId: z.string(),
    agentCode: z.string(),
});
export type WatchAgentByCodeRequestRequired = z.infer<typeof WatchAgentByCodeRequestRequired>;








    

export const WatchAgentByCodeResponse = z.object({
        agent: z.optional(Agent),
});

export const WatchAgentByCodeResponseRequired = z.object({
    agent: Agent,
});
export type WatchAgentByCodeResponseRequired = z.infer<typeof WatchAgentByCodeResponseRequired>;


			// method {LastValidAgentByCode map[] [] false false false false [0xc00068b1d0 0xc00068b270] [0xc00068b310] [] 0xc0005b06e0}






    
    

export const LastValidAgentByCodeRequest = z.object({
        companyId: z.string(),
        agentCode: z.string(),
});

export const LastValidAgentByCodeRequestRequired = z.object({
    companyId: z.string(),
    agentCode: z.string(),
});
export type LastValidAgentByCodeRequestRequired = z.infer<typeof LastValidAgentByCodeRequestRequired>;








    

export const LastValidAgentByCodeResponse = z.object({
        agent: z.optional(Agent),
});

export const LastValidAgentByCodeResponseRequired = z.object({
    agent: Agent,
});
export type LastValidAgentByCodeResponseRequired = z.infer<typeof LastValidAgentByCodeResponseRequired>;


			// method {AgentByCodeAsof map[] [] false false false false [0xc00068b3b0 0xc00068b450 0xc00068b4f0] [0xc00068b590] [] 0xc0005b06e0}






    
    
    

export const AgentByCodeAsofRequest = z.object({
        companyId: z.string(),
        agentCode: z.string(),
        asof: z.string(),
});

export const AgentByCodeAsofRequestRequired = z.object({
    companyId: z.string(),
    agentCode: z.string(),
    asof: z.string(),
});
export type AgentByCodeAsofRequestRequired = z.infer<typeof AgentByCodeAsofRequestRequired>;








    

export const AgentByCodeAsofResponse = z.object({
        agent: z.optional(Agent),
});

export const AgentByCodeAsofResponseRequired = z.object({
    agent: Agent,
});
export type AgentByCodeAsofResponseRequired = z.infer<typeof AgentByCodeAsofResponseRequired>;


			// method {WatchAgentByName map[] [] false false false false [0xc00068b630 0xc00068b6d0] [0xc00068b770] [] 0xc0005b06e0}






    
    

export const WatchAgentByNameRequest = z.object({
        companyId: z.string(),
        agentName: z.string(),
});

export const WatchAgentByNameRequestRequired = z.object({
    companyId: z.string(),
    agentName: z.string(),
});
export type WatchAgentByNameRequestRequired = z.infer<typeof WatchAgentByNameRequestRequired>;








    

export const WatchAgentByNameResponse = z.object({
        agent: z.optional(Agent),
});

export const WatchAgentByNameResponseRequired = z.object({
    agent: Agent,
});
export type WatchAgentByNameResponseRequired = z.infer<typeof WatchAgentByNameResponseRequired>;


			// method {LastValidAgentByName map[] [] false false false false [0xc00068b810 0xc00068b8b0] [0xc00068b950] [] 0xc0005b06e0}






    
    

export const LastValidAgentByNameRequest = z.object({
        companyId: z.string(),
        agentName: z.string(),
});

export const LastValidAgentByNameRequestRequired = z.object({
    companyId: z.string(),
    agentName: z.string(),
});
export type LastValidAgentByNameRequestRequired = z.infer<typeof LastValidAgentByNameRequestRequired>;








    

export const LastValidAgentByNameResponse = z.object({
        agent: z.optional(Agent),
});

export const LastValidAgentByNameResponseRequired = z.object({
    agent: Agent,
});
export type LastValidAgentByNameResponseRequired = z.infer<typeof LastValidAgentByNameResponseRequired>;


			// method {AgentByNameAsof map[] [] false false false false [0xc00068b9f0 0xc00068ba90 0xc00068bb30] [0xc00068bbd0] [] 0xc0005b06e0}






    
    
    

export const AgentByNameAsofRequest = z.object({
        companyId: z.string(),
        agentName: z.string(),
        asof: z.string(),
});

export const AgentByNameAsofRequestRequired = z.object({
    companyId: z.string(),
    agentName: z.string(),
    asof: z.string(),
});
export type AgentByNameAsofRequestRequired = z.infer<typeof AgentByNameAsofRequestRequired>;








    

export const AgentByNameAsofResponse = z.object({
        agent: z.optional(Agent),
});

export const AgentByNameAsofResponseRequired = z.object({
    agent: Agent,
});
export type AgentByNameAsofResponseRequired = z.infer<typeof AgentByNameAsofResponseRequired>;


			// method {WatchAgentByLogin map[] [] false false false false [0xc00068bc70] [0xc00068bd10] [] 0xc0005b06e0}






    

export const WatchAgentByLoginRequest = z.object({
        login: z.string(),
});

export const WatchAgentByLoginRequestRequired = z.object({
    login: z.string(),
});
export type WatchAgentByLoginRequestRequired = z.infer<typeof WatchAgentByLoginRequestRequired>;








    

export const WatchAgentByLoginResponse = z.object({
        agent: z.optional(Agent),
});

export const WatchAgentByLoginResponseRequired = z.object({
    agent: Agent,
});
export type WatchAgentByLoginResponseRequired = z.infer<typeof WatchAgentByLoginResponseRequired>;


			// method {LastValidAgentByLogin map[] [] false false false false [0xc00068bdb0] [0xc00068be50] [] 0xc0005b06e0}






    

export const LastValidAgentByLoginRequest = z.object({
        login: z.string(),
});

export const LastValidAgentByLoginRequestRequired = z.object({
    login: z.string(),
});
export type LastValidAgentByLoginRequestRequired = z.infer<typeof LastValidAgentByLoginRequestRequired>;








    

export const LastValidAgentByLoginResponse = z.object({
        agent: Agent,
});

export const LastValidAgentByLoginResponseRequired = z.object({
    agent: Agent,
});
export type LastValidAgentByLoginResponseRequired = z.infer<typeof LastValidAgentByLoginResponseRequired>;


			// method {AgentByLoginAsof map[] [] false false false false [0xc00068bef0 0xc00068e050] [0xc00068e0f0] [] 0xc0005b06e0}






    
    

export const AgentByLoginAsofRequest = z.object({
        login: z.string(),
        asof: z.string(),
});

export const AgentByLoginAsofRequestRequired = z.object({
    login: z.string(),
    asof: z.string(),
});
export type AgentByLoginAsofRequestRequired = z.infer<typeof AgentByLoginAsofRequestRequired>;








    

export const AgentByLoginAsofResponse = z.object({
        agent: z.optional(Agent),
});

export const AgentByLoginAsofResponseRequired = z.object({
    agent: Agent,
});
export type AgentByLoginAsofResponseRequired = z.infer<typeof AgentByLoginAsofResponseRequired>;


			// method {AgentStampById map[] [] false false false false [0xc00068e190] [0xc00068e230] [] 0xc0005b06e0}






    

export const AgentStampByIdRequest = z.object({
        stampId: z.string(),
});

export const AgentStampByIdRequestRequired = z.object({
    stampId: z.string(),
});
export type AgentStampByIdRequestRequired = z.infer<typeof AgentStampByIdRequestRequired>;








    

export const AgentStampByIdResponse = z.object({
        stamp: AgentStamp,
});

export const AgentStampByIdResponseRequired = z.object({
    stamp: AgentStamp,
});
export type AgentStampByIdResponseRequired = z.infer<typeof AgentStampByIdResponseRequired>;


			// method {LastFlavoredStampForAgent map[] [] false false false false [0xc00068e2d0] [0xc00068e370] [] 0xc0005b06e0}






    

export const LastFlavoredStampForAgentRequest = z.object({
        agentId: z.string(),
});

export const LastFlavoredStampForAgentRequestRequired = z.object({
    agentId: z.string(),
});
export type LastFlavoredStampForAgentRequestRequired = z.infer<typeof LastFlavoredStampForAgentRequestRequired>;








    

export const LastFlavoredStampForAgentResponse = z.object({
        stamp: z.optional(AgentStamp),
});

export const LastFlavoredStampForAgentResponseRequired = z.object({
    stamp: AgentStamp,
});
export type LastFlavoredStampForAgentResponseRequired = z.infer<typeof LastFlavoredStampForAgentResponseRequired>;


			// method {WatchStampsForAgent map[] [] false false false false [0xc00068e410] [0xc00068e500] [] 0xc0005b06e0}






    

export const WatchStampsForAgentRequest = z.object({
        agentId: z.string(),
});

export const WatchStampsForAgentRequestRequired = z.object({
    agentId: z.string(),
});
export type WatchStampsForAgentRequestRequired = z.infer<typeof WatchStampsForAgentRequestRequired>;








    

export const WatchStampsForAgentResponse = z.object({
        stamps: AgentStamp.array(),
});

export const WatchStampsForAgentResponseRequired = z.object({
    stamps: AgentStamp.array(),
});
export type WatchStampsForAgentResponseRequired = z.infer<typeof WatchStampsForAgentResponseRequired>;


			// method {StampsForAgentDuring map[] [] false false false false [0xc00068e5a0 0xc00068e640] [0xc00068e730] [] 0xc0005b06e0}






    
    

export const StampsForAgentDuringRequest = z.object({
        agentId: z.string(),
        during: z.string(),
});

export const StampsForAgentDuringRequestRequired = z.object({
    agentId: z.string(),
    during: z.string(),
});
export type StampsForAgentDuringRequestRequired = z.infer<typeof StampsForAgentDuringRequestRequired>;








    

export const StampsForAgentDuringResponse = z.object({
        stamps: AgentStamp.array(),
});

export const StampsForAgentDuringResponseRequired = z.object({
    stamps: AgentStamp.array(),
});
export type StampsForAgentDuringResponseRequired = z.infer<typeof StampsForAgentDuringResponseRequired>;


			// method {AgentAvatar map[] [] false false false false [0xc00068e7d0] [0xc00068e870] [] 0xc0005b06e0}






    

export const AgentAvatarRequest = z.object({
        agentId: z.string(),
});

export const AgentAvatarRequestRequired = z.object({
    agentId: z.string(),
});
export type AgentAvatarRequestRequired = z.infer<typeof AgentAvatarRequestRequired>;








    

export const AgentAvatarResponse = z.object({
        photoSlug: z.optional(z.string()),
});

export const AgentAvatarResponseRequired = z.object({
    photoSlug: z.string(),
});
export type AgentAvatarResponseRequired = z.infer<typeof AgentAvatarResponseRequired>;


			// method {WatchAgentPresenceById map[] [] false false false false [0xc00068e910] [0xc00068e9b0] [] 0xc0005b06e0}






    

export const WatchAgentPresenceByIdRequest = z.object({
        agentId: z.string(),
});

export const WatchAgentPresenceByIdRequestRequired = z.object({
    agentId: z.string(),
});
export type WatchAgentPresenceByIdRequestRequired = z.infer<typeof WatchAgentPresenceByIdRequestRequired>;








    

export const WatchAgentPresenceByIdResponse = z.object({
        presence: AgentPresence,
});

export const WatchAgentPresenceByIdResponseRequired = z.object({
    presence: AgentPresence,
});
export type WatchAgentPresenceByIdResponseRequired = z.infer<typeof WatchAgentPresenceByIdResponseRequired>;


			// method {WatchAllPresentAgents map[] [] false false false false [] [0xc00068eaa0] [] 0xc0005b06e0}






    

export const WatchAllPresentAgentsResponse = z.object({
        agents: AgentStub.array(),
});

export const WatchAllPresentAgentsResponseRequired = z.object({
    agents: AgentStub.array(),
});
export type WatchAllPresentAgentsResponseRequired = z.infer<typeof WatchAllPresentAgentsResponseRequired>;


			// method {WatchTruckModels map[] [] false false false false [] [0xc00068eb90] [] 0xc0005b06e0}






    

export const WatchTruckModelsResponse = z.object({
        models: TruckModel.array(),
});

export const WatchTruckModelsResponseRequired = z.object({
    models: TruckModel.array(),
});
export type WatchTruckModelsResponseRequired = z.infer<typeof WatchTruckModelsResponseRequired>;


			// method {WatchTruckModelById map[] [] false false false false [0xc00068ec30] [0xc00068ecd0] [] 0xc0005b06e0}






    

export const WatchTruckModelByIdRequest = z.object({
        modelId: z.string(),
});

export const WatchTruckModelByIdRequestRequired = z.object({
    modelId: z.string(),
});
export type WatchTruckModelByIdRequestRequired = z.infer<typeof WatchTruckModelByIdRequestRequired>;








    

export const WatchTruckModelByIdResponse = z.object({
        model: z.optional(TruckModel),
});

export const WatchTruckModelByIdResponseRequired = z.object({
    model: TruckModel,
});
export type WatchTruckModelByIdResponseRequired = z.infer<typeof WatchTruckModelByIdResponseRequired>;


			// method {WatchTruckById map[] [] false false false false [0xc00068ed70] [0xc00068ee10] [] 0xc0005b06e0}






    

export const WatchTruckByIdRequest = z.object({
        truckId: z.string(),
});

export const WatchTruckByIdRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchTruckByIdRequestRequired = z.infer<typeof WatchTruckByIdRequestRequired>;








    

export const WatchTruckByIdResponse = z.object({
        truck: z.optional(Truck),
});

export const WatchTruckByIdResponseRequired = z.object({
    truck: Truck,
});
export type WatchTruckByIdResponseRequired = z.infer<typeof WatchTruckByIdResponseRequired>;


			// method {LastValidTruckById map[] [] false false false false [0xc00068eeb0] [0xc00068ef50] [] 0xc0005b06e0}






    

export const LastValidTruckByIdRequest = z.object({
        truckId: z.string(),
});

export const LastValidTruckByIdRequestRequired = z.object({
    truckId: z.string(),
});
export type LastValidTruckByIdRequestRequired = z.infer<typeof LastValidTruckByIdRequestRequired>;








    

export const LastValidTruckByIdResponse = z.object({
        truck: Truck,
});

export const LastValidTruckByIdResponseRequired = z.object({
    truck: Truck,
});
export type LastValidTruckByIdResponseRequired = z.infer<typeof LastValidTruckByIdResponseRequired>;


			// method {TruckByIdAsof map[] [] false false false false [0xc00068eff0 0xc00068f090] [0xc00068f130] [] 0xc0005b06e0}






    
    

export const TruckByIdAsofRequest = z.object({
        truckId: z.string(),
        asof: z.string(),
});

export const TruckByIdAsofRequestRequired = z.object({
    truckId: z.string(),
    asof: z.string(),
});
export type TruckByIdAsofRequestRequired = z.infer<typeof TruckByIdAsofRequestRequired>;








    

export const TruckByIdAsofResponse = z.object({
        truck: z.optional(Truck),
});

export const TruckByIdAsofResponseRequired = z.object({
    truck: Truck,
});
export type TruckByIdAsofResponseRequired = z.infer<typeof TruckByIdAsofResponseRequired>;


			// method {TruckRevisionCount map[] [] false false false false [0xc00068f1d0] [0xc00068f270] [] 0xc0005b06e0}






    

export const TruckRevisionCountRequest = z.object({
        truckId: z.string(),
});

export const TruckRevisionCountRequestRequired = z.object({
    truckId: z.string(),
});
export type TruckRevisionCountRequestRequired = z.infer<typeof TruckRevisionCountRequestRequired>;








    

export const TruckRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const TruckRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type TruckRevisionCountResponseRequired = z.infer<typeof TruckRevisionCountResponseRequired>;


			// method {AllTruckRevisions map[] [] false false false false [0xc00068f310] [0xc00068f400] [] 0xc0005b06e0}






    

export const AllTruckRevisionsRequest = z.object({
        truckId: z.string(),
});

export const AllTruckRevisionsRequestRequired = z.object({
    truckId: z.string(),
});
export type AllTruckRevisionsRequestRequired = z.infer<typeof AllTruckRevisionsRequestRequired>;








    

export const AllTruckRevisionsResponse = z.object({
        revisions: Truck.array(),
});

export const AllTruckRevisionsResponseRequired = z.object({
    revisions: Truck.array(),
});
export type AllTruckRevisionsResponseRequired = z.infer<typeof AllTruckRevisionsResponseRequired>;


			// method {WatchTruckByPlate map[] [] false false false false [0xc00068f4a0] [0xc00068f540] [] 0xc0005b06e0}






    

export const WatchTruckByPlateRequest = z.object({
        plate: z.string(),
});

export const WatchTruckByPlateRequestRequired = z.object({
    plate: z.string(),
});
export type WatchTruckByPlateRequestRequired = z.infer<typeof WatchTruckByPlateRequestRequired>;








    

export const WatchTruckByPlateResponse = z.object({
        truck: z.optional(Truck),
});

export const WatchTruckByPlateResponseRequired = z.object({
    truck: Truck,
});
export type WatchTruckByPlateResponseRequired = z.infer<typeof WatchTruckByPlateResponseRequired>;


			// method {LastValidTruckByPlate map[] [] false false false false [0xc00068f5e0] [0xc00068f680] [] 0xc0005b06e0}






    

export const LastValidTruckByPlateRequest = z.object({
        plate: z.string(),
});

export const LastValidTruckByPlateRequestRequired = z.object({
    plate: z.string(),
});
export type LastValidTruckByPlateRequestRequired = z.infer<typeof LastValidTruckByPlateRequestRequired>;








    

export const LastValidTruckByPlateResponse = z.object({
        truck: Truck,
});

export const LastValidTruckByPlateResponseRequired = z.object({
    truck: Truck,
});
export type LastValidTruckByPlateResponseRequired = z.infer<typeof LastValidTruckByPlateResponseRequired>;


			// method {TruckByPlateAsof map[] [] false false false false [0xc00068f720 0xc00068f7c0] [0xc00068f860] [] 0xc0005b06e0}






    
    

export const TruckByPlateAsofRequest = z.object({
        plate: z.string(),
        asof: z.string(),
});

export const TruckByPlateAsofRequestRequired = z.object({
    plate: z.string(),
    asof: z.string(),
});
export type TruckByPlateAsofRequestRequired = z.infer<typeof TruckByPlateAsofRequestRequired>;








    

export const TruckByPlateAsofResponse = z.object({
        truck: z.optional(Truck),
});

export const TruckByPlateAsofResponseRequired = z.object({
    truck: Truck,
});
export type TruckByPlateAsofResponseRequired = z.infer<typeof TruckByPlateAsofResponseRequired>;


			// method {WatchTruckByCrew map[] [] false false false false [0xc00068f900] [0xc00068f9a0] [] 0xc0005b06e0}






    

export const WatchTruckByCrewRequest = z.object({
        crewId: z.string(),
});

export const WatchTruckByCrewRequestRequired = z.object({
    crewId: z.string(),
});
export type WatchTruckByCrewRequestRequired = z.infer<typeof WatchTruckByCrewRequestRequired>;








    

export const WatchTruckByCrewResponse = z.object({
        truck: z.optional(TruckStub),
});

export const WatchTruckByCrewResponseRequired = z.object({
    truck: TruckStub,
});
export type WatchTruckByCrewResponseRequired = z.infer<typeof WatchTruckByCrewResponseRequired>;


			// method {TruckTenuresByCrewDuring map[] [] false false false false [0xc00068fa40 0xc00068fae0] [0xc00068fbd0] [] 0xc0005b06e0}






    
    

export const TruckTenuresByCrewDuringRequest = z.object({
        crewId: z.string(),
        during: z.string(),
});

export const TruckTenuresByCrewDuringRequestRequired = z.object({
    crewId: z.string(),
    during: z.string(),
});
export type TruckTenuresByCrewDuringRequestRequired = z.infer<typeof TruckTenuresByCrewDuringRequestRequired>;








    

export const TruckTenuresByCrewDuringResponse = z.object({
        tenures: TruckTenure.array(),
});

export const TruckTenuresByCrewDuringResponseRequired = z.object({
    tenures: TruckTenure.array(),
});
export type TruckTenuresByCrewDuringResponseRequired = z.infer<typeof TruckTenuresByCrewDuringResponseRequired>;


			// method {WatchCrewByTruck map[] [] false false false false [0xc00068fc70] [0xc00068fd60] [] 0xc0005b06e0}






    

export const WatchCrewByTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchCrewByTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchCrewByTruckRequestRequired = z.infer<typeof WatchCrewByTruckRequestRequired>;








    

export const WatchCrewByTruckResponse = z.object({
        tenures: CrewTenure.array(),
});

export const WatchCrewByTruckResponseRequired = z.object({
    tenures: CrewTenure.array(),
});
export type WatchCrewByTruckResponseRequired = z.infer<typeof WatchCrewByTruckResponseRequired>;


			// method {CrewTenuresByTruckDuring map[] [] false false false false [0xc00068fe00 0xc00068fea0] [0xc000690050] [] 0xc0005b06e0}






    
    

export const CrewTenuresByTruckDuringRequest = z.object({
        truckId: z.string(),
        during: z.string(),
});

export const CrewTenuresByTruckDuringRequestRequired = z.object({
    truckId: z.string(),
    during: z.string(),
});
export type CrewTenuresByTruckDuringRequestRequired = z.infer<typeof CrewTenuresByTruckDuringRequestRequired>;








    

export const CrewTenuresByTruckDuringResponse = z.object({
        tenures: CrewTenure.array(),
});

export const CrewTenuresByTruckDuringResponseRequired = z.object({
    tenures: CrewTenure.array(),
});
export type CrewTenuresByTruckDuringResponseRequired = z.infer<typeof CrewTenuresByTruckDuringResponseRequired>;


			// method {TruckStampById map[] [] false false false false [0xc0006900f0] [0xc000690190] [] 0xc0005b06e0}






    

export const TruckStampByIdRequest = z.object({
        stampId: z.string(),
});

export const TruckStampByIdRequestRequired = z.object({
    stampId: z.string(),
});
export type TruckStampByIdRequestRequired = z.infer<typeof TruckStampByIdRequestRequired>;








    

export const TruckStampByIdResponse = z.object({
        stamp: TruckStamp,
});

export const TruckStampByIdResponseRequired = z.object({
    stamp: TruckStamp,
});
export type TruckStampByIdResponseRequired = z.infer<typeof TruckStampByIdResponseRequired>;


			// method {LastFlavoredStampForTruck map[] [] false false false false [0xc000690230] [0xc0006902d0] [] 0xc0005b06e0}






    

export const LastFlavoredStampForTruckRequest = z.object({
        truckId: z.string(),
});

export const LastFlavoredStampForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type LastFlavoredStampForTruckRequestRequired = z.infer<typeof LastFlavoredStampForTruckRequestRequired>;








    

export const LastFlavoredStampForTruckResponse = z.object({
        stamp: z.optional(TruckStamp),
});

export const LastFlavoredStampForTruckResponseRequired = z.object({
    stamp: TruckStamp,
});
export type LastFlavoredStampForTruckResponseRequired = z.infer<typeof LastFlavoredStampForTruckResponseRequired>;


			// method {WatchStampsForTruck map[] [] false false false false [0xc000690370] [0xc000690460] [] 0xc0005b06e0}






    

export const WatchStampsForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchStampsForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchStampsForTruckRequestRequired = z.infer<typeof WatchStampsForTruckRequestRequired>;








    

export const WatchStampsForTruckResponse = z.object({
        stamps: TruckStamp.array(),
});

export const WatchStampsForTruckResponseRequired = z.object({
    stamps: TruckStamp.array(),
});
export type WatchStampsForTruckResponseRequired = z.infer<typeof WatchStampsForTruckResponseRequired>;


			// method {StampsForTruckDuring map[] [] false false false false [0xc000690500 0xc0006905a0] [0xc000690690] [] 0xc0005b06e0}






    
    

export const StampsForTruckDuringRequest = z.object({
        truckId: z.string(),
        during: z.string(),
});

export const StampsForTruckDuringRequestRequired = z.object({
    truckId: z.string(),
    during: z.string(),
});
export type StampsForTruckDuringRequestRequired = z.infer<typeof StampsForTruckDuringRequestRequired>;








    

export const StampsForTruckDuringResponse = z.object({
        stamps: TruckStamp.array(),
});

export const StampsForTruckDuringResponseRequired = z.object({
    stamps: TruckStamp.array(),
});
export type StampsForTruckDuringResponseRequired = z.infer<typeof StampsForTruckDuringResponseRequired>;


			// method {TruckAvatar map[] [] false false false false [0xc000690730] [0xc0006907d0] [] 0xc0005b06e0}






    

export const TruckAvatarRequest = z.object({
        truckId: z.string(),
});

export const TruckAvatarRequestRequired = z.object({
    truckId: z.string(),
});
export type TruckAvatarRequestRequired = z.infer<typeof TruckAvatarRequestRequired>;








    

export const TruckAvatarResponse = z.object({
        photoSlug: z.optional(z.string()),
});

export const TruckAvatarResponseRequired = z.object({
    photoSlug: z.string(),
});
export type TruckAvatarResponseRequired = z.infer<typeof TruckAvatarResponseRequired>;


			// method {WatchJobById map[] [] false false false false [0xc000690870] [0xc000690910] [] 0xc0005b06e0}






    

export const WatchJobByIdRequest = z.object({
        jobId: z.string(),
});

export const WatchJobByIdRequestRequired = z.object({
    jobId: z.string(),
});
export type WatchJobByIdRequestRequired = z.infer<typeof WatchJobByIdRequestRequired>;








    

export const WatchJobByIdResponse = z.object({
        job: z.optional(Job),
});

export const WatchJobByIdResponseRequired = z.object({
    job: Job,
});
export type WatchJobByIdResponseRequired = z.infer<typeof WatchJobByIdResponseRequired>;


			// method {LastValidJobById map[] [] false false false false [0xc0006909b0] [0xc000690a50] [] 0xc0005b06e0}






    

export const LastValidJobByIdRequest = z.object({
        jobId: z.string(),
});

export const LastValidJobByIdRequestRequired = z.object({
    jobId: z.string(),
});
export type LastValidJobByIdRequestRequired = z.infer<typeof LastValidJobByIdRequestRequired>;








    

export const LastValidJobByIdResponse = z.object({
        job: Job,
});

export const LastValidJobByIdResponseRequired = z.object({
    job: Job,
});
export type LastValidJobByIdResponseRequired = z.infer<typeof LastValidJobByIdResponseRequired>;


			// method {JobByIdAsof map[] [] false false false false [0xc000690af0 0xc000690b90] [0xc000690c30] [] 0xc0005b06e0}






    
    

export const JobByIdAsofRequest = z.object({
        jobId: z.string(),
        asof: z.string(),
});

export const JobByIdAsofRequestRequired = z.object({
    jobId: z.string(),
    asof: z.string(),
});
export type JobByIdAsofRequestRequired = z.infer<typeof JobByIdAsofRequestRequired>;








    

export const JobByIdAsofResponse = z.object({
        job: Job,
});

export const JobByIdAsofResponseRequired = z.object({
    job: Job,
});
export type JobByIdAsofResponseRequired = z.infer<typeof JobByIdAsofResponseRequired>;


			// method {JobRevisionCount map[] [] false false false false [0xc000690cd0] [0xc000690d70] [] 0xc0005b06e0}






    

export const JobRevisionCountRequest = z.object({
        jobId: z.string(),
});

export const JobRevisionCountRequestRequired = z.object({
    jobId: z.string(),
});
export type JobRevisionCountRequestRequired = z.infer<typeof JobRevisionCountRequestRequired>;








    

export const JobRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const JobRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type JobRevisionCountResponseRequired = z.infer<typeof JobRevisionCountResponseRequired>;


			// method {AllJobRevisions map[] [] false false false false [0xc000690e10] [0xc000690f00] [] 0xc0005b06e0}






    

export const AllJobRevisionsRequest = z.object({
        jobId: z.string(),
});

export const AllJobRevisionsRequestRequired = z.object({
    jobId: z.string(),
});
export type AllJobRevisionsRequestRequired = z.infer<typeof AllJobRevisionsRequestRequired>;








    

export const AllJobRevisionsResponse = z.object({
        revisions: Job.array(),
});

export const AllJobRevisionsResponseRequired = z.object({
    revisions: Job.array(),
});
export type AllJobRevisionsResponseRequired = z.infer<typeof AllJobRevisionsResponseRequired>;


			// method {WatchExportableJobs map[] [] false false false false [] [0xc000690ff0] [] 0xc0005b06e0}






    

export const WatchExportableJobsResponse = z.object({
        jobs: JobStub.array(),
});

export const WatchExportableJobsResponseRequired = z.object({
    jobs: JobStub.array(),
});
export type WatchExportableJobsResponseRequired = z.infer<typeof WatchExportableJobsResponseRequired>;


			// method {WatchExportedJobs map[] [initially returns all exported in the last 24 hours] false false false false [] [0xc0006910e0] [] 0xc0005b06e0}






    

export const WatchExportedJobsResponse = z.object({
        jobs: JobStub.array(),
});

export const WatchExportedJobsResponseRequired = z.object({
    jobs: JobStub.array(),
});
export type WatchExportedJobsResponseRequired = z.infer<typeof WatchExportedJobsResponseRequired>;


			// method {ShowExportedJob map[] [] false false false false [0xc000691180] [0xc000691220] [] 0xc0005b06e0}






    

export const ShowExportedJobRequest = z.object({
        jobId: z.string(),
});

export const ShowExportedJobRequestRequired = z.object({
    jobId: z.string(),
});
export type ShowExportedJobRequestRequired = z.infer<typeof ShowExportedJobRequestRequired>;








    

export const ShowExportedJobResponse = z.object({
        exported: z.string(),
});

export const ShowExportedJobResponseRequired = z.object({
    exported: z.string(),
});
export type ShowExportedJobResponseRequired = z.infer<typeof ShowExportedJobResponseRequired>;


			// method {ExportJob map[] [] false false false false [0xc0006912c0] [] [] 0xc0005b06e0}






    

export const ExportJobRequest = z.object({
        jobId: z.string(),
});

export const ExportJobRequestRequired = z.object({
    jobId: z.string(),
});
export type ExportJobRequestRequired = z.infer<typeof ExportJobRequestRequired>;


			// method {WatchJobByJobCode map[] [] false false false false [0xc000691360] [0xc000691400] [] 0xc0005b06e0}






    

export const WatchJobByJobCodeRequest = z.object({
        jobCode: z.string(),
});

export const WatchJobByJobCodeRequestRequired = z.object({
    jobCode: z.string(),
});
export type WatchJobByJobCodeRequestRequired = z.infer<typeof WatchJobByJobCodeRequestRequired>;








    

export const WatchJobByJobCodeResponse = z.object({
        job: z.optional(Job),
});

export const WatchJobByJobCodeResponseRequired = z.object({
    job: Job,
});
export type WatchJobByJobCodeResponseRequired = z.infer<typeof WatchJobByJobCodeResponseRequired>;


			// method {LastValidJobByJobCode map[] [] false false false false [0xc0006914a0] [0xc000691540] [] 0xc0005b06e0}






    

export const LastValidJobByJobCodeRequest = z.object({
        jobCode: z.string(),
});

export const LastValidJobByJobCodeRequestRequired = z.object({
    jobCode: z.string(),
});
export type LastValidJobByJobCodeRequestRequired = z.infer<typeof LastValidJobByJobCodeRequestRequired>;








    

export const LastValidJobByJobCodeResponse = z.object({
        job: Job,
});

export const LastValidJobByJobCodeResponseRequired = z.object({
    job: Job,
});
export type LastValidJobByJobCodeResponseRequired = z.infer<typeof LastValidJobByJobCodeResponseRequired>;


			// method {JobByJobCodeAsof map[] [] false false false false [0xc0006915e0 0xc000691680] [0xc000691720] [] 0xc0005b06e0}






    
    

export const JobByJobCodeAsofRequest = z.object({
        jobCode: z.string(),
        asof: z.string(),
});

export const JobByJobCodeAsofRequestRequired = z.object({
    jobCode: z.string(),
    asof: z.string(),
});
export type JobByJobCodeAsofRequestRequired = z.infer<typeof JobByJobCodeAsofRequestRequired>;








    

export const JobByJobCodeAsofResponse = z.object({
        job: z.optional(Job),
});

export const JobByJobCodeAsofResponseRequired = z.object({
    job: Job,
});
export type JobByJobCodeAsofResponseRequired = z.infer<typeof JobByJobCodeAsofResponseRequired>;


			// method {WatchJobByIntakeCode map[] [] false false false false [0xc0006917c0] [0xc000691860] [] 0xc0005b06e0}






    

export const WatchJobByIntakeCodeRequest = z.object({
        intakeCode: z.string(),
});

export const WatchJobByIntakeCodeRequestRequired = z.object({
    intakeCode: z.string(),
});
export type WatchJobByIntakeCodeRequestRequired = z.infer<typeof WatchJobByIntakeCodeRequestRequired>;








    

export const WatchJobByIntakeCodeResponse = z.object({
        job: z.optional(Job),
});

export const WatchJobByIntakeCodeResponseRequired = z.object({
    job: Job,
});
export type WatchJobByIntakeCodeResponseRequired = z.infer<typeof WatchJobByIntakeCodeResponseRequired>;


			// method {LastValidJobByIntakeCode map[] [] false false false false [0xc000691900] [0xc0006919a0] [] 0xc0005b06e0}






    

export const LastValidJobByIntakeCodeRequest = z.object({
        intakeCode: z.string(),
});

export const LastValidJobByIntakeCodeRequestRequired = z.object({
    intakeCode: z.string(),
});
export type LastValidJobByIntakeCodeRequestRequired = z.infer<typeof LastValidJobByIntakeCodeRequestRequired>;








    

export const LastValidJobByIntakeCodeResponse = z.object({
        job: Job,
});

export const LastValidJobByIntakeCodeResponseRequired = z.object({
    job: Job,
});
export type LastValidJobByIntakeCodeResponseRequired = z.infer<typeof LastValidJobByIntakeCodeResponseRequired>;


			// method {JobByIntakeCodeAsof map[] [] false false false false [0xc000691a40 0xc000691ae0] [0xc000691b80] [] 0xc0005b06e0}






    
    

export const JobByIntakeCodeAsofRequest = z.object({
        intakeCode: z.string(),
        asof: z.string(),
});

export const JobByIntakeCodeAsofRequestRequired = z.object({
    intakeCode: z.string(),
    asof: z.string(),
});
export type JobByIntakeCodeAsofRequestRequired = z.infer<typeof JobByIntakeCodeAsofRequestRequired>;








    

export const JobByIntakeCodeAsofResponse = z.object({
        job: z.optional(Job),
});

export const JobByIntakeCodeAsofResponseRequired = z.object({
    job: Job,
});
export type JobByIntakeCodeAsofResponseRequired = z.infer<typeof JobByIntakeCodeAsofResponseRequired>;


			// method {JobStampById map[] [] false false false false [0xc000691c20] [0xc000691cc0] [] 0xc0005b06e0}






    

export const JobStampByIdRequest = z.object({
        stampId: z.string(),
});

export const JobStampByIdRequestRequired = z.object({
    stampId: z.string(),
});
export type JobStampByIdRequestRequired = z.infer<typeof JobStampByIdRequestRequired>;








    

export const JobStampByIdResponse = z.object({
        stamp: JobStamp,
});

export const JobStampByIdResponseRequired = z.object({
    stamp: JobStamp,
});
export type JobStampByIdResponseRequired = z.infer<typeof JobStampByIdResponseRequired>;


			// method {LastFlavoredStampForJob map[] [] false false false false [0xc000691d60] [0xc000691e00] [] 0xc0005b06e0}






    

export const LastFlavoredStampForJobRequest = z.object({
        jobId: z.string(),
});

export const LastFlavoredStampForJobRequestRequired = z.object({
    jobId: z.string(),
});
export type LastFlavoredStampForJobRequestRequired = z.infer<typeof LastFlavoredStampForJobRequestRequired>;








    

export const LastFlavoredStampForJobResponse = z.object({
        stamp: z.optional(JobStamp),
});

export const LastFlavoredStampForJobResponseRequired = z.object({
    stamp: JobStamp,
});
export type LastFlavoredStampForJobResponseRequired = z.infer<typeof LastFlavoredStampForJobResponseRequired>;


			// method {WatchStampsForJob map[] [] false false false false [0xc000691ea0] [0xc000692050] [] 0xc0005b06e0}






    

export const WatchStampsForJobRequest = z.object({
        jobId: z.string(),
});

export const WatchStampsForJobRequestRequired = z.object({
    jobId: z.string(),
});
export type WatchStampsForJobRequestRequired = z.infer<typeof WatchStampsForJobRequestRequired>;








    

export const WatchStampsForJobResponse = z.object({
        stamps: JobStamp.array(),
});

export const WatchStampsForJobResponseRequired = z.object({
    stamps: JobStamp.array(),
});
export type WatchStampsForJobResponseRequired = z.infer<typeof WatchStampsForJobResponseRequired>;


			// method {WatchUnbundledWastesForJobAtVenue map[] [] false false false false [0xc0006920f0 0xc000692190] [0xc000692280] [] 0xc0005b06e0}






    
    

export const WatchUnbundledWastesForJobAtVenueRequest = z.object({
        jobId: z.string(),
        venueId: z.string(),
});

export const WatchUnbundledWastesForJobAtVenueRequestRequired = z.object({
    jobId: z.string(),
    venueId: z.string(),
});
export type WatchUnbundledWastesForJobAtVenueRequestRequired = z.infer<typeof WatchUnbundledWastesForJobAtVenueRequestRequired>;








    

export const WatchUnbundledWastesForJobAtVenueResponse = z.object({
        wastes: WasteStub.array(),
});

export const WatchUnbundledWastesForJobAtVenueResponseRequired = z.object({
    wastes: WasteStub.array(),
});
export type WatchUnbundledWastesForJobAtVenueResponseRequired = z.infer<typeof WatchUnbundledWastesForJobAtVenueResponseRequired>;


			// method {SurchargeFlavorById map[] [] false false false false [0xc000692320] [0xc0006923c0] [] 0xc0005b06e0}






    

export const SurchargeFlavorByIdRequest = z.object({
        surchargeFlavorId: z.string(),
});

export const SurchargeFlavorByIdRequestRequired = z.object({
    surchargeFlavorId: z.string(),
});
export type SurchargeFlavorByIdRequestRequired = z.infer<typeof SurchargeFlavorByIdRequestRequired>;








    

export const SurchargeFlavorByIdResponse = z.object({
        flavor: SurchargeFlavor,
});

export const SurchargeFlavorByIdResponseRequired = z.object({
    flavor: SurchargeFlavor,
});
export type SurchargeFlavorByIdResponseRequired = z.infer<typeof SurchargeFlavorByIdResponseRequired>;


			// method {SurchargeFlavorByCode map[] [] false false false false [0xc000692460] [0xc000692500] [] 0xc0005b06e0}






    

export const SurchargeFlavorByCodeRequest = z.object({
        code: z.string(),
});

export const SurchargeFlavorByCodeRequestRequired = z.object({
    code: z.string(),
});
export type SurchargeFlavorByCodeRequestRequired = z.infer<typeof SurchargeFlavorByCodeRequestRequired>;








    

export const SurchargeFlavorByCodeResponse = z.object({
        flavor: z.optional(SurchargeFlavor),
});

export const SurchargeFlavorByCodeResponseRequired = z.object({
    flavor: SurchargeFlavor,
});
export type SurchargeFlavorByCodeResponseRequired = z.infer<typeof SurchargeFlavorByCodeResponseRequired>;


			// method {WatchSurchargesForSubject map[] [] false false false false [0xc0006925a0 0xc000692640] [0xc000692730] [] 0xc0005b06e0}






    
    

export const WatchSurchargesForSubjectRequest = z.object({
        subjectClass: SurchargeableClassname,
        subjectId: z.string(),
});

export const WatchSurchargesForSubjectRequestRequired = z.object({
    subjectClass: SurchargeableClassname,
    subjectId: z.string(),
});
export type WatchSurchargesForSubjectRequestRequired = z.infer<typeof WatchSurchargesForSubjectRequestRequired>;








    

export const WatchSurchargesForSubjectResponse = z.object({
        surcharges: Surcharge.array(),
});

export const WatchSurchargesForSubjectResponseRequired = z.object({
    surcharges: Surcharge.array(),
});
export type WatchSurchargesForSubjectResponseRequired = z.infer<typeof WatchSurchargesForSubjectResponseRequired>;


			// method {WatchSurchargeById map[] [] false false false false [0xc0006927d0 0xc000692870] [0xc000692910] [] 0xc0005b06e0}






    
    

export const WatchSurchargeByIdRequest = z.object({
        subjectClass: SurchargeableClassname,
        surchargeId: z.string(),
});

export const WatchSurchargeByIdRequestRequired = z.object({
    subjectClass: SurchargeableClassname,
    surchargeId: z.string(),
});
export type WatchSurchargeByIdRequestRequired = z.infer<typeof WatchSurchargeByIdRequestRequired>;








    

export const WatchSurchargeByIdResponse = z.object({
        surcharge: z.optional(Surcharge),
});

export const WatchSurchargeByIdResponseRequired = z.object({
    surcharge: Surcharge,
});
export type WatchSurchargeByIdResponseRequired = z.infer<typeof WatchSurchargeByIdResponseRequired>;


			// method {LastValidSurchargeById map[] [] false false false false [0xc0006929b0 0xc000692a50] [0xc000692af0] [] 0xc0005b06e0}






    
    

export const LastValidSurchargeByIdRequest = z.object({
        subjectClass: SurchargeableClassname,
        surchargeId: z.string(),
});

export const LastValidSurchargeByIdRequestRequired = z.object({
    subjectClass: SurchargeableClassname,
    surchargeId: z.string(),
});
export type LastValidSurchargeByIdRequestRequired = z.infer<typeof LastValidSurchargeByIdRequestRequired>;








    

export const LastValidSurchargeByIdResponse = z.object({
        surcharge: Surcharge,
});

export const LastValidSurchargeByIdResponseRequired = z.object({
    surcharge: Surcharge,
});
export type LastValidSurchargeByIdResponseRequired = z.infer<typeof LastValidSurchargeByIdResponseRequired>;


			// method {SurchargeByIdAsof map[] [] false false false false [0xc000692b90 0xc000692c30 0xc000692cd0] [0xc000692d70] [] 0xc0005b06e0}






    
    
    

export const SurchargeByIdAsofRequest = z.object({
        subjectClass: SurchargeableClassname,
        surchargeId: z.string(),
        asof: z.string(),
});

export const SurchargeByIdAsofRequestRequired = z.object({
    subjectClass: SurchargeableClassname,
    surchargeId: z.string(),
    asof: z.string(),
});
export type SurchargeByIdAsofRequestRequired = z.infer<typeof SurchargeByIdAsofRequestRequired>;








    

export const SurchargeByIdAsofResponse = z.object({
        surcharge: z.optional(Surcharge),
});

export const SurchargeByIdAsofResponseRequired = z.object({
    surcharge: Surcharge,
});
export type SurchargeByIdAsofResponseRequired = z.infer<typeof SurchargeByIdAsofResponseRequired>;


			// method {AllSurchargeRevisions map[] [] false false false false [0xc000692e10 0xc000692eb0] [0xc000692fa0] [] 0xc0005b06e0}






    
    

export const AllSurchargeRevisionsRequest = z.object({
        subjectClass: SurchargeableClassname,
        surchargeId: z.string(),
});

export const AllSurchargeRevisionsRequestRequired = z.object({
    subjectClass: SurchargeableClassname,
    surchargeId: z.string(),
});
export type AllSurchargeRevisionsRequestRequired = z.infer<typeof AllSurchargeRevisionsRequestRequired>;








    

export const AllSurchargeRevisionsResponse = z.object({
        revisions: Surcharge.array(),
});

export const AllSurchargeRevisionsResponseRequired = z.object({
    revisions: Surcharge.array(),
});
export type AllSurchargeRevisionsResponseRequired = z.infer<typeof AllSurchargeRevisionsResponseRequired>;


			// method {WatchBundleById map[] [] false false false false [0xc000693040] [0xc0006930e0] [] 0xc0005b06e0}






    

export const WatchBundleByIdRequest = z.object({
        bundleId: z.string(),
});

export const WatchBundleByIdRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchBundleByIdRequestRequired = z.infer<typeof WatchBundleByIdRequestRequired>;








    

export const WatchBundleByIdResponse = z.object({
        bundle: z.optional(Bundle),
});

export const WatchBundleByIdResponseRequired = z.object({
    bundle: Bundle,
});
export type WatchBundleByIdResponseRequired = z.infer<typeof WatchBundleByIdResponseRequired>;


			// method {LastValidBundleById map[] [] false false false false [0xc000693180] [0xc000693220] [] 0xc0005b06e0}






    

export const LastValidBundleByIdRequest = z.object({
        bundleId: z.string(),
});

export const LastValidBundleByIdRequestRequired = z.object({
    bundleId: z.string(),
});
export type LastValidBundleByIdRequestRequired = z.infer<typeof LastValidBundleByIdRequestRequired>;








    

export const LastValidBundleByIdResponse = z.object({
        bundle: Bundle,
});

export const LastValidBundleByIdResponseRequired = z.object({
    bundle: Bundle,
});
export type LastValidBundleByIdResponseRequired = z.infer<typeof LastValidBundleByIdResponseRequired>;


			// method {BundleByIdAsof map[] [] false false false false [0xc0006932c0 0xc000693360] [0xc000693400] [] 0xc0005b06e0}






    
    

export const BundleByIdAsofRequest = z.object({
        bundleId: z.string(),
        asof: z.string(),
});

export const BundleByIdAsofRequestRequired = z.object({
    bundleId: z.string(),
    asof: z.string(),
});
export type BundleByIdAsofRequestRequired = z.infer<typeof BundleByIdAsofRequestRequired>;








    

export const BundleByIdAsofResponse = z.object({
        bundle: z.optional(Bundle),
});

export const BundleByIdAsofResponseRequired = z.object({
    bundle: Bundle,
});
export type BundleByIdAsofResponseRequired = z.infer<typeof BundleByIdAsofResponseRequired>;


			// method {BundleRevisionCount map[] [] false false false false [0xc0006934a0] [0xc000693540] [] 0xc0005b06e0}






    

export const BundleRevisionCountRequest = z.object({
        bundleId: z.string(),
});

export const BundleRevisionCountRequestRequired = z.object({
    bundleId: z.string(),
});
export type BundleRevisionCountRequestRequired = z.infer<typeof BundleRevisionCountRequestRequired>;








    

export const BundleRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const BundleRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type BundleRevisionCountResponseRequired = z.infer<typeof BundleRevisionCountResponseRequired>;


			// method {AllBundleRevisions map[] [] false false false false [0xc0006935e0] [0xc0006936d0] [] 0xc0005b06e0}






    

export const AllBundleRevisionsRequest = z.object({
        bundleId: z.string(),
});

export const AllBundleRevisionsRequestRequired = z.object({
    bundleId: z.string(),
});
export type AllBundleRevisionsRequestRequired = z.infer<typeof AllBundleRevisionsRequestRequired>;








    

export const AllBundleRevisionsResponse = z.object({
        revisions: Bundle.array(),
});

export const AllBundleRevisionsResponseRequired = z.object({
    revisions: Bundle.array(),
});
export type AllBundleRevisionsResponseRequired = z.infer<typeof AllBundleRevisionsResponseRequired>;


			// method {WatchBundleLocation map[] [] false false false false [0xc000693770] [0xc000693810] [] 0xc0005b06e0}






    

export const WatchBundleLocationRequest = z.object({
        bundleId: z.string(),
});

export const WatchBundleLocationRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchBundleLocationRequestRequired = z.infer<typeof WatchBundleLocationRequestRequired>;








    

export const WatchBundleLocationResponse = z.object({
        curloc: TruckOrVenueStub,
});

export const WatchBundleLocationResponseRequired = z.object({
    curloc: TruckOrVenueStub,
});
export type WatchBundleLocationResponseRequired = z.infer<typeof WatchBundleLocationResponseRequired>;


			// method {WatchOrphanedBundles map[] [] false false false false [] [0xc000693900] [] 0xc0005b06e0}






    

export const WatchOrphanedBundlesResponse = z.object({
        orphans: BundleStub.array(),
});

export const WatchOrphanedBundlesResponseRequired = z.object({
    orphans: BundleStub.array(),
});
export type WatchOrphanedBundlesResponseRequired = z.infer<typeof WatchOrphanedBundlesResponseRequired>;


			// method {ActiveBundleCount map[] [] false false false false [] [0xc0006939a0] [] 0xc0005b06e0}






    

export const ActiveBundleCountResponse = z.object({
        bundleCount: z.number(),
});

export const ActiveBundleCountResponseRequired = z.object({
    bundleCount: z.number(),
});
export type ActiveBundleCountResponseRequired = z.infer<typeof ActiveBundleCountResponseRequired>;


			// method {WatchActiveBundles map[] [] false false false false [] [0xc000693a90] [] 0xc0005b06e0}






    

export const WatchActiveBundlesResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchActiveBundlesResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchActiveBundlesResponseRequired = z.infer<typeof WatchActiveBundlesResponseRequired>;


			// method {ActiveBundlePage map[] [] false false false false [0xc000693b30] [0xc000693c20] [] 0xc0005b06e0}






    

export const ActiveBundlePageRequest = z.object({
        offset: z.number(),
});

export const ActiveBundlePageRequestRequired = z.object({
    offset: z.number(),
});
export type ActiveBundlePageRequestRequired = z.infer<typeof ActiveBundlePageRequestRequired>;








    

export const ActiveBundlePageResponse = z.object({
        bundles: BundleStub.array(),
});

export const ActiveBundlePageResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type ActiveBundlePageResponseRequired = z.infer<typeof ActiveBundlePageResponseRequired>;


			// method {WatchActiveBundlesDestinedFor map[] [] false false false false [0xc000693cc0] [0xc000693db0] [] 0xc0005b06e0}






    

export const WatchActiveBundlesDestinedForRequest = z.object({
        venueId: z.string(),
});

export const WatchActiveBundlesDestinedForRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchActiveBundlesDestinedForRequestRequired = z.infer<typeof WatchActiveBundlesDestinedForRequestRequired>;








    

export const WatchActiveBundlesDestinedForResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchActiveBundlesDestinedForResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchActiveBundlesDestinedForResponseRequired = z.infer<typeof WatchActiveBundlesDestinedForResponseRequired>;


			// method {WatchActiveBundlesOriginatingAt map[] [] false false false false [0xc000693e50] [0xc000698000] [] 0xc0005b06e0}






    

export const WatchActiveBundlesOriginatingAtRequest = z.object({
        venueId: z.string(),
});

export const WatchActiveBundlesOriginatingAtRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchActiveBundlesOriginatingAtRequestRequired = z.infer<typeof WatchActiveBundlesOriginatingAtRequestRequired>;








    

export const WatchActiveBundlesOriginatingAtResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchActiveBundlesOriginatingAtResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchActiveBundlesOriginatingAtResponseRequired = z.infer<typeof WatchActiveBundlesOriginatingAtResponseRequired>;


			// method {WatchExportableBundles map[] [] false false false false [] [0xc0006980f0] [] 0xc0005b06e0}






    

export const WatchExportableBundlesResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchExportableBundlesResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchExportableBundlesResponseRequired = z.infer<typeof WatchExportableBundlesResponseRequired>;


			// method {WatchInspectableBundles map[] [] false false false false [0xc000698190] [0xc000698280] [] 0xc0005b06e0}






    

export const WatchInspectableBundlesRequest = z.object({
        venueId: z.string(),
});

export const WatchInspectableBundlesRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchInspectableBundlesRequestRequired = z.infer<typeof WatchInspectableBundlesRequestRequired>;








    

export const WatchInspectableBundlesResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchInspectableBundlesResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchInspectableBundlesResponseRequired = z.infer<typeof WatchInspectableBundlesResponseRequired>;


			// method {WatchBundlesNeedingSupervisor map[] [] false false false false [0xc000698320] [0xc000698410] [] 0xc0005b06e0}






    

export const WatchBundlesNeedingSupervisorRequest = z.object({
        venueId: z.string(),
});

export const WatchBundlesNeedingSupervisorRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchBundlesNeedingSupervisorRequestRequired = z.infer<typeof WatchBundlesNeedingSupervisorRequestRequired>;








    

export const WatchBundlesNeedingSupervisorResponse = z.object({
        bundles: BundleStub.array(),
});

export const WatchBundlesNeedingSupervisorResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type WatchBundlesNeedingSupervisorResponseRequired = z.infer<typeof WatchBundlesNeedingSupervisorResponseRequired>;


			// method {ShowExportedBundle map[] [] false false false false [0xc0006984b0] [0xc000698550] [] 0xc0005b06e0}






    

export const ShowExportedBundleRequest = z.object({
        bundleId: z.string(),
});

export const ShowExportedBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type ShowExportedBundleRequestRequired = z.infer<typeof ShowExportedBundleRequestRequired>;








    

export const ShowExportedBundleResponse = z.object({
        exported: z.string(),
});

export const ShowExportedBundleResponseRequired = z.object({
    exported: z.string(),
});
export type ShowExportedBundleResponseRequired = z.infer<typeof ShowExportedBundleResponseRequired>;


			// method {CompleteBundleHistoryById map[] [] false false false false [0xc0006985f0] [0xc000698690] [] 0xc0005b06e0}






    

export const CompleteBundleHistoryByIdRequest = z.object({
        bundleId: z.string(),
});

export const CompleteBundleHistoryByIdRequestRequired = z.object({
    bundleId: z.string(),
});
export type CompleteBundleHistoryByIdRequestRequired = z.infer<typeof CompleteBundleHistoryByIdRequestRequired>;








    

export const CompleteBundleHistoryByIdResponse = z.object({
        history: CompleteBundleHistory,
});

export const CompleteBundleHistoryByIdResponseRequired = z.object({
    history: CompleteBundleHistory,
});
export type CompleteBundleHistoryByIdResponseRequired = z.infer<typeof CompleteBundleHistoryByIdResponseRequired>;


			// method {BundleStampById map[] [] false false false false [0xc000698730] [0xc0006987d0] [] 0xc0005b06e0}






    

export const BundleStampByIdRequest = z.object({
        stampId: z.string(),
});

export const BundleStampByIdRequestRequired = z.object({
    stampId: z.string(),
});
export type BundleStampByIdRequestRequired = z.infer<typeof BundleStampByIdRequestRequired>;








    

export const BundleStampByIdResponse = z.object({
        stamp: z.optional(BundleStamp),
});

export const BundleStampByIdResponseRequired = z.object({
    stamp: BundleStamp,
});
export type BundleStampByIdResponseRequired = z.infer<typeof BundleStampByIdResponseRequired>;


			// method {LastFlavoredStampForBundle map[] [] false false false false [0xc000698870] [0xc000698910] [] 0xc0005b06e0}






    

export const LastFlavoredStampForBundleRequest = z.object({
        bundleId: z.string(),
});

export const LastFlavoredStampForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type LastFlavoredStampForBundleRequestRequired = z.infer<typeof LastFlavoredStampForBundleRequestRequired>;








    

export const LastFlavoredStampForBundleResponse = z.object({
        stamp: z.optional(BundleStamp),
});

export const LastFlavoredStampForBundleResponseRequired = z.object({
    stamp: BundleStamp,
});
export type LastFlavoredStampForBundleResponseRequired = z.infer<typeof LastFlavoredStampForBundleResponseRequired>;


			// method {WatchStampsForBundle map[] [] false false false false [0xc0006989b0] [0xc000698aa0] [] 0xc0005b06e0}






    

export const WatchStampsForBundleRequest = z.object({
        bundleId: z.string(),
});

export const WatchStampsForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchStampsForBundleRequestRequired = z.infer<typeof WatchStampsForBundleRequestRequired>;








    

export const WatchStampsForBundleResponse = z.object({
        stamps: BundleStamp.array(),
});

export const WatchStampsForBundleResponseRequired = z.object({
    stamps: BundleStamp.array(),
});
export type WatchStampsForBundleResponseRequired = z.infer<typeof WatchStampsForBundleResponseRequired>;


			// method {WatchFlavoredStampsForBundle map[] [] false false false false [0xc000698b40] [0xc000698c30] [] 0xc0005b06e0}






    

export const WatchFlavoredStampsForBundleRequest = z.object({
        bundleId: z.string(),
});

export const WatchFlavoredStampsForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchFlavoredStampsForBundleRequestRequired = z.infer<typeof WatchFlavoredStampsForBundleRequestRequired>;








    

export const WatchFlavoredStampsForBundleResponse = z.object({
        stamps: BundleStamp.array(),
});

export const WatchFlavoredStampsForBundleResponseRequired = z.object({
    stamps: BundleStamp.array(),
});
export type WatchFlavoredStampsForBundleResponseRequired = z.infer<typeof WatchFlavoredStampsForBundleResponseRequired>;


			// method {WatchTransferById map[] [] false false false false [0xc000698cd0] [0xc000698d70] [] 0xc0005b06e0}






    

export const WatchTransferByIdRequest = z.object({
        transferId: z.string(),
});

export const WatchTransferByIdRequestRequired = z.object({
    transferId: z.string(),
});
export type WatchTransferByIdRequestRequired = z.infer<typeof WatchTransferByIdRequestRequired>;








    

export const WatchTransferByIdResponse = z.object({
        transfer: Transfer,
});

export const WatchTransferByIdResponseRequired = z.object({
    transfer: Transfer,
});
export type WatchTransferByIdResponseRequired = z.infer<typeof WatchTransferByIdResponseRequired>;


			// method {WatchAllTransfers map[] [when initially called, returns all transfers that overlap "today"] false false false false [] [0xc000698e60] [] 0xc0005b06e0}






    

export const WatchAllTransfersResponse = z.object({
        transfers: TransferStub.array(),
});

export const WatchAllTransfersResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type WatchAllTransfersResponseRequired = z.infer<typeof WatchAllTransfersResponseRequired>;


			// method {WatchOpenTransfersForTruck map[] [] false false false false [0xc000698f00] [0xc000698ff0] [] 0xc0005b06e0}






    

export const WatchOpenTransfersForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchOpenTransfersForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchOpenTransfersForTruckRequestRequired = z.infer<typeof WatchOpenTransfersForTruckRequestRequired>;








    

export const WatchOpenTransfersForTruckResponse = z.object({
        transfers: TransferStub.array(),
});

export const WatchOpenTransfersForTruckResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type WatchOpenTransfersForTruckResponseRequired = z.infer<typeof WatchOpenTransfersForTruckResponseRequired>;


			// method {WatchTransfersForTruck map[] [] false false false false [0xc000699090] [0xc000699180] [] 0xc0005b06e0}






    

export const WatchTransfersForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchTransfersForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchTransfersForTruckRequestRequired = z.infer<typeof WatchTransfersForTruckRequestRequired>;








    

export const WatchTransfersForTruckResponse = z.object({
        transfers: TransferStub.array(),
});

export const WatchTransfersForTruckResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type WatchTransfersForTruckResponseRequired = z.infer<typeof WatchTransfersForTruckResponseRequired>;


			// method {WatchLastTransferForBundle map[] [] false false false false [0xc000699220] [0xc0006992c0] [] 0xc0005b06e0}






    

export const WatchLastTransferForBundleRequest = z.object({
        bundleId: z.string(),
});

export const WatchLastTransferForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchLastTransferForBundleRequestRequired = z.infer<typeof WatchLastTransferForBundleRequestRequired>;








    

export const WatchLastTransferForBundleResponse = z.object({
        transfer: z.optional(Transfer),
});

export const WatchLastTransferForBundleResponseRequired = z.object({
    transfer: Transfer,
});
export type WatchLastTransferForBundleResponseRequired = z.infer<typeof WatchLastTransferForBundleResponseRequired>;


			// method {LastTransferForBundleBefore map[] [] false false false false [0xc000699360 0xc000699400] [0xc0006994a0] [] 0xc0005b06e0}






    
    

export const LastTransferForBundleBeforeRequest = z.object({
        bundleId: z.string(),
        before: z.string(),
});

export const LastTransferForBundleBeforeRequestRequired = z.object({
    bundleId: z.string(),
    before: z.string(),
});
export type LastTransferForBundleBeforeRequestRequired = z.infer<typeof LastTransferForBundleBeforeRequestRequired>;








    

export const LastTransferForBundleBeforeResponse = z.object({
        transfer: z.optional(Transfer),
});

export const LastTransferForBundleBeforeResponseRequired = z.object({
    transfer: Transfer,
});
export type LastTransferForBundleBeforeResponseRequired = z.infer<typeof LastTransferForBundleBeforeResponseRequired>;


			// method {AllTransfersForBundle map[] [] false false false false [0xc000699540] [0xc000699630] [] 0xc0005b06e0}






    

export const AllTransfersForBundleRequest = z.object({
        bundleId: z.string(),
});

export const AllTransfersForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type AllTransfersForBundleRequestRequired = z.infer<typeof AllTransfersForBundleRequestRequired>;








    

export const AllTransfersForBundleResponse = z.object({
        transfers: TransferStub.array(),
});

export const AllTransfersForBundleResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type AllTransfersForBundleResponseRequired = z.infer<typeof AllTransfersForBundleResponseRequired>;


			// method {TransfersForTruckDuring map[] [] false false false false [0xc0006996d0 0xc000699770] [0xc000699860] [] 0xc0005b06e0}






    
    

export const TransfersForTruckDuringRequest = z.object({
        truckId: z.string(),
        during: z.string(),
});

export const TransfersForTruckDuringRequestRequired = z.object({
    truckId: z.string(),
    during: z.string(),
});
export type TransfersForTruckDuringRequestRequired = z.infer<typeof TransfersForTruckDuringRequestRequired>;








    

export const TransfersForTruckDuringResponse = z.object({
        transfers: TransferStub.array(),
});

export const TransfersForTruckDuringResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type TransfersForTruckDuringResponseRequired = z.infer<typeof TransfersForTruckDuringResponseRequired>;


			// method {WatchTransfersAtVenue map[] [] false false false false [0xc000699900] [0xc0006999f0] [] 0xc0005b06e0}






    

export const WatchTransfersAtVenueRequest = z.object({
        venueId: z.string(),
});

export const WatchTransfersAtVenueRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchTransfersAtVenueRequestRequired = z.infer<typeof WatchTransfersAtVenueRequestRequired>;








    

export const WatchTransfersAtVenueResponse = z.object({
        transfers: TransferStub.array(),
});

export const WatchTransfersAtVenueResponseRequired = z.object({
    transfers: TransferStub.array(),
});
export type WatchTransfersAtVenueResponseRequired = z.infer<typeof WatchTransfersAtVenueResponseRequired>;


			// method {WatchTriplegById map[] [] false false false false [0xc000699a90] [0xc000699b30] [] 0xc0005b06e0}






    

export const WatchTriplegByIdRequest = z.object({
        triplegId: z.string(),
});

export const WatchTriplegByIdRequestRequired = z.object({
    triplegId: z.string(),
});
export type WatchTriplegByIdRequestRequired = z.infer<typeof WatchTriplegByIdRequestRequired>;








    

export const WatchTriplegByIdResponse = z.object({
        tripleg: Tripleg,
});

export const WatchTriplegByIdResponseRequired = z.object({
    tripleg: Tripleg,
});
export type WatchTriplegByIdResponseRequired = z.infer<typeof WatchTriplegByIdResponseRequired>;


			// method {WatchAllTriplegs map[] [when initially called, returns all triplegs that overlap "today"] false false false false [] [0xc000699c20] [] 0xc0005b06e0}






    

export const WatchAllTriplegsResponse = z.object({
        triplegs: TriplegStub.array(),
});

export const WatchAllTriplegsResponseRequired = z.object({
    triplegs: TriplegStub.array(),
});
export type WatchAllTriplegsResponseRequired = z.infer<typeof WatchAllTriplegsResponseRequired>;


			// method {WatchOpenTriplegForTruck map[] [] false false false false [0xc000699cc0] [0xc000699d60] [] 0xc0005b06e0}






    

export const WatchOpenTriplegForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchOpenTriplegForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchOpenTriplegForTruckRequestRequired = z.infer<typeof WatchOpenTriplegForTruckRequestRequired>;








    

export const WatchOpenTriplegForTruckResponse = z.object({
        tripleg: z.optional(Tripleg),
});

export const WatchOpenTriplegForTruckResponseRequired = z.object({
    tripleg: Tripleg,
});
export type WatchOpenTriplegForTruckResponseRequired = z.infer<typeof WatchOpenTriplegForTruckResponseRequired>;


			// method {WatchLastTriplegForTruck map[] [] false false false false [0xc000699e00] [0xc000699ea0] [] 0xc0005b06e0}






    

export const WatchLastTriplegForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchLastTriplegForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchLastTriplegForTruckRequestRequired = z.infer<typeof WatchLastTriplegForTruckRequestRequired>;








    

export const WatchLastTriplegForTruckResponse = z.object({
        tripleg: z.optional(Tripleg),
});

export const WatchLastTriplegForTruckResponseRequired = z.object({
    tripleg: Tripleg,
});
export type WatchLastTriplegForTruckResponseRequired = z.infer<typeof WatchLastTriplegForTruckResponseRequired>;


			// method {WatchTriplegsForTruck map[] [] false false false false [0xc00069a000] [0xc00069a0f0] [] 0xc0005b06e0}






    

export const WatchTriplegsForTruckRequest = z.object({
        truckId: z.string(),
});

export const WatchTriplegsForTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type WatchTriplegsForTruckRequestRequired = z.infer<typeof WatchTriplegsForTruckRequestRequired>;








    

export const WatchTriplegsForTruckResponse = z.object({
        triplegs: TriplegStub.array(),
});

export const WatchTriplegsForTruckResponseRequired = z.object({
    triplegs: TriplegStub.array(),
});
export type WatchTriplegsForTruckResponseRequired = z.infer<typeof WatchTriplegsForTruckResponseRequired>;


			// method {TriplegsForTruckDuring map[] [] false false false false [0xc00069a190 0xc00069a230] [0xc00069a320] [] 0xc0005b06e0}






    
    

export const TriplegsForTruckDuringRequest = z.object({
        truckId: z.string(),
        during: z.string(),
});

export const TriplegsForTruckDuringRequestRequired = z.object({
    truckId: z.string(),
    during: z.string(),
});
export type TriplegsForTruckDuringRequestRequired = z.infer<typeof TriplegsForTruckDuringRequestRequired>;








    

export const TriplegsForTruckDuringResponse = z.object({
        triplegs: TriplegStub.array(),
});

export const TriplegsForTruckDuringResponseRequired = z.object({
    triplegs: TriplegStub.array(),
});
export type TriplegsForTruckDuringResponseRequired = z.infer<typeof TriplegsForTruckDuringResponseRequired>;


			// method {WatchUnadmittedTriplegsInto map[] [] false false false false [0xc00069a3c0] [0xc00069a4b0] [] 0xc0005b06e0}






    

export const WatchUnadmittedTriplegsIntoRequest = z.object({
        venueId: z.string(),
});

export const WatchUnadmittedTriplegsIntoRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchUnadmittedTriplegsIntoRequestRequired = z.infer<typeof WatchUnadmittedTriplegsIntoRequestRequired>;








    

export const WatchUnadmittedTriplegsIntoResponse = z.object({
        triplegs: TriplegStub.array(),
});

export const WatchUnadmittedTriplegsIntoResponseRequired = z.object({
    triplegs: TriplegStub.array(),
});
export type WatchUnadmittedTriplegsIntoResponseRequired = z.infer<typeof WatchUnadmittedTriplegsIntoResponseRequired>;


			// method {WatchTriplegsInboundTo map[] [] false false false false [0xc00069a550] [0xc00069a640] [] 0xc0005b06e0}






    

export const WatchTriplegsInboundToRequest = z.object({
        venueId: z.string(),
});

export const WatchTriplegsInboundToRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchTriplegsInboundToRequestRequired = z.infer<typeof WatchTriplegsInboundToRequestRequired>;








    

export const WatchTriplegsInboundToResponse = z.object({
        triplegs: TriplegStub.array(),
});

export const WatchTriplegsInboundToResponseRequired = z.object({
    triplegs: TriplegStub.array(),
});
export type WatchTriplegsInboundToResponseRequired = z.infer<typeof WatchTriplegsInboundToResponseRequired>;


			// method {WatchScheduledTransferById map[] [] false false false false [0xc00069a6e0] [0xc00069a780] [] 0xc0005b06e0}






    

export const WatchScheduledTransferByIdRequest = z.object({
        scheduledTransferId: z.string(),
});

export const WatchScheduledTransferByIdRequestRequired = z.object({
    scheduledTransferId: z.string(),
});
export type WatchScheduledTransferByIdRequestRequired = z.infer<typeof WatchScheduledTransferByIdRequestRequired>;








    

export const WatchScheduledTransferByIdResponse = z.object({
        scheduledTransfer: z.optional(ScheduledTransfer),
});

export const WatchScheduledTransferByIdResponseRequired = z.object({
    scheduledTransfer: ScheduledTransfer,
});
export type WatchScheduledTransferByIdResponseRequired = z.infer<typeof WatchScheduledTransferByIdResponseRequired>;


			// method {WatchScheduledTransferForBundle map[] [] false false false false [0xc00069a820] [0xc00069a8c0] [] 0xc0005b06e0}






    

export const WatchScheduledTransferForBundleRequest = z.object({
        bundleId: z.string(),
});

export const WatchScheduledTransferForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchScheduledTransferForBundleRequestRequired = z.infer<typeof WatchScheduledTransferForBundleRequestRequired>;








    

export const WatchScheduledTransferForBundleResponse = z.object({
        scheduledTransfer: z.optional(ScheduledTransfer),
});

export const WatchScheduledTransferForBundleResponseRequired = z.object({
    scheduledTransfer: ScheduledTransfer,
});
export type WatchScheduledTransferForBundleResponseRequired = z.infer<typeof WatchScheduledTransferForBundleResponseRequired>;


			// method {WatchScheduledTransfersForDriver map[] [use an empty string to watch unassigned scheduled transfers] false false false false [0xc00069a960] [0xc00069aa50] [] 0xc0005b06e0}






    

export const WatchScheduledTransfersForDriverRequest = z.object({
        driverId: z.string(),
});

export const WatchScheduledTransfersForDriverRequestRequired = z.object({
    driverId: z.string(),
});
export type WatchScheduledTransfersForDriverRequestRequired = z.infer<typeof WatchScheduledTransfersForDriverRequestRequired>;








    

export const WatchScheduledTransfersForDriverResponse = z.object({
        scheduledTransfers: ScheduledTransferStub.array(),
});

export const WatchScheduledTransfersForDriverResponseRequired = z.object({
    scheduledTransfers: ScheduledTransferStub.array(),
});
export type WatchScheduledTransfersForDriverResponseRequired = z.infer<typeof WatchScheduledTransfersForDriverResponseRequired>;


			// method {WatchScheduledTransfersAwaitingTruck map[] [] false false false false [0xc00069aaf0 0xc00069ab90] [0xc00069ac80] [] 0xc0005b06e0}






    
    

export const WatchScheduledTransfersAwaitingTruckRequest = z.object({
        truckId: z.string(),
        venueId: z.string(),
});

export const WatchScheduledTransfersAwaitingTruckRequestRequired = z.object({
    truckId: z.string(),
    venueId: z.string(),
});
export type WatchScheduledTransfersAwaitingTruckRequestRequired = z.infer<typeof WatchScheduledTransfersAwaitingTruckRequestRequired>;








    

export const WatchScheduledTransfersAwaitingTruckResponse = z.object({
        scheduledTransfers: ScheduledTransferStub.array(),
});

export const WatchScheduledTransfersAwaitingTruckResponseRequired = z.object({
    scheduledTransfers: ScheduledTransferStub.array(),
});
export type WatchScheduledTransfersAwaitingTruckResponseRequired = z.infer<typeof WatchScheduledTransfersAwaitingTruckResponseRequired>;


			// method {ScheduledTransfersDuring map[] [] false false false false [0xc00069ad20] [0xc00069ae10] [] 0xc0005b06e0}






    

export const ScheduledTransfersDuringRequest = z.object({
        during: z.string(),
});

export const ScheduledTransfersDuringRequestRequired = z.object({
    during: z.string(),
});
export type ScheduledTransfersDuringRequestRequired = z.infer<typeof ScheduledTransfersDuringRequestRequired>;








    

export const ScheduledTransfersDuringResponse = z.object({
        scheduledTransfers: ScheduledTransferStub.array(),
});

export const ScheduledTransfersDuringResponseRequired = z.object({
    scheduledTransfers: ScheduledTransferStub.array(),
});
export type ScheduledTransfersDuringResponseRequired = z.infer<typeof ScheduledTransfersDuringResponseRequired>;


			// method {WatchScheduledTransfersAt map[] [] false false false false [0xc00069aeb0] [0xc00069afa0] [] 0xc0005b06e0}






    

export const WatchScheduledTransfersAtRequest = z.object({
        venueId: z.string(),
});

export const WatchScheduledTransfersAtRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchScheduledTransfersAtRequestRequired = z.infer<typeof WatchScheduledTransfersAtRequestRequired>;








    

export const WatchScheduledTransfersAtResponse = z.object({
        scheduledTransfers: ScheduledTransferStub.array(),
});

export const WatchScheduledTransfersAtResponseRequired = z.object({
    scheduledTransfers: ScheduledTransferStub.array(),
});
export type WatchScheduledTransfersAtResponseRequired = z.infer<typeof WatchScheduledTransfersAtResponseRequired>;


			// method {WatchScheduledTransfersForDispatch map[] [] false false false false [] [0xc00069b090] [] 0xc0005b06e0}






    

export const WatchScheduledTransfersForDispatchResponse = z.object({
        scheduledTransfers: ScheduledTransferStub.array(),
});

export const WatchScheduledTransfersForDispatchResponseRequired = z.object({
    scheduledTransfers: ScheduledTransferStub.array(),
});
export type WatchScheduledTransfersForDispatchResponseRequired = z.infer<typeof WatchScheduledTransfersForDispatchResponseRequired>;


			// method {WasteFlavorByCode map[] [] false false false false [0xc00069b130] [0xc00069b1d0] [] 0xc0005b06e0}






    

export const WasteFlavorByCodeRequest = z.object({
        code: z.string(),
});

export const WasteFlavorByCodeRequestRequired = z.object({
    code: z.string(),
});
export type WasteFlavorByCodeRequestRequired = z.infer<typeof WasteFlavorByCodeRequestRequired>;








    

export const WasteFlavorByCodeResponse = z.object({
        flavor: z.optional(WasteFlavor),
});

export const WasteFlavorByCodeResponseRequired = z.object({
    flavor: WasteFlavor,
});
export type WasteFlavorByCodeResponseRequired = z.infer<typeof WasteFlavorByCodeResponseRequired>;


			// method {WatchWasteFlavorById map[] [] false false false false [0xc00069b270] [0xc00069b310] [] 0xc0005b06e0}






    

export const WatchWasteFlavorByIdRequest = z.object({
        wasteFlavorId: z.string(),
});

export const WatchWasteFlavorByIdRequestRequired = z.object({
    wasteFlavorId: z.string(),
});
export type WatchWasteFlavorByIdRequestRequired = z.infer<typeof WatchWasteFlavorByIdRequestRequired>;








    

export const WatchWasteFlavorByIdResponse = z.object({
        flavor: WasteFlavor,
});

export const WatchWasteFlavorByIdResponseRequired = z.object({
    flavor: WasteFlavor,
});
export type WatchWasteFlavorByIdResponseRequired = z.infer<typeof WatchWasteFlavorByIdResponseRequired>;


			// method {LastValidWasteFlavorById map[] [] false false false false [0xc00069b3b0] [0xc00069b450] [] 0xc0005b06e0}






    

export const LastValidWasteFlavorByIdRequest = z.object({
        wasteFlavorId: z.string(),
});

export const LastValidWasteFlavorByIdRequestRequired = z.object({
    wasteFlavorId: z.string(),
});
export type LastValidWasteFlavorByIdRequestRequired = z.infer<typeof LastValidWasteFlavorByIdRequestRequired>;








    

export const LastValidWasteFlavorByIdResponse = z.object({
        flavor: WasteFlavor,
});

export const LastValidWasteFlavorByIdResponseRequired = z.object({
    flavor: WasteFlavor,
});
export type LastValidWasteFlavorByIdResponseRequired = z.infer<typeof LastValidWasteFlavorByIdResponseRequired>;


			// method {WasteFlavorRevisionCount map[] [] false false false false [0xc00069b4f0] [0xc00069b590] [] 0xc0005b06e0}






    

export const WasteFlavorRevisionCountRequest = z.object({
        wasteFlavorId: z.string(),
});

export const WasteFlavorRevisionCountRequestRequired = z.object({
    wasteFlavorId: z.string(),
});
export type WasteFlavorRevisionCountRequestRequired = z.infer<typeof WasteFlavorRevisionCountRequestRequired>;








    

export const WasteFlavorRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const WasteFlavorRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type WasteFlavorRevisionCountResponseRequired = z.infer<typeof WasteFlavorRevisionCountResponseRequired>;


			// method {AllWasteFlavorRevisions map[] [] false false false false [0xc00069b630] [0xc00069b720] [] 0xc0005b06e0}






    

export const AllWasteFlavorRevisionsRequest = z.object({
        wasteFlavorId: z.string(),
});

export const AllWasteFlavorRevisionsRequestRequired = z.object({
    wasteFlavorId: z.string(),
});
export type AllWasteFlavorRevisionsRequestRequired = z.infer<typeof AllWasteFlavorRevisionsRequestRequired>;








    

export const AllWasteFlavorRevisionsResponse = z.object({
        revisions: WasteFlavor.array(),
});

export const AllWasteFlavorRevisionsResponseRequired = z.object({
    revisions: WasteFlavor.array(),
});
export type AllWasteFlavorRevisionsResponseRequired = z.infer<typeof AllWasteFlavorRevisionsResponseRequired>;


			// method {ActiveWasteFlavors map[] [] false false false false [0xc00069b7c0 0xc00069b860] [0xc00069b950] [] 0xc0005b06e0}






    
    

export const ActiveWasteFlavorsRequest = z.object({
        purpose: WasteFlavorPurpose,
        offset: z.optional(z.number()),
});

export const ActiveWasteFlavorsRequestRequired = z.object({
    purpose: WasteFlavorPurpose,
    offset: z.number(),
});
export type ActiveWasteFlavorsRequestRequired = z.infer<typeof ActiveWasteFlavorsRequestRequired>;








    

export const ActiveWasteFlavorsResponse = z.object({
        flavorStubs: WasteFlavorStub.array(),
});

export const ActiveWasteFlavorsResponseRequired = z.object({
    flavorStubs: WasteFlavorStub.array(),
});
export type ActiveWasteFlavorsResponseRequired = z.infer<typeof ActiveWasteFlavorsResponseRequired>;


			// method {GetCleavableFlavors map[] [] false false false false [0xc00069b9f0] [0xc00069bae0] [] 0xc0005b06e0}






    

export const GetCleavableFlavorsRequest = z.object({
        sourceFlavorId: z.string(),
});

export const GetCleavableFlavorsRequestRequired = z.object({
    sourceFlavorId: z.string(),
});
export type GetCleavableFlavorsRequestRequired = z.infer<typeof GetCleavableFlavorsRequestRequired>;








    

export const GetCleavableFlavorsResponse = z.object({
        flavors: WasteFlavorStub.array(),
});

export const GetCleavableFlavorsResponseRequired = z.object({
    flavors: WasteFlavorStub.array(),
});
export type GetCleavableFlavorsResponseRequired = z.infer<typeof GetCleavableFlavorsResponseRequired>;


			// method {GetEmissibleFlavors map[] [] false false false false [0xc00069bb80] [0xc00069bc70] [] 0xc0005b06e0}






    

export const GetEmissibleFlavorsRequest = z.object({
        sinkFlavorId: z.string(),
});

export const GetEmissibleFlavorsRequestRequired = z.object({
    sinkFlavorId: z.string(),
});
export type GetEmissibleFlavorsRequestRequired = z.infer<typeof GetEmissibleFlavorsRequestRequired>;








    

export const GetEmissibleFlavorsResponse = z.object({
        flavors: WasteFlavorStub.array(),
});

export const GetEmissibleFlavorsResponseRequired = z.object({
    flavors: WasteFlavorStub.array(),
});
export type GetEmissibleFlavorsResponseRequired = z.infer<typeof GetEmissibleFlavorsResponseRequired>;


			// method {WatchWasteById map[] [] false false false false [0xc00069bd10] [0xc00069bdb0] [] 0xc0005b06e0}






    

export const WatchWasteByIdRequest = z.object({
        wasteId: z.string(),
});

export const WatchWasteByIdRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchWasteByIdRequestRequired = z.infer<typeof WatchWasteByIdRequestRequired>;








    

export const WatchWasteByIdResponse = z.object({
        waste: z.optional(Waste),
});

export const WatchWasteByIdResponseRequired = z.object({
    waste: Waste,
});
export type WatchWasteByIdResponseRequired = z.infer<typeof WatchWasteByIdResponseRequired>;


			// method {LastValidWasteById map[] [] false false false false [0xc00069be50] [0xc00069bef0] [] 0xc0005b06e0}






    

export const LastValidWasteByIdRequest = z.object({
        wasteId: z.string(),
});

export const LastValidWasteByIdRequestRequired = z.object({
    wasteId: z.string(),
});
export type LastValidWasteByIdRequestRequired = z.infer<typeof LastValidWasteByIdRequestRequired>;








    

export const LastValidWasteByIdResponse = z.object({
        waste: Waste,
});

export const LastValidWasteByIdResponseRequired = z.object({
    waste: Waste,
});
export type LastValidWasteByIdResponseRequired = z.infer<typeof LastValidWasteByIdResponseRequired>;


			// method {WasteByIdAsof map[] [] false false false false [0xc00069e050 0xc00069e0f0] [0xc00069e190] [] 0xc0005b06e0}






    
    

export const WasteByIdAsofRequest = z.object({
        wasteId: z.string(),
        asof: z.string(),
});

export const WasteByIdAsofRequestRequired = z.object({
    wasteId: z.string(),
    asof: z.string(),
});
export type WasteByIdAsofRequestRequired = z.infer<typeof WasteByIdAsofRequestRequired>;








    

export const WasteByIdAsofResponse = z.object({
        waste: z.optional(Waste),
});

export const WasteByIdAsofResponseRequired = z.object({
    waste: Waste,
});
export type WasteByIdAsofResponseRequired = z.infer<typeof WasteByIdAsofResponseRequired>;


			// method {WasteRevisionCount map[] [] false false false false [0xc00069e230] [0xc00069e2d0] [] 0xc0005b06e0}






    

export const WasteRevisionCountRequest = z.object({
        wasteId: z.string(),
});

export const WasteRevisionCountRequestRequired = z.object({
    wasteId: z.string(),
});
export type WasteRevisionCountRequestRequired = z.infer<typeof WasteRevisionCountRequestRequired>;








    

export const WasteRevisionCountResponse = z.object({
        revisionCount: z.number(),
});

export const WasteRevisionCountResponseRequired = z.object({
    revisionCount: z.number(),
});
export type WasteRevisionCountResponseRequired = z.infer<typeof WasteRevisionCountResponseRequired>;


			// method {AllWasteRevisionStubs map[] [] false false false false [0xc00069e370] [0xc00069e460] [] 0xc0005b06e0}






    

export const AllWasteRevisionStubsRequest = z.object({
        wasteId: z.string(),
});

export const AllWasteRevisionStubsRequestRequired = z.object({
    wasteId: z.string(),
});
export type AllWasteRevisionStubsRequestRequired = z.infer<typeof AllWasteRevisionStubsRequestRequired>;








    

export const AllWasteRevisionStubsResponse = z.object({
        revisions: WasteRevisionStub.array(),
});

export const AllWasteRevisionStubsResponseRequired = z.object({
    revisions: WasteRevisionStub.array(),
});
export type AllWasteRevisionStubsResponseRequired = z.infer<typeof AllWasteRevisionStubsResponseRequired>;


			// method {AllWasteRevisions map[] [] false false false false [0xc00069e500] [0xc00069e5f0] [] 0xc0005b06e0}






    

export const AllWasteRevisionsRequest = z.object({
        wasteId: z.string(),
});

export const AllWasteRevisionsRequestRequired = z.object({
    wasteId: z.string(),
});
export type AllWasteRevisionsRequestRequired = z.infer<typeof AllWasteRevisionsRequestRequired>;








    

export const AllWasteRevisionsResponse = z.object({
        revisions: Waste.array(),
});

export const AllWasteRevisionsResponseRequired = z.object({
    revisions: Waste.array(),
});
export type AllWasteRevisionsResponseRequired = z.infer<typeof AllWasteRevisionsResponseRequired>;


			// method {WatchWastesForBundle map[] [] false false false false [0xc00069e690] [0xc00069e780] [] 0xc0005b06e0}






    

export const WatchWastesForBundleRequest = z.object({
        bundleId: z.string(),
});

export const WatchWastesForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type WatchWastesForBundleRequestRequired = z.infer<typeof WatchWastesForBundleRequestRequired>;








    

export const WatchWastesForBundleResponse = z.object({
        wastes: WasteStub.array(),
});

export const WatchWastesForBundleResponseRequired = z.object({
    wastes: WasteStub.array(),
});
export type WatchWastesForBundleResponseRequired = z.infer<typeof WatchWastesForBundleResponseRequired>;


			// method {AllWastesForBundle map[] [] false false false false [0xc00069e820] [0xc00069e910] [] 0xc0005b06e0}






    

export const AllWastesForBundleRequest = z.object({
        bundleId: z.string(),
});

export const AllWastesForBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type AllWastesForBundleRequestRequired = z.infer<typeof AllWastesForBundleRequestRequired>;








    

export const AllWastesForBundleResponse = z.object({
        wastes: WasteStub.array(),
});

export const AllWastesForBundleResponseRequired = z.object({
    wastes: WasteStub.array(),
});
export type AllWastesForBundleResponseRequired = z.infer<typeof AllWastesForBundleResponseRequired>;


			// method {WastesForBundleAsof map[] [] false false false false [0xc00069e9b0 0xc00069ea50] [0xc00069eb40] [] 0xc0005b06e0}






    
    

export const WastesForBundleAsofRequest = z.object({
        bundleId: z.string(),
        asof: z.string(),
});

export const WastesForBundleAsofRequestRequired = z.object({
    bundleId: z.string(),
    asof: z.string(),
});
export type WastesForBundleAsofRequestRequired = z.infer<typeof WastesForBundleAsofRequestRequired>;








    

export const WastesForBundleAsofResponse = z.object({
        wastes: WasteStub.array(),
});

export const WastesForBundleAsofResponseRequired = z.object({
    wastes: WasteStub.array(),
});
export type WastesForBundleAsofResponseRequired = z.infer<typeof WastesForBundleAsofResponseRequired>;


			// method {AllDaughtersOfWaste map[] [] false false false false [0xc00069ebe0] [0xc00069ecd0] [] 0xc0005b06e0}






    

export const AllDaughtersOfWasteRequest = z.object({
        wasteId: z.string(),
});

export const AllDaughtersOfWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type AllDaughtersOfWasteRequestRequired = z.infer<typeof AllDaughtersOfWasteRequestRequired>;








    

export const AllDaughtersOfWasteResponse = z.object({
        daughters: WasteStub.array(),
});

export const AllDaughtersOfWasteResponseRequired = z.object({
    daughters: WasteStub.array(),
});
export type AllDaughtersOfWasteResponseRequired = z.infer<typeof AllDaughtersOfWasteResponseRequired>;


			// method {MothersOfWaste map[] [] false false false false [0xc00069ed70] [0xc00069ee60] [] 0xc0005b06e0}






    

export const MothersOfWasteRequest = z.object({
        wasteId: z.string(),
});

export const MothersOfWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type MothersOfWasteRequestRequired = z.infer<typeof MothersOfWasteRequestRequired>;








    

export const MothersOfWasteResponse = z.object({
        mothers: Waste.array(),
});

export const MothersOfWasteResponseRequired = z.object({
    mothers: Waste.array(),
});
export type MothersOfWasteResponseRequired = z.infer<typeof MothersOfWasteResponseRequired>;


			// method {DirectWasteLineageRecords map[] [] false false false false [0xc00069ef00] [0xc00069eff0] [] 0xc0005b06e0}






    

export const DirectWasteLineageRecordsRequest = z.object({
        wasteId: z.string(),
});

export const DirectWasteLineageRecordsRequestRequired = z.object({
    wasteId: z.string(),
});
export type DirectWasteLineageRecordsRequestRequired = z.infer<typeof DirectWasteLineageRecordsRequestRequired>;








    

export const DirectWasteLineageRecordsResponse = z.object({
        lineageRecords: WasteLineageRecord.array(),
});

export const DirectWasteLineageRecordsResponseRequired = z.object({
    lineageRecords: WasteLineageRecord.array(),
});
export type DirectWasteLineageRecordsResponseRequired = z.infer<typeof DirectWasteLineageRecordsResponseRequired>;


			// method {WatchBundleForWaste map[] [] false false false false [0xc00069f090] [0xc00069f130] [] 0xc0005b06e0}






    

export const WatchBundleForWasteRequest = z.object({
        wasteId: z.string(),
});

export const WatchBundleForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchBundleForWasteRequestRequired = z.infer<typeof WatchBundleForWasteRequestRequired>;








    

export const WatchBundleForWasteResponse = z.object({
        bundle: z.optional(Bundle),
});

export const WatchBundleForWasteResponseRequired = z.object({
    bundle: Bundle,
});
export type WatchBundleForWasteResponseRequired = z.infer<typeof WatchBundleForWasteResponseRequired>;


			// method {LastValidBundleForWaste map[] [] false false false false [0xc00069f1d0] [0xc00069f270] [] 0xc0005b06e0}






    

export const LastValidBundleForWasteRequest = z.object({
        wasteId: z.string(),
});

export const LastValidBundleForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type LastValidBundleForWasteRequestRequired = z.infer<typeof LastValidBundleForWasteRequestRequired>;








    

export const LastValidBundleForWasteResponse = z.object({
        bundle: z.optional(Bundle),
});

export const LastValidBundleForWasteResponseRequired = z.object({
    bundle: Bundle,
});
export type LastValidBundleForWasteResponseRequired = z.infer<typeof LastValidBundleForWasteResponseRequired>;


			// method {BundleForWasteAsof map[] [] false false false false [0xc00069f310 0xc00069f3b0] [0xc00069f450] [] 0xc0005b06e0}






    
    

export const BundleForWasteAsofRequest = z.object({
        wasteId: z.string(),
        asof: z.string(),
});

export const BundleForWasteAsofRequestRequired = z.object({
    wasteId: z.string(),
    asof: z.string(),
});
export type BundleForWasteAsofRequestRequired = z.infer<typeof BundleForWasteAsofRequestRequired>;








    

export const BundleForWasteAsofResponse = z.object({
        bundle: z.optional(Bundle),
});

export const BundleForWasteAsofResponseRequired = z.object({
    bundle: Bundle,
});
export type BundleForWasteAsofResponseRequired = z.infer<typeof BundleForWasteAsofResponseRequired>;


			// method {AllBundlesForWaste map[] [] false false false false [0xc00069f4f0] [0xc00069f5e0] [] 0xc0005b06e0}






    

export const AllBundlesForWasteRequest = z.object({
        wasteId: z.string(),
});

export const AllBundlesForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type AllBundlesForWasteRequestRequired = z.infer<typeof AllBundlesForWasteRequestRequired>;








    

export const AllBundlesForWasteResponse = z.object({
        bundles: BundleStub.array(),
});

export const AllBundlesForWasteResponseRequired = z.object({
    bundles: BundleStub.array(),
});
export type AllBundlesForWasteResponseRequired = z.infer<typeof AllBundlesForWasteResponseRequired>;


			// method {WatchAssociationsForWaste map[] [] false false false false [0xc00069f680] [0xc00069f720] [] 0xc0005b06e0}






    

export const WatchAssociationsForWasteRequest = z.object({
        wasteId: z.string(),
});

export const WatchAssociationsForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchAssociationsForWasteRequestRequired = z.infer<typeof WatchAssociationsForWasteRequestRequired>;








    

export const WatchAssociationsForWasteResponse = z.object({
        assoc: WasteAssociation,
});

export const WatchAssociationsForWasteResponseRequired = z.object({
    assoc: WasteAssociation,
});
export type WatchAssociationsForWasteResponseRequired = z.infer<typeof WatchAssociationsForWasteResponseRequired>;


			// method {ShowExportedWaste map[] [] false false false false [0xc00069f7c0] [0xc00069f860] [] 0xc0005b06e0}






    

export const ShowExportedWasteRequest = z.object({
        wasteId: z.string(),
});

export const ShowExportedWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type ShowExportedWasteRequestRequired = z.infer<typeof ShowExportedWasteRequestRequired>;








    

export const ShowExportedWasteResponse = z.object({
        exported: z.string(),
});

export const ShowExportedWasteResponseRequired = z.object({
    exported: z.string(),
});
export type ShowExportedWasteResponseRequired = z.infer<typeof ShowExportedWasteResponseRequired>;


			// method {CompleteWasteHistoryById map[] [] false false false false [0xc00069f900] [0xc00069f9a0] [] 0xc0005b06e0}






    

export const CompleteWasteHistoryByIdRequest = z.object({
        wasteId: z.string(),
});

export const CompleteWasteHistoryByIdRequestRequired = z.object({
    wasteId: z.string(),
});
export type CompleteWasteHistoryByIdRequestRequired = z.infer<typeof CompleteWasteHistoryByIdRequestRequired>;








    

export const CompleteWasteHistoryByIdResponse = z.object({
        history: CompleteWasteHistory,
});

export const CompleteWasteHistoryByIdResponseRequired = z.object({
    history: CompleteWasteHistory,
});
export type CompleteWasteHistoryByIdResponseRequired = z.infer<typeof CompleteWasteHistoryByIdResponseRequired>;


			// method {WatchWasteLocation map[] [] false false false false [0xc00069fa40] [0xc00069fae0] [] 0xc0005b06e0}






    

export const WatchWasteLocationRequest = z.object({
        wasteId: z.string(),
});

export const WatchWasteLocationRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchWasteLocationRequestRequired = z.infer<typeof WatchWasteLocationRequestRequired>;








    

export const WatchWasteLocationResponse = z.object({
        curloc: TruckOrVenueStub,
});

export const WatchWasteLocationResponseRequired = z.object({
    curloc: TruckOrVenueStub,
});
export type WatchWasteLocationResponseRequired = z.infer<typeof WatchWasteLocationResponseRequired>;


			// method {WatchWastesAt map[] [] false false false false [0xc00069fb80] [0xc00069fc70] [] 0xc0005b06e0}






    

export const WatchWastesAtRequest = z.object({
        venueId: z.string(),
});

export const WatchWastesAtRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchWastesAtRequestRequired = z.infer<typeof WatchWastesAtRequestRequired>;








    

export const WatchWastesAtResponse = z.object({
        stubs: WasteStub.array(),
});

export const WatchWastesAtResponseRequired = z.object({
    stubs: WasteStub.array(),
});
export type WatchWastesAtResponseRequired = z.infer<typeof WatchWastesAtResponseRequired>;


			// method {WasteStampById map[] [] false false false false [0xc00069fd10] [0xc00069fdb0] [] 0xc0005b06e0}






    

export const WasteStampByIdRequest = z.object({
        stampId: z.string(),
});

export const WasteStampByIdRequestRequired = z.object({
    stampId: z.string(),
});
export type WasteStampByIdRequestRequired = z.infer<typeof WasteStampByIdRequestRequired>;








    

export const WasteStampByIdResponse = z.object({
        stamp: WasteStamp,
});

export const WasteStampByIdResponseRequired = z.object({
    stamp: WasteStamp,
});
export type WasteStampByIdResponseRequired = z.infer<typeof WasteStampByIdResponseRequired>;


			// method {LastFlavoredStampForWaste map[] [] false false false false [0xc00069fe50] [0xc00069fef0] [] 0xc0005b06e0}






    

export const LastFlavoredStampForWasteRequest = z.object({
        wasteId: z.string(),
});

export const LastFlavoredStampForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type LastFlavoredStampForWasteRequestRequired = z.infer<typeof LastFlavoredStampForWasteRequestRequired>;








    

export const LastFlavoredStampForWasteResponse = z.object({
        stamp: z.optional(WasteStamp),
});

export const LastFlavoredStampForWasteResponseRequired = z.object({
    stamp: WasteStamp,
});
export type LastFlavoredStampForWasteResponseRequired = z.infer<typeof LastFlavoredStampForWasteResponseRequired>;


			// method {WatchStampsForWaste map[] [] false false false false [0xc0006a0050] [0xc0006a0140] [] 0xc0005b06e0}






    

export const WatchStampsForWasteRequest = z.object({
        wasteId: z.string(),
});

export const WatchStampsForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchStampsForWasteRequestRequired = z.infer<typeof WatchStampsForWasteRequestRequired>;








    

export const WatchStampsForWasteResponse = z.object({
        stamps: WasteStamp.array(),
});

export const WatchStampsForWasteResponseRequired = z.object({
    stamps: WasteStamp.array(),
});
export type WatchStampsForWasteResponseRequired = z.infer<typeof WatchStampsForWasteResponseRequired>;


			// method {WatchFlavoredStampsForWaste map[] [] false false false false [0xc0006a01e0] [0xc0006a02d0] [] 0xc0005b06e0}






    

export const WatchFlavoredStampsForWasteRequest = z.object({
        wasteId: z.string(),
});

export const WatchFlavoredStampsForWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type WatchFlavoredStampsForWasteRequestRequired = z.infer<typeof WatchFlavoredStampsForWasteRequestRequired>;








    

export const WatchFlavoredStampsForWasteResponse = z.object({
        stamps: WasteStamp.array(),
});

export const WatchFlavoredStampsForWasteResponseRequired = z.object({
    stamps: WasteStamp.array(),
});
export type WatchFlavoredStampsForWasteResponseRequired = z.infer<typeof WatchFlavoredStampsForWasteResponseRequired>;


			// method {WatchPackingModes map[] [] false false false false [] [0xc0006a03c0] [] 0xc0005b06e0}






    

export const WatchPackingModesResponse = z.object({
        modes: PackingMode.array(),
});

export const WatchPackingModesResponseRequired = z.object({
    modes: PackingMode.array(),
});
export type WatchPackingModesResponseRequired = z.infer<typeof WatchPackingModesResponseRequired>;


			// method {WatchPackingModeById map[] [] false false false false [0xc0006a0460] [0xc0006a0500] [] 0xc0005b06e0}






    

export const WatchPackingModeByIdRequest = z.object({
        packingModeId: z.string(),
});

export const WatchPackingModeByIdRequestRequired = z.object({
    packingModeId: z.string(),
});
export type WatchPackingModeByIdRequestRequired = z.infer<typeof WatchPackingModeByIdRequestRequired>;








    

export const WatchPackingModeByIdResponse = z.object({
        mode: PackingMode,
});

export const WatchPackingModeByIdResponseRequired = z.object({
    mode: PackingMode,
});
export type WatchPackingModeByIdResponseRequired = z.infer<typeof WatchPackingModeByIdResponseRequired>;


			// method {WatchManifestTypes map[] [] false false false false [] [0xc0006a05f0] [] 0xc0005b06e0}






    

export const WatchManifestTypesResponse = z.object({
        maniTypes: ManifestType.array(),
});

export const WatchManifestTypesResponseRequired = z.object({
    maniTypes: ManifestType.array(),
});
export type WatchManifestTypesResponseRequired = z.infer<typeof WatchManifestTypesResponseRequired>;


			// method {WatchManifestTypeById map[] [] false false false false [0xc0006a0690] [0xc0006a0730] [] 0xc0005b06e0}






    

export const WatchManifestTypeByIdRequest = z.object({
        maniTypeId: z.string(),
});

export const WatchManifestTypeByIdRequestRequired = z.object({
    maniTypeId: z.string(),
});
export type WatchManifestTypeByIdRequestRequired = z.infer<typeof WatchManifestTypeByIdRequestRequired>;








    

export const WatchManifestTypeByIdResponse = z.object({
        maniType: z.optional(ManifestType),
});

export const WatchManifestTypeByIdResponseRequired = z.object({
    maniType: ManifestType,
});
export type WatchManifestTypeByIdResponseRequired = z.infer<typeof WatchManifestTypeByIdResponseRequired>;


			// method {WatchUnits map[] [] false false false false [] [0xc0006a0820] [] 0xc0005b06e0}






    

export const WatchUnitsResponse = z.object({
        units: Unit.array(),
});

export const WatchUnitsResponseRequired = z.object({
    units: Unit.array(),
});
export type WatchUnitsResponseRequired = z.infer<typeof WatchUnitsResponseRequired>;


			// method {WatchTransformModes map[] [] false false false false [] [0xc0006a0910] [] 0xc0005b06e0}






    

export const WatchTransformModesResponse = z.object({
        modes: EntityStub.array(),
});

export const WatchTransformModesResponseRequired = z.object({
    modes: EntityStub.array(),
});
export type WatchTransformModesResponseRequired = z.infer<typeof WatchTransformModesResponseRequired>;


			// method {WatchTransformModesForVenue map[] [] false false false false [0xc0006a09b0] [0xc0006a0aa0] [] 0xc0005b06e0}






    

export const WatchTransformModesForVenueRequest = z.object({
        venueId: z.string(),
});

export const WatchTransformModesForVenueRequestRequired = z.object({
    venueId: z.string(),
});
export type WatchTransformModesForVenueRequestRequired = z.infer<typeof WatchTransformModesForVenueRequestRequired>;








    

export const WatchTransformModesForVenueResponse = z.object({
        modes: EntityStub.array(),
});

export const WatchTransformModesForVenueResponseRequired = z.object({
    modes: EntityStub.array(),
});
export type WatchTransformModesForVenueResponseRequired = z.infer<typeof WatchTransformModesForVenueResponseRequired>;


			// method {AllRewindCheckpoints map[] [] false false false false [] [0xc0006a0b90] [] 0xc0005b06e0}






    

export const AllRewindCheckpointsResponse = z.object({
        checkpoints: RewindCheckpoint.array(),
});

export const AllRewindCheckpointsResponseRequired = z.object({
    checkpoints: RewindCheckpoint.array(),
});
export type AllRewindCheckpointsResponseRequired = z.infer<typeof AllRewindCheckpointsResponseRequired>;


			// method {Setlists map[] [] true false true false [] [0xc0006a0c30] [] 0xc0005b06e0}






    

export const SetlistsResponse = z.object({
        setlistPacketResult: SetlistPacketResult,
});

export const SetlistsResponseRequired = z.object({
    setlistPacketResult: SetlistPacketResult,
});
export type SetlistsResponseRequired = z.infer<typeof SetlistsResponseRequired>;


			// method {SetlistSubscriptions map[] [] false false false false [] [0xc0006a0d20] [] 0xc0005b06e0}






    

export const SetlistSubscriptionsResponse = z.object({
        subscriptions: SetlistSubscription.array(),
});

export const SetlistSubscriptionsResponseRequired = z.object({
    subscriptions: SetlistSubscription.array(),
});
export type SetlistSubscriptionsResponseRequired = z.infer<typeof SetlistSubscriptionsResponseRequired>;


			// method {SetSystemConfig map[] [this is loosely typed to allow extension. it needs to be guaranteed to extend the shape of SystemConfig] false false false false [0xc0006a0e60] [] [] 0xc0005b06e0}






    

export const SetSystemConfigRequest = z.object({
        sysconf: 

// TODO map
z.any(),
});

export const SetSystemConfigRequestRequired = z.object({
    sysconf: 

// TODO map
z.any(),
});
export type SetSystemConfigRequestRequired = z.infer<typeof SetSystemConfigRequestRequired>;


			// method {UpsertCompany map[] [] false false false false [0xc0006a0f00] [0xc0006a0fa0] [] 0xc0005b06e0}






    

export const UpsertCompanyRequest = z.object({
        food: NewCompanyFood,
});

export const UpsertCompanyRequestRequired = z.object({
    food: NewCompanyFood,
});
export type UpsertCompanyRequestRequired = z.infer<typeof UpsertCompanyRequestRequired>;








    

export const UpsertCompanyResponse = z.object({
        result: CompanyUpsertResult,
});

export const UpsertCompanyResponseRequired = z.object({
    result: CompanyUpsertResult,
});
export type UpsertCompanyResponseRequired = z.infer<typeof UpsertCompanyResponseRequired>;


			// method {PatchCompany map[] [] false false false false [0xc0006a1040 0xc0006a10e0] [0xc0006a1180] [] 0xc0005b06e0}






    
    

export const PatchCompanyRequest = z.object({
        companyId: z.string(),
        patch: CompanyPatch,
});

export const PatchCompanyRequestRequired = z.object({
    companyId: z.string(),
    patch: CompanyPatch,
});
export type PatchCompanyRequestRequired = z.infer<typeof PatchCompanyRequestRequired>;








    

export const PatchCompanyResponse = z.object({
        company: Company,
});

export const PatchCompanyResponseRequired = z.object({
    company: Company,
});
export type PatchCompanyResponseRequired = z.infer<typeof PatchCompanyResponseRequired>;


			// method {RetireCompany map[] [] false false false false [0xc0006a1220] [] [] 0xc0005b06e0}






    

export const RetireCompanyRequest = z.object({
        companyId: z.string(),
});

export const RetireCompanyRequestRequired = z.object({
    companyId: z.string(),
});
export type RetireCompanyRequestRequired = z.infer<typeof RetireCompanyRequestRequired>;


			// method {UpsertVenue map[] [] false false false false [0xc0006a12c0] [0xc0006a1360] [] 0xc0005b06e0}






    

export const UpsertVenueRequest = z.object({
        food: UpsertableVenue,
});

export const UpsertVenueRequestRequired = z.object({
    food: UpsertableVenue,
});
export type UpsertVenueRequestRequired = z.infer<typeof UpsertVenueRequestRequired>;








    

export const UpsertVenueResponse = z.object({
        result: VenueUpsertResult,
});

export const UpsertVenueResponseRequired = z.object({
    result: VenueUpsertResult,
});
export type UpsertVenueResponseRequired = z.infer<typeof UpsertVenueResponseRequired>;


			// method {PatchVenue map[] [] false false false false [0xc0006a1400 0xc0006a14a0] [0xc0006a1540] [] 0xc0005b06e0}






    
    

export const PatchVenueRequest = z.object({
        venueId: z.string(),
        patch: VenuePatch,
});

export const PatchVenueRequestRequired = z.object({
    venueId: z.string(),
    patch: VenuePatch,
});
export type PatchVenueRequestRequired = z.infer<typeof PatchVenueRequestRequired>;








    

export const PatchVenueResponse = z.object({
        venue: Venue,
});

export const PatchVenueResponseRequired = z.object({
    venue: Venue,
});
export type PatchVenueResponseRequired = z.infer<typeof PatchVenueResponseRequired>;


			// method {RetireVenue map[] [] false false false false [0xc0006a15e0] [] [] 0xc0005b06e0}






    

export const RetireVenueRequest = z.object({
        venueId: z.string(),
});

export const RetireVenueRequestRequired = z.object({
    venueId: z.string(),
});
export type RetireVenueRequestRequired = z.infer<typeof RetireVenueRequestRequired>;


			// method {UpsertDownstreamVenue map[] [] false false false false [0xc0006a1680] [0xc0006a1720] [] 0xc0005b06e0}






    

export const UpsertDownstreamVenueRequest = z.object({
        food: UpsertableVenue,
});

export const UpsertDownstreamVenueRequestRequired = z.object({
    food: UpsertableVenue,
});
export type UpsertDownstreamVenueRequestRequired = z.infer<typeof UpsertDownstreamVenueRequestRequired>;








    

export const UpsertDownstreamVenueResponse = z.object({
        result: VenueUpsertResult,
});

export const UpsertDownstreamVenueResponseRequired = z.object({
    result: VenueUpsertResult,
});
export type UpsertDownstreamVenueResponseRequired = z.infer<typeof UpsertDownstreamVenueResponseRequired>;


			// method {UpsertAgent map[] [] false false false false [0xc0006a17c0] [0xc0006a1860] [] 0xc0005b06e0}






    

export const UpsertAgentRequest = z.object({
        food: UpsertableAgent,
});

export const UpsertAgentRequestRequired = z.object({
    food: UpsertableAgent,
});
export type UpsertAgentRequestRequired = z.infer<typeof UpsertAgentRequestRequired>;








    

export const UpsertAgentResponse = z.object({
        result: AgentUpsertResult,
});

export const UpsertAgentResponseRequired = z.object({
    result: AgentUpsertResult,
});
export type UpsertAgentResponseRequired = z.infer<typeof UpsertAgentResponseRequired>;


			// method {PatchAgent map[] [] false false false false [0xc0006a1900 0xc0006a19a0] [0xc0006a1a40] [] 0xc0005b06e0}






    
    

export const PatchAgentRequest = z.object({
        agentId: z.string(),
        patch: AgentPatch,
});

export const PatchAgentRequestRequired = z.object({
    agentId: z.string(),
    patch: AgentPatch,
});
export type PatchAgentRequestRequired = z.infer<typeof PatchAgentRequestRequired>;








    

export const PatchAgentResponse = z.object({
        agent: Agent,
});

export const PatchAgentResponseRequired = z.object({
    agent: Agent,
});
export type PatchAgentResponseRequired = z.infer<typeof PatchAgentResponseRequired>;


			// method {PatchSelf map[] [] false false false false [0xc0006a1ae0] [0xc0006a1b80] [] 0xc0005b06e0}






    

export const PatchSelfRequest = z.object({
        patch: SelfPatch,
});

export const PatchSelfRequestRequired = z.object({
    patch: SelfPatch,
});
export type PatchSelfRequestRequired = z.infer<typeof PatchSelfRequestRequired>;








    

export const PatchSelfResponse = z.object({
        self: Agent,
});

export const PatchSelfResponseRequired = z.object({
    self: Agent,
});
export type PatchSelfResponseRequired = z.infer<typeof PatchSelfResponseRequired>;


			// method {ChangePassword map[] [returns new authentication token] false false false false [0xc0006a1c20] [0xc0006a1cc0] [] 0xc0005b06e0}






    

export const ChangePasswordRequest = z.object({
        food: PasswordChange,
});

export const ChangePasswordRequestRequired = z.object({
    food: PasswordChange,
});
export type ChangePasswordRequestRequired = z.infer<typeof ChangePasswordRequestRequired>;








    

export const ChangePasswordResponse = z.object({
        authtoken: z.string(),
});

export const ChangePasswordResponseRequired = z.object({
    authtoken: z.string(),
});
export type ChangePasswordResponseRequired = z.infer<typeof ChangePasswordResponseRequired>;


			// method {RetireAgent map[] [] false false false false [0xc0006a1d60] [] [] 0xc0005b06e0}






    

export const RetireAgentRequest = z.object({
        agentId: z.string(),
});

export const RetireAgentRequestRequired = z.object({
    agentId: z.string(),
});
export type RetireAgentRequestRequired = z.infer<typeof RetireAgentRequestRequired>;


			// method {StampAgent map[] [] false false false false [0xc0006a1e00] [0xc0006a1ea0] [] 0xc0005b06e0}






    

export const StampAgentRequest = z.object({
        food: NewAgentStampFood,
});

export const StampAgentRequestRequired = z.object({
    food: NewAgentStampFood,
});
export type StampAgentRequestRequired = z.infer<typeof StampAgentRequestRequired>;








    

export const StampAgentResponse = z.object({
        stamp: AgentStamp,
});

export const StampAgentResponseRequired = z.object({
    stamp: AgentStamp,
});
export type StampAgentResponseRequired = z.infer<typeof StampAgentResponseRequired>;


			// method {UpsertTruckModel map[] [] false false false false [0xc0006a2000] [0xc0006a20a0] [] 0xc0005b06e0}






    

export const UpsertTruckModelRequest = z.object({
        food: NewTruckModelFood,
});

export const UpsertTruckModelRequestRequired = z.object({
    food: NewTruckModelFood,
});
export type UpsertTruckModelRequestRequired = z.infer<typeof UpsertTruckModelRequestRequired>;








    

export const UpsertTruckModelResponse = z.object({
        model: TruckModelUpsertResult,
});

export const UpsertTruckModelResponseRequired = z.object({
    model: TruckModelUpsertResult,
});
export type UpsertTruckModelResponseRequired = z.infer<typeof UpsertTruckModelResponseRequired>;


			// method {PatchTruckModel map[] [] false false false false [0xc0006a2140 0xc0006a21e0] [0xc0006a2280] [] 0xc0005b06e0}






    
    

export const PatchTruckModelRequest = z.object({
        modelId: z.string(),
        patch: TruckModelPatch,
});

export const PatchTruckModelRequestRequired = z.object({
    modelId: z.string(),
    patch: TruckModelPatch,
});
export type PatchTruckModelRequestRequired = z.infer<typeof PatchTruckModelRequestRequired>;








    

export const PatchTruckModelResponse = z.object({
        model: TruckModel,
});

export const PatchTruckModelResponseRequired = z.object({
    model: TruckModel,
});
export type PatchTruckModelResponseRequired = z.infer<typeof PatchTruckModelResponseRequired>;


			// method {RetireTruckModel map[] [] false false false false [0xc0006a2320] [] [] 0xc0005b06e0}






    

export const RetireTruckModelRequest = z.object({
        modelId: z.string(),
});

export const RetireTruckModelRequestRequired = z.object({
    modelId: z.string(),
});
export type RetireTruckModelRequestRequired = z.infer<typeof RetireTruckModelRequestRequired>;


			// method {UpsertTruck map[] [] false false false false [0xc0006a23c0] [0xc0006a2460] [] 0xc0005b06e0}






    

export const UpsertTruckRequest = z.object({
        food: UpsertableTruck,
});

export const UpsertTruckRequestRequired = z.object({
    food: UpsertableTruck,
});
export type UpsertTruckRequestRequired = z.infer<typeof UpsertTruckRequestRequired>;








    

export const UpsertTruckResponse = z.object({
        result: TruckUpsertResult,
});

export const UpsertTruckResponseRequired = z.object({
    result: TruckUpsertResult,
});
export type UpsertTruckResponseRequired = z.infer<typeof UpsertTruckResponseRequired>;


			// method {PatchTruck map[] [] false false false false [0xc0006a2500 0xc0006a25a0] [0xc0006a2640] [] 0xc0005b06e0}






    
    

export const PatchTruckRequest = z.object({
        truckId: z.string(),
        patch: TruckPatch,
});

export const PatchTruckRequestRequired = z.object({
    truckId: z.string(),
    patch: TruckPatch,
});
export type PatchTruckRequestRequired = z.infer<typeof PatchTruckRequestRequired>;








    

export const PatchTruckResponse = z.object({
        truck: Truck,
});

export const PatchTruckResponseRequired = z.object({
    truck: Truck,
});
export type PatchTruckResponseRequired = z.infer<typeof PatchTruckResponseRequired>;


			// method {RetireTruck map[] [] false false false false [0xc0006a26e0] [] [] 0xc0005b06e0}






    

export const RetireTruckRequest = z.object({
        truckId: z.string(),
});

export const RetireTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type RetireTruckRequestRequired = z.infer<typeof RetireTruckRequestRequired>;


			// method {MountTruck map[] [] false false false false [0xc0006a2780] [] [] 0xc0005b06e0}






    

export const MountTruckRequest = z.object({
        truckId: z.string(),
});

export const MountTruckRequestRequired = z.object({
    truckId: z.string(),
});
export type MountTruckRequestRequired = z.infer<typeof MountTruckRequestRequired>;


			// method {DismountTruck map[] [] false false false false [] [0xc0006a2820] [] 0xc0005b06e0}






    

export const DismountTruckResponse = z.object({
        oldTruckId: z.optional(z.string()),
});

export const DismountTruckResponseRequired = z.object({
    oldTruckId: z.string(),
});
export type DismountTruckResponseRequired = z.infer<typeof DismountTruckResponseRequired>;


			// method {StampTruck map[] [] false false false false [0xc0006a28c0] [0xc0006a2960] [] 0xc0005b06e0}






    

export const StampTruckRequest = z.object({
        food: NewTruckStampFood,
});

export const StampTruckRequestRequired = z.object({
    food: NewTruckStampFood,
});
export type StampTruckRequestRequired = z.infer<typeof StampTruckRequestRequired>;








    

export const StampTruckResponse = z.object({
        stamp: TruckStamp,
});

export const StampTruckResponseRequired = z.object({
    stamp: TruckStamp,
});
export type StampTruckResponseRequired = z.infer<typeof StampTruckResponseRequired>;


			// method {UpsertSurchargeFlavor map[] [] false false false false [0xc0006a2a00] [0xc0006a2aa0] [] 0xc0005b06e0}






    

export const UpsertSurchargeFlavorRequest = z.object({
        food: NewSurchargeFlavorFood,
});

export const UpsertSurchargeFlavorRequestRequired = z.object({
    food: NewSurchargeFlavorFood,
});
export type UpsertSurchargeFlavorRequestRequired = z.infer<typeof UpsertSurchargeFlavorRequestRequired>;








    

export const UpsertSurchargeFlavorResponse = z.object({
        result: SurchargeFlavorUpsertResult,
});

export const UpsertSurchargeFlavorResponseRequired = z.object({
    result: SurchargeFlavorUpsertResult,
});
export type UpsertSurchargeFlavorResponseRequired = z.infer<typeof UpsertSurchargeFlavorResponseRequired>;


			// method {PatchSurchargeFlavor map[] [] false false false false [0xc0006a2b40 0xc0006a2be0] [0xc0006a2c80] [] 0xc0005b06e0}






    
    

export const PatchSurchargeFlavorRequest = z.object({
        flavorId: z.string(),
        patch: SurchargeFlavorPatch,
});

export const PatchSurchargeFlavorRequestRequired = z.object({
    flavorId: z.string(),
    patch: SurchargeFlavorPatch,
});
export type PatchSurchargeFlavorRequestRequired = z.infer<typeof PatchSurchargeFlavorRequestRequired>;








    

export const PatchSurchargeFlavorResponse = z.object({
        flavor: SurchargeFlavor,
});

export const PatchSurchargeFlavorResponseRequired = z.object({
    flavor: SurchargeFlavor,
});
export type PatchSurchargeFlavorResponseRequired = z.infer<typeof PatchSurchargeFlavorResponseRequired>;


			// method {RetireSurchargeFlavor map[] [] false false false false [0xc0006a2d20] [] [] 0xc0005b06e0}






    

export const RetireSurchargeFlavorRequest = z.object({
        flavorId: z.string(),
});

export const RetireSurchargeFlavorRequestRequired = z.object({
    flavorId: z.string(),
});
export type RetireSurchargeFlavorRequestRequired = z.infer<typeof RetireSurchargeFlavorRequestRequired>;


			// method {SpawnSurcharge map[] [] false false false false [0xc0006a2dc0] [0xc0006a2e60] [] 0xc0005b06e0}






    

export const SpawnSurchargeRequest = z.object({
        food: NewSurchargeFood,
});

export const SpawnSurchargeRequestRequired = z.object({
    food: NewSurchargeFood,
});
export type SpawnSurchargeRequestRequired = z.infer<typeof SpawnSurchargeRequestRequired>;








    

export const SpawnSurchargeResponse = z.object({
        surcharge: Surcharge,
});

export const SpawnSurchargeResponseRequired = z.object({
    surcharge: Surcharge,
});
export type SpawnSurchargeResponseRequired = z.infer<typeof SpawnSurchargeResponseRequired>;


			// method {PatchSurcharge map[] [] false false false false [0xc0006a2f00 0xc0006a2fa0 0xc0006a3040] [0xc0006a30e0] [] 0xc0005b06e0}






    
    
    

export const PatchSurchargeRequest = z.object({
        subjectClassname: SurchargeableClassname,
        surchargeId: z.string(),
        patch: SurchargePatch,
});

export const PatchSurchargeRequestRequired = z.object({
    subjectClassname: SurchargeableClassname,
    surchargeId: z.string(),
    patch: SurchargePatch,
});
export type PatchSurchargeRequestRequired = z.infer<typeof PatchSurchargeRequestRequired>;








    

export const PatchSurchargeResponse = z.object({
        surcharge: Surcharge,
});

export const PatchSurchargeResponseRequired = z.object({
    surcharge: Surcharge,
});
export type PatchSurchargeResponseRequired = z.infer<typeof PatchSurchargeResponseRequired>;


			// method {RetireSurcharge map[] [] false false false false [0xc0006a3180 0xc0006a3220] [] [] 0xc0005b06e0}






    
    

export const RetireSurchargeRequest = z.object({
        subjectClassname: SurchargeableClassname,
        surchargeId: z.string(),
});

export const RetireSurchargeRequestRequired = z.object({
    subjectClassname: SurchargeableClassname,
    surchargeId: z.string(),
});
export type RetireSurchargeRequestRequired = z.infer<typeof RetireSurchargeRequestRequired>;


			// method {UpsertShinwaJob map[] [] false false false false [0xc0006a32c0] [0xc0006a3360] [] 0xc0005b06e0}






    

export const UpsertShinwaJobRequest = z.object({
        food: UpsertableShinwaJob,
});

export const UpsertShinwaJobRequestRequired = z.object({
    food: UpsertableShinwaJob,
});
export type UpsertShinwaJobRequestRequired = z.infer<typeof UpsertShinwaJobRequestRequired>;








    

export const UpsertShinwaJobResponse = z.object({
        result: JobUpsertResult,
});

export const UpsertShinwaJobResponseRequired = z.object({
    result: JobUpsertResult,
});
export type UpsertShinwaJobResponseRequired = z.infer<typeof UpsertShinwaJobResponseRequired>;


			// method {UpsertSanyuJob map[] [] false false false false [0xc0006a3400] [0xc0006a34a0] [] 0xc0005b06e0}






    

export const UpsertSanyuJobRequest = z.object({
        food: UpsertableSanyuJob,
});

export const UpsertSanyuJobRequestRequired = z.object({
    food: UpsertableSanyuJob,
});
export type UpsertSanyuJobRequestRequired = z.infer<typeof UpsertSanyuJobRequestRequired>;








    

export const UpsertSanyuJobResponse = z.object({
        result: JobUpsertResult,
});

export const UpsertSanyuJobResponseRequired = z.object({
    result: JobUpsertResult,
});
export type UpsertSanyuJobResponseRequired = z.infer<typeof UpsertSanyuJobResponseRequired>;


			// method {PatchJob map[] [] false false false false [0xc0006a3540 0xc0006a35e0] [0xc0006a3680] [] 0xc0005b06e0}






    
    

export const PatchJobRequest = z.object({
        jobId: z.string(),
        patch: JobPatch,
});

export const PatchJobRequestRequired = z.object({
    jobId: z.string(),
    patch: JobPatch,
});
export type PatchJobRequestRequired = z.infer<typeof PatchJobRequestRequired>;








    

export const PatchJobResponse = z.object({
        job: Job,
});

export const PatchJobResponseRequired = z.object({
    job: Job,
});
export type PatchJobResponseRequired = z.infer<typeof PatchJobResponseRequired>;


			// method {StampJob map[] [] false false false false [0xc0006a3720] [0xc0006a37c0] [] 0xc0005b06e0}






    

export const StampJobRequest = z.object({
        food: NewJobStampFood,
});

export const StampJobRequestRequired = z.object({
    food: NewJobStampFood,
});
export type StampJobRequestRequired = z.infer<typeof StampJobRequestRequired>;








    

export const StampJobResponse = z.object({
        stamp: JobStamp,
});

export const StampJobResponseRequired = z.object({
    stamp: JobStamp,
});
export type StampJobResponseRequired = z.infer<typeof StampJobResponseRequired>;


			// method {CancelJobStamp map[] [] false false false false [0xc0006a3860] [] [] 0xc0005b06e0}






    

export const CancelJobStampRequest = z.object({
        stampId: z.string(),
});

export const CancelJobStampRequestRequired = z.object({
    stampId: z.string(),
});
export type CancelJobStampRequestRequired = z.infer<typeof CancelJobStampRequestRequired>;


			// method {SpawnGroundedBundle map[] [] false false false false [0xc0006a3900] [0xc0006a39a0] [] 0xc0005b06e0}






    

export const SpawnGroundedBundleRequest = z.object({
        food: NewGroundedBundleFood,
});

export const SpawnGroundedBundleRequestRequired = z.object({
    food: NewGroundedBundleFood,
});
export type SpawnGroundedBundleRequestRequired = z.infer<typeof SpawnGroundedBundleRequestRequired>;








    

export const SpawnGroundedBundleResponse = z.object({
        bundle: Bundle,
});

export const SpawnGroundedBundleResponseRequired = z.object({
    bundle: Bundle,
});
export type SpawnGroundedBundleResponseRequired = z.infer<typeof SpawnGroundedBundleResponseRequired>;


			// method {SpawnLoadedBundle map[] [] false false false false [0xc0006a3a40] [0xc0006a3ae0] [] 0xc0005b06e0}






    

export const SpawnLoadedBundleRequest = z.object({
        food: NewLoadedBundleFood,
});

export const SpawnLoadedBundleRequestRequired = z.object({
    food: NewLoadedBundleFood,
});
export type SpawnLoadedBundleRequestRequired = z.infer<typeof SpawnLoadedBundleRequestRequired>;








    

export const SpawnLoadedBundleResponse = z.object({
        bundle: Bundle,
});

export const SpawnLoadedBundleResponseRequired = z.object({
    bundle: Bundle,
});
export type SpawnLoadedBundleResponseRequired = z.infer<typeof SpawnLoadedBundleResponseRequired>;


			// method {PatchBundle map[] [] false false false false [0xc0006a3b80 0xc0006a3c20] [0xc0006a3cc0] [] 0xc0005b06e0}






    
    

export const PatchBundleRequest = z.object({
        bundleId: z.string(),
        patch: BundlePatch,
});

export const PatchBundleRequestRequired = z.object({
    bundleId: z.string(),
    patch: BundlePatch,
});
export type PatchBundleRequestRequired = z.infer<typeof PatchBundleRequestRequired>;








    

export const PatchBundleResponse = z.object({
        bundle: Bundle,
});

export const PatchBundleResponseRequired = z.object({
    bundle: Bundle,
});
export type PatchBundleResponseRequired = z.infer<typeof PatchBundleResponseRequired>;


			// method {StampBundle map[] [] false false false false [0xc0006a3d60] [0xc0006a3e00] [] 0xc0005b06e0}






    

export const StampBundleRequest = z.object({
        food: NewBundleStampFood,
});

export const StampBundleRequestRequired = z.object({
    food: NewBundleStampFood,
});
export type StampBundleRequestRequired = z.infer<typeof StampBundleRequestRequired>;








    

export const StampBundleResponse = z.object({
        stamp: BundleStamp,
});

export const StampBundleResponseRequired = z.object({
    stamp: BundleStamp,
});
export type StampBundleResponseRequired = z.infer<typeof StampBundleResponseRequired>;


			// method {FieldCancelBundle map[] [] false false false false [0xc0006a3ea0] [] [] 0xc0005b06e0}






    

export const FieldCancelBundleRequest = z.object({
        bundleId: z.string(),
});

export const FieldCancelBundleRequestRequired = z.object({
    bundleId: z.string(),
});
export type FieldCancelBundleRequestRequired = z.infer<typeof FieldCancelBundleRequestRequired>;


			// method {RetireBundle map[] [] false false false false [0xc0006a6000 0xc0006a60a0] [] [] 0xc0005b06e0}






    
    

export const RetireBundleRequest = z.object({
        bundleId: z.string(),
        deep: z.boolean(),
});

export const RetireBundleRequestRequired = z.object({
    bundleId: z.string(),
    deep: z.boolean(),
});
export type RetireBundleRequestRequired = z.infer<typeof RetireBundleRequestRequired>;


			// method {ScheduleBundlePickup map[] [] false false false false [0xc0006a6140] [0xc0006a61e0] [] 0xc0005b06e0}






    

export const ScheduleBundlePickupRequest = z.object({
        food: NewScheduledPickupFood,
});

export const ScheduleBundlePickupRequestRequired = z.object({
    food: NewScheduledPickupFood,
});
export type ScheduleBundlePickupRequestRequired = z.infer<typeof ScheduleBundlePickupRequestRequired>;








    

export const ScheduleBundlePickupResponse = z.object({
        scheduledTransfer: ScheduledTransfer,
});

export const ScheduleBundlePickupResponseRequired = z.object({
    scheduledTransfer: ScheduledTransfer,
});
export type ScheduleBundlePickupResponseRequired = z.infer<typeof ScheduleBundlePickupResponseRequired>;


			// method {ScheduleBundleDropoff map[] [] false false false false [0xc0006a6280] [0xc0006a6320] [] 0xc0005b06e0}






    

export const ScheduleBundleDropoffRequest = z.object({
        food: NewScheduledDropoffFood,
});

export const ScheduleBundleDropoffRequestRequired = z.object({
    food: NewScheduledDropoffFood,
});
export type ScheduleBundleDropoffRequestRequired = z.infer<typeof ScheduleBundleDropoffRequestRequired>;








    

export const ScheduleBundleDropoffResponse = z.object({
        scheduledTransfer: ScheduledTransfer,
});

export const ScheduleBundleDropoffResponseRequired = z.object({
    scheduledTransfer: ScheduledTransfer,
});
export type ScheduleBundleDropoffResponseRequired = z.infer<typeof ScheduleBundleDropoffResponseRequired>;


			// method {PatchScheduledTransfer map[] [] false false false false [0xc0006a63c0 0xc0006a6460] [0xc0006a6500] [] 0xc0005b06e0}






    
    

export const PatchScheduledTransferRequest = z.object({
        transferId: z.string(),
        patch: ScheduledTransferPatch,
});

export const PatchScheduledTransferRequestRequired = z.object({
    transferId: z.string(),
    patch: ScheduledTransferPatch,
});
export type PatchScheduledTransferRequestRequired = z.infer<typeof PatchScheduledTransferRequestRequired>;








    

export const PatchScheduledTransferResponse = z.object({
        scheduledTransfer: ScheduledTransfer,
});

export const PatchScheduledTransferResponseRequired = z.object({
    scheduledTransfer: ScheduledTransfer,
});
export type PatchScheduledTransferResponseRequired = z.infer<typeof PatchScheduledTransferResponseRequired>;


			// method {CancelScheduledTransfer map[] [] false false false false [0xc0006a65a0] [] [] 0xc0005b06e0}






    

export const CancelScheduledTransferRequest = z.object({
        transferId: z.string(),
});

export const CancelScheduledTransferRequestRequired = z.object({
    transferId: z.string(),
});
export type CancelScheduledTransferRequestRequired = z.infer<typeof CancelScheduledTransferRequestRequired>;


			// method {DisclaimScheduledTransfer map[] [] false false false false [0xc0006a6640 0xc0006a66e0] [] [] 0xc0005b06e0}






    
    

export const DisclaimScheduledTransferRequest = z.object({
        transferId: z.string(),
        removeTruck: z.optional(z.boolean()),
});

export const DisclaimScheduledTransferRequestRequired = z.object({
    transferId: z.string(),
    removeTruck: z.boolean(),
});
export type DisclaimScheduledTransferRequestRequired = z.infer<typeof DisclaimScheduledTransferRequestRequired>;


			// method {DisclaimAllMyScheduledTransfers map[] [] false false false false [] [] [] 0xc0005b06e0}
			// method {StartTripleg map[] [] false false false false [0xc0006a6780] [0xc0006a6820] [] 0xc0005b06e0}






    

export const StartTriplegRequest = z.object({
        food: NewTriplegFood,
});

export const StartTriplegRequestRequired = z.object({
    food: NewTriplegFood,
});
export type StartTriplegRequestRequired = z.infer<typeof StartTriplegRequestRequired>;








    

export const StartTriplegResponse = z.object({
        tripleg: Tripleg,
});

export const StartTriplegResponseRequired = z.object({
    tripleg: Tripleg,
});
export type StartTriplegResponseRequired = z.infer<typeof StartTriplegResponseRequired>;


			// method {PatchTripleg map[] [] false false false false [0xc0006a68c0 0xc0006a6960] [0xc0006a6a00] [] 0xc0005b06e0}






    
    

export const PatchTriplegRequest = z.object({
        triplegId: z.string(),
        patch: TriplegPatch,
});

export const PatchTriplegRequestRequired = z.object({
    triplegId: z.string(),
    patch: TriplegPatch,
});
export type PatchTriplegRequestRequired = z.infer<typeof PatchTriplegRequestRequired>;








    

export const PatchTriplegResponse = z.object({
        tripleg: Tripleg,
});

export const PatchTriplegResponseRequired = z.object({
    tripleg: Tripleg,
});
export type PatchTriplegResponseRequired = z.infer<typeof PatchTriplegResponseRequired>;


			// method {Arrive map[] [] false false false false [0xc0006a6aa0] [] [] 0xc0005b06e0}






    

export const ArriveRequest = z.object({
        triplegId: z.string(),
});

export const ArriveRequestRequired = z.object({
    triplegId: z.string(),
});
export type ArriveRequestRequired = z.infer<typeof ArriveRequestRequired>;


			// method {Admit map[] [] false false false false [0xc0006a6b40] [] [] 0xc0005b06e0}






    

export const AdmitRequest = z.object({
        triplegId: z.string(),
});

export const AdmitRequestRequired = z.object({
    triplegId: z.string(),
});
export type AdmitRequestRequired = z.infer<typeof AdmitRequestRequired>;


			// method {StartBundleOnloading map[] [] false false false false [0xc0006a6be0 0xc0006a6c80] [0xc0006a6d20] [] 0xc0005b06e0}






    
    

export const StartBundleOnloadingRequest = z.object({
        bundleId: z.string(),
        truckId: z.string(),
});

export const StartBundleOnloadingRequestRequired = z.object({
    bundleId: z.string(),
    truckId: z.string(),
});
export type StartBundleOnloadingRequestRequired = z.infer<typeof StartBundleOnloadingRequestRequired>;








    

export const StartBundleOnloadingResponse = z.object({
        transfer: Transfer,
});

export const StartBundleOnloadingResponseRequired = z.object({
    transfer: Transfer,
});
export type StartBundleOnloadingResponseRequired = z.infer<typeof StartBundleOnloadingResponseRequired>;


			// method {CompleteBundleOnloading map[] [] false false false false [0xc0006a6dc0] [0xc0006a6e60] [] 0xc0005b06e0}






    

export const CompleteBundleOnloadingRequest = z.object({
        bundleId: z.string(),
});

export const CompleteBundleOnloadingRequestRequired = z.object({
    bundleId: z.string(),
});
export type CompleteBundleOnloadingRequestRequired = z.infer<typeof CompleteBundleOnloadingRequestRequired>;








    

export const CompleteBundleOnloadingResponse = z.object({
        transfer: Transfer,
});

export const CompleteBundleOnloadingResponseRequired = z.object({
    transfer: Transfer,
});
export type CompleteBundleOnloadingResponseRequired = z.infer<typeof CompleteBundleOnloadingResponseRequired>;


			// method {StartBundleOffloading map[] [] false false false false [0xc0006a6f00 0xc0006a6fa0] [0xc0006a7040] [] 0xc0005b06e0}






    
    

export const StartBundleOffloadingRequest = z.object({
        bundleId: z.string(),
        venueId: z.string(),
});

export const StartBundleOffloadingRequestRequired = z.object({
    bundleId: z.string(),
    venueId: z.string(),
});
export type StartBundleOffloadingRequestRequired = z.infer<typeof StartBundleOffloadingRequestRequired>;








    

export const StartBundleOffloadingResponse = z.object({
        transfer: Transfer,
});

export const StartBundleOffloadingResponseRequired = z.object({
    transfer: Transfer,
});
export type StartBundleOffloadingResponseRequired = z.infer<typeof StartBundleOffloadingResponseRequired>;


			// method {CompleteBundleOffloading map[] [] false false false false [0xc0006a70e0] [0xc0006a7180] [] 0xc0005b06e0}






    

export const CompleteBundleOffloadingRequest = z.object({
        bundleId: z.string(),
});

export const CompleteBundleOffloadingRequestRequired = z.object({
    bundleId: z.string(),
});
export type CompleteBundleOffloadingRequestRequired = z.infer<typeof CompleteBundleOffloadingRequestRequired>;








    

export const CompleteBundleOffloadingResponse = z.object({
        transfer: Transfer,
});

export const CompleteBundleOffloadingResponseRequired = z.object({
    transfer: Transfer,
});
export type CompleteBundleOffloadingResponseRequired = z.infer<typeof CompleteBundleOffloadingResponseRequired>;


			// method {UpsertUnit map[] [] false false false false [0xc0006a7220] [0xc0006a72c0] [] 0xc0005b06e0}






    

export const UpsertUnitRequest = z.object({
        food: NewUnitFood,
});

export const UpsertUnitRequestRequired = z.object({
    food: NewUnitFood,
});
export type UpsertUnitRequestRequired = z.infer<typeof UpsertUnitRequestRequired>;








    

export const UpsertUnitResponse = z.object({
        result: UnitUpsertResult,
});

export const UpsertUnitResponseRequired = z.object({
    result: UnitUpsertResult,
});
export type UpsertUnitResponseRequired = z.infer<typeof UpsertUnitResponseRequired>;


			// method {UpsertWasteFlavor map[] [] false false false false [0xc0006a7360] [0xc0006a7400] [] 0xc0005b06e0}






    

export const UpsertWasteFlavorRequest = z.object({
        food: NewWasteFlavorFood,
});

export const UpsertWasteFlavorRequestRequired = z.object({
    food: NewWasteFlavorFood,
});
export type UpsertWasteFlavorRequestRequired = z.infer<typeof UpsertWasteFlavorRequestRequired>;








    

export const UpsertWasteFlavorResponse = z.object({
        result: WasteFlavorUpsertResult,
});

export const UpsertWasteFlavorResponseRequired = z.object({
    result: WasteFlavorUpsertResult,
});
export type UpsertWasteFlavorResponseRequired = z.infer<typeof UpsertWasteFlavorResponseRequired>;


			// method {PatchWasteFlavor map[] [] false false false false [0xc0006a74a0 0xc0006a7540] [0xc0006a75e0] [] 0xc0005b06e0}






    
    

export const PatchWasteFlavorRequest = z.object({
        flavorId: z.string(),
        patch: WasteFlavorPatch,
});

export const PatchWasteFlavorRequestRequired = z.object({
    flavorId: z.string(),
    patch: WasteFlavorPatch,
});
export type PatchWasteFlavorRequestRequired = z.infer<typeof PatchWasteFlavorRequestRequired>;








    

export const PatchWasteFlavorResponse = z.object({
        flavor: WasteFlavor,
});

export const PatchWasteFlavorResponseRequired = z.object({
    flavor: WasteFlavor,
});
export type PatchWasteFlavorResponseRequired = z.infer<typeof PatchWasteFlavorResponseRequired>;


			// method {RetireWasteFlavor map[] [] false false false false [0xc0006a7680] [] [] 0xc0005b06e0}






    

export const RetireWasteFlavorRequest = z.object({
        flavorId: z.string(),
});

export const RetireWasteFlavorRequestRequired = z.object({
    flavorId: z.string(),
});
export type RetireWasteFlavorRequestRequired = z.infer<typeof RetireWasteFlavorRequestRequired>;


			// method {UpsertWasteFlavorRecipe map[] [] false false false false [0xc0006a7720 0xc0006a77c0] [] [] 0xc0005b06e0}






    
    

export const UpsertWasteFlavorRecipeRequest = z.object({
        sourceId: z.string(),
        sinkId: z.string(),
});

export const UpsertWasteFlavorRecipeRequestRequired = z.object({
    sourceId: z.string(),
    sinkId: z.string(),
});
export type UpsertWasteFlavorRecipeRequestRequired = z.infer<typeof UpsertWasteFlavorRecipeRequestRequired>;


			// method {DeleteWasteFlavorRecipe map[] [] false false false false [0xc0006a7860 0xc0006a7900] [] [] 0xc0005b06e0}






    
    

export const DeleteWasteFlavorRecipeRequest = z.object({
        sourceId: z.string(),
        sinkId: z.string(),
});

export const DeleteWasteFlavorRecipeRequestRequired = z.object({
    sourceId: z.string(),
    sinkId: z.string(),
});
export type DeleteWasteFlavorRecipeRequestRequired = z.infer<typeof DeleteWasteFlavorRecipeRequestRequired>;


			// method {UpsertPackingMode map[] [] false false false false [0xc0006a79a0] [0xc0006a7a40] [] 0xc0005b06e0}






    

export const UpsertPackingModeRequest = z.object({
        food: UpsertablePackingMode,
});

export const UpsertPackingModeRequestRequired = z.object({
    food: UpsertablePackingMode,
});
export type UpsertPackingModeRequestRequired = z.infer<typeof UpsertPackingModeRequestRequired>;








    

export const UpsertPackingModeResponse = z.object({
        result: PackingModeUpsertResult,
});

export const UpsertPackingModeResponseRequired = z.object({
    result: PackingModeUpsertResult,
});
export type UpsertPackingModeResponseRequired = z.infer<typeof UpsertPackingModeResponseRequired>;


			// method {UpsertManifestType map[] [] false false false false [0xc0006a7ae0] [0xc0006a7b80] [] 0xc0005b06e0}






    

export const UpsertManifestTypeRequest = z.object({
        food: UpsertableManifestType,
});

export const UpsertManifestTypeRequestRequired = z.object({
    food: UpsertableManifestType,
});
export type UpsertManifestTypeRequestRequired = z.infer<typeof UpsertManifestTypeRequestRequired>;








    

export const UpsertManifestTypeResponse = z.object({
        result: ManifestTypeUpsertResult,
});

export const UpsertManifestTypeResponseRequired = z.object({
    result: ManifestTypeUpsertResult,
});
export type UpsertManifestTypeResponseRequired = z.infer<typeof UpsertManifestTypeResponseRequired>;


			// method {SpawnWaste map[] [] false false false false [0xc0006a7c20] [0xc0006a7cc0] [] 0xc0005b06e0}






    

export const SpawnWasteRequest = z.object({
        food: NewWasteFood,
});

export const SpawnWasteRequestRequired = z.object({
    food: NewWasteFood,
});
export type SpawnWasteRequestRequired = z.infer<typeof SpawnWasteRequestRequired>;








    

export const SpawnWasteResponse = z.object({
        waste: Waste,
});

export const SpawnWasteResponseRequired = z.object({
    waste: Waste,
});
export type SpawnWasteResponseRequired = z.infer<typeof SpawnWasteResponseRequired>;


			// method {PatchWaste map[] [] false false false false [0xc0006a7d60 0xc0006a7e00] [0xc0006a7ea0] [] 0xc0005b06e0}






    
    

export const PatchWasteRequest = z.object({
        wasteId: z.string(),
        patch: WastePatch,
});

export const PatchWasteRequestRequired = z.object({
    wasteId: z.string(),
    patch: WastePatch,
});
export type PatchWasteRequestRequired = z.infer<typeof PatchWasteRequestRequired>;








    

export const PatchWasteResponse = z.object({
        waste: Waste,
});

export const PatchWasteResponseRequired = z.object({
    waste: Waste,
});
export type PatchWasteResponseRequired = z.infer<typeof PatchWasteResponseRequired>;


			// method {StampWaste map[] [] false false false false [0xc0006a8000] [0xc0006a80a0] [] 0xc0005b06e0}






    

export const StampWasteRequest = z.object({
        food: NewWasteStampFood,
});

export const StampWasteRequestRequired = z.object({
    food: NewWasteStampFood,
});
export type StampWasteRequestRequired = z.infer<typeof StampWasteRequestRequired>;








    

export const StampWasteResponse = z.object({
        stamp: WasteStamp,
});

export const StampWasteResponseRequired = z.object({
    stamp: WasteStamp,
});
export type StampWasteResponseRequired = z.infer<typeof StampWasteResponseRequired>;


			// method {AttachWasteToBundle map[] [you probably only want to call one or the other of these] false false false false [0xc0006a8140 0xc0006a81e0] [] [] 0xc0005b06e0}






    
    

export const AttachWasteToBundleRequest = z.object({
        bundleId: z.string(),
        wasteId: z.string(),
});

export const AttachWasteToBundleRequestRequired = z.object({
    bundleId: z.string(),
    wasteId: z.string(),
});
export type AttachWasteToBundleRequestRequired = z.infer<typeof AttachWasteToBundleRequestRequired>;


			// method {AttachWasteToJob map[] [] false false false false [0xc0006a8280 0xc0006a8320 0xc0006a83c0] [] [] 0xc0005b06e0}






    
    
    

export const AttachWasteToJobRequest = z.object({
        jobId: z.string(),
        originId: z.string(),
        wasteId: z.string(),
});

export const AttachWasteToJobRequestRequired = z.object({
    jobId: z.string(),
    originId: z.string(),
    wasteId: z.string(),
});
export type AttachWasteToJobRequestRequired = z.infer<typeof AttachWasteToJobRequestRequired>;


			// method {DetachWasteFromBundle map[] [] false false false false [0xc0006a8460] [] [] 0xc0005b06e0}






    

export const DetachWasteFromBundleRequest = z.object({
        wasteId: z.string(),
});

export const DetachWasteFromBundleRequestRequired = z.object({
    wasteId: z.string(),
});
export type DetachWasteFromBundleRequestRequired = z.infer<typeof DetachWasteFromBundleRequestRequired>;


			// method {StoreWasteTemporary map[] [] false false false false [0xc0006a8500 0xc0006a85a0] [] [] 0xc0005b06e0}






    
    

export const StoreWasteTemporaryRequest = z.object({
        wasteId: z.string(),
        venueId: z.string(),
});

export const StoreWasteTemporaryRequestRequired = z.object({
    wasteId: z.string(),
    venueId: z.string(),
});
export type StoreWasteTemporaryRequestRequired = z.infer<typeof StoreWasteTemporaryRequestRequired>;


			// method {StoreWastePermanent map[] [] false false false false [0xc0006a8640 0xc0006a86e0] [] [] 0xc0005b06e0}






    
    

export const StoreWastePermanentRequest = z.object({
        wasteId: z.string(),
        venueId: z.string(),
});

export const StoreWastePermanentRequestRequired = z.object({
    wasteId: z.string(),
    venueId: z.string(),
});
export type StoreWastePermanentRequestRequired = z.infer<typeof StoreWastePermanentRequestRequired>;


			// method {DivideFromWaste map[] [] false false false false [0xc0006a8780 0xc0006a8820] [0xc0006a88c0] [] 0xc0005b06e0}






    
    

export const DivideFromWasteRequest = z.object({
        oyaId: z.string(),
        food: NewWasteFood,
});

export const DivideFromWasteRequestRequired = z.object({
    oyaId: z.string(),
    food: NewWasteFood,
});
export type DivideFromWasteRequestRequired = z.infer<typeof DivideFromWasteRequestRequired>;








    

export const DivideFromWasteResponse = z.object({
        daughter: Waste,
});

export const DivideFromWasteResponseRequired = z.object({
    daughter: Waste,
});
export type DivideFromWasteResponseRequired = z.infer<typeof DivideFromWasteResponseRequired>;


			// method {MergeIntoWaste map[] [] false false false false [0xc0006a8960 0xc0006a8a00] [] [] 0xc0005b06e0}






    
    

export const MergeIntoWasteRequest = z.object({
        dyingId: z.string(),
        receivingId: z.string(),
});

export const MergeIntoWasteRequestRequired = z.object({
    dyingId: z.string(),
    receivingId: z.string(),
});
export type MergeIntoWasteRequestRequired = z.infer<typeof MergeIntoWasteRequestRequired>;


			// method {RetireWaste map[] [] false false false false [0xc0006a8aa0] [] [] 0xc0005b06e0}






    

export const RetireWasteRequest = z.object({
        wasteId: z.string(),
});

export const RetireWasteRequestRequired = z.object({
    wasteId: z.string(),
});
export type RetireWasteRequestRequired = z.infer<typeof RetireWasteRequestRequired>;


			// method {UpsertTransformMode map[] [] false false false false [0xc0006a8b40] [0xc0006a8be0] [] 0xc0005b06e0}






    

export const UpsertTransformModeRequest = z.object({
        food: UpsertableTransformMode,
});

export const UpsertTransformModeRequestRequired = z.object({
    food: UpsertableTransformMode,
});
export type UpsertTransformModeRequestRequired = z.infer<typeof UpsertTransformModeRequestRequired>;








    

export const UpsertTransformModeResponse = z.object({
        result: TransformModeUpsertResult,
});

export const UpsertTransformModeResponseRequired = z.object({
    result: TransformModeUpsertResult,
});
export type UpsertTransformModeResponseRequired = z.infer<typeof UpsertTransformModeResponseRequired>;


			// method {AdoptTransformMode map[] [] false false false false [0xc0006a8c80] [] [] 0xc0005b06e0}






    

export const AdoptTransformModeRequest = z.object({
        modeId: z.string(),
});

export const AdoptTransformModeRequestRequired = z.object({
    modeId: z.string(),
});
export type AdoptTransformModeRequestRequired = z.infer<typeof AdoptTransformModeRequestRequired>;


			// method {AbandonTransformMode map[] [] false false false false [0xc0006a8d20] [] [] 0xc0005b06e0}






    

export const AbandonTransformModeRequest = z.object({
        modeId: z.string(),
});

export const AbandonTransformModeRequestRequired = z.object({
    modeId: z.string(),
});
export type AbandonTransformModeRequestRequired = z.infer<typeof AbandonTransformModeRequestRequired>;


			// method {AttachPhotoToStamp map[] [] false false false false [0xc0006a8dc0 0xc0006a8e60 0xc0006a8f00] [] [] 0xc0005b06e0}






    
    
    

export const AttachPhotoToStampRequest = z.object({
        subjectClass: StampableClassname,
        stampId: z.string(),
        photoSlug: z.string(),
});

export const AttachPhotoToStampRequestRequired = z.object({
    subjectClass: StampableClassname,
    stampId: z.string(),
    photoSlug: z.string(),
});
export type AttachPhotoToStampRequestRequired = z.infer<typeof AttachPhotoToStampRequestRequired>;


			// method {RewindToCheckpoint map[] [] false false false false [0xc0006a8fa0] [] [] 0xc0005b06e0}






    

export const RewindToCheckpointRequest = z.object({
        checkpointId: z.string(),
});

export const RewindToCheckpointRequestRequired = z.object({
    checkpointId: z.string(),
});
export type RewindToCheckpointRequestRequired = z.infer<typeof RewindToCheckpointRequestRequired>;


			// method {SpawnCheckpoint map[] [] false false false false [0xc0006a9040] [0xc0006a90e0] [] 0xc0005b06e0}






    

export const SpawnCheckpointRequest = z.object({
        name: z.string(),
});

export const SpawnCheckpointRequestRequired = z.object({
    name: z.string(),
});
export type SpawnCheckpointRequestRequired = z.infer<typeof SpawnCheckpointRequestRequired>;








    

export const SpawnCheckpointResponse = z.object({
        checkpoint: RewindCheckpoint,
});

export const SpawnCheckpointResponseRequired = z.object({
    checkpoint: RewindCheckpoint,
});
export type SpawnCheckpointResponseRequired = z.infer<typeof SpawnCheckpointResponseRequired>;



export const RpcVerbMap = {

		Ping: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("Ping")]),
			

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},
					

		Login: {
			hasInput: true,
			requestSchema: LoginRequest,
			tqkSchema: z.tuple([z.literal("Login"), LoginRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("Login"), z.optional(LoginRequest)]),

			returnEnvelope: "jwt",
			responseSchema: LoginResponse,
			unwrapResponse: (rpc: LoginResponse) => rpc.jwt,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},
					

		RefreshAuthToken: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("RefreshAuthToken")]),
			

			returnEnvelope: "jwt",
			responseSchema: RefreshAuthTokenResponse,
			unwrapResponse: (rpc: RefreshAuthTokenResponse) => rpc.jwt,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		Self: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("Self")]),
			

			returnEnvelope: "srv",
			responseSchema: SelfResponse,
			unwrapResponse: (rpc: SelfResponse) => rpc.srv,
//			returnLetterSchema: SelfResult,
//			returnLetterTypeName: "SelfResult",
		},

		Logout: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("Logout")]),
			

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		GetSystemConfig: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("GetSystemConfig")]),
			

			returnEnvelope: "config",
			responseSchema: GetSystemConfigResponse,
			unwrapResponse: (rpc: GetSystemConfigResponse) => rpc.config,
//			returnLetterSchema: SystemConfig,
//			returnLetterTypeName: "SystemConfig",
		},

		GetVersionInfo: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("GetVersionInfo")]),
			

			returnEnvelope: "vinfo",
			responseSchema: GetVersionInfoResponse,
			unwrapResponse: (rpc: GetVersionInfoResponse) => rpc.vinfo,
//			returnLetterSchema: VersionInfo,
//			returnLetterTypeName: "VersionInfo",
		},
				
				

		CompanyById: {
			hasInput: true,
			requestSchema: WatchCompanyByIdRequest,
			tqkSchema: z.tuple([z.literal("CompanyById"), WatchCompanyByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompanyById"), z.optional(WatchCompanyByIdRequest)]),

			returnEnvelope: "company",
			responseSchema: WatchCompanyByIdResponse,
			unwrapResponse: (rpc: WatchCompanyByIdResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},

		LastValidCompanyById: {
			hasInput: true,
			requestSchema: LastValidCompanyByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidCompanyById"), LastValidCompanyByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidCompanyById"), z.optional(LastValidCompanyByIdRequest)]),

			returnEnvelope: "company",
			responseSchema: LastValidCompanyByIdResponse,
			unwrapResponse: (rpc: LastValidCompanyByIdResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},

		CompanyByIdAsof: {
			hasInput: true,
			requestSchema: CompanyByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("CompanyByIdAsof"), CompanyByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompanyByIdAsof"), z.optional(CompanyByIdAsofRequest)]),

			returnEnvelope: "company",
			responseSchema: CompanyByIdAsofResponse,
			unwrapResponse: (rpc: CompanyByIdAsofResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},
					

		CompanyRevisionCount: {
			hasInput: true,
			requestSchema: CompanyRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("CompanyRevisionCount"), CompanyRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompanyRevisionCount"), z.optional(CompanyRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: CompanyRevisionCountResponse,
			unwrapResponse: (rpc: CompanyRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllCompanyRevisions: {
			hasInput: true,
			requestSchema: AllCompanyRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllCompanyRevisions"), AllCompanyRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllCompanyRevisions"), z.optional(AllCompanyRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllCompanyRevisionsResponse,
			unwrapResponse: (rpc: AllCompanyRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Company.array(),
//			returnLetterTypeName: "Company",
		},
				
				

		CompanyByCode: {
			hasInput: true,
			requestSchema: WatchCompanyByCodeRequest,
			tqkSchema: z.tuple([z.literal("CompanyByCode"), WatchCompanyByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompanyByCode"), z.optional(WatchCompanyByCodeRequest)]),

			returnEnvelope: "company",
			responseSchema: WatchCompanyByCodeResponse,
			unwrapResponse: (rpc: WatchCompanyByCodeResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},

		LastValidCompanyByCode: {
			hasInput: true,
			requestSchema: LastValidCompanyByCodeRequest,
			tqkSchema: z.tuple([z.literal("LastValidCompanyByCode"), LastValidCompanyByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidCompanyByCode"), z.optional(LastValidCompanyByCodeRequest)]),

			returnEnvelope: "company",
			responseSchema: LastValidCompanyByCodeResponse,
			unwrapResponse: (rpc: LastValidCompanyByCodeResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},

		CompanyByCodeAsof: {
			hasInput: true,
			requestSchema: CompanyByCodeAsofRequest,
			tqkSchema: z.tuple([z.literal("CompanyByCodeAsof"), CompanyByCodeAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompanyByCodeAsof"), z.optional(CompanyByCodeAsofRequest)]),

			returnEnvelope: "company",
			responseSchema: CompanyByCodeAsofResponse,
			unwrapResponse: (rpc: CompanyByCodeAsofResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},
				
				

		CompaniesByNameFragment: {
			hasInput: true,
			requestSchema: WatchCompaniesByNameFragmentRequest,
			tqkSchema: z.tuple([z.literal("CompaniesByNameFragment"), WatchCompaniesByNameFragmentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompaniesByNameFragment"), z.optional(WatchCompaniesByNameFragmentRequest)]),

			returnEnvelope: "companies",
			responseSchema: WatchCompaniesByNameFragmentResponse,
			unwrapResponse: (rpc: WatchCompaniesByNameFragmentResponse) => rpc.companies,
//			returnLetterSchema: CompanyStub.array(),
//			returnLetterTypeName: "CompanyStub",
		},
				
				

		VenueById: {
			hasInput: true,
			requestSchema: WatchVenueByIdRequest,
			tqkSchema: z.tuple([z.literal("VenueById"), WatchVenueByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueById"), z.optional(WatchVenueByIdRequest)]),

			returnEnvelope: "venue",
			responseSchema: WatchVenueByIdResponse,
			unwrapResponse: (rpc: WatchVenueByIdResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		LastValidVenueById: {
			hasInput: true,
			requestSchema: LastValidVenueByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidVenueById"), LastValidVenueByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidVenueById"), z.optional(LastValidVenueByIdRequest)]),

			returnEnvelope: "venue",
			responseSchema: LastValidVenueByIdResponse,
			unwrapResponse: (rpc: LastValidVenueByIdResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		VenueByIdAsof: {
			hasInput: true,
			requestSchema: VenueByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("VenueByIdAsof"), VenueByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueByIdAsof"), z.optional(VenueByIdAsofRequest)]),

			returnEnvelope: "venue",
			responseSchema: VenueByIdAsofResponse,
			unwrapResponse: (rpc: VenueByIdAsofResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},
					

		VenueRevisionCount: {
			hasInput: true,
			requestSchema: VenueRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("VenueRevisionCount"), VenueRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueRevisionCount"), z.optional(VenueRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: VenueRevisionCountResponse,
			unwrapResponse: (rpc: VenueRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllVenueRevisions: {
			hasInput: true,
			requestSchema: AllVenueRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllVenueRevisions"), AllVenueRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllVenueRevisions"), z.optional(AllVenueRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllVenueRevisionsResponse,
			unwrapResponse: (rpc: AllVenueRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Venue.array(),
//			returnLetterTypeName: "Venue",
		},
				
				

		AdmittersOnDutyForVenue: {
			hasInput: true,
			requestSchema: WatchAdmittersOnDutyForVenueRequest,
			tqkSchema: z.tuple([z.literal("AdmittersOnDutyForVenue"), WatchAdmittersOnDutyForVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AdmittersOnDutyForVenue"), z.optional(WatchAdmittersOnDutyForVenueRequest)]),

			returnEnvelope: "admitters",
			responseSchema: WatchAdmittersOnDutyForVenueResponse,
			unwrapResponse: (rpc: WatchAdmittersOnDutyForVenueResponse) => rpc.admitters,
//			returnLetterSchema: AgentStub.array(),
//			returnLetterTypeName: "AgentStub",
		},
				
				

		VenueByCode: {
			hasInput: true,
			requestSchema: WatchVenueByCodeRequest,
			tqkSchema: z.tuple([z.literal("VenueByCode"), WatchVenueByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueByCode"), z.optional(WatchVenueByCodeRequest)]),

			returnEnvelope: "venue",
			responseSchema: WatchVenueByCodeResponse,
			unwrapResponse: (rpc: WatchVenueByCodeResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		LastValidVenueByCode: {
			hasInput: true,
			requestSchema: LastValidVenueByCodeRequest,
			tqkSchema: z.tuple([z.literal("LastValidVenueByCode"), LastValidVenueByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidVenueByCode"), z.optional(LastValidVenueByCodeRequest)]),

			returnEnvelope: "venue",
			responseSchema: LastValidVenueByCodeResponse,
			unwrapResponse: (rpc: LastValidVenueByCodeResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		VenueByCodeAsof: {
			hasInput: true,
			requestSchema: VenueByCodeAsofRequest,
			tqkSchema: z.tuple([z.literal("VenueByCodeAsof"), VenueByCodeAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueByCodeAsof"), z.optional(VenueByCodeAsofRequest)]),

			returnEnvelope: "venue",
			responseSchema: VenueByCodeAsofResponse,
			unwrapResponse: (rpc: VenueByCodeAsofResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},
				
				

		VenueByName: {
			hasInput: true,
			requestSchema: WatchVenueByNameRequest,
			tqkSchema: z.tuple([z.literal("VenueByName"), WatchVenueByNameRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueByName"), z.optional(WatchVenueByNameRequest)]),

			returnEnvelope: "venue",
			responseSchema: WatchVenueByNameResponse,
			unwrapResponse: (rpc: WatchVenueByNameResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		LastValidVenueByName: {
			hasInput: true,
			requestSchema: LastValidVenueByNameRequest,
			tqkSchema: z.tuple([z.literal("LastValidVenueByName"), LastValidVenueByNameRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidVenueByName"), z.optional(LastValidVenueByNameRequest)]),

			returnEnvelope: "venue",
			responseSchema: LastValidVenueByNameResponse,
			unwrapResponse: (rpc: LastValidVenueByNameResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		VenueByNameAsof: {
			hasInput: true,
			requestSchema: VenueByNameAsofRequest,
			tqkSchema: z.tuple([z.literal("VenueByNameAsof"), VenueByNameAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("VenueByNameAsof"), z.optional(VenueByNameAsofRequest)]),

			returnEnvelope: "venue",
			responseSchema: VenueByNameAsofResponse,
			unwrapResponse: (rpc: VenueByNameAsofResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		DownstreamVenues: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("DownstreamVenues")]),
			

			returnEnvelope: "venues",
			responseSchema: DownstreamVenuesResponse,
			unwrapResponse: (rpc: DownstreamVenuesResponse) => rpc.venues,
//			returnLetterSchema: VenueStub.array(),
//			returnLetterTypeName: "VenueStub",
		},
				
				

		TrucksDockedAt: {
			hasInput: true,
			requestSchema: WatchTrucksDockedAtRequest,
			tqkSchema: z.tuple([z.literal("TrucksDockedAt"), WatchTrucksDockedAtRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TrucksDockedAt"), z.optional(WatchTrucksDockedAtRequest)]),

			returnEnvelope: "trucks",
			responseSchema: WatchTrucksDockedAtResponse,
			unwrapResponse: (rpc: WatchTrucksDockedAtResponse) => rpc.trucks,
//			returnLetterSchema: TruckStub.array(),
//			returnLetterTypeName: "TruckStub",
		},
				
				

		AgentById: {
			hasInput: true,
			requestSchema: WatchAgentByIdRequest,
			tqkSchema: z.tuple([z.literal("AgentById"), WatchAgentByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentById"), z.optional(WatchAgentByIdRequest)]),

			returnEnvelope: "agent",
			responseSchema: WatchAgentByIdResponse,
			unwrapResponse: (rpc: WatchAgentByIdResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		LastValidAgentById: {
			hasInput: true,
			requestSchema: LastValidAgentByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidAgentById"), LastValidAgentByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidAgentById"), z.optional(LastValidAgentByIdRequest)]),

			returnEnvelope: "agent",
			responseSchema: LastValidAgentByIdResponse,
			unwrapResponse: (rpc: LastValidAgentByIdResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		AgentByIdAsof: {
			hasInput: true,
			requestSchema: AgentByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("AgentByIdAsof"), AgentByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByIdAsof"), z.optional(AgentByIdAsofRequest)]),

			returnEnvelope: "agent",
			responseSchema: AgentByIdAsofResponse,
			unwrapResponse: (rpc: AgentByIdAsofResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},
					

		AgentRevisionCount: {
			hasInput: true,
			requestSchema: AgentRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("AgentRevisionCount"), AgentRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentRevisionCount"), z.optional(AgentRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: AgentRevisionCountResponse,
			unwrapResponse: (rpc: AgentRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllAgentRevisions: {
			hasInput: true,
			requestSchema: AllAgentRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllAgentRevisions"), AllAgentRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllAgentRevisions"), z.optional(AllAgentRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllAgentRevisionsResponse,
			unwrapResponse: (rpc: AllAgentRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Agent.array(),
//			returnLetterTypeName: "Agent",
		},
				
				

		AgentByCode: {
			hasInput: true,
			requestSchema: WatchAgentByCodeRequest,
			tqkSchema: z.tuple([z.literal("AgentByCode"), WatchAgentByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByCode"), z.optional(WatchAgentByCodeRequest)]),

			returnEnvelope: "agent",
			responseSchema: WatchAgentByCodeResponse,
			unwrapResponse: (rpc: WatchAgentByCodeResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		LastValidAgentByCode: {
			hasInput: true,
			requestSchema: LastValidAgentByCodeRequest,
			tqkSchema: z.tuple([z.literal("LastValidAgentByCode"), LastValidAgentByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidAgentByCode"), z.optional(LastValidAgentByCodeRequest)]),

			returnEnvelope: "agent",
			responseSchema: LastValidAgentByCodeResponse,
			unwrapResponse: (rpc: LastValidAgentByCodeResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		AgentByCodeAsof: {
			hasInput: true,
			requestSchema: AgentByCodeAsofRequest,
			tqkSchema: z.tuple([z.literal("AgentByCodeAsof"), AgentByCodeAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByCodeAsof"), z.optional(AgentByCodeAsofRequest)]),

			returnEnvelope: "agent",
			responseSchema: AgentByCodeAsofResponse,
			unwrapResponse: (rpc: AgentByCodeAsofResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},
				
				

		AgentByName: {
			hasInput: true,
			requestSchema: WatchAgentByNameRequest,
			tqkSchema: z.tuple([z.literal("AgentByName"), WatchAgentByNameRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByName"), z.optional(WatchAgentByNameRequest)]),

			returnEnvelope: "agent",
			responseSchema: WatchAgentByNameResponse,
			unwrapResponse: (rpc: WatchAgentByNameResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		LastValidAgentByName: {
			hasInput: true,
			requestSchema: LastValidAgentByNameRequest,
			tqkSchema: z.tuple([z.literal("LastValidAgentByName"), LastValidAgentByNameRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidAgentByName"), z.optional(LastValidAgentByNameRequest)]),

			returnEnvelope: "agent",
			responseSchema: LastValidAgentByNameResponse,
			unwrapResponse: (rpc: LastValidAgentByNameResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		AgentByNameAsof: {
			hasInput: true,
			requestSchema: AgentByNameAsofRequest,
			tqkSchema: z.tuple([z.literal("AgentByNameAsof"), AgentByNameAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByNameAsof"), z.optional(AgentByNameAsofRequest)]),

			returnEnvelope: "agent",
			responseSchema: AgentByNameAsofResponse,
			unwrapResponse: (rpc: AgentByNameAsofResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},
				
				

		AgentByLogin: {
			hasInput: true,
			requestSchema: WatchAgentByLoginRequest,
			tqkSchema: z.tuple([z.literal("AgentByLogin"), WatchAgentByLoginRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByLogin"), z.optional(WatchAgentByLoginRequest)]),

			returnEnvelope: "agent",
			responseSchema: WatchAgentByLoginResponse,
			unwrapResponse: (rpc: WatchAgentByLoginResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		LastValidAgentByLogin: {
			hasInput: true,
			requestSchema: LastValidAgentByLoginRequest,
			tqkSchema: z.tuple([z.literal("LastValidAgentByLogin"), LastValidAgentByLoginRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidAgentByLogin"), z.optional(LastValidAgentByLoginRequest)]),

			returnEnvelope: "agent",
			responseSchema: LastValidAgentByLoginResponse,
			unwrapResponse: (rpc: LastValidAgentByLoginResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		AgentByLoginAsof: {
			hasInput: true,
			requestSchema: AgentByLoginAsofRequest,
			tqkSchema: z.tuple([z.literal("AgentByLoginAsof"), AgentByLoginAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentByLoginAsof"), z.optional(AgentByLoginAsofRequest)]),

			returnEnvelope: "agent",
			responseSchema: AgentByLoginAsofResponse,
			unwrapResponse: (rpc: AgentByLoginAsofResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		AgentStampById: {
			hasInput: true,
			requestSchema: AgentStampByIdRequest,
			tqkSchema: z.tuple([z.literal("AgentStampById"), AgentStampByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentStampById"), z.optional(AgentStampByIdRequest)]),

			returnEnvelope: "stamp",
			responseSchema: AgentStampByIdResponse,
			unwrapResponse: (rpc: AgentStampByIdResponse) => rpc.stamp,
//			returnLetterSchema: AgentStamp,
//			returnLetterTypeName: "AgentStamp",
		},

		LastFlavoredStampForAgent: {
			hasInput: true,
			requestSchema: LastFlavoredStampForAgentRequest,
			tqkSchema: z.tuple([z.literal("LastFlavoredStampForAgent"), LastFlavoredStampForAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastFlavoredStampForAgent"), z.optional(LastFlavoredStampForAgentRequest)]),

			returnEnvelope: "stamp",
			responseSchema: LastFlavoredStampForAgentResponse,
			unwrapResponse: (rpc: LastFlavoredStampForAgentResponse) => rpc.stamp,
//			returnLetterSchema: AgentStamp,
//			returnLetterTypeName: "AgentStamp",
		},
				
				

		StampsForAgent: {
			hasInput: true,
			requestSchema: WatchStampsForAgentRequest,
			tqkSchema: z.tuple([z.literal("StampsForAgent"), WatchStampsForAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForAgent"), z.optional(WatchStampsForAgentRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchStampsForAgentResponse,
			unwrapResponse: (rpc: WatchStampsForAgentResponse) => rpc.stamps,
//			returnLetterSchema: AgentStamp.array(),
//			returnLetterTypeName: "AgentStamp",
		},

		StampsForAgentDuring: {
			hasInput: true,
			requestSchema: StampsForAgentDuringRequest,
			tqkSchema: z.tuple([z.literal("StampsForAgentDuring"), StampsForAgentDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForAgentDuring"), z.optional(StampsForAgentDuringRequest)]),

			returnEnvelope: "stamps",
			responseSchema: StampsForAgentDuringResponse,
			unwrapResponse: (rpc: StampsForAgentDuringResponse) => rpc.stamps,
//			returnLetterSchema: AgentStamp.array(),
//			returnLetterTypeName: "AgentStamp",
		},
					

		AgentAvatar: {
			hasInput: true,
			requestSchema: AgentAvatarRequest,
			tqkSchema: z.tuple([z.literal("AgentAvatar"), AgentAvatarRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentAvatar"), z.optional(AgentAvatarRequest)]),

			returnEnvelope: "photoSlug",
			responseSchema: AgentAvatarResponse,
			unwrapResponse: (rpc: AgentAvatarResponse) => rpc.photoSlug,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},
				
				

		AgentPresenceById: {
			hasInput: true,
			requestSchema: WatchAgentPresenceByIdRequest,
			tqkSchema: z.tuple([z.literal("AgentPresenceById"), WatchAgentPresenceByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AgentPresenceById"), z.optional(WatchAgentPresenceByIdRequest)]),

			returnEnvelope: "presence",
			responseSchema: WatchAgentPresenceByIdResponse,
			unwrapResponse: (rpc: WatchAgentPresenceByIdResponse) => rpc.presence,
//			returnLetterSchema: AgentPresence,
//			returnLetterTypeName: "AgentPresence",
		},
				
				

		AllPresentAgents: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("AllPresentAgents")]),
			

			returnEnvelope: "agents",
			responseSchema: WatchAllPresentAgentsResponse,
			unwrapResponse: (rpc: WatchAllPresentAgentsResponse) => rpc.agents,
//			returnLetterSchema: AgentStub.array(),
//			returnLetterTypeName: "AgentStub",
		},
				
				

		TruckModels: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("TruckModels")]),
			

			returnEnvelope: "models",
			responseSchema: WatchTruckModelsResponse,
			unwrapResponse: (rpc: WatchTruckModelsResponse) => rpc.models,
//			returnLetterSchema: TruckModel.array(),
//			returnLetterTypeName: "TruckModel",
		},
				
				

		TruckModelById: {
			hasInput: true,
			requestSchema: WatchTruckModelByIdRequest,
			tqkSchema: z.tuple([z.literal("TruckModelById"), WatchTruckModelByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckModelById"), z.optional(WatchTruckModelByIdRequest)]),

			returnEnvelope: "model",
			responseSchema: WatchTruckModelByIdResponse,
			unwrapResponse: (rpc: WatchTruckModelByIdResponse) => rpc.model,
//			returnLetterSchema: TruckModel,
//			returnLetterTypeName: "TruckModel",
		},
				
				

		TruckById: {
			hasInput: true,
			requestSchema: WatchTruckByIdRequest,
			tqkSchema: z.tuple([z.literal("TruckById"), WatchTruckByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckById"), z.optional(WatchTruckByIdRequest)]),

			returnEnvelope: "truck",
			responseSchema: WatchTruckByIdResponse,
			unwrapResponse: (rpc: WatchTruckByIdResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},

		LastValidTruckById: {
			hasInput: true,
			requestSchema: LastValidTruckByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidTruckById"), LastValidTruckByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidTruckById"), z.optional(LastValidTruckByIdRequest)]),

			returnEnvelope: "truck",
			responseSchema: LastValidTruckByIdResponse,
			unwrapResponse: (rpc: LastValidTruckByIdResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},

		TruckByIdAsof: {
			hasInput: true,
			requestSchema: TruckByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("TruckByIdAsof"), TruckByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckByIdAsof"), z.optional(TruckByIdAsofRequest)]),

			returnEnvelope: "truck",
			responseSchema: TruckByIdAsofResponse,
			unwrapResponse: (rpc: TruckByIdAsofResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},
					

		TruckRevisionCount: {
			hasInput: true,
			requestSchema: TruckRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("TruckRevisionCount"), TruckRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckRevisionCount"), z.optional(TruckRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: TruckRevisionCountResponse,
			unwrapResponse: (rpc: TruckRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllTruckRevisions: {
			hasInput: true,
			requestSchema: AllTruckRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllTruckRevisions"), AllTruckRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllTruckRevisions"), z.optional(AllTruckRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllTruckRevisionsResponse,
			unwrapResponse: (rpc: AllTruckRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Truck.array(),
//			returnLetterTypeName: "Truck",
		},
				
				

		TruckByPlate: {
			hasInput: true,
			requestSchema: WatchTruckByPlateRequest,
			tqkSchema: z.tuple([z.literal("TruckByPlate"), WatchTruckByPlateRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckByPlate"), z.optional(WatchTruckByPlateRequest)]),

			returnEnvelope: "truck",
			responseSchema: WatchTruckByPlateResponse,
			unwrapResponse: (rpc: WatchTruckByPlateResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},

		LastValidTruckByPlate: {
			hasInput: true,
			requestSchema: LastValidTruckByPlateRequest,
			tqkSchema: z.tuple([z.literal("LastValidTruckByPlate"), LastValidTruckByPlateRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidTruckByPlate"), z.optional(LastValidTruckByPlateRequest)]),

			returnEnvelope: "truck",
			responseSchema: LastValidTruckByPlateResponse,
			unwrapResponse: (rpc: LastValidTruckByPlateResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},

		TruckByPlateAsof: {
			hasInput: true,
			requestSchema: TruckByPlateAsofRequest,
			tqkSchema: z.tuple([z.literal("TruckByPlateAsof"), TruckByPlateAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckByPlateAsof"), z.optional(TruckByPlateAsofRequest)]),

			returnEnvelope: "truck",
			responseSchema: TruckByPlateAsofResponse,
			unwrapResponse: (rpc: TruckByPlateAsofResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},
				
				

		TruckByCrew: {
			hasInput: true,
			requestSchema: WatchTruckByCrewRequest,
			tqkSchema: z.tuple([z.literal("TruckByCrew"), WatchTruckByCrewRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckByCrew"), z.optional(WatchTruckByCrewRequest)]),

			returnEnvelope: "truck",
			responseSchema: WatchTruckByCrewResponse,
			unwrapResponse: (rpc: WatchTruckByCrewResponse) => rpc.truck,
//			returnLetterSchema: TruckStub,
//			returnLetterTypeName: "TruckStub",
		},

		TruckTenuresByCrewDuring: {
			hasInput: true,
			requestSchema: TruckTenuresByCrewDuringRequest,
			tqkSchema: z.tuple([z.literal("TruckTenuresByCrewDuring"), TruckTenuresByCrewDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckTenuresByCrewDuring"), z.optional(TruckTenuresByCrewDuringRequest)]),

			returnEnvelope: "tenures",
			responseSchema: TruckTenuresByCrewDuringResponse,
			unwrapResponse: (rpc: TruckTenuresByCrewDuringResponse) => rpc.tenures,
//			returnLetterSchema: TruckTenure.array(),
//			returnLetterTypeName: "TruckTenure",
		},
				
				

		CrewByTruck: {
			hasInput: true,
			requestSchema: WatchCrewByTruckRequest,
			tqkSchema: z.tuple([z.literal("CrewByTruck"), WatchCrewByTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CrewByTruck"), z.optional(WatchCrewByTruckRequest)]),

			returnEnvelope: "tenures",
			responseSchema: WatchCrewByTruckResponse,
			unwrapResponse: (rpc: WatchCrewByTruckResponse) => rpc.tenures,
//			returnLetterSchema: CrewTenure.array(),
//			returnLetterTypeName: "CrewTenure",
		},

		CrewTenuresByTruckDuring: {
			hasInput: true,
			requestSchema: CrewTenuresByTruckDuringRequest,
			tqkSchema: z.tuple([z.literal("CrewTenuresByTruckDuring"), CrewTenuresByTruckDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CrewTenuresByTruckDuring"), z.optional(CrewTenuresByTruckDuringRequest)]),

			returnEnvelope: "tenures",
			responseSchema: CrewTenuresByTruckDuringResponse,
			unwrapResponse: (rpc: CrewTenuresByTruckDuringResponse) => rpc.tenures,
//			returnLetterSchema: CrewTenure.array(),
//			returnLetterTypeName: "CrewTenure",
		},

		TruckStampById: {
			hasInput: true,
			requestSchema: TruckStampByIdRequest,
			tqkSchema: z.tuple([z.literal("TruckStampById"), TruckStampByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckStampById"), z.optional(TruckStampByIdRequest)]),

			returnEnvelope: "stamp",
			responseSchema: TruckStampByIdResponse,
			unwrapResponse: (rpc: TruckStampByIdResponse) => rpc.stamp,
//			returnLetterSchema: TruckStamp,
//			returnLetterTypeName: "TruckStamp",
		},

		LastFlavoredStampForTruck: {
			hasInput: true,
			requestSchema: LastFlavoredStampForTruckRequest,
			tqkSchema: z.tuple([z.literal("LastFlavoredStampForTruck"), LastFlavoredStampForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastFlavoredStampForTruck"), z.optional(LastFlavoredStampForTruckRequest)]),

			returnEnvelope: "stamp",
			responseSchema: LastFlavoredStampForTruckResponse,
			unwrapResponse: (rpc: LastFlavoredStampForTruckResponse) => rpc.stamp,
//			returnLetterSchema: TruckStamp,
//			returnLetterTypeName: "TruckStamp",
		},
				
				

		StampsForTruck: {
			hasInput: true,
			requestSchema: WatchStampsForTruckRequest,
			tqkSchema: z.tuple([z.literal("StampsForTruck"), WatchStampsForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForTruck"), z.optional(WatchStampsForTruckRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchStampsForTruckResponse,
			unwrapResponse: (rpc: WatchStampsForTruckResponse) => rpc.stamps,
//			returnLetterSchema: TruckStamp.array(),
//			returnLetterTypeName: "TruckStamp",
		},

		StampsForTruckDuring: {
			hasInput: true,
			requestSchema: StampsForTruckDuringRequest,
			tqkSchema: z.tuple([z.literal("StampsForTruckDuring"), StampsForTruckDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForTruckDuring"), z.optional(StampsForTruckDuringRequest)]),

			returnEnvelope: "stamps",
			responseSchema: StampsForTruckDuringResponse,
			unwrapResponse: (rpc: StampsForTruckDuringResponse) => rpc.stamps,
//			returnLetterSchema: TruckStamp.array(),
//			returnLetterTypeName: "TruckStamp",
		},
					

		TruckAvatar: {
			hasInput: true,
			requestSchema: TruckAvatarRequest,
			tqkSchema: z.tuple([z.literal("TruckAvatar"), TruckAvatarRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TruckAvatar"), z.optional(TruckAvatarRequest)]),

			returnEnvelope: "photoSlug",
			responseSchema: TruckAvatarResponse,
			unwrapResponse: (rpc: TruckAvatarResponse) => rpc.photoSlug,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},
				
				

		JobById: {
			hasInput: true,
			requestSchema: WatchJobByIdRequest,
			tqkSchema: z.tuple([z.literal("JobById"), WatchJobByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobById"), z.optional(WatchJobByIdRequest)]),

			returnEnvelope: "job",
			responseSchema: WatchJobByIdResponse,
			unwrapResponse: (rpc: WatchJobByIdResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		LastValidJobById: {
			hasInput: true,
			requestSchema: LastValidJobByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidJobById"), LastValidJobByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidJobById"), z.optional(LastValidJobByIdRequest)]),

			returnEnvelope: "job",
			responseSchema: LastValidJobByIdResponse,
			unwrapResponse: (rpc: LastValidJobByIdResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		JobByIdAsof: {
			hasInput: true,
			requestSchema: JobByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("JobByIdAsof"), JobByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobByIdAsof"), z.optional(JobByIdAsofRequest)]),

			returnEnvelope: "job",
			responseSchema: JobByIdAsofResponse,
			unwrapResponse: (rpc: JobByIdAsofResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},
					

		JobRevisionCount: {
			hasInput: true,
			requestSchema: JobRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("JobRevisionCount"), JobRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobRevisionCount"), z.optional(JobRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: JobRevisionCountResponse,
			unwrapResponse: (rpc: JobRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllJobRevisions: {
			hasInput: true,
			requestSchema: AllJobRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllJobRevisions"), AllJobRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllJobRevisions"), z.optional(AllJobRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllJobRevisionsResponse,
			unwrapResponse: (rpc: AllJobRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Job.array(),
//			returnLetterTypeName: "Job",
		},
				
				

		ExportableJobs: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ExportableJobs")]),
			

			returnEnvelope: "jobs",
			responseSchema: WatchExportableJobsResponse,
			unwrapResponse: (rpc: WatchExportableJobsResponse) => rpc.jobs,
//			returnLetterSchema: JobStub.array(),
//			returnLetterTypeName: "JobStub",
		},
				
				

		ExportedJobs: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ExportedJobs")]),
			

			returnEnvelope: "jobs",
			responseSchema: WatchExportedJobsResponse,
			unwrapResponse: (rpc: WatchExportedJobsResponse) => rpc.jobs,
//			returnLetterSchema: JobStub.array(),
//			returnLetterTypeName: "JobStub",
		},
					

		ShowExportedJob: {
			hasInput: true,
			requestSchema: ShowExportedJobRequest,
			tqkSchema: z.tuple([z.literal("ShowExportedJob"), ShowExportedJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ShowExportedJob"), z.optional(ShowExportedJobRequest)]),

			returnEnvelope: "exported",
			responseSchema: ShowExportedJobResponse,
			unwrapResponse: (rpc: ShowExportedJobResponse) => rpc.exported,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		ExportJob: {
			hasInput: true,
			requestSchema: ExportJobRequest,
			tqkSchema: z.tuple([z.literal("ExportJob"), ExportJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ExportJob"), z.optional(ExportJobRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},
				
				

		JobByJobCode: {
			hasInput: true,
			requestSchema: WatchJobByJobCodeRequest,
			tqkSchema: z.tuple([z.literal("JobByJobCode"), WatchJobByJobCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobByJobCode"), z.optional(WatchJobByJobCodeRequest)]),

			returnEnvelope: "job",
			responseSchema: WatchJobByJobCodeResponse,
			unwrapResponse: (rpc: WatchJobByJobCodeResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		LastValidJobByJobCode: {
			hasInput: true,
			requestSchema: LastValidJobByJobCodeRequest,
			tqkSchema: z.tuple([z.literal("LastValidJobByJobCode"), LastValidJobByJobCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidJobByJobCode"), z.optional(LastValidJobByJobCodeRequest)]),

			returnEnvelope: "job",
			responseSchema: LastValidJobByJobCodeResponse,
			unwrapResponse: (rpc: LastValidJobByJobCodeResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		JobByJobCodeAsof: {
			hasInput: true,
			requestSchema: JobByJobCodeAsofRequest,
			tqkSchema: z.tuple([z.literal("JobByJobCodeAsof"), JobByJobCodeAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobByJobCodeAsof"), z.optional(JobByJobCodeAsofRequest)]),

			returnEnvelope: "job",
			responseSchema: JobByJobCodeAsofResponse,
			unwrapResponse: (rpc: JobByJobCodeAsofResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},
				
				

		JobByIntakeCode: {
			hasInput: true,
			requestSchema: WatchJobByIntakeCodeRequest,
			tqkSchema: z.tuple([z.literal("JobByIntakeCode"), WatchJobByIntakeCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobByIntakeCode"), z.optional(WatchJobByIntakeCodeRequest)]),

			returnEnvelope: "job",
			responseSchema: WatchJobByIntakeCodeResponse,
			unwrapResponse: (rpc: WatchJobByIntakeCodeResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		LastValidJobByIntakeCode: {
			hasInput: true,
			requestSchema: LastValidJobByIntakeCodeRequest,
			tqkSchema: z.tuple([z.literal("LastValidJobByIntakeCode"), LastValidJobByIntakeCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidJobByIntakeCode"), z.optional(LastValidJobByIntakeCodeRequest)]),

			returnEnvelope: "job",
			responseSchema: LastValidJobByIntakeCodeResponse,
			unwrapResponse: (rpc: LastValidJobByIntakeCodeResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		JobByIntakeCodeAsof: {
			hasInput: true,
			requestSchema: JobByIntakeCodeAsofRequest,
			tqkSchema: z.tuple([z.literal("JobByIntakeCodeAsof"), JobByIntakeCodeAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobByIntakeCodeAsof"), z.optional(JobByIntakeCodeAsofRequest)]),

			returnEnvelope: "job",
			responseSchema: JobByIntakeCodeAsofResponse,
			unwrapResponse: (rpc: JobByIntakeCodeAsofResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		JobStampById: {
			hasInput: true,
			requestSchema: JobStampByIdRequest,
			tqkSchema: z.tuple([z.literal("JobStampById"), JobStampByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("JobStampById"), z.optional(JobStampByIdRequest)]),

			returnEnvelope: "stamp",
			responseSchema: JobStampByIdResponse,
			unwrapResponse: (rpc: JobStampByIdResponse) => rpc.stamp,
//			returnLetterSchema: JobStamp,
//			returnLetterTypeName: "JobStamp",
		},

		LastFlavoredStampForJob: {
			hasInput: true,
			requestSchema: LastFlavoredStampForJobRequest,
			tqkSchema: z.tuple([z.literal("LastFlavoredStampForJob"), LastFlavoredStampForJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastFlavoredStampForJob"), z.optional(LastFlavoredStampForJobRequest)]),

			returnEnvelope: "stamp",
			responseSchema: LastFlavoredStampForJobResponse,
			unwrapResponse: (rpc: LastFlavoredStampForJobResponse) => rpc.stamp,
//			returnLetterSchema: JobStamp,
//			returnLetterTypeName: "JobStamp",
		},
				
				

		StampsForJob: {
			hasInput: true,
			requestSchema: WatchStampsForJobRequest,
			tqkSchema: z.tuple([z.literal("StampsForJob"), WatchStampsForJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForJob"), z.optional(WatchStampsForJobRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchStampsForJobResponse,
			unwrapResponse: (rpc: WatchStampsForJobResponse) => rpc.stamps,
//			returnLetterSchema: JobStamp.array(),
//			returnLetterTypeName: "JobStamp",
		},
				
				

		UnbundledWastesForJobAtVenue: {
			hasInput: true,
			requestSchema: WatchUnbundledWastesForJobAtVenueRequest,
			tqkSchema: z.tuple([z.literal("UnbundledWastesForJobAtVenue"), WatchUnbundledWastesForJobAtVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UnbundledWastesForJobAtVenue"), z.optional(WatchUnbundledWastesForJobAtVenueRequest)]),

			returnEnvelope: "wastes",
			responseSchema: WatchUnbundledWastesForJobAtVenueResponse,
			unwrapResponse: (rpc: WatchUnbundledWastesForJobAtVenueResponse) => rpc.wastes,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		SurchargeFlavorById: {
			hasInput: true,
			requestSchema: SurchargeFlavorByIdRequest,
			tqkSchema: z.tuple([z.literal("SurchargeFlavorById"), SurchargeFlavorByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SurchargeFlavorById"), z.optional(SurchargeFlavorByIdRequest)]),

			returnEnvelope: "flavor",
			responseSchema: SurchargeFlavorByIdResponse,
			unwrapResponse: (rpc: SurchargeFlavorByIdResponse) => rpc.flavor,
//			returnLetterSchema: SurchargeFlavor,
//			returnLetterTypeName: "SurchargeFlavor",
		},

		SurchargeFlavorByCode: {
			hasInput: true,
			requestSchema: SurchargeFlavorByCodeRequest,
			tqkSchema: z.tuple([z.literal("SurchargeFlavorByCode"), SurchargeFlavorByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SurchargeFlavorByCode"), z.optional(SurchargeFlavorByCodeRequest)]),

			returnEnvelope: "flavor",
			responseSchema: SurchargeFlavorByCodeResponse,
			unwrapResponse: (rpc: SurchargeFlavorByCodeResponse) => rpc.flavor,
//			returnLetterSchema: SurchargeFlavor,
//			returnLetterTypeName: "SurchargeFlavor",
		},
				
				

		SurchargesForSubject: {
			hasInput: true,
			requestSchema: WatchSurchargesForSubjectRequest,
			tqkSchema: z.tuple([z.literal("SurchargesForSubject"), WatchSurchargesForSubjectRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SurchargesForSubject"), z.optional(WatchSurchargesForSubjectRequest)]),

			returnEnvelope: "surcharges",
			responseSchema: WatchSurchargesForSubjectResponse,
			unwrapResponse: (rpc: WatchSurchargesForSubjectResponse) => rpc.surcharges,
//			returnLetterSchema: Surcharge.array(),
//			returnLetterTypeName: "Surcharge",
		},
				
				

		SurchargeById: {
			hasInput: true,
			requestSchema: WatchSurchargeByIdRequest,
			tqkSchema: z.tuple([z.literal("SurchargeById"), WatchSurchargeByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SurchargeById"), z.optional(WatchSurchargeByIdRequest)]),

			returnEnvelope: "surcharge",
			responseSchema: WatchSurchargeByIdResponse,
			unwrapResponse: (rpc: WatchSurchargeByIdResponse) => rpc.surcharge,
//			returnLetterSchema: Surcharge,
//			returnLetterTypeName: "Surcharge",
		},

		LastValidSurchargeById: {
			hasInput: true,
			requestSchema: LastValidSurchargeByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidSurchargeById"), LastValidSurchargeByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidSurchargeById"), z.optional(LastValidSurchargeByIdRequest)]),

			returnEnvelope: "surcharge",
			responseSchema: LastValidSurchargeByIdResponse,
			unwrapResponse: (rpc: LastValidSurchargeByIdResponse) => rpc.surcharge,
//			returnLetterSchema: Surcharge,
//			returnLetterTypeName: "Surcharge",
		},

		SurchargeByIdAsof: {
			hasInput: true,
			requestSchema: SurchargeByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("SurchargeByIdAsof"), SurchargeByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SurchargeByIdAsof"), z.optional(SurchargeByIdAsofRequest)]),

			returnEnvelope: "surcharge",
			responseSchema: SurchargeByIdAsofResponse,
			unwrapResponse: (rpc: SurchargeByIdAsofResponse) => rpc.surcharge,
//			returnLetterSchema: Surcharge,
//			returnLetterTypeName: "Surcharge",
		},

		AllSurchargeRevisions: {
			hasInput: true,
			requestSchema: AllSurchargeRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllSurchargeRevisions"), AllSurchargeRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllSurchargeRevisions"), z.optional(AllSurchargeRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllSurchargeRevisionsResponse,
			unwrapResponse: (rpc: AllSurchargeRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Surcharge.array(),
//			returnLetterTypeName: "Surcharge",
		},
				
				

		BundleById: {
			hasInput: true,
			requestSchema: WatchBundleByIdRequest,
			tqkSchema: z.tuple([z.literal("BundleById"), WatchBundleByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleById"), z.optional(WatchBundleByIdRequest)]),

			returnEnvelope: "bundle",
			responseSchema: WatchBundleByIdResponse,
			unwrapResponse: (rpc: WatchBundleByIdResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		LastValidBundleById: {
			hasInput: true,
			requestSchema: LastValidBundleByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidBundleById"), LastValidBundleByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidBundleById"), z.optional(LastValidBundleByIdRequest)]),

			returnEnvelope: "bundle",
			responseSchema: LastValidBundleByIdResponse,
			unwrapResponse: (rpc: LastValidBundleByIdResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		BundleByIdAsof: {
			hasInput: true,
			requestSchema: BundleByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("BundleByIdAsof"), BundleByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleByIdAsof"), z.optional(BundleByIdAsofRequest)]),

			returnEnvelope: "bundle",
			responseSchema: BundleByIdAsofResponse,
			unwrapResponse: (rpc: BundleByIdAsofResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},
					

		BundleRevisionCount: {
			hasInput: true,
			requestSchema: BundleRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("BundleRevisionCount"), BundleRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleRevisionCount"), z.optional(BundleRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: BundleRevisionCountResponse,
			unwrapResponse: (rpc: BundleRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllBundleRevisions: {
			hasInput: true,
			requestSchema: AllBundleRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllBundleRevisions"), AllBundleRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllBundleRevisions"), z.optional(AllBundleRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllBundleRevisionsResponse,
			unwrapResponse: (rpc: AllBundleRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Bundle.array(),
//			returnLetterTypeName: "Bundle",
		},
				
				

		BundleLocation: {
			hasInput: true,
			requestSchema: WatchBundleLocationRequest,
			tqkSchema: z.tuple([z.literal("BundleLocation"), WatchBundleLocationRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleLocation"), z.optional(WatchBundleLocationRequest)]),

			returnEnvelope: "curloc",
			responseSchema: WatchBundleLocationResponse,
			unwrapResponse: (rpc: WatchBundleLocationResponse) => rpc.curloc,
//			returnLetterSchema: TruckOrVenueStub,
//			returnLetterTypeName: "TruckOrVenueStub",
		},
				
				

		OrphanedBundles: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("OrphanedBundles")]),
			

			returnEnvelope: "orphans",
			responseSchema: WatchOrphanedBundlesResponse,
			unwrapResponse: (rpc: WatchOrphanedBundlesResponse) => rpc.orphans,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
					

		ActiveBundleCount: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ActiveBundleCount")]),
			

			returnEnvelope: "bundleCount",
			responseSchema: ActiveBundleCountResponse,
			unwrapResponse: (rpc: ActiveBundleCountResponse) => rpc.bundleCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},
				
				

		ActiveBundles: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ActiveBundles")]),
			

			returnEnvelope: "bundles",
			responseSchema: WatchActiveBundlesResponse,
			unwrapResponse: (rpc: WatchActiveBundlesResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},

		ActiveBundlePage: {
			hasInput: true,
			requestSchema: ActiveBundlePageRequest,
			tqkSchema: z.tuple([z.literal("ActiveBundlePage"), ActiveBundlePageRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ActiveBundlePage"), z.optional(ActiveBundlePageRequest)]),

			returnEnvelope: "bundles",
			responseSchema: ActiveBundlePageResponse,
			unwrapResponse: (rpc: ActiveBundlePageResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		ActiveBundlesDestinedFor: {
			hasInput: true,
			requestSchema: WatchActiveBundlesDestinedForRequest,
			tqkSchema: z.tuple([z.literal("ActiveBundlesDestinedFor"), WatchActiveBundlesDestinedForRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ActiveBundlesDestinedFor"), z.optional(WatchActiveBundlesDestinedForRequest)]),

			returnEnvelope: "bundles",
			responseSchema: WatchActiveBundlesDestinedForResponse,
			unwrapResponse: (rpc: WatchActiveBundlesDestinedForResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		ActiveBundlesOriginatingAt: {
			hasInput: true,
			requestSchema: WatchActiveBundlesOriginatingAtRequest,
			tqkSchema: z.tuple([z.literal("ActiveBundlesOriginatingAt"), WatchActiveBundlesOriginatingAtRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ActiveBundlesOriginatingAt"), z.optional(WatchActiveBundlesOriginatingAtRequest)]),

			returnEnvelope: "bundles",
			responseSchema: WatchActiveBundlesOriginatingAtResponse,
			unwrapResponse: (rpc: WatchActiveBundlesOriginatingAtResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		ExportableBundles: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ExportableBundles")]),
			

			returnEnvelope: "bundles",
			responseSchema: WatchExportableBundlesResponse,
			unwrapResponse: (rpc: WatchExportableBundlesResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		InspectableBundles: {
			hasInput: true,
			requestSchema: WatchInspectableBundlesRequest,
			tqkSchema: z.tuple([z.literal("InspectableBundles"), WatchInspectableBundlesRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("InspectableBundles"), z.optional(WatchInspectableBundlesRequest)]),

			returnEnvelope: "bundles",
			responseSchema: WatchInspectableBundlesResponse,
			unwrapResponse: (rpc: WatchInspectableBundlesResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		BundlesNeedingSupervisor: {
			hasInput: true,
			requestSchema: WatchBundlesNeedingSupervisorRequest,
			tqkSchema: z.tuple([z.literal("BundlesNeedingSupervisor"), WatchBundlesNeedingSupervisorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundlesNeedingSupervisor"), z.optional(WatchBundlesNeedingSupervisorRequest)]),

			returnEnvelope: "bundles",
			responseSchema: WatchBundlesNeedingSupervisorResponse,
			unwrapResponse: (rpc: WatchBundlesNeedingSupervisorResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
					

		ShowExportedBundle: {
			hasInput: true,
			requestSchema: ShowExportedBundleRequest,
			tqkSchema: z.tuple([z.literal("ShowExportedBundle"), ShowExportedBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ShowExportedBundle"), z.optional(ShowExportedBundleRequest)]),

			returnEnvelope: "exported",
			responseSchema: ShowExportedBundleResponse,
			unwrapResponse: (rpc: ShowExportedBundleResponse) => rpc.exported,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		CompleteBundleHistoryById: {
			hasInput: true,
			requestSchema: CompleteBundleHistoryByIdRequest,
			tqkSchema: z.tuple([z.literal("CompleteBundleHistoryById"), CompleteBundleHistoryByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompleteBundleHistoryById"), z.optional(CompleteBundleHistoryByIdRequest)]),

			returnEnvelope: "history",
			responseSchema: CompleteBundleHistoryByIdResponse,
			unwrapResponse: (rpc: CompleteBundleHistoryByIdResponse) => rpc.history,
//			returnLetterSchema: CompleteBundleHistory,
//			returnLetterTypeName: "CompleteBundleHistory",
		},

		BundleStampById: {
			hasInput: true,
			requestSchema: BundleStampByIdRequest,
			tqkSchema: z.tuple([z.literal("BundleStampById"), BundleStampByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleStampById"), z.optional(BundleStampByIdRequest)]),

			returnEnvelope: "stamp",
			responseSchema: BundleStampByIdResponse,
			unwrapResponse: (rpc: BundleStampByIdResponse) => rpc.stamp,
//			returnLetterSchema: BundleStamp,
//			returnLetterTypeName: "BundleStamp",
		},

		LastFlavoredStampForBundle: {
			hasInput: true,
			requestSchema: LastFlavoredStampForBundleRequest,
			tqkSchema: z.tuple([z.literal("LastFlavoredStampForBundle"), LastFlavoredStampForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastFlavoredStampForBundle"), z.optional(LastFlavoredStampForBundleRequest)]),

			returnEnvelope: "stamp",
			responseSchema: LastFlavoredStampForBundleResponse,
			unwrapResponse: (rpc: LastFlavoredStampForBundleResponse) => rpc.stamp,
//			returnLetterSchema: BundleStamp,
//			returnLetterTypeName: "BundleStamp",
		},
				
				

		StampsForBundle: {
			hasInput: true,
			requestSchema: WatchStampsForBundleRequest,
			tqkSchema: z.tuple([z.literal("StampsForBundle"), WatchStampsForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForBundle"), z.optional(WatchStampsForBundleRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchStampsForBundleResponse,
			unwrapResponse: (rpc: WatchStampsForBundleResponse) => rpc.stamps,
//			returnLetterSchema: BundleStamp.array(),
//			returnLetterTypeName: "BundleStamp",
		},
				
				

		FlavoredStampsForBundle: {
			hasInput: true,
			requestSchema: WatchFlavoredStampsForBundleRequest,
			tqkSchema: z.tuple([z.literal("FlavoredStampsForBundle"), WatchFlavoredStampsForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("FlavoredStampsForBundle"), z.optional(WatchFlavoredStampsForBundleRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchFlavoredStampsForBundleResponse,
			unwrapResponse: (rpc: WatchFlavoredStampsForBundleResponse) => rpc.stamps,
//			returnLetterSchema: BundleStamp.array(),
//			returnLetterTypeName: "BundleStamp",
		},
				
				

		TransferById: {
			hasInput: true,
			requestSchema: WatchTransferByIdRequest,
			tqkSchema: z.tuple([z.literal("TransferById"), WatchTransferByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TransferById"), z.optional(WatchTransferByIdRequest)]),

			returnEnvelope: "transfer",
			responseSchema: WatchTransferByIdResponse,
			unwrapResponse: (rpc: WatchTransferByIdResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},
				
				

		AllTransfers: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("AllTransfers")]),
			

			returnEnvelope: "transfers",
			responseSchema: WatchAllTransfersResponse,
			unwrapResponse: (rpc: WatchAllTransfersResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},
				
				

		OpenTransfersForTruck: {
			hasInput: true,
			requestSchema: WatchOpenTransfersForTruckRequest,
			tqkSchema: z.tuple([z.literal("OpenTransfersForTruck"), WatchOpenTransfersForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("OpenTransfersForTruck"), z.optional(WatchOpenTransfersForTruckRequest)]),

			returnEnvelope: "transfers",
			responseSchema: WatchOpenTransfersForTruckResponse,
			unwrapResponse: (rpc: WatchOpenTransfersForTruckResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},
				
				

		TransfersForTruck: {
			hasInput: true,
			requestSchema: WatchTransfersForTruckRequest,
			tqkSchema: z.tuple([z.literal("TransfersForTruck"), WatchTransfersForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TransfersForTruck"), z.optional(WatchTransfersForTruckRequest)]),

			returnEnvelope: "transfers",
			responseSchema: WatchTransfersForTruckResponse,
			unwrapResponse: (rpc: WatchTransfersForTruckResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},
				
				

		LastTransferForBundle: {
			hasInput: true,
			requestSchema: WatchLastTransferForBundleRequest,
			tqkSchema: z.tuple([z.literal("LastTransferForBundle"), WatchLastTransferForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastTransferForBundle"), z.optional(WatchLastTransferForBundleRequest)]),

			returnEnvelope: "transfer",
			responseSchema: WatchLastTransferForBundleResponse,
			unwrapResponse: (rpc: WatchLastTransferForBundleResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		LastTransferForBundleBefore: {
			hasInput: true,
			requestSchema: LastTransferForBundleBeforeRequest,
			tqkSchema: z.tuple([z.literal("LastTransferForBundleBefore"), LastTransferForBundleBeforeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastTransferForBundleBefore"), z.optional(LastTransferForBundleBeforeRequest)]),

			returnEnvelope: "transfer",
			responseSchema: LastTransferForBundleBeforeResponse,
			unwrapResponse: (rpc: LastTransferForBundleBeforeResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		AllTransfersForBundle: {
			hasInput: true,
			requestSchema: AllTransfersForBundleRequest,
			tqkSchema: z.tuple([z.literal("AllTransfersForBundle"), AllTransfersForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllTransfersForBundle"), z.optional(AllTransfersForBundleRequest)]),

			returnEnvelope: "transfers",
			responseSchema: AllTransfersForBundleResponse,
			unwrapResponse: (rpc: AllTransfersForBundleResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},

		TransfersForTruckDuring: {
			hasInput: true,
			requestSchema: TransfersForTruckDuringRequest,
			tqkSchema: z.tuple([z.literal("TransfersForTruckDuring"), TransfersForTruckDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TransfersForTruckDuring"), z.optional(TransfersForTruckDuringRequest)]),

			returnEnvelope: "transfers",
			responseSchema: TransfersForTruckDuringResponse,
			unwrapResponse: (rpc: TransfersForTruckDuringResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},
				
				

		TransfersAtVenue: {
			hasInput: true,
			requestSchema: WatchTransfersAtVenueRequest,
			tqkSchema: z.tuple([z.literal("TransfersAtVenue"), WatchTransfersAtVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TransfersAtVenue"), z.optional(WatchTransfersAtVenueRequest)]),

			returnEnvelope: "transfers",
			responseSchema: WatchTransfersAtVenueResponse,
			unwrapResponse: (rpc: WatchTransfersAtVenueResponse) => rpc.transfers,
//			returnLetterSchema: TransferStub.array(),
//			returnLetterTypeName: "TransferStub",
		},
				
				

		TriplegById: {
			hasInput: true,
			requestSchema: WatchTriplegByIdRequest,
			tqkSchema: z.tuple([z.literal("TriplegById"), WatchTriplegByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TriplegById"), z.optional(WatchTriplegByIdRequest)]),

			returnEnvelope: "tripleg",
			responseSchema: WatchTriplegByIdResponse,
			unwrapResponse: (rpc: WatchTriplegByIdResponse) => rpc.tripleg,
//			returnLetterSchema: Tripleg,
//			returnLetterTypeName: "Tripleg",
		},
				
				

		AllTriplegs: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("AllTriplegs")]),
			

			returnEnvelope: "triplegs",
			responseSchema: WatchAllTriplegsResponse,
			unwrapResponse: (rpc: WatchAllTriplegsResponse) => rpc.triplegs,
//			returnLetterSchema: TriplegStub.array(),
//			returnLetterTypeName: "TriplegStub",
		},
				
				

		OpenTriplegForTruck: {
			hasInput: true,
			requestSchema: WatchOpenTriplegForTruckRequest,
			tqkSchema: z.tuple([z.literal("OpenTriplegForTruck"), WatchOpenTriplegForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("OpenTriplegForTruck"), z.optional(WatchOpenTriplegForTruckRequest)]),

			returnEnvelope: "tripleg",
			responseSchema: WatchOpenTriplegForTruckResponse,
			unwrapResponse: (rpc: WatchOpenTriplegForTruckResponse) => rpc.tripleg,
//			returnLetterSchema: Tripleg,
//			returnLetterTypeName: "Tripleg",
		},
				
				

		LastTriplegForTruck: {
			hasInput: true,
			requestSchema: WatchLastTriplegForTruckRequest,
			tqkSchema: z.tuple([z.literal("LastTriplegForTruck"), WatchLastTriplegForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastTriplegForTruck"), z.optional(WatchLastTriplegForTruckRequest)]),

			returnEnvelope: "tripleg",
			responseSchema: WatchLastTriplegForTruckResponse,
			unwrapResponse: (rpc: WatchLastTriplegForTruckResponse) => rpc.tripleg,
//			returnLetterSchema: Tripleg,
//			returnLetterTypeName: "Tripleg",
		},
				
				

		TriplegsForTruck: {
			hasInput: true,
			requestSchema: WatchTriplegsForTruckRequest,
			tqkSchema: z.tuple([z.literal("TriplegsForTruck"), WatchTriplegsForTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TriplegsForTruck"), z.optional(WatchTriplegsForTruckRequest)]),

			returnEnvelope: "triplegs",
			responseSchema: WatchTriplegsForTruckResponse,
			unwrapResponse: (rpc: WatchTriplegsForTruckResponse) => rpc.triplegs,
//			returnLetterSchema: TriplegStub.array(),
//			returnLetterTypeName: "TriplegStub",
		},

		TriplegsForTruckDuring: {
			hasInput: true,
			requestSchema: TriplegsForTruckDuringRequest,
			tqkSchema: z.tuple([z.literal("TriplegsForTruckDuring"), TriplegsForTruckDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TriplegsForTruckDuring"), z.optional(TriplegsForTruckDuringRequest)]),

			returnEnvelope: "triplegs",
			responseSchema: TriplegsForTruckDuringResponse,
			unwrapResponse: (rpc: TriplegsForTruckDuringResponse) => rpc.triplegs,
//			returnLetterSchema: TriplegStub.array(),
//			returnLetterTypeName: "TriplegStub",
		},
				
				

		UnadmittedTriplegsInto: {
			hasInput: true,
			requestSchema: WatchUnadmittedTriplegsIntoRequest,
			tqkSchema: z.tuple([z.literal("UnadmittedTriplegsInto"), WatchUnadmittedTriplegsIntoRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UnadmittedTriplegsInto"), z.optional(WatchUnadmittedTriplegsIntoRequest)]),

			returnEnvelope: "triplegs",
			responseSchema: WatchUnadmittedTriplegsIntoResponse,
			unwrapResponse: (rpc: WatchUnadmittedTriplegsIntoResponse) => rpc.triplegs,
//			returnLetterSchema: TriplegStub.array(),
//			returnLetterTypeName: "TriplegStub",
		},
				
				

		TriplegsInboundTo: {
			hasInput: true,
			requestSchema: WatchTriplegsInboundToRequest,
			tqkSchema: z.tuple([z.literal("TriplegsInboundTo"), WatchTriplegsInboundToRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TriplegsInboundTo"), z.optional(WatchTriplegsInboundToRequest)]),

			returnEnvelope: "triplegs",
			responseSchema: WatchTriplegsInboundToResponse,
			unwrapResponse: (rpc: WatchTriplegsInboundToResponse) => rpc.triplegs,
//			returnLetterSchema: TriplegStub.array(),
//			returnLetterTypeName: "TriplegStub",
		},
				
				

		ScheduledTransferById: {
			hasInput: true,
			requestSchema: WatchScheduledTransferByIdRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransferById"), WatchScheduledTransferByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransferById"), z.optional(WatchScheduledTransferByIdRequest)]),

			returnEnvelope: "scheduledTransfer",
			responseSchema: WatchScheduledTransferByIdResponse,
			unwrapResponse: (rpc: WatchScheduledTransferByIdResponse) => rpc.scheduledTransfer,
//			returnLetterSchema: ScheduledTransfer,
//			returnLetterTypeName: "ScheduledTransfer",
		},
				
				

		ScheduledTransferForBundle: {
			hasInput: true,
			requestSchema: WatchScheduledTransferForBundleRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransferForBundle"), WatchScheduledTransferForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransferForBundle"), z.optional(WatchScheduledTransferForBundleRequest)]),

			returnEnvelope: "scheduledTransfer",
			responseSchema: WatchScheduledTransferForBundleResponse,
			unwrapResponse: (rpc: WatchScheduledTransferForBundleResponse) => rpc.scheduledTransfer,
//			returnLetterSchema: ScheduledTransfer,
//			returnLetterTypeName: "ScheduledTransfer",
		},
				
				

		ScheduledTransfersForDriver: {
			hasInput: true,
			requestSchema: WatchScheduledTransfersForDriverRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransfersForDriver"), WatchScheduledTransfersForDriverRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransfersForDriver"), z.optional(WatchScheduledTransfersForDriverRequest)]),

			returnEnvelope: "scheduledTransfers",
			responseSchema: WatchScheduledTransfersForDriverResponse,
			unwrapResponse: (rpc: WatchScheduledTransfersForDriverResponse) => rpc.scheduledTransfers,
//			returnLetterSchema: ScheduledTransferStub.array(),
//			returnLetterTypeName: "ScheduledTransferStub",
		},
				
				

		ScheduledTransfersAwaitingTruck: {
			hasInput: true,
			requestSchema: WatchScheduledTransfersAwaitingTruckRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransfersAwaitingTruck"), WatchScheduledTransfersAwaitingTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransfersAwaitingTruck"), z.optional(WatchScheduledTransfersAwaitingTruckRequest)]),

			returnEnvelope: "scheduledTransfers",
			responseSchema: WatchScheduledTransfersAwaitingTruckResponse,
			unwrapResponse: (rpc: WatchScheduledTransfersAwaitingTruckResponse) => rpc.scheduledTransfers,
//			returnLetterSchema: ScheduledTransferStub.array(),
//			returnLetterTypeName: "ScheduledTransferStub",
		},

		ScheduledTransfersDuring: {
			hasInput: true,
			requestSchema: ScheduledTransfersDuringRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransfersDuring"), ScheduledTransfersDuringRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransfersDuring"), z.optional(ScheduledTransfersDuringRequest)]),

			returnEnvelope: "scheduledTransfers",
			responseSchema: ScheduledTransfersDuringResponse,
			unwrapResponse: (rpc: ScheduledTransfersDuringResponse) => rpc.scheduledTransfers,
//			returnLetterSchema: ScheduledTransferStub.array(),
//			returnLetterTypeName: "ScheduledTransferStub",
		},
				
				

		ScheduledTransfersAt: {
			hasInput: true,
			requestSchema: WatchScheduledTransfersAtRequest,
			tqkSchema: z.tuple([z.literal("ScheduledTransfersAt"), WatchScheduledTransfersAtRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduledTransfersAt"), z.optional(WatchScheduledTransfersAtRequest)]),

			returnEnvelope: "scheduledTransfers",
			responseSchema: WatchScheduledTransfersAtResponse,
			unwrapResponse: (rpc: WatchScheduledTransfersAtResponse) => rpc.scheduledTransfers,
//			returnLetterSchema: ScheduledTransferStub.array(),
//			returnLetterTypeName: "ScheduledTransferStub",
		},
				
				

		ScheduledTransfersForDispatch: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ScheduledTransfersForDispatch")]),
			

			returnEnvelope: "scheduledTransfers",
			responseSchema: WatchScheduledTransfersForDispatchResponse,
			unwrapResponse: (rpc: WatchScheduledTransfersForDispatchResponse) => rpc.scheduledTransfers,
//			returnLetterSchema: ScheduledTransferStub.array(),
//			returnLetterTypeName: "ScheduledTransferStub",
		},

		WasteFlavorByCode: {
			hasInput: true,
			requestSchema: WasteFlavorByCodeRequest,
			tqkSchema: z.tuple([z.literal("WasteFlavorByCode"), WasteFlavorByCodeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteFlavorByCode"), z.optional(WasteFlavorByCodeRequest)]),

			returnEnvelope: "flavor",
			responseSchema: WasteFlavorByCodeResponse,
			unwrapResponse: (rpc: WasteFlavorByCodeResponse) => rpc.flavor,
//			returnLetterSchema: WasteFlavor,
//			returnLetterTypeName: "WasteFlavor",
		},
				
				

		WasteFlavorById: {
			hasInput: true,
			requestSchema: WatchWasteFlavorByIdRequest,
			tqkSchema: z.tuple([z.literal("WasteFlavorById"), WatchWasteFlavorByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteFlavorById"), z.optional(WatchWasteFlavorByIdRequest)]),

			returnEnvelope: "flavor",
			responseSchema: WatchWasteFlavorByIdResponse,
			unwrapResponse: (rpc: WatchWasteFlavorByIdResponse) => rpc.flavor,
//			returnLetterSchema: WasteFlavor,
//			returnLetterTypeName: "WasteFlavor",
		},

		LastValidWasteFlavorById: {
			hasInput: true,
			requestSchema: LastValidWasteFlavorByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidWasteFlavorById"), LastValidWasteFlavorByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidWasteFlavorById"), z.optional(LastValidWasteFlavorByIdRequest)]),

			returnEnvelope: "flavor",
			responseSchema: LastValidWasteFlavorByIdResponse,
			unwrapResponse: (rpc: LastValidWasteFlavorByIdResponse) => rpc.flavor,
//			returnLetterSchema: WasteFlavor,
//			returnLetterTypeName: "WasteFlavor",
		},
					

		WasteFlavorRevisionCount: {
			hasInput: true,
			requestSchema: WasteFlavorRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("WasteFlavorRevisionCount"), WasteFlavorRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteFlavorRevisionCount"), z.optional(WasteFlavorRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: WasteFlavorRevisionCountResponse,
			unwrapResponse: (rpc: WasteFlavorRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllWasteFlavorRevisions: {
			hasInput: true,
			requestSchema: AllWasteFlavorRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllWasteFlavorRevisions"), AllWasteFlavorRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllWasteFlavorRevisions"), z.optional(AllWasteFlavorRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllWasteFlavorRevisionsResponse,
			unwrapResponse: (rpc: AllWasteFlavorRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: WasteFlavor.array(),
//			returnLetterTypeName: "WasteFlavor",
		},

		ActiveWasteFlavors: {
			hasInput: true,
			requestSchema: ActiveWasteFlavorsRequest,
			tqkSchema: z.tuple([z.literal("ActiveWasteFlavors"), ActiveWasteFlavorsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ActiveWasteFlavors"), z.optional(ActiveWasteFlavorsRequest)]),

			returnEnvelope: "flavorStubs",
			responseSchema: ActiveWasteFlavorsResponse,
			unwrapResponse: (rpc: ActiveWasteFlavorsResponse) => rpc.flavorStubs,
//			returnLetterSchema: WasteFlavorStub.array(),
//			returnLetterTypeName: "WasteFlavorStub",
		},

		GetCleavableFlavors: {
			hasInput: true,
			requestSchema: GetCleavableFlavorsRequest,
			tqkSchema: z.tuple([z.literal("GetCleavableFlavors"), GetCleavableFlavorsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("GetCleavableFlavors"), z.optional(GetCleavableFlavorsRequest)]),

			returnEnvelope: "flavors",
			responseSchema: GetCleavableFlavorsResponse,
			unwrapResponse: (rpc: GetCleavableFlavorsResponse) => rpc.flavors,
//			returnLetterSchema: WasteFlavorStub.array(),
//			returnLetterTypeName: "WasteFlavorStub",
		},

		GetEmissibleFlavors: {
			hasInput: true,
			requestSchema: GetEmissibleFlavorsRequest,
			tqkSchema: z.tuple([z.literal("GetEmissibleFlavors"), GetEmissibleFlavorsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("GetEmissibleFlavors"), z.optional(GetEmissibleFlavorsRequest)]),

			returnEnvelope: "flavors",
			responseSchema: GetEmissibleFlavorsResponse,
			unwrapResponse: (rpc: GetEmissibleFlavorsResponse) => rpc.flavors,
//			returnLetterSchema: WasteFlavorStub.array(),
//			returnLetterTypeName: "WasteFlavorStub",
		},
				
				

		WasteById: {
			hasInput: true,
			requestSchema: WatchWasteByIdRequest,
			tqkSchema: z.tuple([z.literal("WasteById"), WatchWasteByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteById"), z.optional(WatchWasteByIdRequest)]),

			returnEnvelope: "waste",
			responseSchema: WatchWasteByIdResponse,
			unwrapResponse: (rpc: WatchWasteByIdResponse) => rpc.waste,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},

		LastValidWasteById: {
			hasInput: true,
			requestSchema: LastValidWasteByIdRequest,
			tqkSchema: z.tuple([z.literal("LastValidWasteById"), LastValidWasteByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidWasteById"), z.optional(LastValidWasteByIdRequest)]),

			returnEnvelope: "waste",
			responseSchema: LastValidWasteByIdResponse,
			unwrapResponse: (rpc: LastValidWasteByIdResponse) => rpc.waste,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},

		WasteByIdAsof: {
			hasInput: true,
			requestSchema: WasteByIdAsofRequest,
			tqkSchema: z.tuple([z.literal("WasteByIdAsof"), WasteByIdAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteByIdAsof"), z.optional(WasteByIdAsofRequest)]),

			returnEnvelope: "waste",
			responseSchema: WasteByIdAsofResponse,
			unwrapResponse: (rpc: WasteByIdAsofResponse) => rpc.waste,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},
					

		WasteRevisionCount: {
			hasInput: true,
			requestSchema: WasteRevisionCountRequest,
			tqkSchema: z.tuple([z.literal("WasteRevisionCount"), WasteRevisionCountRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteRevisionCount"), z.optional(WasteRevisionCountRequest)]),

			returnEnvelope: "revisionCount",
			responseSchema: WasteRevisionCountResponse,
			unwrapResponse: (rpc: WasteRevisionCountResponse) => rpc.revisionCount,
//			returnLetterSchema: z.number(),
//			returnLetterTypeName: "number",
		},

		AllWasteRevisionStubs: {
			hasInput: true,
			requestSchema: AllWasteRevisionStubsRequest,
			tqkSchema: z.tuple([z.literal("AllWasteRevisionStubs"), AllWasteRevisionStubsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllWasteRevisionStubs"), z.optional(AllWasteRevisionStubsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllWasteRevisionStubsResponse,
			unwrapResponse: (rpc: AllWasteRevisionStubsResponse) => rpc.revisions,
//			returnLetterSchema: WasteRevisionStub.array(),
//			returnLetterTypeName: "WasteRevisionStub",
		},

		AllWasteRevisions: {
			hasInput: true,
			requestSchema: AllWasteRevisionsRequest,
			tqkSchema: z.tuple([z.literal("AllWasteRevisions"), AllWasteRevisionsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllWasteRevisions"), z.optional(AllWasteRevisionsRequest)]),

			returnEnvelope: "revisions",
			responseSchema: AllWasteRevisionsResponse,
			unwrapResponse: (rpc: AllWasteRevisionsResponse) => rpc.revisions,
//			returnLetterSchema: Waste.array(),
//			returnLetterTypeName: "Waste",
		},
				
				

		WastesForBundle: {
			hasInput: true,
			requestSchema: WatchWastesForBundleRequest,
			tqkSchema: z.tuple([z.literal("WastesForBundle"), WatchWastesForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WastesForBundle"), z.optional(WatchWastesForBundleRequest)]),

			returnEnvelope: "wastes",
			responseSchema: WatchWastesForBundleResponse,
			unwrapResponse: (rpc: WatchWastesForBundleResponse) => rpc.wastes,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		AllWastesForBundle: {
			hasInput: true,
			requestSchema: AllWastesForBundleRequest,
			tqkSchema: z.tuple([z.literal("AllWastesForBundle"), AllWastesForBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllWastesForBundle"), z.optional(AllWastesForBundleRequest)]),

			returnEnvelope: "wastes",
			responseSchema: AllWastesForBundleResponse,
			unwrapResponse: (rpc: AllWastesForBundleResponse) => rpc.wastes,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		WastesForBundleAsof: {
			hasInput: true,
			requestSchema: WastesForBundleAsofRequest,
			tqkSchema: z.tuple([z.literal("WastesForBundleAsof"), WastesForBundleAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WastesForBundleAsof"), z.optional(WastesForBundleAsofRequest)]),

			returnEnvelope: "wastes",
			responseSchema: WastesForBundleAsofResponse,
			unwrapResponse: (rpc: WastesForBundleAsofResponse) => rpc.wastes,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		AllDaughtersOfWaste: {
			hasInput: true,
			requestSchema: AllDaughtersOfWasteRequest,
			tqkSchema: z.tuple([z.literal("AllDaughtersOfWaste"), AllDaughtersOfWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllDaughtersOfWaste"), z.optional(AllDaughtersOfWasteRequest)]),

			returnEnvelope: "daughters",
			responseSchema: AllDaughtersOfWasteResponse,
			unwrapResponse: (rpc: AllDaughtersOfWasteResponse) => rpc.daughters,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		MothersOfWaste: {
			hasInput: true,
			requestSchema: MothersOfWasteRequest,
			tqkSchema: z.tuple([z.literal("MothersOfWaste"), MothersOfWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("MothersOfWaste"), z.optional(MothersOfWasteRequest)]),

			returnEnvelope: "mothers",
			responseSchema: MothersOfWasteResponse,
			unwrapResponse: (rpc: MothersOfWasteResponse) => rpc.mothers,
//			returnLetterSchema: Waste.array(),
//			returnLetterTypeName: "Waste",
		},

		DirectWasteLineageRecords: {
			hasInput: true,
			requestSchema: DirectWasteLineageRecordsRequest,
			tqkSchema: z.tuple([z.literal("DirectWasteLineageRecords"), DirectWasteLineageRecordsRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("DirectWasteLineageRecords"), z.optional(DirectWasteLineageRecordsRequest)]),

			returnEnvelope: "lineageRecords",
			responseSchema: DirectWasteLineageRecordsResponse,
			unwrapResponse: (rpc: DirectWasteLineageRecordsResponse) => rpc.lineageRecords,
//			returnLetterSchema: WasteLineageRecord.array(),
//			returnLetterTypeName: "WasteLineageRecord",
		},
				
				

		BundleForWaste: {
			hasInput: true,
			requestSchema: WatchBundleForWasteRequest,
			tqkSchema: z.tuple([z.literal("BundleForWaste"), WatchBundleForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleForWaste"), z.optional(WatchBundleForWasteRequest)]),

			returnEnvelope: "bundle",
			responseSchema: WatchBundleForWasteResponse,
			unwrapResponse: (rpc: WatchBundleForWasteResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		LastValidBundleForWaste: {
			hasInput: true,
			requestSchema: LastValidBundleForWasteRequest,
			tqkSchema: z.tuple([z.literal("LastValidBundleForWaste"), LastValidBundleForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastValidBundleForWaste"), z.optional(LastValidBundleForWasteRequest)]),

			returnEnvelope: "bundle",
			responseSchema: LastValidBundleForWasteResponse,
			unwrapResponse: (rpc: LastValidBundleForWasteResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		BundleForWasteAsof: {
			hasInput: true,
			requestSchema: BundleForWasteAsofRequest,
			tqkSchema: z.tuple([z.literal("BundleForWasteAsof"), BundleForWasteAsofRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("BundleForWasteAsof"), z.optional(BundleForWasteAsofRequest)]),

			returnEnvelope: "bundle",
			responseSchema: BundleForWasteAsofResponse,
			unwrapResponse: (rpc: BundleForWasteAsofResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		AllBundlesForWaste: {
			hasInput: true,
			requestSchema: AllBundlesForWasteRequest,
			tqkSchema: z.tuple([z.literal("AllBundlesForWaste"), AllBundlesForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AllBundlesForWaste"), z.optional(AllBundlesForWasteRequest)]),

			returnEnvelope: "bundles",
			responseSchema: AllBundlesForWasteResponse,
			unwrapResponse: (rpc: AllBundlesForWasteResponse) => rpc.bundles,
//			returnLetterSchema: BundleStub.array(),
//			returnLetterTypeName: "BundleStub",
		},
				
				

		AssociationsForWaste: {
			hasInput: true,
			requestSchema: WatchAssociationsForWasteRequest,
			tqkSchema: z.tuple([z.literal("AssociationsForWaste"), WatchAssociationsForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AssociationsForWaste"), z.optional(WatchAssociationsForWasteRequest)]),

			returnEnvelope: "assoc",
			responseSchema: WatchAssociationsForWasteResponse,
			unwrapResponse: (rpc: WatchAssociationsForWasteResponse) => rpc.assoc,
//			returnLetterSchema: WasteAssociation,
//			returnLetterTypeName: "WasteAssociation",
		},
					

		ShowExportedWaste: {
			hasInput: true,
			requestSchema: ShowExportedWasteRequest,
			tqkSchema: z.tuple([z.literal("ShowExportedWaste"), ShowExportedWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ShowExportedWaste"), z.optional(ShowExportedWasteRequest)]),

			returnEnvelope: "exported",
			responseSchema: ShowExportedWasteResponse,
			unwrapResponse: (rpc: ShowExportedWasteResponse) => rpc.exported,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		CompleteWasteHistoryById: {
			hasInput: true,
			requestSchema: CompleteWasteHistoryByIdRequest,
			tqkSchema: z.tuple([z.literal("CompleteWasteHistoryById"), CompleteWasteHistoryByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompleteWasteHistoryById"), z.optional(CompleteWasteHistoryByIdRequest)]),

			returnEnvelope: "history",
			responseSchema: CompleteWasteHistoryByIdResponse,
			unwrapResponse: (rpc: CompleteWasteHistoryByIdResponse) => rpc.history,
//			returnLetterSchema: CompleteWasteHistory,
//			returnLetterTypeName: "CompleteWasteHistory",
		},
				
				

		WasteLocation: {
			hasInput: true,
			requestSchema: WatchWasteLocationRequest,
			tqkSchema: z.tuple([z.literal("WasteLocation"), WatchWasteLocationRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteLocation"), z.optional(WatchWasteLocationRequest)]),

			returnEnvelope: "curloc",
			responseSchema: WatchWasteLocationResponse,
			unwrapResponse: (rpc: WatchWasteLocationResponse) => rpc.curloc,
//			returnLetterSchema: TruckOrVenueStub,
//			returnLetterTypeName: "TruckOrVenueStub",
		},
				
				

		WastesAt: {
			hasInput: true,
			requestSchema: WatchWastesAtRequest,
			tqkSchema: z.tuple([z.literal("WastesAt"), WatchWastesAtRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WastesAt"), z.optional(WatchWastesAtRequest)]),

			returnEnvelope: "stubs",
			responseSchema: WatchWastesAtResponse,
			unwrapResponse: (rpc: WatchWastesAtResponse) => rpc.stubs,
//			returnLetterSchema: WasteStub.array(),
//			returnLetterTypeName: "WasteStub",
		},

		WasteStampById: {
			hasInput: true,
			requestSchema: WasteStampByIdRequest,
			tqkSchema: z.tuple([z.literal("WasteStampById"), WasteStampByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("WasteStampById"), z.optional(WasteStampByIdRequest)]),

			returnEnvelope: "stamp",
			responseSchema: WasteStampByIdResponse,
			unwrapResponse: (rpc: WasteStampByIdResponse) => rpc.stamp,
//			returnLetterSchema: WasteStamp,
//			returnLetterTypeName: "WasteStamp",
		},

		LastFlavoredStampForWaste: {
			hasInput: true,
			requestSchema: LastFlavoredStampForWasteRequest,
			tqkSchema: z.tuple([z.literal("LastFlavoredStampForWaste"), LastFlavoredStampForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("LastFlavoredStampForWaste"), z.optional(LastFlavoredStampForWasteRequest)]),

			returnEnvelope: "stamp",
			responseSchema: LastFlavoredStampForWasteResponse,
			unwrapResponse: (rpc: LastFlavoredStampForWasteResponse) => rpc.stamp,
//			returnLetterSchema: WasteStamp,
//			returnLetterTypeName: "WasteStamp",
		},
				
				

		StampsForWaste: {
			hasInput: true,
			requestSchema: WatchStampsForWasteRequest,
			tqkSchema: z.tuple([z.literal("StampsForWaste"), WatchStampsForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampsForWaste"), z.optional(WatchStampsForWasteRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchStampsForWasteResponse,
			unwrapResponse: (rpc: WatchStampsForWasteResponse) => rpc.stamps,
//			returnLetterSchema: WasteStamp.array(),
//			returnLetterTypeName: "WasteStamp",
		},
				
				

		FlavoredStampsForWaste: {
			hasInput: true,
			requestSchema: WatchFlavoredStampsForWasteRequest,
			tqkSchema: z.tuple([z.literal("FlavoredStampsForWaste"), WatchFlavoredStampsForWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("FlavoredStampsForWaste"), z.optional(WatchFlavoredStampsForWasteRequest)]),

			returnEnvelope: "stamps",
			responseSchema: WatchFlavoredStampsForWasteResponse,
			unwrapResponse: (rpc: WatchFlavoredStampsForWasteResponse) => rpc.stamps,
//			returnLetterSchema: WasteStamp.array(),
//			returnLetterTypeName: "WasteStamp",
		},
				
				

		PackingModes: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("PackingModes")]),
			

			returnEnvelope: "modes",
			responseSchema: WatchPackingModesResponse,
			unwrapResponse: (rpc: WatchPackingModesResponse) => rpc.modes,
//			returnLetterSchema: PackingMode.array(),
//			returnLetterTypeName: "PackingMode",
		},
				
				

		PackingModeById: {
			hasInput: true,
			requestSchema: WatchPackingModeByIdRequest,
			tqkSchema: z.tuple([z.literal("PackingModeById"), WatchPackingModeByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PackingModeById"), z.optional(WatchPackingModeByIdRequest)]),

			returnEnvelope: "mode",
			responseSchema: WatchPackingModeByIdResponse,
			unwrapResponse: (rpc: WatchPackingModeByIdResponse) => rpc.mode,
//			returnLetterSchema: PackingMode,
//			returnLetterTypeName: "PackingMode",
		},
				
				

		ManifestTypes: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("ManifestTypes")]),
			

			returnEnvelope: "maniTypes",
			responseSchema: WatchManifestTypesResponse,
			unwrapResponse: (rpc: WatchManifestTypesResponse) => rpc.maniTypes,
//			returnLetterSchema: ManifestType.array(),
//			returnLetterTypeName: "ManifestType",
		},
				
				

		ManifestTypeById: {
			hasInput: true,
			requestSchema: WatchManifestTypeByIdRequest,
			tqkSchema: z.tuple([z.literal("ManifestTypeById"), WatchManifestTypeByIdRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ManifestTypeById"), z.optional(WatchManifestTypeByIdRequest)]),

			returnEnvelope: "maniType",
			responseSchema: WatchManifestTypeByIdResponse,
			unwrapResponse: (rpc: WatchManifestTypeByIdResponse) => rpc.maniType,
//			returnLetterSchema: ManifestType,
//			returnLetterTypeName: "ManifestType",
		},
				
				

		Units: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("Units")]),
			

			returnEnvelope: "units",
			responseSchema: WatchUnitsResponse,
			unwrapResponse: (rpc: WatchUnitsResponse) => rpc.units,
//			returnLetterSchema: Unit.array(),
//			returnLetterTypeName: "Unit",
		},
				
				

		TransformModes: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("TransformModes")]),
			

			returnEnvelope: "modes",
			responseSchema: WatchTransformModesResponse,
			unwrapResponse: (rpc: WatchTransformModesResponse) => rpc.modes,
//			returnLetterSchema: EntityStub.array(),
//			returnLetterTypeName: "EntityStub",
		},
				
				

		TransformModesForVenue: {
			hasInput: true,
			requestSchema: WatchTransformModesForVenueRequest,
			tqkSchema: z.tuple([z.literal("TransformModesForVenue"), WatchTransformModesForVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("TransformModesForVenue"), z.optional(WatchTransformModesForVenueRequest)]),

			returnEnvelope: "modes",
			responseSchema: WatchTransformModesForVenueResponse,
			unwrapResponse: (rpc: WatchTransformModesForVenueResponse) => rpc.modes,
//			returnLetterSchema: EntityStub.array(),
//			returnLetterTypeName: "EntityStub",
		},

		AllRewindCheckpoints: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("AllRewindCheckpoints")]),
			

			returnEnvelope: "checkpoints",
			responseSchema: AllRewindCheckpointsResponse,
			unwrapResponse: (rpc: AllRewindCheckpointsResponse) => rpc.checkpoints,
//			returnLetterSchema: RewindCheckpoint.array(),
//			returnLetterTypeName: "RewindCheckpoint",
		},

		Setlists: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("Setlists")]),
			

			returnEnvelope: "setlistPacketResult",
			responseSchema: SetlistsResponse,
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		SetlistSubscriptions: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("SetlistSubscriptions")]),
			

			returnEnvelope: "subscriptions",
			responseSchema: SetlistSubscriptionsResponse,
			unwrapResponse: (rpc: SetlistSubscriptionsResponse) => rpc.subscriptions,
//			returnLetterSchema: SetlistSubscription.array(),
//			returnLetterTypeName: "SetlistSubscription",
		},

		SetSystemConfig: {
			hasInput: true,
			requestSchema: SetSystemConfigRequest,
			tqkSchema: z.tuple([z.literal("SetSystemConfig"), SetSystemConfigRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SetSystemConfig"), z.optional(SetSystemConfigRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertCompany: {
			hasInput: true,
			requestSchema: UpsertCompanyRequest,
			tqkSchema: z.tuple([z.literal("UpsertCompany"), UpsertCompanyRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertCompany"), z.optional(UpsertCompanyRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertCompanyResponse,
			unwrapResponse: (rpc: UpsertCompanyResponse) => rpc.result,
//			returnLetterSchema: CompanyUpsertResult,
//			returnLetterTypeName: "CompanyUpsertResult",
		},

		PatchCompany: {
			hasInput: true,
			requestSchema: PatchCompanyRequest,
			tqkSchema: z.tuple([z.literal("PatchCompany"), PatchCompanyRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchCompany"), z.optional(PatchCompanyRequest)]),

			returnEnvelope: "company",
			responseSchema: PatchCompanyResponse,
			unwrapResponse: (rpc: PatchCompanyResponse) => rpc.company,
//			returnLetterSchema: Company,
//			returnLetterTypeName: "Company",
		},

		RetireCompany: {
			hasInput: true,
			requestSchema: RetireCompanyRequest,
			tqkSchema: z.tuple([z.literal("RetireCompany"), RetireCompanyRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireCompany"), z.optional(RetireCompanyRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertVenue: {
			hasInput: true,
			requestSchema: UpsertVenueRequest,
			tqkSchema: z.tuple([z.literal("UpsertVenue"), UpsertVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertVenue"), z.optional(UpsertVenueRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertVenueResponse,
			unwrapResponse: (rpc: UpsertVenueResponse) => rpc.result,
//			returnLetterSchema: VenueUpsertResult,
//			returnLetterTypeName: "VenueUpsertResult",
		},

		PatchVenue: {
			hasInput: true,
			requestSchema: PatchVenueRequest,
			tqkSchema: z.tuple([z.literal("PatchVenue"), PatchVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchVenue"), z.optional(PatchVenueRequest)]),

			returnEnvelope: "venue",
			responseSchema: PatchVenueResponse,
			unwrapResponse: (rpc: PatchVenueResponse) => rpc.venue,
//			returnLetterSchema: Venue,
//			returnLetterTypeName: "Venue",
		},

		RetireVenue: {
			hasInput: true,
			requestSchema: RetireVenueRequest,
			tqkSchema: z.tuple([z.literal("RetireVenue"), RetireVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireVenue"), z.optional(RetireVenueRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertDownstreamVenue: {
			hasInput: true,
			requestSchema: UpsertDownstreamVenueRequest,
			tqkSchema: z.tuple([z.literal("UpsertDownstreamVenue"), UpsertDownstreamVenueRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertDownstreamVenue"), z.optional(UpsertDownstreamVenueRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertDownstreamVenueResponse,
			unwrapResponse: (rpc: UpsertDownstreamVenueResponse) => rpc.result,
//			returnLetterSchema: VenueUpsertResult,
//			returnLetterTypeName: "VenueUpsertResult",
		},

		UpsertAgent: {
			hasInput: true,
			requestSchema: UpsertAgentRequest,
			tqkSchema: z.tuple([z.literal("UpsertAgent"), UpsertAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertAgent"), z.optional(UpsertAgentRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertAgentResponse,
			unwrapResponse: (rpc: UpsertAgentResponse) => rpc.result,
//			returnLetterSchema: AgentUpsertResult,
//			returnLetterTypeName: "AgentUpsertResult",
		},

		PatchAgent: {
			hasInput: true,
			requestSchema: PatchAgentRequest,
			tqkSchema: z.tuple([z.literal("PatchAgent"), PatchAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchAgent"), z.optional(PatchAgentRequest)]),

			returnEnvelope: "agent",
			responseSchema: PatchAgentResponse,
			unwrapResponse: (rpc: PatchAgentResponse) => rpc.agent,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},

		PatchSelf: {
			hasInput: true,
			requestSchema: PatchSelfRequest,
			tqkSchema: z.tuple([z.literal("PatchSelf"), PatchSelfRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchSelf"), z.optional(PatchSelfRequest)]),

			returnEnvelope: "self",
			responseSchema: PatchSelfResponse,
			unwrapResponse: (rpc: PatchSelfResponse) => rpc.self,
//			returnLetterSchema: Agent,
//			returnLetterTypeName: "Agent",
		},
					

		ChangePassword: {
			hasInput: true,
			requestSchema: ChangePasswordRequest,
			tqkSchema: z.tuple([z.literal("ChangePassword"), ChangePasswordRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ChangePassword"), z.optional(ChangePasswordRequest)]),

			returnEnvelope: "authtoken",
			responseSchema: ChangePasswordResponse,
			unwrapResponse: (rpc: ChangePasswordResponse) => rpc.authtoken,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		RetireAgent: {
			hasInput: true,
			requestSchema: RetireAgentRequest,
			tqkSchema: z.tuple([z.literal("RetireAgent"), RetireAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireAgent"), z.optional(RetireAgentRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		StampAgent: {
			hasInput: true,
			requestSchema: StampAgentRequest,
			tqkSchema: z.tuple([z.literal("StampAgent"), StampAgentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampAgent"), z.optional(StampAgentRequest)]),

			returnEnvelope: "stamp",
			responseSchema: StampAgentResponse,
			unwrapResponse: (rpc: StampAgentResponse) => rpc.stamp,
//			returnLetterSchema: AgentStamp,
//			returnLetterTypeName: "AgentStamp",
		},

		UpsertTruckModel: {
			hasInput: true,
			requestSchema: UpsertTruckModelRequest,
			tqkSchema: z.tuple([z.literal("UpsertTruckModel"), UpsertTruckModelRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertTruckModel"), z.optional(UpsertTruckModelRequest)]),

			returnEnvelope: "model",
			responseSchema: UpsertTruckModelResponse,
			unwrapResponse: (rpc: UpsertTruckModelResponse) => rpc.model,
//			returnLetterSchema: TruckModelUpsertResult,
//			returnLetterTypeName: "TruckModelUpsertResult",
		},

		PatchTruckModel: {
			hasInput: true,
			requestSchema: PatchTruckModelRequest,
			tqkSchema: z.tuple([z.literal("PatchTruckModel"), PatchTruckModelRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchTruckModel"), z.optional(PatchTruckModelRequest)]),

			returnEnvelope: "model",
			responseSchema: PatchTruckModelResponse,
			unwrapResponse: (rpc: PatchTruckModelResponse) => rpc.model,
//			returnLetterSchema: TruckModel,
//			returnLetterTypeName: "TruckModel",
		},

		RetireTruckModel: {
			hasInput: true,
			requestSchema: RetireTruckModelRequest,
			tqkSchema: z.tuple([z.literal("RetireTruckModel"), RetireTruckModelRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireTruckModel"), z.optional(RetireTruckModelRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertTruck: {
			hasInput: true,
			requestSchema: UpsertTruckRequest,
			tqkSchema: z.tuple([z.literal("UpsertTruck"), UpsertTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertTruck"), z.optional(UpsertTruckRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertTruckResponse,
			unwrapResponse: (rpc: UpsertTruckResponse) => rpc.result,
//			returnLetterSchema: TruckUpsertResult,
//			returnLetterTypeName: "TruckUpsertResult",
		},

		PatchTruck: {
			hasInput: true,
			requestSchema: PatchTruckRequest,
			tqkSchema: z.tuple([z.literal("PatchTruck"), PatchTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchTruck"), z.optional(PatchTruckRequest)]),

			returnEnvelope: "truck",
			responseSchema: PatchTruckResponse,
			unwrapResponse: (rpc: PatchTruckResponse) => rpc.truck,
//			returnLetterSchema: Truck,
//			returnLetterTypeName: "Truck",
		},

		RetireTruck: {
			hasInput: true,
			requestSchema: RetireTruckRequest,
			tqkSchema: z.tuple([z.literal("RetireTruck"), RetireTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireTruck"), z.optional(RetireTruckRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		MountTruck: {
			hasInput: true,
			requestSchema: MountTruckRequest,
			tqkSchema: z.tuple([z.literal("MountTruck"), MountTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("MountTruck"), z.optional(MountTruckRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},
					

		DismountTruck: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("DismountTruck")]),
			

			returnEnvelope: "oldTruckId",
			responseSchema: DismountTruckResponse,
			unwrapResponse: (rpc: DismountTruckResponse) => rpc.oldTruckId,
//			returnLetterSchema: z.string(),
//			returnLetterTypeName: "string",
		},

		StampTruck: {
			hasInput: true,
			requestSchema: StampTruckRequest,
			tqkSchema: z.tuple([z.literal("StampTruck"), StampTruckRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampTruck"), z.optional(StampTruckRequest)]),

			returnEnvelope: "stamp",
			responseSchema: StampTruckResponse,
			unwrapResponse: (rpc: StampTruckResponse) => rpc.stamp,
//			returnLetterSchema: TruckStamp,
//			returnLetterTypeName: "TruckStamp",
		},

		UpsertSurchargeFlavor: {
			hasInput: true,
			requestSchema: UpsertSurchargeFlavorRequest,
			tqkSchema: z.tuple([z.literal("UpsertSurchargeFlavor"), UpsertSurchargeFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertSurchargeFlavor"), z.optional(UpsertSurchargeFlavorRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertSurchargeFlavorResponse,
			unwrapResponse: (rpc: UpsertSurchargeFlavorResponse) => rpc.result,
//			returnLetterSchema: SurchargeFlavorUpsertResult,
//			returnLetterTypeName: "SurchargeFlavorUpsertResult",
		},

		PatchSurchargeFlavor: {
			hasInput: true,
			requestSchema: PatchSurchargeFlavorRequest,
			tqkSchema: z.tuple([z.literal("PatchSurchargeFlavor"), PatchSurchargeFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchSurchargeFlavor"), z.optional(PatchSurchargeFlavorRequest)]),

			returnEnvelope: "flavor",
			responseSchema: PatchSurchargeFlavorResponse,
			unwrapResponse: (rpc: PatchSurchargeFlavorResponse) => rpc.flavor,
//			returnLetterSchema: SurchargeFlavor,
//			returnLetterTypeName: "SurchargeFlavor",
		},

		RetireSurchargeFlavor: {
			hasInput: true,
			requestSchema: RetireSurchargeFlavorRequest,
			tqkSchema: z.tuple([z.literal("RetireSurchargeFlavor"), RetireSurchargeFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireSurchargeFlavor"), z.optional(RetireSurchargeFlavorRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		SpawnSurcharge: {
			hasInput: true,
			requestSchema: SpawnSurchargeRequest,
			tqkSchema: z.tuple([z.literal("SpawnSurcharge"), SpawnSurchargeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SpawnSurcharge"), z.optional(SpawnSurchargeRequest)]),

			returnEnvelope: "surcharge",
			responseSchema: SpawnSurchargeResponse,
			unwrapResponse: (rpc: SpawnSurchargeResponse) => rpc.surcharge,
//			returnLetterSchema: Surcharge,
//			returnLetterTypeName: "Surcharge",
		},

		PatchSurcharge: {
			hasInput: true,
			requestSchema: PatchSurchargeRequest,
			tqkSchema: z.tuple([z.literal("PatchSurcharge"), PatchSurchargeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchSurcharge"), z.optional(PatchSurchargeRequest)]),

			returnEnvelope: "surcharge",
			responseSchema: PatchSurchargeResponse,
			unwrapResponse: (rpc: PatchSurchargeResponse) => rpc.surcharge,
//			returnLetterSchema: Surcharge,
//			returnLetterTypeName: "Surcharge",
		},

		RetireSurcharge: {
			hasInput: true,
			requestSchema: RetireSurchargeRequest,
			tqkSchema: z.tuple([z.literal("RetireSurcharge"), RetireSurchargeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireSurcharge"), z.optional(RetireSurchargeRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertShinwaJob: {
			hasInput: true,
			requestSchema: UpsertShinwaJobRequest,
			tqkSchema: z.tuple([z.literal("UpsertShinwaJob"), UpsertShinwaJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertShinwaJob"), z.optional(UpsertShinwaJobRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertShinwaJobResponse,
			unwrapResponse: (rpc: UpsertShinwaJobResponse) => rpc.result,
//			returnLetterSchema: JobUpsertResult,
//			returnLetterTypeName: "JobUpsertResult",
		},

		UpsertSanyuJob: {
			hasInput: true,
			requestSchema: UpsertSanyuJobRequest,
			tqkSchema: z.tuple([z.literal("UpsertSanyuJob"), UpsertSanyuJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertSanyuJob"), z.optional(UpsertSanyuJobRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertSanyuJobResponse,
			unwrapResponse: (rpc: UpsertSanyuJobResponse) => rpc.result,
//			returnLetterSchema: JobUpsertResult,
//			returnLetterTypeName: "JobUpsertResult",
		},

		PatchJob: {
			hasInput: true,
			requestSchema: PatchJobRequest,
			tqkSchema: z.tuple([z.literal("PatchJob"), PatchJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchJob"), z.optional(PatchJobRequest)]),

			returnEnvelope: "job",
			responseSchema: PatchJobResponse,
			unwrapResponse: (rpc: PatchJobResponse) => rpc.job,
//			returnLetterSchema: Job,
//			returnLetterTypeName: "Job",
		},

		StampJob: {
			hasInput: true,
			requestSchema: StampJobRequest,
			tqkSchema: z.tuple([z.literal("StampJob"), StampJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampJob"), z.optional(StampJobRequest)]),

			returnEnvelope: "stamp",
			responseSchema: StampJobResponse,
			unwrapResponse: (rpc: StampJobResponse) => rpc.stamp,
//			returnLetterSchema: JobStamp,
//			returnLetterTypeName: "JobStamp",
		},

		CancelJobStamp: {
			hasInput: true,
			requestSchema: CancelJobStampRequest,
			tqkSchema: z.tuple([z.literal("CancelJobStamp"), CancelJobStampRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CancelJobStamp"), z.optional(CancelJobStampRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		SpawnGroundedBundle: {
			hasInput: true,
			requestSchema: SpawnGroundedBundleRequest,
			tqkSchema: z.tuple([z.literal("SpawnGroundedBundle"), SpawnGroundedBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SpawnGroundedBundle"), z.optional(SpawnGroundedBundleRequest)]),

			returnEnvelope: "bundle",
			responseSchema: SpawnGroundedBundleResponse,
			unwrapResponse: (rpc: SpawnGroundedBundleResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		SpawnLoadedBundle: {
			hasInput: true,
			requestSchema: SpawnLoadedBundleRequest,
			tqkSchema: z.tuple([z.literal("SpawnLoadedBundle"), SpawnLoadedBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SpawnLoadedBundle"), z.optional(SpawnLoadedBundleRequest)]),

			returnEnvelope: "bundle",
			responseSchema: SpawnLoadedBundleResponse,
			unwrapResponse: (rpc: SpawnLoadedBundleResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		PatchBundle: {
			hasInput: true,
			requestSchema: PatchBundleRequest,
			tqkSchema: z.tuple([z.literal("PatchBundle"), PatchBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchBundle"), z.optional(PatchBundleRequest)]),

			returnEnvelope: "bundle",
			responseSchema: PatchBundleResponse,
			unwrapResponse: (rpc: PatchBundleResponse) => rpc.bundle,
//			returnLetterSchema: Bundle,
//			returnLetterTypeName: "Bundle",
		},

		StampBundle: {
			hasInput: true,
			requestSchema: StampBundleRequest,
			tqkSchema: z.tuple([z.literal("StampBundle"), StampBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampBundle"), z.optional(StampBundleRequest)]),

			returnEnvelope: "stamp",
			responseSchema: StampBundleResponse,
			unwrapResponse: (rpc: StampBundleResponse) => rpc.stamp,
//			returnLetterSchema: BundleStamp,
//			returnLetterTypeName: "BundleStamp",
		},

		FieldCancelBundle: {
			hasInput: true,
			requestSchema: FieldCancelBundleRequest,
			tqkSchema: z.tuple([z.literal("FieldCancelBundle"), FieldCancelBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("FieldCancelBundle"), z.optional(FieldCancelBundleRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		RetireBundle: {
			hasInput: true,
			requestSchema: RetireBundleRequest,
			tqkSchema: z.tuple([z.literal("RetireBundle"), RetireBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireBundle"), z.optional(RetireBundleRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		ScheduleBundlePickup: {
			hasInput: true,
			requestSchema: ScheduleBundlePickupRequest,
			tqkSchema: z.tuple([z.literal("ScheduleBundlePickup"), ScheduleBundlePickupRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduleBundlePickup"), z.optional(ScheduleBundlePickupRequest)]),

			returnEnvelope: "scheduledTransfer",
			responseSchema: ScheduleBundlePickupResponse,
			unwrapResponse: (rpc: ScheduleBundlePickupResponse) => rpc.scheduledTransfer,
//			returnLetterSchema: ScheduledTransfer,
//			returnLetterTypeName: "ScheduledTransfer",
		},

		ScheduleBundleDropoff: {
			hasInput: true,
			requestSchema: ScheduleBundleDropoffRequest,
			tqkSchema: z.tuple([z.literal("ScheduleBundleDropoff"), ScheduleBundleDropoffRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("ScheduleBundleDropoff"), z.optional(ScheduleBundleDropoffRequest)]),

			returnEnvelope: "scheduledTransfer",
			responseSchema: ScheduleBundleDropoffResponse,
			unwrapResponse: (rpc: ScheduleBundleDropoffResponse) => rpc.scheduledTransfer,
//			returnLetterSchema: ScheduledTransfer,
//			returnLetterTypeName: "ScheduledTransfer",
		},

		PatchScheduledTransfer: {
			hasInput: true,
			requestSchema: PatchScheduledTransferRequest,
			tqkSchema: z.tuple([z.literal("PatchScheduledTransfer"), PatchScheduledTransferRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchScheduledTransfer"), z.optional(PatchScheduledTransferRequest)]),

			returnEnvelope: "scheduledTransfer",
			responseSchema: PatchScheduledTransferResponse,
			unwrapResponse: (rpc: PatchScheduledTransferResponse) => rpc.scheduledTransfer,
//			returnLetterSchema: ScheduledTransfer,
//			returnLetterTypeName: "ScheduledTransfer",
		},

		CancelScheduledTransfer: {
			hasInput: true,
			requestSchema: CancelScheduledTransferRequest,
			tqkSchema: z.tuple([z.literal("CancelScheduledTransfer"), CancelScheduledTransferRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CancelScheduledTransfer"), z.optional(CancelScheduledTransferRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		DisclaimScheduledTransfer: {
			hasInput: true,
			requestSchema: DisclaimScheduledTransferRequest,
			tqkSchema: z.tuple([z.literal("DisclaimScheduledTransfer"), DisclaimScheduledTransferRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("DisclaimScheduledTransfer"), z.optional(DisclaimScheduledTransferRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		DisclaimAllMyScheduledTransfers: {
			hasInput: false,
			requestSchema: z.undefined(),
			tqkSchema: z.tuple([z.literal("DisclaimAllMyScheduledTransfers")]),
			

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		StartTripleg: {
			hasInput: true,
			requestSchema: StartTriplegRequest,
			tqkSchema: z.tuple([z.literal("StartTripleg"), StartTriplegRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StartTripleg"), z.optional(StartTriplegRequest)]),

			returnEnvelope: "tripleg",
			responseSchema: StartTriplegResponse,
			unwrapResponse: (rpc: StartTriplegResponse) => rpc.tripleg,
//			returnLetterSchema: Tripleg,
//			returnLetterTypeName: "Tripleg",
		},

		PatchTripleg: {
			hasInput: true,
			requestSchema: PatchTriplegRequest,
			tqkSchema: z.tuple([z.literal("PatchTripleg"), PatchTriplegRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchTripleg"), z.optional(PatchTriplegRequest)]),

			returnEnvelope: "tripleg",
			responseSchema: PatchTriplegResponse,
			unwrapResponse: (rpc: PatchTriplegResponse) => rpc.tripleg,
//			returnLetterSchema: Tripleg,
//			returnLetterTypeName: "Tripleg",
		},

		Arrive: {
			hasInput: true,
			requestSchema: ArriveRequest,
			tqkSchema: z.tuple([z.literal("Arrive"), ArriveRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("Arrive"), z.optional(ArriveRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		Admit: {
			hasInput: true,
			requestSchema: AdmitRequest,
			tqkSchema: z.tuple([z.literal("Admit"), AdmitRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("Admit"), z.optional(AdmitRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		StartBundleOnloading: {
			hasInput: true,
			requestSchema: StartBundleOnloadingRequest,
			tqkSchema: z.tuple([z.literal("StartBundleOnloading"), StartBundleOnloadingRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StartBundleOnloading"), z.optional(StartBundleOnloadingRequest)]),

			returnEnvelope: "transfer",
			responseSchema: StartBundleOnloadingResponse,
			unwrapResponse: (rpc: StartBundleOnloadingResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		CompleteBundleOnloading: {
			hasInput: true,
			requestSchema: CompleteBundleOnloadingRequest,
			tqkSchema: z.tuple([z.literal("CompleteBundleOnloading"), CompleteBundleOnloadingRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompleteBundleOnloading"), z.optional(CompleteBundleOnloadingRequest)]),

			returnEnvelope: "transfer",
			responseSchema: CompleteBundleOnloadingResponse,
			unwrapResponse: (rpc: CompleteBundleOnloadingResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		StartBundleOffloading: {
			hasInput: true,
			requestSchema: StartBundleOffloadingRequest,
			tqkSchema: z.tuple([z.literal("StartBundleOffloading"), StartBundleOffloadingRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StartBundleOffloading"), z.optional(StartBundleOffloadingRequest)]),

			returnEnvelope: "transfer",
			responseSchema: StartBundleOffloadingResponse,
			unwrapResponse: (rpc: StartBundleOffloadingResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		CompleteBundleOffloading: {
			hasInput: true,
			requestSchema: CompleteBundleOffloadingRequest,
			tqkSchema: z.tuple([z.literal("CompleteBundleOffloading"), CompleteBundleOffloadingRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("CompleteBundleOffloading"), z.optional(CompleteBundleOffloadingRequest)]),

			returnEnvelope: "transfer",
			responseSchema: CompleteBundleOffloadingResponse,
			unwrapResponse: (rpc: CompleteBundleOffloadingResponse) => rpc.transfer,
//			returnLetterSchema: Transfer,
//			returnLetterTypeName: "Transfer",
		},

		UpsertUnit: {
			hasInput: true,
			requestSchema: UpsertUnitRequest,
			tqkSchema: z.tuple([z.literal("UpsertUnit"), UpsertUnitRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertUnit"), z.optional(UpsertUnitRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertUnitResponse,
			unwrapResponse: (rpc: UpsertUnitResponse) => rpc.result,
//			returnLetterSchema: UnitUpsertResult,
//			returnLetterTypeName: "UnitUpsertResult",
		},

		UpsertWasteFlavor: {
			hasInput: true,
			requestSchema: UpsertWasteFlavorRequest,
			tqkSchema: z.tuple([z.literal("UpsertWasteFlavor"), UpsertWasteFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertWasteFlavor"), z.optional(UpsertWasteFlavorRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertWasteFlavorResponse,
			unwrapResponse: (rpc: UpsertWasteFlavorResponse) => rpc.result,
//			returnLetterSchema: WasteFlavorUpsertResult,
//			returnLetterTypeName: "WasteFlavorUpsertResult",
		},

		PatchWasteFlavor: {
			hasInput: true,
			requestSchema: PatchWasteFlavorRequest,
			tqkSchema: z.tuple([z.literal("PatchWasteFlavor"), PatchWasteFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchWasteFlavor"), z.optional(PatchWasteFlavorRequest)]),

			returnEnvelope: "flavor",
			responseSchema: PatchWasteFlavorResponse,
			unwrapResponse: (rpc: PatchWasteFlavorResponse) => rpc.flavor,
//			returnLetterSchema: WasteFlavor,
//			returnLetterTypeName: "WasteFlavor",
		},

		RetireWasteFlavor: {
			hasInput: true,
			requestSchema: RetireWasteFlavorRequest,
			tqkSchema: z.tuple([z.literal("RetireWasteFlavor"), RetireWasteFlavorRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireWasteFlavor"), z.optional(RetireWasteFlavorRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertWasteFlavorRecipe: {
			hasInput: true,
			requestSchema: UpsertWasteFlavorRecipeRequest,
			tqkSchema: z.tuple([z.literal("UpsertWasteFlavorRecipe"), UpsertWasteFlavorRecipeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertWasteFlavorRecipe"), z.optional(UpsertWasteFlavorRecipeRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		DeleteWasteFlavorRecipe: {
			hasInput: true,
			requestSchema: DeleteWasteFlavorRecipeRequest,
			tqkSchema: z.tuple([z.literal("DeleteWasteFlavorRecipe"), DeleteWasteFlavorRecipeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("DeleteWasteFlavorRecipe"), z.optional(DeleteWasteFlavorRecipeRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertPackingMode: {
			hasInput: true,
			requestSchema: UpsertPackingModeRequest,
			tqkSchema: z.tuple([z.literal("UpsertPackingMode"), UpsertPackingModeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertPackingMode"), z.optional(UpsertPackingModeRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertPackingModeResponse,
			unwrapResponse: (rpc: UpsertPackingModeResponse) => rpc.result,
//			returnLetterSchema: PackingModeUpsertResult,
//			returnLetterTypeName: "PackingModeUpsertResult",
		},

		UpsertManifestType: {
			hasInput: true,
			requestSchema: UpsertManifestTypeRequest,
			tqkSchema: z.tuple([z.literal("UpsertManifestType"), UpsertManifestTypeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertManifestType"), z.optional(UpsertManifestTypeRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertManifestTypeResponse,
			unwrapResponse: (rpc: UpsertManifestTypeResponse) => rpc.result,
//			returnLetterSchema: ManifestTypeUpsertResult,
//			returnLetterTypeName: "ManifestTypeUpsertResult",
		},

		SpawnWaste: {
			hasInput: true,
			requestSchema: SpawnWasteRequest,
			tqkSchema: z.tuple([z.literal("SpawnWaste"), SpawnWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SpawnWaste"), z.optional(SpawnWasteRequest)]),

			returnEnvelope: "waste",
			responseSchema: SpawnWasteResponse,
			unwrapResponse: (rpc: SpawnWasteResponse) => rpc.waste,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},

		PatchWaste: {
			hasInput: true,
			requestSchema: PatchWasteRequest,
			tqkSchema: z.tuple([z.literal("PatchWaste"), PatchWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("PatchWaste"), z.optional(PatchWasteRequest)]),

			returnEnvelope: "waste",
			responseSchema: PatchWasteResponse,
			unwrapResponse: (rpc: PatchWasteResponse) => rpc.waste,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},

		StampWaste: {
			hasInput: true,
			requestSchema: StampWasteRequest,
			tqkSchema: z.tuple([z.literal("StampWaste"), StampWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StampWaste"), z.optional(StampWasteRequest)]),

			returnEnvelope: "stamp",
			responseSchema: StampWasteResponse,
			unwrapResponse: (rpc: StampWasteResponse) => rpc.stamp,
//			returnLetterSchema: WasteStamp,
//			returnLetterTypeName: "WasteStamp",
		},

		AttachWasteToBundle: {
			hasInput: true,
			requestSchema: AttachWasteToBundleRequest,
			tqkSchema: z.tuple([z.literal("AttachWasteToBundle"), AttachWasteToBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AttachWasteToBundle"), z.optional(AttachWasteToBundleRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		AttachWasteToJob: {
			hasInput: true,
			requestSchema: AttachWasteToJobRequest,
			tqkSchema: z.tuple([z.literal("AttachWasteToJob"), AttachWasteToJobRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AttachWasteToJob"), z.optional(AttachWasteToJobRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		DetachWasteFromBundle: {
			hasInput: true,
			requestSchema: DetachWasteFromBundleRequest,
			tqkSchema: z.tuple([z.literal("DetachWasteFromBundle"), DetachWasteFromBundleRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("DetachWasteFromBundle"), z.optional(DetachWasteFromBundleRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		StoreWasteTemporary: {
			hasInput: true,
			requestSchema: StoreWasteTemporaryRequest,
			tqkSchema: z.tuple([z.literal("StoreWasteTemporary"), StoreWasteTemporaryRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StoreWasteTemporary"), z.optional(StoreWasteTemporaryRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		StoreWastePermanent: {
			hasInput: true,
			requestSchema: StoreWastePermanentRequest,
			tqkSchema: z.tuple([z.literal("StoreWastePermanent"), StoreWastePermanentRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("StoreWastePermanent"), z.optional(StoreWastePermanentRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		DivideFromWaste: {
			hasInput: true,
			requestSchema: DivideFromWasteRequest,
			tqkSchema: z.tuple([z.literal("DivideFromWaste"), DivideFromWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("DivideFromWaste"), z.optional(DivideFromWasteRequest)]),

			returnEnvelope: "daughter",
			responseSchema: DivideFromWasteResponse,
			unwrapResponse: (rpc: DivideFromWasteResponse) => rpc.daughter,
//			returnLetterSchema: Waste,
//			returnLetterTypeName: "Waste",
		},

		MergeIntoWaste: {
			hasInput: true,
			requestSchema: MergeIntoWasteRequest,
			tqkSchema: z.tuple([z.literal("MergeIntoWaste"), MergeIntoWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("MergeIntoWaste"), z.optional(MergeIntoWasteRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		RetireWaste: {
			hasInput: true,
			requestSchema: RetireWasteRequest,
			tqkSchema: z.tuple([z.literal("RetireWaste"), RetireWasteRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RetireWaste"), z.optional(RetireWasteRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		UpsertTransformMode: {
			hasInput: true,
			requestSchema: UpsertTransformModeRequest,
			tqkSchema: z.tuple([z.literal("UpsertTransformMode"), UpsertTransformModeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("UpsertTransformMode"), z.optional(UpsertTransformModeRequest)]),

			returnEnvelope: "result",
			responseSchema: UpsertTransformModeResponse,
			unwrapResponse: (rpc: UpsertTransformModeResponse) => rpc.result,
//			returnLetterSchema: TransformModeUpsertResult,
//			returnLetterTypeName: "TransformModeUpsertResult",
		},

		AdoptTransformMode: {
			hasInput: true,
			requestSchema: AdoptTransformModeRequest,
			tqkSchema: z.tuple([z.literal("AdoptTransformMode"), AdoptTransformModeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AdoptTransformMode"), z.optional(AdoptTransformModeRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		AbandonTransformMode: {
			hasInput: true,
			requestSchema: AbandonTransformModeRequest,
			tqkSchema: z.tuple([z.literal("AbandonTransformMode"), AbandonTransformModeRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AbandonTransformMode"), z.optional(AbandonTransformModeRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		AttachPhotoToStamp: {
			hasInput: true,
			requestSchema: AttachPhotoToStampRequest,
			tqkSchema: z.tuple([z.literal("AttachPhotoToStamp"), AttachPhotoToStampRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("AttachPhotoToStamp"), z.optional(AttachPhotoToStampRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		RewindToCheckpoint: {
			hasInput: true,
			requestSchema: RewindToCheckpointRequest,
			tqkSchema: z.tuple([z.literal("RewindToCheckpoint"), RewindToCheckpointRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("RewindToCheckpoint"), z.optional(RewindToCheckpointRequest)]),

			returnEnvelope: "DEADBEEF",
			responseSchema: z.never(),
			unwrapResponse: () => undefined,
//			returnLetterSchema: z.never(),
//			returnLetterTypeName: undefined,
		},

		SpawnCheckpoint: {
			hasInput: true,
			requestSchema: SpawnCheckpointRequest,
			tqkSchema: z.tuple([z.literal("SpawnCheckpoint"), SpawnCheckpointRequest]),
			optionalArgTqkSchema: z.tuple([z.literal("SpawnCheckpoint"), z.optional(SpawnCheckpointRequest)]),

			returnEnvelope: "checkpoint",
			responseSchema: SpawnCheckpointResponse,
			unwrapResponse: (rpc: SpawnCheckpointResponse) => rpc.checkpoint,
//			returnLetterSchema: RewindCheckpoint,
//			returnLetterTypeName: "RewindCheckpoint",
		},
} as const;
export type RpcVerb = keyof typeof RpcVerbMap;
export type RequestSchemaFor<Verb extends RpcVerb> = typeof RpcVerbMap[Verb] extends { requestSchema: unknown }
	? typeof RpcVerbMap[Verb]["requestSchema"] : never;
export type ResponseSchemaFor<Verb extends RpcVerb> = typeof RpcVerbMap[Verb] extends { responseSchema: unknown }
	? typeof RpcVerbMap[Verb]["responseSchema"] : never;
export type TqKey<Verb extends RpcVerb> = z.infer<typeof RpcVerbMap[Verb]["tqkSchema"]>;

export const setlistPacketConsumersByVerb = {
	CompanyById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["CompanyById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchCompanyByIdResponse;
		const deltaSchema = RpcTypeMap["Company"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.company : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({company: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Company.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Company.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	CompanyByCode: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["CompanyByCode"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchCompanyByCodeResponse;
		const deltaSchema = RpcTypeMap["Company"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.company : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({company: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Company.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Company.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	CompaniesByNameFragment: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["CompaniesByNameFragment"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchCompaniesByNameFragmentResponse;
		const deltaSchema = RpcTypeMap["CompanyStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.companies : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({companies: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: CompanyStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = CompanyStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = CompanyStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	VenueById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["VenueById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchVenueByIdResponse;
		const deltaSchema = RpcTypeMap["Venue"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.venue : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({venue: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Venue.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Venue.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AdmittersOnDutyForVenue: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AdmittersOnDutyForVenue"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAdmittersOnDutyForVenueResponse;
		const deltaSchema = RpcTypeMap["AgentStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.admitters : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({admitters: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: AgentStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = AgentStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = AgentStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	VenueByCode: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["VenueByCode"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchVenueByCodeResponse;
		const deltaSchema = RpcTypeMap["Venue"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.venue : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({venue: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Venue.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Venue.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	VenueByName: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["VenueByName"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchVenueByNameResponse;
		const deltaSchema = RpcTypeMap["Venue"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.venue : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({venue: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Venue.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Venue.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TrucksDockedAt: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TrucksDockedAt"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTrucksDockedAtResponse;
		const deltaSchema = RpcTypeMap["TruckStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.trucks : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({trucks: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TruckStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TruckStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TruckStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	AgentById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AgentById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAgentByIdResponse;
		const deltaSchema = RpcTypeMap["Agent"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.agent : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({agent: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Agent.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Agent.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AgentByCode: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AgentByCode"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAgentByCodeResponse;
		const deltaSchema = RpcTypeMap["Agent"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.agent : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({agent: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Agent.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Agent.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AgentByName: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AgentByName"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAgentByNameResponse;
		const deltaSchema = RpcTypeMap["Agent"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.agent : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({agent: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Agent.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Agent.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AgentByLogin: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AgentByLogin"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAgentByLoginResponse;
		const deltaSchema = RpcTypeMap["Agent"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.agent : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({agent: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Agent.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Agent.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	StampsForAgent: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["StampsForAgent"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchStampsForAgentResponse;
		const deltaSchema = RpcTypeMap["AgentStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: AgentStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = AgentStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = AgentStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	AgentPresenceById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AgentPresenceById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAgentPresenceByIdResponse;
		const deltaSchema = RpcTypeMap["AgentPresence"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.presence : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({presence: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? AgentPresence.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? AgentPresence.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AllPresentAgents: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AllPresentAgents"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAllPresentAgentsResponse;
		const deltaSchema = RpcTypeMap["AgentStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.agents : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({agents: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: AgentStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = AgentStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = AgentStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TruckModels: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TruckModels"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTruckModelsResponse;
		const deltaSchema = RpcTypeMap["TruckModel"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.models : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({models: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TruckModel[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TruckModel.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TruckModel.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TruckModelById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TruckModelById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTruckModelByIdResponse;
		const deltaSchema = RpcTypeMap["TruckModel"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.model : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({model: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? TruckModel.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? TruckModel.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TruckById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TruckById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTruckByIdResponse;
		const deltaSchema = RpcTypeMap["Truck"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.truck : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({truck: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Truck.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Truck.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TruckByPlate: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TruckByPlate"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTruckByPlateResponse;
		const deltaSchema = RpcTypeMap["Truck"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.truck : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({truck: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Truck.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Truck.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TruckByCrew: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TruckByCrew"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTruckByCrewResponse;
		const deltaSchema = RpcTypeMap["TruckStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.truck : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({truck: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? TruckStub.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? TruckStub.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	CrewByTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["CrewByTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchCrewByTruckResponse;
		const deltaSchema = RpcTypeMap["CrewTenure"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.tenures : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({tenures: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: CrewTenure[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = CrewTenure.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = CrewTenure.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	StampsForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["StampsForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchStampsForTruckResponse;
		const deltaSchema = RpcTypeMap["TruckStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TruckStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TruckStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TruckStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	JobById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["JobById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchJobByIdResponse;
		const deltaSchema = RpcTypeMap["Job"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.job : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({job: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Job.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Job.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	ExportableJobs: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ExportableJobs"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchExportableJobsResponse;
		const deltaSchema = RpcTypeMap["JobStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.jobs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({jobs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: JobStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = JobStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = JobStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ExportedJobs: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ExportedJobs"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchExportedJobsResponse;
		const deltaSchema = RpcTypeMap["JobStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.jobs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({jobs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: JobStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = JobStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = JobStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	JobByJobCode: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["JobByJobCode"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchJobByJobCodeResponse;
		const deltaSchema = RpcTypeMap["Job"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.job : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({job: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Job.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Job.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	JobByIntakeCode: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["JobByIntakeCode"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchJobByIntakeCodeResponse;
		const deltaSchema = RpcTypeMap["Job"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.job : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({job: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Job.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Job.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	StampsForJob: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["StampsForJob"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchStampsForJobResponse;
		const deltaSchema = RpcTypeMap["JobStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: JobStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = JobStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = JobStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	UnbundledWastesForJobAtVenue: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["UnbundledWastesForJobAtVenue"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchUnbundledWastesForJobAtVenueResponse;
		const deltaSchema = RpcTypeMap["WasteStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.wastes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({wastes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: WasteStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = WasteStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = WasteStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	SurchargesForSubject: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["SurchargesForSubject"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchSurchargesForSubjectResponse;
		const deltaSchema = RpcTypeMap["Surcharge"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.surcharges : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({surcharges: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: Surcharge[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = Surcharge.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = Surcharge.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	SurchargeById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["SurchargeById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchSurchargeByIdResponse;
		const deltaSchema = RpcTypeMap["Surcharge"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.surcharge : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({surcharge: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Surcharge.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Surcharge.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	BundleById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["BundleById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchBundleByIdResponse;
		const deltaSchema = RpcTypeMap["Bundle"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundle : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundle: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Bundle.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Bundle.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	BundleLocation: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["BundleLocation"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchBundleLocationResponse;
		const deltaSchema = RpcTypeMap["TruckOrVenueStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.curloc : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({curloc: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? TruckOrVenueStub.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? TruckOrVenueStub.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	OrphanedBundles: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["OrphanedBundles"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchOrphanedBundlesResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.orphans : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({orphans: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ActiveBundles: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ActiveBundles"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchActiveBundlesResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ActiveBundlesDestinedFor: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ActiveBundlesDestinedFor"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchActiveBundlesDestinedForResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ActiveBundlesOriginatingAt: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ActiveBundlesOriginatingAt"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchActiveBundlesOriginatingAtResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ExportableBundles: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ExportableBundles"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchExportableBundlesResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	InspectableBundles: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["InspectableBundles"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchInspectableBundlesResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	BundlesNeedingSupervisor: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["BundlesNeedingSupervisor"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchBundlesNeedingSupervisorResponse;
		const deltaSchema = RpcTypeMap["BundleStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundles : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundles: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	StampsForBundle: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["StampsForBundle"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchStampsForBundleResponse;
		const deltaSchema = RpcTypeMap["BundleStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	FlavoredStampsForBundle: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["FlavoredStampsForBundle"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchFlavoredStampsForBundleResponse;
		const deltaSchema = RpcTypeMap["BundleStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: BundleStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = BundleStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = BundleStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TransferById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TransferById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTransferByIdResponse;
		const deltaSchema = RpcTypeMap["Transfer"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfer : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfer: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Transfer.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Transfer.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AllTransfers: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AllTransfers"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAllTransfersResponse;
		const deltaSchema = RpcTypeMap["TransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	OpenTransfersForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["OpenTransfersForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchOpenTransfersForTruckResponse;
		const deltaSchema = RpcTypeMap["TransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TransfersForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TransfersForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTransfersForTruckResponse;
		const deltaSchema = RpcTypeMap["TransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	LastTransferForBundle: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["LastTransferForBundle"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchLastTransferForBundleResponse;
		const deltaSchema = RpcTypeMap["Transfer"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfer : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfer: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Transfer.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Transfer.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TransfersAtVenue: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TransfersAtVenue"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTransfersAtVenueResponse;
		const deltaSchema = RpcTypeMap["TransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.transfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({transfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TriplegById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TriplegById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTriplegByIdResponse;
		const deltaSchema = RpcTypeMap["Tripleg"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.tripleg : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({tripleg: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Tripleg.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Tripleg.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AllTriplegs: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AllTriplegs"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAllTriplegsResponse;
		const deltaSchema = RpcTypeMap["TriplegStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.triplegs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({triplegs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TriplegStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TriplegStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TriplegStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	OpenTriplegForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["OpenTriplegForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchOpenTriplegForTruckResponse;
		const deltaSchema = RpcTypeMap["Tripleg"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.tripleg : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({tripleg: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Tripleg.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Tripleg.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	LastTriplegForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["LastTriplegForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchLastTriplegForTruckResponse;
		const deltaSchema = RpcTypeMap["Tripleg"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.tripleg : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({tripleg: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Tripleg.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Tripleg.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	TriplegsForTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TriplegsForTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTriplegsForTruckResponse;
		const deltaSchema = RpcTypeMap["TriplegStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.triplegs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({triplegs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TriplegStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TriplegStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TriplegStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	UnadmittedTriplegsInto: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["UnadmittedTriplegsInto"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchUnadmittedTriplegsIntoResponse;
		const deltaSchema = RpcTypeMap["TriplegStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.triplegs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({triplegs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TriplegStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TriplegStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TriplegStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TriplegsInboundTo: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TriplegsInboundTo"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTriplegsInboundToResponse;
		const deltaSchema = RpcTypeMap["TriplegStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.triplegs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({triplegs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: TriplegStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = TriplegStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = TriplegStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ScheduledTransferById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransferById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransferByIdResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransfer"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfer : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfer: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? ScheduledTransfer.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? ScheduledTransfer.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	ScheduledTransferForBundle: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransferForBundle"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransferForBundleResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransfer"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfer : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfer: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? ScheduledTransfer.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? ScheduledTransfer.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	ScheduledTransfersForDriver: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransfersForDriver"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransfersForDriverResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: ScheduledTransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = ScheduledTransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = ScheduledTransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ScheduledTransfersAwaitingTruck: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransfersAwaitingTruck"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransfersAwaitingTruckResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: ScheduledTransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = ScheduledTransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = ScheduledTransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ScheduledTransfersAt: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransfersAt"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransfersAtResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: ScheduledTransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = ScheduledTransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = ScheduledTransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ScheduledTransfersForDispatch: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ScheduledTransfersForDispatch"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchScheduledTransfersForDispatchResponse;
		const deltaSchema = RpcTypeMap["ScheduledTransferStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.scheduledTransfers : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({scheduledTransfers: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: ScheduledTransferStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = ScheduledTransferStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = ScheduledTransferStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	WasteFlavorById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["WasteFlavorById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchWasteFlavorByIdResponse;
		const deltaSchema = RpcTypeMap["WasteFlavor"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.flavor : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({flavor: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? WasteFlavor.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? WasteFlavor.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	WasteById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["WasteById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchWasteByIdResponse;
		const deltaSchema = RpcTypeMap["Waste"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.waste : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({waste: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Waste.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Waste.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	WastesForBundle: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["WastesForBundle"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchWastesForBundleResponse;
		const deltaSchema = RpcTypeMap["WasteStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.wastes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({wastes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: WasteStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = WasteStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = WasteStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	BundleForWaste: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["BundleForWaste"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchBundleForWasteResponse;
		const deltaSchema = RpcTypeMap["Bundle"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.bundle : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({bundle: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? Bundle.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? Bundle.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	AssociationsForWaste: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["AssociationsForWaste"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchAssociationsForWasteResponse;
		const deltaSchema = RpcTypeMap["WasteAssociation"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.assoc : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({assoc: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? WasteAssociation.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? WasteAssociation.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	WasteLocation: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["WasteLocation"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchWasteLocationResponse;
		const deltaSchema = RpcTypeMap["TruckOrVenueStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.curloc : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({curloc: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? TruckOrVenueStub.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? TruckOrVenueStub.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	WastesAt: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["WastesAt"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchWastesAtResponse;
		const deltaSchema = RpcTypeMap["WasteStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stubs : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stubs: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: WasteStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = WasteStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = WasteStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	StampsForWaste: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["StampsForWaste"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchStampsForWasteResponse;
		const deltaSchema = RpcTypeMap["WasteStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: WasteStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = WasteStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = WasteStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	FlavoredStampsForWaste: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["FlavoredStampsForWaste"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchFlavoredStampsForWasteResponse;
		const deltaSchema = RpcTypeMap["WasteStamp"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.stamps : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({stamps: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: WasteStamp[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = WasteStamp.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = WasteStamp.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	PackingModes: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["PackingModes"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchPackingModesResponse;
		const deltaSchema = RpcTypeMap["PackingMode"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.modes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({modes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: PackingMode[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = PackingMode.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = PackingMode.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	PackingModeById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["PackingModeById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchPackingModeByIdResponse;
		const deltaSchema = RpcTypeMap["PackingMode"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.mode : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({mode: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? PackingMode.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? PackingMode.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	ManifestTypes: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ManifestTypes"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchManifestTypesResponse;
		const deltaSchema = RpcTypeMap["ManifestType"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.maniTypes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({maniTypes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: ManifestType[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = ManifestType.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = ManifestType.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	ManifestTypeById: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["ManifestTypeById"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchManifestTypeByIdResponse;
		const deltaSchema = RpcTypeMap["ManifestType"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.maniType : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({maniType: letter}, {reportInput: true});
		const patchedNext = !!cachePayload && deltaZprv.success
			? ManifestType.parse(applyPatch(cachePayload, deltaZprv.data), {reportInput: true})
			: undefined;

		if (!("next" in rawPacket) || !rawPacket.next
			|| (deltaZprv.success && !patchedNext)) {
			void tqc.invalidateQueries({queryKey: tqk});
			return
		}
		// at this point, three possible things can be happening:
		// - an addition
		// - a full replace
		// - a delta that has been inflated
		const next = patchedNext ?? ManifestType.parse(rawPacket.next, {reportInput: true});
		const sealedNext = seal(next);
		tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
	},
	Units: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["Units"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchUnitsResponse;
		const deltaSchema = RpcTypeMap["Unit"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.units : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({units: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: Unit[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = Unit.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = Unit.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TransformModes: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TransformModes"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTransformModesResponse;
		const deltaSchema = RpcTypeMap["EntityStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.modes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({modes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: EntityStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = EntityStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = EntityStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
	TransformModesForVenue: (tqc: QueryClient, rawTqk: QueryKey, rawPacket: WiredSetlistPacket) => {
		const vrec = RpcVerbMap["TransformModesForVenue"];
		const tqk = vrec.tqkSchema.parse(rawTqk, {reportInput: true});
		type CacheEntryT = WatchTransformModesForVenueResponse;
		const deltaSchema = RpcTypeMap["EntityStub"].deltaTransitionSchema;
		const deltaZprv = deltaSchema.safeParse(rawPacket);
		const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
		const cachePayload = cacheEntry ? cacheEntry.modes : undefined;
		const seal = (letter: unknown) => vrec.responseSchema.parse({modes: letter}, {reportInput: true});
		if (isNukePacket(rawPacket)) {
			void tqc.invalidateQueries({queryKey: tqk});
		}

		if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
			// a delete
			const prevId = Ided.parse(rawPacket.prev).id;
			if (cachePayload) {
				const next = cachePayload.filter(maybe => maybe.id !== prevId);
				const sealedNext = seal(next);
				tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
			}
		} else {
			// at this point, next must exist and we have the same three-pronged situation.
			// we need set behavior, so we don't blindly add things that we are told to add.
			// so basically we are updating our entry with the relevant id or adding a new
			// one if we don't find one.

			const wantedId = Ided.parse(rawPacket.next, {reportInput: true}).id;
			let found = false;
			const next: EntityStub[] = [];
			for (const elem of (cachePayload ?? [])) {
				if (elem.id === wantedId) {
					const newElem = EntityStub.parse(
                    (deltaZprv.success ? applyPatch(elem, deltaZprv.data) : rawPacket.next),
					   {reportInput: true});
					next.push(newElem);
					found = true;
				} else {
					next.push(elem);
				}
			}

			if (!found) {
				if (deltaZprv.success) {
					// no bueno, we have nothing to patch from
					void tqc.invalidateQueries({queryKey: tqk});
				}
				const newElem = EntityStub.parse(rawPacket.next, {reportInput: true});
				next.push(newElem);
			}

			const sealedNext = seal(next);
			tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
		}
	},
} as const;

//
// Webrpc
//

export const WebrpcHeader = "Webrpc"

export const WebrpcHeaderValue = "webrpc@v0.31.3;gen-typescript@unknown;kingbasura@0.3.1"

type WebrpcGenVersions = {
  WebrpcGenVersion: string;
  codeGenName: string;
  codeGenVersion: string;
  schemaName: string;
  schemaVersion: string;
};

export function VersionFromHeader(headers: Headers): WebrpcGenVersions {
  const headerValue = headers.get(WebrpcHeader)
  if (!headerValue) {
    return {
      WebrpcGenVersion: "",
      codeGenName: "",
      codeGenVersion: "",
      schemaName: "",
      schemaVersion: "",
    };
  }

  return parseWebrpcGenVersions(headerValue)
}

function parseWebrpcGenVersions(header: string): WebrpcGenVersions {
  const versions = header.split(";")
  if (versions.length < 3) {
    return {
      WebrpcGenVersion: "",
      codeGenName: "",
      codeGenVersion: "",
      schemaName: "",
      schemaVersion: "",
    };
  }

  const [_, WebrpcGenVersion] = versions[0]!.split("@")
  const [codeGenName, codeGenVersion] = versions[1]!.split("@")
  const [schemaName, schemaVersion] = versions[2]!.split("@")

  return {
    WebrpcGenVersion: WebrpcGenVersion ?? "",
    codeGenName: codeGenName ?? "",
    codeGenVersion: codeGenVersion ?? "",
    schemaName: schemaName ?? "",
    schemaVersion: schemaVersion ?? "",
  };
}